var Bm = Object.defineProperty;
var Wm = Object.getPrototypeOf;
var Hm = Reflect.get;
var Hd = (e) => {
  throw TypeError(e);
};
var Um = (e, t, a) => t in e ? Bm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var Ve = (e, t, a) => Um(e, typeof t != "symbol" ? t + "" : t, a), xc = (e, t, a) => t.has(e) || Hd("Cannot " + a);
var j = (e, t, a) => (xc(e, t, "read from private field"), a ? a.call(e) : t.get(e)), ne = (e, t, a) => t.has(e) ? Hd("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, a), Ie = (e, t, a, r) => (xc(e, t, "write to private field"), r ? r.call(e, a) : t.set(e, a), a), Gt = (e, t, a) => (xc(e, t, "access private method"), a);
var zc = (e, t, a, r) => ({
  set _(n) {
    Ie(e, t, n, a);
  },
  get _() {
    return j(e, t, r);
  }
}), Ud = (e, t, a) => Hm(Wm(e), a, t);
const qt = Symbol(), oy = "http://www.w3.org/2000/svg", sy = !1;
var Zl = Array.isArray, Fu = Array.from, Gm = Object.defineProperty, wr = Object.getOwnPropertyDescriptor, iy = Object.getOwnPropertyDescriptors, Km = Object.prototype, Zm = Array.prototype, Li = Object.getPrototypeOf;
function bn(e) {
  return typeof e == "function";
}
const qe = () => {
};
function Ym(e) {
  return e();
}
function Hc(e) {
  for (var t = 0; t < e.length; t++)
    e[t]();
}
const ga = 2, ly = 4, Gs = 8, Yl = 16, wa = 32, Ks = 64, Uc = 128, sn = 256, Di = 512, Wt = 1024, xr = 2048, no = 4096, Ta = 8192, oo = 16384, cy = 32768, ln = 65536, Xm = 1 << 17, Jm = 1 << 19, uy = 1 << 20, vr = Symbol("$state"), dy = Symbol("legacy props"), Qm = Symbol("");
function fy(e) {
  return e === this.v;
}
function Xl(e, t) {
  return e != e ? t == t : e !== t || e !== null && typeof e == "object" || typeof e == "function";
}
function $m(e, t) {
  return e !== t;
}
function ju(e) {
  return !Xl(e, this.v);
}
function e_(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function t_() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function a_(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function r_() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function n_(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function o_() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function s_() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function i_() {
  throw new Error("https://svelte.dev/e/state_unsafe_local_read");
}
function l_() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let so = !1;
function c_() {
  so = !0;
}
function Ot(e) {
  return {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: fy,
    version: 0
  };
}
function me(e) {
  return /* @__PURE__ */ py(Ot(e));
}
// @__NO_SIDE_EFFECTS__
function Jl(e, t = !1) {
  var r;
  const a = Ot(e);
  return t || (a.equals = ju), so && Je !== null && Je.l !== null && ((r = Je.l).s ?? (r.s = [])).push(a), a;
}
function Ke(e, t = !1) {
  return /* @__PURE__ */ py(/* @__PURE__ */ Jl(e, t));
}
// @__NO_SIDE_EFFECTS__
function py(e) {
  return tt !== null && tt.f & ga && (Pa === null ? w_([e]) : Pa.push(e)), e;
}
function q(e, t) {
  return tt !== null && Xs() && tt.f & (ga | Yl) && // If the source was created locally within the current derived, then
  // we allow the mutation.
  (Pa === null || !Pa.includes(e)) && l_(), Gc(e, t);
}
function Gc(e, t) {
  return e.equals(t) || (e.v = t, e.version = Iy(), yy(e, xr), Xs() && Ge !== null && Ge.f & Wt && !(Ge.f & wa) && (Lt !== null && Lt.includes(e) ? (va(Ge, xr), ac(Ge)) : br === null ? v_([e]) : br.push(e))), t;
}
function yy(e, t) {
  var a = e.reactions;
  if (a !== null)
    for (var r = Xs(), n = a.length, o = 0; o < n; o++) {
      var s = a[o], i = s.f;
      i & xr || !r && s === Ge || (va(s, t), i & (Wt | sn) && (i & ga ? yy(
        /** @type {Derived} */
        s,
        no
      ) : ac(
        /** @type {Effect} */
        s
      )));
    }
}
let hy = !1;
function ce(e, t = null, a) {
  if (typeof e != "object" || e === null || vr in e)
    return e;
  const r = Li(e);
  if (r !== Km && r !== Zm)
    return e;
  var n = /* @__PURE__ */ new Map(), o = Zl(e), s = Ot(0);
  o && n.set("length", Ot(
    /** @type {any[]} */
    e.length
  ));
  var i;
  return new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, u, f) {
        (!("value" in f) || f.configurable === !1 || f.enumerable === !1 || f.writable === !1) && o_();
        var p = n.get(u);
        return p === void 0 ? (p = Ot(f.value), n.set(u, p)) : q(p, ce(f.value, i)), !0;
      },
      deleteProperty(l, u) {
        var f = n.get(u);
        if (f === void 0)
          u in l && n.set(u, Ot(qt));
        else {
          if (o && typeof u == "string") {
            var p = (
              /** @type {Source<number>} */
              n.get("length")
            ), c = Number(u);
            Number.isInteger(c) && c < p.v && q(p, c);
          }
          q(f, qt), Gd(s);
        }
        return !0;
      },
      get(l, u, f) {
        var g;
        if (u === vr)
          return e;
        var p = n.get(u), c = u in l;
        if (p === void 0 && (!c || (g = wr(l, u)) != null && g.writable) && (p = Ot(ce(c ? l[u] : qt, i)), n.set(u, p)), p !== void 0) {
          var h = d(p);
          return h === qt ? void 0 : h;
        }
        return Reflect.get(l, u, f);
      },
      getOwnPropertyDescriptor(l, u) {
        var f = Reflect.getOwnPropertyDescriptor(l, u);
        if (f && "value" in f) {
          var p = n.get(u);
          p && (f.value = d(p));
        } else if (f === void 0) {
          var c = n.get(u), h = c == null ? void 0 : c.v;
          if (c !== void 0 && h !== qt)
            return {
              enumerable: !0,
              configurable: !0,
              value: h,
              writable: !0
            };
        }
        return f;
      },
      has(l, u) {
        var h;
        if (u === vr)
          return !0;
        var f = n.get(u), p = f !== void 0 && f.v !== qt || Reflect.has(l, u);
        if (f !== void 0 || Ge !== null && (!p || (h = wr(l, u)) != null && h.writable)) {
          f === void 0 && (f = Ot(p ? ce(l[u], i) : qt), n.set(u, f));
          var c = d(f);
          if (c === qt)
            return !1;
        }
        return p;
      },
      set(l, u, f, p) {
        var S;
        var c = n.get(u), h = u in l;
        if (o && u === "length")
          for (var g = f; g < /** @type {Source<number>} */
          c.v; g += 1) {
            var _ = n.get(g + "");
            _ !== void 0 ? q(_, qt) : g in l && (_ = Ot(qt), n.set(g + "", _));
          }
        c === void 0 ? (!h || (S = wr(l, u)) != null && S.writable) && (c = Ot(void 0), q(c, ce(f, i)), n.set(u, c)) : (h = c.v !== qt, q(c, ce(f, i)));
        var b = Reflect.getOwnPropertyDescriptor(l, u);
        if (b != null && b.set && b.set.call(p, f), !h) {
          if (o && typeof u == "string") {
            var m = (
              /** @type {Source<number>} */
              n.get("length")
            ), w = Number(u);
            Number.isInteger(w) && w >= m.v && q(m, w + 1);
          }
          Gd(s);
        }
        return !0;
      },
      ownKeys(l) {
        d(s);
        var u = Reflect.ownKeys(l).filter((c) => {
          var h = n.get(c);
          return h === void 0 || h.v !== qt;
        });
        for (var [f, p] of n)
          p.v !== qt && !(f in l) && u.push(f);
        return u;
      },
      setPrototypeOf() {
        s_();
      }
    }
  );
}
function Gd(e, t = 1) {
  q(e, e.v + t);
}
var Ga, gy, my;
function u_() {
  if (Ga === void 0) {
    Ga = window;
    var e = Element.prototype, t = Node.prototype;
    gy = wr(t, "firstChild").get, my = wr(t, "nextSibling").get, e.__click = void 0, e.__className = "", e.__attributes = null, e.__styles = null, e.__e = void 0, Text.prototype.__t = void 0;
  }
}
function Zs(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function Jr(e) {
  return gy.call(e);
}
// @__NO_SIDE_EFFECTS__
function Ql(e) {
  return my.call(e);
}
function A(e, t) {
  return /* @__PURE__ */ Jr(e);
}
function D(e, t) {
  {
    var a = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ Jr(
        /** @type {Node} */
        e
      )
    );
    return a instanceof Comment && a.data === "" ? /* @__PURE__ */ Ql(a) : a;
  }
}
function X(e, t = 1, a = !1) {
  let r = e;
  for (; t--; )
    r = /** @type {TemplateNode} */
    /* @__PURE__ */ Ql(r);
  return r;
}
function d_(e) {
  e.textContent = "";
}
// @__NO_SIDE_EFFECTS__
function M(e) {
  var t = ga | xr;
  Ge === null ? t |= sn : Ge.f |= uy;
  var a = tt !== null && tt.f & ga ? (
    /** @type {Derived} */
    tt
  ) : null;
  const r = {
    children: null,
    ctx: Je,
    deps: null,
    equals: fy,
    f: t,
    fn: e,
    reactions: null,
    v: (
      /** @type {V} */
      null
    ),
    version: 0,
    parent: a ?? Ge
  };
  return a !== null && (a.children ?? (a.children = [])).push(r), r;
}
// @__NO_SIDE_EFFECTS__
function kt(e) {
  const t = /* @__PURE__ */ M(e);
  return t.equals = ju, t;
}
function _y(e) {
  var t = e.children;
  if (t !== null) {
    e.children = null;
    for (var a = 0; a < t.length; a += 1) {
      var r = t[a];
      r.f & ga ? Ru(
        /** @type {Derived} */
        r
      ) : La(
        /** @type {Effect} */
        r
      );
    }
  }
}
function f_(e) {
  for (var t = e.parent; t !== null; ) {
    if (!(t.f & ga))
      return (
        /** @type {Effect} */
        t
      );
    t = t.parent;
  }
  return null;
}
function wy(e) {
  var t, a = Ge;
  Xt(f_(e));
  try {
    _y(e), t = Fy(e);
  } finally {
    Xt(a);
  }
  return t;
}
function vy(e) {
  var t = wy(e), a = (Br || e.f & sn) && e.deps !== null ? no : Wt;
  va(e, a), e.equals(t) || (e.v = t, e.version = Iy());
}
function Ru(e) {
  _y(e), Lo(e, 0), va(e, oo), e.v = e.children = e.deps = e.ctx = e.reactions = null;
}
function by(e) {
  Ge === null && tt === null && a_(), tt !== null && tt.f & sn && t_(), Du && e_();
}
function p_(e, t) {
  var a = t.last;
  a === null ? t.last = t.first = e : (a.next = e, e.prev = a, t.last = e);
}
function io(e, t, a, r = !0) {
  var n = (e & Ks) !== 0, o = Ge, s = {
    ctx: Je,
    deps: null,
    deriveds: null,
    nodes_start: null,
    nodes_end: null,
    f: e | xr,
    first: null,
    fn: t,
    last: null,
    next: null,
    parent: n ? null : o,
    prev: null,
    teardown: null,
    transitions: null,
    version: 0
  };
  if (a) {
    var i = Sn;
    try {
      Kd(!0), Js(s), s.f |= cy;
    } catch (f) {
      throw La(s), f;
    } finally {
      Kd(i);
    }
  } else t !== null && ac(s);
  var l = a && s.deps === null && s.first === null && s.nodes_start === null && s.teardown === null && (s.f & uy) === 0;
  if (!l && !n && r && (o !== null && p_(s, o), tt !== null && tt.f & ga)) {
    var u = (
      /** @type {Derived} */
      tt
    );
    (u.children ?? (u.children = [])).push(s);
  }
  return s;
}
function y_() {
  return tt === null ? !1 : !Br;
}
function ky(e) {
  const t = io(Gs, null, !1);
  return va(t, Wt), t.teardown = e, t;
}
function Pe(e) {
  by();
  var t = Ge !== null && (Ge.f & wa) !== 0 && Je !== null && !Je.m;
  if (t) {
    var a = (
      /** @type {ComponentContext} */
      Je
    );
    (a.e ?? (a.e = [])).push({
      fn: e,
      effect: Ge,
      reaction: tt
    });
  } else {
    var r = lo(e);
    return r;
  }
}
function h_(e) {
  return by(), co(e);
}
function xy(e) {
  const t = io(Ks, e, !0);
  return () => {
    La(t);
  };
}
function lo(e) {
  return io(ly, e, !1);
}
function Qe(e, t, a, r) {
  var n = (
    /** @type {ComponentContextLegacy} */
    Je
  ), o = { effect: null, ran: !1 };
  n.l.r1.push(o), o.effect = co(() => {
    e(), !o.ran && (o.ran = !0, q(n.l.r2, !0), zt(t));
  });
}
function $l() {
  var e = (
    /** @type {ComponentContextLegacy} */
    Je
  );
  co(() => {
    if (d(e.l.r2)) {
      for (var t of e.l.r1) {
        var a = t.effect;
        a.f & Wt && va(a, no), uo(a) && Js(a), t.ran = !1;
      }
      e.l.r2.v = !1;
    }
  });
}
function co(e) {
  return io(Gs, e, !0);
}
function $(e) {
  return Or(e);
}
function Or(e, t = 0) {
  return io(Gs | Yl | t, e, !0);
}
function Ia(e, t = !0) {
  return io(Gs | wa, e, !0, t);
}
function zy(e) {
  var t = e.teardown;
  if (t !== null) {
    const a = Du, r = tt;
    Zd(!0), la(null);
    try {
      t.call(null);
    } finally {
      Zd(a), la(r);
    }
  }
}
function Sy(e) {
  var t = e.deriveds;
  if (t !== null) {
    e.deriveds = null;
    for (var a = 0; a < t.length; a += 1)
      Ru(t[a]);
  }
}
function Cy(e, t = !1) {
  var a = e.first;
  for (e.first = e.last = null; a !== null; ) {
    var r = a.next;
    La(a, t), a = r;
  }
}
function g_(e) {
  for (var t = e.first; t !== null; ) {
    var a = t.next;
    t.f & wa || La(t), t = a;
  }
}
function La(e, t = !0) {
  var a = !1;
  if ((t || e.f & Jm) && e.nodes_start !== null) {
    for (var r = e.nodes_start, n = e.nodes_end; r !== null; ) {
      var o = r === n ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Ql(r)
      );
      r.remove(), r = o;
    }
    a = !0;
  }
  Cy(e, t && !a), Sy(e), Lo(e, 0), va(e, oo);
  var s = e.transitions;
  if (s !== null)
    for (const l of s)
      l.stop();
  zy(e);
  var i = e.parent;
  i !== null && i.first !== null && Ey(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function Ey(e) {
  var t = e.parent, a = e.prev, r = e.next;
  a !== null && (a.next = r), r !== null && (r.prev = a), t !== null && (t.first === e && (t.first = r), t.last === e && (t.last = a));
}
function Yn(e, t) {
  var a = [];
  Lu(e, a, !0), Ay(a, () => {
    La(e), t && t();
  });
}
function Ay(e, t) {
  var a = e.length;
  if (a > 0) {
    var r = () => --a || t();
    for (var n of e)
      n.out(r);
  } else
    t();
}
function Lu(e, t, a) {
  if (!(e.f & Ta)) {
    if (e.f ^= Ta, e.transitions !== null)
      for (const s of e.transitions)
        (s.is_global || a) && t.push(s);
    for (var r = e.first; r !== null; ) {
      var n = r.next, o = (r.f & ln) !== 0 || (r.f & wa) !== 0;
      Lu(r, t, o ? a : !1), r = n;
    }
  }
}
function Fo(e) {
  Ty(e, !0);
}
function Ty(e, t) {
  if (e.f & Ta) {
    uo(e) && Js(e), e.f ^= Ta;
    for (var a = e.first; a !== null; ) {
      var r = a.next, n = (a.f & ln) !== 0 || (a.f & wa) !== 0;
      Ty(a, n ? t : !1), a = r;
    }
    if (e.transitions !== null)
      for (const o of e.transitions)
        (o.is_global || t) && o.in();
  }
}
let Ni = !1, Kc = [];
function Py() {
  Ni = !1;
  const e = Kc.slice();
  Kc = [], Hc(e);
}
function Ys(e) {
  Ni || (Ni = !0, queueMicrotask(Py)), Kc.push(e);
}
function m_() {
  Ni && Py();
}
function ec(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
const Oy = 0, __ = 1;
let Ei = !1, Ai = Oy, jo = !1, Ro = null, Sn = !1, Du = !1;
function Kd(e) {
  Sn = e;
}
function Zd(e) {
  Du = e;
}
let qr = [], Cn = 0;
let tt = null;
function la(e) {
  tt = e;
}
let Ge = null;
function Xt(e) {
  Ge = e;
}
let Pa = null;
function w_(e) {
  Pa = e;
}
let Lt = null, Qt = 0, br = null;
function v_(e) {
  br = e;
}
let My = 0, Br = !1, Je = null;
function Iy() {
  return ++My;
}
function Xs() {
  return !so || Je !== null && Je.l === null;
}
function uo(e) {
  var s, i;
  var t = e.f;
  if (t & xr)
    return !0;
  if (t & no) {
    var a = e.deps, r = (t & sn) !== 0;
    if (a !== null) {
      var n;
      if (t & Di) {
        for (n = 0; n < a.length; n++)
          ((s = a[n]).reactions ?? (s.reactions = [])).push(e);
        e.f ^= Di;
      }
      for (n = 0; n < a.length; n++) {
        var o = a[n];
        if (uo(
          /** @type {Derived} */
          o
        ) && vy(
          /** @type {Derived} */
          o
        ), r && Ge !== null && !Br && !((i = o == null ? void 0 : o.reactions) != null && i.includes(e)) && (o.reactions ?? (o.reactions = [])).push(e), o.version > e.version)
          return !0;
      }
    }
    r || va(e, Wt);
  }
  return !1;
}
function b_(e, t) {
  for (var a = t; a !== null; ) {
    if (a.f & Uc)
      try {
        a.fn(e);
        return;
      } catch {
        a.f ^= Uc;
      }
    a = a.parent;
  }
  throw Ei = !1, e;
}
function k_(e) {
  return (e.f & oo) === 0 && (e.parent === null || (e.parent.f & Uc) === 0);
}
function tc(e, t, a, r) {
  if (Ei) {
    if (a === null && (Ei = !1), k_(t))
      throw e;
    return;
  }
  a !== null && (Ei = !0);
  {
    b_(e, t);
    return;
  }
}
function Fy(e) {
  var c;
  var t = Lt, a = Qt, r = br, n = tt, o = Br, s = Pa, i = Je, l = e.f;
  Lt = /** @type {null | Value[]} */
  null, Qt = 0, br = null, tt = l & (wa | Ks) ? null : e, Br = !Sn && (l & sn) !== 0, Pa = null, Je = e.ctx;
  try {
    var u = (
      /** @type {Function} */
      (0, e.fn)()
    ), f = e.deps;
    if (Lt !== null) {
      var p;
      if (Lo(e, Qt), f !== null && Qt > 0)
        for (f.length = Qt + Lt.length, p = 0; p < Lt.length; p++)
          f[Qt + p] = Lt[p];
      else
        e.deps = f = Lt;
      if (!Br)
        for (p = Qt; p < f.length; p++)
          ((c = f[p]).reactions ?? (c.reactions = [])).push(e);
    } else f !== null && Qt < f.length && (Lo(e, Qt), f.length = Qt);
    return u;
  } finally {
    Lt = t, Qt = a, br = r, tt = n, Br = o, Pa = s, Je = i;
  }
}
function x_(e, t) {
  let a = t.reactions;
  if (a !== null) {
    var r = a.indexOf(e);
    if (r !== -1) {
      var n = a.length - 1;
      n === 0 ? a = t.reactions = null : (a[r] = a[n], a.pop());
    }
  }
  a === null && t.f & ga && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Lt === null || !Lt.includes(t)) && (va(t, no), t.f & (sn | Di) || (t.f ^= Di), Lo(
    /** @type {Derived} **/
    t,
    0
  ));
}
function Lo(e, t) {
  var a = e.deps;
  if (a !== null)
    for (var r = t; r < a.length; r++)
      x_(e, a[r]);
}
function Js(e) {
  var t = e.f;
  if (!(t & oo)) {
    va(e, Wt);
    var a = Ge, r = Je;
    Ge = e;
    try {
      t & Yl ? g_(e) : Cy(e), Sy(e), zy(e);
      var n = Fy(e);
      e.teardown = typeof n == "function" ? n : null, e.version = My;
    } catch (o) {
      tc(o, e, a, r || e.ctx);
    } finally {
      Ge = a;
    }
  }
}
function jy() {
  if (Cn > 1e3) {
    Cn = 0;
    try {
      r_();
    } catch (e) {
      if (Ro !== null)
        tc(e, Ro, null);
      else
        throw e;
    }
  }
  Cn++;
}
function Ry(e) {
  var t = e.length;
  if (t !== 0) {
    jy();
    var a = Sn;
    Sn = !0;
    try {
      for (var r = 0; r < t; r++) {
        var n = e[r];
        n.f & Wt || (n.f ^= Wt);
        var o = [];
        Ly(n, o), z_(o);
      }
    } finally {
      Sn = a;
    }
  }
}
function z_(e) {
  var t = e.length;
  if (t !== 0)
    for (var a = 0; a < t; a++) {
      var r = e[a];
      if (!(r.f & (oo | Ta)))
        try {
          uo(r) && (Js(r), r.deps === null && r.first === null && r.nodes_start === null && (r.teardown === null ? Ey(r) : r.fn = null));
        } catch (n) {
          tc(n, r, null, r.ctx);
        }
    }
}
function S_() {
  if (jo = !1, Cn > 1001)
    return;
  const e = qr;
  qr = [], Ry(e), jo || (Cn = 0, Ro = null);
}
function ac(e) {
  Ai === Oy && (jo || (jo = !0, queueMicrotask(S_))), Ro = e;
  for (var t = e; t.parent !== null; ) {
    t = t.parent;
    var a = t.f;
    if (a & (Ks | wa)) {
      if (!(a & Wt)) return;
      t.f ^= Wt;
    }
  }
  qr.push(t);
}
function Ly(e, t) {
  var a = e.first, r = [];
  e: for (; a !== null; ) {
    var n = a.f, o = (n & wa) !== 0, s = o && (n & Wt) !== 0, i = a.next;
    if (!s && !(n & Ta))
      if (n & Gs) {
        if (o)
          a.f ^= Wt;
        else
          try {
            uo(a) && Js(a);
          } catch (p) {
            tc(p, a, null, a.ctx);
          }
        var l = a.first;
        if (l !== null) {
          a = l;
          continue;
        }
      } else n & ly && r.push(a);
    if (i === null) {
      let p = a.parent;
      for (; p !== null; ) {
        if (e === p)
          break e;
        var u = p.next;
        if (u !== null) {
          a = u;
          continue e;
        }
        p = p.parent;
      }
    }
    a = i;
  }
  for (var f = 0; f < r.length; f++)
    l = r[f], t.push(l), Ly(l, t);
}
function Dy(e) {
  var t = Ai, a = qr;
  try {
    jy();
    const n = [];
    Ai = __, qr = n, jo = !1, Ry(a);
    var r = e == null ? void 0 : e();
    return m_(), (qr.length > 0 || n.length > 0) && Dy(), Cn = 0, Ro = null, r;
  } finally {
    Ai = t, qr = a;
  }
}
async function Nu() {
  await Promise.resolve(), Dy();
}
function d(e) {
  var f;
  var t = e.f, a = (t & ga) !== 0;
  if (a && t & oo) {
    var r = wy(
      /** @type {Derived} */
      e
    );
    return Ru(
      /** @type {Derived} */
      e
    ), r;
  }
  if (tt !== null) {
    Pa !== null && Pa.includes(e) && i_();
    var n = tt.deps;
    Lt === null && n !== null && n[Qt] === e ? Qt++ : Lt === null ? Lt = [e] : Lt.push(e), br !== null && Ge !== null && Ge.f & Wt && !(Ge.f & wa) && br.includes(e) && (va(Ge, xr), ac(Ge));
  } else if (a && /** @type {Derived} */
  e.deps === null)
    for (var o = (
      /** @type {Derived} */
      e
    ), s = o.parent, i = o; s !== null; )
      if (s.f & ga) {
        var l = (
          /** @type {Derived} */
          s
        );
        i = l, s = l.parent;
      } else {
        var u = (
          /** @type {Effect} */
          s
        );
        (f = u.deriveds) != null && f.includes(i) || (u.deriveds ?? (u.deriveds = [])).push(i);
        break;
      }
  return a && (o = /** @type {Derived} */
  e, uo(o) && vy(o)), e.v;
}
function zt(e) {
  const t = tt;
  try {
    return tt = null, e();
  } finally {
    tt = t;
  }
}
const C_ = ~(xr | no | Wt);
function va(e, t) {
  e.f = e.f & C_ | t;
}
function rc(e) {
  return (
    /** @type {T} */
    nc().get(e)
  );
}
function Ny(e, t) {
  return nc().set(e, t), t;
}
function E_(e) {
  return nc().has(e);
}
function A_() {
  return nc();
}
function nc(e) {
  return Je === null && ec(), Je.c ?? (Je.c = new Map(T_(Je) || void 0));
}
function T_(e) {
  let t = e.p;
  for (; t !== null; ) {
    const a = t.c;
    if (a !== null)
      return a;
    t = t.p;
  }
  return null;
}
function Yd(e, t = 1) {
  var a = d(e), r = t === 1 ? a++ : a--;
  return q(e, a), r;
}
function ke(e, t = !1, a) {
  Je = {
    p: Je,
    c: null,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  }, so && !t && (Je.l = {
    s: null,
    u: null,
    r1: [],
    r2: Ot(!1)
  });
}
function xe(e) {
  const t = Je;
  if (t !== null) {
    const s = t.e;
    if (s !== null) {
      var a = Ge, r = tt;
      t.e = null;
      try {
        for (var n = 0; n < s.length; n++) {
          var o = s[n];
          Xt(o.effect), la(o.reaction), lo(o.fn);
        }
      } finally {
        Xt(a), la(r);
      }
    }
    Je = t.p, t.m = !0;
  }
  return (
    /** @type {T} */
    {}
  );
}
function $e(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (vr in e)
      Zc(e);
    else if (!Array.isArray(e))
      for (let t in e) {
        const a = e[t];
        typeof a == "object" && a && vr in a && Zc(a);
      }
  }
}
function Zc(e, t = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !t.has(e)) {
    t.add(e), e instanceof Date && e.getTime();
    for (let r in e)
      try {
        Zc(e[r], t);
      } catch {
      }
    const a = Li(e);
    if (a !== Object.prototype && a !== Array.prototype && a !== Map.prototype && a !== Set.prototype && a !== Date.prototype) {
      const r = iy(a);
      for (let n in r) {
        const o = r[n].get;
        if (o)
          try {
            o.call(e);
          } catch {
          }
      }
    }
  }
}
function P_(e, t) {
  if (t) {
    const a = document.body;
    e.autofocus = !0, Ys(() => {
      document.activeElement === a && e.focus();
    });
  }
}
let Xd = !1;
function O_() {
  Xd || (Xd = !0, document.addEventListener(
    "reset",
    (e) => {
      Promise.resolve().then(() => {
        var t;
        if (!e.defaultPrevented)
          for (
            const a of
            /**@type {HTMLFormElement} */
            e.target.elements
          )
            (t = a.__on_r) == null || t.call(a);
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function Vy(e) {
  var t = tt, a = Ge;
  la(null), Xt(null);
  try {
    return e();
  } finally {
    la(t), Xt(a);
  }
}
function M_(e, t, a, r = a) {
  e.addEventListener(t, () => Vy(a));
  const n = e.__on_r;
  n ? e.__on_r = () => {
    n(), r(!0);
  } : e.__on_r = () => r(!0), O_();
}
const qy = /* @__PURE__ */ new Set(), Yc = /* @__PURE__ */ new Set();
function By(e, t, a, r) {
  function n(o) {
    if (r.capture || Ao.call(t, o), !o.cancelBubble)
      return Vy(() => a.call(this, o));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? Ys(() => {
    t.addEventListener(e, n, r);
  }) : t.addEventListener(e, n, r), n;
}
function pt(e, t, a, r, n) {
  var o = { capture: r, passive: n }, s = By(e, t, a, o);
  (t === document.body || t === window || t === document) && ky(() => {
    t.removeEventListener(e, s, o);
  });
}
function nr(e) {
  for (var t = 0; t < e.length; t++)
    qy.add(e[t]);
  for (var a of Yc)
    a(e);
}
function Ao(e) {
  var w;
  var t = this, a = (
    /** @type {Node} */
    t.ownerDocument
  ), r = e.type, n = ((w = e.composedPath) == null ? void 0 : w.call(e)) || [], o = (
    /** @type {null | Element} */
    n[0] || e.target
  ), s = 0, i = e.__root;
  if (i) {
    var l = n.indexOf(i);
    if (l !== -1 && (t === document || t === /** @type {any} */
    window)) {
      e.__root = t;
      return;
    }
    var u = n.indexOf(t);
    if (u === -1)
      return;
    l <= u && (s = l);
  }
  if (o = /** @type {Element} */
  n[s] || e.target, o !== t) {
    Gm(e, "currentTarget", {
      configurable: !0,
      get() {
        return o || a;
      }
    });
    var f = tt, p = Ge;
    la(null), Xt(null);
    try {
      for (var c, h = []; o !== null; ) {
        var g = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var _ = o["__" + r];
          if (_ !== void 0 && !/** @type {any} */
          o.disabled)
            if (Zl(_)) {
              var [b, ...m] = _;
              b.apply(o, [e, ...m]);
            } else
              _.call(o, e);
        } catch (S) {
          c ? h.push(S) : c = S;
        }
        if (e.cancelBubble || g === t || g === null)
          break;
        o = g;
      }
      if (c) {
        for (let S of h)
          queueMicrotask(() => {
            throw S;
          });
        throw c;
      }
    } finally {
      e.__root = t, delete e.currentTarget, la(f), Xt(p);
    }
  }
}
function Vu(e) {
  var t = document.createElement("template");
  return t.innerHTML = e, t.content;
}
function Qr(e, t) {
  var a = (
    /** @type {Effect} */
    Ge
  );
  a.nodes_start === null && (a.nodes_start = e, a.nodes_end = t);
}
// @__NO_SIDE_EFFECTS__
function L(e, t) {
  var a = (t & 1) !== 0, r = (t & 2) !== 0, n, o = !e.startsWith("<!>");
  return () => {
    n === void 0 && (n = Vu(o ? e : "<!>" + e), a || (n = /** @type {Node} */
    /* @__PURE__ */ Jr(n)));
    var s = (
      /** @type {TemplateNode} */
      r ? document.importNode(n, !0) : n.cloneNode(!0)
    );
    if (a) {
      var i = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Jr(s)
      ), l = (
        /** @type {TemplateNode} */
        s.lastChild
      );
      Qr(i, l);
    } else
      Qr(s, s);
    return s;
  };
}
// @__NO_SIDE_EFFECTS__
function St(e, t, a = "svg") {
  var r = !e.startsWith("<!>"), n = `<${a}>${r ? e : "<!>" + e}</${a}>`, o;
  return () => {
    if (!o) {
      var s = (
        /** @type {DocumentFragment} */
        Vu(n)
      ), i = (
        /** @type {Element} */
        /* @__PURE__ */ Jr(s)
      );
      o = /** @type {Element} */
      /* @__PURE__ */ Jr(i);
    }
    var l = (
      /** @type {TemplateNode} */
      o.cloneNode(!0)
    );
    return Qr(l, l), l;
  };
}
function Xn(e = "") {
  {
    var t = Zs(e + "");
    return Qr(t, t), t;
  }
}
function K() {
  var e = document.createDocumentFragment(), t = document.createComment(""), a = Zs();
  return e.append(t, a), Qr(t, a), e;
}
function z(e, t) {
  e !== null && e.before(
    /** @type {Node} */
    t
  );
}
function I_(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const F_ = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function j_(e) {
  return F_.includes(e);
}
const R_ = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject"
};
function L_(e) {
  return e = e.toLowerCase(), R_[e] ?? e;
}
const D_ = ["touchstart", "touchmove"];
function N_(e) {
  return D_.includes(e);
}
let Vi = !0;
function Jd(e) {
  Vi = e;
}
function Me(e, t) {
  var a = t == null ? "" : typeof t == "object" ? t + "" : t;
  a !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = a, e.nodeValue = a == null ? "" : a + "");
}
function qu(e, t) {
  return V_(e, t);
}
const pn = /* @__PURE__ */ new Map();
function V_(e, { target: t, anchor: a, props: r = {}, events: n, context: o, intro: s = !0 }) {
  u_();
  var i = /* @__PURE__ */ new Set(), l = (p) => {
    for (var c = 0; c < p.length; c++) {
      var h = p[c];
      if (!i.has(h)) {
        i.add(h);
        var g = N_(h);
        t.addEventListener(h, Ao, { passive: g });
        var _ = pn.get(h);
        _ === void 0 ? (document.addEventListener(h, Ao, { passive: g }), pn.set(h, 1)) : pn.set(h, _ + 1);
      }
    }
  };
  l(Fu(qy)), Yc.add(l);
  var u = void 0, f = xy(() => {
    var p = a ?? t.appendChild(Zs());
    return Ia(() => {
      if (o) {
        ke({});
        var c = (
          /** @type {ComponentContext} */
          Je
        );
        c.c = o;
      }
      n && (r.$$events = n), Vi = s, u = e(p, r) || {}, Vi = !0, o && xe();
    }), () => {
      var g;
      for (var c of i) {
        t.removeEventListener(c, Ao);
        var h = (
          /** @type {number} */
          pn.get(c)
        );
        --h === 0 ? (document.removeEventListener(c, Ao), pn.delete(c)) : pn.set(c, h);
      }
      Yc.delete(l), Xc.delete(u), p !== a && ((g = p.parentNode) == null || g.removeChild(p));
    };
  });
  return Xc.set(u, f), u;
}
let Xc = /* @__PURE__ */ new WeakMap();
function Jc(e) {
  const t = Xc.get(e);
  t && t();
}
function B(e, t, a = !1) {
  var r = e, n = null, o = null, s = qt, i = a ? ln : 0, l = !1;
  const u = (p, c = !0) => {
    l = !0, f(c, p);
  }, f = (p, c) => {
    s !== (s = p) && (s ? (n ? Fo(n) : c && (n = Ia(() => c(r))), o && Yn(o, () => {
      o = null;
    })) : (o ? Fo(o) : c && (o = Ia(() => c(r))), n && Yn(n, () => {
      n = null;
    })));
  };
  Or(() => {
    l = !1, t(u), l || f(null, null);
  }, i);
}
function zr(e, t, a) {
  var r = e, n = qt, o, s = Xs() ? $m : Xl;
  Or(() => {
    s(n, n = t()) && (o && Yn(o), o = Ia(() => a(r)));
  });
}
let Yr = null;
function Qd(e) {
  Yr = e;
}
function yt(e, t) {
  return t;
}
function q_(e, t, a, r) {
  for (var n = [], o = t.length, s = 0; s < o; s++)
    Lu(t[s].e, n, !0);
  var i = o > 0 && n.length === 0 && a !== null;
  if (i) {
    var l = (
      /** @type {Element} */
      /** @type {Element} */
      a.parentNode
    );
    d_(l), l.append(
      /** @type {Element} */
      a
    ), r.clear(), fr(e, t[0].prev, t[o - 1].next);
  }
  Ay(n, () => {
    for (var u = 0; u < o; u++) {
      var f = t[u];
      i || (r.delete(f.k), fr(e, f.prev, f.next)), La(f.e, !i);
    }
  });
}
function et(e, t, a, r, n, o = null) {
  var s = e, i = { flags: t, items: /* @__PURE__ */ new Map(), first: null }, l = (t & 4) !== 0;
  if (l) {
    var u = (
      /** @type {Element} */
      e
    );
    s = u.appendChild(Zs());
  }
  var f = null, p = !1;
  Or(() => {
    var c = a(), h = Zl(c) ? c : c == null ? [] : Fu(c), g = h.length;
    if (!(p && g === 0)) {
      p = g === 0;
      {
        var _ = (
          /** @type {Effect} */
          tt
        );
        B_(h, i, s, n, t, (_.f & Ta) !== 0, r);
      }
      o !== null && (g === 0 ? f ? Fo(f) : f = Ia(() => o(s)) : f !== null && Yn(f, () => {
        f = null;
      })), a();
    }
  });
}
function B_(e, t, a, r, n, o, s) {
  var E, N, H, Y;
  var i = (n & 8) !== 0, l = (n & 3) !== 0, u = e.length, f = t.items, p = t.first, c = p, h, g = null, _, b = [], m = [], w, S, C, v;
  if (i)
    for (v = 0; v < u; v += 1)
      w = e[v], S = s(w, v), C = f.get(S), C !== void 0 && ((E = C.a) == null || E.measure(), (_ ?? (_ = /* @__PURE__ */ new Set())).add(C));
  for (v = 0; v < u; v += 1) {
    if (w = e[v], S = s(w, v), C = f.get(S), C === void 0) {
      var y = c ? (
        /** @type {TemplateNode} */
        c.e.nodes_start
      ) : a;
      g = H_(
        y,
        t,
        g,
        g === null ? t.first : g.next,
        w,
        S,
        v,
        r,
        n
      ), f.set(S, g), b = [], m = [], c = g.next;
      continue;
    }
    if (l && W_(C, w, v, n), C.e.f & Ta && (Fo(C.e), i && ((N = C.a) == null || N.unfix(), (_ ?? (_ = /* @__PURE__ */ new Set())).delete(C))), C !== c) {
      if (h !== void 0 && h.has(C)) {
        if (b.length < m.length) {
          var k = m[0], x;
          g = k.prev;
          var T = b[0], F = b[b.length - 1];
          for (x = 0; x < b.length; x += 1)
            $d(b[x], k, a);
          for (x = 0; x < m.length; x += 1)
            h.delete(m[x]);
          fr(t, T.prev, F.next), fr(t, g, T), fr(t, F, k), c = k, g = F, v -= 1, b = [], m = [];
        } else
          h.delete(C), $d(C, c, a), fr(t, C.prev, C.next), fr(t, C, g === null ? t.first : g.next), fr(t, g, C), g = C;
        continue;
      }
      for (b = [], m = []; c !== null && c.k !== S; )
        (o || !(c.e.f & Ta)) && (h ?? (h = /* @__PURE__ */ new Set())).add(c), m.push(c), c = c.next;
      if (c === null)
        continue;
      C = c;
    }
    b.push(C), g = C, c = C.next;
  }
  if (c !== null || h !== void 0) {
    for (var P = h === void 0 ? [] : Fu(h); c !== null; )
      (o || !(c.e.f & Ta)) && P.push(c), c = c.next;
    var O = P.length;
    if (O > 0) {
      var I = n & 4 && u === 0 ? a : null;
      if (i) {
        for (v = 0; v < O; v += 1)
          (H = P[v].a) == null || H.measure();
        for (v = 0; v < O; v += 1)
          (Y = P[v].a) == null || Y.fix();
      }
      q_(t, P, I, f);
    }
  }
  i && Ys(() => {
    var V;
    if (_ !== void 0)
      for (C of _)
        (V = C.a) == null || V.apply();
  }), Ge.first = t.first && t.first.e, Ge.last = g && g.e;
}
function W_(e, t, a, r) {
  r & 1 && Gc(e.v, t), r & 2 ? Gc(
    /** @type {Value<number>} */
    e.i,
    a
  ) : e.i = a;
}
function H_(e, t, a, r, n, o, s, i, l) {
  var u = Yr, f = (l & 1) !== 0, p = (l & 16) === 0, c = f ? p ? /* @__PURE__ */ Jl(n) : Ot(n) : n, h = l & 2 ? Ot(s) : s, g = {
    i: h,
    v: c,
    k: o,
    a: null,
    // @ts-expect-error
    e: null,
    prev: a,
    next: r
  };
  Yr = g;
  try {
    return g.e = Ia(() => i(e, c, h), hy), g.e.prev = a && a.e, g.e.next = r && r.e, a === null ? t.first = g : (a.next = g, a.e.next = g.e), r !== null && (r.prev = g, r.e.prev = g.e), g;
  } finally {
    Yr = u;
  }
}
function $d(e, t, a) {
  for (var r = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : a, n = t ? (
    /** @type {TemplateNode} */
    t.e.nodes_start
  ) : a, o = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); o !== r; ) {
    var s = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ Ql(o)
    );
    n.before(o), o = s;
  }
}
function fr(e, t, a) {
  t === null ? e.first = a : (t.next = a, t.e.next = a && a.e), a !== null && (a.prev = t, a.e.prev = t && t.e);
}
function At(e, t, a, r, n) {
  var o = e, s = "", i;
  Or(() => {
    s !== (s = t() ?? "") && (i !== void 0 && (La(i), i = void 0), s !== "" && (i = Ia(() => {
      var l = s + "", u = Vu(l);
      Qr(
        /** @type {TemplateNode} */
        /* @__PURE__ */ Jr(u),
        /** @type {TemplateNode} */
        u.lastChild
      ), o.before(u);
    })));
  });
}
function Ze(e, t, a, r, n) {
  var i;
  var o = (i = t.$$slots) == null ? void 0 : i[a], s = !1;
  o === !0 && (o = t[a === "default" ? "children" : a], s = !0), o === void 0 ? n !== null && n(e) : o(e, s ? () => r : r);
}
function nt(e, t, ...a) {
  var r = e, n = qe, o;
  Or(() => {
    n !== (n = t()) && (o && (La(o), o = null), o = Ia(() => (
      /** @type {SnippetFn} */
      n(r, ...a)
    )));
  }, ln);
}
function Xe(e, t, a) {
  var r = e, n, o;
  Or(() => {
    n !== (n = t()) && (o && (Yn(o), o = null), n && (o = Ia(() => a(r, n))));
  }, ln);
}
function U_(e, t, a, r, n, o) {
  var s, i, l = null, u = (
    /** @type {TemplateNode} */
    e
  ), f, p = Yr;
  Or(() => {
    const c = t() || null;
    var h = oy;
    if (c !== s) {
      var g = Yr;
      Qd(p), f && (c === null ? Yn(f, () => {
        f = null, i = null;
      }) : c === i ? Fo(f) : (La(f), Jd(!1))), c && c !== i && (f = Ia(() => {
        if (l = document.createElementNS(h, c), Qr(l, l), r) {
          var _ = (
            /** @type {TemplateNode} */
            l.appendChild(Zs())
          );
          r(l, _);
        }
        Ge.nodes_end = l, u.before(l);
      })), s = c, s && (i = s), Jd(!0), Qd(g);
    }
  }, ln);
}
function Qc(e, t, a) {
  lo(() => {
    var r = zt(() => t(e, a == null ? void 0 : a()) || {});
    if (a && (r != null && r.update)) {
      var n = !1, o = (
        /** @type {any} */
        {}
      );
      co(() => {
        var s = a();
        $e(s), n && Xl(o, s) && (o = s, r.update(s));
      }), n = !0;
    }
    if (r != null && r.destroy)
      return () => (
        /** @type {Function} */
        r.destroy()
      );
  });
}
function be(e, t, a, r) {
  var n = e.__attributes ?? (e.__attributes = {});
  n[t] !== (n[t] = a) && (t === "style" && "__styles" in e && (e.__styles = {}), t === "loading" && (e[Qm] = a), a == null ? e.removeAttribute(t) : typeof a != "string" && Bu(e).includes(t) ? e[t] = a : e.setAttribute(t, a));
}
function ef(e, t, a) {
  var r = tt, n = Ge;
  la(null), Xt(null);
  try {
    Bu(e).includes(t) ? e[t] = a : be(e, t, a);
  } finally {
    la(r), Xt(n);
  }
}
function at(e, t, a, r, n = !1, o = !1, s = !1) {
  var i = t || {}, l = e.tagName === "OPTION";
  for (var u in t)
    u in a || (a[u] = null);
  r !== void 0 && (a.class = a.class ? a.class + " " + r : r);
  var f = Bu(e), p = (
    /** @type {Record<string, unknown>} **/
    e.__attributes ?? (e.__attributes = {})
  );
  for (const b in a) {
    let m = a[b];
    if (l && b === "value" && m == null) {
      e.value = e.__value = "", i[b] = m;
      continue;
    }
    var c = i[b];
    if (m !== c) {
      i[b] = m;
      var h = b[0] + b[1];
      if (h !== "$$") {
        if (h === "on") {
          const w = {}, S = "$$" + b;
          let C = b.slice(2);
          var g = j_(C);
          if (I_(C) && (C = C.slice(0, -7), w.capture = !0), !g && c) {
            if (m != null) continue;
            e.removeEventListener(C, i[S], w), i[S] = null;
          }
          if (m != null)
            if (g)
              e[`__${C}`] = m, nr([C]);
            else {
              let v = function(y) {
                i[b].call(this, y);
              };
              i[S] = By(C, e, v, w);
            }
          else g && (e[`__${C}`] = void 0);
        } else if (b === "style" && m != null)
          e.style.cssText = m + "";
        else if (b === "autofocus")
          P_(
            /** @type {HTMLElement} */
            e,
            !!m
          );
        else if (b === "__value" || b === "value" && m != null)
          e.value = e[b] = e.__value = m;
        else {
          var _ = b;
          n || (_ = L_(_)), m == null && !o ? (p[b] = null, e.removeAttribute(b)) : f.includes(_) && (o || typeof m != "string") ? e[_] = m : typeof m != "function" && be(e, _, m);
        }
        b === "style" && "__styles" in e && (e.__styles = {});
      }
    }
  }
  return i;
}
var tf = /* @__PURE__ */ new Map();
function Bu(e) {
  var t = tf.get(e.nodeName);
  if (t) return t;
  tf.set(e.nodeName, t = []);
  for (var a, r = Li(e), n = Element.prototype; n !== r; ) {
    a = iy(r);
    for (var o in a)
      a[o].set && t.push(o);
    r = Li(r);
  }
  return t;
}
function Ue(e, t) {
  var a = e.__className, r = G_(t);
  (a !== r || hy) && (t == null ? e.removeAttribute("class") : e.className = r, e.__className = r);
}
function G_(e) {
  return e ?? "";
}
function ci(e, t, a) {
  if (a) {
    if (e.classList.contains(t)) return;
    e.classList.add(t);
  } else {
    if (!e.classList.contains(t)) return;
    e.classList.remove(t);
  }
}
function Ja(e, t, a, r) {
  var n = e.__styles ?? (e.__styles = {});
  n[t] !== a && (n[t] = a, a == null ? e.style.removeProperty(t) : e.style.setProperty(t, a, ""));
}
const K_ = () => performance.now(), Qa = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => K_(),
  tasks: /* @__PURE__ */ new Set()
};
function Wy() {
  const e = Qa.now();
  Qa.tasks.forEach((t) => {
    t.c(e) || (Qa.tasks.delete(t), t.f());
  }), Qa.tasks.size !== 0 && Qa.tick(Wy);
}
function Z_(e) {
  let t;
  return Qa.tasks.size === 0 && Qa.tick(Wy), {
    promise: new Promise((a) => {
      Qa.tasks.add(t = { c: e, f: a });
    }),
    abort() {
      Qa.tasks.delete(t);
    }
  };
}
function ui(e, t) {
  e.dispatchEvent(new CustomEvent(t));
}
function Y_(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const t = e.split("-");
  return t.length === 1 ? t[0] : t[0] + t.slice(1).map(
    /** @param {any} word */
    (a) => a[0].toUpperCase() + a.slice(1)
  ).join("");
}
function af(e) {
  const t = {}, a = e.split(";");
  for (const r of a) {
    const [n, o] = r.split(":");
    if (!n || o === void 0) break;
    const s = Y_(n.trim());
    t[s] = o.trim();
  }
  return t;
}
const X_ = (e) => e;
function J_(e, t, a) {
  var r = (
    /** @type {EachItem} */
    Yr
  ), n, o, s, i = null;
  r.a ?? (r.a = {
    element: e,
    measure() {
      n = this.element.getBoundingClientRect();
    },
    apply() {
      if (s == null || s.abort(), o = this.element.getBoundingClientRect(), n.left !== o.left || n.right !== o.right || n.top !== o.top || n.bottom !== o.bottom) {
        const l = t()(this.element, { from: n, to: o }, a == null ? void 0 : a());
        s = qi(this.element, l, void 0, 1, () => {
          s == null || s.abort(), s = void 0;
        });
      }
    },
    fix() {
      if (!e.getAnimations().length) {
        var { position: l, width: u, height: f } = getComputedStyle(e);
        if (l !== "absolute" && l !== "fixed") {
          var p = (
            /** @type {HTMLElement | SVGElement} */
            e.style
          );
          i = {
            position: p.position,
            width: p.width,
            height: p.height,
            transform: p.transform
          }, p.position = "absolute", p.width = u, p.height = f;
          var c = e.getBoundingClientRect();
          if (n.left !== c.left || n.top !== c.top) {
            var h = `translate(${n.left - c.left}px, ${n.top - c.top}px)`;
            p.transform = p.transform ? `${p.transform} ${h}` : h;
          }
        }
      }
    },
    unfix() {
      if (i) {
        var l = (
          /** @type {HTMLElement | SVGElement} */
          e.style
        );
        l.position = i.position, l.width = i.width, l.height = i.height, l.transform = i.transform;
      }
    }
  }), r.a.element = e;
}
function xt(e, t, a, r) {
  var n = (e & 1) !== 0, o = (e & 2) !== 0, s = n && o, i = (e & 4) !== 0, l = s ? "both" : n ? "in" : "out", u, f = t.inert, p, c;
  function h() {
    var w = tt, S = Ge;
    la(null), Xt(null);
    try {
      return u ?? (u = a()(t, (r == null ? void 0 : r()) ?? /** @type {P} */
      {}, {
        direction: l
      }));
    } finally {
      la(w), Xt(S);
    }
  }
  var g = {
    is_global: i,
    in() {
      var w;
      if (t.inert = f, !n) {
        c == null || c.abort(), (w = c == null ? void 0 : c.reset) == null || w.call(c);
        return;
      }
      o || p == null || p.abort(), ui(t, "introstart"), p = qi(t, h(), c, 1, () => {
        ui(t, "introend"), p == null || p.abort(), p = u = void 0;
      });
    },
    out(w) {
      if (!o) {
        w == null || w(), u = void 0;
        return;
      }
      t.inert = !0, ui(t, "outrostart"), c = qi(t, h(), p, 0, () => {
        ui(t, "outroend"), w == null || w();
      });
    },
    stop: () => {
      p == null || p.abort(), c == null || c.abort();
    }
  }, _ = (
    /** @type {Effect} */
    Ge
  );
  if ((_.transitions ?? (_.transitions = [])).push(g), n && Vi) {
    var b = i;
    if (!b) {
      for (var m = (
        /** @type {Effect | null} */
        _.parent
      ); m && m.f & ln; )
        for (; (m = m.parent) && !(m.f & Yl); )
          ;
      b = !m || (m.f & cy) !== 0;
    }
    b && lo(() => {
      zt(() => g.in());
    });
  }
}
function qi(e, t, a, r, n) {
  var o = r === 1;
  if (bn(t)) {
    var s, i = !1;
    return Ys(() => {
      if (!i) {
        var b = t({ direction: o ? "in" : "out" });
        s = qi(e, b, a, r, n);
      }
    }), {
      abort: () => {
        i = !0, s == null || s.abort();
      },
      deactivate: () => s.deactivate(),
      reset: () => s.reset(),
      t: () => s.t()
    };
  }
  if (a == null || a.deactivate(), !(t != null && t.duration))
    return n(), {
      abort: qe,
      deactivate: qe,
      reset: qe,
      t: () => r
    };
  const { delay: l = 0, css: u, tick: f, easing: p = X_ } = t;
  var c = [];
  if (o && a === void 0 && (f && f(0, 1), u)) {
    var h = af(u(0, 1));
    c.push(h, h);
  }
  var g = () => 1 - r, _ = e.animate(c, { duration: l });
  return _.onfinish = () => {
    var b = (a == null ? void 0 : a.t()) ?? 1 - r;
    a == null || a.abort();
    var m = r - b, w = (
      /** @type {number} */
      t.duration * Math.abs(m)
    ), S = [];
    if (w > 0) {
      if (u)
        for (var C = Math.ceil(w / 16.666666666666668), v = 0; v <= C; v += 1) {
          var y = b + m * p(v / C), k = u(y, 1 - y);
          S.push(af(k));
        }
      g = () => {
        var x = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          _.currentTime
        );
        return b + m * p(x / w);
      }, f && Z_(() => {
        if (_.playState !== "running") return !1;
        var x = g();
        return f(x, 1 - x), !0;
      });
    }
    _ = e.animate(S, { duration: w, fill: "forwards" }), _.onfinish = () => {
      g = () => r, f == null || f(r, 1 - r), n();
    };
  }, {
    abort: () => {
      _ && (_.cancel(), _.effect = null, _.onfinish = qe);
    },
    deactivate: () => {
      n = qe;
    },
    reset: () => {
      r === 0 && (f == null || f(1, 0));
    },
    t: () => g()
  };
}
function Q_(e, t, a = t) {
  var r = Xs();
  M_(e, "input", (n) => {
    var o = n ? e.defaultValue : e.value;
    if (o = Sc(e) ? Cc(o) : o, a(o), r && o !== (o = t())) {
      var s = e.selectionStart, i = e.selectionEnd;
      e.value = o ?? "", i !== null && (e.selectionStart = s, e.selectionEnd = Math.min(i, e.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  zt(t) == null && e.value && a(Sc(e) ? Cc(e.value) : e.value), co(() => {
    var n = t();
    Sc(e) && n === Cc(e.value) || e.type === "date" && !n && !e.value || n !== e.value && (e.value = n ?? "");
  });
}
function Sc(e) {
  var t = e.type;
  return t === "number" || t === "range";
}
function Cc(e) {
  return e === "" ? null : +e;
}
function rf(e, t) {
  return e === t || (e == null ? void 0 : e[vr]) === t;
}
function aa(e = {}, t, a, r) {
  return lo(() => {
    var n, o;
    return co(() => {
      n = o, o = (r == null ? void 0 : r()) || [], zt(() => {
        e !== a(...o) && (t(e, ...o), n && rf(a(...n), e) && t(null, ...n));
      });
    }), () => {
      Ys(() => {
        o && rf(a(...o), e) && t(null, ...o);
      });
    };
  }), e;
}
function ca(e = !1) {
  const t = (
    /** @type {ComponentContextLegacy} */
    Je
  ), a = t.l.u;
  if (!a) return;
  let r = () => $e(t.s);
  if (e) {
    let n = 0, o = (
      /** @type {Record<string, any>} */
      {}
    );
    const s = /* @__PURE__ */ M(() => {
      let i = !1;
      const l = t.s;
      for (const u in l)
        l[u] !== o[u] && (o[u] = l[u], i = !0);
      return i && n++, n;
    });
    r = () => d(s);
  }
  a.b.length && h_(() => {
    nf(t, r), Hc(a.b);
  }), Pe(() => {
    const n = zt(() => a.m.map(Ym));
    return () => {
      for (const o of n)
        typeof o == "function" && o();
    };
  }), a.a.length && Pe(() => {
    nf(t, r), Hc(a.a);
  });
}
function nf(e, t) {
  if (e.l.s)
    for (const a of e.l.s) d(a);
  t();
}
function Da(e) {
  Je === null && ec(), so && Je.l !== null ? tw(Je).m.push(e) : Pe(() => {
    const t = zt(e);
    if (typeof t == "function") return (
      /** @type {() => void} */
      t
    );
  });
}
function Wu(e) {
  Je === null && ec(), Da(() => () => zt(e));
}
function $_(e, t, { bubbles: a = !1, cancelable: r = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: a, cancelable: r });
}
function ew() {
  const e = Je;
  return e === null && ec(), (t, a, r) => {
    var o;
    const n = (
      /** @type {Record<string, Function | Function[]>} */
      (o = e.s.$$events) == null ? void 0 : o[
        /** @type {any} */
        t
      ]
    );
    if (n) {
      const s = Zl(n) ? n.slice() : [n], i = $_(
        /** @type {string} */
        t,
        a,
        r
      );
      for (const l of s)
        l.call(e.x, i);
      return !i.defaultPrevented;
    }
    return !0;
  };
}
function tw(e) {
  var t = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return t.u ?? (t.u = { a: [], b: [], m: [] });
}
function Hy(e, t, a) {
  if (e == null)
    return t(void 0), qe;
  const r = zt(
    () => e.subscribe(
      t,
      // @ts-expect-error
      a
    )
  );
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
let di = !1;
function Yt(e, t, a) {
  const r = a[t] ?? (a[t] = {
    store: null,
    source: /* @__PURE__ */ Jl(void 0),
    unsubscribe: qe
  });
  if (r.store !== e)
    if (r.unsubscribe(), r.store = e ?? null, e == null)
      r.source.v = void 0, r.unsubscribe = qe;
    else {
      var n = !0;
      r.unsubscribe = Hy(e, (o) => {
        n ? r.source.v = o : q(r.source, o);
      }), n = !1;
    }
  return d(r.source);
}
function aw(e, t, a) {
  let r = a[t];
  return r && r.store !== e && (r.unsubscribe(), r.unsubscribe = qe), e;
}
function ba() {
  const e = {};
  return ky(() => {
    for (var t in e)
      e[t].unsubscribe();
  }), e;
}
function rw(e) {
  var t = di;
  try {
    return di = !1, [e(), di];
  } finally {
    di = t;
  }
}
const nw = {
  get(e, t) {
    if (!e.exclude.includes(t))
      return e.props[t];
  },
  set(e, t) {
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    if (!e.exclude.includes(t) && t in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[t]
      };
  },
  has(e, t) {
    return e.exclude.includes(t) ? !1 : t in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((t) => !e.exclude.includes(t));
  }
};
// @__NO_SIDE_EFFECTS__
function st(e, t, a) {
  return new Proxy(
    { props: e, exclude: t },
    nw
  );
}
const ow = {
  get(e, t) {
    if (!e.exclude.includes(t))
      return d(e.version), t in e.special ? e.special[t]() : e.props[t];
  },
  set(e, t, a) {
    return t in e.special || (e.special[t] = R(
      {
        get [t]() {
          return e.props[t];
        }
      },
      /** @type {string} */
      t,
      4
    )), e.special[t](a), Yd(e.version), !0;
  },
  getOwnPropertyDescriptor(e, t) {
    if (!e.exclude.includes(t) && t in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[t]
      };
  },
  deleteProperty(e, t) {
    return e.exclude.includes(t) || (e.exclude.push(t), Yd(e.version)), !0;
  },
  has(e, t) {
    return e.exclude.includes(t) ? !1 : t in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((t) => !e.exclude.includes(t));
  }
};
function Dt(e, t) {
  return new Proxy({ props: e, exclude: t, special: {}, version: Ot(0) }, ow);
}
const sw = {
  get(e, t) {
    let a = e.props.length;
    for (; a--; ) {
      let r = e.props[a];
      if (bn(r) && (r = r()), typeof r == "object" && r !== null && t in r) return r[t];
    }
  },
  set(e, t, a) {
    let r = e.props.length;
    for (; r--; ) {
      let n = e.props[r];
      bn(n) && (n = n());
      const o = wr(n, t);
      if (o && o.set)
        return o.set(a), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    let a = e.props.length;
    for (; a--; ) {
      let r = e.props[a];
      if (bn(r) && (r = r()), typeof r == "object" && r !== null && t in r) {
        const n = wr(r, t);
        return n && !n.configurable && (n.configurable = !0), n;
      }
    }
  },
  has(e, t) {
    if (t === vr || t === dy) return !1;
    for (let a of e.props)
      if (bn(a) && (a = a()), a != null && t in a) return !0;
    return !1;
  },
  ownKeys(e) {
    const t = [];
    for (let a of e.props) {
      bn(a) && (a = a());
      for (const r in a)
        t.includes(r) || t.push(r);
    }
    return t;
  }
};
function it(...e) {
  return new Proxy({ props: e }, sw);
}
function of(e) {
  for (var t = Ge, a = Ge; t !== null && !(t.f & (wa | Ks)); )
    t = t.parent;
  try {
    return Xt(t), e();
  } finally {
    Xt(a);
  }
}
function R(e, t, a, r) {
  var k;
  var n = (a & 1) !== 0, o = !so || (a & 2) !== 0, s = (a & 8) !== 0, i = (a & 16) !== 0, l = !1, u;
  s ? [u, l] = rw(() => (
    /** @type {V} */
    e[t]
  )) : u = /** @type {V} */
  e[t];
  var f = vr in e || dy in e, p = ((k = wr(e, t)) == null ? void 0 : k.set) ?? (f && s && t in e ? (x) => e[t] = x : void 0), c = (
    /** @type {V} */
    r
  ), h = !0, g = !1, _ = () => (g = !0, h && (h = !1, i ? c = zt(
    /** @type {() => V} */
    r
  ) : c = /** @type {V} */
  r), c);
  u === void 0 && r !== void 0 && (p && o && n_(), u = _(), p && p(u));
  var b;
  if (o)
    b = () => {
      var x = (
        /** @type {V} */
        e[t]
      );
      return x === void 0 ? _() : (h = !0, g = !1, x);
    };
  else {
    var m = of(
      () => (n ? M : kt)(() => (
        /** @type {V} */
        e[t]
      ))
    );
    m.f |= Xm, b = () => {
      var x = d(m);
      return x !== void 0 && (c = /** @type {V} */
      void 0), x === void 0 ? c : x;
    };
  }
  if (!(a & 4))
    return b;
  if (p) {
    var w = e.$$legacy;
    return function(x, T) {
      return arguments.length > 0 ? ((!o || !T || w || l) && p(T ? b() : x), x) : b();
    };
  }
  var S = !1, C = !1, v = /* @__PURE__ */ Jl(u), y = of(
    () => /* @__PURE__ */ M(() => {
      var x = b(), T = d(v);
      return S ? (S = !1, C = !0, T) : (C = !1, v.v = x);
    })
  );
  return n || (y.equals = ju), function(x, T) {
    if (arguments.length > 0) {
      const F = T ? d(y) : o && s ? ce(x) : x;
      return y.equals(F) || (S = !0, q(v, F), g && c !== void 0 && (c = F), zt(() => d(y))), x;
    }
    return d(y);
  };
}
const iw = () => {
  let e = me(ce({ api_key: void 0, platform_id: void 0 })), t = me(ce({
    api_host: "https://api.layuplabs.ai",
    user_data: {},
    group_id: "everyone",
    theme: void 0,
    debug: !1,
    URLpath: "",
    isSSR: !1,
    anchor: {
      side: "right",
      align: "center",
      element: null,
      id: null,
      sideOffset: 10,
      alignOffset: 20
    },
    variant: "sidebar",
    name: "Layup",
    styles: void 0,
    onClose: () => {
    },
    onInit: () => {
    },
    onOpen: () => {
    },
    onMetadata: () => {
    }
  }));
  return {
    get config() {
      return d(t);
    },
    set config(a) {
      q(t, ce(a));
    },
    get internal_config() {
      return d(e);
    },
    set internal_config(a) {
      q(e, ce(a));
    }
  };
}, Z = iw(), Ti = (e, t) => {
  ["#layup-app"].forEach((r) => {
    const n = document.querySelector(r);
    n && (n.style.setProperty("--layup-item-gap", `${e.spacing.gap.item}px`), n.style.setProperty(
      "--layup-section-gap",
      `${e.spacing.gap.section}px`
    ), n.style.setProperty("--layup-width", `${e.spacing.width}px`), n.style.setProperty(
      "--layup-padding-default",
      `${e.spacing.padding.default}px`
    ), n.style.setProperty(
      "--layup-padding-controller-vertical",
      `${e.spacing.padding.controller.vertical}px`
    ), n.style.setProperty(
      "--layup-padding-controller-horizontal",
      `${e.spacing.padding.controller.horizontal}px`
    ), n.style.setProperty(
      "--layup-padding-text-guidance",
      `${e.spacing.padding.text_guidance}px`
    ), document.documentElement.style.setProperty(
      "--layup-item-gap",
      `${e.spacing.gap.item}px`
    ), document.documentElement.style.setProperty(
      "--layup-section-gap",
      `${e.spacing.gap.section}px`
    ), document.documentElement.style.setProperty(
      "--layup-width",
      `${e.spacing.width}px`
    ), document.documentElement.style.setProperty(
      "--layup-padding-default",
      `${e.spacing.padding.default}px`
    ), document.documentElement.style.setProperty(
      "--layup-padding-controller-vertical",
      `${e.spacing.padding.controller.vertical}px`
    ), document.documentElement.style.setProperty(
      "--layup-padding-controller-horizontal",
      `${e.spacing.padding.controller.horizontal}px`
    ), document.documentElement.style.setProperty(
      "--layup-padding-text-guidance",
      `${e.spacing.padding.text_guidance}px`
    ), n.style.setProperty(
      "--layup-radius-inner",
      `${e.border_radius.inner}px`
    ), n.style.setProperty(
      "--layup-radius-outer",
      `${e.border_radius.outer}px`
    ), n.style.setProperty(
      "--layup-radius-button-inner",
      `${e.border_radius["button-secondary"]}px`
    ), n.style.setProperty(
      "--layup-radius-button-outer",
      `${e.border_radius["button-primary"]}px`
    ), document.documentElement.style.setProperty(
      "--layup-radius-inner",
      `${e.border_radius.inner}px`
    ), document.documentElement.style.setProperty(
      "--layup-radius-outer",
      `${e.border_radius.outer}px`
    ), document.documentElement.style.setProperty(
      "--layup-radius-button-inner",
      `${e.border_radius["button-secondary"]}px`
    ), document.documentElement.style.setProperty(
      "--layup-radius-button-outer",
      `${e.border_radius["button-primary"]}px`
    ), Object.entries(t).forEach(([o, s]) => {
      if (typeof s == "string") {
        const i = o === "shadow" ? s : `hsla(${s})`;
        n.style.setProperty(`--layup-${o}`, i), document.documentElement.style.setProperty(
          `--layup-${o}`,
          i
        );
      }
    }));
  });
}, fi = async () => {
  var a, r;
  if (!((a = Z.internal_config) != null && a.api_key) || !((r = Z.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${Z.config.api_host}/platform-user/announcements?platform_user_id=${Z.config.user_data.user_id}`,
    {
      headers: {
        "x-api-token": Z.internal_config.api_key
      }
    }
  )).json();
}, lw = async () => {
  var e, t;
  if (!((e = Z.internal_config) != null && e.api_key) || !((t = Z.config) != null && t.api_host))
    throw new Error("API key or host is not defined");
  try {
    const a = await fetch(
      `${Z.config.api_host}/platform-user/widget/init`,
      {
        method: "POST",
        headers: {
          "x-api-token": Z.internal_config.api_key,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          group_id: Z.config.group_id,
          platform_user_data: Z.config.user_data
        })
      }
    );
    return a.ok ? a.json() : null;
  } catch (a) {
    return console.error("Error initializing widget:", a), null;
  }
}, pi = async () => {
  var a, r;
  if (!((a = Z.internal_config) != null && a.api_key) || !((r = Z.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  const e = await fetch(
    `${Z.config.api_host}/platform-user/onboarding-plan?platform_user_id=${Z.config.user_data.user_id}`,
    {
      headers: {
        "x-api-token": Z.internal_config.api_key
      }
    }
  );
  if (!e.ok)
    throw new Error("Something went wrong");
  return await e.json();
}, cw = async () => {
  var a, r;
  if (!((a = Z.internal_config) != null && a.api_key) || !((r = Z.config) != null && r.api_host))
    throw new Error("API key or host is not defined");
  const e = await fetch(
    `${Z.config.api_host}/platform-user/query-history?user_id=${Z.config.user_data.user_id}&platform_id=${Z.internal_config.platform_id}`,
    {
      headers: {
        "x-api-token": Z.internal_config.api_key
      }
    }
  );
  if (!e.ok)
    throw new Error("Something went wrong");
  return await e.json();
}, uw = async (e) => {
  var r, n;
  if (!((r = Z.internal_config) != null && r.api_key) || !((n = Z.config) != null && n.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${Z.config.api_host}/platform-user/platforms/onboarding-flow/get_selected_flow?template_onboarding_flow_id=${e}&user_id=${Z.config.user_data.user_id}`,
    {
      headers: {
        "x-api-token": Z.internal_config.api_key
      }
    }
  )).json();
}, sf = async (e, t, a, r) => {
  var s, i;
  if (!((s = Z.internal_config) != null && s.api_key) || !((i = Z.config) != null && i.api_host))
    throw new Error("API key or host is not defined");
  return await (await fetch(
    `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/queries/${e}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-api-token": Z.internal_config.api_key
      },
      body: JSON.stringify({
        status: t,
        completed_flow_steps: a,
        is_helpful: r
      })
    }
  )).json();
}, yi = async (e, t) => {
  var n;
  return await (await fetch(
    `${Z.config.api_host}/users/platforms/announcement/${e}/status`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-api-token": Z.internal_config.api_key
      },
      body: JSON.stringify({
        status: t,
        user_id: (n = Z.config.user_data) == null ? void 0 : n.user_id,
        group_id: Z.config.group_id
      })
    }
  )).json();
}, yn = async (e, t) => await (await fetch(
  `${Z.config.api_host}/users/platforms/onboarding-flow/${e}/status`,
  {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": Z.internal_config.api_key
    },
    body: JSON.stringify({
      status: t,
      user_id: Z.config.user_data.user_id
    })
  }
)).json(), dw = async (e) => await fetch(
  `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/queries/${e}`,
  {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": Z.internal_config.api_key
    },
    body: JSON.stringify({
      user_data: Z.config.user_data,
      group_id: Z.config.group_id
    })
  }
), fw = async ({
  flow: e,
  query: t,
  had_full_run: a,
  from_cache: r,
  is_helpful: n
}) => await (await fetch(
  `${Z.config.api_host}/users/platforms/${Z.internal_config.platform_id}/query-history/feedback`,
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-token": Z.internal_config.api_key
    },
    body: JSON.stringify({
      flow_id: e,
      query_id: t,
      is_helpful: n,
      had_full_run: a,
      from_cache: r
    })
  }
)).json(), lf = async (e) => await (await fetch(
  `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/guidance-flows/${e}`,
  {
    headers: {
      "x-api-token": Z.internal_config.api_key
    }
  }
)).json(), pw = async (e) => await (await fetch(
  `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/guidance-flows?name=${e}&limit=3&include_context=false`,
  {
    headers: {
      "x-api-token": Z.internal_config.api_key
    }
  }
)).json(), hi = async () => {
  var e;
  try {
    return await (await fetch(
      `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/queries/top/${(e = Z.config.user_data) == null ? void 0 : e.user_id}?starting_url=${encodeURIComponent(window.location.href)}`,
      {
        headers: {
          "x-api-token": Z.internal_config.api_key
        }
      }
    )).json();
  } catch {
    return [];
  }
}, yw = async (e) => {
  var r, n;
  if (!((r = Z.internal_config) != null && r.api_key) || !((n = Z.config) != null && n.api_host))
    throw new Error("API key or host is not defined");
  const t = await fetch(
    `${Z.config.api_host}/automation/platforms/${Z.internal_config.platform_id}/knowledge/query?query=${e}`,
    {
      headers: {
        "x-api-token": Z.internal_config.api_key
      }
    }
  );
  if (!t.ok)
    throw new Error("Something went wrong");
  return await t.json();
}, Uy = async ({
  query: e,
  flow_id: t,
  is_knowledge_query: a,
  is_guide_query: r,
  type: n,
  completed_flow_steps: o
}) => {
  var l, u, f;
  if (!((l = Z.internal_config) != null && l.api_key) || !((u = Z.config) != null && u.api_host))
    throw new Error("API key or host is not defined");
  const s = await fetch(
    `${Z.config.api_host}/platform-user/query-history/create?platform_id=${Z.internal_config.platform_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-token": Z.internal_config.api_key
      },
      body: JSON.stringify({
        query: e,
        user_id: (f = Z.config.user_data) == null ? void 0 : f.user_id,
        group_id: Z.config.group_id,
        flow_id: t,
        is_knowledge_query: a,
        is_guide_query: r,
        type: n,
        status: "Engaged",
        completed_flow_steps: o
      })
    }
  );
  if (!s.ok)
    throw new Error("Something went wrong");
  return await s.json();
}, hw = "5";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(hw);
c_();
var gw = /* @__PURE__ */ St('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>'), mw = /* @__PURE__ */ St('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>'), _w = /* @__PURE__ */ St('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"></path></svg>'), ww = /* @__PURE__ */ St('<svg viewBox="0 0 64 64" fill="currentColor" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M32.427,7.987c2.183,0.124 4,1.165 5.096,3.281l17.936,36.208c1.739,3.66 -0.954,8.585 -5.373,8.656l-36.119,0c-4.022,-0.064 -7.322,-4.631 -5.352,-8.696l18.271,-36.207c0.342,-0.65 0.498,-0.838 0.793,-1.179c1.186,-1.375 2.483,-2.111 4.748,-2.063Zm-0.295,3.997c-0.687,0.034 -1.316,0.419 -1.659,1.017c-6.312,11.979 -12.397,24.081 -18.301,36.267c-0.546,1.225 0.391,2.797 1.762,2.863c12.06,0.195 24.125,0.195 36.185,0c1.325,-0.064 2.321,-1.584 1.769,-2.85c-5.793,-12.184 -11.765,-24.286 -17.966,-36.267c-0.366,-0.651 -0.903,-1.042 -1.79,-1.03Z"></path><path d="M33.631,40.581l-3.348,0l-0.368,-16.449l4.1,0l-0.384,16.449Zm-3.828,5.03c0,-0.609 0.197,-1.113 0.592,-1.514c0.396,-0.4 0.935,-0.601 1.618,-0.601c0.684,0 1.223,0.201 1.618,0.601c0.395,0.401 0.593,0.905 0.593,1.514c0,0.587 -0.193,1.078 -0.577,1.473c-0.385,0.395 -0.929,0.593 -1.634,0.593c-0.705,0 -1.249,-0.198 -1.634,-0.593c-0.384,-0.395 -0.576,-0.886 -0.576,-1.473Z"></path></svg>');
function gi(e, t) {
  let a = R(t, "type", 8, "success");
  var r = K(), n = D(r);
  {
    var o = (i) => {
      var l = gw();
      z(i, l);
    }, s = (i) => {
      var l = K(), u = D(l);
      {
        var f = (c) => {
          var h = mw();
          z(c, h);
        }, p = (c) => {
          var h = K(), g = D(h);
          {
            var _ = (m) => {
              var w = _w();
              z(m, w);
            }, b = (m) => {
              var w = K(), S = D(w);
              {
                var C = (y) => {
                  var k = ww();
                  z(y, k);
                }, v = (y) => {
                };
                B(
                  S,
                  (y) => {
                    a() === "warning" ? y(C) : y(v, !1);
                  },
                  !0
                );
              }
              z(m, w);
            };
            B(
              g,
              (m) => {
                a() === "info" ? m(_) : m(b, !1);
              },
              !0
            );
          }
          z(c, h);
        };
        B(
          u,
          (c) => {
            a() === "error" ? c(f) : c(p, !1);
          },
          !0
        );
      }
      z(i, l);
    };
    B(n, (i) => {
      a() === "success" ? i(o) : i(s, !1);
    });
  }
  z(e, r);
}
var vw = /* @__PURE__ */ L('<div class="sonner-loading-bar"></div>'), bw = /* @__PURE__ */ L('<div class="sonner-loading-wrapper"><div class="sonner-spinner"></div></div>');
function kw(e, t) {
  ke(t, !1);
  let a = R(t, "visible", 8);
  const r = Array(12).fill(0);
  ca();
  var n = bw(), o = A(n);
  et(o, 5, () => r, yt, (s, i) => {
    var l = vw();
    z(s, l);
  }), $(() => be(n, "data-visible", a())), z(e, n), xe();
}
const hn = [];
function xw(e, t) {
  return {
    subscribe: Gy(e, t).subscribe
  };
}
function Gy(e, t = qe) {
  let a = null;
  const r = /* @__PURE__ */ new Set();
  function n(i) {
    if (Xl(e, i) && (e = i, a)) {
      const l = !hn.length;
      for (const u of r)
        u[1](), hn.push(u, e);
      if (l) {
        for (let u = 0; u < hn.length; u += 2)
          hn[u][0](hn[u + 1]);
        hn.length = 0;
      }
    }
  }
  function o(i) {
    n(i(
      /** @type {T} */
      e
    ));
  }
  function s(i, l = qe) {
    const u = [i, l];
    return r.add(u), r.size === 1 && (a = t(n, o) || qe), i(
      /** @type {T} */
      e
    ), () => {
      r.delete(u), r.size === 0 && a && (a(), a = null);
    };
  }
  return { set: n, update: o, subscribe: s };
}
function cf(e) {
  let t;
  return Hy(e, (a) => t = a)(), t;
}
function vo(e) {
  q(e, e.v + 1);
}
function gn(...e) {
  return e.filter(Boolean).join(" ");
}
const uf = typeof document < "u";
function df(e) {
  const t = Gy(e);
  function a(n) {
    uf && t.set(n);
  }
  function r(n) {
    uf && t.update(n);
  }
  return {
    subscribe: t.subscribe,
    set: a,
    update: r
  };
}
let ff = 0;
function zw() {
  const e = df([]), t = df([]);
  function a(m) {
    e.update((w) => [m, ...w]);
  }
  function r(m) {
    var T;
    const { message: w, ...S } = m, C = typeof (m == null ? void 0 : m.id) == "number" || m.id && ((T = m.id) == null ? void 0 : T.length) > 0 ? m.id : ff++, v = m.dismissable === void 0 ? !0 : m.dismissable, y = m.type === void 0 ? "default" : m.type;
    return cf(e).find((F) => F.id === C) ? e.update((F) => F.map((P) => P.id === C ? {
      ...P,
      ...m,
      id: C,
      title: w,
      dismissable: v,
      type: y,
      updated: !0
    } : {
      ...P,
      updated: !1
    })) : a({ ...S, id: C, title: w, dismissable: v, type: y }), C;
  }
  function n(m) {
    if (m === void 0) {
      e.update((w) => w.map((S) => ({ ...S, dismiss: !0 })));
      return;
    }
    return e.update((w) => w.map((S) => S.id === m ? { ...S, dismiss: !0 } : S)), m;
  }
  function o(m) {
    if (m === void 0) {
      e.set([]);
      return;
    }
    return e.update((w) => w.filter((S) => S.id !== m)), m;
  }
  function s(m, w) {
    return r({ ...w, type: "default", message: m });
  }
  function i(m, w) {
    return r({ ...w, type: "error", message: m });
  }
  function l(m, w) {
    return r({ ...w, type: "success", message: m });
  }
  function u(m, w) {
    return r({ ...w, type: "info", message: m });
  }
  function f(m, w) {
    return r({ ...w, type: "warning", message: m });
  }
  function p(m, w) {
    return r({ ...w, type: "loading", message: m });
  }
  function c(m, w) {
    if (!w)
      return;
    let S;
    w.loading !== void 0 && (S = r({
      ...w,
      promise: m,
      type: "loading",
      message: w.loading
    }));
    const C = m instanceof Promise ? m : m();
    let v = S !== void 0;
    return C.then((y) => {
      if (y && typeof y.ok == "boolean" && !y.ok) {
        v = !1;
        const k = typeof w.error == "function" ? (
          // @ts-expect-error: Incorrect response type
          w.error(`HTTP error! status: ${y.status}`)
        ) : w.error;
        r({ id: S, type: "error", message: k });
      } else if (w.success !== void 0) {
        v = !1;
        const k = (
          // @ts-expect-error: TODO: Better function checking
          typeof w.success == "function" ? w.success(y) : w.success
        );
        r({ id: S, type: "success", message: k });
      }
    }).catch((y) => {
      if (w.error !== void 0) {
        v = !1;
        const k = (
          // @ts-expect-error: TODO: Better function checking
          typeof w.error == "function" ? w.error(y) : w.error
        );
        r({ id: S, type: "error", message: k });
      }
    }).finally(() => {
      var y;
      v && (n(S), S = void 0), (y = w.finally) == null || y.call(w);
    }), S;
  }
  function h(m, w) {
    const S = (w == null ? void 0 : w.id) || ff++;
    return r({ component: m, id: S, ...w }), S;
  }
  function g(m) {
    t.update((w) => w.filter((S) => S.toastId !== m));
  }
  function _(m) {
    if (cf(t).find((S) => S.toastId === m.toastId) === void 0) {
      t.update((S) => [m, ...S]);
      return;
    }
    t.update((S) => S.map((C) => C.toastId === m.toastId ? m : C));
  }
  function b() {
    e.set([]), t.set([]);
  }
  return {
    // methods
    create: r,
    addToast: a,
    dismiss: n,
    remove: o,
    message: s,
    error: i,
    success: l,
    info: u,
    warning: f,
    loading: p,
    promise: c,
    custom: h,
    removeHeight: g,
    setHeight: _,
    reset: b,
    // stores
    toasts: e,
    heights: t
  };
}
const sa = zw();
function Sw(e, t) {
  return sa.create({
    message: e,
    ...t
  });
}
const Cw = Sw, Rr = Object.assign(Cw, {
  success: sa.success,
  info: sa.info,
  warning: sa.warning,
  error: sa.error,
  custom: sa.custom,
  message: sa.message,
  promise: sa.promise,
  dismiss: sa.dismiss,
  loading: sa.loading
}), Ew = (e) => ({ subscribe: e });
var Aw = /* @__PURE__ */ L('<button aria-label="Close toast" data-close-button=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>'), Tw = /* @__PURE__ */ L('<div data-icon=""><!> <!></div>'), Pw = /* @__PURE__ */ L('<div data-title=""><!></div>'), Ow = /* @__PURE__ */ L('<div data-description=""><!></div>'), Mw = /* @__PURE__ */ L('<button data-button="" data-cancel=""> </button>'), Iw = /* @__PURE__ */ L('<button data-button=""> </button>'), Fw = /* @__PURE__ */ L('<!> <div data-content=""><!> <!></div> <!> <!>', 1), jw = /* @__PURE__ */ L('<li aria-atomic="true" role="status" data-sonner-toast=""><!> <!></li>');
function Rw(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  ke(t, !1);
  const r = ba(), n = () => Yt(F, "$heights", r), o = () => Yt(d(Fe), "$effect", r), s = () => Yt(T, "$toasts", r), i = Ke(void 0, !0), l = Ke(void 0, !0), u = Ke(void 0, !0), f = Ke(void 0, !0), p = Ke(void 0, !0), c = Ke(void 0, !0), h = Ke(void 0, !0), g = Ke(void 0, !0), _ = Ke(void 0, !0), b = Ke(void 0, !0), m = Ke(void 0, !0), w = Ke(void 0, !0), S = 4e3, C = 14, v = 20, y = 200, k = 0.05, x = {
    toast: "",
    title: "",
    description: "",
    loader: "",
    closeButton: "",
    cancelButton: "",
    actionButton: "",
    action: "",
    warning: "",
    error: "",
    success: "",
    default: "",
    info: "",
    loading: ""
  }, {
    toasts: T,
    heights: F,
    removeHeight: P,
    setHeight: O,
    remove: I
  } = sa;
  let E = R(t, "toast", 9), N = R(t, "index", 9), H = R(t, "expanded", 9), Y = R(t, "invert", 13), V = R(t, "position", 9), U = R(t, "visibleToasts", 9), ee = R(t, "expandByDefault", 9), W = R(t, "closeButton", 9), G = R(t, "interacting", 9), J = R(t, "cancelButtonStyle", 9, ""), te = R(t, "actionButtonStyle", 9, ""), ae = R(t, "duration", 9, 4e3), ie = R(t, "descriptionClass", 9, ""), oe = R(t, "classes", 29, () => ({})), Q = R(t, "unstyled", 9, !1), le = Ke(!1, !0), he = Ke(!1, !0), pe = Ke(!1, !0), se = Ke(!1, !0), ye = Ke(0, !0), ge = Ke(0, !0), ue = Ke(void 0, !0), _e = Ke(0, !0), Se = 0, Re = 0, ve = null;
  async function ze() {
    if (!d(le))
      return;
    await Nu();
    let Te;
    H() || ee() ? Te = 1 : Te = 1 - N() * k, d(ue).style.setProperty("height", "auto");
    const Ye = d(ue).offsetHeight, vt = d(ue).getBoundingClientRect().height, Mt = Math.round((vt / Te + Number.EPSILON) * 100) / 100;
    d(ue).style.removeProperty("height");
    let ht;
    Math.abs(Mt - Ye) < 1 ? ht = Mt : ht = Ye, q(ge, ht), O({ toastId: E().id, height: ht });
  }
  function fe() {
    q(he, !0), q(ye, d(_e)), P(E().id), setTimeout(
      () => {
        I(E().id);
      },
      y
    );
  }
  let Ce = Ke(void 0, !0), Ne = Ke(E().duration || ae() || S, !0);
  function je() {
    if (Re < Se) {
      const Te = (/* @__PURE__ */ new Date()).getTime() - Se;
      q(Ne, d(Ne) - Te);
    }
    Re = (/* @__PURE__ */ new Date()).getTime();
  }
  function Be() {
    Se = (/* @__PURE__ */ new Date()).getTime(), q(Ce, setTimeout(
      () => {
        var Te, Ye;
        (Ye = (Te = E()).onAutoClose) == null || Ye.call(Te, E()), fe();
      },
      d(Ne)
    ));
  }
  let Fe = Ke(void 0, !0);
  Da(() => {
    q(le, !0);
    const Te = d(ue).getBoundingClientRect().height;
    return q(ge, Te), O({ toastId: E().id, height: Te }), () => P(E().id);
  });
  function Ae(Te) {
    if (d(m))
      return;
    q(ye, d(_e));
    const Ye = Te.target;
    Ye.setPointerCapture(Te.pointerId), Ye.tagName !== "BUTTON" && (q(pe, !0), ve = { x: Te.clientX, y: Te.clientY });
  }
  function mt() {
    var Ye, vt, Mt;
    if (d(se))
      return;
    ve = null;
    const Te = Number(((Ye = d(ue)) == null ? void 0 : Ye.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0);
    if (Math.abs(Te) >= v) {
      q(ye, d(_e)), (Mt = (vt = E()).onDismiss) == null || Mt.call(vt, E()), fe(), q(se, !0);
      return;
    }
    d(ue).style.setProperty("--swipe-amount", "0px"), q(pe, !1);
  }
  function ut(Te) {
    if (!ve)
      return;
    const Ye = Te.clientY - ve.y, vt = Te.clientX - ve.x, ht = (d(_)[0] === "top" ? Math.min : Math.max)(0, Ye), Pt = Te.pointerType === "touch" ? 10 : 2;
    Math.abs(ht) > Pt ? d(ue).style.setProperty("--swipe-amount", `${Ye}px`) : Math.abs(vt) > Pt && (ve = null);
  }
  Qe(() => $e(oe()), () => {
    oe({ ...x, ...oe() });
  }), Qe(() => $e(N()), () => {
    q(i, N() === 0);
  }), Qe(
    () => ($e(N()), $e(U())),
    () => {
      q(l, N() + 1 <= U());
    }
  ), Qe(() => $e(E()), () => {
    q(u, E().title);
  }), Qe(() => $e(E()), () => {
    q(f, E().description);
  }), Qe(() => $e(E()), () => {
    q(p, E().type);
  }), Qe(() => $e(E()), () => {
    q(c, E().class || "");
  }), Qe(() => $e(E()), () => {
    q(h, E().descriptionClass || "");
  }), Qe(
    () => (n(), $e(E())),
    () => {
      q(g, n().findIndex((Te) => Te.toastId === E().id) || 0);
    }
  ), Qe(() => $e(V()), () => {
    q(_, V().split("-"));
  }), Qe(() => (n(), d(g)), () => {
    q(b, n().reduce(
      (Te, Ye, vt) => vt >= d(g) ? Te : Te + Ye.height,
      0
    ));
  }), Qe(
    () => ($e(Y()), $e(E())),
    () => {
      Y(E().invert || Y());
    }
  ), Qe(() => d(p), () => {
    q(m, d(p) === "loading");
  }), Qe(
    () => (d(g), d(b)),
    () => {
      q(_e, Math.round(d(g) * C + d(b)));
    }
  ), Qe(
    () => (d(u), d(f)),
    () => {
      d(u), d(f), ze();
    }
  ), Qe(
    () => ($e(E()), d(Ce), $e(ae())),
    () => {
      E().updated && (clearTimeout(d(Ce)), q(Ne, E().duration || ae() || S), Be());
    }
  ), Qe(
    () => ($e(E()), d(p)),
    () => {
      q(w, E().promise && d(p) === "loading" || E().duration === Number.POSITIVE_INFINITY);
    }
  ), Qe(
    () => (d(w), $e(H()), $e(G()), d(Ce)),
    () => {
      aw(
        q(Fe, Ew(() => (d(w) || (H() || G() ? je() : Be()), () => clearTimeout(d(Ce))))),
        "$effect",
        r
      );
    }
  ), Qe(() => o(), () => {
    o();
  }), Qe(() => $e(E()), () => {
    E().delete && fe();
  }), $l(), ca(!0);
  var De = jw();
  be(De, "tabindex", 0);
  const dt = /* @__PURE__ */ kt(() => {
    var Te, Ye, vt, Mt, ht, Pt;
    return gn(a.class, d(c), (Te = oe()) == null ? void 0 : Te.toast, (vt = (Ye = E()) == null ? void 0 : Ye.classes) == null ? void 0 : vt.toast, (Mt = oe()) == null ? void 0 : Mt[d(p)], (Pt = (ht = E()) == null ? void 0 : ht.classes) == null ? void 0 : Pt[d(p)]);
  });
  $(() => be(De, "data-promise", !!E().promise)), $(() => be(De, "data-expanded", !!(H() || ee() && d(le))));
  var ra = A(De);
  {
    var ua = (Te) => {
      var Ye = Aw(), vt = /* @__PURE__ */ M(() => d(m) ? void 0 : () => {
        var ht, Pt;
        fe(), (Pt = (ht = E()).onDismiss) == null || Pt.call(ht, E());
      });
      const Mt = /* @__PURE__ */ kt(() => {
        var ht, Pt, Fr;
        return gn((ht = oe()) == null ? void 0 : ht.closeButton, (Fr = (Pt = E()) == null ? void 0 : Pt.classes) == null ? void 0 : Fr.closeButton);
      });
      $(() => {
        be(Ye, "data-disabled", d(m)), Ue(Ye, d(Mt));
      }), pt("click", Ye, function(...ht) {
        var Pt;
        (Pt = d(vt)) == null || Pt.apply(this, ht);
      }), z(Te, Ye);
    };
    B(ra, (Te) => {
      W() && !E().component && Te(ua);
    });
  }
  var da = X(ra, 2);
  {
    var Ir = (Te) => {
      var Ye = K(), vt = D(Ye);
      Xe(vt, () => E().component, (Mt, ht) => {
        ht(Mt, it(() => E().componentProps, { $$events: { closeToast: fe } }));
      }), z(Te, Ye);
    }, fa = (Te) => {
      var Ye = Fw(), vt = D(Ye);
      {
        var Mt = (It) => {
          var Ct = Tw(), xa = A(Ct);
          {
            var Ba = (ct) => {
              var Nt = K(), Wa = D(Nt);
              Ze(Wa, t, "loading-icon", {}, null), z(ct, Nt);
            };
            B(xa, (ct) => {
              (E().promise || d(p) === "loading") && !E().icon && ct(Ba);
            });
          }
          var Ft = X(xa, 2);
          {
            var Ut = (ct) => {
              var Nt = K(), Wa = D(Nt);
              Xe(Wa, () => E().icon, (jr, _c) => {
                _c(jr, {});
              }), z(ct, Nt);
            }, ft = (ct) => {
              var Nt = K(), Wa = D(Nt);
              {
                var jr = (un) => {
                  var mo = K(), wc = D(mo);
                  Ze(wc, t, "success-icon", {}, null), z(un, mo);
                }, _c = (un) => {
                  var mo = K(), wc = D(mo);
                  {
                    var Rm = (dn) => {
                      var _o = K(), vc = D(_o);
                      Ze(vc, t, "error-icon", {}, null), z(dn, _o);
                    }, Lm = (dn) => {
                      var _o = K(), vc = D(_o);
                      {
                        var Dm = (fn) => {
                          var wo = K(), bc = D(wo);
                          Ze(bc, t, "warning-icon", {}, null), z(fn, wo);
                        }, Nm = (fn) => {
                          var wo = K(), bc = D(wo);
                          {
                            var Vm = (kc) => {
                              var Wd = K(), qm = D(Wd);
                              Ze(qm, t, "info-icon", {}, null), z(kc, Wd);
                            };
                            B(
                              bc,
                              (kc) => {
                                d(p) === "info" && kc(Vm);
                              },
                              !0
                            );
                          }
                          z(fn, wo);
                        };
                        B(
                          vc,
                          (fn) => {
                            d(p) === "warning" ? fn(Dm) : fn(Nm, !1);
                          },
                          !0
                        );
                      }
                      z(dn, _o);
                    };
                    B(
                      wc,
                      (dn) => {
                        d(p) === "error" ? dn(Rm) : dn(Lm, !1);
                      },
                      !0
                    );
                  }
                  z(un, mo);
                };
                B(
                  Wa,
                  (un) => {
                    d(p) === "success" ? un(jr) : un(_c, !1);
                  },
                  !0
                );
              }
              z(ct, Nt);
            };
            B(Ft, (ct) => {
              E().icon ? ct(Ut) : ct(ft, !1);
            });
          }
          z(It, Ct);
        };
        B(vt, (It) => {
          (d(p) !== "default" || E().icon || E().promise) && It(Mt);
        });
      }
      var ht = X(vt, 2), Pt = A(ht);
      {
        var Fr = (It) => {
          var Ct = Pw();
          const xa = /* @__PURE__ */ kt(() => {
            var ft, ct, Nt;
            return gn((ft = oe()) == null ? void 0 : ft.title, (Nt = (ct = E()) == null ? void 0 : ct.classes) == null ? void 0 : Nt.title);
          });
          var Ba = A(Ct);
          {
            var Ft = (ft) => {
              var ct = K(), Nt = D(ct);
              Xe(Nt, () => E().title, (Wa, jr) => {
                jr(Wa, it(() => E().componentProps));
              }), z(ft, ct);
            }, Ut = (ft) => {
              var ct = Xn();
              $(() => Me(ct, E().title)), z(ft, ct);
            };
            B(Ba, (ft) => {
              typeof E().title != "string" ? ft(Ft) : ft(Ut, !1);
            });
          }
          $(() => Ue(Ct, d(xa))), z(It, Ct);
        };
        B(Pt, (It) => {
          E().title && It(Fr);
        });
      }
      var gc = X(Pt, 2);
      {
        var mc = (It) => {
          var Ct = Ow();
          const xa = /* @__PURE__ */ kt(() => {
            var ft, ct;
            return gn(ie(), d(h), (ft = oe()) == null ? void 0 : ft.description, (ct = E().classes) == null ? void 0 : ct.description);
          });
          var Ba = A(Ct);
          {
            var Ft = (ft) => {
              var ct = K(), Nt = D(ct);
              Xe(Nt, () => E().description, (Wa, jr) => {
                jr(Wa, it(() => E().componentProps));
              }), z(ft, ct);
            }, Ut = (ft) => {
              var ct = Xn();
              $(() => Me(ct, E().description)), z(ft, ct);
            };
            B(Ba, (ft) => {
              typeof E().description != "string" ? ft(Ft) : ft(Ut, !1);
            });
          }
          $(() => Ue(Ct, d(xa))), z(It, Ct);
        };
        B(gc, (It) => {
          E().description && It(mc);
        });
      }
      var sr = X(ht, 2);
      {
        var Im = (It) => {
          var Ct = Mw();
          const xa = /* @__PURE__ */ kt(() => {
            var Ft, Ut, ft;
            return gn((Ft = oe()) == null ? void 0 : Ft.cancelButton, (ft = (Ut = E()) == null ? void 0 : Ut.classes) == null ? void 0 : ft.cancelButton);
          });
          var Ba = A(Ct);
          $(() => {
            be(Ct, "style", J()), Ue(Ct, d(xa)), Me(Ba, E().cancel.label);
          }), pt("click", Ct, () => {
            var Ft;
            fe(), (Ft = E().cancel) != null && Ft.onClick && E().cancel.onClick();
          }), z(It, Ct);
        };
        B(sr, (It) => {
          E().cancel && It(Im);
        });
      }
      var Fm = X(sr, 2);
      {
        var jm = (It) => {
          var Ct = Iw();
          const xa = /* @__PURE__ */ kt(() => {
            var Ft, Ut, ft;
            return gn((Ft = oe()) == null ? void 0 : Ft.actionButton, (ft = (Ut = E()) == null ? void 0 : Ut.classes) == null ? void 0 : ft.actionButton);
          });
          var Ba = A(Ct);
          $(() => {
            be(Ct, "style", te()), Ue(Ct, d(xa)), Me(Ba, E().action.label);
          }), pt("click", Ct, (Ft) => {
            var Ut;
            (Ut = E().action) == null || Ut.onClick(Ft), !Ft.defaultPrevented && fe();
          }), z(It, Ct);
        };
        B(Fm, (It) => {
          E().action && It(jm);
        });
      }
      z(Te, Ye);
    };
    B(da, (Te) => {
      E().component ? Te(Ir) : Te(fa, !1);
    });
  }
  aa(De, (Te) => q(ue, Te), () => d(ue)), $(() => {
    var Te;
    be(De, "aria-live", E().important ? "assertive" : "polite"), Ue(De, d(dt)), be(De, "data-styled", !(E().component || (Te = E()) != null && Te.unstyled || Q())), be(De, "data-mounted", d(le)), be(De, "data-removed", d(he)), be(De, "data-visible", d(l)), be(De, "data-y-position", d(_)[0]), be(De, "data-x-position", d(_)[1]), be(De, "data-index", N()), be(De, "data-front", d(i)), be(De, "data-swiping", d(pe)), be(De, "data-type", d(p)), be(De, "data-invert", Y()), be(De, "data-swipe-out", d(se)), be(De, "style", `${a.style} ${E().style}`), Ja(De, "--index", N()), Ja(De, "--toasts-before", N()), Ja(De, "--z-index", s().length - N()), Ja(De, "--offset", `${d(he) ? d(ye) : d(_e)}px`), Ja(De, "--initial-height", `${d(ge)}px`);
  }), pt("pointerdown", De, Ae), pt("pointerup", De, mt), pt("pointermove", De, ut), z(e, De), xe();
}
var Lw = /* @__PURE__ */ L("<ol></ol>"), Dw = /* @__PURE__ */ L('<section class="svelte-1fo5d1m"></section>');
function Nw(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, [
    "invert",
    "theme",
    "position",
    "hotkey",
    "containerAriaLabel",
    "richColors",
    "expand",
    "duration",
    "visibleToasts",
    "closeButton",
    "toastOptions",
    "offset",
    "dir"
  ]);
  ke(t, !1);
  const n = ba(), o = () => Yt(E, "$toasts", n), s = () => Yt(N, "$heights", n), i = Ke(), l = Ke(), u = 3, f = "32px", p = 356, c = 14, h = "dark", g = "light";
  function _(Q) {
    return Q !== "system" ? Q : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? h : g;
  }
  function b() {
    if (typeof window > "u" || typeof document > "u") return "ltr";
    const Q = document.documentElement.getAttribute("dir");
    return Q === "auto" || !Q ? window.getComputedStyle(document.documentElement).direction : Q;
  }
  let m = R(t, "invert", 8, !1), w = R(t, "theme", 8, "light"), S = R(t, "position", 8, "bottom-right"), C = R(t, "hotkey", 24, () => ["altKey", "KeyT"]), v = R(t, "containerAriaLabel", 8, "Notifications"), y = R(t, "richColors", 8, !1), k = R(t, "expand", 8, !1), x = R(t, "duration", 8, 4e3), T = R(t, "visibleToasts", 8, u), F = R(t, "closeButton", 8, !1), P = R(t, "toastOptions", 24, () => ({})), O = R(t, "offset", 8, null), I = R(t, "dir", 24, b);
  const { toasts: E, heights: N, reset: H } = sa;
  let Y = Ke(!1), V = Ke(!1), U = Ke(_(w())), ee = Ke(), W = null, G = !1;
  Wu(() => {
    d(ee) && W && (W.focus({ preventScroll: !0 }), W = null, G = !1);
  }), Da(() => {
    H();
    const Q = (le) => {
      var pe, se;
      C().every((ye) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        le[ye] || le.code === ye
      )) && (q(Y, !0), (pe = d(ee)) == null || pe.focus()), le.code === "Escape" && (document.activeElement === d(ee) || (se = d(ee)) != null && se.contains(document.activeElement)) && q(Y, !1);
    };
    return document.addEventListener("keydown", Q), () => {
      document.removeEventListener("keydown", Q);
    };
  });
  function J(Q) {
    G && !Q.currentTarget.contains(Q.relatedTarget) && (G = !1, W && (W.focus({ preventScroll: !0 }), W = null));
  }
  function te(Q) {
    G || (G = !0, W = Q.relatedTarget);
  }
  Qe(
    () => ($e(S()), o()),
    () => {
      q(i, Array.from(new Set([
        S(),
        ...o().filter((Q) => Q.position).map((Q) => Q.position)
      ].filter(Boolean))));
    }
  ), Qe(() => $e(C()), () => {
    q(l, C().join("+").replace(/Key/g, "").replace(/Digit/g, ""));
  }), Qe(() => o(), () => {
    o().length <= 1 && q(Y, !1);
  }), Qe(() => o(), () => {
    const Q = o().filter((le) => le.dismiss && !le.delete);
    if (Q.length > 0) {
      const le = o().map((he) => Q.find((se) => se.id === he.id) ? { ...he, delete: !0 } : he);
      E.set(le);
    }
  }), Qe(() => $e(w()), () => {
    if (w() !== "system" && q(U, w()), typeof window < "u") {
      w() === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? q(U, h) : q(U, g));
      const Q = window.matchMedia("(prefers-color-scheme: dark)"), le = ({ matches: he }) => {
        q(U, he ? h : g);
      };
      "addEventListener" in Q ? Q.addEventListener("change", le) : Q.addListener(le);
    }
  }), $l(), ca();
  var ae = K(), ie = D(ae);
  {
    var oe = (Q) => {
      var le = Dw();
      be(le, "tabindex", -1), et(le, 5, () => d(i), yt, (pe, se, ye) => {
        var ge = Lw();
        let ue;
        et(ge, 7, () => o().filter((Se) => !Se.position && ye === 0 || Se.position === d(se)), (Se) => Se.id, (Se, Re, ve) => {
          var ze = /* @__PURE__ */ kt(() => {
            var Ae;
            return ((Ae = P()) == null ? void 0 : Ae.actionButtonStyle) || "";
          }), fe = /* @__PURE__ */ kt(() => {
            var Ae;
            return ((Ae = P()) == null ? void 0 : Ae.cancelButtonStyle) || "";
          }), Ce = /* @__PURE__ */ kt(() => {
            var Ae;
            return ((Ae = P()) == null ? void 0 : Ae.class) || "";
          }), Ne = /* @__PURE__ */ kt(() => {
            var Ae;
            return ((Ae = P()) == null ? void 0 : Ae.descriptionClass) || "";
          }), je = /* @__PURE__ */ kt(() => P().classes || {}), Be = /* @__PURE__ */ kt(() => {
            var Ae;
            return ((Ae = P()) == null ? void 0 : Ae.duration) ?? x();
          }), Fe = /* @__PURE__ */ kt(() => P().unstyled || !1);
          Rw(Se, {
            get index() {
              return d(ve);
            },
            get toast() {
              return d(Re);
            },
            get invert() {
              return m();
            },
            get visibleToasts() {
              return T();
            },
            get closeButton() {
              return F();
            },
            get interacting() {
              return d(V);
            },
            get position() {
              return d(se);
            },
            get expandByDefault() {
              return k();
            },
            get expanded() {
              return d(Y);
            },
            get actionButtonStyle() {
              return d(ze);
            },
            get cancelButtonStyle() {
              return d(fe);
            },
            get class() {
              return d(Ce);
            },
            get descriptionClass() {
              return d(Ne);
            },
            get classes() {
              return d(je);
            },
            get duration() {
              return d(Be);
            },
            get unstyled() {
              return d(Fe);
            },
            $$slots: {
              "loading-icon": (Ae, mt) => {
                var ut = K(), De = D(ut);
                Ze(De, t, "loading-icon", {}, (dt) => {
                  var ra = /* @__PURE__ */ kt(() => d(Re).type === "loading");
                  kw(dt, {
                    get visible() {
                      return d(ra);
                    }
                  });
                }), z(Ae, ut);
              },
              "success-icon": (Ae, mt) => {
                var ut = K(), De = D(ut);
                Ze(De, t, "success-icon", {}, (dt) => {
                  gi(dt, { type: "success" });
                }), z(Ae, ut);
              },
              "error-icon": (Ae, mt) => {
                var ut = K(), De = D(ut);
                Ze(De, t, "error-icon", {}, (dt) => {
                  gi(dt, { type: "error" });
                }), z(Ae, ut);
              },
              "warning-icon": (Ae, mt) => {
                var ut = K(), De = D(ut);
                Ze(De, t, "warning-icon", {}, (dt) => {
                  gi(dt, { type: "warning" });
                }), z(Ae, ut);
              },
              "info-icon": (Ae, mt) => {
                var ut = K(), De = D(ut);
                Ze(De, t, "info-icon", {}, (dt) => {
                  gi(dt, { type: "info" });
                }), z(Ae, ut);
              }
            }
          });
        }), aa(ge, (Se) => q(ee, Se), () => d(ee)), $(() => {
          var Se;
          ue = at(
            ge,
            ue,
            {
              tabIndex: -1,
              class: a.class,
              "data-sonner-toaster": !0,
              "data-theme": d(U),
              "data-rich-colors": y(),
              dir: I() === "auto" ? b() : I(),
              "data-y-position": d(se).split("-")[0],
              "data-x-position": d(se).split("-")[1],
              style: a.style,
              ...r
            },
            "svelte-1fo5d1m"
          ), Ja(ge, "--front-toast-height", `${(Se = s()[0]) == null ? void 0 : Se.height}px`), Ja(ge, "--offset", typeof O() == "number" ? `${O()}px` : O() || f), Ja(ge, "--width", `${p}px`), Ja(ge, "--gap", `${c}px`), ge.dir = ge.dir;
        }), pt("blur", ge, J), pt("focus", ge, te), pt("mouseenter", ge, () => q(Y, !0)), pt("mousemove", ge, () => q(Y, !0)), pt("mouseleave", ge, () => {
          d(V) || q(Y, !1);
        }), pt("pointerdown", ge, () => q(V, !0)), pt("pointerup", ge, () => q(V, !1)), z(pe, ge);
      }), $(() => be(le, "aria-label", `${v()} ${d(l)}`)), z(Q, le);
    };
    B(ie, (Q) => {
      o().length > 0 && Q(oe);
    });
  }
  z(e, ae), xe();
}
function Vw(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, []);
  Nw(e, it(
    {
      class: "toaster group",
      toastOptions: {
        classes: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      }
    },
    () => r
  ));
}
async function qw(e, t) {
  const a = e.getReader();
  let r;
  for (; !(r = await a.read()).done; )
    t(r.value);
}
function Bw(e) {
  let t, a, r, n = !1;
  return function(s) {
    t === void 0 ? (t = s, a = 0, r = -1) : t = Hw(t, s);
    const i = t.length;
    let l = 0;
    for (; a < i; ) {
      n && (t[a] === 10 && (l = ++a), n = !1);
      let u = -1;
      for (; a < i && u === -1; ++a)
        switch (t[a]) {
          case 58:
            r === -1 && (r = a - l);
            break;
          case 13:
            n = !0;
          case 10:
            u = a;
            break;
        }
      if (u === -1)
        break;
      e(t.subarray(l, u), r), l = a, r = -1;
    }
    l === i ? t = void 0 : l !== 0 && (t = t.subarray(l), a -= l);
  };
}
function Ww(e, t, a) {
  let r = pf();
  const n = new TextDecoder();
  return function(s, i) {
    if (s.length === 0)
      a == null || a(r), r = pf();
    else if (i > 0) {
      const l = n.decode(s.subarray(0, i)), u = i + (s[i + 1] === 32 ? 2 : 1), f = n.decode(s.subarray(u));
      switch (l) {
        case "data":
          r.data = r.data ? r.data + `
` + f : f;
          break;
        case "event":
          r.event = f;
          break;
        case "id":
          e(r.id = f);
          break;
        case "retry":
          const p = parseInt(f, 10);
          isNaN(p) || t(r.retry = p);
          break;
      }
    }
  };
}
function Hw(e, t) {
  const a = new Uint8Array(e.length + t.length);
  return a.set(e), a.set(t, e.length), a;
}
function pf() {
  return {
    data: "",
    event: "",
    id: "",
    retry: void 0
  };
}
var Uw = function(e, t) {
  var a = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (a[r[n]] = e[r[n]]);
  return a;
};
const $c = "text/event-stream", Gw = 1e3, yf = "last-event-id";
function Kw(e, t) {
  var { signal: a, headers: r, onopen: n, onmessage: o, onclose: s, onerror: i, openWhenHidden: l, fetch: u } = t, f = Uw(t, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
  return new Promise((p, c) => {
    const h = Object.assign({}, r);
    h.accept || (h.accept = $c);
    let g;
    function _() {
      g.abort(), document.hidden || v();
    }
    l || document.addEventListener("visibilitychange", _);
    let b = Gw, m = 0;
    function w() {
      document.removeEventListener("visibilitychange", _), window.clearTimeout(m), g.abort();
    }
    a == null || a.addEventListener("abort", () => {
      w(), p();
    });
    const S = u ?? window.fetch, C = n ?? Zw;
    async function v() {
      var y;
      g = new AbortController();
      try {
        const k = await S(e, Object.assign(Object.assign({}, f), { headers: h, signal: g.signal }));
        await C(k), await qw(k.body, Bw(Ww((x) => {
          x ? h[yf] = x : delete h[yf];
        }, (x) => {
          b = x;
        }, o))), s == null || s(), w(), p();
      } catch (k) {
        if (!g.signal.aborted)
          try {
            const x = (y = i == null ? void 0 : i(k)) !== null && y !== void 0 ? y : b;
            window.clearTimeout(m), m = window.setTimeout(v, x);
          } catch (x) {
            w(), c(x);
          }
      }
    }
    v();
  });
}
function Zw(e) {
  const t = e.headers.get("content-type");
  if (!(t != null && t.startsWith($c)))
    throw new Error(`Expected content-type to be ${$c}, Actual: ${t}`);
}
function Yw() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function Xw() {
  const e = Yw();
  if (e.__xstate__)
    return e.__xstate__;
}
const Jw = (e) => {
  if (typeof window > "u")
    return;
  const t = Xw();
  t && t.register(e);
};
class hf {
  constructor(t) {
    this._process = t, this._active = !1, this._current = null, this._last = null;
  }
  start() {
    this._active = !0, this.flush();
  }
  clear() {
    this._current && (this._current.next = null, this._last = this._current);
  }
  enqueue(t) {
    const a = {
      value: t,
      next: null
    };
    if (this._current) {
      this._last.next = a, this._last = a;
      return;
    }
    this._current = a, this._last = a, this._active && this.flush();
  }
  flush() {
    for (; this._current; ) {
      const t = this._current;
      this._process(t.value), this._current = t.next;
    }
    this._last = null;
  }
}
const Ky = ".", Qw = "", Zy = "", $w = "#", ev = "*", Yy = "xstate.init", tv = "xstate.error", Do = "xstate.stop";
function av(e, t) {
  return {
    type: `xstate.after.${e}.${t}`
  };
}
function eu(e, t) {
  return {
    type: `xstate.done.state.${e}`,
    output: t
  };
}
function rv(e, t) {
  return {
    type: `xstate.done.actor.${e}`,
    output: t,
    actorId: e
  };
}
function Xy(e, t) {
  return {
    type: `xstate.error.actor.${e}`,
    error: t,
    actorId: e
  };
}
function Jy(e) {
  return {
    type: Yy,
    input: e
  };
}
function Ha(e) {
  setTimeout(() => {
    throw e;
  });
}
const nv = typeof Symbol == "function" && Symbol.observable || "@@observable";
function Qy(e, t) {
  const a = gf(e), r = gf(t);
  return typeof r == "string" ? typeof a == "string" ? r === a : !1 : typeof a == "string" ? a in r : Object.keys(a).every((n) => n in r ? Qy(a[n], r[n]) : !1);
}
function Hu(e) {
  if (eh(e))
    return e;
  const t = [];
  let a = "";
  for (let r = 0; r < e.length; r++) {
    switch (e.charCodeAt(r)) {
      case 92:
        a += e[r + 1], r++;
        continue;
      case 46:
        t.push(a), a = "";
        continue;
    }
    a += e[r];
  }
  return t.push(a), t;
}
function gf(e) {
  if (qv(e))
    return e.value;
  if (typeof e != "string")
    return e;
  const t = Hu(e);
  return ov(t);
}
function ov(e) {
  if (e.length === 1)
    return e[0];
  const t = {};
  let a = t;
  for (let r = 0; r < e.length - 1; r++)
    if (r === e.length - 2)
      a[e[r]] = e[r + 1];
    else {
      const n = a;
      a = {}, n[e[r]] = a;
    }
  return t;
}
function mf(e, t) {
  const a = {}, r = Object.keys(e);
  for (let n = 0; n < r.length; n++) {
    const o = r[n];
    a[o] = t(e[o], o, e, n);
  }
  return a;
}
function $y(e) {
  return eh(e) ? e : [e];
}
function _r(e) {
  return e === void 0 ? [] : $y(e);
}
function tu(e, t, a, r) {
  return typeof e == "function" ? e({
    context: t,
    event: a,
    self: r
  }) : e;
}
function eh(e) {
  return Array.isArray(e);
}
function sv(e) {
  return e.type.startsWith("xstate.error.actor");
}
function kn(e) {
  return $y(e).map((t) => typeof t > "u" || typeof t == "string" ? {
    target: t
  } : t);
}
function th(e) {
  if (!(e === void 0 || e === Qw))
    return _r(e);
}
function au(e, t, a) {
  var o, s, i;
  const r = typeof e == "object", n = r ? e : void 0;
  return {
    next: (o = r ? e.next : e) == null ? void 0 : o.bind(n),
    error: (s = r ? e.error : t) == null ? void 0 : s.bind(n),
    complete: (i = r ? e.complete : a) == null ? void 0 : i.bind(n)
  };
}
function _f(e, t) {
  return `${t}.${e}`;
}
function Uu(e, t) {
  const a = t.match(/^xstate\.invoke\.(\d+)\.(.*)/);
  if (!a)
    return e.implementations.actors[t];
  const [, r, n] = a, s = e.getStateNodeById(n).config.invoke;
  return (Array.isArray(s) ? s[r] : s).src;
}
function wf(e, t) {
  return `${e.sessionId}.${t}`;
}
let iv = 0;
function lv(e, t) {
  const a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new Set(), s = {}, {
    clock: i,
    logger: l
  } = t, u = {
    schedule: (c, h, g, _, b = Math.random().toString(36).slice(2)) => {
      const m = {
        source: c,
        target: h,
        event: g,
        delay: _,
        id: b,
        startedAt: Date.now()
      }, w = wf(c, b);
      p._snapshot._scheduledEvents[w] = m;
      const S = i.setTimeout(() => {
        delete s[w], delete p._snapshot._scheduledEvents[w], p._relay(c, h, g);
      }, _);
      s[w] = S;
    },
    cancel: (c, h) => {
      const g = wf(c, h), _ = s[g];
      delete s[g], delete p._snapshot._scheduledEvents[g], _ !== void 0 && i.clearTimeout(_);
    },
    cancelAll: (c) => {
      for (const h in p._snapshot._scheduledEvents) {
        const g = p._snapshot._scheduledEvents[h];
        g.source === c && u.cancel(c, g.id);
      }
    }
  }, f = (c) => {
    if (!o.size)
      return;
    const h = {
      ...c,
      rootId: e.sessionId
    };
    o.forEach((g) => {
      var _;
      return (_ = g.next) == null ? void 0 : _.call(g, h);
    });
  }, p = {
    _snapshot: {
      _scheduledEvents: ((t == null ? void 0 : t.snapshot) && t.snapshot.scheduler) ?? {}
    },
    _bookId: () => `x:${iv++}`,
    _register: (c, h) => (a.set(c, h), c),
    _unregister: (c) => {
      a.delete(c.sessionId);
      const h = n.get(c);
      h !== void 0 && (r.delete(h), n.delete(c));
    },
    get: (c) => r.get(c),
    _set: (c, h) => {
      const g = r.get(c);
      if (g && g !== h)
        throw new Error(`Actor with system ID '${c}' already exists.`);
      r.set(c, h), n.set(h, c);
    },
    inspect: (c) => {
      const h = au(c);
      return o.add(h), {
        unsubscribe() {
          o.delete(h);
        }
      };
    },
    _sendInspectionEvent: f,
    _relay: (c, h, g) => {
      p._sendInspectionEvent({
        type: "@xstate.event",
        sourceRef: c,
        actorRef: h,
        event: g
      }), h._send(g);
    },
    scheduler: u,
    getSnapshot: () => ({
      _scheduledEvents: {
        ...p._snapshot._scheduledEvents
      }
    }),
    start: () => {
      const c = p._snapshot._scheduledEvents;
      p._snapshot._scheduledEvents = {};
      for (const h in c) {
        const {
          source: g,
          target: _,
          event: b,
          delay: m,
          id: w
        } = c[h];
        u.schedule(g, _, b, m, w);
      }
    },
    _clock: i,
    _logger: l
  };
  return p;
}
let Ec = !1;
const Gu = 1;
let Zt = /* @__PURE__ */ function(e) {
  return e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped", e;
}({});
const cv = {
  clock: {
    setTimeout: (e, t) => setTimeout(e, t),
    clearTimeout: (e) => clearTimeout(e)
  },
  logger: console.log.bind(console),
  devTools: !1
};
class uv {
  /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */
  constructor(t, a) {
    this.logic = t, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new hf(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = Zt.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this._systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
    const r = {
      ...cv,
      ...a
    }, {
      clock: n,
      logger: o,
      parent: s,
      syncSnapshot: i,
      id: l,
      systemId: u,
      inspect: f
    } = r;
    this.system = s ? s.system : lv(this, {
      clock: n,
      logger: o
    }), f && !s && this.system.inspect(au(f)), this.sessionId = this.system._bookId(), this.id = l ?? this.sessionId, this.logger = (a == null ? void 0 : a.logger) ?? this.system._logger, this.clock = (a == null ? void 0 : a.clock) ?? this.system._clock, this._parent = s, this._syncSnapshot = i, this.options = r, this.src = r.src ?? t, this.ref = this, this._actorScope = {
      self: this,
      id: this.id,
      sessionId: this.sessionId,
      logger: this.logger,
      defer: (p) => {
        this._deferred.push(p);
      },
      system: this.system,
      stopChild: (p) => {
        if (p._parent !== this)
          throw new Error(`Cannot stop child actor ${p.id} of ${this.id} because it is not a child`);
        p._stop();
      },
      emit: (p) => {
        const c = this.eventListeners.get(p.type), h = this.eventListeners.get("*");
        if (!c && !h)
          return;
        const g = [...c ? c.values() : [], ...h ? h.values() : []];
        for (const _ of g)
          _(p);
      },
      actionExecutor: (p) => {
        const c = () => {
          if (this._actorScope.system._sendInspectionEvent({
            type: "@xstate.action",
            actorRef: this,
            action: {
              type: p.type,
              params: p.params
            }
          }), !p.exec)
            return;
          const h = Ec;
          try {
            Ec = !0, p.exec(p.info, p.params);
          } finally {
            Ec = h;
          }
        };
        this._processingStatus === Zt.Running ? c() : this._deferred.push(c);
      }
    }, this.send = this.send.bind(this), this.system._sendInspectionEvent({
      type: "@xstate.actor",
      actorRef: this
    }), u && (this._systemId = u, this.system._set(u, this)), this._initState((a == null ? void 0 : a.snapshot) ?? (a == null ? void 0 : a.state)), u && this._snapshot.status !== "active" && this.system._unregister(this);
  }
  _initState(t) {
    var a;
    try {
      this._snapshot = t ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(t, this._actorScope) : t : this.logic.getInitialSnapshot(this._actorScope, (a = this.options) == null ? void 0 : a.input);
    } catch (r) {
      this._snapshot = {
        status: "error",
        output: void 0,
        error: r
      };
    }
  }
  update(t, a) {
    var n, o;
    this._snapshot = t;
    let r;
    for (; r = this._deferred.shift(); )
      try {
        r();
      } catch (s) {
        this._deferred.length = 0, this._snapshot = {
          ...t,
          status: "error",
          error: s
        };
      }
    switch (this._snapshot.status) {
      case "active":
        for (const s of this.observers)
          try {
            (n = s.next) == null || n.call(s, t);
          } catch (i) {
            Ha(i);
          }
        break;
      case "done":
        for (const s of this.observers)
          try {
            (o = s.next) == null || o.call(s, t);
          } catch (i) {
            Ha(i);
          }
        this._stopProcedure(), this._complete(), this._doneEvent = rv(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
        break;
      case "error":
        this._error(this._snapshot.error);
        break;
    }
    this.system._sendInspectionEvent({
      type: "@xstate.snapshot",
      actorRef: this,
      event: a,
      snapshot: t
    });
  }
  /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */
  subscribe(t, a, r) {
    var o;
    const n = au(t, a, r);
    if (this._processingStatus !== Zt.Stopped)
      this.observers.add(n);
    else
      switch (this._snapshot.status) {
        case "done":
          try {
            (o = n.complete) == null || o.call(n);
          } catch (s) {
            Ha(s);
          }
          break;
        case "error": {
          const s = this._snapshot.error;
          if (!n.error)
            Ha(s);
          else
            try {
              n.error(s);
            } catch (i) {
              Ha(i);
            }
          break;
        }
      }
    return {
      unsubscribe: () => {
        this.observers.delete(n);
      }
    };
  }
  on(t, a) {
    let r = this.eventListeners.get(t);
    r || (r = /* @__PURE__ */ new Set(), this.eventListeners.set(t, r));
    const n = a.bind(void 0);
    return r.add(n), {
      unsubscribe: () => {
        r.delete(n);
      }
    };
  }
  /** Starts the Actor from the initial state */
  start() {
    if (this._processingStatus === Zt.Running)
      return this;
    this._syncSnapshot && this.subscribe({
      next: (r) => {
        r.status === "active" && this.system._relay(this, this._parent, {
          type: `xstate.snapshot.${this.id}`,
          snapshot: r
        });
      },
      error: () => {
      }
    }), this.system._register(this.sessionId, this), this._systemId && this.system._set(this._systemId, this), this._processingStatus = Zt.Running;
    const t = Jy(this.options.input);
    switch (this.system._sendInspectionEvent({
      type: "@xstate.event",
      sourceRef: this._parent,
      actorRef: this,
      event: t
    }), this._snapshot.status) {
      case "done":
        return this.update(this._snapshot, t), this;
      case "error":
        return this._error(this._snapshot.error), this;
    }
    if (this._parent || this.system.start(), this.logic.start)
      try {
        this.logic.start(this._snapshot, this._actorScope);
      } catch (r) {
        return this._snapshot = {
          ...this._snapshot,
          status: "error",
          error: r
        }, this._error(r), this;
      }
    return this.update(this._snapshot, t), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
  }
  _process(t) {
    let a, r;
    try {
      a = this.logic.transition(this._snapshot, t, this._actorScope);
    } catch (n) {
      r = {
        err: n
      };
    }
    if (r) {
      const {
        err: n
      } = r;
      this._snapshot = {
        ...this._snapshot,
        status: "error",
        error: n
      }, this._error(n);
      return;
    }
    this.update(a, t), t.type === Do && (this._stopProcedure(), this._complete());
  }
  _stop() {
    return this._processingStatus === Zt.Stopped ? this : (this.mailbox.clear(), this._processingStatus === Zt.NotStarted ? (this._processingStatus = Zt.Stopped, this) : (this.mailbox.enqueue({
      type: Do
    }), this));
  }
  /** Stops the Actor and unsubscribe all listeners. */
  stop() {
    if (this._parent)
      throw new Error("A non-root actor cannot be stopped directly.");
    return this._stop();
  }
  _complete() {
    var t;
    for (const a of this.observers)
      try {
        (t = a.complete) == null || t.call(a);
      } catch (r) {
        Ha(r);
      }
    this.observers.clear();
  }
  _reportError(t) {
    if (!this.observers.size) {
      this._parent || Ha(t);
      return;
    }
    let a = !1;
    for (const r of this.observers) {
      const n = r.error;
      a || (a = !n);
      try {
        n == null || n(t);
      } catch (o) {
        Ha(o);
      }
    }
    this.observers.clear(), a && Ha(t);
  }
  _error(t) {
    this._stopProcedure(), this._reportError(t), this._parent && this.system._relay(this, this._parent, Xy(this.id, t));
  }
  // TODO: atm children don't belong entirely to the actor so
  // in a way - it's not even super aware of them
  // so we can't stop them from here but we really should!
  // right now, they are being stopped within the machine's transition
  // but that could throw and leave us with "orphaned" active actors
  _stopProcedure() {
    return this._processingStatus !== Zt.Running ? this : (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new hf(this._process.bind(this)), this._processingStatus = Zt.Stopped, this.system._unregister(this), this);
  }
  /** @internal */
  _send(t) {
    this._processingStatus !== Zt.Stopped && this.mailbox.enqueue(t);
  }
  /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */
  send(t) {
    this.system._relay(void 0, this, t);
  }
  attachDevTools() {
    const {
      devTools: t
    } = this.options;
    t && (typeof t == "function" ? t : Jw)(this);
  }
  toJSON() {
    return {
      xstate$$type: Gu,
      id: this.id
    };
  }
  /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */
  getPersistedSnapshot(t) {
    return this.logic.getPersistedSnapshot(this._snapshot, t);
  }
  [nv]() {
    return this;
  }
  /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */
  getSnapshot() {
    return this._snapshot;
  }
}
function No(e, ...[t]) {
  return new uv(e, t);
}
function dv(e, t, a, r, {
  sendId: n
}) {
  const o = typeof n == "function" ? n(a, r) : n;
  return [t, {
    sendId: o
  }, void 0];
}
function fv(e, t) {
  e.defer(() => {
    e.system.scheduler.cancel(e.self, t.sendId);
  });
}
function pv(e) {
  function t(a, r) {
  }
  return t.type = "xstate.cancel", t.sendId = e, t.resolve = dv, t.execute = fv, t;
}
function yv(e, t, a, r, {
  id: n,
  systemId: o,
  src: s,
  input: i,
  syncSnapshot: l
}) {
  const u = typeof s == "string" ? Uu(t.machine, s) : s, f = typeof n == "function" ? n(a) : n;
  let p, c;
  return u && (c = typeof i == "function" ? i({
    context: t.context,
    event: a.event,
    self: e.self
  }) : i, p = No(u, {
    id: f,
    src: s,
    parent: e.self,
    syncSnapshot: l,
    systemId: o,
    input: c
  })), [$r(t, {
    children: {
      ...t.children,
      [f]: p
    }
  }), {
    id: n,
    systemId: o,
    actorRef: p,
    src: s,
    input: c
  }, void 0];
}
function hv(e, {
  actorRef: t
}) {
  t && e.defer(() => {
    t._processingStatus !== Zt.Stopped && t.start();
  });
}
function gv(...[e, {
  id: t,
  systemId: a,
  input: r,
  syncSnapshot: n = !1
} = {}]) {
  function o(s, i) {
  }
  return o.type = "xstate.spawnChild", o.id = t, o.systemId = a, o.src = e, o.input = r, o.syncSnapshot = n, o.resolve = yv, o.execute = hv, o;
}
function mv(e, t, a, r, {
  actorRef: n
}) {
  const o = typeof n == "function" ? n(a, r) : n, s = typeof o == "string" ? t.children[o] : o;
  let i = t.children;
  return s && (i = {
    ...i
  }, delete i[s.id]), [$r(t, {
    children: i
  }), s, void 0];
}
function _v(e, t) {
  if (t) {
    if (e.system._unregister(t), t._processingStatus !== Zt.Running) {
      e.stopChild(t);
      return;
    }
    e.defer(() => {
      e.stopChild(t);
    });
  }
}
function ah(e) {
  function t(a, r) {
  }
  return t.type = "xstate.stopChild", t.actorRef = e, t.resolve = mv, t.execute = _v, t;
}
function wv(e, {
  context: t,
  event: a
}, {
  guards: r
}) {
  return !Qs(r[0], t, a, e);
}
function vv(e) {
  function t(a, r) {
    return !1;
  }
  return t.check = wv, t.guards = [e], t;
}
function bv(e, {
  context: t,
  event: a
}, {
  guards: r
}) {
  return r.every((n) => Qs(n, t, a, e));
}
function ia(e) {
  function t(a, r) {
    return !1;
  }
  return t.check = bv, t.guards = e, t;
}
function Qs(e, t, a, r) {
  const {
    machine: n
  } = r, o = typeof e == "function", s = o ? e : n.implementations.guards[typeof e == "string" ? e : e.type];
  if (!o && !s)
    throw new Error(`Guard '${typeof e == "string" ? e : e.type}' is not implemented.'.`);
  if (typeof s != "function")
    return Qs(s, t, a, r);
  const i = {
    context: t,
    event: a
  }, l = o || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
    context: t,
    event: a
  }) : e.params : void 0;
  return "check" in s ? s.check(
    r,
    i,
    s
    // this holds all params
  ) : s(i, l);
}
const Ku = (e) => e.type === "atomic" || e.type === "final";
function Jn(e) {
  return Object.values(e.states).filter((t) => t.type !== "history");
}
function $s(e, t) {
  const a = [];
  if (t === e)
    return a;
  let r = e.parent;
  for (; r && r !== t; )
    a.push(r), r = r.parent;
  return a;
}
function Bi(e) {
  const t = new Set(e), a = nh(t);
  for (const r of t)
    if (r.type === "compound" && (!a.get(r) || !a.get(r).length))
      vf(r).forEach((n) => t.add(n));
    else if (r.type === "parallel") {
      for (const n of Jn(r))
        if (n.type !== "history" && !t.has(n)) {
          const o = vf(n);
          for (const s of o)
            t.add(s);
        }
    }
  for (const r of t) {
    let n = r.parent;
    for (; n; )
      t.add(n), n = n.parent;
  }
  return t;
}
function rh(e, t) {
  const a = t.get(e);
  if (!a)
    return {};
  if (e.type === "compound") {
    const n = a[0];
    if (n) {
      if (Ku(n))
        return n.key;
    } else
      return {};
  }
  const r = {};
  for (const n of a)
    r[n.key] = rh(n, t);
  return r;
}
function nh(e) {
  const t = /* @__PURE__ */ new Map();
  for (const a of e)
    t.has(a) || t.set(a, []), a.parent && (t.has(a.parent) || t.set(a.parent, []), t.get(a.parent).push(a));
  return t;
}
function oh(e, t) {
  const a = Bi(t);
  return rh(e, nh(a));
}
function Zu(e, t) {
  return t.type === "compound" ? Jn(t).some((a) => a.type === "final" && e.has(a)) : t.type === "parallel" ? Jn(t).every((a) => Zu(e, a)) : t.type === "final";
}
const oc = (e) => e[0] === $w;
function kv(e, t) {
  return e.transitions.get(t) || [...e.transitions.keys()].filter((r) => {
    if (r === ev)
      return !0;
    if (!r.endsWith(".*"))
      return !1;
    const n = r.split("."), o = t.split(".");
    for (let s = 0; s < n.length; s++) {
      const i = n[s], l = o[s];
      if (i === "*")
        return s === n.length - 1;
      if (i !== l)
        return !1;
    }
    return !0;
  }).sort((r, n) => n.length - r.length).flatMap((r) => e.transitions.get(r));
}
function xv(e) {
  const t = e.config.after;
  if (!t)
    return [];
  const a = (n) => {
    const o = av(n, e.id), s = o.type;
    return e.entry.push(Xv(o, {
      id: s,
      delay: n
    })), e.exit.push(pv(s)), s;
  };
  return Object.keys(t).flatMap((n) => {
    const o = t[n], s = typeof o == "string" ? {
      target: o
    } : o, i = Number.isNaN(+n) ? n : +n, l = a(i);
    return _r(s).map((u) => ({
      ...u,
      event: l,
      delay: i
    }));
  }).map((n) => {
    const {
      delay: o
    } = n;
    return {
      ...Nr(e, n.event, n),
      delay: o
    };
  });
}
function Nr(e, t, a) {
  const r = th(a.target), n = a.reenter ?? !1, o = Cv(e, r), s = {
    ...a,
    actions: _r(a.actions),
    guard: a.guard,
    target: o,
    source: e,
    reenter: n,
    eventType: t,
    toJSON: () => ({
      ...s,
      source: `#${e.id}`,
      target: o ? o.map((i) => `#${i.id}`) : void 0
    })
  };
  return s;
}
function zv(e) {
  const t = /* @__PURE__ */ new Map();
  if (e.config.on)
    for (const a of Object.keys(e.config.on)) {
      if (a === Zy)
        throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
      const r = e.config.on[a];
      t.set(a, kn(r).map((n) => Nr(e, a, n)));
    }
  if (e.config.onDone) {
    const a = `xstate.done.state.${e.id}`;
    t.set(a, kn(e.config.onDone).map((r) => Nr(e, a, r)));
  }
  for (const a of e.invoke) {
    if (a.onDone) {
      const r = `xstate.done.actor.${a.id}`;
      t.set(r, kn(a.onDone).map((n) => Nr(e, r, n)));
    }
    if (a.onError) {
      const r = `xstate.error.actor.${a.id}`;
      t.set(r, kn(a.onError).map((n) => Nr(e, r, n)));
    }
    if (a.onSnapshot) {
      const r = `xstate.snapshot.${a.id}`;
      t.set(r, kn(a.onSnapshot).map((n) => Nr(e, r, n)));
    }
  }
  for (const a of e.after) {
    let r = t.get(a.eventType);
    r || (r = [], t.set(a.eventType, r)), r.push(a);
  }
  return t;
}
function Sv(e, t) {
  const a = typeof t == "string" ? e.states[t] : t ? e.states[t.target] : void 0;
  if (!a && t)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
      `Initial state node "${t}" not found on parent state node #${e.id}`
    );
  const r = {
    source: e,
    actions: !t || typeof t == "string" ? [] : _r(t.actions),
    eventType: null,
    reenter: !1,
    target: a ? [a] : [],
    toJSON: () => ({
      ...r,
      source: `#${e.id}`,
      target: a ? [`#${a.id}`] : []
    })
  };
  return r;
}
function Cv(e, t) {
  if (t !== void 0)
    return t.map((a) => {
      if (typeof a != "string")
        return a;
      if (oc(a))
        return e.machine.getStateNodeById(a);
      const r = a[0] === Ky;
      if (r && !e.parent)
        return Wi(e, a.slice(1));
      const n = r ? e.key + a : a;
      if (e.parent)
        try {
          return Wi(e.parent, n);
        } catch (o) {
          throw new Error(`Invalid transition definition for state node '${e.id}':
${o.message}`);
        }
      else
        throw new Error(`Invalid target: "${a}" is not a valid target from the root node. Did you mean ".${a}"?`);
    });
}
function sh(e) {
  const t = th(e.config.target);
  return t ? {
    target: t.map((a) => typeof a == "string" ? Wi(e.parent, a) : a)
  } : e.parent.initial;
}
function Wr(e) {
  return e.type === "history";
}
function vf(e) {
  const t = ih(e);
  for (const a of t)
    for (const r of $s(a, e))
      t.add(r);
  return t;
}
function ih(e) {
  const t = /* @__PURE__ */ new Set();
  function a(r) {
    if (!t.has(r)) {
      if (t.add(r), r.type === "compound")
        a(r.initial.target[0]);
      else if (r.type === "parallel")
        for (const n of Jn(r))
          a(n);
    }
  }
  return a(e), t;
}
function Qn(e, t) {
  if (oc(t))
    return e.machine.getStateNodeById(t);
  if (!e.states)
    throw new Error(`Unable to retrieve child state '${t}' from '${e.id}'; no child states exist.`);
  const a = e.states[t];
  if (!a)
    throw new Error(`Child state '${t}' does not exist on '${e.id}'`);
  return a;
}
function Wi(e, t) {
  if (typeof t == "string" && oc(t))
    try {
      return e.machine.getStateNodeById(t);
    } catch {
    }
  const a = Hu(t).slice();
  let r = e;
  for (; a.length; ) {
    const n = a.shift();
    if (!n.length)
      break;
    r = Qn(r, n);
  }
  return r;
}
function Hi(e, t) {
  if (typeof t == "string") {
    const n = e.states[t];
    if (!n)
      throw new Error(`State '${t}' does not exist on '${e.id}'`);
    return [e, n];
  }
  const a = Object.keys(t), r = a.map((n) => Qn(e, n)).filter(Boolean);
  return [e.machine.root, e].concat(r, a.reduce((n, o) => {
    const s = Qn(e, o);
    if (!s)
      return n;
    const i = Hi(s, t[o]);
    return n.concat(i);
  }, []));
}
function Ev(e, t, a, r) {
  const o = Qn(e, t).next(a, r);
  return !o || !o.length ? e.next(a, r) : o;
}
function Av(e, t, a, r) {
  const n = Object.keys(t), o = Qn(e, n[0]), s = Yu(o, t[n[0]], a, r);
  return !s || !s.length ? e.next(a, r) : s;
}
function Tv(e, t, a, r) {
  const n = [];
  for (const o of Object.keys(t)) {
    const s = t[o];
    if (!s)
      continue;
    const i = Qn(e, o), l = Yu(i, s, a, r);
    l && n.push(...l);
  }
  return n.length ? n : e.next(a, r);
}
function Yu(e, t, a, r) {
  return typeof t == "string" ? Ev(e, t, a, r) : Object.keys(t).length === 1 ? Av(e, t, a, r) : Tv(e, t, a, r);
}
function Pv(e) {
  return Object.keys(e.states).map((t) => e.states[t]).filter((t) => t.type === "history");
}
function Sr(e, t) {
  let a = e;
  for (; a.parent && a.parent !== t; )
    a = a.parent;
  return a.parent === t;
}
function Ov(e, t) {
  const a = new Set(e), r = new Set(t);
  for (const n of a)
    if (r.has(n))
      return !0;
  for (const n of r)
    if (a.has(n))
      return !0;
  return !1;
}
function lh(e, t, a) {
  const r = /* @__PURE__ */ new Set();
  for (const n of e) {
    let o = !1;
    const s = /* @__PURE__ */ new Set();
    for (const i of r)
      if (Ov(ru([n], t, a), ru([i], t, a)))
        if (Sr(n.source, i.source))
          s.add(i);
        else {
          o = !0;
          break;
        }
    if (!o) {
      for (const i of s)
        r.delete(i);
      r.add(n);
    }
  }
  return Array.from(r);
}
function Mv(e) {
  const [t, ...a] = e;
  for (const r of $s(t, void 0))
    if (a.every((n) => Sr(n, r)))
      return r;
}
function Xu(e, t) {
  if (!e.target)
    return [];
  const a = /* @__PURE__ */ new Set();
  for (const r of e.target)
    if (Wr(r))
      if (t[r.id])
        for (const n of t[r.id])
          a.add(n);
      else
        for (const n of Xu(sh(r), t))
          a.add(n);
    else
      a.add(r);
  return [...a];
}
function ch(e, t) {
  const a = Xu(e, t);
  if (!a)
    return;
  if (!e.reenter && a.every((n) => n === e.source || Sr(n, e.source)))
    return e.source;
  const r = Mv(a.concat(e.source));
  if (r)
    return r;
  if (!e.reenter)
    return e.source.machine.root;
}
function ru(e, t, a) {
  var n;
  const r = /* @__PURE__ */ new Set();
  for (const o of e)
    if ((n = o.target) != null && n.length) {
      const s = ch(o, a);
      o.reenter && o.source === s && r.add(s);
      for (const i of t)
        Sr(i, s) && r.add(i);
    }
  return [...r];
}
function Iv(e, t) {
  if (e.length !== t.size)
    return !1;
  for (const a of e)
    if (!t.has(a))
      return !1;
  return !0;
}
function nu(e, t, a, r, n, o) {
  if (!e.length)
    return t;
  const s = new Set(t._nodes);
  let i = t.historyValue;
  const l = lh(e, s, i);
  let u = t;
  n || ([u, i] = Lv(u, r, a, l, s, i, o, a.actionExecutor)), u = $n(u, r, a, l.flatMap((p) => p.actions), o, void 0), u = jv(u, r, a, l, s, o, i, n);
  const f = [...s];
  u.status === "done" && (u = $n(u, r, a, f.sort((p, c) => c.order - p.order).flatMap((p) => p.exit), o, void 0));
  try {
    return i === t.historyValue && Iv(t._nodes, s) ? u : $r(u, {
      _nodes: f,
      historyValue: i
    });
  } catch (p) {
    throw p;
  }
}
function Fv(e, t, a, r, n) {
  if (r.output === void 0)
    return;
  const o = eu(n.id, n.output !== void 0 && n.parent ? tu(n.output, e.context, t, a.self) : void 0);
  return tu(r.output, e.context, o, a.self);
}
function jv(e, t, a, r, n, o, s, i) {
  let l = e;
  const u = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set();
  Rv(r, s, f, u), i && f.add(e.machine.root);
  const p = /* @__PURE__ */ new Set();
  for (const c of [...u].sort((h, g) => h.order - g.order)) {
    n.add(c);
    const h = [];
    h.push(...c.entry);
    for (const g of c.invoke)
      h.push(gv(g.src, {
        ...g,
        syncSnapshot: !!g.onSnapshot
      }));
    if (f.has(c)) {
      const g = c.initial.actions;
      h.push(...g);
    }
    if (l = $n(l, t, a, h, o, c.invoke.map((g) => g.id)), c.type === "final") {
      const g = c.parent;
      let _ = (g == null ? void 0 : g.type) === "parallel" ? g : g == null ? void 0 : g.parent, b = _ || c;
      for ((g == null ? void 0 : g.type) === "compound" && o.push(eu(g.id, c.output !== void 0 ? tu(c.output, l.context, t, a.self) : void 0)); (_ == null ? void 0 : _.type) === "parallel" && !p.has(_) && Zu(n, _); )
        p.add(_), o.push(eu(_.id)), b = _, _ = _.parent;
      if (_)
        continue;
      l = $r(l, {
        status: "done",
        output: Fv(l, t, a, l.machine.root, b)
      });
    }
  }
  return l;
}
function Rv(e, t, a, r) {
  for (const n of e) {
    const o = ch(n, t);
    for (const i of n.target || [])
      !Wr(i) && // if the target is different than the source then it will *definitely* be entered
      (n.source !== i || // we know that the domain can't lie within the source
      // if it's different than the source then it's outside of it and it means that the target has to be entered as well
      n.source !== o || // reentering transitions always enter the target, even if it's the source itself
      n.reenter) && (r.add(i), a.add(i)), xn(i, t, a, r);
    const s = Xu(n, t);
    for (const i of s) {
      const l = $s(i, o);
      (o == null ? void 0 : o.type) === "parallel" && l.push(o), uh(r, t, a, l, !n.source.parent && n.reenter ? void 0 : o);
    }
  }
}
function xn(e, t, a, r) {
  var n;
  if (Wr(e))
    if (t[e.id]) {
      const o = t[e.id];
      for (const s of o)
        r.add(s), xn(s, t, a, r);
      for (const s of o)
        Ac(s, e.parent, r, t, a);
    } else {
      const o = sh(e);
      for (const s of o.target)
        r.add(s), o === ((n = e.parent) == null ? void 0 : n.initial) && a.add(e.parent), xn(s, t, a, r);
      for (const s of o.target)
        Ac(s, e.parent, r, t, a);
    }
  else if (e.type === "compound") {
    const [o] = e.initial.target;
    Wr(o) || (r.add(o), a.add(o)), xn(o, t, a, r), Ac(o, e, r, t, a);
  } else if (e.type === "parallel")
    for (const o of Jn(e).filter((s) => !Wr(s)))
      [...r].some((s) => Sr(s, o)) || (Wr(o) || (r.add(o), a.add(o)), xn(o, t, a, r));
}
function uh(e, t, a, r, n) {
  for (const o of r)
    if ((!n || Sr(o, n)) && e.add(o), o.type === "parallel")
      for (const s of Jn(o).filter((i) => !Wr(i)))
        [...e].some((i) => Sr(i, s)) || (e.add(s), xn(s, t, a, e));
}
function Ac(e, t, a, r, n) {
  uh(a, r, n, $s(e, t));
}
function Lv(e, t, a, r, n, o, s, i) {
  let l = e;
  const u = ru(r, n, o);
  u.sort((p, c) => c.order - p.order);
  let f;
  for (const p of u)
    for (const c of Pv(p)) {
      let h;
      c.history === "deep" ? h = (g) => Ku(g) && Sr(g, p) : h = (g) => g.parent === p, f ?? (f = {
        ...o
      }), f[c.id] = Array.from(n).filter(h);
    }
  for (const p of u)
    l = $n(l, t, a, [...p.exit, ...p.invoke.map((c) => ah(c.id))], s, void 0), n.delete(p);
  return [l, f || o];
}
function Dv(e, t) {
  return e.implementations.actions[t];
}
function dh(e, t, a, r, n, o) {
  const {
    machine: s
  } = e;
  let i = e;
  for (const l of r) {
    const u = typeof l == "function", f = u ? l : (
      // the existing type of `.actions` assumes non-nullable `TExpressionAction`
      // it's fine to cast this here to get a common type and lack of errors in the rest of the code
      // our logic below makes sure that we call those 2 "variants" correctly
      Dv(s, typeof l == "string" ? l : l.type)
    ), p = {
      context: i.context,
      event: t,
      self: a.self,
      system: a.system
    }, c = u || typeof l == "string" ? void 0 : "params" in l ? typeof l.params == "function" ? l.params({
      context: i.context,
      event: t
    }) : l.params : void 0;
    if (!f || !("resolve" in f)) {
      a.actionExecutor({
        type: typeof l == "string" ? l : typeof l == "object" ? l.type : l.name || "(anonymous)",
        info: p,
        params: c,
        exec: f
      });
      continue;
    }
    const h = f, [g, _, b] = h.resolve(
      a,
      i,
      p,
      c,
      f,
      // this holds all params
      n
    );
    i = g, "retryResolve" in h && (o == null || o.push([h, _])), "execute" in h && a.actionExecutor({
      type: h.type,
      info: p,
      params: _,
      exec: h.execute.bind(null, a, _)
    }), b && (i = dh(i, t, a, b, n, o));
  }
  return i;
}
function $n(e, t, a, r, n, o) {
  const s = o ? [] : void 0, i = dh(e, t, a, r, {
    internalQueue: n,
    deferredActorIds: o
  }, s);
  return s == null || s.forEach(([l, u]) => {
    l.retryResolve(a, i, u);
  }), i;
}
function Tc(e, t, a, r) {
  let n = e;
  const o = [];
  function s(u, f, p) {
    a.system._sendInspectionEvent({
      type: "@xstate.microstep",
      actorRef: a.self,
      event: f,
      snapshot: u,
      _transitions: p
    }), o.push(u);
  }
  if (t.type === Do)
    return n = $r(bf(n, t, a), {
      status: "stopped"
    }), s(n, t, []), {
      snapshot: n,
      microstates: o
    };
  let i = t;
  if (i.type !== Yy) {
    const u = i, f = sv(u), p = kf(u, n);
    if (f && !p.length)
      return n = $r(e, {
        status: "error",
        error: u.error
      }), s(n, u, []), {
        snapshot: n,
        microstates: o
      };
    n = nu(
      p,
      e,
      a,
      i,
      !1,
      // isInitial
      r
    ), s(n, u, p);
  }
  let l = !0;
  for (; n.status === "active"; ) {
    let u = l ? Nv(n, i) : [];
    const f = u.length ? n : void 0;
    if (!u.length) {
      if (!r.length)
        break;
      i = r.shift(), u = kf(i, n);
    }
    n = nu(u, n, a, i, !1, r), l = n !== f, s(n, i, u);
  }
  return n.status !== "active" && bf(n, i, a), {
    snapshot: n,
    microstates: o
  };
}
function bf(e, t, a) {
  return $n(e, t, a, Object.values(e.children).map((r) => ah(r)), [], void 0);
}
function kf(e, t) {
  return t.machine.getTransitionData(t, e);
}
function Nv(e, t) {
  const a = /* @__PURE__ */ new Set(), r = e._nodes.filter(Ku);
  for (const n of r)
    e: for (const o of [n].concat($s(n, void 0)))
      if (o.always) {
        for (const s of o.always)
          if (s.guard === void 0 || Qs(s.guard, e.context, t, e)) {
            a.add(s);
            break e;
          }
      }
  return lh(Array.from(a), new Set(e._nodes), e.historyValue);
}
function Vv(e, t) {
  const a = Bi(Hi(e, t));
  return oh(e, [...a]);
}
function qv(e) {
  return !!e && typeof e == "object" && "machine" in e && "value" in e;
}
const Bv = function(t) {
  return Qy(t, this.value);
}, Wv = function(t) {
  return this.tags.has(t);
}, Hv = function(t) {
  const a = this.machine.getTransitionData(this, t);
  return !!(a != null && a.length) && // Check that at least one transition is not forbidden
  a.some((r) => r.target !== void 0 || r.actions.length);
}, Uv = function() {
  const {
    _nodes: t,
    tags: a,
    machine: r,
    getMeta: n,
    toJSON: o,
    can: s,
    hasTag: i,
    matches: l,
    ...u
  } = this;
  return {
    ...u,
    tags: Array.from(a)
  };
}, Gv = function() {
  return this._nodes.reduce((t, a) => (a.meta !== void 0 && (t[a.id] = a.meta), t), {});
};
function Pi(e, t) {
  return {
    status: e.status,
    output: e.output,
    error: e.error,
    machine: t,
    context: e.context,
    _nodes: e._nodes,
    value: oh(t.root, e._nodes),
    tags: new Set(e._nodes.flatMap((a) => a.tags)),
    children: e.children,
    historyValue: e.historyValue || {},
    matches: Bv,
    hasTag: Wv,
    can: Hv,
    getMeta: Gv,
    toJSON: Uv
  };
}
function $r(e, t = {}) {
  return Pi({
    ...e,
    ...t
  }, e.machine);
}
function Kv(e, t) {
  const {
    _nodes: a,
    tags: r,
    machine: n,
    children: o,
    context: s,
    can: i,
    hasTag: l,
    matches: u,
    getMeta: f,
    toJSON: p,
    ...c
  } = e, h = {};
  for (const _ in o) {
    const b = o[_];
    h[_] = {
      snapshot: b.getPersistedSnapshot(t),
      src: b.src,
      systemId: b._systemId,
      syncSnapshot: b._syncSnapshot
    };
  }
  return {
    ...c,
    context: fh(s),
    children: h
  };
}
function fh(e) {
  let t;
  for (const a in e) {
    const r = e[a];
    if (r && typeof r == "object")
      if ("sessionId" in r && "send" in r && "ref" in r)
        t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[a] = {
          xstate$$type: Gu,
          id: r.id
        };
      else {
        const n = fh(r);
        n !== r && (t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[a] = n);
      }
  }
  return t ?? e;
}
function Zv(e, t, a, r, {
  event: n,
  id: o,
  delay: s
}, {
  internalQueue: i
}) {
  const l = t.machine.implementations.delays;
  if (typeof n == "string")
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Only event objects may be used with raise; use raise({ type: "${n}" }) instead`
    );
  const u = typeof n == "function" ? n(a, r) : n;
  let f;
  if (typeof s == "string") {
    const p = l && l[s];
    f = typeof p == "function" ? p(a, r) : p;
  } else
    f = typeof s == "function" ? s(a, r) : s;
  return typeof f != "number" && i.push(u), [t, {
    event: u,
    id: o,
    delay: f
  }, void 0];
}
function Yv(e, t) {
  const {
    event: a,
    delay: r,
    id: n
  } = t;
  if (typeof r == "number") {
    e.defer(() => {
      const o = e.self;
      e.system.scheduler.schedule(o, o, a, r, n);
    });
    return;
  }
}
function Xv(e, t) {
  function a(r, n) {
  }
  return a.type = "xstate.raise", a.event = e, a.id = t == null ? void 0 : t.id, a.delay = t == null ? void 0 : t.delay, a.resolve = Zv, a.execute = Yv, a;
}
const xf = /* @__PURE__ */ new WeakMap();
function Oi(e) {
  return {
    config: e,
    start: (a, r) => {
      const {
        self: n,
        system: o,
        emit: s
      } = r, i = {
        receivers: void 0,
        dispose: void 0
      };
      xf.set(n, i), i.dispose = e({
        input: a.input,
        system: o,
        self: n,
        sendBack: (l) => {
          n.getSnapshot().status !== "stopped" && n._parent && o._relay(n, n._parent, l);
        },
        receive: (l) => {
          i.receivers ?? (i.receivers = /* @__PURE__ */ new Set()), i.receivers.add(l);
        },
        emit: s
      });
    },
    transition: (a, r, n) => {
      var s, i;
      const o = xf.get(n.self);
      return r.type === Do ? (a = {
        ...a,
        status: "stopped",
        error: void 0
      }, (s = o.dispose) == null || s.call(o), a) : ((i = o.receivers) == null || i.forEach((l) => l(r)), a);
    },
    getInitialSnapshot: (a, r) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input: r
    }),
    getPersistedSnapshot: (a) => a,
    restoreSnapshot: (a) => a
  };
}
const zf = "xstate.promise.resolve", Sf = "xstate.promise.reject", mi = /* @__PURE__ */ new WeakMap();
function wt(e) {
  return {
    config: e,
    transition: (a, r, n) => {
      var o;
      if (a.status !== "active")
        return a;
      switch (r.type) {
        case zf: {
          const s = r.data;
          return {
            ...a,
            status: "done",
            output: s,
            input: void 0
          };
        }
        case Sf:
          return {
            ...a,
            status: "error",
            error: r.data,
            input: void 0
          };
        case Do:
          return (o = mi.get(n.self)) == null || o.abort(), {
            ...a,
            status: "stopped",
            input: void 0
          };
        default:
          return a;
      }
    },
    start: (a, {
      self: r,
      system: n,
      emit: o
    }) => {
      if (a.status !== "active")
        return;
      const s = new AbortController();
      mi.set(r, s), Promise.resolve(e({
        input: a.input,
        system: n,
        self: r,
        signal: s.signal,
        emit: o
      })).then((l) => {
        r.getSnapshot().status === "active" && (mi.delete(r), n._relay(r, r, {
          type: zf,
          data: l
        }));
      }, (l) => {
        r.getSnapshot().status === "active" && (mi.delete(r), n._relay(r, r, {
          type: Sf,
          data: l
        }));
      });
    },
    getInitialSnapshot: (a, r) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input: r
    }),
    getPersistedSnapshot: (a) => a,
    restoreSnapshot: (a) => a
  };
}
function Jv(e, {
  machine: t,
  context: a
}, r, n) {
  const o = (s, i) => {
    if (typeof s == "string") {
      const l = Uu(t, s);
      if (!l)
        throw new Error(`Actor logic '${s}' not implemented in machine '${t.id}'`);
      const u = No(l, {
        id: i == null ? void 0 : i.id,
        parent: e.self,
        syncSnapshot: i == null ? void 0 : i.syncSnapshot,
        input: typeof (i == null ? void 0 : i.input) == "function" ? i.input({
          context: a,
          event: r,
          self: e.self
        }) : i == null ? void 0 : i.input,
        src: s,
        systemId: i == null ? void 0 : i.systemId
      });
      return n[u.id] = u, u;
    } else
      return No(s, {
        id: i == null ? void 0 : i.id,
        parent: e.self,
        syncSnapshot: i == null ? void 0 : i.syncSnapshot,
        input: i == null ? void 0 : i.input,
        src: s,
        systemId: i == null ? void 0 : i.systemId
      });
  };
  return (s, i) => {
    const l = o(s, i);
    return n[l.id] = l, e.defer(() => {
      l._processingStatus !== Zt.Stopped && l.start();
    }), l;
  };
}
function Qv(e, t, a, r, {
  assignment: n
}) {
  if (!t.context)
    throw new Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
  const o = {}, s = {
    context: t.context,
    event: a.event,
    spawn: Jv(e, t, a.event, o),
    self: e.self,
    system: e.system
  };
  let i = {};
  if (typeof n == "function")
    i = n(s, r);
  else
    for (const u of Object.keys(n)) {
      const f = n[u];
      i[u] = typeof f == "function" ? f(s, r) : f;
    }
  const l = Object.assign({}, t.context, i);
  return [$r(t, {
    context: l,
    children: Object.keys(o).length ? {
      ...t.children,
      ...o
    } : t.children
  }), void 0, void 0];
}
function re(e) {
  function t(a, r) {
  }
  return t.type = "xstate.assign", t.assignment = e, t.resolve = Qv, t;
}
let ou = /* @__PURE__ */ function(e) {
  return e.Parent = "#_parent", e.Internal = "#_internal", e;
}({});
function $v(e, t, a, r, {
  to: n,
  event: o,
  id: s,
  delay: i
}, l) {
  var g;
  const u = t.machine.implementations.delays;
  if (typeof o == "string")
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Only event objects may be used with sendTo; use sendTo({ type: "${o}" }) instead`
    );
  const f = typeof o == "function" ? o(a, r) : o;
  let p;
  if (typeof i == "string") {
    const _ = u && u[i];
    p = typeof _ == "function" ? _(a, r) : _;
  } else
    p = typeof i == "function" ? i(a, r) : i;
  const c = typeof n == "function" ? n(a, r) : n;
  let h;
  if (typeof c == "string") {
    if (c === ou.Parent ? h = e.self._parent : c === ou.Internal ? h = e.self : c.startsWith("#_") ? h = t.children[c.slice(2)] : h = (g = l.deferredActorIds) != null && g.includes(c) ? c : t.children[c], !h)
      throw new Error(`Unable to send event to actor '${c}' from machine '${t.machine.id}'.`);
  } else
    h = c || e.self;
  return [t, {
    to: h,
    targetId: typeof c == "string" ? c : void 0,
    event: f,
    id: s,
    delay: p
  }, void 0];
}
function eb(e, t, a) {
  typeof a.to == "string" && (a.to = t.children[a.to]);
}
function tb(e, t) {
  e.defer(() => {
    const {
      to: a,
      event: r,
      delay: n,
      id: o
    } = t;
    if (typeof n == "number") {
      e.system.scheduler.schedule(e.self, a, r, n, o);
      return;
    }
    e.system._relay(
      e.self,
      // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
      // if it initially started as a string
      a,
      r.type === tv ? Xy(e.self.id, r.data) : r
    );
  });
}
function ab(e, t, a) {
  function r(n, o) {
  }
  return r.type = "xstate.sendTo", r.to = e, r.event = t, r.id = a == null ? void 0 : a.id, r.delay = a == null ? void 0 : a.delay, r.resolve = $v, r.retryResolve = eb, r.execute = tb, r;
}
function Cf(e, t) {
  return ab(ou.Parent, e, t);
}
const Ef = /* @__PURE__ */ new WeakMap();
function mn(e, t, a) {
  let r = Ef.get(e);
  return r ? t in r || (r[t] = a()) : (r = {
    [t]: a()
  }, Ef.set(e, r)), r[t];
}
const rb = {}, bo = (e) => typeof e == "string" ? {
  type: e
} : typeof e == "function" ? "resolve" in e ? {
  type: e.type
} : {
  type: e.name
} : e;
class Ju {
  constructor(t, a) {
    if (this.config = t, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = a._parent, this.key = a._key, this.machine = a._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join(Ky), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? mf(this.config.states, (r, n) => new Ju(r, {
      _parent: this,
      _key: n,
      _machine: this.machine
    })) : rb, this.type === "compound" && !this.config.initial)
      throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
    this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = _r(this.config.entry).slice(), this.exit = _r(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = _r(t.tags).slice();
  }
  /** @internal */
  _initialize() {
    this.transitions = zv(this), this.config.always && (this.always = kn(this.config.always).map((t) => Nr(this, Zy, t))), Object.keys(this.states).forEach((t) => {
      this.states[t]._initialize();
    });
  }
  /** The well-structured state node definition. */
  get definition() {
    return {
      id: this.id,
      key: this.key,
      version: this.machine.version,
      type: this.type,
      initial: this.initial ? {
        target: this.initial.target,
        source: this,
        actions: this.initial.actions.map(bo),
        eventType: null,
        reenter: !1,
        toJSON: () => ({
          target: this.initial.target.map((t) => `#${t.id}`),
          source: `#${this.id}`,
          actions: this.initial.actions.map(bo),
          eventType: null
        })
      } : void 0,
      history: this.history,
      states: mf(this.states, (t) => t.definition),
      on: this.on,
      transitions: [...this.transitions.values()].flat().map((t) => ({
        ...t,
        actions: t.actions.map(bo)
      })),
      entry: this.entry.map(bo),
      exit: this.exit.map(bo),
      meta: this.meta,
      order: this.order || -1,
      output: this.output,
      invoke: this.invoke,
      description: this.description,
      tags: this.tags
    };
  }
  /** @internal */
  toJSON() {
    return this.definition;
  }
  /** The logic invoked as actors by this state node. */
  get invoke() {
    return mn(this, "invoke", () => _r(this.config.invoke).map((t, a) => {
      const {
        src: r,
        systemId: n
      } = t, o = t.id ?? _f(this.id, a), s = typeof r == "string" ? r : `xstate.invoke.${_f(this.id, a)}`;
      return {
        ...t,
        src: s,
        id: o,
        systemId: n,
        toJSON() {
          const {
            onDone: i,
            onError: l,
            ...u
          } = t;
          return {
            ...u,
            type: "xstate.invoke",
            src: s,
            id: o
          };
        }
      };
    }));
  }
  /** The mapping of events to transitions. */
  get on() {
    return mn(this, "on", () => [...this.transitions].flatMap(([a, r]) => r.map((n) => [a, n])).reduce((a, [r, n]) => (a[r] = a[r] || [], a[r].push(n), a), {}));
  }
  get after() {
    return mn(this, "delayedTransitions", () => xv(this));
  }
  get initial() {
    return mn(this, "initial", () => Sv(this, this.config.initial));
  }
  /** @internal */
  next(t, a) {
    const r = a.type, n = [];
    let o;
    const s = mn(this, `candidates-${r}`, () => kv(this, r));
    for (const i of s) {
      const {
        guard: l
      } = i, u = t.context;
      let f = !1;
      try {
        f = !l || Qs(l, u, a, t);
      } catch (p) {
        const c = typeof l == "string" ? l : typeof l == "object" ? l.type : void 0;
        throw new Error(`Unable to evaluate guard ${c ? `'${c}' ` : ""}in transition for event '${r}' in state node '${this.id}':
${p.message}`);
      }
      if (f) {
        n.push(...i.actions), o = i;
        break;
      }
    }
    return o ? [o] : void 0;
  }
  /** All the event types accepted by this state node and its descendants. */
  get events() {
    return mn(this, "events", () => {
      const {
        states: t
      } = this, a = new Set(this.ownEvents);
      if (t)
        for (const r of Object.keys(t)) {
          const n = t[r];
          if (n.states)
            for (const o of n.events)
              a.add(`${o}`);
        }
      return Array.from(a);
    });
  }
  /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */
  get ownEvents() {
    const t = new Set([...this.transitions.keys()].filter((a) => this.transitions.get(a).some((r) => !(!r.target && !r.actions.length && !r.reenter))));
    return Array.from(t);
  }
}
const nb = "#";
class Qu {
  constructor(t, a) {
    this.config = t, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = t.id || "(machine)", this.implementations = {
      actors: (a == null ? void 0 : a.actors) ?? {},
      actions: (a == null ? void 0 : a.actions) ?? {},
      delays: (a == null ? void 0 : a.delays) ?? {},
      guards: (a == null ? void 0 : a.guards) ?? {}
    }, this.version = this.config.version, this.schemas = this.config.schemas, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new Ju(t, {
      _key: this.id,
      _machine: this
    }), this.root._initialize(), this.states = this.root.states, this.events = this.root.events;
  }
  /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */
  provide(t) {
    const {
      actions: a,
      guards: r,
      actors: n,
      delays: o
    } = this.implementations;
    return new Qu(this.config, {
      actions: {
        ...a,
        ...t.actions
      },
      guards: {
        ...r,
        ...t.guards
      },
      actors: {
        ...n,
        ...t.actors
      },
      delays: {
        ...o,
        ...t.delays
      }
    });
  }
  resolveState(t) {
    const a = Vv(this.root, t.value), r = Bi(Hi(this.root, a));
    return Pi({
      _nodes: [...r],
      context: t.context || {},
      children: {},
      status: Zu(r, this.root) ? "done" : t.status || "active",
      output: t.output,
      error: t.error,
      historyValue: t.historyValue
    }, this);
  }
  /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */
  transition(t, a, r) {
    return Tc(t, a, r, []).snapshot;
  }
  /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */
  microstep(t, a, r) {
    return Tc(t, a, r, []).microstates;
  }
  getTransitionData(t, a) {
    return Yu(this.root, t.value, t, a) || [];
  }
  /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */
  getPreInitialState(t, a, r) {
    const {
      context: n
    } = this.config, o = Pi({
      context: typeof n != "function" && n ? n : {},
      _nodes: [this.root],
      children: {},
      status: "active"
    }, this);
    return typeof n == "function" ? $n(o, a, t, [re(({
      spawn: i,
      event: l,
      self: u
    }) => n({
      spawn: i,
      input: l.input,
      self: u
    }))], r, void 0) : o;
  }
  /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */
  getInitialSnapshot(t, a) {
    const r = Jy(a), n = [], o = this.getPreInitialState(t, r, n), s = nu([{
      target: [...ih(this.root)],
      source: this.root,
      reenter: !0,
      actions: [],
      eventType: null,
      toJSON: null
      // TODO: fix
    }], o, t, r, !0, n), {
      snapshot: i
    } = Tc(s, r, t, n);
    return i;
  }
  start(t) {
    Object.values(t.children).forEach((a) => {
      a.getSnapshot().status === "active" && a.start();
    });
  }
  getStateNodeById(t) {
    const a = Hu(t), r = a.slice(1), n = oc(a[0]) ? a[0].slice(nb.length) : a[0], o = this.idMap.get(n);
    if (!o)
      throw new Error(`Child state node '#${n}' does not exist on machine '${this.id}'`);
    return Wi(o, r);
  }
  get definition() {
    return this.root.definition;
  }
  toJSON() {
    return this.definition;
  }
  getPersistedSnapshot(t, a) {
    return Kv(t, a);
  }
  restoreSnapshot(t, a) {
    const r = {}, n = t.children;
    Object.keys(n).forEach((l) => {
      const u = n[l], f = u.snapshot, p = u.src, c = typeof p == "string" ? Uu(this, p) : p;
      if (!c)
        return;
      const h = No(c, {
        id: l,
        parent: a.self,
        syncSnapshot: u.syncSnapshot,
        snapshot: f,
        src: p,
        systemId: u.systemId
      });
      r[l] = h;
    });
    const o = Pi({
      ...t,
      children: r,
      _nodes: Array.from(Bi(Hi(this.root, t.value)))
    }, this), s = /* @__PURE__ */ new Set();
    function i(l, u) {
      if (!s.has(l)) {
        s.add(l);
        for (const f in l) {
          const p = l[f];
          if (p && typeof p == "object") {
            if ("xstate$$type" in p && p.xstate$$type === Gu) {
              l[f] = u[p.id];
              continue;
            }
            i(p, u);
          }
        }
      }
    }
    return i(o.context, r), o;
  }
}
function $u(e, t) {
  return new Qu(e, t);
}
const Cr = (e) => e;
var ob = {};
let ei = Cr, en = Cr;
ob.NODE_ENV !== "production" && (ei = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, en = (e, t) => {
  if (!e)
    throw new Error(t);
});
function sb(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function ph(e, t) {
  const a = e.indexOf(t);
  a > -1 && e.splice(a, 1);
}
class yh {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return sb(this.subscriptions, t), () => ph(this.subscriptions, t);
  }
  notify(t, a, r) {
    const n = this.subscriptions.length;
    if (n)
      if (n === 1)
        this.subscriptions[0](t, a, r);
      else
        for (let o = 0; o < n; o++) {
          const s = this.subscriptions[o];
          s && s(t, a, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function hh(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Af = /* @__PURE__ */ new Set();
function ed(e, t, a) {
  e || Af.has(t) || (console.warn(t), Af.add(t));
}
const ib = {
  skipAnimations: !1,
  useManualTiming: !1
};
function lb(e) {
  let t = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), r = !1, n = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function i(u) {
    o.has(u) && (l.schedule(u), e()), u(s);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, f = !1, p = !1) => {
      const h = p && r ? t : a;
      return f && o.add(u), h.has(u) || h.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      a.delete(u), o.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (s = u, r) {
        n = !0;
        return;
      }
      r = !0, [t, a] = [a, t], a.clear(), t.forEach(i), r = !1, n && (n = !1, l.process(u));
    }
  };
  return l;
}
const _i = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], cb = 40;
function ub(e, t) {
  let a = !1, r = !0;
  const n = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => a = !0, s = _i.reduce((m, w) => (m[w] = lb(o), m), {}), { read: i, resolveKeyframes: l, update: u, preRender: f, render: p, postRender: c } = s, h = () => {
    const m = performance.now();
    a = !1, n.delta = r ? 1e3 / 60 : Math.max(Math.min(m - n.timestamp, cb), 1), n.timestamp = m, n.isProcessing = !0, i.process(n), l.process(n), u.process(n), f.process(n), p.process(n), c.process(n), n.isProcessing = !1, a && t && (r = !1, e(h));
  }, g = () => {
    a = !0, r = !0, n.isProcessing || e(h);
  };
  return { schedule: _i.reduce((m, w) => {
    const S = s[w];
    return m[w] = (C, v = !1, y = !1) => (a || g(), S.schedule(C, v, y)), m;
  }, {}), cancel: (m) => {
    for (let w = 0; w < _i.length; w++)
      s[_i[w]].cancel(m);
  }, state: n, steps: s };
}
const { schedule: er, cancel: su, state: Ui, steps: wte } = ub(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Cr, !0);
let Mi;
function db() {
  Mi = void 0;
}
const kr = {
  now: () => (Mi === void 0 && kr.set(Ui.isProcessing || ib.useManualTiming ? Ui.timestamp : performance.now()), Mi),
  set: (e) => {
    Mi = e, queueMicrotask(db);
  }
};
var fb = {};
const Tf = 30, pb = (e) => !isNaN(parseFloat(e));
class yb {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, a = {}) {
    this.version = "11.13.5", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, n = !0) => {
      const o = kr.now();
      this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), n && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = a.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = kr.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = pb(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return fb.NODE_ENV !== "production" && ed(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, a) {
    this.events[t] || (this.events[t] = new yh());
    const r = this.events[t].add(a);
    return t === "change" ? () => {
      r(), er.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, a) {
    this.passiveEffect = t, this.stopPassiveEffect = a;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, a = !0) {
    !a || !this.passiveEffect ? this.updateAndNotify(t, a) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, a, r) {
    this.set(a), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, a = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, a && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = kr.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Tf)
      return 0;
    const a = Math.min(this.updatedAt - this.prevUpdatedAt, Tf);
    return hh(parseFloat(this.current) - parseFloat(this.prevFrameValue), a);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((a) => {
      this.hasAnimated = !0, this.animation = t(a), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Vo(e, t) {
  return new yb(e, t);
}
function td(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const hb = td(() => window.ScrollTimeline !== void 0);
class gh {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, a) {
    return Promise.all(this.animations).then(t).catch(a);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, a) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = a;
  }
  attachTimeline(t, a) {
    const r = this.animations.map((n) => hb() && n.attachTimeline ? n.attachTimeline(t) : a(n));
    return () => {
      r.forEach((n, o) => {
        n && n(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let a = 0; a < this.animations.length; a++)
      t = Math.max(t, this.animations[a].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((a) => a[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const sc = (e, t, a) => {
  const r = t - e;
  return r === 0 ? 1 : (a - e) / r;
}, mh = (e, t, a = 10) => {
  let r = "";
  const n = Math.max(Math.round(t / a), 2);
  for (let o = 0; o < n; o++)
    r += e(sc(0, n - 1, o)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Oa = (e) => e * 1e3, $a = (e) => e / 1e3, gb = 5;
function _h(e, t, a) {
  const r = Math.max(t - gb, 0);
  return hh(a - e(r), t - r);
}
const tn = (e, t, a) => a > t ? t : a < e ? e : a, bt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Pc = 1e-3;
function mb({ duration: e = bt.duration, bounce: t = bt.bounce, velocity: a = bt.velocity, mass: r = bt.mass }) {
  let n, o;
  ei(e <= Oa(bt.maxDuration), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = tn(bt.minDamping, bt.maxDamping, s), e = tn(bt.minDuration, bt.maxDuration, $a(e)), s < 1 ? (n = (u) => {
    const f = u * s, p = f * e, c = f - a, h = iu(u, s), g = Math.exp(-p);
    return Pc - c / h * g;
  }, o = (u) => {
    const p = u * s * e, c = p * a + a, h = Math.pow(s, 2) * Math.pow(u, 2) * e, g = Math.exp(-p), _ = iu(Math.pow(u, 2), s);
    return (-n(u) + Pc > 0 ? -1 : 1) * ((c - h) * g) / _;
  }) : (n = (u) => {
    const f = Math.exp(-u * e), p = (u - a) * e + 1;
    return -Pc + f * p;
  }, o = (u) => {
    const f = Math.exp(-u * e), p = (a - u) * (e * e);
    return f * p;
  });
  const i = 5 / e, l = wb(n, o, i);
  if (e = Oa(e), isNaN(l))
    return {
      stiffness: bt.stiffness,
      damping: bt.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: s * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const _b = 12;
function wb(e, t, a) {
  let r = a;
  for (let n = 1; n < _b; n++)
    r = r - e(r) / t(r);
  return r;
}
function iu(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Gi = 2e4;
function ad(e) {
  let t = 0;
  const a = 50;
  let r = e.next(t);
  for (; !r.done && t < Gi; )
    t += a, r = e.next(t);
  return t >= Gi ? 1 / 0 : t;
}
const vb = ["duration", "bounce"], bb = ["stiffness", "damping", "mass"];
function Pf(e, t) {
  return t.some((a) => e[a] !== void 0);
}
function kb(e) {
  let t = {
    velocity: bt.velocity,
    stiffness: bt.stiffness,
    damping: bt.damping,
    mass: bt.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Pf(e, bb) && Pf(e, vb))
    if (e.visualDuration) {
      const a = e.visualDuration, r = 2 * Math.PI / (a * 1.2), n = r * r, o = 2 * tn(0.05, 1, 1 - e.bounce) * Math.sqrt(n);
      t = {
        ...t,
        mass: bt.mass,
        stiffness: n,
        damping: o
      };
    } else {
      const a = mb(e);
      t = {
        ...t,
        ...a,
        mass: bt.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function rd(e = bt.visualDuration, t = bt.bounce) {
  const a = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: n } = a;
  const o = a.keyframes[0], s = a.keyframes[a.keyframes.length - 1], i = { done: !1, value: o }, { stiffness: l, damping: u, mass: f, duration: p, velocity: c, isResolvedFromDuration: h } = kb({
    ...a,
    velocity: -$a(a.velocity || 0)
  }), g = c || 0, _ = u / (2 * Math.sqrt(l * f)), b = s - o, m = $a(Math.sqrt(l / f)), w = Math.abs(b) < 5;
  r || (r = w ? bt.restSpeed.granular : bt.restSpeed.default), n || (n = w ? bt.restDelta.granular : bt.restDelta.default);
  let S;
  if (_ < 1) {
    const v = iu(m, _);
    S = (y) => {
      const k = Math.exp(-_ * m * y);
      return s - k * ((g + _ * m * b) / v * Math.sin(v * y) + b * Math.cos(v * y));
    };
  } else if (_ === 1)
    S = (v) => s - Math.exp(-m * v) * (b + (g + m * b) * v);
  else {
    const v = m * Math.sqrt(_ * _ - 1);
    S = (y) => {
      const k = Math.exp(-_ * m * y), x = Math.min(v * y, 300);
      return s - k * ((g + _ * m * b) * Math.sinh(x) + v * b * Math.cosh(x)) / v;
    };
  }
  const C = {
    calculatedDuration: h && p || null,
    next: (v) => {
      const y = S(v);
      if (h)
        i.done = v >= p;
      else {
        let k = 0;
        _ < 1 && (k = v === 0 ? Oa(g) : _h(S, v, y));
        const x = Math.abs(k) <= r, T = Math.abs(s - y) <= n;
        i.done = x && T;
      }
      return i.value = i.done ? s : y, i;
    },
    toString: () => {
      const v = Math.min(ad(C), Gi), y = mh((k) => C.next(v * k).value, v, 30);
      return v + "ms " + y;
    }
  };
  return C;
}
function xb(e, t = 100, a) {
  const r = a({ ...e, keyframes: [0, t] }), n = Math.min(ad(r), Gi);
  return {
    type: "keyframes",
    ease: (o) => r.next(n * o).value / t,
    duration: $a(n)
  };
}
const ti = (e, t, a) => e + (t - e) * a;
function wh(e, t) {
  const a = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const n = sc(0, t, r);
    e.push(ti(a, 1, n));
  }
}
function vh(e) {
  const t = [0];
  return wh(t, e.length - 1), t;
}
const Bt = (e) => !!(e && e.getVelocity);
function zb(e, t, a) {
  var r;
  if (e instanceof Element)
    return [e];
  if (typeof e == "string") {
    let n = document;
    const o = (r = a == null ? void 0 : a[e]) !== null && r !== void 0 ? r : n.querySelectorAll(e);
    return o ? Array.from(o) : [];
  }
  return Array.from(e);
}
function nd(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function bh(e, t, a, r) {
  return typeof e == "string" && nd(t) ? zb(e, a, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e];
}
function ic(e) {
  return typeof e == "function";
}
function Of(e, t, a, r) {
  var n;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? a : (n = r.get(t)) !== null && n !== void 0 ? n : e;
}
const Sb = (e, t, a) => {
  const r = t - e;
  return ((a - e) % r + r) % r + e;
}, kh = (e) => Array.isArray(e) && typeof e[0] != "number";
function Cb(e, t) {
  return kh(e) ? e[Sb(0, e.length, t)] : e;
}
function Eb(e, t, a) {
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    n.at > t && n.at < a && (ph(e, n), r--);
  }
}
function Ab(e, t, a, r, n, o) {
  Eb(e, n, o);
  for (let s = 0; s < t.length; s++)
    e.push({
      value: t[s],
      at: ti(n, o, r[s]),
      easing: Cb(a, s)
    });
}
function Tb(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const Pb = "easeInOut";
function Ob(e, { defaultTransition: t = {}, ...a } = {}, r, n) {
  const o = t.duration || 0.3, s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = {}, u = /* @__PURE__ */ new Map();
  let f = 0, p = 0, c = 0;
  for (let h = 0; h < e.length; h++) {
    const g = e[h];
    if (typeof g == "string") {
      u.set(g, p);
      continue;
    } else if (!Array.isArray(g)) {
      u.set(g.name, Of(p, g.at, f, u));
      continue;
    }
    let [_, b, m = {}] = g;
    m.at !== void 0 && (p = Of(p, m.at, f, u));
    let w = 0;
    const S = (C, v, y, k = 0, x = 0) => {
      const T = Mb(C), { delay: F = 0, times: P = vh(T), type: O = "keyframes", ...I } = v;
      let { ease: E = t.ease || "easeOut", duration: N } = v;
      const H = typeof F == "function" ? F(k, x) : F, Y = T.length, V = ic(O) ? O : n == null ? void 0 : n[O];
      if (Y <= 2 && V) {
        let G = 100;
        if (Y === 2 && jb(T)) {
          const ae = T[1] - T[0];
          G = Math.abs(ae);
        }
        const J = { ...I };
        N !== void 0 && (J.duration = Oa(N));
        const te = xb(J, G, V);
        E = te.ease, N = te.duration;
      }
      N ?? (N = o);
      const U = p + H, ee = U + N;
      P.length === 1 && P[0] === 0 && (P[1] = 1);
      const W = P.length - T.length;
      W > 0 && wh(P, W), T.length === 1 && T.unshift(null), Ab(y, T, E, P, U, ee), w = Math.max(H + N, w), c = Math.max(ee, c);
    };
    if (Bt(_)) {
      const C = Mf(_, i);
      S(b, m, If("default", C));
    } else {
      const C = bh(_, b, r, l), v = C.length;
      for (let y = 0; y < v; y++) {
        b = b, m = m;
        const k = C[y], x = Mf(k, i);
        for (const T in b)
          S(b[T], Ib(m, T), If(T, x), y, v);
      }
    }
    f = p, p += w;
  }
  return i.forEach((h, g) => {
    for (const _ in h) {
      const b = h[_];
      b.sort(Tb);
      const m = [], w = [], S = [];
      for (let v = 0; v < b.length; v++) {
        const { at: y, value: k, easing: x } = b[v];
        m.push(k), w.push(sc(0, c, y)), S.push(x || "easeOut");
      }
      w[0] !== 0 && (w.unshift(0), m.unshift(m[0]), S.unshift(Pb)), w[w.length - 1] !== 1 && (w.push(1), m.push(null)), s.has(g) || s.set(g, {
        keyframes: {},
        transition: {}
      });
      const C = s.get(g);
      C.keyframes[_] = m, C.transition[_] = {
        ...t,
        duration: c,
        ease: S,
        times: w,
        ...a
      };
    }
  }), s;
}
function Mf(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function If(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function Mb(e) {
  return Array.isArray(e) ? e : [e];
}
function Ib(e, t) {
  return e && e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const Fb = (e) => typeof e == "number", jb = (e) => e.every(Fb), eo = /* @__PURE__ */ new WeakMap(), ai = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], cn = new Set(ai), Rb = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Lb = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Db = {
  type: "keyframes",
  duration: 0.8
}, Nb = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Vb = (e, { keyframes: t }) => t.length > 2 ? Db : cn.has(e) ? e.startsWith("scale") ? Lb(t[1]) : Rb : Nb;
function xh(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const qb = (e) => e !== null;
function lc(e, { repeat: t, repeatType: a = "loop" }, r) {
  const n = e.filter(qb), o = t && a !== "loop" && t % 2 === 1 ? 0 : n.length - 1;
  return !o || r === void 0 ? n[o] : r;
}
const zh = (e, t, a) => (((1 - 3 * a + 3 * t) * e + (3 * a - 6 * t)) * e + 3 * t) * e, Bb = 1e-7, Wb = 12;
function Hb(e, t, a, r, n) {
  let o, s, i = 0;
  do
    s = t + (a - t) / 2, o = zh(s, r, n) - e, o > 0 ? a = s : t = s;
  while (Math.abs(o) > Bb && ++i < Wb);
  return s;
}
function an(e, t, a, r) {
  if (e === t && a === r)
    return Cr;
  const n = (o) => Hb(o, 0, 1, e, a);
  return (o) => o === 0 || o === 1 ? o : zh(n(o), t, r);
}
const Sh = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Ch = (e) => (t) => 1 - e(1 - t), Eh = /* @__PURE__ */ an(0.33, 1.53, 0.69, 0.99), od = /* @__PURE__ */ Ch(Eh), Ah = /* @__PURE__ */ Sh(od), Th = (e) => (e *= 2) < 1 ? 0.5 * od(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), sd = (e) => 1 - Math.sin(Math.acos(e)), Ub = Ch(sd), Ph = Sh(sd), Oh = (e) => /^0[^.\s]+$/u.test(e);
function Gb(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Oh(e) : !0;
}
const Mh = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Ih = (e) => (t) => typeof t == "string" && t.startsWith(e), Fh = /* @__PURE__ */ Ih("--"), Kb = /* @__PURE__ */ Ih("var(--"), id = (e) => Kb(e) ? Zb.test(e.split("/*")[0].trim()) : !1, Zb = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Yb = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Xb(e) {
  const t = Yb.exec(e);
  if (!t)
    return [,];
  const [, a, r, n] = t;
  return [`--${a ?? r}`, n];
}
const Jb = 4;
function jh(e, t, a = 1) {
  en(a <= Jb, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, n] = Xb(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const s = o.trim();
    return Mh(s) ? parseFloat(s) : s;
  }
  return id(n) ? jh(n, t, a + 1) : n;
}
const fo = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, qo = {
  ...fo,
  transform: (e) => tn(0, 1, e)
}, wi = {
  ...fo,
  default: 1
}, ri = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ur = /* @__PURE__ */ ri("deg"), En = /* @__PURE__ */ ri("%"), Le = /* @__PURE__ */ ri("px"), Qb = /* @__PURE__ */ ri("vh"), $b = /* @__PURE__ */ ri("vw"), Ff = {
  ...En,
  parse: (e) => En.parse(e) / 100,
  transform: (e) => En.transform(e * 100)
}, ek = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), jf = (e) => e === fo || e === Le, Rf = (e, t) => parseFloat(e.split(", ")[t]), Lf = (e, t) => (a, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const n = r.match(/^matrix3d\((.+)\)$/u);
  if (n)
    return Rf(n[1], t);
  {
    const o = r.match(/^matrix\((.+)\)$/u);
    return o ? Rf(o[1], e) : 0;
  }
}, tk = /* @__PURE__ */ new Set(["x", "y", "z"]), ak = ai.filter((e) => !tk.has(e));
function rk(e) {
  const t = [];
  return ak.forEach((a) => {
    const r = e.getValue(a);
    r !== void 0 && (t.push([a, r.get()]), r.set(a.startsWith("scale") ? 1 : 0));
  }), t;
}
const to = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: a = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(a),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: a = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(a),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Lf(4, 13),
  y: Lf(5, 14)
};
to.translateX = to.x;
to.translateY = to.y;
const Rh = (e) => (t) => t.test(e), nk = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Lh = [fo, Le, En, ur, $b, Qb, nk], Df = (e) => Lh.find(Rh(e)), Xr = /* @__PURE__ */ new Set();
let lu = !1, cu = !1;
function Dh() {
  if (cu) {
    const e = Array.from(Xr).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), a = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const n = rk(r);
      n.length && (a.set(r, n), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const n = a.get(r);
      n && n.forEach(([o, s]) => {
        var i;
        (i = r.getValue(o)) === null || i === void 0 || i.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  cu = !1, lu = !1, Xr.forEach((e) => e.complete()), Xr.clear();
}
function Nh() {
  Xr.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (cu = !0);
  });
}
function ok() {
  Nh(), Dh();
}
class ld {
  constructor(t, a, r, n, o, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = a, this.name = r, this.motionValue = n, this.element = o, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Xr.add(this), lu || (lu = !0, er.read(Nh), er.resolveKeyframes(Dh))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: a, element: r, motionValue: n } = this;
    for (let o = 0; o < t.length; o++)
      if (t[o] === null)
        if (o === 0) {
          const s = n == null ? void 0 : n.get(), i = t[t.length - 1];
          if (s !== void 0)
            t[0] = s;
          else if (r && a) {
            const l = r.readValue(a, i);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = i), n && s === void 0 && n.set(t[0]);
        } else
          t[o] = t[o - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Xr.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Xr.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Mo = (e) => Math.round(e * 1e5) / 1e5, cd = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function sk(e) {
  return e == null;
}
const ik = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, ud = (e, t) => (a) => !!(typeof a == "string" && ik.test(a) && a.startsWith(e) || t && !sk(a) && Object.prototype.hasOwnProperty.call(a, t)), Vh = (e, t, a) => (r) => {
  if (typeof r != "string")
    return r;
  const [n, o, s, i] = r.match(cd);
  return {
    [e]: parseFloat(n),
    [t]: parseFloat(o),
    [a]: parseFloat(s),
    alpha: i !== void 0 ? parseFloat(i) : 1
  };
}, lk = (e) => tn(0, 255, e), Oc = {
  ...fo,
  transform: (e) => Math.round(lk(e))
}, Hr = {
  test: /* @__PURE__ */ ud("rgb", "red"),
  parse: /* @__PURE__ */ Vh("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: a, alpha: r = 1 }) => "rgba(" + Oc.transform(e) + ", " + Oc.transform(t) + ", " + Oc.transform(a) + ", " + Mo(qo.transform(r)) + ")"
};
function ck(e) {
  let t = "", a = "", r = "", n = "";
  return e.length > 5 ? (t = e.substring(1, 3), a = e.substring(3, 5), r = e.substring(5, 7), n = e.substring(7, 9)) : (t = e.substring(1, 2), a = e.substring(2, 3), r = e.substring(3, 4), n = e.substring(4, 5), t += t, a += a, r += r, n += n), {
    red: parseInt(t, 16),
    green: parseInt(a, 16),
    blue: parseInt(r, 16),
    alpha: n ? parseInt(n, 16) / 255 : 1
  };
}
const uu = {
  test: /* @__PURE__ */ ud("#"),
  parse: ck,
  transform: Hr.transform
}, zn = {
  test: /* @__PURE__ */ ud("hsl", "hue"),
  parse: /* @__PURE__ */ Vh("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: a, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + En.transform(Mo(t)) + ", " + En.transform(Mo(a)) + ", " + Mo(qo.transform(r)) + ")"
}, jt = {
  test: (e) => Hr.test(e) || uu.test(e) || zn.test(e),
  parse: (e) => Hr.test(e) ? Hr.parse(e) : zn.test(e) ? zn.parse(e) : uu.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Hr.transform(e) : zn.transform(e)
}, uk = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function dk(e) {
  var t, a;
  return isNaN(e) && typeof e == "string" && (((t = e.match(cd)) === null || t === void 0 ? void 0 : t.length) || 0) + (((a = e.match(uk)) === null || a === void 0 ? void 0 : a.length) || 0) > 0;
}
const qh = "number", Bh = "color", fk = "var", pk = "var(", Nf = "${}", yk = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Bo(e) {
  const t = e.toString(), a = [], r = {
    color: [],
    number: [],
    var: []
  }, n = [];
  let o = 0;
  const i = t.replace(yk, (l) => (jt.test(l) ? (r.color.push(o), n.push(Bh), a.push(jt.parse(l))) : l.startsWith(pk) ? (r.var.push(o), n.push(fk), a.push(l)) : (r.number.push(o), n.push(qh), a.push(parseFloat(l))), ++o, Nf)).split(Nf);
  return { values: a, split: i, indexes: r, types: n };
}
function Wh(e) {
  return Bo(e).values;
}
function Hh(e) {
  const { split: t, types: a } = Bo(e), r = t.length;
  return (n) => {
    let o = "";
    for (let s = 0; s < r; s++)
      if (o += t[s], n[s] !== void 0) {
        const i = a[s];
        i === qh ? o += Mo(n[s]) : i === Bh ? o += jt.transform(n[s]) : o += n[s];
      }
    return o;
  };
}
const hk = (e) => typeof e == "number" ? 0 : e;
function gk(e) {
  const t = Wh(e);
  return Hh(e)(t.map(hk));
}
const po = {
  test: dk,
  parse: Wh,
  createTransformer: Hh,
  getAnimatableNone: gk
}, mk = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function _k(e) {
  const [t, a] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = a.match(cd) || [];
  if (!r)
    return e;
  const n = a.replace(r, "");
  let o = mk.has(t) ? 1 : 0;
  return r !== a && (o *= 100), t + "(" + o + n + ")";
}
const wk = /\b([a-z-]*)\(.*?\)/gu, du = {
  ...po,
  getAnimatableNone: (e) => {
    const t = e.match(wk);
    return t ? t.map(_k).join(" ") : e;
  }
}, vk = {
  // Border props
  borderWidth: Le,
  borderTopWidth: Le,
  borderRightWidth: Le,
  borderBottomWidth: Le,
  borderLeftWidth: Le,
  borderRadius: Le,
  radius: Le,
  borderTopLeftRadius: Le,
  borderTopRightRadius: Le,
  borderBottomRightRadius: Le,
  borderBottomLeftRadius: Le,
  // Positioning props
  width: Le,
  maxWidth: Le,
  height: Le,
  maxHeight: Le,
  top: Le,
  right: Le,
  bottom: Le,
  left: Le,
  // Spacing props
  padding: Le,
  paddingTop: Le,
  paddingRight: Le,
  paddingBottom: Le,
  paddingLeft: Le,
  margin: Le,
  marginTop: Le,
  marginRight: Le,
  marginBottom: Le,
  marginLeft: Le,
  // Misc
  backgroundPositionX: Le,
  backgroundPositionY: Le
}, bk = {
  rotate: ur,
  rotateX: ur,
  rotateY: ur,
  rotateZ: ur,
  scale: wi,
  scaleX: wi,
  scaleY: wi,
  scaleZ: wi,
  skew: ur,
  skewX: ur,
  skewY: ur,
  distance: Le,
  translateX: Le,
  translateY: Le,
  translateZ: Le,
  x: Le,
  y: Le,
  z: Le,
  perspective: Le,
  transformPerspective: Le,
  opacity: qo,
  originX: Ff,
  originY: Ff,
  originZ: Le
}, Vf = {
  ...fo,
  transform: Math.round
}, dd = {
  ...vk,
  ...bk,
  zIndex: Vf,
  size: Le,
  // SVG
  fillOpacity: qo,
  strokeOpacity: qo,
  numOctaves: Vf
}, kk = {
  ...dd,
  // Color props
  color: jt,
  backgroundColor: jt,
  outlineColor: jt,
  fill: jt,
  stroke: jt,
  // Border props
  borderColor: jt,
  borderTopColor: jt,
  borderRightColor: jt,
  borderBottomColor: jt,
  borderLeftColor: jt,
  filter: du,
  WebkitFilter: du
}, fd = (e) => kk[e];
function Uh(e, t) {
  let a = fd(e);
  return a !== du && (a = po), a.getAnimatableNone ? a.getAnimatableNone(t) : void 0;
}
const xk = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function zk(e, t, a) {
  let r = 0, n;
  for (; r < e.length && !n; ) {
    const o = e[r];
    typeof o == "string" && !xk.has(o) && Bo(o).values.length && (n = e[r]), r++;
  }
  if (n && a)
    for (const o of t)
      e[o] = Uh(a, n);
}
class Gh extends ld {
  constructor(t, a, r, n, o) {
    super(t, a, r, n, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: a, name: r } = this;
    if (!a || !a.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let u = t[l];
      if (typeof u == "string" && (u = u.trim(), id(u))) {
        const f = jh(u, a.current);
        f !== void 0 && (t[l] = f), l === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !ek.has(r) || t.length !== 2)
      return;
    const [n, o] = t, s = Df(n), i = Df(o);
    if (s !== i)
      if (jf(s) && jf(i))
        for (let l = 0; l < t.length; l++) {
          const u = t[l];
          typeof u == "string" && (t[l] = parseFloat(u));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: a } = this, r = [];
    for (let n = 0; n < t.length; n++)
      Gb(t[n]) && r.push(n);
    r.length && zk(t, r, a);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: a, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = to[r](t.measureViewportBox(), window.getComputedStyle(t.current)), a[0] = this.measuredOrigin;
    const n = a[a.length - 1];
    n !== void 0 && t.getValue(r, n).jump(n, !1);
  }
  measureEndState() {
    var t;
    const { element: a, name: r, unresolvedKeyframes: n } = this;
    if (!a || !a.current)
      return;
    const o = a.getValue(r);
    o && o.jump(this.measuredOrigin, !1);
    const s = n.length - 1, i = n[s];
    n[s] = to[r](a.measureViewportBox(), window.getComputedStyle(a.current)), i !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = i), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, u]) => {
      a.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
const qf = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(po.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function Sk(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let a = 0; a < e.length; a++)
    if (e[a] !== t)
      return !0;
}
function Ck(e, t, a, r) {
  const n = e[0];
  if (n === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], s = qf(n, t), i = qf(o, t);
  return ei(s === i, `You are trying to animate ${t} from "${n}" to "${o}". ${n} is not an animatable value - to enable this animation set ${n} to a value animatable to ${o} via the \`style\` property.`), !s || !i ? !1 : Sk(e) || (a === "spring" || ic(a)) && r;
}
const Ek = 40;
class Kh {
  constructor({ autoplay: t = !0, delay: a = 0, type: r = "keyframes", repeat: n = 0, repeatDelay: o = 0, repeatType: s = "loop", ...i }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = kr.now(), this.options = {
      autoplay: t,
      delay: a,
      type: r,
      repeat: n,
      repeatDelay: o,
      repeatType: s,
      ...i
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > Ek ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && ok(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, a) {
    this.resolvedAt = kr.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: n, velocity: o, delay: s, onComplete: i, onUpdate: l, isGenerator: u } = this.options;
    if (!u && !Ck(t, r, n, o))
      if (s)
        this.options.duration = 0;
      else {
        l == null || l(lc(t, this.options, a)), i == null || i(), this.resolveFinishedPromise();
        return;
      }
    const f = this.initPlayback(t, a);
    f !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: a,
      ...f
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, a) {
    return this.currentFinishedPromise.then(t, a);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function Bf({ keyframes: e, velocity: t = 0, power: a = 0.8, timeConstant: r = 325, bounceDamping: n = 10, bounceStiffness: o = 500, modifyTarget: s, min: i, max: l, restDelta: u = 0.5, restSpeed: f }) {
  const p = e[0], c = {
    done: !1,
    value: p
  }, h = (x) => i !== void 0 && x < i || l !== void 0 && x > l, g = (x) => i === void 0 ? l : l === void 0 || Math.abs(i - x) < Math.abs(l - x) ? i : l;
  let _ = a * t;
  const b = p + _, m = s === void 0 ? b : s(b);
  m !== b && (_ = m - p);
  const w = (x) => -_ * Math.exp(-x / r), S = (x) => m + w(x), C = (x) => {
    const T = w(x), F = S(x);
    c.done = Math.abs(T) <= u, c.value = c.done ? m : F;
  };
  let v, y;
  const k = (x) => {
    h(c.value) && (v = x, y = rd({
      keyframes: [c.value, g(c.value)],
      velocity: _h(S, x, c.value),
      // TODO: This should be passing * 1000
      damping: n,
      stiffness: o,
      restDelta: u,
      restSpeed: f
    }));
  };
  return k(0), {
    calculatedDuration: null,
    next: (x) => {
      let T = !1;
      return !y && v === void 0 && (T = !0, C(x), k(x)), v !== void 0 && x >= v ? y.next(x - v) : (!T && C(x), c);
    }
  };
}
const Ak = /* @__PURE__ */ an(0.42, 0, 1, 1), Tk = /* @__PURE__ */ an(0, 0, 0.58, 1), Zh = /* @__PURE__ */ an(0.42, 0, 0.58, 1), pd = (e) => Array.isArray(e) && typeof e[0] == "number", Wf = {
  linear: Cr,
  easeIn: Ak,
  easeInOut: Zh,
  easeOut: Tk,
  circIn: sd,
  circInOut: Ph,
  circOut: Ub,
  backIn: od,
  backInOut: Ah,
  backOut: Eh,
  anticipate: Th
}, Hf = (e) => {
  if (pd(e)) {
    en(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, a, r, n] = e;
    return an(t, a, r, n);
  } else if (typeof e == "string")
    return en(Wf[e] !== void 0, `Invalid easing type '${e}'`), Wf[e];
  return e;
}, Pk = (e, t) => (a) => t(e(a)), yd = (...e) => e.reduce(Pk);
function Mc(e, t, a) {
  return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? e + (t - e) * 6 * a : a < 1 / 2 ? t : a < 2 / 3 ? e + (t - e) * (2 / 3 - a) * 6 : e;
}
function Ok({ hue: e, saturation: t, lightness: a, alpha: r }) {
  e /= 360, t /= 100, a /= 100;
  let n = 0, o = 0, s = 0;
  if (!t)
    n = o = s = a;
  else {
    const i = a < 0.5 ? a * (1 + t) : a + t - a * t, l = 2 * a - i;
    n = Mc(l, i, e + 1 / 3), o = Mc(l, i, e), s = Mc(l, i, e - 1 / 3);
  }
  return {
    red: Math.round(n * 255),
    green: Math.round(o * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Ki(e, t) {
  return (a) => a > 0 ? t : e;
}
const Ic = (e, t, a) => {
  const r = e * e, n = a * (t * t - r) + r;
  return n < 0 ? 0 : Math.sqrt(n);
}, Mk = [uu, Hr, zn], Ik = (e) => Mk.find((t) => t.test(e));
function Uf(e) {
  const t = Ik(e);
  if (ei(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let a = t.parse(e);
  return t === zn && (a = Ok(a)), a;
}
const Gf = (e, t) => {
  const a = Uf(e), r = Uf(t);
  if (!a || !r)
    return Ki(e, t);
  const n = { ...a };
  return (o) => (n.red = Ic(a.red, r.red, o), n.green = Ic(a.green, r.green, o), n.blue = Ic(a.blue, r.blue, o), n.alpha = ti(a.alpha, r.alpha, o), Hr.transform(n));
}, fu = /* @__PURE__ */ new Set(["none", "hidden"]);
function Fk(e, t) {
  return fu.has(e) ? (a) => a <= 0 ? e : t : (a) => a >= 1 ? t : e;
}
function jk(e, t) {
  return (a) => ti(e, t, a);
}
function hd(e) {
  return typeof e == "number" ? jk : typeof e == "string" ? id(e) ? Ki : jt.test(e) ? Gf : Dk : Array.isArray(e) ? Yh : typeof e == "object" ? jt.test(e) ? Gf : Rk : Ki;
}
function Yh(e, t) {
  const a = [...e], r = a.length, n = e.map((o, s) => hd(o)(o, t[s]));
  return (o) => {
    for (let s = 0; s < r; s++)
      a[s] = n[s](o);
    return a;
  };
}
function Rk(e, t) {
  const a = { ...e, ...t }, r = {};
  for (const n in a)
    e[n] !== void 0 && t[n] !== void 0 && (r[n] = hd(e[n])(e[n], t[n]));
  return (n) => {
    for (const o in r)
      a[o] = r[o](n);
    return a;
  };
}
function Lk(e, t) {
  var a;
  const r = [], n = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const s = t.types[o], i = e.indexes[s][n[s]], l = (a = e.values[i]) !== null && a !== void 0 ? a : 0;
    r[o] = l, n[s]++;
  }
  return r;
}
const Dk = (e, t) => {
  const a = po.createTransformer(t), r = Bo(e), n = Bo(t);
  return r.indexes.var.length === n.indexes.var.length && r.indexes.color.length === n.indexes.color.length && r.indexes.number.length >= n.indexes.number.length ? fu.has(e) && !n.values.length || fu.has(t) && !r.values.length ? Fk(e, t) : yd(Yh(Lk(r, n), n.values), a) : (ei(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Ki(e, t));
};
function Xh(e, t, a) {
  return typeof e == "number" && typeof t == "number" && typeof a == "number" ? ti(e, t, a) : hd(e)(e, t);
}
function Nk(e, t, a) {
  const r = [], n = a || Xh, o = e.length - 1;
  for (let s = 0; s < o; s++) {
    let i = n(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || Cr : t;
      i = yd(l, i);
    }
    r.push(i);
  }
  return r;
}
function Vk(e, t, { clamp: a = !0, ease: r, mixer: n } = {}) {
  const o = e.length;
  if (en(o === t.length, "Both input and output ranges must be the same length"), o === 1)
    return () => t[0];
  if (o === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = Nk(t, r, n), i = s.length, l = (u) => {
    let f = 0;
    if (i > 1)
      for (; f < e.length - 2 && !(u < e[f + 1]); f++)
        ;
    const p = sc(e[f], e[f + 1], u);
    return s[f](p);
  };
  return a ? (u) => l(tn(e[0], e[o - 1], u)) : l;
}
function qk(e, t) {
  return e.map((a) => a * t);
}
function Bk(e, t) {
  return e.map(() => t || Zh).splice(0, e.length - 1);
}
function Zi({ duration: e = 300, keyframes: t, times: a, ease: r = "easeInOut" }) {
  const n = kh(r) ? r.map(Hf) : Hf(r), o = {
    done: !1,
    value: t[0]
  }, s = qk(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    a && a.length === t.length ? a : vh(t),
    e
  ), i = Vk(s, t, {
    ease: Array.isArray(n) ? n : Bk(t, n)
  });
  return {
    calculatedDuration: e,
    next: (l) => (o.value = i(l), o.done = l >= e, o)
  };
}
const Wk = (e) => {
  const t = ({ timestamp: a }) => e(a);
  return {
    start: () => er.update(t, !0),
    stop: () => su(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ui.isProcessing ? Ui.timestamp : kr.now()
  };
};
var Hk = {};
const Uk = {
  decay: Bf,
  inertia: Bf,
  tween: Zi,
  keyframes: Zi,
  spring: rd
}, Gk = (e) => e / 100;
class gd extends Kh {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: a, motionValue: r, element: n, keyframes: o } = this.options, s = (n == null ? void 0 : n.KeyframeResolver) || ld, i = (l, u) => this.onKeyframesResolved(l, u);
    this.resolver = new s(o, i, a, r, n), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: a = "keyframes", repeat: r = 0, repeatDelay: n = 0, repeatType: o, velocity: s = 0 } = this.options, i = ic(a) ? a : Uk[a] || Zi;
    let l, u;
    i !== Zi && typeof t[0] != "number" && (Hk.NODE_ENV !== "production" && en(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = yd(Gk, Xh(t[0], t[1])), t = [0, 100]);
    const f = i({ ...this.options, keyframes: t });
    o === "mirror" && (u = i({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -s
    })), f.calculatedDuration === null && (f.calculatedDuration = ad(f));
    const { calculatedDuration: p } = f, c = p + n, h = c * (r + 1) - n;
    return {
      generator: f,
      mirroredGenerator: u,
      mapPercentToKeyframes: l,
      calculatedDuration: p,
      resolvedDuration: c,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, a = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: x } = this.options;
      return { done: !0, value: x[x.length - 1] };
    }
    const { finalKeyframe: n, generator: o, mirroredGenerator: s, mapPercentToKeyframes: i, keyframes: l, calculatedDuration: u, totalDuration: f, resolvedDuration: p } = r;
    if (this.startTime === null)
      return o.next(0);
    const { delay: c, repeat: h, repeatType: g, repeatDelay: _, onUpdate: b } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - f / this.speed, this.startTime)), a ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const m = this.currentTime - c * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? m < 0 : m > f;
    this.currentTime = Math.max(m, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = f);
    let S = this.currentTime, C = o;
    if (h) {
      const x = Math.min(this.currentTime, f) / p;
      let T = Math.floor(x), F = x % 1;
      !F && x >= 1 && (F = 1), F === 1 && T--, T = Math.min(T, h + 1), !!(T % 2) && (g === "reverse" ? (F = 1 - F, _ && (F -= _ / p)) : g === "mirror" && (C = s)), S = tn(0, 1, F) * p;
    }
    const v = w ? { done: !1, value: l[0] } : C.next(S);
    i && (v.value = i(v.value));
    let { done: y } = v;
    !w && u !== null && (y = this.speed >= 0 ? this.currentTime >= f : this.currentTime <= 0);
    const k = this.holdTime === null && (this.state === "finished" || this.state === "running" && y);
    return k && n !== void 0 && (v.value = lc(l, this.options, n)), b && b(v.value), k && this.finish(), v;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? $a(t.calculatedDuration) : 0;
  }
  get time() {
    return $a(this.currentTime);
  }
  set time(t) {
    t = Oa(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const a = this.playbackSpeed !== t;
    this.playbackSpeed = t, a && (this.time = $a(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = Wk, onPlay: a, startTime: r } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), a && a();
    const n = this.driver.now();
    this.holdTime !== null ? this.startTime = n - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = n) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const Kk = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Zk = {
  linearEasing: void 0
};
function Yk(e, t) {
  const a = td(e);
  return () => {
    var r;
    return (r = Zk[t]) !== null && r !== void 0 ? r : a();
  };
}
const Yi = /* @__PURE__ */ Yk(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function Jh(e) {
  return !!(typeof e == "function" && Yi() || !e || typeof e == "string" && (e in pu || Yi()) || pd(e) || Array.isArray(e) && e.every(Jh));
}
const To = ([e, t, a, r]) => `cubic-bezier(${e}, ${t}, ${a}, ${r})`, pu = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ To([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ To([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ To([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ To([0.33, 1.53, 0.69, 0.99])
};
function Qh(e, t) {
  if (e)
    return typeof e == "function" && Yi() ? mh(e, t) : pd(e) ? To(e) : Array.isArray(e) ? e.map((a) => Qh(a, t) || pu.easeOut) : pu[e];
}
function Xk(e, t, a, { delay: r = 0, duration: n = 300, repeat: o = 0, repeatType: s = "loop", ease: i = "easeInOut", times: l } = {}) {
  const u = { [t]: a };
  l && (u.offset = l);
  const f = Qh(i, n);
  return Array.isArray(f) && (u.easing = f), e.animate(u, {
    delay: r,
    duration: n,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
function Kf(e, t) {
  e.timeline = t, e.onfinish = null;
}
const Jk = /* @__PURE__ */ td(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Xi = 10, Qk = 2e4;
function $k(e) {
  return ic(e.type) || e.type === "spring" || !Jh(e.ease);
}
function e0(e, t) {
  const a = new gd({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const n = [];
  let o = 0;
  for (; !r.done && o < Qk; )
    r = a.sample(o), n.push(r.value), o += Xi;
  return {
    times: void 0,
    keyframes: n,
    duration: o - Xi,
    ease: "linear"
  };
}
const $h = {
  anticipate: Th,
  backInOut: Ah,
  circInOut: Ph
};
function t0(e) {
  return e in $h;
}
class Zf extends Kh {
  constructor(t) {
    super(t);
    const { name: a, motionValue: r, element: n, keyframes: o } = this.options;
    this.resolver = new Gh(o, (s, i) => this.onKeyframesResolved(s, i), a, r, n), this.resolver.scheduleResolve();
  }
  initPlayback(t, a) {
    var r;
    let { duration: n = 300, times: o, ease: s, type: i, motionValue: l, name: u, startTime: f } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof s == "string" && Yi() && t0(s) && (s = $h[s]), $k(this.options)) {
      const { onComplete: c, onUpdate: h, motionValue: g, element: _, ...b } = this.options, m = e0(t, b);
      t = m.keyframes, t.length === 1 && (t[1] = t[0]), n = m.duration, o = m.times, s = m.ease, i = "keyframes";
    }
    const p = Xk(l.owner.current, u, t, { ...this.options, duration: n, times: o, ease: s });
    return p.startTime = f ?? this.calcStartTime(), this.pendingTimeline ? (Kf(p, this.pendingTimeline), this.pendingTimeline = void 0) : p.onfinish = () => {
      const { onComplete: c } = this.options;
      l.set(lc(t, this.options, a)), c && c(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: p,
      duration: n,
      times: o,
      type: i,
      ease: s,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: a } = t;
    return $a(a);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: a } = t;
    return $a(a.currentTime || 0);
  }
  set time(t) {
    const { resolved: a } = this;
    if (!a)
      return;
    const { animation: r } = a;
    r.currentTime = Oa(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: a } = t;
    return a.playbackRate;
  }
  set speed(t) {
    const { resolved: a } = this;
    if (!a)
      return;
    const { animation: r } = a;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: a } = t;
    return a.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: a } = t;
    return a.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: a } = this;
      if (!a)
        return Cr;
      const { animation: r } = a;
      Kf(r, t);
    }
    return Cr;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a } = t;
    a.playState === "finished" && this.updateFinishedPromise(), a.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a } = t;
    a.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a, keyframes: r, duration: n, type: o, ease: s, times: i } = t;
    if (a.playState === "idle" || a.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: u, onUpdate: f, onComplete: p, element: c, ...h } = this.options, g = new gd({
        ...h,
        keyframes: r,
        duration: n,
        type: o,
        ease: s,
        times: i,
        isGenerator: !0
      }), _ = Oa(this.time);
      u.setWithVelocity(g.sample(_ - Xi).value, g.sample(_).value, Xi);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: a, name: r, repeatDelay: n, repeatType: o, damping: s, type: i } = t;
    return Jk() && r && Kk.has(r) && a && a.owner && a.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !a.owner.getProps().onUpdate && !n && o !== "mirror" && s !== 0 && i !== "inertia";
  }
}
function a0({ when: e, delay: t, delayChildren: a, staggerChildren: r, staggerDirection: n, repeat: o, repeatType: s, repeatDelay: i, from: l, elapsed: u, ...f }) {
  return !!Object.keys(f).length;
}
const eg = (e, t, a, r = {}, n, o) => (s) => {
  const i = xh(r, e) || {}, l = i.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - Oa(l);
  let f = {
    keyframes: Array.isArray(a) ? a : [null, a],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...i,
    delay: -u,
    onUpdate: (c) => {
      t.set(c), i.onUpdate && i.onUpdate(c);
    },
    onComplete: () => {
      s(), i.onComplete && i.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : n
  };
  a0(i) || (f = {
    ...f,
    ...Vb(e, f)
  }), f.duration && (f.duration = Oa(f.duration)), f.repeatDelay && (f.repeatDelay = Oa(f.repeatDelay)), f.from !== void 0 && (f.keyframes[0] = f.from);
  let p = !1;
  if ((f.type === !1 || f.duration === 0 && !f.repeatDelay) && (f.duration = 0, f.delay === 0 && (p = !0)), p && !o && t.get() !== void 0) {
    const c = lc(f.keyframes, i);
    if (c !== void 0)
      return er.update(() => {
        f.onUpdate(c), f.onComplete();
      }), new gh([]);
  }
  return !o && Zf.supports(f) ? new Zf(f) : new gd(f);
}, r0 = (e) => Array.isArray(e), n0 = (e) => r0(e) ? e[e.length - 1] || 0 : e;
function Yf(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((a, r) => {
    t[0][r] = a.get(), t[1][r] = a.getVelocity();
  }), t;
}
function tg(e, t, a, r) {
  if (typeof t == "function") {
    const [n, o] = Yf(r);
    t = t(a !== void 0 ? a : e.custom, n, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [n, o] = Yf(r);
    t = t(a !== void 0 ? a : e.custom, n, o);
  }
  return t;
}
function o0(e, t, a) {
  const r = e.getProps();
  return tg(r, t, r.custom, e);
}
function s0(e, t, a) {
  e.hasValue(t) ? e.getValue(t).set(a) : e.addValue(t, Vo(a));
}
function i0(e, t) {
  const a = o0(e, t);
  let { transitionEnd: r = {}, transition: n = {}, ...o } = a || {};
  o = { ...o, ...r };
  for (const s in o) {
    const i = n0(o[s]);
    s0(e, s, i);
  }
}
const md = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), l0 = "framerAppearId", c0 = "data-" + md(l0);
function u0(e) {
  return e.props[c0];
}
function d0(e) {
  return !!(Bt(e) && e.add);
}
function f0(e, t) {
  const a = e.getValue("willChange");
  if (d0(a))
    return a.add(t);
}
function p0({ protectedKeys: e, needsAnimating: t }, a) {
  const r = e.hasOwnProperty(a) && t[a] !== !0;
  return t[a] = !1, r;
}
function y0(e, t, { delay: a = 0, transitionOverride: r, type: n } = {}) {
  var o;
  let { transition: s = e.getDefaultTransition(), transitionEnd: i, ...l } = t;
  r && (s = r);
  const u = [], f = n && e.animationState && e.animationState.getState()[n];
  for (const p in l) {
    const c = e.getValue(p, (o = e.latestValues[p]) !== null && o !== void 0 ? o : null), h = l[p];
    if (h === void 0 || f && p0(f, p))
      continue;
    const g = {
      delay: a,
      ...xh(s || {}, p)
    };
    let _ = !1;
    if (window.MotionHandoffAnimation) {
      const m = u0(e);
      if (m) {
        const w = window.MotionHandoffAnimation(m, p, er);
        w !== null && (g.startTime = w, _ = !0);
      }
    }
    f0(e, p), c.start(eg(p, c, h, e.shouldReduceMotion && cn.has(p) ? { type: !1 } : g, e, _));
    const b = c.animation;
    b && u.push(b);
  }
  return i && Promise.all(u).then(() => {
    er.update(() => {
      i && i0(e, i);
    });
  }), u;
}
function h0(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const g0 = {};
function m0(e, { layout: t, layoutId: a }) {
  return cn.has(e) || e.startsWith("origin") || (t || a !== void 0) && (!!g0[e] || e === "opacity");
}
function ag(e, t, a) {
  var r;
  const { style: n } = e, o = {};
  for (const s in n)
    (Bt(n[s]) || t.style && Bt(t.style[s]) || m0(s, e) || ((r = a == null ? void 0 : a.getValue(s)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (o[s] = n[s]);
  return o;
}
function _0(e, t, a) {
  const r = ag(e, t, a);
  for (const n in e)
    if (Bt(e[n]) || Bt(t[n])) {
      const o = ai.indexOf(n) !== -1 ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n;
      r[o] = e[n];
    }
  return r;
}
const w0 = typeof window < "u", yu = { current: null }, rg = { current: !1 };
function v0() {
  if (rg.current = !0, !!w0)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => yu.current = e.matches;
      e.addListener(t), t();
    } else
      yu.current = !1;
}
function b0(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function k0(e) {
  return typeof e == "string" || Array.isArray(e);
}
const x0 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], z0 = ["initial", ...x0];
function ng(e) {
  return b0(e.animate) || z0.some((t) => k0(e[t]));
}
function S0(e) {
  return !!(ng(e) || e.variants);
}
var C0 = {};
function E0(e, t, a) {
  for (const r in t) {
    const n = t[r], o = a[r];
    if (Bt(n))
      e.addValue(r, n), C0.NODE_ENV === "development" && ed(n.version === "11.13.5", `Attempting to mix Motion versions ${n.version} with 11.13.5 may not work as expected.`);
    else if (Bt(o))
      e.addValue(r, Vo(n, { owner: e }));
    else if (o !== n)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(n) : s.hasAnimated || s.set(n);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Vo(s !== void 0 ? s : n, { owner: e }));
      }
  }
  for (const r in a)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Xf = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, hu = {};
for (const e in Xf)
  hu[e] = {
    isEnabled: (t) => Xf[e].some((a) => !!t[a])
  };
const A0 = [...Lh, jt, po], T0 = (e) => A0.find(Rh(e)), Jf = () => ({ min: 0, max: 0 }), _d = () => ({
  x: Jf(),
  y: Jf()
});
var P0 = {};
const Qf = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class og {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, a, r) {
    return {};
  }
  constructor({ parent: t, props: a, presenceContext: r, reducedMotionConfig: n, blockInitialAnimation: o, visualState: s }, i = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = ld, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const c = kr.now();
      this.renderScheduledAt < c && (this.renderScheduledAt = c, er.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = s;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = a.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = a, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = n, this.options = i, this.blockInitialAnimation = !!o, this.isControllingVariants = ng(a), this.isVariantNode = S0(a), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...p } = this.scrapeMotionValuesFromProps(a, {}, this);
    for (const c in p) {
      const h = p[c];
      l[c] !== void 0 && Bt(h) && h.set(l[c], !1);
    }
  }
  mount(t) {
    this.current = t, eo.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((a, r) => this.bindToMotionValue(r, a)), rg.current || v0(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : yu.current, P0.NODE_ENV !== "production" && ed(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    eo.delete(this.current), this.projection && this.projection.unmount(), su(this.notifyUpdate), su(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const a = this.features[t];
      a && (a.unmount(), a.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, a) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = cn.has(t), n = a.on("change", (i) => {
      this.latestValues[t] = i, this.props.onUpdate && er.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = a.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, a)), this.valueSubscriptions.set(t, () => {
      n(), o(), s && s(), a.owner && a.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in hu) {
      const a = hu[t];
      if (!a)
        continue;
      const { isEnabled: r, Feature: n } = a;
      if (!this.features[t] && n && r(this.props) && (this.features[t] = new n(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : _d();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, a) {
    this.latestValues[t] = a;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, a) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = a;
    for (let r = 0; r < Qf.length; r++) {
      const n = Qf[r];
      this.propEventSubscriptions[n] && (this.propEventSubscriptions[n](), delete this.propEventSubscriptions[n]);
      const o = "on" + n, s = t[o];
      s && (this.propEventSubscriptions[n] = this.on(n, s));
    }
    this.prevMotionValues = E0(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const a = this.getClosestVariantNode();
    if (a)
      return a.variantChildren && a.variantChildren.add(t), () => a.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, a) {
    const r = this.values.get(t);
    a !== r && (r && this.removeValue(t), this.bindToMotionValue(t, a), this.values.set(t, a), this.latestValues[t] = a.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const a = this.valueSubscriptions.get(t);
    a && (a(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, a) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && a !== void 0 && (r = Vo(a === null ? void 0 : a, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, a) {
    var r;
    let n = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return n != null && (typeof n == "string" && (Mh(n) || Oh(n)) ? n = parseFloat(n) : !T0(n) && po.test(a) && (n = Uh(t, a)), this.setBaseTarget(t, Bt(n) ? n.get() : n)), Bt(n) ? n.get() : n;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, a) {
    this.baseTarget[t] = a;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: r } = this.props;
    let n;
    if (typeof r == "string" || typeof r == "object") {
      const s = tg(this.props, r, (a = this.presenceContext) === null || a === void 0 ? void 0 : a.custom);
      s && (n = s[t]);
    }
    if (r && n !== void 0)
      return n;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !Bt(o) ? o : this.initialValues[t] !== void 0 && n === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, a) {
    return this.events[t] || (this.events[t] = new yh()), this.events[t].add(a);
  }
  notify(t, ...a) {
    this.events[t] && this.events[t].notify(...a);
  }
}
class sg extends og {
  constructor() {
    super(...arguments), this.KeyframeResolver = Gh;
  }
  sortInstanceNodePosition(t, a) {
    return t.compareDocumentPosition(a) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, a) {
    return t.style ? t.style[a] : void 0;
  }
  removeValueFromRenderState(t, { vars: a, style: r }) {
    delete a[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Bt(t) && (this.childSubscription = t.on("change", (a) => {
      this.current && (this.current.textContent = `${a}`);
    }));
  }
}
const ig = (e, t) => t && typeof e == "number" ? t.transform(e) : e, O0 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, M0 = ai.length;
function I0(e, t, a) {
  let r = "", n = !0;
  for (let o = 0; o < M0; o++) {
    const s = ai[o], i = e[s];
    if (i === void 0)
      continue;
    let l = !0;
    if (typeof i == "number" ? l = i === (s.startsWith("scale") ? 1 : 0) : l = parseFloat(i) === 0, !l || a) {
      const u = ig(i, dd[s]);
      if (!l) {
        n = !1;
        const f = O0[s] || s;
        r += `${f}(${u}) `;
      }
      a && (t[s] = u);
    }
  }
  return r = r.trim(), a ? r = a(t, n ? "" : r) : n && (r = "none"), r;
}
function lg(e, t, a) {
  const { style: r, vars: n, transformOrigin: o } = e;
  let s = !1, i = !1;
  for (const l in t) {
    const u = t[l];
    if (cn.has(l)) {
      s = !0;
      continue;
    } else if (Fh(l)) {
      n[l] = u;
      continue;
    } else {
      const f = ig(u, dd[l]);
      l.startsWith("origin") ? (i = !0, o[l] = f) : r[l] = f;
    }
  }
  if (t.transform || (s || a ? r.transform = I0(t, e.transform, a) : r.transform && (r.transform = "none")), i) {
    const { originX: l = "50%", originY: u = "50%", originZ: f = 0 } = o;
    r.transformOrigin = `${l} ${u} ${f}`;
  }
}
function $f(e, t, a) {
  return typeof e == "string" ? e : Le.transform(t + a * e);
}
function F0(e, t, a) {
  const r = $f(t, e.x, e.width), n = $f(a, e.y, e.height);
  return `${r} ${n}`;
}
const j0 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, R0 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function L0(e, t, a = 1, r = 0, n = !0) {
  e.pathLength = 1;
  const o = n ? j0 : R0;
  e[o.offset] = Le.transform(-r);
  const s = Le.transform(t), i = Le.transform(a);
  e[o.array] = `${s} ${i}`;
}
function D0(e, {
  attrX: t,
  attrY: a,
  attrScale: r,
  originX: n,
  originY: o,
  pathLength: s,
  pathSpacing: i = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, f, p) {
  if (lg(e, u, p), f) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: c, style: h, dimensions: g } = e;
  c.transform && (g && (h.transform = c.transform), delete c.transform), g && (n !== void 0 || o !== void 0 || h.transform) && (h.transformOrigin = F0(g, n !== void 0 ? n : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (c.x = t), a !== void 0 && (c.y = a), r !== void 0 && (c.scale = r), s !== void 0 && L0(c, s, i, l, !1);
}
const cg = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function ug(e, { style: t, vars: a }, r, n) {
  Object.assign(e.style, t, n && n.getProjectionStyles(r));
  for (const o in a)
    e.style.setProperty(o, a[o]);
}
function N0(e, t, a, r) {
  ug(e, t, void 0, r);
  for (const n in t.attrs)
    e.setAttribute(cg.has(n) ? n : md(n), t.attrs[n]);
}
const V0 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
class q0 extends sg {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = _d;
  }
  getBaseTargetFromProps(t, a) {
    return t[a];
  }
  readValueFromInstance(t, a) {
    if (cn.has(a)) {
      const r = fd(a);
      return r && r.default || 0;
    }
    return a = cg.has(a) ? a : md(a), t.getAttribute(a);
  }
  scrapeMotionValuesFromProps(t, a, r) {
    return _0(t, a, r);
  }
  build(t, a, r) {
    D0(t, a, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, a, r, n) {
    N0(t, a, r, n);
  }
  mount(t) {
    this.isSVGTag = V0(t.tagName), super.mount(t);
  }
}
function B0({ top: e, left: t, right: a, bottom: r }) {
  return {
    x: { min: t, max: a },
    y: { min: e, max: r }
  };
}
function W0(e, t) {
  if (!t)
    return e;
  const a = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: a.y,
    left: a.x,
    bottom: r.y,
    right: r.x
  };
}
function H0(e, t) {
  return B0(W0(e.getBoundingClientRect(), t));
}
function U0(e) {
  return window.getComputedStyle(e);
}
class G0 extends sg {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = ug;
  }
  readValueFromInstance(t, a) {
    if (cn.has(a)) {
      const r = fd(a);
      return r && r.default || 0;
    } else {
      const r = U0(t), n = (Fh(a) ? r.getPropertyValue(a) : r[a]) || 0;
      return typeof n == "string" ? n.trim() : n;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: a }) {
    return H0(t, a);
  }
  build(t, a, r) {
    lg(t, a, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, a, r) {
    return ag(t, a, r);
  }
}
function K0(e, t) {
  return e in t;
}
class Z0 extends og {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, a) {
    if (K0(a, t)) {
      const r = t[a];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, a) {
    delete a.output[t];
  }
  measureInstanceViewportBox() {
    return _d();
  }
  build(t, a) {
    Object.assign(t.output, a);
  }
  renderInstance(t, { output: a }) {
    Object.assign(t, a);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function Y0(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, a = h0(e) ? new q0(t) : new G0(t);
  a.mount(e), eo.set(e, a);
}
function X0(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, a = new Z0(t);
  a.mount(e), eo.set(e, a);
}
function J0(e, t, a) {
  const r = Bt(e) ? e : Vo(e);
  return r.start(eg("", r, t, a)), r.animation;
}
function Q0(e, t) {
  return Bt(e) || typeof e == "number" || typeof e == "string" && !nd(t);
}
function dg(e, t, a, r) {
  const n = [];
  if (Q0(e, t))
    n.push(J0(e, nd(t) && t.default || t, a && (a.default || a)));
  else {
    const o = bh(e, t, r), s = o.length;
    en(!!s, "No valid elements provided.");
    for (let i = 0; i < s; i++) {
      const l = o[i], u = l instanceof Element ? Y0 : X0;
      eo.has(l) || u(l);
      const f = eo.get(l), p = { ...a };
      "delay" in p && typeof p.delay == "function" && (p.delay = p.delay(i, s)), n.push(...y0(f, { ...t, transition: p }, {}));
    }
  }
  return n;
}
function $0(e, t, a) {
  const r = [];
  return Ob(e, t, a, { spring: rd }).forEach(({ keyframes: o, transition: s }, i) => {
    r.push(...dg(i, o, s));
  }), r;
}
function e1(e) {
  return Array.isArray(e) && Array.isArray(e[0]);
}
function t1(e) {
  function t(a, r, n) {
    let o = [];
    return e1(a) ? o = $0(a, r, e) : o = dg(a, r, n, e), new gh(o);
  }
  return t;
}
const a1 = t1(), Fc = (e, t = {
  startPoint: {
    x: 0,
    y: 0
  },
  options: {
    speed: 400,
    randomness: 0.02
  }
}) => {
  let a;
  const r = async (n, o, s) => {
    if (!o)
      throw e.dispatchEvent(
        new CustomEvent("cursormove", { detail: { success: !1 } })
      ), new Error("targetPoint is required");
    const i = n.x, l = n.y, u = o.x, f = o.y, p = Math.hypot(u - i, f - l), c = 0.5, h = (s == null ? void 0 : s.randomness) ?? 0.02, g = Math.min(p * h, 12), _ = () => (Math.random() - 0.5) * g, b = i + (u - i) * 0.33, m = l + (f - l) * 0.33, w = b + _(), S = m + _(), C = {
      transform: [
        `translate(${i}px, ${l}px)`,
        `translate(${w}px, ${S}px)`,
        `translate(${u}px, ${f}px)`
      ]
    }, v = {
      duration: c,
      easing: "cubic-bezier(0.4, 0.0, 0.2, 1)",
      // Standard easing curve
      ...s
    };
    a = a1(e, C, v), a.then(() => {
      e.dispatchEvent(
        new CustomEvent("cursormove", {
          detail: { success: !0, position: o }
        })
      );
    }).catch((y) => {
      e.dispatchEvent(
        new CustomEvent("cursormove", { detail: { success: !1 } })
      ), console.warn("[Layup] Animation failed:", y);
    });
  };
  return r(t.startPoint, t.targetPoint, t.options), {
    update(n) {
      r(n.startPoint, n.targetPoint, n.options);
    },
    destroy() {
      a == null || a.cancel();
    }
  };
};
function fg(e) {
  var t, a, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = fg(e[t])) && (r && (r += " "), r += a);
  } else for (a in e) e[a] && (r && (r += " "), r += a);
  return r;
}
function pg() {
  for (var e, t, a = 0, r = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = fg(e)) && (r && (r += " "), r += t);
  return r;
}
const wd = "-", r1 = (e) => {
  const t = o1(e), {
    conflictingClassGroups: a,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const i = s.split(wd);
      return i[0] === "" && i.length !== 1 && i.shift(), yg(i, t) || n1(s);
    },
    getConflictingClassGroupIds: (s, i) => {
      const l = a[s] || [];
      return i && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, yg = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const a = e[0], r = t.nextPart.get(a), n = r ? yg(e.slice(1), r) : void 0;
  if (n)
    return n;
  if (t.validators.length === 0)
    return;
  const o = e.join(wd);
  return (s = t.validators.find(({
    validator: i
  }) => i(o))) == null ? void 0 : s.classGroupId;
}, ep = /^\[(.+)\]$/, n1 = (e) => {
  if (ep.test(e)) {
    const t = ep.exec(e)[1], a = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (a)
      return "arbitrary.." + a;
  }
}, o1 = (e) => {
  const {
    theme: t,
    prefix: a
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return i1(Object.entries(e.classGroups), a).forEach(([o, s]) => {
    gu(s, r, o, t);
  }), r;
}, gu = (e, t, a, r) => {
  e.forEach((n) => {
    if (typeof n == "string") {
      const o = n === "" ? t : tp(t, n);
      o.classGroupId = a;
      return;
    }
    if (typeof n == "function") {
      if (s1(n)) {
        gu(n(r), t, a, r);
        return;
      }
      t.validators.push({
        validator: n,
        classGroupId: a
      });
      return;
    }
    Object.entries(n).forEach(([o, s]) => {
      gu(s, tp(t, o), a, r);
    });
  });
}, tp = (e, t) => {
  let a = e;
  return t.split(wd).forEach((r) => {
    a.nextPart.has(r) || a.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), a = a.nextPart.get(r);
  }), a;
}, s1 = (e) => e.isThemeGetter, i1 = (e, t) => t ? e.map(([a, r]) => {
  const n = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([s, i]) => [t + s, i])) : o);
  return [a, n];
}) : e, l1 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const n = (o, s) => {
    a.set(o, s), t++, t > e && (t = 0, r = a, a = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let s = a.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return n(o, s), s;
    },
    set(o, s) {
      a.has(o) ? a.set(o, s) : n(o, s);
    }
  };
}, hg = "!", c1 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: a
  } = e, r = t.length === 1, n = t[0], o = t.length, s = (i) => {
    const l = [];
    let u = 0, f = 0, p;
    for (let b = 0; b < i.length; b++) {
      let m = i[b];
      if (u === 0) {
        if (m === n && (r || i.slice(b, b + o) === t)) {
          l.push(i.slice(f, b)), f = b + o;
          continue;
        }
        if (m === "/") {
          p = b;
          continue;
        }
      }
      m === "[" ? u++ : m === "]" && u--;
    }
    const c = l.length === 0 ? i : i.substring(f), h = c.startsWith(hg), g = h ? c.substring(1) : c, _ = p && p > f ? p - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: _
    };
  };
  return a ? (i) => a({
    className: i,
    parseClassName: s
  }) : s;
}, u1 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let a = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...a.sort(), r), a = []) : a.push(r);
  }), t.push(...a.sort()), t;
}, d1 = (e) => ({
  cache: l1(e.cacheSize),
  parseClassName: c1(e),
  ...r1(e)
}), f1 = /\s+/, p1 = (e, t) => {
  const {
    parseClassName: a,
    getClassGroupId: r,
    getConflictingClassGroupIds: n
  } = t, o = [], s = e.trim().split(f1);
  let i = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const u = s[l], {
      modifiers: f,
      hasImportantModifier: p,
      baseClassName: c,
      maybePostfixModifierPosition: h
    } = a(u);
    let g = !!h, _ = r(g ? c.substring(0, h) : c);
    if (!_) {
      if (!g) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (_ = r(c), !_) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      g = !1;
    }
    const b = u1(f).join(":"), m = p ? b + hg : b, w = m + _;
    if (o.includes(w))
      continue;
    o.push(w);
    const S = n(_, g);
    for (let C = 0; C < S.length; ++C) {
      const v = S[C];
      o.push(m + v);
    }
    i = u + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function y1() {
  let e = 0, t, a, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (a = gg(t)) && (r && (r += " "), r += a);
  return r;
}
const gg = (e) => {
  if (typeof e == "string")
    return e;
  let t, a = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = gg(e[r])) && (a && (a += " "), a += t);
  return a;
};
function mu(e, ...t) {
  let a, r, n, o = s;
  function s(l) {
    const u = t.reduce((f, p) => p(f), e());
    return a = d1(u), r = a.cache.get, n = a.cache.set, o = i, i(l);
  }
  function i(l) {
    const u = r(l);
    if (u)
      return u;
    const f = p1(l, a);
    return n(l, f), f;
  }
  return function() {
    return o(y1.apply(null, arguments));
  };
}
const gt = (e) => {
  const t = (a) => a[e] || [];
  return t.isThemeGetter = !0, t;
}, mg = /^\[(?:([a-z-]+):)?(.+)\]$/i, h1 = /^\d+\/\d+$/, g1 = /* @__PURE__ */ new Set(["px", "full", "screen"]), m1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, _1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, w1 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, v1 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, b1 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Ua = (e) => An(e) || g1.has(e) || h1.test(e), ir = (e) => yo(e, "length", T1), An = (e) => !!e && !Number.isNaN(Number(e)), jc = (e) => yo(e, "number", An), ko = (e) => !!e && Number.isInteger(Number(e)), k1 = (e) => e.endsWith("%") && An(e.slice(0, -1)), We = (e) => mg.test(e), lr = (e) => m1.test(e), x1 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), z1 = (e) => yo(e, x1, _g), S1 = (e) => yo(e, "position", _g), C1 = /* @__PURE__ */ new Set(["image", "url"]), E1 = (e) => yo(e, C1, O1), A1 = (e) => yo(e, "", P1), xo = () => !0, yo = (e, t, a) => {
  const r = mg.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : a(r[2]) : !1;
}, T1 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  _1.test(e) && !w1.test(e)
), _g = () => !1, P1 = (e) => v1.test(e), O1 = (e) => b1.test(e), _u = () => {
  const e = gt("colors"), t = gt("spacing"), a = gt("blur"), r = gt("brightness"), n = gt("borderColor"), o = gt("borderRadius"), s = gt("borderSpacing"), i = gt("borderWidth"), l = gt("contrast"), u = gt("grayscale"), f = gt("hueRotate"), p = gt("invert"), c = gt("gap"), h = gt("gradientColorStops"), g = gt("gradientColorStopPositions"), _ = gt("inset"), b = gt("margin"), m = gt("opacity"), w = gt("padding"), S = gt("saturate"), C = gt("scale"), v = gt("sepia"), y = gt("skew"), k = gt("space"), x = gt("translate"), T = () => ["auto", "contain", "none"], F = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", We, t], O = () => [We, t], I = () => ["", Ua, ir], E = () => ["auto", An, We], N = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], H = () => ["solid", "dashed", "dotted", "double", "none"], Y = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], V = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], U = () => ["", "0", We], ee = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], W = () => [An, We];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [xo],
      spacing: [Ua, ir],
      blur: ["none", "", lr, We],
      brightness: W(),
      borderColor: [e],
      borderRadius: ["none", "", "full", lr, We],
      borderSpacing: O(),
      borderWidth: I(),
      contrast: W(),
      grayscale: U(),
      hueRotate: W(),
      invert: U(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [k1, ir],
      inset: P(),
      margin: P(),
      opacity: W(),
      padding: O(),
      saturate: W(),
      scale: W(),
      sepia: U(),
      skew: W(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", We]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [lr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ee()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ee()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...N(), We]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: F()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": F()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": F()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: T()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": T()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": T()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [_]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [_]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [_]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [_]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [_]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [_]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [_]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [_]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [_]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ko, We]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", We]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: U()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: U()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ko, We]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [xo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ko, We]
        }, We]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": E()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": E()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [xo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ko, We]
        }, We]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": E()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": E()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", We]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", We]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [c]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [c]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [c]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...V()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...V(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...V(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [k]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [k]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", We, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [We, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [We, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [lr]
        }, lr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [We, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [We, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [We, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [We, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", lr, ir]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", jc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [xo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", We]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", An, jc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ua, We]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", We]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", We]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...H(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ua, ir]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ua, We]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", We]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", We]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...N(), S1]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", z1]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, E1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...H(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: H()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [n]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...H()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ua, We]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ua, ir]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: I()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ua, ir]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", lr, A1]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [xo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Y(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Y()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [a]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", lr, We]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [v]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [a]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [v]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", We]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: W()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", We]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: W()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", We]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ko, We]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [x]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [x]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [y]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [y]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", We]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", We]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", We]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ua, ir, jc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, M1 = (e, {
  cacheSize: t,
  prefix: a,
  separator: r,
  experimentalParseClassName: n,
  extend: o = {},
  override: s = {}
}) => {
  Po(e, "cacheSize", t), Po(e, "prefix", a), Po(e, "separator", r), Po(e, "experimentalParseClassName", n);
  for (const i in s)
    I1(e[i], s[i]);
  for (const i in o)
    F1(e[i], o[i]);
  return e;
}, Po = (e, t, a) => {
  a !== void 0 && (e[t] = a);
}, I1 = (e, t) => {
  if (t)
    for (const a in t)
      Po(e, a, t[a]);
}, F1 = (e, t) => {
  if (t)
    for (const a in t) {
      const r = t[a];
      r !== void 0 && (e[a] = (e[a] || []).concat(r));
    }
}, j1 = (e, ...t) => typeof e == "function" ? mu(_u, e, ...t) : mu(() => M1(_u(), e), ...t), wg = /* @__PURE__ */ mu(_u);
function Oe(...e) {
  return wg(pg(e));
}
function R1(e) {
  let t = 0, a = 0, r = 0;
  e.length == 4 ? (t = "0x" + e[1] + e[1], a = "0x" + e[2] + e[2], r = "0x" + e[3] + e[3]) : e.length == 7 && (t = "0x" + e[1] + e[2], a = "0x" + e[3] + e[4], r = "0x" + e[5] + e[6]), t /= 255, a /= 255, r /= 255;
  let n = Math.min(t, a, r), o = Math.max(t, a, r), s = o - n, i = 0, l = 0, u = 0;
  return s == 0 ? i = 0 : o == t ? i = (a - r) / s % 6 : o == a ? i = (r - t) / s + 2 : i = (t - a) / s + 4, i = Math.round(i * 60), i < 0 && (i += 360), u = (o + n) / 2, l = s == 0 ? 0 : s / (1 - Math.abs(2 * u - 1)), l = +(l * 100).toFixed(1), u = +(u * 100).toFixed(1), i + " " + l + "% " + u + "%";
}
const Ii = (e, t) => {
  var r, n, o, s, i, l, u, f, p, c, h, g, _, b, m, w, S, C, v, y, k;
  const a = [
    `--layup-radius-inner: ${e.border_radius.inner}px`,
    `--layup-radius-outer: ${e.border_radius.outer}px`,
    `--layup-radius-button-primary: ${e.border_radius["button-primary"]}px`,
    `--layup-radius-button-secondary: ${e.border_radius["button-secondary"]}px`,
    `--layup-section-gap: ${e.spacing.gap.section}px`,
    `--layup-item-gap: ${e.spacing.gap.item}px`,
    `--layup-width: ${e.spacing.width}px`,
    `--layup-padding-default: ${e.spacing.padding.default}px`,
    `--layup-padding-controller-vertical: ${e.spacing.padding.controller.vertical}px`,
    `--layup-padding-controller-horizontal: ${e.spacing.padding.controller.horizontal}px`,
    `--layup-padding-text-guidance: ${e.spacing.padding.text_guidance}px`,
    `--layup-font-size-dates: ${((r = e.font_sizes) == null ? void 0 : r.dates) || 14}px`,
    `--layup-font-size-items: ${((n = e.font_sizes) == null ? void 0 : n.items) || 16}px`,
    `--layup-font-size-button: ${((o = e.font_sizes) == null ? void 0 : o.button) || 16}px`,
    `--layup-font-size-heading: ${((s = e.font_sizes) == null ? void 0 : s.heading) || 20}px`,
    `--layup-font-size-subheading: ${((i = e.font_sizes) == null ? void 0 : i.subheading) || 16}px`,
    `--layup-font-size-item-description: ${((l = e.font_sizes) == null ? void 0 : l.item_description) || 14}px`,
    `--layup-font-size-label: ${((u = e.font_sizes) == null ? void 0 : u.label) || 14}px`,
    `--layup-font-weight-dates: ${((p = (f = e == null ? void 0 : e.metadata) == null ? void 0 : f.font_weights) == null ? void 0 : p.dates) || 400}`,
    `--layup-font-weight-items: ${((h = (c = e == null ? void 0 : e.metadata) == null ? void 0 : c.font_weights) == null ? void 0 : h.items) || 400}`,
    `--layup-font-weight-button: ${((_ = (g = e == null ? void 0 : e.metadata) == null ? void 0 : g.font_weights) == null ? void 0 : _.button) || 400}`,
    `--layup-font-weight-heading: ${((m = (b = e == null ? void 0 : e.metadata) == null ? void 0 : b.font_weights) == null ? void 0 : m.heading) || 600}`,
    `--layup-font-weight-subheading: ${((S = (w = e == null ? void 0 : e.metadata) == null ? void 0 : w.font_weights) == null ? void 0 : S.subheading) || 400}`,
    `--layup-font-weight-item-description: ${((v = (C = e == null ? void 0 : e.metadata) == null ? void 0 : C.font_weights) == null ? void 0 : v.item_description) || 400}`,
    `--layup-font-weight-label: ${((k = (y = e == null ? void 0 : e.metadata) == null ? void 0 : y.font_weights) == null ? void 0 : k.label) || 400}`
  ];
  return t && Object.entries(t).forEach(([x, T]) => {
    typeof T == "string" && a.push(`--layup-${x}: ${R1(T)}`);
  }), a.join("; ");
}, vg = function(e) {
  return e && (e == null ? void 0 : e.filter((t) => t.state.status === "NotStarted").length) || 0;
}, bg = function(e) {
  var t, a;
  return e ? ((t = e.onboarding_flows) == null ? void 0 : t.length) - ((a = e.onboarding_flows) == null ? void 0 : a.filter((r) => r.state.status === "Completed").length) : 0;
};
function L1(e, t) {
  let a;
  return (...r) => {
    clearTimeout(a), a = setTimeout(() => e(...r), t);
  };
}
var D1 = /* @__PURE__ */ L("<div></div>"), N1 = /* @__PURE__ */ L('<div class="layup-relative layup-h-8 layup-w-8"></div>');
function V1(e, t) {
  ke(t, !1), ca();
  var a = N1();
  et(a, 4, () => [3, 2, 1], yt, (r, n) => {
    var o = D1();
    const s = /* @__PURE__ */ kt(() => Oe("layup-absolute layup-h-8 layup-w-8 layup-animate-bounce-fade layup-rounded-full layup-bg-accent", n === 1 && "layup-delay-0", n === 2 && "layup-delay-300", n === 3 && "layup-delay-600"));
    $(() => Ue(o, d(s))), z(r, o);
  }), z(e, a), xe();
}
var q1 = /* @__PURE__ */ L('<p class="animated-letter layup-text-items !layup-font-items !layup-text-primary dark:!layup-text-primary svelte-pd0xct"> </p>'), B1 = /* @__PURE__ */ L('<p class="word-space svelte-pd0xct">&nbsp;</p>'), W1 = /* @__PURE__ */ L('<p class="word-wrapper svelte-pd0xct"><!><!></p>'), H1 = /* @__PURE__ */ L("<div></div>");
function kg(e, t) {
  var o;
  ke(t, !0);
  let a = [], r = R(t, "intensity", 3, "default");
  Da(() => {
    const s = () => {
      const u = a.filter((c) => {
        var h;
        return c && ((h = c.textContent) == null ? void 0 : h.trim()) !== "";
      }), f = {
        default: {
          letterDelay: 50,
          letterDuration: 300,
          cycleDelay: 200,
          initialOpacity: "0.7",
          initialGlow: "0 0 5px rgba(255, 255, 255, 0.3)",
          peakOpacity: "1",
          peakGlow: "0 0 8px rgba(255, 255, 255, 0.8)"
        },
        subtle: {
          letterDelay: 80,
          letterDuration: 400,
          cycleDelay: 400,
          initialOpacity: "0.8",
          initialGlow: "0 0 2px rgba(255, 255, 255, 0.15)",
          peakOpacity: "1",
          peakGlow: "0 0 4px rgba(255, 255, 255, 0.3)"
        }
      }[r()], p = u.length * f.letterDelay + f.letterDuration;
      return u.forEach((c) => {
        c && (c.style.opacity = f.initialOpacity, c.style.textShadow = f.initialGlow);
      }), u.forEach((c, h) => {
        c && setTimeout(
          () => {
            c.style.opacity = f.peakOpacity, c.style.textShadow = f.peakGlow, setTimeout(
              () => {
                c && (c.style.opacity = f.initialOpacity, c.style.textShadow = f.initialGlow);
              },
              f.letterDuration
            );
          },
          h * f.letterDelay
        );
      }), p + f.cycleDelay;
    };
    let i = s();
    const l = setInterval(
      () => {
        i = s();
      },
      i
    );
    return () => clearInterval(l);
  }), (o = Z == null ? void 0 : Z.config) == null || o.styles;
  var n = H1();
  et(n, 21, () => {
    var s;
    return (s = t.text) == null ? void 0 : s.split(" ");
  }, yt, (s, i, l) => {
    var u = W1(), f = A(u);
    et(f, 17, () => d(i).split(""), yt, (h, g) => {
      var _ = q1(), b = A(_);
      aa(_, (m) => a[a.length] = m, () => a == null ? void 0 : a[a.length]), $(() => Me(b, d(g))), z(h, _);
    });
    var p = X(f);
    {
      var c = (h) => {
        var g = B1();
        z(h, g);
      };
      B(p, (h) => {
        var g;
        l !== ((g = t.text) == null ? void 0 : g.split(" ").length) - 1 && h(c);
      });
    }
    z(s, u);
  }), $(() => {
    Ue(n, `text-container layup-relative layup-z-50 !layup-max-w-sm !layup-rounded-sm !layup-text-items !layup-font-items
      !layup-text-primary dark:!layup-text-primary ${t.padding ?? ""} svelte-pd0xct`), be(n, "style", `text-align: ${t.textAlign ?? ""};`);
  }), z(e, n), xe();
}
var U1 = /* @__PURE__ */ St('<svg><g filter="url(#filter0_d_1615_459)"><path d="M23.3401 4.77807L23.3402 4.7781C25.492 5.35532 26.2233 8.03394 24.6723 9.62217C24.2851 10.1366 23.6996 10.5794 23.0667 10.9741C22.4226 11.3759 21.6821 11.7559 20.9656 12.1237L20.9413 12.1361C20.2081 12.5125 19.501 12.8763 18.8978 13.2548C18.2956 13.6327 17.8447 13.9967 17.5828 14.3581C17.4318 14.605 17.1877 15.0598 16.8784 15.6382L16.8477 15.6955C16.5435 16.2646 16.1866 16.9319 15.8176 17.5876C15.4368 18.2642 15.0376 18.9382 14.6639 19.4863C14.4772 19.7602 14.2918 20.01 14.114 20.2158C13.9582 20.3961 13.7877 20.5669 13.6088 20.6862C12.0192 22.2179 9.354 21.487 8.77826 19.3408L8.77822 19.3407L4.58915 3.70906C4.08094 1.81504 5.81514 0.0809754 7.70914 0.589143L23.3401 4.77807Z" stroke="white"></path></g><defs><filter id="filter0_d_1615_459" x="-0.000976562" y="-0.000976562" width="30.0015" height="30.0017" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1615_459"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1615_459" result="shape"></feBlend></filter></defs></svg>');
function G1(e, t) {
  let a = R(t, "class", 3, ""), r = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var n = U1();
  let o;
  $(() => o = at(
    n,
    o,
    {
      width: "34",
      height: "28",
      viewBox: "-2 -2 34 32",
      class: a(),
      ...r,
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, n);
}
var ap = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Kt = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, K1 = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function xg(e, t) {
  e.forEach(function(a) {
    Array.isArray(a) ? xg(a, t) : t.push(a);
  });
}
function zg(e) {
  let t = [];
  return xg(e, t), t;
}
var Sg = (...e) => zg(e).filter(Boolean), Cg = (e, t) => {
  let a = {}, r = Object.keys(e), n = Object.keys(t);
  for (let o of r) if (n.includes(o)) {
    let s = e[o], i = t[o];
    Array.isArray(s) || Array.isArray(i) ? a[o] = Sg(i, s) : typeof s == "object" && typeof i == "object" ? a[o] = Cg(s, i) : a[o] = i + " " + s;
  } else a[o] = e[o];
  for (let o of n) r.includes(o) || (a[o] = t[o]);
  return a;
}, rp = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim(), Z1 = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, Eg = (e) => e || void 0, Wo = (...e) => Eg(zg(e).filter(Boolean).join(" ")), Rc = null, Ka = {}, wu = !1, zo = (...e) => (t) => t.twMerge ? ((!Rc || wu) && (wu = !1, Rc = Kt(Ka) ? wg : j1({ ...Ka, extend: { theme: Ka.theme, classGroups: Ka.classGroups, conflictingClassGroupModifiers: Ka.conflictingClassGroupModifiers, conflictingClassGroups: Ka.conflictingClassGroups, ...Ka.extend } })), Eg(Rc(Wo(e)))) : Wo(e), np = (e, t) => {
  for (let a in t) e.hasOwnProperty(a) ? e[a] = Wo(e[a], t[a]) : e[a] = t[a];
  return e;
}, Y1 = (e, t) => {
  let { extend: a = null, slots: r = {}, variants: n = {}, compoundVariants: o = [], compoundSlots: s = [], defaultVariants: i = {} } = e, l = { ...Z1, ...t }, u = a != null && a.base ? Wo(a.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, f = a != null && a.variants && !Kt(a.variants) ? Cg(n, a.variants) : n, p = a != null && a.defaultVariants && !Kt(a.defaultVariants) ? { ...a.defaultVariants, ...i } : i;
  !Kt(l.twMergeConfig) && !K1(l.twMergeConfig, Ka) && (wu = !0, Ka = l.twMergeConfig);
  let c = Kt(a == null ? void 0 : a.slots), h = Kt(r) ? {} : { base: Wo(e == null ? void 0 : e.base, c && (a == null ? void 0 : a.base)), ...r }, g = c ? h : np({ ...a == null ? void 0 : a.slots }, Kt(h) ? { base: e == null ? void 0 : e.base } : h), _ = Kt(a == null ? void 0 : a.compoundVariants) ? o : Sg(a == null ? void 0 : a.compoundVariants, o), b = (w) => {
    if (Kt(f) && Kt(r) && c) return zo(u, w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
    if (_ && !Array.isArray(_)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof _}`);
    if (s && !Array.isArray(s)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof s}`);
    let S = (O, I, E = [], N) => {
      let H = E;
      if (typeof I == "string") H = H.concat(rp(I).split(" ").map((Y) => `${O}:${Y}`));
      else if (Array.isArray(I)) H = H.concat(I.reduce((Y, V) => Y.concat(`${O}:${V}`), []));
      else if (typeof I == "object" && typeof N == "string") {
        for (let Y in I) if (I.hasOwnProperty(Y) && Y === N) {
          let V = I[Y];
          if (V && typeof V == "string") {
            let U = rp(V);
            H[N] ? H[N] = H[N].concat(U.split(" ").map((ee) => `${O}:${ee}`)) : H[N] = U.split(" ").map((ee) => `${O}:${ee}`);
          } else Array.isArray(V) && V.length > 0 && (H[N] = V.reduce((U, ee) => U.concat(`${O}:${ee}`), []));
        }
      }
      return H;
    }, C = (O, I = f, E = null, N = null) => {
      var H;
      let Y = I[O];
      if (!Y || Kt(Y)) return null;
      let V = (H = N == null ? void 0 : N[O]) != null ? H : w == null ? void 0 : w[O];
      if (V === null) return null;
      let U = ap(V), ee = Array.isArray(l.responsiveVariants) && l.responsiveVariants.length > 0 || l.responsiveVariants === !0, W = p == null ? void 0 : p[O], G = [];
      if (typeof U == "object" && ee) for (let [ae, ie] of Object.entries(U)) {
        let oe = Y[ie];
        if (ae === "initial") {
          W = ie;
          continue;
        }
        Array.isArray(l.responsiveVariants) && !l.responsiveVariants.includes(ae) || (G = S(ae, oe, G, E));
      }
      let J = U != null && typeof U != "object" ? U : ap(W), te = Y[J || "false"];
      return typeof G == "object" && typeof E == "string" && G[E] ? np(G, te) : G.length > 0 ? (G.push(te), E === "base" ? G.join(" ") : G) : te;
    }, v = () => f ? Object.keys(f).map((O) => C(O, f)) : null, y = (O, I) => {
      if (!f || typeof f != "object") return null;
      let E = new Array();
      for (let N in f) {
        let H = C(N, f, O, I), Y = O === "base" && typeof H == "string" ? H : H && H[O];
        Y && (E[E.length] = Y);
      }
      return E;
    }, k = {};
    for (let O in w) w[O] !== void 0 && (k[O] = w[O]);
    let x = (O, I) => {
      var E;
      let N = typeof (w == null ? void 0 : w[O]) == "object" ? { [O]: (E = w[O]) == null ? void 0 : E.initial } : {};
      return { ...p, ...k, ...N, ...I };
    }, T = (O = [], I) => {
      let E = [];
      for (let { class: N, className: H, ...Y } of O) {
        let V = !0;
        for (let [U, ee] of Object.entries(Y)) {
          let W = x(U, I)[U];
          if (Array.isArray(ee)) {
            if (!ee.includes(W)) {
              V = !1;
              break;
            }
          } else {
            let G = (J) => J == null || J === !1;
            if (G(ee) && G(W)) continue;
            if (W !== ee) {
              V = !1;
              break;
            }
          }
        }
        V && (N && E.push(N), H && E.push(H));
      }
      return E;
    }, F = (O) => {
      let I = T(_, O);
      if (!Array.isArray(I)) return I;
      let E = {};
      for (let N of I) if (typeof N == "string" && (E.base = zo(E.base, N)(l)), typeof N == "object") for (let [H, Y] of Object.entries(N)) E[H] = zo(E[H], Y)(l);
      return E;
    }, P = (O) => {
      if (s.length < 1) return null;
      let I = {};
      for (let { slots: E = [], class: N, className: H, ...Y } of s) {
        if (!Kt(Y)) {
          let V = !0;
          for (let U of Object.keys(Y)) {
            let ee = x(U, O)[U];
            if (ee === void 0 || (Array.isArray(Y[U]) ? !Y[U].includes(ee) : Y[U] !== ee)) {
              V = !1;
              break;
            }
          }
          if (!V) continue;
        }
        for (let V of E) I[V] = I[V] || [], I[V].push([N, H]);
      }
      return I;
    };
    if (!Kt(r) || !c) {
      let O = {};
      if (typeof g == "object" && !Kt(g)) for (let I of Object.keys(g)) O[I] = (E) => {
        var N, H;
        return zo(g[I], y(I, E), ((N = F(E)) != null ? N : [])[I], ((H = P(E)) != null ? H : [])[I], E == null ? void 0 : E.class, E == null ? void 0 : E.className)(l);
      };
      return O;
    }
    return zo(u, v(), T(_), w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
  }, m = () => {
    if (!(!f || typeof f != "object")) return Object.keys(f);
  };
  return b.variantKeys = m(), b.extend = a, b.base = u, b.slots = g, b.variants = f, b.defaultVariants = p, b.compoundSlots = s, b.compoundVariants = _, b;
};
const op = Y1({
  base: "focus-visible:!layup-ring-ring !layup-inline-flex layup-items-center layup-justify-center !layup-gap-2 !layup-whitespace-nowrap !layup-text-sm layup-font-medium transition-colors focus-visible:layup-outline-none focus-visible:ring-0 disabled:layup-pointer-events-none disabled:layup-opacity-50 [&_svg]:layup-pointer-events-none [&_svg]:layup-size-4 [&_svg]:layup-shrink-0",
  variants: {
    variant: {
      default: "layup-bg-accent layup-text-accent-foreground hover:!layup-bg-accent-secondary layup-shadow",
      destructive: "layup-bg-destructive layup-text-destructive-foreground hover:!layup-bg-destructive/90 layup-shadow-sm",
      outline: "layup-border-input layup-bg-background hover:layup-bg-accent hover:layup-text-accent-foreground layup-border layup-shadow-sm",
      secondary: "layup-bg-secondary layup-text-secondary-foreground hover:!layup-bg-secondary/80 layup-shadow-sm",
      ghost: "hover:!layup-bg-accent hover:!layup-text-accent-foreground",
      link: "layup-text-accent layup-underline-offset-4 hover:!layup-underline"
    },
    size: {
      default: "layup-h-9 layup-px-4 layup-py-2",
      sm: "layup-h-8 layup-rounded-md layup-px-3 !layup-text-xs",
      lg: "layup-h-10 layup-rounded-md layup-px-8",
      icon: "layup-size-8"
    }
  },
  defaultVariants: { variant: "default", size: "default" }
});
var X1 = /* @__PURE__ */ L("<a><!></a>"), J1 = /* @__PURE__ */ L("<button><!></button>");
function He(e, t) {
  ke(t, !0);
  let a = R(t, "variant", 3, "default"), r = R(t, "size", 3, "default"), n = R(t, "ref", 15, null), o = R(t, "href", 3, void 0), s = R(t, "type", 3, "button"), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "class",
    "variant",
    "size",
    "ref",
    "href",
    "type",
    "children"
  ]);
  var l = K(), u = D(l);
  {
    var f = (c) => {
      var h = X1();
      let g;
      var _ = A(h);
      nt(_, () => t.children ?? qe), aa(h, (b) => n(b), () => n()), $(() => g = at(h, g, {
        class: Oe(op({
          variant: a(),
          size: r(),
          className: t.class
        })),
        href: o(),
        ...i
      })), z(c, h);
    }, p = (c) => {
      var h = J1(), g = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, _ = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, b = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, m = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, w = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, S = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, C = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, v = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, y = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, k = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      }, x = (P) => {
        P.preventDefault(), P.stopPropagation(), P.stopImmediatePropagation();
      };
      let T;
      var F = A(h);
      nt(F, () => t.children ?? qe), aa(h, (P) => n(P), () => n()), $(() => T = at(h, T, {
        tabindex: "-99",
        onfocus: g,
        onpointerover: _,
        onpointerenter: b,
        onmouseover: m,
        onmouseenter: w,
        onpointermove: S,
        onpointerdown: C,
        onmousedown: v,
        onpointerup: y,
        onmouseup: k,
        onblur: x,
        class: Oe(op({
          variant: a(),
          size: r(),
          className: t.class
        })),
        type: s(),
        ...i
      })), z(c, h);
    };
    B(u, (c) => {
      o() ? c(f) : c(p, !1);
    });
  }
  z(e, l), xe();
}
function Q1(e) {
  return typeof e == "function";
}
function $1(e) {
  return e !== null && typeof e == "object";
}
const Ho = Symbol("box"), vd = Symbol("is-writable");
function ex(e) {
  return $1(e) && Ho in e;
}
function tx(e) {
  return de.isBox(e) && vd in e;
}
function de(e) {
  let t = me(ce(e));
  return {
    [Ho]: !0,
    [vd]: !0,
    get current() {
      return d(t);
    },
    set current(a) {
      q(t, ce(a));
    }
  };
}
function ax(e, t) {
  const a = /* @__PURE__ */ M(e);
  return t ? {
    [Ho]: !0,
    [vd]: !0,
    get current() {
      return d(a);
    },
    set current(r) {
      t(r);
    }
  } : {
    [Ho]: !0,
    get current() {
      return e();
    }
  };
}
function rx(e) {
  return de.isBox(e) ? e : Q1(e) ? de.with(e) : de(e);
}
function nx(e) {
  return Object.entries(e).reduce(
    (t, [a, r]) => de.isBox(r) ? (de.isWritableBox(r) ? Object.defineProperty(t, a, {
      get() {
        return r.current;
      },
      set(n) {
        r.current = n;
      }
    }) : Object.defineProperty(t, a, {
      get() {
        return r.current;
      }
    }), t) : Object.assign(t, { [a]: r }),
    {}
  );
}
function ox(e) {
  return de.isWritableBox(e) ? {
    [Ho]: !0,
    get current() {
      return e.current;
    }
  } : e;
}
de.from = rx;
de.with = ax;
de.flatten = nx;
de.readonly = ox;
de.isBox = ex;
de.isWritableBox = tx;
function Ag(...e) {
  return function(t) {
    var a;
    for (const r of e)
      if (r) {
        if (t.defaultPrevented)
          return;
        typeof r == "function" ? r.call(this, t) : (a = r.current) == null || a.call(this, t);
      }
  };
}
var sp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function cc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Tg = {}, ip = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, sx = /\n/g, ix = /^\s*/, lx = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, cx = /^:\s*/, ux = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, dx = /^[;\s]*/, fx = /^\s+|\s+$/g, px = `
`, lp = "/", cp = "*", Vr = "", yx = "comment", hx = "declaration", gx = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var a = 1, r = 1;
  function n(g) {
    var _ = g.match(sx);
    _ && (a += _.length);
    var b = g.lastIndexOf(px);
    r = ~b ? g.length - b : r + g.length;
  }
  function o() {
    var g = { line: a, column: r };
    return function(_) {
      return _.position = new s(g), u(), _;
    };
  }
  function s(g) {
    this.start = g, this.end = { line: a, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function i(g) {
    var _ = new Error(
      t.source + ":" + a + ":" + r + ": " + g
    );
    if (_.reason = g, _.filename = t.source, _.line = a, _.column = r, _.source = e, !t.silent) throw _;
  }
  function l(g) {
    var _ = g.exec(e);
    if (_) {
      var b = _[0];
      return n(b), e = e.slice(b.length), _;
    }
  }
  function u() {
    l(ix);
  }
  function f(g) {
    var _;
    for (g = g || []; _ = p(); )
      _ !== !1 && g.push(_);
    return g;
  }
  function p() {
    var g = o();
    if (!(lp != e.charAt(0) || cp != e.charAt(1))) {
      for (var _ = 2; Vr != e.charAt(_) && (cp != e.charAt(_) || lp != e.charAt(_ + 1)); )
        ++_;
      if (_ += 2, Vr === e.charAt(_ - 1))
        return i("End of comment missing");
      var b = e.slice(2, _ - 2);
      return r += 2, n(b), e = e.slice(_), r += 2, g({
        type: yx,
        comment: b
      });
    }
  }
  function c() {
    var g = o(), _ = l(lx);
    if (_) {
      if (p(), !l(cx)) return i("property missing ':'");
      var b = l(ux), m = g({
        type: hx,
        property: up(_[0].replace(ip, Vr)),
        value: b ? up(b[0].replace(ip, Vr)) : Vr
      });
      return l(dx), m;
    }
  }
  function h() {
    var g = [];
    f(g);
    for (var _; _ = c(); )
      _ !== !1 && (g.push(_), f(g));
    return g;
  }
  return u(), h();
};
function up(e) {
  return e ? e.replace(fx, Vr) : Vr;
}
var mx = sp && sp.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Tg, "__esModule", { value: !0 });
var dp = Tg.default = wx, _x = mx(gx);
function wx(e, t) {
  var a = null;
  if (!e || typeof e != "string")
    return a;
  var r = (0, _x.default)(e), n = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var s = o.property, i = o.value;
      n ? t(s, i, o) : i && (a = a || {}, a[s] = i);
    }
  }), a;
}
const vx = dp.default || dp, bx = /\d/, kx = ["-", "_", "/", "."];
function xx(e = "") {
  if (!bx.test(e))
    return e !== e.toLowerCase();
}
function zx(e) {
  const t = [];
  let a = "", r, n;
  for (const o of e) {
    const s = kx.includes(o);
    if (s === !0) {
      t.push(a), a = "", r = void 0;
      continue;
    }
    const i = xx(o);
    if (n === !1) {
      if (r === !1 && i === !0) {
        t.push(a), a = o, r = i;
        continue;
      }
      if (r === !0 && i === !1 && a.length > 1) {
        const l = a.at(-1);
        t.push(a.slice(0, Math.max(0, a.length - 1))), a = l + o, r = i;
        continue;
      }
    }
    a += o, r = i, n = s;
  }
  return t.push(a), t;
}
function Pg(e) {
  return e ? zx(e).map((t) => Cx(t)).join("") : "";
}
function Sx(e) {
  return Ex(Pg(e || ""));
}
function Cx(e) {
  return e ? e[0].toUpperCase() + e.slice(1) : "";
}
function Ex(e) {
  return e ? e[0].toLowerCase() + e.slice(1) : "";
}
function Oo(e) {
  if (!e)
    return {};
  const t = {};
  function a(r, n) {
    if (r.startsWith("-moz-") || r.startsWith("-webkit-") || r.startsWith("-ms-") || r.startsWith("-o-")) {
      t[Pg(r)] = n;
      return;
    }
    if (r.startsWith("--")) {
      t[r] = n;
      return;
    }
    t[Sx(r)] = n;
  }
  return vx(e, a), t;
}
function Tn(...e) {
  return (...t) => {
    for (const a of e)
      typeof a == "function" && a(...t);
  };
}
function Ax(e, t) {
  const a = RegExp(e, "g");
  return (r) => {
    if (typeof r != "string")
      throw new TypeError(`expected an argument of type string, but got ${typeof r}`);
    return r.match(a) ? r.replace(a, t) : r;
  };
}
const Tx = Ax(/[A-Z]/, (e) => `-${e.toLowerCase()}`);
function Px(e) {
  if (!e || typeof e != "object" || Array.isArray(e))
    throw new TypeError(`expected an argument of type object, but got ${typeof e}`);
  return Object.keys(e).map((t) => `${Tx(t)}: ${e[t]};`).join(`
`);
}
function bd(e = {}) {
  return Px(e).replace(`
`, " ");
}
const Ox = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0",
  transform: "translateX(-100%)"
};
bd(Ox);
function Mx(e) {
  var t;
  return e.length > 2 && e.startsWith("on") && e[2] === ((t = e[2]) == null ? void 0 : t.toLowerCase());
}
function ea(...e) {
  const t = { ...e[0] };
  for (let a = 1; a < e.length; a++) {
    const r = e[a];
    for (const n in r) {
      const o = t[n], s = r[n], i = typeof o == "function", l = typeof s == "function";
      if (i && Mx(n)) {
        const u = o, f = s;
        t[n] = Ag(u, f);
      } else if (i && l)
        t[n] = Tn(o, s);
      else if (n === "class" && typeof o == "string" && typeof s == "string")
        t[n] = pg(o, s);
      else if (n === "style") {
        const u = typeof o == "object", f = typeof s == "object", p = typeof o == "string", c = typeof s == "string";
        if (u && f)
          t[n] = { ...o, ...s };
        else if (u && c) {
          const h = Oo(s);
          t[n] = { ...o, ...h };
        } else if (p && f) {
          const h = Oo(o);
          t[n] = { ...h, ...s };
        } else if (p && c) {
          const h = Oo(o), g = Oo(s);
          t[n] = { ...h, ...g };
        } else u ? t[n] = o : f && (t[n] = s);
      } else
        t[n] = s !== void 0 ? s : o;
    }
  }
  return typeof t.style == "object" && (t.style = bd(t.style).replaceAll(`
`, " ")), t.hidden !== !0 && (t.hidden = void 0), t.disabled !== !0 && (t.disabled = void 0), t;
}
function Fa({
  id: e,
  ref: t,
  deps: a = () => !0,
  onRefChange: r = () => {
  },
  getRootNode: n = () => typeof document < "u" ? document : void 0
}) {
  const o = /* @__PURE__ */ M(() => a()), s = /* @__PURE__ */ M(() => n());
  Pe(() => (e.current, d(o), d(s), zt(() => {
    var l;
    const i = (l = d(s)) == null ? void 0 : l.getElementById(e.current);
    i ? t.current = i : t.current = null, r(t.current);
  }))), Pe(() => () => {
    t.current = null, r(null);
  });
}
function Ix(e) {
  Pe(() => () => {
    e();
  });
}
function Og(e, t) {
  setTimeout(t, e);
}
function uc(e) {
  Nu().then(e);
}
function Mg(e) {
  return e ? "open" : "closed";
}
function Fx(e) {
  return e ? "true" : void 0;
}
const jx = "Enter", Rx = "Escape", Lx = " ", Dx = "Tab", kd = typeof document < "u", fp = Nx();
function Nx() {
  var e, t;
  return kd && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && // eslint-disable-next-line regexp/no-unused-capturing-group
  (/iP(ad|hone|od)/.test(window.navigator.userAgent) || // The new iPad Pro Gen3 does not identify itself as iPad, but as Macintosh.
  ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Ji(e) {
  return e instanceof HTMLElement;
}
function Vx(e) {
  return e instanceof Element;
}
function qx(e) {
  return e !== null;
}
function Bx(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wx(e, t) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function pp(e, t) {
  return Ny(e, t);
}
function Hx(e, t) {
  const a = e, r = typeof e == "symbol" ? e.description : e;
  if (!E_(a)) {
    if (t === void 0)
      throw new Error(`Missing context dependency: ${r} and no fallback was provided.`);
    return t;
  }
  return rc(e);
}
function Ux(e, t) {
  return typeof e == "string" && t === void 0 ? `${e}Context` : Array.isArray(e) && t === void 0 ? `${e[0]}Context` : `${e}Context`;
}
function dc(e, t, a = !0) {
  const r = Ux(e, t), n = Symbol.for(`bits-ui.${r}`), o = r;
  function s(l) {
    const u = Hx(a ? n : o, l);
    if (u === void 0)
      throw new Error(`Context \`${r}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
    return u;
  }
  function i(l) {
    return pp(a ? n : o, l);
  }
  return [i, s];
}
let yp = 0;
function or(e = "bits") {
  return yp++, `${e}-${yp}`;
}
function Tt() {
}
var On, Yo, pr, Ur, Pr, vu, bu;
class Gx {
  constructor(t, a) {
    ne(this, Pr);
    ne(this, On, me());
    ne(this, Yo);
    ne(this, pr, 0);
    ne(this, Ur, null);
    j(this, On).v = ce(t), Ie(this, Yo, a);
  }
  get current() {
    return y_() ? Pe(() => (zc(this, pr)._++, j(this, pr) === 1 && Gt(this, Pr, vu).call(this, !0), () => {
      Nu().then(() => {
        zc(this, pr)._--, j(this, pr) === 0 && Gt(this, Pr, bu).call(this);
      });
    })) : j(this, pr) === 0 && (Gt(this, Pr, vu).call(this, !1), Gt(this, Pr, bu).call(this)), d(j(this, On));
  }
}
On = new WeakMap(), Yo = new WeakMap(), pr = new WeakMap(), Ur = new WeakMap(), Pr = new WeakSet(), vu = function(t) {
  Ie(this, Ur, j(this, Yo).call(this, (a) => {
    q(j(this, On), ce(a));
  }, t) ?? null);
}, bu = function() {
  j(this, Ur) !== null && (j(this, Ur).call(this), Ie(this, Ur, null));
};
new Gx(null, (e, t) => {
  function a() {
    e(document.activeElement);
  }
  if (a(), !!t)
    return document.addEventListener("focusin", a), document.addEventListener("focusout", a), () => {
      document.removeEventListener("focusin", a), document.removeEventListener("focusout", a);
    };
});
function Kx(e) {
  return typeof e == "function";
}
function Zx(e) {
  return Kx(e) ? e() : e;
}
var yr;
class Yx {
  constructor(t, a = { box: "border-box" }) {
    ne(this, yr, me(ce({ width: 0, height: 0 })));
    var r, n;
    j(this, yr).v = ce({
      width: ((r = a.initialSize) == null ? void 0 : r.width) ?? 0,
      height: ((n = a.initialSize) == null ? void 0 : n.height) ?? 0
    }), Pe(() => {
      const o = Zx(t);
      if (!o) return;
      const s = new ResizeObserver((i) => {
        for (const l of i) {
          const u = a.box === "content-box" ? l.contentBoxSize : l.borderBoxSize, f = Array.isArray(u) ? u : [u];
          d(j(this, yr)).width = f.reduce((p, c) => Math.max(p, c.inlineSize), 0), d(j(this, yr)).height = f.reduce((p, c) => Math.max(p, c.blockSize), 0);
        }
      });
      return s.observe(o), () => {
        s.disconnect();
      };
    });
  }
  get width() {
    return d(j(this, yr)).width;
  }
  get height() {
    return d(j(this, yr)).height;
  }
}
yr = new WeakMap();
var Xo, Jo;
class Ig {
  constructor(t) {
    ne(this, Xo, me());
    ne(this, Jo);
    Pe(() => {
      q(j(this, Xo), ce(j(this, Jo))), Ie(this, Jo, t());
    });
  }
  get current() {
    return d(j(this, Xo));
  }
}
Xo = new WeakMap(), Jo = new WeakMap();
function Xx(e, t) {
  const a = de(e);
  function r(o) {
    return t[a.current][o] ?? a.current;
  }
  return { state: a, dispatch: (o) => {
    a.current = r(o);
  } };
}
function Jx(e, t) {
  let a = me(ce({})), r = me("none");
  const n = e.current ? "mounted" : "unmounted";
  let o = me(null);
  const s = new Ig(() => e.current);
  Pe(() => {
    t.current && e.current && uc(() => {
      q(o, ce(document.getElementById(t.current)));
    });
  });
  const { state: i, dispatch: l } = Xx(n, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" },
    unmounted: { MOUNT: "mounted" }
  });
  Pe(() => {
    const c = e.current;
    zt(() => {
      if (d(o) || q(o, ce(document.getElementById(t.current))), !d(o) || !(c !== s.current)) return;
      const g = d(r), _ = vi(d(o));
      c ? l("MOUNT") : _ === "none" || d(a).display === "none" ? l("UNMOUNT") : l(s && g !== _ ? "ANIMATION_OUT" : "UNMOUNT");
    });
  });
  function u(c) {
    if (d(o) || q(o, ce(document.getElementById(t.current))), !d(o)) return;
    const h = vi(d(o)), g = h.includes(c.animationName) || h === "none";
    c.target === d(o) && g && l("ANIMATION_END");
  }
  function f(c) {
    d(o) || q(o, ce(document.getElementById(t.current))), d(o) && c.target === d(o) && q(r, ce(vi(d(o))));
  }
  Pe(() => {
    i.current, zt(() => {
      if (d(o) || q(o, ce(document.getElementById(t.current))), !d(o)) return;
      const c = vi(d(o));
      q(r, ce(i.current === "mounted" ? c : "none"));
    });
  }), Pe(() => {
    if (d(o))
      return q(a, ce(getComputedStyle(d(o)))), d(o).addEventListener("animationstart", f), d(o).addEventListener("animationcancel", u), d(o).addEventListener("animationend", u), () => {
        var c, h, g;
        (c = d(o)) == null || c.removeEventListener("animationstart", f), (h = d(o)) == null || h.removeEventListener("animationcancel", u), (g = d(o)) == null || g.removeEventListener("animationend", u);
      };
  });
  const p = /* @__PURE__ */ M(() => ["mounted", "unmountSuspended"].includes(i.current));
  return {
    get current() {
      return d(p);
    }
  };
}
function vi(e) {
  return e && getComputedStyle(e).animationName || "none";
}
function xd(e, t) {
  ke(t, !0);
  const a = Jx(de.with(() => t.present), de.with(() => t.id));
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = K(), l = D(i);
      nt(l, () => t.presence ?? qe, () => ({ present: a })), z(s, i);
    };
    B(n, (s) => {
      (t.forceMount || t.present || a.current) && s(o);
    });
  }
  z(e, r), xe();
}
function Qx(e) {
  return {
    content: `data-${e}-content`,
    trigger: `data-${e}-trigger`,
    overlay: `data-${e}-overlay`,
    title: `data-${e}-title`,
    description: `data-${e}-description`,
    close: `data-${e}-close`,
    cancel: `data-${e}-cancel`,
    action: `data-${e}-action`
  };
}
var Qo, $o, es, ts, as, rs, ns, os, ss, ll, cl;
class $x {
  constructor(t) {
    Ve(this, "open");
    Ve(this, "variant");
    ne(this, Qo, me(null));
    ne(this, $o, me(null));
    ne(this, es, me(null));
    ne(this, ts, me(null));
    ne(this, as, me(void 0));
    ne(this, rs, me(void 0));
    ne(this, ns, me(void 0));
    ne(this, os, me(void 0));
    ne(this, ss, me(null));
    ne(this, ll, /* @__PURE__ */ M(() => Qx(this.variant.current)));
    Ve(this, "handleOpen", () => {
      this.open.current || (this.open.current = !0);
    });
    Ve(this, "handleClose", () => {
      this.open.current && (this.open.current = !1);
    });
    ne(this, cl, /* @__PURE__ */ M(() => ({
      "data-state": Mg(this.open.current)
    })));
    this.open = t.open, this.variant = t.variant;
  }
  get triggerNode() {
    return d(j(this, Qo));
  }
  set triggerNode(t) {
    q(j(this, Qo), ce(t));
  }
  get titleNode() {
    return d(j(this, $o));
  }
  set titleNode(t) {
    q(j(this, $o), ce(t));
  }
  get contentNode() {
    return d(j(this, es));
  }
  set contentNode(t) {
    q(j(this, es), ce(t));
  }
  get descriptionNode() {
    return d(j(this, ts));
  }
  set descriptionNode(t) {
    q(j(this, ts), ce(t));
  }
  get contentId() {
    return d(j(this, as));
  }
  set contentId(t) {
    q(j(this, as), ce(t));
  }
  get titleId() {
    return d(j(this, rs));
  }
  set titleId(t) {
    q(j(this, rs), ce(t));
  }
  get triggerId() {
    return d(j(this, ns));
  }
  set triggerId(t) {
    q(j(this, ns), ce(t));
  }
  get descriptionId() {
    return d(j(this, os));
  }
  set descriptionId(t) {
    q(j(this, os), ce(t));
  }
  get cancelNode() {
    return d(j(this, ss));
  }
  set cancelNode(t) {
    q(j(this, ss), ce(t));
  }
  get attrs() {
    return d(j(this, ll));
  }
  get sharedProps() {
    return d(j(this, cl));
  }
}
Qo = new WeakMap(), $o = new WeakMap(), es = new WeakMap(), ts = new WeakMap(), as = new WeakMap(), rs = new WeakMap(), ns = new WeakMap(), os = new WeakMap(), ss = new WeakMap(), ll = new WeakMap(), cl = new WeakMap();
var Mn, is, za, ls, Gr, ul, dl, fl, pl, yl;
class e2 {
  constructor(t, a) {
    ne(this, Mn);
    ne(this, is);
    ne(this, za);
    ne(this, ls);
    ne(this, Gr);
    ne(this, ul, /* @__PURE__ */ M(() => j(this, za).attrs[j(this, ls).current]));
    ne(this, dl, (t) => {
      if (!j(this, Gr).current) {
        if (t.pointerType === "touch") return t.preventDefault();
        t.button > 0 || j(this, za).handleClose();
      }
    });
    ne(this, fl, (t) => {
      j(this, Gr).current || t.pointerType === "touch" && (t.preventDefault(), j(this, za).handleClose());
    });
    ne(this, pl, (t) => {
      j(this, Gr).current || (t.key === Lx || t.key === jx) && (t.preventDefault(), j(this, za).handleClose());
    });
    ne(this, yl, /* @__PURE__ */ M(() => ({
      id: j(this, Mn).current,
      [d(j(this, ul))]: "",
      onpointerdown: j(this, dl),
      onpointerup: j(this, fl),
      onkeydown: j(this, pl),
      ...j(this, za).sharedProps
    })));
    Ie(this, za, a), Ie(this, is, t.ref), Ie(this, Mn, t.id), Ie(this, ls, t.variant), Ie(this, Gr, t.disabled), Fa({
      id: j(this, Mn),
      ref: j(this, is),
      deps: () => j(this, za).open.current
    });
  }
  get props() {
    return d(j(this, yl));
  }
}
Mn = new WeakMap(), is = new WeakMap(), za = new WeakMap(), ls = new WeakMap(), Gr = new WeakMap(), ul = new WeakMap(), dl = new WeakMap(), fl = new WeakMap(), pl = new WeakMap(), yl = new WeakMap();
var In, cs, hl, gl;
class t2 {
  constructor(t, a) {
    ne(this, In);
    ne(this, cs);
    Ve(this, "root");
    ne(this, hl, /* @__PURE__ */ M(() => ({ open: this.root.open.current })));
    ne(this, gl, /* @__PURE__ */ M(() => ({
      id: j(this, In).current,
      role: this.root.variant.current === "alert-dialog" ? "alertdialog" : "dialog",
      "aria-describedby": this.root.descriptionId,
      "aria-labelledby": this.root.titleId,
      [this.root.attrs.content]: "",
      style: { pointerEvents: "auto" },
      ...this.root.sharedProps
    })));
    Ie(this, In, t.id), this.root = a, Ie(this, cs, t.ref), Fa({
      id: j(this, In),
      ref: j(this, cs),
      deps: () => this.root.open.current,
      onRefChange: (r) => {
        this.root.contentNode = r, this.root.contentId = r == null ? void 0 : r.id;
      }
    });
  }
  get snippetProps() {
    return d(j(this, hl));
  }
  get props() {
    return d(j(this, gl));
  }
}
In = new WeakMap(), cs = new WeakMap(), hl = new WeakMap(), gl = new WeakMap();
var Fn, us, ml, _l;
class a2 {
  constructor(t, a) {
    ne(this, Fn);
    ne(this, us);
    Ve(this, "root");
    ne(this, ml, /* @__PURE__ */ M(() => ({ open: this.root.open.current })));
    ne(this, _l, /* @__PURE__ */ M(() => ({
      id: j(this, Fn).current,
      [this.root.attrs.overlay]: "",
      style: { pointerEvents: "auto" },
      ...this.root.sharedProps
    })));
    Ie(this, Fn, t.id), Ie(this, us, t.ref), this.root = a, Fa({
      id: j(this, Fn),
      ref: j(this, us),
      deps: () => this.root.open.current
    });
  }
  get snippetProps() {
    return d(j(this, ml));
  }
  get props() {
    return d(j(this, _l));
  }
}
Fn = new WeakMap(), us = new WeakMap(), ml = new WeakMap(), _l = new WeakMap();
const [r2, zd] = dc("Dialog.Root");
function n2(e) {
  return r2(new $x(e));
}
function o2(e) {
  return new t2(e, zd());
}
function s2(e) {
  return new a2(e, zd());
}
function i2(e) {
  return new e2(e, zd());
}
function l2(e, t) {
  ke(t, !0);
  var a = K(), r = D(a);
  zr(r, () => t.children, (n) => {
    var o = K(), s = D(o);
    nt(s, () => t.children ?? qe), z(n, o);
  }), z(e, a), xe();
}
function Fg(e, t) {
  ke(t, !0);
  let a = R(t, "to", 3, "body");
  const r = A_();
  let n = /* @__PURE__ */ M(o);
  function o() {
    if (!kd || t.disabled) return null;
    let f = null;
    return typeof a() == "string" ? f = document.querySelector(a()) : (a() instanceof HTMLElement || a() instanceof DocumentFragment) && (f = a()), f;
  }
  let s;
  Pe(() => {
    if (!d(n) || t.disabled) {
      s && (Jc(s), s = null);
      return;
    }
    return zt(() => s = qu(l2, {
      target: d(n),
      props: { children: t.children },
      context: r
    })), () => {
      s && (Jc(s), s = null);
    };
  });
  var i = K(), l = D(i);
  {
    var u = (f) => {
      var p = K(), c = D(p);
      nt(c, () => t.children ?? qe), z(f, p);
    };
    B(l, (f) => {
      t.disabled && f(u);
    });
  }
  z(e, i), xe();
}
function Ea(e, t, a, r) {
  const n = Array.isArray(t) ? t : [t];
  return n.forEach((o) => e.addEventListener(o, a, r)), () => {
    n.forEach((o) => e.removeEventListener(o, a, r));
  };
}
function hp(e, t = 500) {
  let a = null;
  const r = (...n) => {
    a !== null && clearTimeout(a), a = setTimeout(() => {
      e(...n);
    }, t);
  };
  return r.destroy = () => {
    a !== null && (clearTimeout(a), a = null);
  }, r;
}
function Sd(e, t) {
  return e === t || e.contains(t);
}
function jg(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
globalThis.bitsDismissableLayers ?? (globalThis.bitsDismissableLayers = /* @__PURE__ */ new Map());
var jn, Kr, hr, Rn, gr, Ln, Dn, ds, fs, ps, Ya, wl, ro, Rg, vl, Nn, bl, kl, xl, zl, ys, Lg, Sl, Cl;
class c2 {
  constructor(t) {
    ne(this, ro);
    ne(this, jn);
    ne(this, Kr);
    ne(this, hr, { pointerdown: !1 });
    ne(this, Rn, !1);
    Ve(this, "node", de(null));
    ne(this, gr);
    ne(this, Ln);
    ne(this, Dn, me(!1));
    ne(this, ds);
    ne(this, fs, me(null));
    ne(this, ps);
    ne(this, Ya, Tt);
    ne(this, wl, (t) => {
      t.defaultPrevented || this.currNode && uc(() => {
        var a, r;
        !this.currNode || j(this, zl).call(this, t.target) || t.target && !d(j(this, Dn)) && ((r = (a = j(this, ds)).current) == null || r.call(a, t));
      });
    });
    ne(this, vl, (t) => {
      let a = t;
      a.defaultPrevented && (a = gp(t)), j(this, jn).current(t);
    });
    ne(this, Nn, hp(
      (t) => {
        if (!this.currNode) {
          j(this, Ya).call(this);
          return;
        }
        const a = j(this, ps).current(t, this.currNode) || p2(t, this.currNode);
        if (!j(this, Rn) || Gt(this, ro, Lg).call(this) || !a) {
          j(this, Ya).call(this);
          return;
        }
        let r = t;
        if (r.defaultPrevented && (r = gp(r)), j(this, Kr).current !== "close" && j(this, Kr).current !== "defer-otherwise-close") {
          j(this, Ya).call(this);
          return;
        }
        t.pointerType === "touch" ? (j(this, Ya).call(this), Ie(this, Ya, Ea(j(this, gr), "click", j(this, vl), { once: !0 }))) : j(this, jn).current(r);
      },
      10
    ));
    ne(this, bl, (t) => {
      j(this, hr)[t.type] = !0;
    });
    ne(this, kl, (t) => {
      j(this, hr)[t.type] = !1;
    });
    ne(this, xl, () => {
      this.node.current && Ie(this, Rn, f2(this.node.current));
    });
    ne(this, zl, (t) => this.node.current ? Sd(this.node.current, t) : !1);
    ne(this, ys, hp(
      () => {
        for (const t in j(this, hr))
          j(this, hr)[t] = !1;
        Ie(this, Rn, !1);
      },
      20
    ));
    ne(this, Sl, () => {
      q(j(this, Dn), !0);
    });
    ne(this, Cl, () => {
      q(j(this, Dn), !1);
    });
    Ve(this, "props", {
      onfocuscapture: j(this, Sl),
      onblurcapture: j(this, Cl)
    });
    Ie(this, Ln, t.enabled), Ie(this, ps, t.isValidEvent), Fa({
      id: t.id,
      ref: this.node,
      deps: () => j(this, Ln).current,
      onRefChange: (n) => {
        this.currNode = n;
      }
    }), Ie(this, Kr, t.interactOutsideBehavior), Ie(this, jn, t.onInteractOutside), Ie(this, ds, t.onFocusOutside), Pe(() => {
      Ie(this, gr, jg(this.currNode));
    });
    let a = Tt;
    const r = () => {
      j(this, ys).call(this), globalThis.bitsDismissableLayers.delete(this), j(this, Nn).destroy(), a();
    };
    Pe(() => (j(this, Ln).current && this.currNode && Og(1, () => {
      this.currNode && (globalThis.bitsDismissableLayers.set(this, zt(() => j(this, Kr))), a(), a = Gt(this, ro, Rg).call(this));
    }), () => {
      r();
    })), Ix(() => {
      j(this, ys).destroy(), globalThis.bitsDismissableLayers.delete(this), j(this, Nn).destroy(), j(this, Ya).call(this), a();
    });
  }
  get currNode() {
    return d(j(this, fs));
  }
  set currNode(t) {
    q(j(this, fs), ce(t));
  }
}
jn = new WeakMap(), Kr = new WeakMap(), hr = new WeakMap(), Rn = new WeakMap(), gr = new WeakMap(), Ln = new WeakMap(), Dn = new WeakMap(), ds = new WeakMap(), fs = new WeakMap(), ps = new WeakMap(), Ya = new WeakMap(), wl = new WeakMap(), ro = new WeakSet(), Rg = function() {
  return Tn(
    /**
    * CAPTURE INTERACTION START
    * mark interaction-start event as intercepted.
    * mark responsible layer during interaction start
    * to avoid checking if is responsible layer during interaction end
    * when a new floating element may have been opened.
    */
    Ea(j(this, gr), "pointerdown", Tn(j(this, bl), j(this, xl)), !0),
    /**
    * BUBBLE INTERACTION START
    * Mark interaction-start event as non-intercepted. Debounce `onInteractOutsideStart`
    * to avoid prematurely checking if other events were intercepted.
    */
    Ea(j(this, gr), "pointerdown", Tn(j(this, kl), j(this, Nn))),
    /**
    * HANDLE FOCUS OUTSIDE
    */
    Ea(j(this, gr), "focusin", j(this, wl))
  );
}, vl = new WeakMap(), Nn = new WeakMap(), bl = new WeakMap(), kl = new WeakMap(), xl = new WeakMap(), zl = new WeakMap(), ys = new WeakMap(), Lg = function() {
  return Object.values(j(this, hr)).some(Boolean);
}, Sl = new WeakMap(), Cl = new WeakMap();
function u2(e) {
  return new c2(e);
}
function d2(e) {
  return e.findLast(([t, { current: a }]) => a === "close" || a === "ignore");
}
function f2(e) {
  const t = [...globalThis.bitsDismissableLayers], a = d2(t);
  if (a) return a[0].node.current === e;
  const [r] = t[0];
  return r.node.current === e;
}
function p2(e, t) {
  if ("button" in e && e.button > 0) return !1;
  const a = e.target;
  return Vx(a) ? jg(a).documentElement.contains(a) && !Sd(t, a) : !1;
}
function gp(e) {
  const t = e.currentTarget, a = e.target;
  let r;
  e instanceof PointerEvent ? r = new PointerEvent(e.type, e) : r = new PointerEvent("pointerdown", e);
  let n = !1;
  return new Proxy(r, {
    get: (s, i) => i === "currentTarget" ? t : i === "target" ? a : i === "preventDefault" ? () => {
      n = !0, typeof s.preventDefault == "function" && s.preventDefault();
    } : i === "defaultPrevented" ? n : i in s ? s[i] : e[i]
  });
}
function Dg(e, t) {
  ke(t, !0);
  let a = R(t, "interactOutsideBehavior", 3, "close"), r = R(t, "onInteractOutside", 3, Tt), n = R(t, "onFocusOutside", 3, Tt), o = R(t, "isValidEvent", 3, () => !1);
  const s = u2({
    id: de.with(() => t.id),
    interactOutsideBehavior: de.with(() => a()),
    onInteractOutside: de.with(() => r()),
    enabled: de.with(() => t.enabled),
    onFocusOutside: de.with(() => n()),
    isValidEvent: de.with(() => o())
  });
  var i = K(), l = D(i);
  nt(l, () => t.children ?? qe, () => ({ props: s.props })), z(e, i), xe();
}
globalThis.bitsEscapeLayers ?? (globalThis.bitsEscapeLayers = /* @__PURE__ */ new Map());
var hs, Vn, gs, El, Al;
class y2 {
  constructor(t) {
    ne(this, hs);
    ne(this, Vn);
    ne(this, gs);
    ne(this, El, () => Ea(document, "keydown", j(this, Al), { passive: !1 }));
    ne(this, Al, (t) => {
      if (t.key !== Rx || !g2(this)) return;
      const a = new KeyboardEvent(t.type, t);
      t.preventDefault();
      const r = j(this, Vn).current;
      r !== "close" && r !== "defer-otherwise-close" || j(this, hs).current(a);
    });
    Ie(this, Vn, t.escapeKeydownBehavior), Ie(this, hs, t.onEscapeKeydown), Ie(this, gs, t.enabled);
    let a = Tt;
    Pe(() => (j(this, gs).current && (globalThis.bitsEscapeLayers.set(this, zt(() => j(this, Vn))), a = j(this, El).call(this)), () => {
      a(), globalThis.bitsEscapeLayers.delete(this);
    }));
  }
}
hs = new WeakMap(), Vn = new WeakMap(), gs = new WeakMap(), El = new WeakMap(), Al = new WeakMap();
function h2(e) {
  return new y2(e);
}
function g2(e) {
  const t = [...globalThis.bitsEscapeLayers], a = t.findLast(([n, { current: o }]) => o === "close" || o === "ignore");
  if (a) return a[0] === e;
  const [r] = t[0];
  return r === e;
}
function Ng(e, t) {
  ke(t, !0);
  let a = R(t, "escapeKeydownBehavior", 3, "close"), r = R(t, "onEscapeKeydown", 3, Tt);
  h2({
    escapeKeydownBehavior: de.with(() => a()),
    onEscapeKeydown: de.with(() => r()),
    enabled: de.with(() => t.enabled)
  });
  var n = K(), o = D(n);
  nt(o, () => t.children ?? qe), z(e, n), xe();
}
const m2 = de([]);
function _2() {
  const e = m2;
  return {
    add(t) {
      const a = e.current[0];
      t.id !== (a == null ? void 0 : a.id) && (a == null || a.pause()), e.current = mp(e.current, t), e.current.unshift(t);
    },
    remove(t) {
      var a;
      e.current = mp(e.current, t), (a = e.current[0]) == null || a.resume();
    }
  };
}
function w2() {
  let e = me(!1);
  return {
    id: or(),
    get paused() {
      return d(e);
    },
    pause() {
      q(e, !0);
    },
    resume() {
      q(e, !1);
    }
  };
}
function mp(e, t) {
  return [...e].filter((a) => a.id !== t.id);
}
function v2(e) {
  return e.filter((t) => t.tagName !== "A");
}
function dr(e, { select: t = !1 } = {}) {
  if (!(e && e.focus))
    return;
  const a = document.activeElement;
  e.focus({ preventScroll: !0 }), e !== a && Bx(e) && t && e.select();
}
function b2(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const r of e)
    if (dr(r, { select: t }), document.activeElement !== a)
      return !0;
}
function _p(e, t) {
  for (const a of e)
    if (!Wx(a, t))
      return a;
}
function Vg(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    // eslint-disable-next-line ts/no-explicit-any
    acceptNode: (r) => {
      const n = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || n ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); )
    t.push(a.currentNode);
  return t;
}
function k2(e) {
  const t = Vg(e), a = _p(t, e), r = _p(t.reverse(), e);
  return [a, r];
}
const x2 = "focusScope.autoFocusOnMount", z2 = "focusScope.autoFocusOnDestroy", wp = { bubbles: !1, cancelable: !0 };
function S2({
  id: e,
  loop: t,
  enabled: a,
  onOpenAutoFocus: r,
  onCloseAutoFocus: n,
  forceMount: o
}) {
  const s = _2(), i = w2(), l = de(null);
  Fa({ id: e, ref: l, deps: () => a.current });
  let u = me(null);
  Pe(() => {
    const g = l.current;
    if (!g || !a.current) return;
    function _(C) {
      if (i.paused || !g) return;
      const v = C.target;
      Ji(v) && (g.contains(v) ? q(u, ce(v)) : dr(d(u), { select: !0 }));
    }
    function b(C) {
      if (i.paused || !g) return;
      const v = C.relatedTarget;
      Ji(v) && v !== null && (g.contains(v) || dr(d(u), { select: !0 }));
    }
    function m(C) {
      (g == null ? void 0 : g.contains(d(u))) || dr(g);
    }
    const w = Tn(Ea(document, "focusin", _), Ea(document, "focusout", b)), S = new MutationObserver(m);
    return g && S.observe(g, { childList: !0, subtree: !0 }), () => {
      w(), S.disconnect();
    };
  }), Pe(() => {
    if (o.current) return;
    let g = l.current;
    const _ = document.activeElement;
    return zt(() => {
      f(g, _);
    }), () => {
      g && p(_);
    };
  }), Pe(() => {
    if (!o.current) return;
    let g = l.current;
    a.current;
    const _ = document.activeElement;
    return zt(() => {
      f(g, _);
    }), () => {
      g && p(_);
    };
  });
  function f(g, _) {
    if (g || (g = document.getElementById(e.current)), !g) return;
    if (s.add(i), !g.contains(_)) {
      const m = new CustomEvent(x2, wp);
      r.current(m), m.defaultPrevented || uc(() => {
        g && (b2(v2(Vg(g)), { select: !0 }), document.activeElement === _ && dr(g));
      });
    }
  }
  function p(g) {
    const _ = new CustomEvent(z2, wp);
    n.current(_), setTimeout(
      () => {
        !_.defaultPrevented && g && dr(g ?? document.body, { select: !0 }), s.remove(i);
      },
      0
    );
  }
  function c(g) {
    if (!a.current || !t.current && !a.current || i.paused) return;
    const _ = g.key === Dx && !g.ctrlKey && !g.altKey && !g.metaKey, b = document.activeElement;
    if (!(_ && b)) return;
    const m = l.current;
    if (!m) return;
    const [w, S] = k2(m);
    w && S ? !g.shiftKey && b === S ? (g.preventDefault(), t.current && dr(w, { select: !0 })) : g.shiftKey && b === w && (g.preventDefault(), t.current && dr(S, { select: !0 })) : b === m && g.preventDefault();
  }
  const h = /* @__PURE__ */ M(() => ({
    id: e.current,
    tabindex: -1,
    onkeydown: c
  }));
  return {
    get props() {
      return d(h);
    }
  };
}
function qg(e, t) {
  ke(t, !0);
  let a = R(t, "trapFocus", 3, !1), r = R(t, "loop", 3, !1), n = R(t, "onCloseAutoFocus", 3, Tt), o = R(t, "onOpenAutoFocus", 3, Tt), s = R(t, "forceMount", 3, !1);
  const i = S2({
    enabled: de.with(() => a()),
    loop: de.with(() => r()),
    onCloseAutoFocus: de.with(() => n()),
    onOpenAutoFocus: de.with(() => o()),
    id: de.with(() => t.id),
    forceMount: de.with(() => s())
  });
  var l = K(), u = D(l);
  nt(u, () => t.focusScope ?? qe, () => ({ props: i.props })), z(e, l), xe();
}
globalThis.bitsTextSelectionLayers ?? (globalThis.bitsTextSelectionLayers = /* @__PURE__ */ new Map());
var ms, _s, ws, mr, qn, vs, Tl, Bg, Pl, bs;
class C2 {
  constructor(t) {
    ne(this, Tl);
    ne(this, ms);
    ne(this, _s);
    ne(this, ws);
    ne(this, mr);
    ne(this, qn, Tt);
    ne(this, vs, de(null));
    ne(this, Pl, (t) => {
      const a = j(this, vs).current, r = t.target;
      !Ji(a) || !Ji(r) || !j(this, mr).current || !T2(this) || !Sd(a, r) || (j(this, _s).current(t), !t.defaultPrevented && Ie(this, qn, A2(a)));
    });
    ne(this, bs, () => {
      j(this, qn).call(this), Ie(this, qn, Tt);
    });
    Ie(this, ms, t.id), Ie(this, mr, t.preventOverflowTextSelection), Ie(this, _s, t.onPointerDown), Ie(this, ws, t.onPointerUp), Fa({
      id: j(this, ms),
      ref: j(this, vs),
      deps: () => j(this, mr).current
    });
    let a = Tt;
    Pe(() => (j(this, mr).current && (globalThis.bitsTextSelectionLayers.set(this, zt(() => j(this, mr))), a = Gt(this, Tl, Bg).call(this)), () => {
      a(), j(this, bs).call(this), globalThis.bitsTextSelectionLayers.delete(this);
    }));
  }
}
ms = new WeakMap(), _s = new WeakMap(), ws = new WeakMap(), mr = new WeakMap(), qn = new WeakMap(), vs = new WeakMap(), Tl = new WeakSet(), Bg = function() {
  return Tn(Ea(document, "pointerdown", j(this, Pl)), Ea(document, "pointerup", Ag(j(this, bs), j(this, ws))));
}, Pl = new WeakMap(), bs = new WeakMap();
function E2(e) {
  return new C2(e);
}
const vp = (e) => e.style.userSelect || e.style.webkitUserSelect;
function A2(e) {
  const t = document.body, a = vp(t), r = vp(e);
  return bi(t, "none"), bi(e, "text"), () => {
    bi(t, a), bi(e, r);
  };
}
function bi(e, t) {
  e.style.userSelect = t, e.style.webkitUserSelect = t;
}
function T2(e) {
  const t = [...globalThis.bitsTextSelectionLayers];
  if (!t.length) return !1;
  const a = t.at(-1);
  return a ? a[0] === e : !1;
}
function Wg(e, t) {
  ke(t, !0);
  let a = R(t, "preventOverflowTextSelection", 3, !0), r = R(t, "onPointerDown", 3, Tt), n = R(t, "onPointerUp", 3, Tt);
  E2({
    id: de.with(() => t.id),
    preventOverflowTextSelection: de.with(() => a()),
    onPointerDown: de.with(() => r()),
    onPointerUp: de.with(() => n()),
    enabled: de.with(() => t.enabled)
  });
  var o = K(), s = D(o);
  nt(s, () => t.children ?? qe), z(e, o), xe();
}
var Sa, Ca, Xa, Bn, Fi;
const Bd = class Bd extends Map {
  /**
   * @param {Iterable<readonly [K, V]> | null | undefined} [value]
   */
  constructor(a) {
    super();
    ne(this, Bn);
    /** @type {Map<K, Source<number>>} */
    ne(this, Sa, /* @__PURE__ */ new Map());
    ne(this, Ca, Ot(0));
    ne(this, Xa, Ot(0));
    if (a) {
      for (var [r, n] of a)
        super.set(r, n);
      j(this, Xa).v = super.size;
    }
  }
  /** @param {K} key */
  has(a) {
    var r = j(this, Sa), n = r.get(a);
    if (n === void 0) {
      var o = super.get(a);
      if (o !== void 0)
        n = Ot(0), r.set(a, n);
      else
        return d(j(this, Ca)), !1;
    }
    return d(n), !0;
  }
  /**
   * @param {(value: V, key: K, map: Map<K, V>) => void} callbackfn
   * @param {any} [this_arg]
   */
  forEach(a, r) {
    Gt(this, Bn, Fi).call(this), super.forEach(a, r);
  }
  /** @param {K} key */
  get(a) {
    var r = j(this, Sa), n = r.get(a);
    if (n === void 0) {
      var o = super.get(a);
      if (o !== void 0)
        n = Ot(0), r.set(a, n);
      else {
        d(j(this, Ca));
        return;
      }
    }
    return d(n), super.get(a);
  }
  /**
   * @param {K} key
   * @param {V} value
   * */
  set(a, r) {
    var p;
    var n = j(this, Sa), o = n.get(a), s = super.get(a), i = super.set(a, r), l = j(this, Ca);
    if (o === void 0)
      n.set(a, Ot(0)), q(j(this, Xa), super.size), vo(l);
    else if (s !== r) {
      vo(o);
      var u = l.reactions === null ? null : new Set(l.reactions), f = u === null || !((p = o.reactions) != null && p.every(
        (c) => (
          /** @type {NonNullable<typeof v_reactions>} */
          u.has(c)
        )
      ));
      f && vo(l);
    }
    return i;
  }
  /** @param {K} key */
  delete(a) {
    var r = j(this, Sa), n = r.get(a), o = super.delete(a);
    return n !== void 0 && (r.delete(a), q(j(this, Xa), super.size), q(n, -1), vo(j(this, Ca))), o;
  }
  clear() {
    if (super.size !== 0) {
      super.clear();
      var a = j(this, Sa);
      q(j(this, Xa), 0);
      for (var r of a.values())
        q(r, -1);
      vo(j(this, Ca)), a.clear();
    }
  }
  keys() {
    return d(j(this, Ca)), super.keys();
  }
  values() {
    return Gt(this, Bn, Fi).call(this), super.values();
  }
  entries() {
    return Gt(this, Bn, Fi).call(this), super.entries();
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  get size() {
    return d(j(this, Xa)), super.size;
  }
};
Sa = new WeakMap(), Ca = new WeakMap(), Xa = new WeakMap(), Bn = new WeakSet(), Fi = function() {
  d(j(this, Ca));
  var a = j(this, Sa);
  if (j(this, Xa).v !== a.size)
    for (var r of Ud(Bd.prototype, this, "keys").call(this))
      a.has(r) || a.set(r, Ot(0));
  for (var [, n] of j(this, Sa))
    d(n);
};
let ku = Bd;
function P2(e) {
  let t = 0, a = me(void 0), r;
  function n() {
    t -= 1, r && t <= 0 && (r(), q(a, void 0), r = void 0);
  }
  return (...o) => (t += 1, d(a) === void 0 && (r = xy(() => {
    q(a, ce(e(...o)));
  })), Pe(() => () => {
    n();
  }), d(a));
}
const O2 = P2(() => {
  const e = new ku(), t = /* @__PURE__ */ M(() => {
    for (const o of e.values())
      if (o)
        return !0;
    return !1;
  });
  new Ig(() => d(t));
  let a = ce({}), r = null;
  function n() {
    kd && (document.body.style.paddingRight = a.paddingRight ?? "", document.body.style.marginRight = a.marginRight ?? "", document.body.style.pointerEvents = a.pointerEvents ?? "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = a.overflow ?? "", fp && (r == null || r()));
  }
  return Pe(() => {
    const o = d(t);
    return zt(() => {
      if (!o)
        return;
      const s = getComputedStyle(document.body);
      a.overflow = s.overflow, a.paddingRight = s.paddingRight, a.marginRight = s.marginRight, a.pointerEvents = s.pointerEvents;
      const i = window.innerWidth - document.documentElement.clientWidth, u = {
        padding: Number.parseInt(a.paddingRight ?? "0", 10) + i,
        margin: Number.parseInt(a.marginRight ?? "0", 10)
      };
      i > 0 && (document.body.style.paddingRight = `${u.padding}px`, document.body.style.marginRight = `${u.margin}px`, document.body.style.setProperty("--scrollbar-width", `${i}px`), document.body.style.overflow = "hidden"), fp && (r = Ea(
        document,
        "touchmove",
        (f) => {
          f.target === document.documentElement && (f.touches.length > 1 || f.preventDefault());
        },
        { passive: !1 }
      )), uc(() => {
        document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
      });
    });
  }), Pe(() => () => {
    r == null || r();
  }), {
    get map() {
      return e;
    },
    resetBodyStyle: n
  };
});
function M2(e, t = () => null) {
  const a = or(), r = O2(), n = /* @__PURE__ */ M(t);
  r.map.set(a, e ?? !1);
  const o = de.with(() => r.map.get(a) ?? !1, (s) => r.map.set(a, s));
  return Pe(() => () => {
    r.map.delete(a), Array.from(r.map.values()).length === 0 && (d(n) === null ? r.resetBodyStyle() : Og(d(n), () => r.resetBodyStyle()));
  }), o;
}
function Qi(e, t) {
  ke(t, !0);
  let a = R(t, "preventScroll", 3, !0), r = R(t, "restoreScrollDelay", 3, null);
  M2(a(), () => r()), xe();
}
function I2({ forceMount: e, present: t, trapFocus: a, open: r }) {
  return e ? r && a : t && a;
}
var F2 = /* @__PURE__ */ L("<div><!></div>");
function j2(e, t) {
  ke(t, !0);
  let a = R(t, "id", 19, or), r = R(t, "forceMount", 3, !1), n = R(t, "ref", 15, null), o = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "forceMount",
    "child",
    "children",
    "ref"
  ]);
  const s = s2({
    id: de.with(() => a()),
    ref: de.with(() => n(), (u) => n(u))
  }), i = /* @__PURE__ */ M(() => ea(o, s.props));
  var l = /* @__PURE__ */ M(() => s.root.open.current || r());
  xd(e, {
    get id() {
      return a();
    },
    get present() {
      return d(l);
    },
    presence: (f) => {
      var p = K(), c = D(p);
      {
        var h = (_) => {
          var b = K(), m = D(b), w = /* @__PURE__ */ kt(() => ({
            props: ea(d(i)),
            ...s.snippetProps
          }));
          nt(m, () => t.child, () => d(w)), z(_, b);
        }, g = (_) => {
          var b = F2();
          const m = /* @__PURE__ */ M(() => ea(d(i)));
          let w;
          var S = A(b);
          nt(S, () => t.children ?? qe, () => s.snippetProps), $(() => w = at(b, w, { ...d(m) })), z(_, b);
        };
        B(c, (_) => {
          t.child ? _(h) : _(g, !1);
        });
      }
      z(f, p);
    },
    $$slots: { presence: !0 }
  }), xe();
}
const R2 = ["top", "right", "bottom", "left"], Er = Math.min, $t = Math.max, $i = Math.round, ki = Math.floor, Ma = (e) => ({
  x: e,
  y: e
}), L2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, D2 = {
  start: "end",
  end: "start"
};
function xu(e, t, a) {
  return $t(e, Er(t, a));
}
function tr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ar(e) {
  return e.split("-")[0];
}
function ho(e) {
  return e.split("-")[1];
}
function Cd(e) {
  return e === "x" ? "y" : "x";
}
function Ed(e) {
  return e === "y" ? "height" : "width";
}
function Ar(e) {
  return ["top", "bottom"].includes(ar(e)) ? "y" : "x";
}
function Ad(e) {
  return Cd(Ar(e));
}
function N2(e, t, a) {
  a === void 0 && (a = !1);
  const r = ho(e), n = Ad(e), o = Ed(n);
  let s = n === "x" ? r === (a ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = el(s)), [s, el(s)];
}
function V2(e) {
  const t = el(e);
  return [zu(e), t, zu(t)];
}
function zu(e) {
  return e.replace(/start|end/g, (t) => D2[t]);
}
function q2(e, t, a) {
  const r = ["left", "right"], n = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? n : r : t ? r : n;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function B2(e, t, a, r) {
  const n = ho(e);
  let o = q2(ar(e), a === "start", r);
  return n && (o = o.map((s) => s + "-" + n), t && (o = o.concat(o.map(zu)))), o;
}
function el(e) {
  return e.replace(/left|right|bottom|top/g, (t) => L2[t]);
}
function W2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Hg(e) {
  return typeof e != "number" ? W2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function tl(e) {
  const {
    x: t,
    y: a,
    width: r,
    height: n
  } = e;
  return {
    width: r,
    height: n,
    top: a,
    left: t,
    right: t + r,
    bottom: a + n,
    x: t,
    y: a
  };
}
function bp(e, t, a) {
  let {
    reference: r,
    floating: n
  } = e;
  const o = Ar(t), s = Ad(t), i = Ed(s), l = ar(t), u = o === "y", f = r.x + r.width / 2 - n.width / 2, p = r.y + r.height / 2 - n.height / 2, c = r[i] / 2 - n[i] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: f,
        y: r.y - n.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: p
      };
      break;
    case "left":
      h = {
        x: r.x - n.width,
        y: p
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (ho(t)) {
    case "start":
      h[s] -= c * (a && u ? -1 : 1);
      break;
    case "end":
      h[s] += c * (a && u ? -1 : 1);
      break;
  }
  return h;
}
const H2 = async (e, t, a) => {
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: s
  } = a, i = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: f,
    y: p
  } = bp(u, r, l), c = r, h = {}, g = 0;
  for (let _ = 0; _ < i.length; _++) {
    const {
      name: b,
      fn: m
    } = i[_], {
      x: w,
      y: S,
      data: C,
      reset: v
    } = await m({
      x: f,
      y: p,
      initialPlacement: r,
      placement: c,
      strategy: n,
      middlewareData: h,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, p = S ?? p, h = {
      ...h,
      [b]: {
        ...h[b],
        ...C
      }
    }, v && g <= 50 && (g++, typeof v == "object" && (v.placement && (c = v.placement), v.rects && (u = v.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : v.rects), {
      x: f,
      y: p
    } = bp(u, c, l)), _ = -1);
  }
  return {
    x: f,
    y: p,
    placement: c,
    strategy: n,
    middlewareData: h
  };
};
async function Uo(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: r,
    y: n,
    platform: o,
    rects: s,
    elements: i,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: p = "floating",
    altBoundary: c = !1,
    padding: h = 0
  } = tr(t, e), g = Hg(h), b = i[c ? p === "floating" ? "reference" : "floating" : p], m = tl(await o.getClippingRect({
    element: (a = await (o.isElement == null ? void 0 : o.isElement(b))) == null || a ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: l
  })), w = p === "floating" ? {
    x: r,
    y: n,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(i.floating)), C = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = tl(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: S,
    strategy: l
  }) : w);
  return {
    top: (m.top - v.top + g.top) / C.y,
    bottom: (v.bottom - m.bottom + g.bottom) / C.y,
    left: (m.left - v.left + g.left) / C.x,
    right: (v.right - m.right + g.right) / C.x
  };
}
const U2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: r,
      placement: n,
      rects: o,
      platform: s,
      elements: i,
      middlewareData: l
    } = t, {
      element: u,
      padding: f = 0
    } = tr(e, t) || {};
    if (u == null)
      return {};
    const p = Hg(f), c = {
      x: a,
      y: r
    }, h = Ad(n), g = Ed(h), _ = await s.getDimensions(u), b = h === "y", m = b ? "top" : "left", w = b ? "bottom" : "right", S = b ? "clientHeight" : "clientWidth", C = o.reference[g] + o.reference[h] - c[h] - o.floating[g], v = c[h] - o.reference[h], y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let k = y ? y[S] : 0;
    (!k || !await (s.isElement == null ? void 0 : s.isElement(y))) && (k = i.floating[S] || o.floating[g]);
    const x = C / 2 - v / 2, T = k / 2 - _[g] / 2 - 1, F = Er(p[m], T), P = Er(p[w], T), O = F, I = k - _[g] - P, E = k / 2 - _[g] / 2 + x, N = xu(O, E, I), H = !l.arrow && ho(n) != null && E !== N && o.reference[g] / 2 - (E < O ? F : P) - _[g] / 2 < 0, Y = H ? E < O ? E - O : E - I : 0;
    return {
      [h]: c[h] + Y,
      data: {
        [h]: N,
        centerOffset: E - N - Y,
        ...H && {
          alignmentOffset: Y
        }
      },
      reset: H
    };
  }
}), G2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, r;
      const {
        placement: n,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: u
      } = t, {
        mainAxis: f = !0,
        crossAxis: p = !0,
        fallbackPlacements: c,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: _ = !0,
        ...b
      } = tr(e, t);
      if ((a = o.arrow) != null && a.alignmentOffset)
        return {};
      const m = ar(n), w = Ar(i), S = ar(i) === i, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), v = c || (S || !_ ? [el(i)] : V2(i)), y = g !== "none";
      !c && y && v.push(...B2(i, _, g, C));
      const k = [i, ...v], x = await Uo(t, b), T = [];
      let F = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (f && T.push(x[m]), p) {
        const E = N2(n, s, C);
        T.push(x[E[0]], x[E[1]]);
      }
      if (F = [...F, {
        placement: n,
        overflows: T
      }], !T.every((E) => E <= 0)) {
        var P, O;
        const E = (((P = o.flip) == null ? void 0 : P.index) || 0) + 1, N = k[E];
        if (N)
          return {
            data: {
              index: E,
              overflows: F
            },
            reset: {
              placement: N
            }
          };
        let H = (O = F.filter((Y) => Y.overflows[0] <= 0).sort((Y, V) => Y.overflows[1] - V.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!H)
          switch (h) {
            case "bestFit": {
              var I;
              const Y = (I = F.filter((V) => {
                if (y) {
                  const U = Ar(V.placement);
                  return U === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((U) => U > 0).reduce((U, ee) => U + ee, 0)]).sort((V, U) => V[1] - U[1])[0]) == null ? void 0 : I[0];
              Y && (H = Y);
              break;
            }
            case "initialPlacement":
              H = i;
              break;
          }
        if (n !== H)
          return {
            reset: {
              placement: H
            }
          };
      }
      return {};
    }
  };
};
function kp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function xp(e) {
  return R2.some((t) => e[t] >= 0);
}
const K2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: a
      } = t, {
        strategy: r = "referenceHidden",
        ...n
      } = tr(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await Uo(t, {
            ...n,
            elementContext: "reference"
          }), s = kp(o, a.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: xp(s)
            }
          };
        }
        case "escaped": {
          const o = await Uo(t, {
            ...n,
            altBoundary: !0
          }), s = kp(o, a.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: xp(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Z2(e, t) {
  const {
    placement: a,
    platform: r,
    elements: n
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(n.floating)), s = ar(a), i = ho(a), l = Ar(a) === "y", u = ["left", "top"].includes(s) ? -1 : 1, f = o && l ? -1 : 1, p = tr(t, e);
  let {
    mainAxis: c,
    crossAxis: h,
    alignmentAxis: g
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return i && typeof g == "number" && (h = i === "end" ? g * -1 : g), l ? {
    x: h * f,
    y: c * u
  } : {
    x: c * u,
    y: h * f
  };
}
const Y2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, r;
      const {
        x: n,
        y: o,
        placement: s,
        middlewareData: i
      } = t, l = await Z2(t, e);
      return s === ((a = i.offset) == null ? void 0 : a.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: n + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, X2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: r,
        placement: n
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: i = {
          fn: (b) => {
            let {
              x: m,
              y: w
            } = b;
            return {
              x: m,
              y: w
            };
          }
        },
        ...l
      } = tr(e, t), u = {
        x: a,
        y: r
      }, f = await Uo(t, l), p = Ar(ar(n)), c = Cd(p);
      let h = u[c], g = u[p];
      if (o) {
        const b = c === "y" ? "top" : "left", m = c === "y" ? "bottom" : "right", w = h + f[b], S = h - f[m];
        h = xu(w, h, S);
      }
      if (s) {
        const b = p === "y" ? "top" : "left", m = p === "y" ? "bottom" : "right", w = g + f[b], S = g - f[m];
        g = xu(w, g, S);
      }
      const _ = i.fn({
        ...t,
        [c]: h,
        [p]: g
      });
      return {
        ..._,
        data: {
          x: _.x - a,
          y: _.y - r,
          enabled: {
            [c]: o,
            [p]: s
          }
        }
      };
    }
  };
}, J2 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: r,
        placement: n,
        rects: o,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = tr(e, t), f = {
        x: a,
        y: r
      }, p = Ar(n), c = Cd(p);
      let h = f[c], g = f[p];
      const _ = tr(i, t), b = typeof _ == "number" ? {
        mainAxis: _,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ..._
      };
      if (l) {
        const S = c === "y" ? "height" : "width", C = o.reference[c] - o.floating[S] + b.mainAxis, v = o.reference[c] + o.reference[S] - b.mainAxis;
        h < C ? h = C : h > v && (h = v);
      }
      if (u) {
        var m, w;
        const S = c === "y" ? "width" : "height", C = ["top", "left"].includes(ar(n)), v = o.reference[p] - o.floating[S] + (C && ((m = s.offset) == null ? void 0 : m[p]) || 0) + (C ? 0 : b.crossAxis), y = o.reference[p] + o.reference[S] + (C ? 0 : ((w = s.offset) == null ? void 0 : w[p]) || 0) - (C ? b.crossAxis : 0);
        g < v ? g = v : g > y && (g = y);
      }
      return {
        [c]: h,
        [p]: g
      };
    }
  };
}, Q2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var a, r;
      const {
        placement: n,
        rects: o,
        platform: s,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...u
      } = tr(e, t), f = await Uo(t, u), p = ar(n), c = ho(n), h = Ar(n) === "y", {
        width: g,
        height: _
      } = o.floating;
      let b, m;
      p === "top" || p === "bottom" ? (b = p, m = c === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = p, b = c === "end" ? "top" : "bottom");
      const w = _ - f.top - f.bottom, S = g - f.left - f.right, C = Er(_ - f[b], w), v = Er(g - f[m], S), y = !t.middlewareData.shift;
      let k = C, x = v;
      if ((a = t.middlewareData.shift) != null && a.enabled.x && (x = S), (r = t.middlewareData.shift) != null && r.enabled.y && (k = w), y && !c) {
        const F = $t(f.left, 0), P = $t(f.right, 0), O = $t(f.top, 0), I = $t(f.bottom, 0);
        h ? x = g - 2 * (F !== 0 || P !== 0 ? F + P : $t(f.left, f.right)) : k = _ - 2 * (O !== 0 || I !== 0 ? O + I : $t(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: x,
        availableHeight: k
      });
      const T = await s.getDimensions(i.floating);
      return g !== T.width || _ !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function fc() {
  return typeof window < "u";
}
function go(e) {
  return Ug(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ta(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Na(e) {
  var t;
  return (t = (Ug(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ug(e) {
  return fc() ? e instanceof Node || e instanceof ta(e).Node : !1;
}
function ma(e) {
  return fc() ? e instanceof Element || e instanceof ta(e).Element : !1;
}
function ja(e) {
  return fc() ? e instanceof HTMLElement || e instanceof ta(e).HTMLElement : !1;
}
function zp(e) {
  return !fc() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ta(e).ShadowRoot;
}
function ni(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: r,
    display: n
  } = _a(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + a) && !["inline", "contents"].includes(n);
}
function $2(e) {
  return ["table", "td", "th"].includes(go(e));
}
function pc(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Td(e) {
  const t = Pd(), a = ma(e) ? _a(e) : e;
  return a.transform !== "none" || a.perspective !== "none" || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (a.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (a.contain || "").includes(r));
}
function ez(e) {
  let t = Tr(e);
  for (; ja(t) && !ao(t); ) {
    if (Td(t))
      return t;
    if (pc(t))
      return null;
    t = Tr(t);
  }
  return null;
}
function Pd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ao(e) {
  return ["html", "body", "#document"].includes(go(e));
}
function _a(e) {
  return ta(e).getComputedStyle(e);
}
function yc(e) {
  return ma(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Tr(e) {
  if (go(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zp(e) && e.host || // Fallback.
    Na(e)
  );
  return zp(t) ? t.host : t;
}
function Gg(e) {
  const t = Tr(e);
  return ao(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ja(t) && ni(t) ? t : Gg(t);
}
function Go(e, t, a) {
  var r;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const n = Gg(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), s = ta(n);
  if (o) {
    const i = Su(s);
    return t.concat(s, s.visualViewport || [], ni(n) ? n : [], i && a ? Go(i) : []);
  }
  return t.concat(n, Go(n, [], a));
}
function Su(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Kg(e) {
  const t = _a(e);
  let a = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const n = ja(e), o = n ? e.offsetWidth : a, s = n ? e.offsetHeight : r, i = $i(a) !== o || $i(r) !== s;
  return i && (a = o, r = s), {
    width: a,
    height: r,
    $: i
  };
}
function Od(e) {
  return ma(e) ? e : e.contextElement;
}
function Pn(e) {
  const t = Od(e);
  if (!ja(t))
    return Ma(1);
  const a = t.getBoundingClientRect(), {
    width: r,
    height: n,
    $: o
  } = Kg(t);
  let s = (o ? $i(a.width) : a.width) / r, i = (o ? $i(a.height) : a.height) / n;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const tz = /* @__PURE__ */ Ma(0);
function Zg(e) {
  const t = ta(e);
  return !Pd() || !t.visualViewport ? tz : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function az(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== ta(e) ? !1 : t;
}
function rn(e, t, a, r) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const n = e.getBoundingClientRect(), o = Od(e);
  let s = Ma(1);
  t && (r ? ma(r) && (s = Pn(r)) : s = Pn(e));
  const i = az(o, a, r) ? Zg(o) : Ma(0);
  let l = (n.left + i.x) / s.x, u = (n.top + i.y) / s.y, f = n.width / s.x, p = n.height / s.y;
  if (o) {
    const c = ta(o), h = r && ma(r) ? ta(r) : r;
    let g = c, _ = Su(g);
    for (; _ && r && h !== g; ) {
      const b = Pn(_), m = _.getBoundingClientRect(), w = _a(_), S = m.left + (_.clientLeft + parseFloat(w.paddingLeft)) * b.x, C = m.top + (_.clientTop + parseFloat(w.paddingTop)) * b.y;
      l *= b.x, u *= b.y, f *= b.x, p *= b.y, l += S, u += C, g = ta(_), _ = Su(g);
    }
  }
  return tl({
    width: f,
    height: p,
    x: l,
    y: u
  });
}
function Md(e, t) {
  const a = yc(e).scrollLeft;
  return t ? t.left + a : rn(Na(e)).left + a;
}
function Yg(e, t, a) {
  a === void 0 && (a = !1);
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - (a ? 0 : (
    // RTL <body> scrollbar.
    Md(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: n,
    y: o
  };
}
function rz(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: r,
    strategy: n
  } = e;
  const o = n === "fixed", s = Na(r), i = t ? pc(t.floating) : !1;
  if (r === s || i && o)
    return a;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ma(1);
  const f = Ma(0), p = ja(r);
  if ((p || !p && !o) && ((go(r) !== "body" || ni(s)) && (l = yc(r)), ja(r))) {
    const h = rn(r);
    u = Pn(r), f.x = h.x + r.clientLeft, f.y = h.y + r.clientTop;
  }
  const c = s && !p && !o ? Yg(s, l, !0) : Ma(0);
  return {
    width: a.width * u.x,
    height: a.height * u.y,
    x: a.x * u.x - l.scrollLeft * u.x + f.x + c.x,
    y: a.y * u.y - l.scrollTop * u.y + f.y + c.y
  };
}
function nz(e) {
  return Array.from(e.getClientRects());
}
function oz(e) {
  const t = Na(e), a = yc(e), r = e.ownerDocument.body, n = $t(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = $t(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -a.scrollLeft + Md(e);
  const i = -a.scrollTop;
  return _a(r).direction === "rtl" && (s += $t(t.clientWidth, r.clientWidth) - n), {
    width: n,
    height: o,
    x: s,
    y: i
  };
}
function sz(e, t) {
  const a = ta(e), r = Na(e), n = a.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, i = 0, l = 0;
  if (n) {
    o = n.width, s = n.height;
    const u = Pd();
    (!u || u && t === "fixed") && (i = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: i,
    y: l
  };
}
function iz(e, t) {
  const a = rn(e, !0, t === "fixed"), r = a.top + e.clientTop, n = a.left + e.clientLeft, o = ja(e) ? Pn(e) : Ma(1), s = e.clientWidth * o.x, i = e.clientHeight * o.y, l = n * o.x, u = r * o.y;
  return {
    width: s,
    height: i,
    x: l,
    y: u
  };
}
function Sp(e, t, a) {
  let r;
  if (t === "viewport")
    r = sz(e, a);
  else if (t === "document")
    r = oz(Na(e));
  else if (ma(t))
    r = iz(t, a);
  else {
    const n = Zg(e);
    r = {
      x: t.x - n.x,
      y: t.y - n.y,
      width: t.width,
      height: t.height
    };
  }
  return tl(r);
}
function Xg(e, t) {
  const a = Tr(e);
  return a === t || !ma(a) || ao(a) ? !1 : _a(a).position === "fixed" || Xg(a, t);
}
function lz(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let r = Go(e, [], !1).filter((i) => ma(i) && go(i) !== "body"), n = null;
  const o = _a(e).position === "fixed";
  let s = o ? Tr(e) : e;
  for (; ma(s) && !ao(s); ) {
    const i = _a(s), l = Td(s);
    !l && i.position === "fixed" && (n = null), (o ? !l && !n : !l && i.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || ni(s) && !l && Xg(e, s)) ? r = r.filter((f) => f !== s) : n = i, s = Tr(s);
  }
  return t.set(e, r), r;
}
function cz(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: r,
    strategy: n
  } = e;
  const s = [...a === "clippingAncestors" ? pc(t) ? [] : lz(t, this._c) : [].concat(a), r], i = s[0], l = s.reduce((u, f) => {
    const p = Sp(t, f, n);
    return u.top = $t(p.top, u.top), u.right = Er(p.right, u.right), u.bottom = Er(p.bottom, u.bottom), u.left = $t(p.left, u.left), u;
  }, Sp(t, i, n));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function uz(e) {
  const {
    width: t,
    height: a
  } = Kg(e);
  return {
    width: t,
    height: a
  };
}
function dz(e, t, a) {
  const r = ja(t), n = Na(t), o = a === "fixed", s = rn(e, !0, o, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ma(0);
  if (r || !r && !o)
    if ((go(t) !== "body" || ni(n)) && (i = yc(t)), r) {
      const c = rn(t, !0, o, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else n && (l.x = Md(n));
  const u = n && !r && !o ? Yg(n, i) : Ma(0), f = s.left + i.scrollLeft - l.x - u.x, p = s.top + i.scrollTop - l.y - u.y;
  return {
    x: f,
    y: p,
    width: s.width,
    height: s.height
  };
}
function Lc(e) {
  return _a(e).position === "static";
}
function Cp(e, t) {
  if (!ja(e) || _a(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return Na(e) === a && (a = a.ownerDocument.body), a;
}
function Jg(e, t) {
  const a = ta(e);
  if (pc(e))
    return a;
  if (!ja(e)) {
    let n = Tr(e);
    for (; n && !ao(n); ) {
      if (ma(n) && !Lc(n))
        return n;
      n = Tr(n);
    }
    return a;
  }
  let r = Cp(e, t);
  for (; r && $2(r) && Lc(r); )
    r = Cp(r, t);
  return r && ao(r) && Lc(r) && !Td(r) ? a : r || ez(e) || a;
}
const fz = async function(e) {
  const t = this.getOffsetParent || Jg, a = this.getDimensions, r = await a(e.floating);
  return {
    reference: dz(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function pz(e) {
  return _a(e).direction === "rtl";
}
const yz = {
  convertOffsetParentRelativeRectToViewportRelativeRect: rz,
  getDocumentElement: Na,
  getClippingRect: cz,
  getOffsetParent: Jg,
  getElementRects: fz,
  getClientRects: nz,
  getDimensions: uz,
  getScale: Pn,
  isElement: ma,
  isRTL: pz
};
function hz(e, t) {
  let a = null, r;
  const n = Na(e);
  function o() {
    var i;
    clearTimeout(r), (i = a) == null || i.disconnect(), a = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), o();
    const {
      left: u,
      top: f,
      width: p,
      height: c
    } = e.getBoundingClientRect();
    if (i || t(), !p || !c)
      return;
    const h = ki(f), g = ki(n.clientWidth - (u + p)), _ = ki(n.clientHeight - (f + c)), b = ki(u), w = {
      rootMargin: -h + "px " + -g + "px " + -_ + "px " + -b + "px",
      threshold: $t(0, Er(1, l)) || 1
    };
    let S = !0;
    function C(v) {
      const y = v[0].intersectionRatio;
      if (y !== l) {
        if (!S)
          return s();
        y ? s(!1, y) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      a = new IntersectionObserver(C, {
        ...w,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(C, w);
    }
    a.observe(e);
  }
  return s(!0), o;
}
function gz(e, t, a, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Od(e), f = n || o ? [...u ? Go(u) : [], ...Go(t)] : [];
  f.forEach((m) => {
    n && m.addEventListener("scroll", a, {
      passive: !0
    }), o && m.addEventListener("resize", a);
  });
  const p = u && i ? hz(u, a) : null;
  let c = -1, h = null;
  s && (h = new ResizeObserver((m) => {
    let [w] = m;
    w && w.target === u && h && (h.unobserve(t), cancelAnimationFrame(c), c = requestAnimationFrame(() => {
      var S;
      (S = h) == null || S.observe(t);
    })), a();
  }), u && !l && h.observe(u), h.observe(t));
  let g, _ = l ? rn(e) : null;
  l && b();
  function b() {
    const m = rn(e);
    _ && (m.x !== _.x || m.y !== _.y || m.width !== _.width || m.height !== _.height) && a(), _ = m, g = requestAnimationFrame(b);
  }
  return a(), () => {
    var m;
    f.forEach((w) => {
      n && w.removeEventListener("scroll", a), o && w.removeEventListener("resize", a);
    }), p == null || p(), (m = h) == null || m.disconnect(), h = null, l && cancelAnimationFrame(g);
  };
}
const mz = Y2, _z = X2, wz = G2, vz = Q2, bz = K2, kz = U2, xz = J2, zz = (e, t, a) => {
  const r = /* @__PURE__ */ new Map(), n = {
    platform: yz,
    ...a
  }, o = {
    ...n.platform,
    _c: r
  };
  return H2(e, t, {
    ...n,
    platform: o
  });
};
function So(e) {
  return typeof e == "function" ? e() : e;
}
function Qg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ep(e, t) {
  const a = Qg(e);
  return Math.round(t * a) / a;
}
function Ap(e) {
  return {
    [`--bits-${e}-content-transform-origin`]: "var(--bits-floating-transform-origin)",
    [`--bits-${e}-content-available-width`]: "var(--bits-floating-available-width)",
    [`--bits-${e}-content-available-height`]: "var(--bits-floating-available-height)",
    [`--bits-${e}-anchor-width`]: "var(--bits-floating-anchor-width)",
    [`--bits-${e}-anchor-height`]: "var(--bits-floating-anchor-height)"
  };
}
function Sz(e) {
  const t = e.whileElementsMounted, a = /* @__PURE__ */ M(() => So(e.open) ?? !0), r = /* @__PURE__ */ M(() => So(e.middleware)), n = /* @__PURE__ */ M(() => So(e.transform) ?? !0), o = /* @__PURE__ */ M(() => So(e.placement) ?? "bottom"), s = /* @__PURE__ */ M(() => So(e.strategy) ?? "absolute"), i = e.reference;
  let l = me(0), u = me(0);
  const f = de(null);
  let p = me(ce(d(s))), c = me(ce(d(o))), h = me(ce({})), g = me(!1);
  const _ = /* @__PURE__ */ M(() => {
    const v = {
      position: d(p),
      left: "0",
      top: "0"
    };
    if (!f.current)
      return v;
    const y = Ep(f.current, d(l)), k = Ep(f.current, d(u));
    return d(n) ? {
      ...v,
      transform: `translate(${y}px, ${k}px)`,
      ...Qg(f.current) >= 1.5 && { willChange: "transform" }
    } : {
      position: d(p),
      left: `${y}px`,
      top: `${k}px`
    };
  });
  let b;
  function m() {
    i.current === null || f.current === null || zz(i.current, f.current, {
      middleware: d(r),
      placement: d(o),
      strategy: d(s)
    }).then((v) => {
      q(l, ce(v.x)), q(u, ce(v.y)), q(p, ce(v.strategy)), q(c, ce(v.placement)), q(h, ce(v.middlewareData)), q(g, !0);
    });
  }
  function w() {
    typeof b == "function" && (b(), b = void 0);
  }
  function S() {
    if (w(), t === void 0) {
      m();
      return;
    }
    i.current === null || f.current === null || (b = t(i.current, f.current, m));
  }
  function C() {
    d(a) || q(g, !1);
  }
  return Pe(m), Pe(S), Pe(C), Pe(() => w), {
    floating: f,
    reference: i,
    get strategy() {
      return d(p);
    },
    get placement() {
      return d(c);
    },
    get middlewareData() {
      return d(h);
    },
    get isPositioned() {
      return d(g);
    },
    get floatingStyles() {
      return d(_);
    },
    get update() {
      return m;
    }
  };
}
const Cz = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
class Ez {
  constructor() {
    Ve(this, "anchorNode", de(null));
    Ve(this, "customAnchorNode", de(null));
    Ve(this, "triggerNode", de(null));
    Pe(() => {
      this.customAnchorNode.current ? typeof this.customAnchorNode.current == "string" ? this.anchorNode.current = document.querySelector(this.customAnchorNode.current) : this.anchorNode.current = this.customAnchorNode.current : this.anchorNode.current = this.triggerNode.current;
    });
  }
}
var ks, xs, zs, Ss, Wn, Cs, Es, Hn, Zr, As, Ts, Ps, Os, Ms, Is, Ol, Fs, Ml, js, Il, Fl, Rs, Ls, Ds, Ns, jl, Rl, Ll, Dl, Nl, Vl, Vs, ql, Bl, Wl, Hl;
class Az {
  constructor(t, a) {
    // state
    Ve(this, "root");
    // nodes
    Ve(this, "contentRef", de(null));
    Ve(this, "wrapperRef", de(null));
    Ve(this, "arrowRef", de(null));
    // ids
    Ve(this, "arrowId", de(or()));
    Ve(this, "id");
    Ve(this, "wrapperId");
    Ve(this, "style");
    ne(this, ks, /* @__PURE__ */ M(() => {
      if (typeof this.style == "string") return Oo(this.style);
      if (!this.style) return {};
    }));
    ne(this, xs);
    ne(this, zs);
    ne(this, Ss);
    ne(this, Wn);
    ne(this, Cs);
    ne(this, Es);
    ne(this, Hn);
    ne(this, Zr);
    ne(this, As);
    ne(this, Ts);
    ne(this, Ps);
    ne(this, Os);
    ne(this, Ms);
    Ve(this, "onPlaced");
    Ve(this, "enabled");
    ne(this, Is, new Yx(() => this.arrowRef.current ?? void 0));
    ne(this, Ol, /* @__PURE__ */ M(() => {
      var t;
      return ((t = j(this, Is)) == null ? void 0 : t.width) ?? 0;
    }));
    ne(this, Fs, /* @__PURE__ */ M(() => {
      var t;
      return ((t = j(this, Is)) == null ? void 0 : t.height) ?? 0;
    }));
    ne(this, Ml, /* @__PURE__ */ M(() => {
      var t;
      return ((t = j(this, zs)) == null ? void 0 : t.current) + (j(this, Wn).current !== "center" ? `-${j(this, Wn).current}` : "");
    }));
    ne(this, js, /* @__PURE__ */ M(() => Array.isArray(j(this, Zr).current) ? j(this, Zr).current : [j(this, Zr).current]));
    ne(this, Il, /* @__PURE__ */ M(() => d(j(this, js)).length > 0));
    ne(this, Fl, /* @__PURE__ */ M(() => ({
      padding: j(this, As).current,
      boundary: d(j(this, js)).filter(qx),
      altBoundary: this.hasExplicitBoundaries
    })));
    ne(this, Rs, me(void 0));
    ne(this, Ls, me(void 0));
    ne(this, Ds, me(void 0));
    ne(this, Ns, me(void 0));
    ne(this, jl, /* @__PURE__ */ M(() => [
      mz({
        mainAxis: j(this, Ss).current + d(j(this, Fs)),
        alignmentAxis: j(this, Cs).current
      }),
      j(this, Hn) && _z({
        mainAxis: !0,
        crossAxis: !1,
        limiter: j(this, Ts).current === "partial" ? xz() : void 0,
        ...this.detectOverflowOptions
      }),
      j(this, Hn) && wz({ ...this.detectOverflowOptions }),
      vz({
        ...this.detectOverflowOptions,
        apply: ({ rects: t, availableWidth: a, availableHeight: r }) => {
          const { width: n, height: o } = t.reference;
          q(j(this, Rs), ce(a)), q(j(this, Ls), ce(r)), q(j(this, Ds), ce(n)), q(j(this, Ns), ce(o));
        }
      }),
      this.arrowRef.current && kz({
        element: this.arrowRef.current,
        padding: j(this, Es).current
      }),
      Fz({
        arrowWidth: d(j(this, Ol)),
        arrowHeight: d(j(this, Fs))
      }),
      j(this, Ps).current && bz({
        strategy: "referenceHidden",
        ...this.detectOverflowOptions
      })
    ].filter(Boolean)));
    Ve(this, "floating");
    ne(this, Rl, /* @__PURE__ */ M(() => jz(this.floating.placement)));
    ne(this, Ll, /* @__PURE__ */ M(() => Rz(this.floating.placement)));
    ne(this, Dl, /* @__PURE__ */ M(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.x) ?? 0;
    }));
    ne(this, Nl, /* @__PURE__ */ M(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.y) ?? 0;
    }));
    ne(this, Vl, /* @__PURE__ */ M(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.centerOffset) !== 0;
    }));
    ne(this, Vs, me());
    ne(this, ql, /* @__PURE__ */ M(() => Cz[this.placedSide]));
    ne(this, Bl, /* @__PURE__ */ M(() => {
      var t, a, r;
      return {
        id: this.wrapperId.current,
        "data-bits-floating-content-wrapper": "",
        style: {
          ...this.floating.floatingStyles,
          // keep off page when measuring
          transform: this.floating.isPositioned ? this.floating.floatingStyles.transform : "translate(0, -200%)",
          minWidth: "max-content",
          zIndex: this.contentZIndex,
          "--bits-floating-transform-origin": `${(t = this.floating.middlewareData.transformOrigin) == null ? void 0 : t.x} ${(a = this.floating.middlewareData.transformOrigin) == null ? void 0 : a.y}`,
          "--bits-floating-available-width": `${d(j(this, Rs))}px`,
          "--bits-floating-available-height": `${d(j(this, Ls))}px`,
          "--bits-floating-anchor-width": `${d(j(this, Ds))}px`,
          "--bits-floating-anchor-height": `${d(j(this, Ns))}px`,
          // hide the content if using the hide middleware and should be hidden
          ...((r = this.floating.middlewareData.hide) == null ? void 0 : r.referenceHidden) && {
            visibility: "hidden",
            "pointer-events": "none"
          },
          ...d(j(this, ks))
        },
        // Floating UI calculates logical alignment based the `dir` attribute
        dir: j(this, xs).current
      };
    }));
    ne(this, Wl, /* @__PURE__ */ M(() => ({
      "data-side": this.placedSide,
      "data-align": this.placedAlign,
      style: bd({
        ...d(j(this, ks))
        // if the FloatingContent hasn't been placed yet (not all measurements done)
      })
    })));
    ne(this, Hl, /* @__PURE__ */ M(() => ({
      position: "absolute",
      left: this.arrowX ? `${this.arrowX}px` : void 0,
      top: this.arrowY ? `${this.arrowY}px` : void 0,
      [this.arrowBaseSide]: 0,
      "transform-origin": {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[this.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[this.placedSide],
      visibility: this.cannotCenterArrow ? "hidden" : void 0
    })));
    this.id = t.id, Ie(this, zs, t.side), Ie(this, Ss, t.sideOffset), Ie(this, Wn, t.align), Ie(this, Cs, t.alignOffset), Ie(this, Es, t.arrowPadding), Ie(this, Hn, t.avoidCollisions), Ie(this, Zr, t.collisionBoundary), Ie(this, As, t.collisionPadding), Ie(this, Ts, t.sticky), Ie(this, Ps, t.hideWhenDetached), Ie(this, Ms, t.updatePositionStrategy), this.onPlaced = t.onPlaced, Ie(this, Os, t.strategy), Ie(this, xs, t.dir), this.style = t.style, this.root = a, this.enabled = t.enabled, this.wrapperId = t.wrapperId, t.customAnchor && (this.root.customAnchorNode.current = t.customAnchor.current), Pe(() => {
      t.customAnchor.current, zt(() => {
        this.root.customAnchorNode.current = t.customAnchor.current;
      });
    }), Fa({
      id: this.wrapperId,
      ref: this.wrapperRef,
      deps: () => this.enabled.current
    }), Fa({
      id: this.id,
      ref: this.contentRef,
      deps: () => this.enabled.current
    }), this.floating = Sz({
      strategy: () => j(this, Os).current,
      placement: () => d(j(this, Ml)),
      middleware: () => this.middleware,
      reference: this.root.anchorNode,
      whileElementsMounted: (...r) => {
        var o;
        return gz(...r, {
          animationFrame: ((o = j(this, Ms)) == null ? void 0 : o.current) === "always"
        });
      },
      open: () => this.enabled.current
    }), Pe(() => {
      var r;
      this.floating.isPositioned && ((r = this.onPlaced) == null || r.current());
    }), Pe(() => {
      const r = this.contentRef.current;
      r && zt(() => {
        this.contentZIndex = window.getComputedStyle(r).zIndex;
      });
    }), Pe(() => {
      this.floating.floating.current = this.wrapperRef.current;
    });
  }
  get hasExplicitBoundaries() {
    return d(j(this, Il));
  }
  get detectOverflowOptions() {
    return d(j(this, Fl));
  }
  get middleware() {
    return d(j(this, jl));
  }
  get placedSide() {
    return d(j(this, Rl));
  }
  get placedAlign() {
    return d(j(this, Ll));
  }
  get arrowX() {
    return d(j(this, Dl));
  }
  get arrowY() {
    return d(j(this, Nl));
  }
  get cannotCenterArrow() {
    return d(j(this, Vl));
  }
  get contentZIndex() {
    return d(j(this, Vs));
  }
  set contentZIndex(t) {
    q(j(this, Vs), ce(t));
  }
  get arrowBaseSide() {
    return d(j(this, ql));
  }
  get wrapperProps() {
    return d(j(this, Bl));
  }
  get props() {
    return d(j(this, Wl));
  }
  get arrowStyle() {
    return d(j(this, Hl));
  }
}
ks = new WeakMap(), xs = new WeakMap(), zs = new WeakMap(), Ss = new WeakMap(), Wn = new WeakMap(), Cs = new WeakMap(), Es = new WeakMap(), Hn = new WeakMap(), Zr = new WeakMap(), As = new WeakMap(), Ts = new WeakMap(), Ps = new WeakMap(), Os = new WeakMap(), Ms = new WeakMap(), Is = new WeakMap(), Ol = new WeakMap(), Fs = new WeakMap(), Ml = new WeakMap(), js = new WeakMap(), Il = new WeakMap(), Fl = new WeakMap(), Rs = new WeakMap(), Ls = new WeakMap(), Ds = new WeakMap(), Ns = new WeakMap(), jl = new WeakMap(), Rl = new WeakMap(), Ll = new WeakMap(), Dl = new WeakMap(), Nl = new WeakMap(), Vl = new WeakMap(), Vs = new WeakMap(), ql = new WeakMap(), Bl = new WeakMap(), Wl = new WeakMap(), Hl = new WeakMap();
const [
  Tz,
  Pz
] = dc("Floating.Root"), [
  Oz,
  vte
] = dc("Floating.Content");
function Mz() {
  return Tz(new Ez());
}
function Iz(e) {
  return Oz(new Az(e, Pz()));
}
function Fz(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(t) {
      var b, m, w;
      const { placement: a, rects: r, middlewareData: n } = t, s = ((b = n.arrow) == null ? void 0 : b.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, f] = Id(a), p = { start: "0%", center: "50%", end: "100%" }[f], c = (((m = n.arrow) == null ? void 0 : m.x) ?? 0) + i / 2, h = (((w = n.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
      let g = "", _ = "";
      return u === "bottom" ? (g = s ? p : `${c}px`, _ = `${-l}px`) : u === "top" ? (g = s ? p : `${c}px`, _ = `${r.floating.height + l}px`) : u === "right" ? (g = `${-l}px`, _ = s ? p : `${h}px`) : u === "left" && (g = `${r.floating.width + l}px`, _ = s ? p : `${h}px`), { data: { x: g, y: _ } };
    }
  };
}
function Id(e) {
  const [t, a = "center"] = e.split("-");
  return [t, a];
}
function jz(e) {
  return Id(e)[0];
}
function Rz(e) {
  return Id(e)[1];
}
function Lz(e, t) {
  ke(t, !0), Mz();
  var a = K(), r = D(a);
  nt(r, () => t.children ?? qe), z(e, a), xe();
}
var Dz = /* @__PURE__ */ L("<div><!></div>");
function Nz(e, t) {
  ke(t, !0);
  let a = R(t, "side", 3, "bottom"), r = R(t, "sideOffset", 3, 0), n = R(t, "align", 3, "center"), o = R(t, "alignOffset", 3, 0), s = R(t, "arrowPadding", 3, 0), i = R(t, "avoidCollisions", 3, !0), l = R(t, "collisionBoundary", 19, () => []), u = R(t, "collisionPadding", 3, 0), f = R(t, "hideWhenDetached", 3, !1), p = R(t, "onPlaced", 3, () => {
  }), c = R(t, "sticky", 3, "partial"), h = R(t, "updatePositionStrategy", 3, "optimized"), g = R(t, "strategy", 3, "fixed"), _ = R(t, "dir", 3, "ltr"), b = R(t, "style", 19, () => ({})), m = R(t, "wrapperId", 19, or), w = R(t, "customAnchor", 3, null);
  const S = Iz({
    side: de.with(() => a()),
    sideOffset: de.with(() => r()),
    align: de.with(() => n()),
    alignOffset: de.with(() => o()),
    id: de.with(() => t.id),
    arrowPadding: de.with(() => s()),
    avoidCollisions: de.with(() => i()),
    collisionBoundary: de.with(() => l()),
    collisionPadding: de.with(() => u()),
    hideWhenDetached: de.with(() => f()),
    onPlaced: de.with(() => p()),
    sticky: de.with(() => c()),
    updatePositionStrategy: de.with(() => h()),
    strategy: de.with(() => g()),
    dir: de.with(() => _()),
    style: de.with(() => b()),
    enabled: de.with(() => !1),
    wrapperId: de.with(() => m()),
    customAnchor: de.with(() => w())
  }), C = /* @__PURE__ */ M(() => ea(S.wrapperProps, { style: { pointerEvents: "auto" } }));
  var v = Dz();
  let y;
  var k = A(v);
  nt(k, () => t.content ?? qe, () => ({ props: S.props })), $(() => y = at(v, y, { ...d(C) })), z(e, v), xe();
}
function Vz(e, t) {
  ke(t, !0), Da(() => {
    var n;
    (n = t.onPlaced) == null || n.call(t);
  });
  var a = K(), r = D(a);
  nt(r, () => t.content ?? qe, () => ({ props: {} })), z(e, a), xe();
}
const qz = "data-separator-root";
var Un, qs, Gn, Kn, Ul;
class Bz {
  constructor(t) {
    ne(this, Un);
    ne(this, qs);
    ne(this, Gn);
    ne(this, Kn);
    ne(this, Ul, /* @__PURE__ */ M(() => ({
      id: j(this, Un).current,
      role: j(this, Kn).current ? "none" : "separator",
      "aria-orientation": j(this, Gn).current,
      "aria-hidden": Fx(j(this, Kn).current),
      "data-orientation": j(this, Gn).current,
      [qz]: ""
    })));
    Ie(this, Gn, t.orientation), Ie(this, Kn, t.decorative), Ie(this, Un, t.id), Ie(this, qs, t.ref), Fa({ id: j(this, Un), ref: j(this, qs) });
  }
  get props() {
    return d(j(this, Ul));
  }
}
Un = new WeakMap(), qs = new WeakMap(), Gn = new WeakMap(), Kn = new WeakMap(), Ul = new WeakMap();
function Wz(e) {
  return new Bz(e);
}
var Hz = /* @__PURE__ */ L("<div><!></div>");
function Uz(e, t) {
  ke(t, !0);
  let a = R(t, "id", 19, or), r = R(t, "ref", 15, null), n = R(t, "decorative", 3, !1), o = R(t, "orientation", 3, "horizontal"), s = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "ref",
    "child",
    "children",
    "decorative",
    "orientation"
  ]);
  const i = Wz({
    ref: de.with(() => r(), (h) => r(h)),
    id: de.with(() => a()),
    decorative: de.with(() => n()),
    orientation: de.with(() => o())
  }), l = /* @__PURE__ */ M(() => ea(s, i.props));
  var u = K(), f = D(u);
  {
    var p = (h) => {
      var g = K(), _ = D(g);
      nt(_, () => t.child, () => ({ props: d(l) })), z(h, g);
    }, c = (h) => {
      var g = Hz();
      let _;
      var b = A(g);
      nt(b, () => t.children ?? qe), $(() => _ = at(g, _, { ...d(l) })), z(h, g);
    };
    B(f, (h) => {
      t.child ? h(p) : h(c, !1);
    });
  }
  z(e, u), xe();
}
function Gz(e, t) {
  let a = R(t, "isStatic", 3, !1), r = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "content",
    "isStatic",
    "onPlaced"
  ]);
  var n = K(), o = D(n);
  {
    var s = (l) => {
      Vz(l, {
        get content() {
          return t.content;
        },
        get onPlaced() {
          return t.onPlaced;
        }
      });
    }, i = (l) => {
      Nz(l, it(
        {
          get content() {
            return t.content;
          },
          get onPlaced() {
            return t.onPlaced;
          }
        },
        () => r
      ));
    };
    B(o, (l) => {
      a() ? l(s) : l(i, !1);
    });
  }
  z(e, n);
}
var Kz = /* @__PURE__ */ L("<!> <!>", 1);
function $g(e, t) {
  ke(t, !0);
  let a = R(t, "interactOutsideBehavior", 3, "close"), r = R(t, "trapFocus", 3, !0), n = R(t, "isValidEvent", 3, () => !1), o = R(t, "customAnchor", 3, null), s = R(t, "isStatic", 3, !1), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled"
  ]);
  Gz(e, {
    get isStatic() {
      return s();
    },
    get id() {
      return t.id;
    },
    get side() {
      return t.side;
    },
    get sideOffset() {
      return t.sideOffset;
    },
    get align() {
      return t.align;
    },
    get alignOffset() {
      return t.alignOffset;
    },
    get arrowPadding() {
      return t.arrowPadding;
    },
    get avoidCollisions() {
      return t.avoidCollisions;
    },
    get collisionBoundary() {
      return t.collisionBoundary;
    },
    get collisionPadding() {
      return t.collisionPadding;
    },
    get sticky() {
      return t.sticky;
    },
    get hideWhenDetached() {
      return t.hideWhenDetached;
    },
    get updatePositionStrategy() {
      return t.updatePositionStrategy;
    },
    get strategy() {
      return t.strategy;
    },
    get dir() {
      return t.dir;
    },
    get wrapperId() {
      return t.wrapperId;
    },
    get style() {
      return t.style;
    },
    get onPlaced() {
      return t.onPlaced;
    },
    get customAnchor() {
      return o();
    },
    content: (u, f) => {
      let p = () => f == null ? void 0 : f().props;
      var c = Kz(), h = D(c);
      {
        var g = (w) => {
          Qi(w, {
            get preventScroll() {
              return t.preventScroll;
            }
          });
        }, _ = (w) => {
          var S = K(), C = D(S);
          {
            var v = (y) => {
              Qi(y, {
                get preventScroll() {
                  return t.preventScroll;
                }
              });
            };
            B(
              C,
              (y) => {
                t.forceMount || y(v);
              },
              !0
            );
          }
          z(w, S);
        };
        B(h, (w) => {
          t.forceMount && t.enabled ? w(g) : w(_, !1);
        });
      }
      var b = X(h, 2), m = /* @__PURE__ */ M(() => t.enabled && r());
      qg(b, {
        get id() {
          return t.id;
        },
        get onOpenAutoFocus() {
          return t.onOpenAutoFocus;
        },
        get onCloseAutoFocus() {
          return t.onCloseAutoFocus;
        },
        get loop() {
          return t.loop;
        },
        get trapFocus() {
          return d(m);
        },
        get forceMount() {
          return t.forceMount;
        },
        focusScope: (S, C) => {
          let v = () => C == null ? void 0 : C().props;
          Ng(S, {
            get onEscapeKeydown() {
              return t.onEscapeKeydown;
            },
            get escapeKeydownBehavior() {
              return t.escapeKeydownBehavior;
            },
            get enabled() {
              return t.enabled;
            },
            children: (y, k) => {
              Dg(y, {
                get id() {
                  return t.id;
                },
                get onInteractOutside() {
                  return t.onInteractOutside;
                },
                get onFocusOutside() {
                  return t.onFocusOutside;
                },
                get interactOutsideBehavior() {
                  return a();
                },
                get isValidEvent() {
                  return n();
                },
                get enabled() {
                  return t.enabled;
                },
                children: (T, F) => {
                  let P = () => F == null ? void 0 : F().props;
                  Wg(T, {
                    get id() {
                      return t.id;
                    },
                    get preventOverflowTextSelection() {
                      return t.preventOverflowTextSelection;
                    },
                    get onPointerDown() {
                      return t.onPointerDown;
                    },
                    get onPointerUp() {
                      return t.onPointerUp;
                    },
                    get enabled() {
                      return t.enabled;
                    },
                    children: (O, I) => {
                      var E = K(), N = D(E), H = /* @__PURE__ */ kt(() => ({
                        props: ea(i, p(), P(), v(), { style: { pointerEvents: "auto" } })
                      }));
                      nt(N, () => t.popper ?? qe, () => d(H)), z(O, E);
                    },
                    $$slots: { default: !0 }
                  });
                },
                $$slots: { default: !0 }
              });
            },
            $$slots: { default: !0 }
          });
        },
        $$slots: { focusScope: !0 }
      }), z(u, c);
    },
    $$slots: { content: !0 }
  }), xe();
}
function Zz(e, t) {
  let a = R(t, "interactOutsideBehavior", 3, "close"), r = R(t, "trapFocus", 3, !0), n = R(t, "isValidEvent", 3, () => !1), o = R(t, "customAnchor", 3, null), s = R(t, "isStatic", 3, !1), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "present",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic"
  ]);
  xd(e, it(
    {
      get id() {
        return t.id;
      },
      get present() {
        return t.present;
      }
    },
    () => i,
    { presence: (u, f) => {
      let p = () => f == null ? void 0 : f().present;
      $g(u, it(
        {
          get popper() {
            return t.popper;
          },
          get onEscapeKeydown() {
            return t.onEscapeKeydown;
          },
          get escapeKeydownBehavior() {
            return t.escapeKeydownBehavior;
          },
          get preventOverflowTextSelection() {
            return t.preventOverflowTextSelection;
          },
          get id() {
            return t.id;
          },
          get onPointerDown() {
            return t.onPointerDown;
          },
          get onPointerUp() {
            return t.onPointerUp;
          },
          get side() {
            return t.side;
          },
          get sideOffset() {
            return t.sideOffset;
          },
          get align() {
            return t.align;
          },
          get alignOffset() {
            return t.alignOffset;
          },
          get arrowPadding() {
            return t.arrowPadding;
          },
          get avoidCollisions() {
            return t.avoidCollisions;
          },
          get collisionBoundary() {
            return t.collisionBoundary;
          },
          get collisionPadding() {
            return t.collisionPadding;
          },
          get sticky() {
            return t.sticky;
          },
          get hideWhenDetached() {
            return t.hideWhenDetached;
          },
          get updatePositionStrategy() {
            return t.updatePositionStrategy;
          },
          get strategy() {
            return t.strategy;
          },
          get dir() {
            return t.dir;
          },
          get preventScroll() {
            return t.preventScroll;
          },
          get wrapperId() {
            return t.wrapperId;
          },
          get style() {
            return t.style;
          },
          get onPlaced() {
            return t.onPlaced;
          },
          get customAnchor() {
            return o();
          },
          get isStatic() {
            return s();
          },
          get enabled() {
            return p().current;
          },
          get onInteractOutside() {
            return t.onInteractOutside;
          },
          get onCloseAutoFocus() {
            return t.onCloseAutoFocus;
          },
          get onOpenAutoFocus() {
            return t.onOpenAutoFocus;
          },
          get interactOutsideBehavior() {
            return a();
          },
          get loop() {
            return t.loop;
          },
          get trapFocus() {
            return r();
          },
          get isValidEvent() {
            return n();
          },
          get onFocusOutside() {
            return t.onFocusOutside;
          },
          forceMount: !1
        },
        () => i
      ));
    }, $$slots: { presence: !0 } }
  ));
}
function Yz(e, t) {
  let a = R(t, "interactOutsideBehavior", 3, "close"), r = R(t, "trapFocus", 3, !0), n = R(t, "isValidEvent", 3, () => !1), o = R(t, "customAnchor", 3, null), s = R(t, "isStatic", 3, !1), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled"
  ]);
  $g(e, it(
    {
      get popper() {
        return t.popper;
      },
      get onEscapeKeydown() {
        return t.onEscapeKeydown;
      },
      get escapeKeydownBehavior() {
        return t.escapeKeydownBehavior;
      },
      get preventOverflowTextSelection() {
        return t.preventOverflowTextSelection;
      },
      get id() {
        return t.id;
      },
      get onPointerDown() {
        return t.onPointerDown;
      },
      get onPointerUp() {
        return t.onPointerUp;
      },
      get side() {
        return t.side;
      },
      get sideOffset() {
        return t.sideOffset;
      },
      get align() {
        return t.align;
      },
      get alignOffset() {
        return t.alignOffset;
      },
      get arrowPadding() {
        return t.arrowPadding;
      },
      get avoidCollisions() {
        return t.avoidCollisions;
      },
      get collisionBoundary() {
        return t.collisionBoundary;
      },
      get collisionPadding() {
        return t.collisionPadding;
      },
      get sticky() {
        return t.sticky;
      },
      get hideWhenDetached() {
        return t.hideWhenDetached;
      },
      get updatePositionStrategy() {
        return t.updatePositionStrategy;
      },
      get strategy() {
        return t.strategy;
      },
      get dir() {
        return t.dir;
      },
      get preventScroll() {
        return t.preventScroll;
      },
      get wrapperId() {
        return t.wrapperId;
      },
      get style() {
        return t.style;
      },
      get onPlaced() {
        return t.onPlaced;
      },
      get customAnchor() {
        return o();
      },
      get isStatic() {
        return s();
      },
      get enabled() {
        return t.enabled;
      },
      get onInteractOutside() {
        return t.onInteractOutside;
      },
      get onCloseAutoFocus() {
        return t.onCloseAutoFocus;
      },
      get onOpenAutoFocus() {
        return t.onOpenAutoFocus;
      },
      get interactOutsideBehavior() {
        return a();
      },
      get loop() {
        return t.loop;
      },
      get trapFocus() {
        return r();
      },
      get isValidEvent() {
        return n();
      },
      get onFocusOutside() {
        return t.onFocusOutside;
      }
    },
    () => i,
    { forceMount: !0 }
  ));
}
var Bs, Ws, Hs;
class Xz {
  constructor(t) {
    Ve(this, "open");
    ne(this, Bs, me(null));
    ne(this, Ws, me(void 0));
    ne(this, Hs, me(null));
    Ve(this, "toggleOpen", () => {
      this.open.current = !this.open.current;
    });
    Ve(this, "close", () => {
      this.open.current && (this.open.current = !1);
    });
    this.open = t.open;
  }
  get contentNode() {
    return d(j(this, Bs));
  }
  set contentNode(t) {
    q(j(this, Bs), ce(t));
  }
  get contentId() {
    return d(j(this, Ws));
  }
  set contentId(t) {
    q(j(this, Ws), ce(t));
  }
  get triggerNode() {
    return d(j(this, Hs));
  }
  set triggerNode(t) {
    q(j(this, Hs), ce(t));
  }
}
Bs = new WeakMap(), Ws = new WeakMap(), Hs = new WeakMap();
var Zn, Us, Gl, Kl;
class Jz {
  constructor(t, a) {
    ne(this, Zn);
    ne(this, Us);
    Ve(this, "root");
    ne(this, Gl, /* @__PURE__ */ M(() => ({ open: this.root.open.current })));
    ne(this, Kl, /* @__PURE__ */ M(() => ({
      id: j(this, Zn).current,
      tabindex: -1,
      "data-state": Mg(this.root.open.current),
      "data-popover-content": "",
      style: { pointerEvents: "auto" }
    })));
    Ie(this, Zn, t.id), this.root = a, Ie(this, Us, t.ref), Fa({
      id: j(this, Zn),
      ref: j(this, Us),
      deps: () => this.root.open.current,
      onRefChange: (r) => {
        this.root.contentNode = r, this.root.contentId = r == null ? void 0 : r.id;
      }
    });
  }
  get snippetProps() {
    return d(j(this, Gl));
  }
  get props() {
    return d(j(this, Kl));
  }
}
Zn = new WeakMap(), Us = new WeakMap(), Gl = new WeakMap(), Kl = new WeakMap();
const [Qz, $z] = dc("Popover.Root");
function e3(e) {
  return Qz(new Xz(e));
}
function t3(e) {
  return new Jz(e, $z());
}
var a3 = /* @__PURE__ */ L("<div><!></div>"), r3 = /* @__PURE__ */ L("<div><!></div>");
function Tp(e, t) {
  ke(t, !0);
  let a = R(t, "ref", 15, null), r = R(t, "id", 19, or), n = R(t, "forceMount", 3, !1), o = R(t, "onCloseAutoFocus", 3, Tt), s = R(t, "onEscapeKeydown", 3, Tt), i = R(t, "onInteractOutside", 3, Tt), l = R(t, "trapFocus", 3, !0), u = R(t, "preventScroll", 3, !1), f = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "child",
    "children",
    "ref",
    "id",
    "forceMount",
    "onCloseAutoFocus",
    "onEscapeKeydown",
    "onInteractOutside",
    "trapFocus",
    "preventScroll"
  ]);
  const p = t3({
    id: de.with(() => r()),
    ref: de.with(() => a(), (C) => a(C))
  }), c = /* @__PURE__ */ M(() => ea(f, p.props));
  function h(C) {
    i()(C), !C.defaultPrevented && p.root.close();
  }
  function g(C) {
    s()(C), !C.defaultPrevented && p.root.close();
  }
  function _(C) {
    var v;
    o()(C), !C.defaultPrevented && (C.preventDefault(), (v = p.root.triggerNode) == null || v.focus());
  }
  var b = K(), m = D(b);
  {
    var w = (C) => {
      Yz(C, it(() => d(c), {
        get enabled() {
          return p.root.open.current;
        },
        get id() {
          return r();
        },
        onInteractOutside: h,
        onEscapeKeydown: g,
        onCloseAutoFocus: _,
        get trapFocus() {
          return l();
        },
        get preventScroll() {
          return u();
        },
        loop: !0,
        forceMount: !0,
        popper: (y, k) => {
          let x = () => k == null ? void 0 : k().props;
          var T = K();
          const F = /* @__PURE__ */ M(() => ea(x(), {
            style: Ap("popover")
          }));
          var P = D(T);
          {
            var O = (E) => {
              var N = K(), H = D(N);
              nt(H, () => t.child, () => ({
                props: d(F),
                ...p.snippetProps
              })), z(E, N);
            }, I = (E) => {
              var N = a3();
              let H;
              var Y = A(N);
              nt(Y, () => t.children ?? qe), $(() => H = at(N, H, { ...d(F) })), z(E, N);
            };
            B(P, (E) => {
              t.child ? E(O) : E(I, !1);
            });
          }
          z(y, T);
        },
        $$slots: { popper: !0 }
      }));
    }, S = (C) => {
      var v = K(), y = D(v);
      {
        var k = (x) => {
          Zz(x, it(() => d(c), {
            get present() {
              return p.root.open.current;
            },
            get id() {
              return r();
            },
            onInteractOutside: h,
            onEscapeKeydown: g,
            onCloseAutoFocus: _,
            get trapFocus() {
              return l();
            },
            get preventScroll() {
              return u();
            },
            loop: !0,
            forceMount: !1,
            popper: (F, P) => {
              let O = () => P == null ? void 0 : P().props;
              var I = K();
              const E = /* @__PURE__ */ M(() => ea(O(), {
                style: Ap("popover")
              }));
              var N = D(I);
              {
                var H = (V) => {
                  var U = K(), ee = D(U);
                  nt(ee, () => t.child, () => ({
                    props: d(E),
                    ...p.snippetProps
                  })), z(V, U);
                }, Y = (V) => {
                  var U = r3();
                  let ee;
                  var W = A(U);
                  nt(W, () => t.children ?? qe), $(() => ee = at(U, ee, { ...d(E) })), z(V, U);
                };
                B(N, (V) => {
                  t.child ? V(H) : V(Y, !1);
                });
              }
              z(F, I);
            },
            $$slots: { popper: !0 }
          }));
        };
        B(
          y,
          (x) => {
            n() || x(k);
          },
          !0
        );
      }
      z(C, v);
    };
    B(m, (C) => {
      n() ? C(w) : C(S, !1);
    });
  }
  z(e, b), xe();
}
function n3(e, t) {
  ke(t, !0);
  let a = R(t, "open", 15, !1), r = R(t, "onOpenChange", 3, Tt), n = R(t, "controlledOpen", 3, !1);
  n2({
    variant: de.with(() => "dialog"),
    open: de.with(() => a(), (i) => {
      n() || a(i), r()(i);
    })
  });
  var o = K(), s = D(o);
  nt(s, () => t.children ?? qe), z(e, o), xe();
}
var o3 = /* @__PURE__ */ L("<button><!></button>");
function s3(e, t) {
  ke(t, !0);
  let a = R(t, "id", 19, or), r = R(t, "ref", 15, null), n = R(t, "disabled", 3, !1), o = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "children",
    "child",
    "id",
    "ref",
    "disabled"
  ]);
  const s = i2({
    variant: de.with(() => "close"),
    id: de.with(() => a()),
    ref: de.with(() => r(), (c) => r(c)),
    disabled: de.with(() => !!n())
  }), i = /* @__PURE__ */ M(() => ea(o, s.props));
  var l = K(), u = D(l);
  {
    var f = (c) => {
      var h = K(), g = D(h);
      nt(g, () => t.child, () => ({ props: d(i) })), z(c, h);
    }, p = (c) => {
      var h = o3();
      let g;
      var _ = A(h);
      nt(_, () => t.children ?? qe), $(() => g = at(h, g, { ...d(i) })), z(c, h);
    };
    B(u, (c) => {
      t.child ? c(f) : c(p, !1);
    });
  }
  z(e, l), xe();
}
var i3 = /* @__PURE__ */ L("<!> <!>", 1), l3 = /* @__PURE__ */ L("<!> <div><!></div>", 1);
function c3(e, t) {
  ke(t, !0);
  let a = R(t, "id", 19, or), r = R(t, "ref", 15, null), n = R(t, "forceMount", 3, !1), o = R(t, "onCloseAutoFocus", 3, Tt), s = R(t, "onEscapeKeydown", 3, Tt), i = R(t, "onInteractOutside", 3, Tt), l = R(t, "trapFocus", 3, !0), u = R(t, "preventScroll", 3, !0), f = R(t, "restoreScrollDelay", 3, null), p = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "children",
    "child",
    "ref",
    "forceMount",
    "onCloseAutoFocus",
    "onEscapeKeydown",
    "onInteractOutside",
    "trapFocus",
    "preventScroll",
    "restoreScrollDelay"
  ]);
  const c = o2({
    id: de.with(() => a()),
    ref: de.with(() => r(), (_) => r(_))
  }), h = /* @__PURE__ */ M(() => ea(p, c.props));
  var g = /* @__PURE__ */ M(() => c.root.open.current || n());
  xd(e, it(() => d(h), {
    get forceMount() {
      return n();
    },
    get present() {
      return d(g);
    },
    presence: (b, m) => {
      let w = () => m == null ? void 0 : m().present;
      var S = /* @__PURE__ */ M(() => I2({
        forceMount: n(),
        present: w().current,
        trapFocus: l(),
        open: c.root.open.current
      }));
      qg(b, it(
        {
          loop: !0,
          get trapFocus() {
            return d(S);
          }
        },
        () => d(h),
        {
          onCloseAutoFocus: (v) => {
            var y;
            o()(v), !v.defaultPrevented && ((y = c.root.triggerNode) == null || y.focus());
          },
          focusScope: (v, y) => {
            let k = () => y == null ? void 0 : y().props;
            Ng(v, it(() => d(h), {
              get enabled() {
                return w().current;
              },
              onEscapeKeydown: (x) => {
                s()(x), !x.defaultPrevented && c.root.handleClose();
              },
              children: (x, T) => {
                Dg(x, it(() => d(h), {
                  get enabled() {
                    return w().current;
                  },
                  onInteractOutside: (F) => {
                    i()(F), !F.defaultPrevented && c.root.handleClose();
                  },
                  children: (F, P) => {
                    Wg(F, it(() => d(h), {
                      get enabled() {
                        return w().current;
                      },
                      children: (O, I) => {
                        var E = K(), N = D(E);
                        {
                          var H = (V) => {
                            var U = i3(), ee = D(U);
                            {
                              var W = (te) => {
                                Qi(te, {
                                  get preventScroll() {
                                    return u();
                                  },
                                  get restoreScrollDelay() {
                                    return f();
                                  }
                                });
                              };
                              B(ee, (te) => {
                                c.root.open.current && te(W);
                              });
                            }
                            var G = X(ee, 2), J = /* @__PURE__ */ kt(() => ({
                              props: ea(d(h), k()),
                              ...c.snippetProps
                            }));
                            nt(G, () => t.child, () => d(J)), z(V, U);
                          }, Y = (V) => {
                            var U = l3(), ee = D(U);
                            Qi(ee, {
                              get preventScroll() {
                                return u();
                              }
                            });
                            var W = X(ee, 2);
                            const G = /* @__PURE__ */ M(() => ea(d(h), k()));
                            let J;
                            var te = A(W);
                            nt(te, () => t.children ?? qe), $(() => J = at(W, J, { ...d(G) })), z(V, U);
                          };
                          B(N, (V) => {
                            t.child ? V(H) : V(Y, !1);
                          });
                        }
                        z(O, E);
                      },
                      $$slots: { default: !0 }
                    }));
                  },
                  $$slots: { default: !0 }
                }));
              },
              $$slots: { default: !0 }
            }));
          },
          $$slots: { focusScope: !0 }
        }
      ));
    },
    $$slots: { presence: !0 }
  })), xe();
}
function u3(e, t) {
  ke(t, !0);
  let a = R(t, "open", 15, !1), r = R(t, "onOpenChange", 3, Tt), n = R(t, "controlledOpen", 3, !1);
  e3({
    open: de.with(() => a(), (o) => {
      n() || a(o), r()(o);
    })
  }), Lz(e, {
    children: (o, s) => {
      var i = K(), l = D(i);
      nt(l, () => t.children ?? qe), z(o, i);
    },
    $$slots: { default: !0 }
  }), xe();
}
function em(e, t) {
  ke(t, !0);
  let a = R(t, "ref", 15, null), r = R(t, "align", 3, "center"), n = R(t, "sideOffset", 3, 4), o = R(t, "portal", 3, !0), s = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class",
    "align",
    "sideOffset",
    "portal"
  ]);
  var i = K(), l = D(i);
  {
    var u = (p) => {
      var c = K(), h = D(c);
      Xe(h, () => Fg, (g, _) => {
        _(g, {
          children: (b, m) => {
            var w = K(), S = D(w), C = /* @__PURE__ */ M(() => Oe("layup-z-50 layup-w-72 layup-rounded-md layup-border layup-bg-popover layup-p-4 layup-text-popover-foreground layup-outline-none data-[state=open]:layup-animate-in data-[state=closed]:layup-animate-out data-[state=closed]:layup-fade-out-0 data-[state=open]:layup-fade-in-0 data-[state=closed]:layup-zoom-out-95 data-[state=open]:layup-zoom-in-95 data-[side=bottom]:layup-slide-in-from-top-2 data-[side=left]:layup-slide-in-from-right-2 data-[side=right]:layup-slide-in-from-left-2 data-[side=top]:layup-slide-in-from-bottom-2", t.class));
            Xe(S, () => Tp, (v, y) => {
              y(v, it(
                {
                  get align() {
                    return r();
                  },
                  style: { boxShadow: "var(--layup-shadow)" },
                  get sideOffset() {
                    return n();
                  },
                  get class() {
                    return d(C);
                  }
                },
                () => s,
                {
                  get ref() {
                    return a();
                  },
                  set ref(k) {
                    a(k);
                  }
                }
              ));
            }), z(b, w);
          },
          $$slots: { default: !0 }
        });
      }), z(p, c);
    }, f = (p) => {
      var c = K(), h = D(c), g = /* @__PURE__ */ M(() => Oe("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 layup-z-50 layup-w-72 layup-rounded-md layup-border layup-bg-popover layup-p-4 layup-text-popover-foreground  layup-outline-none", t.class));
      Xe(h, () => Tp, (_, b) => {
        b(_, it(
          {
            get align() {
              return r();
            },
            style: { boxShadow: "var(--layup-shadow)" },
            get sideOffset() {
              return n();
            },
            get class() {
              return d(g);
            }
          },
          () => s,
          {
            get ref() {
              return a();
            },
            set ref(m) {
              a(m);
            }
          }
        ));
      }), z(p, c);
    };
    B(l, (p) => {
      o() ? p(u) : p(f, !1);
    });
  }
  z(e, i), xe();
}
const tm = u3, d3 = (e) => e;
function Fd(e) {
  const t = e - 1;
  return t * t * t + 1;
}
function Pp(e) {
  const t = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return t ? [parseFloat(t[1]), t[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function al(e, { delay: t = 0, duration: a = 400, easing: r = d3 } = {}) {
  const n = +getComputedStyle(e).opacity;
  return {
    delay: t,
    duration: a,
    easing: r,
    css: (o) => `opacity: ${o * n}`
  };
}
function oi(e, { delay: t = 0, duration: a = 400, easing: r = Fd, x: n = 0, y: o = 0, opacity: s = 0 } = {}) {
  const i = getComputedStyle(e), l = +i.opacity, u = i.transform === "none" ? "" : i.transform, f = l * (1 - s), [p, c] = Pp(n), [h, g] = Pp(o);
  return {
    delay: t,
    duration: a,
    easing: r,
    css: (_, b) => `
			transform: ${u} translate(${(1 - _) * p}${c}, ${(1 - _) * h}${g});
			opacity: ${l - f * b}`
  };
}
function Cu(e, { delay: t = 0, duration: a = 400, easing: r = Fd, axis: n = "y" } = {}) {
  const o = getComputedStyle(e), s = +o.opacity, i = n === "y" ? "height" : "width", l = parseFloat(o[i]), u = n === "y" ? ["top", "bottom"] : ["left", "right"], f = u.map(
    (m) => (
      /** @type {'Left' | 'Right' | 'Top' | 'Bottom'} */
      `${m[0].toUpperCase()}${m.slice(1)}`
    )
  ), p = parseFloat(o[`padding${f[0]}`]), c = parseFloat(o[`padding${f[1]}`]), h = parseFloat(o[`margin${f[0]}`]), g = parseFloat(o[`margin${f[1]}`]), _ = parseFloat(
    o[`border${f[0]}Width`]
  ), b = parseFloat(
    o[`border${f[1]}Width`]
  );
  return {
    delay: t,
    duration: a,
    easing: r,
    css: (m) => `overflow: hidden;opacity: ${Math.min(m * 20, 1) * s};${i}: ${m * l}px;padding-${u[0]}: ${m * p}px;padding-${u[1]}: ${m * c}px;margin-${u[0]}: ${m * h}px;margin-${u[1]}: ${m * g}px;border-${u[0]}-width: ${m * _}px;border-${u[1]}-width: ${m * b}px;`
  };
}
function ha(e, { delay: t = 0, duration: a = 400, easing: r = Fd, start: n = 0, opacity: o = 0 } = {}) {
  const s = getComputedStyle(e), i = +s.opacity, l = s.transform === "none" ? "" : s.transform, u = 1 - n, f = i * (1 - o);
  return {
    delay: t,
    duration: a,
    easing: r,
    css: (p, c) => `
			transform: ${l} scale(${1 - u * c});
			opacity: ${i - f * c}
		`
  };
}
var f3 = /* @__PURE__ */ L("<div> </div>"), p3 = /* @__PURE__ */ L("<!> <!>", 1), y3 = /* @__PURE__ */ L('<div class="layup-relative layup-z-[99999999] layup-flex layup-w-fit layup-items-center layup-justify-center svelte-qzlv45"><!> <div> </div></div>'), h3 = /* @__PURE__ */ L("<div><!></div>"), g3 = /* @__PURE__ */ L('<p class="!layup-text-base !layup-font-button svelte-qzlv45">Hide</p>'), m3 = /* @__PURE__ */ L('<div class="!layup-text-base !layup-font-button svelte-qzlv45">Next</div>'), _3 = /* @__PURE__ */ L('<p class="!layup-text-base !layup-font-button svelte-qzlv45">Finish</p>'), w3 = /* @__PURE__ */ L(`<div class="layup-cursor-popover !layup-pointer-events-none !layup-z-[9999999] !layup-flex !layup-min-w-[200px]
              !layup-max-w-[260px] !layup-origin-top-left !layup-transform-gpu !layup-items-center !layup-gap-1.5 !layup-rounded-outer !layup-border-none !layup-outline-none !layup-ring-0 focus-visible:!layup-ring-0 svelte-qzlv45"><div><div><div class="!layup-pointer-events-none !layup-flex !layup-w-full !layup-items-start !layup-justify-between !layup-gap-2 svelte-qzlv45"><div class="!layup-flex !layup-flex-1 !layup-items-start svelte-qzlv45"><!></div></div> <div class="!layup-flex !layup-w-full !layup-justify-end !layup-gap-2 svelte-qzlv45"><!> <!> <!></div></div></div></div>`), v3 = /* @__PURE__ */ L("<layup-cursor><!> <!></layup-cursor>", 2);
function b3(e, t) {
  var C;
  ke(t, !0);
  let a = me({ x: 0, y: 0 }), r = me(void 0), n = me(!1), o = me(!1);
  Z.config.styles;
  let s = me(null);
  (C = t.actorRef) == null || C.subscribe((v) => {
    q(s, v);
  });
  let i = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.position;
  }), l = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.visible;
  }), u = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.showText;
  }), f = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.text;
  }), p = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.currentElement;
  }), c = /* @__PURE__ */ M(() => {
    var v;
    return (v = d(s)) == null ? void 0 : v.context.popoverSide;
  });
  const h = /* @__PURE__ */ M(() => {
    var v, y, k;
    return (k = (y = d(s)) == null ? void 0 : y.context.currentActionsMap[((v = d(s)) == null ? void 0 : v.context.currentActionsMap.length) - 1]) == null ? void 0 : k.hide_cursor;
  }), g = (v) => {
    var y;
    v.detail.success && (q(a, v.detail.position), (y = t.actorRef) == null || y.send({ type: "cursorMoved" }));
  };
  Pe(() => {
    var v;
    t.initialPosition && ((v = d(s)) == null ? void 0 : v.value) === "initCursor" && q(a, t.initialPosition);
  }), Pe(() => {
    var x, T;
    if (!d(i)) return;
    const v = 0, y = d(i).y < v, k = d(i).y > window.innerHeight - v;
    y !== d(n) && (q(n, y), (x = t.actorRef) == null || x.send({
      type: "SCROLL_UP",
      scrollUp: d(n)
    })), k !== d(o) && (q(o, k), (T = t.actorRef) == null || T.send({
      type: "SCROLL_DOWN",
      scrollDown: d(o)
    }));
  });
  let _ = me(!1), b;
  Pe(() => {
    var v;
    ((v = d(s)) == null ? void 0 : v.value) === "findSelector" ? (b && clearTimeout(b), b = setTimeout(
      () => {
        q(_, !0);
      },
      500
    )) : (b && clearTimeout(b), q(_, !1));
  }), Wu(() => {
    b && clearTimeout(b);
  });
  var m = v3();
  $(() => ef(m, "class", `${Oe("layup-cursor layup-pointer-events-none layup-fixed layup-z-[99999999] layup-size-8 layup-will-change-transform", d(h) ? "!layup-opacity-0" : "!layup-opacity-100 ") ?? ""} svelte-qzlv45`)), ef(m, "style", "top: 0; left: 0; transform-origin: center center;");
  var w = A(m);
  zr(w, () => d(l), (v) => {
    var y = K(), k = D(y);
    {
      var x = (T) => {
        var F = h3();
        const P = /* @__PURE__ */ M(() => `${Oe("layup-z-[9999999] layup-flex layup-w-fit layup-items-center layup-justify-center layup-overflow-visible", d(c) === "left" ? "layup-scale-x-[-1]" : "") ?? ""} svelte-qzlv45`);
        var O = A(F);
        {
          var I = (N) => {
            var H = p3(), Y = D(H);
            G1(Y, { class: "layup-overflow-auto layup-fill-cursor" });
            var V = X(Y, 2);
            {
              var U = (ee) => {
                var W = f3();
                const G = /* @__PURE__ */ M(() => `${Oe(
                  "!layup-absolute !layup-rounded-[4px] !layup-border-[1px] !layup-border-border !layup-border-white !layup-bg-accent !layup-pb-[2px] !layup-pl-[6px] !layup-pr-[6px] !layup-pt-[2px] !layup-text-items !layup-text-white !layup-transition-opacity !layup-duration-300",
                  // Position based on popoverSide
                  d(c) === "left" && "!layup-left-10 !layup-top-0 !layup-scale-x-[-1]",
                  d(c) === "right" && "!layup-left-10 !layup-top-0",
                  d(c) === "top" && "!layup-bottom-8 !layup-left-0",
                  d(c) === "bottom" && "!layup-left-0 !layup-top-8"
                ) ?? ""} svelte-qzlv45`);
                var J = A(W);
                $(() => {
                  Ue(W, d(G)), Me(J, Z.config.name);
                }), z(ee, W);
              };
              B(V, (ee) => {
                d(u) || ee(U);
              });
            }
            z(N, H);
          }, E = (N) => {
            var H = K(), Y = D(H);
            {
              var V = (U) => {
                var ee = y3(), W = A(ee);
                V1(W, {});
                var G = X(W, 2);
                const J = /* @__PURE__ */ M(() => `${Oe(
                  "!layup-border-border/70 !layup-fixed !layup-rounded-[4px] !layup-border-[1px] !layup-border-white !layup-bg-accent !layup-pb-[2px] !layup-pl-[6px] !layup-pr-[6px] !layup-pt-[2px] !layup-text-items !layup-text-accent-text !layup-transition-opacity !layup-duration-300",
                  // Position based on popoverSide
                  d(c) === "left" && "!layup-right-10 !layup-top-0 !layup-scale-x-[-1]",
                  d(c) === "right" && "!layup-left-10 !layup-top-0",
                  d(c) === "top" && "!layup-bottom-8 !layup-left-0",
                  d(c) === "bottom" && "!layup-left-0 !layup-top-8"
                ) ?? ""} svelte-qzlv45`);
                var te = A(G);
                $(() => {
                  Ue(G, d(J)), Me(te, Z.config.name);
                }), z(U, ee);
              };
              B(
                Y,
                (U) => {
                  d(_) && U(V);
                },
                !0
              );
            }
            z(N, H);
          };
          B(O, (N) => {
            d(_) ? N(E, !1) : N(I);
          });
        }
        $(() => Ue(F, d(P))), xt(5, F, () => ha, () => ({ duration: 400 })), z(T, F);
      };
      B(k, (T) => {
        var F;
        d(l) && ((F = d(s)) == null ? void 0 : F.value) !== "completed" && T(x);
      });
    }
    z(v, y);
  });
  var S = X(w, 2);
  zr(S, () => d(f), (v) => {
    var y = K(), k = D(y);
    {
      var x = (T) => {
        var F = K(), P = D(F);
        Xe(P, () => tm, (O, I) => {
          I(O, {
            open: !0,
            controlledOpen: !0,
            children: (E, N) => {
              var H = K(), Y = D(H), V = /* @__PURE__ */ M(() => d(h) ? d(p) : d(r)), U = /* @__PURE__ */ M(() => d(h) ? 10 : d(c) === "top" || d(c) === "bottom" ? 20 : -10), ee = /* @__PURE__ */ M(() => d(h) || d(c) === "top" || d(c) === "bottom" ? "center" : "start"), W = /* @__PURE__ */ M(() => d(c) === "left" || d(c) === "right" ? 20 : 0);
              Xe(Y, () => em, (G, J) => {
                J(G, {
                  trapFocus: !1,
                  get customAnchor() {
                    return d(V);
                  },
                  get sideOffset() {
                    return d(U);
                  },
                  get side() {
                    return d(c);
                  },
                  get align() {
                    return d(ee);
                  },
                  get alignOffset() {
                    return d(W);
                  },
                  onclick: (te) => {
                    te.preventDefault(), te.stopPropagation();
                  },
                  onOpenAutoFocus: (te) => {
                    te.preventDefault(), te.stopPropagation();
                  },
                  onCloseAutoFocus: (te) => {
                    te.preventDefault(), te.stopPropagation();
                  },
                  portal: !0,
                  class: "layup-cursor-popover !layup-pointer-events-none !layup-z-[9999999] !layup-overflow-hidden !layup-w-fit !layup-transform-gpu  !layup-rounded-outer  !layup-border-none !layup-p-0 !layup-text-base !layup-text-white focus-visible:!layup-ring-0 !layup-shadow-custom",
                  children: (te, ae) => {
                    var ie = K(), oe = D(ie);
                    {
                      var Q = (le) => {
                        var he = w3(), pe = A(he);
                        const se = /* @__PURE__ */ M(() => `${Oe(
                          "layup-relative layup-w-full !layup-rounded-outer layup-p-[1px]",
                          // Change gradient direction based on popover side
                          d(c) === "right" && "layup-bg-gradient-to-br !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          d(c) === "left" && "layup-bg-gradient-to-bl !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          d(c) === "top" && "layup-bg-gradient-to-t !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%",
                          d(c) === "bottom" && "layup-bg-gradient-to-b !layup-from-accent !layup-via-accent !layup-to-background !layup-to-60%"
                        ) ?? ""} svelte-qzlv45`);
                        var ye = A(pe);
                        const ge = /* @__PURE__ */ M(() => `${Oe("!layup-shadow-primary/20 !layup-relative layup-z-10 !layup-flex !layup-w-full !layup-flex-col !layup-items-start !layup-justify-center !layup-gap-item !layup-rounded-outer !layup-bg-background !layup-p-text-guidance !layup-text-base !layup-shadow-md dark:!layup-text-white") ?? ""} svelte-qzlv45`);
                        var ue = A(ye), _e = A(ue), Se = A(_e);
                        kg(Se, {
                          get text() {
                            return d(f);
                          },
                          textAlign: "left",
                          backgroundColor: "transparent",
                          textColor: "text-textPrimary",
                          padding: "!layup-p-0"
                        });
                        var Re = X(ue, 2), ve = A(Re);
                        He(ve, {
                          variant: "ghost",
                          size: "sm",
                          class: "!layup-bg-background-secondary/50 !layup-pointer-events-auto !layup-h-8 !layup-rounded-button-outer !layup-p-2 !layup-text-primary !layup-transition-transform !layup-duration-200 hover:!layup-bg-background-secondary hover:!layup-text-primary",
                          onmousedowncapture: (je) => {
                            je.stopPropagation();
                          },
                          onclick: (je) => {
                            var Be;
                            je.preventDefault(), je.stopPropagation(), (Be = t.actorRef) == null || Be.send({ type: "HIDE_TEXT" });
                          },
                          children: (je, Be) => {
                            var Fe = g3();
                            z(je, Fe);
                          },
                          $$slots: { default: !0 }
                        });
                        var ze = X(ve, 2);
                        {
                          var fe = (je) => {
                            var Be = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 !layup-rounded-button-outer !layup-bg-accent !layup-p-2 !layup-text-accent-text hover:!layup-bg-accent-secondary hover:!layup-text-accent-text hover:!layup-no-underline dark:!layup-border-[0px] dark:hover:!layup-bg-accent-secondary"));
                            He(je, {
                              onmousedowncapture: (Fe) => {
                                Fe.stopPropagation();
                              },
                              onclick: (Fe) => {
                                var Ae;
                                Fe.preventDefault(), Fe.stopPropagation(), (Ae = t.actorRef) == null || Ae.send({ type: "interacted" });
                              },
                              variant: "ghost",
                              get class() {
                                return d(Be);
                              },
                              children: (Fe, Ae) => {
                                var mt = m3();
                                z(Fe, mt);
                              },
                              $$slots: { default: !0 }
                            });
                          };
                          B(ze, (je) => {
                            var Be, Fe;
                            (Be = d(s)) != null && Be.can({ type: "NEXT_STEP" }) && !((Fe = d(s)) != null && Fe.can({ type: "LAST_STEP" })) && je(fe);
                          });
                        }
                        var Ce = X(ze, 2);
                        {
                          var Ne = (je) => {
                            var Be = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border-[1px] !layup-border-accent !layup-bg-accent !layup-p-2 !layup-shadow-none   hover:!layup-bg-accent-secondary hover:!layup-no-underline !layup-text-accent-text"));
                            He(je, {
                              onmousedowncapture: (Fe) => {
                                Fe.stopPropagation();
                              },
                              onclick: (Fe) => {
                                var Ae;
                                Fe.preventDefault(), Fe.stopPropagation(), (Ae = t.actorRef) == null || Ae.send({ type: "LAST_STEP" });
                              },
                              variant: "ghost",
                              get class() {
                                return d(Be);
                              },
                              children: (Fe, Ae) => {
                                var mt = _3();
                                z(Fe, mt);
                              },
                              $$slots: { default: !0 }
                            });
                          };
                          B(Ce, (je) => {
                            var Be;
                            (Be = d(s)) != null && Be.can({ type: "LAST_STEP" }) && je(Ne);
                          });
                        }
                        $(() => {
                          Ue(pe, d(se)), Ue(ye, d(ge));
                        }), xt(5, he, () => ha, () => ({ duration: 400 })), z(le, he);
                      };
                      B(oe, (le) => {
                        d(l) && d(u) && le(Q);
                      });
                    }
                    z(te, ie);
                  },
                  $$slots: { default: !0 }
                });
              }), z(E, H);
            },
            $$slots: { default: !0 }
          });
        }), z(T, F);
      };
      B(k, (T) => {
        var F, P, O;
        d(f) && ((F = d(s)) == null ? void 0 : F.value) !== "completed" && ((P = d(s)) == null ? void 0 : P.value) !== "findSelector" && ((O = d(s)) == null ? void 0 : O.value) !== "error" && T(x);
      });
    }
    z(v, y);
  }), aa(m, (v) => q(r, v), () => d(r)), Qc(m, (v, y) => Fc == null ? void 0 : Fc(v, y), () => ({
    startPoint: d(a),
    targetPoint: d(i)
  })), pt("cursormove", m, g), z(e, m), xe();
}
const k3 = $u(
  {
    initial: "idle",
    states: {
      idle: {
        on: {
          QUERY: "querying"
        }
      },
      querying: {
        invoke: {
          input: ({ event: e }) => e.query,
          id: "knowledgeQuery",
          src: "knowledgeQuery",
          onDone: {
            target: "idle",
            actions: [
              Cf(({ event: e }) => ({
                type: "KNOWLEDGE_QUERY_RESPONSE",
                data: e.output
              }))
            ]
          },
          onError: {
            target: "idle",
            actions: [
              Cf(({ event: e }) => ({
                type: "KNOWLEDGE_QUERY_ERROR",
                data: e.error
              }))
            ]
          }
        }
      }
    }
  },
  {
    actors: {
      knowledgeQuery: wt(async ({ input: e }) => {
        const t = await yw(e);
        if (!t)
          throw new Error("No response from knowledge query");
        return t;
      })
    }
  }
);
function x3(e, t) {
  var a;
  if (!e || e.type !== "css") return null;
  try {
    const r = document.querySelectorAll(e.value);
    if (r.length === 1) return r[0];
    if (r.length > 1 && t && t.type === "js")
      for (const n of r) {
        const o = t.conditions;
        if (!o) continue;
        let s = !1;
        switch (o.condition) {
          case "text-contains":
            s = (a = n.textContent) == null ? void 0 : a.includes(o.value);
            break;
          case "matches":
            s = n.matches(o.value);
            break;
          case "key-exists":
            s = n.hasAttribute(o.key) && n.getAttribute(o.key) === o.value;
            break;
          default:
            s = !1;
        }
        if (s) return n;
      }
    return r[0] || null;
  } catch (r) {
    return console.error("Error processing selector:", r), null;
  }
}
const z3 = async (e, t = 1e4) => {
  const a = Date.now(), r = (n) => {
    const o = n.find(
      (l) => l.type.toLowerCase() === "css"
    );
    if (o)
      try {
        const l = document.querySelectorAll(o.value);
        if (l.length >= 1) return l[0];
      } catch (l) {
        console.error("Invalid CSS selector:", l);
      }
    const s = n.find(
      (l) => l.type.toLowerCase() === "xpath"
    );
    if (s)
      try {
        const l = document.evaluate(
          s.value,
          document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
        if (l) return l;
      } catch (l) {
        console.error("Invalid XPath selector:", l);
      }
    const i = n.find(
      (l) => l.type.toLowerCase() === "js"
    );
    if (i && o)
      try {
        const l = document.querySelectorAll(o.value);
        x3(l, i);
      } catch (l) {
        console.error("Invalid JS selector:", l);
      }
    return null;
  };
  return new Promise((n, o) => {
    const s = () => {
      const i = r(e);
      if (i)
        return n(i);
      if (Date.now() - a > t)
        return o(
          new Error(
            `Timeout waiting for element with selectors: ${JSON.stringify(e)}`
          )
        );
      const l = new MutationObserver(() => {
        const u = r(e);
        u && (l.disconnect(), n(u));
      });
      l.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0
      }), setTimeout(s, 100);
    };
    s();
  });
}, Op = async (e, t = 1e4) => Promise.all(
  e.map((a) => z3(a, t))
), Mp = async (e, t) => {
  if (e)
    return new Promise((a, r) => {
      if (!document.body.contains(e)) {
        r(new Error("Element is no longer in DOM"));
        return;
      }
      const n = new IntersectionObserver(
        (s) => {
          const [i] = s;
          if (!document.body.contains(e)) {
            n.disconnect(), r(new Error("Element was removed during scroll"));
            return;
          }
          i.isIntersecting && (n.disconnect(), a());
        },
        {
          root: null,
          // viewport
          threshold: 0.1
          // partially visible is enough
        }
      ), o = new MutationObserver(() => {
        document.body.contains(e) || (n.disconnect(), o.disconnect(), r(new Error("Element was removed during scroll")));
      });
      o.observe(document.body, {
        childList: !0,
        subtree: !0
      }), setTimeout(() => {
        n.disconnect(), o.disconnect(), a();
      }, 1200), n.observe(e), e.scrollIntoView({ behavior: "instant", block: "center" });
    });
}, Eu = (e) => {
  if (e.children.length === 0)
    return 1;
  let t = 0;
  for (const a of e.children)
    t = Math.max(t, Eu(a));
  return t + 1;
}, S3 = (e) => e.map((a) => {
  let r = 0;
  for (const n of a.actions)
    r = Math.max(r, Eu(n));
  return Eu(a.actions[0]);
});
class Dc extends Error {
  constructor(a, r, n) {
    super(r);
    Ve(this, "type");
    Ve(this, "subMessage");
    this.name = "CustomError", this.type = a, this.subMessage = n, Object.setPrototypeOf(this, new.target.prototype);
  }
}
const Ip = (e) => {
  if (!e) return null;
  try {
    const t = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      steps: []
    }, a = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      actions: []
    }, r = (o) => {
      const s = JSON.parse(o.metadata);
      return {
        id: o.id,
        guideText: s == null ? void 0 : s.message,
        show_next: (s == null ? void 0 : s.show_next) || !1,
        waitForInput: s == null ? void 0 : s.wait_for_input,
        glow: (s == null ? void 0 : s.glow) || !1,
        hide_cursor: (s == null ? void 0 : s.hide_cursor) || !1,
        tips: s == null ? void 0 : s.tips,
        highlight: !0,
        type: o == null ? void 0 : o.type,
        url: s.url,
        attachEvent: s.attach_event ? [s.attach_event] : null,
        validation: s == null ? void 0 : s.validation,
        selector: [JSON.parse(o.selection_criteria)],
        criteria: {},
        dependencies: [],
        children: []
      };
    };
    let n = null;
    return e == null || e.steps.forEach((o, s) => {
      const i = r(o);
      n ? n.children.push(i) : a.actions.push(i), n = i;
    }), t.steps.push(a), t;
  } catch {
  }
}, Lr = (e) => {
  var t, a, r, n, o;
  if (!e) return null;
  try {
    const s = {
      name: (e == null ? void 0 : e.name) || (e == null ? void 0 : e.title),
      description: e == null ? void 0 : e.description,
      id: e == null ? void 0 : e.id,
      steps: []
    }, i = {
      name: ((t = e.flow) == null ? void 0 : t.name) || ((a = e.flow) == null ? void 0 : a.title),
      description: (r = e.flow) == null ? void 0 : r.description,
      id: (n = e.flow) == null ? void 0 : n.id,
      actions: []
    }, l = (f) => {
      const p = JSON.parse(f.metadata);
      return {
        id: f == null ? void 0 : f.id,
        guideText: p == null ? void 0 : p.message,
        show_next: (p == null ? void 0 : p.show_next) || !1,
        waitForInput: p == null ? void 0 : p.wait_for_input,
        glow: (p == null ? void 0 : p.glow) || !1,
        hide_cursor: (p == null ? void 0 : p.hide_cursor) || !1,
        attachEvent: p != null && p.attach_event ? [p == null ? void 0 : p.attach_event] : null,
        tips: p == null ? void 0 : p.tips,
        highlight: !0,
        url: p == null ? void 0 : p.url,
        type: f == null ? void 0 : f.type,
        validation: p == null ? void 0 : p.validation,
        selector: [JSON.parse(f.selection_criteria)],
        criteria: {},
        dependencies: [],
        children: []
      };
    };
    let u = null;
    return (o = e == null ? void 0 : e.flow) == null || o.steps.forEach((f, p) => {
      const c = l(f);
      u ? u.children.push(c) : i.actions.push(c), u = c;
    }), s.steps.push(i), s;
  } catch {
  }
}, C3 = (e) => {
  if (!e) return !1;
  const t = [
    "is-open",
    "opened",
    "expanded",
    "-open",
    "--selected"
  ], a = [
    "data-state",
    "data-active",
    "aria-current",
    "aria-selected"
  ], r = (o) => {
    if (!o) return !1;
    if (Array.from(o.classList || []).some(
      (l) => t.some((u) => {
        var f;
        return (f = l == null ? void 0 : l.includes) == null ? void 0 : f.call(l, u);
      })
    ))
      return !0;
    for (const l of a) {
      const u = o.getAttribute(l);
      if (u && ["true", "open", "page"].includes(u))
        return !0;
    }
    return Array.from(o.children || []).some((l) => r(l));
  };
  return r(e);
};
function Co(e) {
  try {
    const t = new URL(e), a = new URL(window.location.href);
    return !t.pathname || t.pathname === "/" ? t.hostname === a.hostname && (!t.search || t.search === a.search) : t.pathname + t.search === a.pathname + a.search;
  } catch {
    return !0;
  }
}
function xi(e, t, a = "new_page_flow") {
  localStorage.setItem(a, JSON.stringify(t));
  const r = new URL(e), n = new URL(window.location.origin);
  n.pathname = r.pathname, n.search = r.search, window.location.href = n.toString();
}
function E3(e) {
  var s, i, l, u, f, p, c, h, g, _, b, m;
  const t = {
    ...e,
    colors: JSON.parse(e.colors),
    font_family: JSON.parse(e.font_family),
    font_sizes: JSON.parse(e.font_sizes),
    icons: JSON.parse(e.icons),
    border_radius: JSON.parse(e.border_radius),
    spacing: JSON.parse(e.spacing),
    metadata: JSON.parse(e.metadata),
    widget_variant: ((s = e.widget_variant) == null ? void 0 : s.toLowerCase()) || "compact"
  }, a = {
    ...t,
    ...(i = Z.config) == null ? void 0 : i.theme,
    colors: {
      ...t.colors,
      dark_mode: {
        ...(l = t.colors) == null ? void 0 : l.dark_mode,
        ...(p = (f = (u = Z.config) == null ? void 0 : u.theme) == null ? void 0 : f.colors) == null ? void 0 : p.dark_mode
      },
      light_mode: {
        ...(c = t.colors) == null ? void 0 : c.light_mode,
        ...(_ = (g = (h = Z.config) == null ? void 0 : h.theme) == null ? void 0 : g.colors) == null ? void 0 : _.light_mode
      }
    }
  }, r = window.matchMedia("(prefers-color-scheme: dark)"), n = ((b = Z.config.theme) == null ? void 0 : b.mode) === "system" ? a.colors[`${r.matches ? "dark" : "light"}_mode`] : a.colors[`${(m = Z.config.theme) == null ? void 0 : m.mode}_mode`], o = Ii(a, n);
  return document.documentElement.setAttribute("style", o), Z.config.styles = o, Ti(a, n), r.addEventListener("change", (w) => {
    if (localStorage.getItem("layup-widget-theme") === "system")
      if (w.matches) {
        document.documentElement.setAttribute("data-layup-mode", "dark");
        const S = a.colors.dark_mode, C = Ii(a, S);
        document.documentElement.setAttribute("style", C), Z.config.styles = C, Ti(a, S);
      } else {
        document.documentElement.setAttribute("data-layup-mode", "light");
        const S = a.colors.light_mode, C = Ii(a, S);
        document.documentElement.setAttribute("style", C), Z.config.styles = C, Ti(a, S);
      }
  }), Z.config.variant = a.widget_variant, Z.config.theme = a, a;
}
const na = $u(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5RQK4EsJgLIEMDGAFmgHZgCCeALgPYBOAxAMoDCASgPIAynA+gCrseAUU5CsQgHJ8A2gAYAuolAAHarDSU01YkpAAPRACYAjIYDsAOgAcAZgCcZ2WeM2AbIbt2ANCACeR2QAWCztZdzMzQLsAVmNZOOiAX0SfVAxsfCJSChoGRgAJdgB1fgBJAAVGOUUkEFV1TW1dAwQTY2iLaKdXHq6raKsrH38EU2TU9ExcQhJyKjp6fNKAESEyyurdeo0tHVqWkxNOrtd7ZytXWSG-I0N4i2NjM3NowLigs1dxkDSpzNmcgsCsV+EIABoyBRbNQ7Jr7AIxCyBQbGQJhGxvQyuaLDRBxKxI6I2FxWSJmaJdInfX4ZGbZeYMJarUEQza1baNPagA6PYwhZ6vKyGcyBCm41oeSzRRxvN7S6J2KzUya0rJzXL0PhCVhYUoSMhatkqGGc5qIOyGcWBVyWYmGSmBZyXezK9LTNWAvJsLi8ACq5SNdRNuzNrWMPQsNjOhlFsjspzM4pjoSRn1cdnD0Sxnldfzp6qB3u4PGWxQkgY5IfhYazD2RdruhhssjFN1a9mCsibFI8LdRdlzqoBDPo5TIvsYQgrwbh3PNlrbNkc1gVbhtMZbUa+KR+Kvdw9yFjAtFoC3KE-y04aVbnCDcgWC7UuQVC8Qc4tRRKRzeFjuMVkCYlB33elD2PU8GAAITIZgAGkr1hLl9EQKMLgsVxw08IJmy3HE23DexrFsGxzGbOwbCseNgP+UC6CPE8FlYIRGD4MhWEhGpjWvWdkLva07E6CjQgxQCoh6cUYkMSNyVkNwhSiMxBmo-NPXoiD6HBUoOOhbikJaCjm0jYSAM8U54g-BVZCIqNiUuKxM2Uj0GQsPBqAAW2UAAbMBKEgegmJYtjtPZGc9LxNECUGEVZKbU503FVxBgsGMTE8IVHG3CY3RogtaBc9yvJ8vzNOCrjENDf8AOsUwfwxRLTgSpKUuMNLzDCRyDzo1yPO83yIFHdhGC00oADUpyhELdIq9wOk8QC4scRtjHFAZXAsT5olOKw43I0lDA62i8u6wq+voCQhAAcQNUbxs4oMpurcMm3W0kSIfQJYvMK0UztKJyNiWxsSSHcaRA3KXJQWhYDoUoIG8+gIG0MALBIAA3agAGtkZIDRylChDTUewZgnspsuzqi4bA-S4pJtUUoniQCEgO8GYEoHJdgRpGUeIdGsYsNmOe0Amb140wPBCFxyJbAZhUTNtFOCdMiQo6VrTiTLd2ylTnMFqhOcR0geb55G9c5aRjDuyseJababEjBUPFFSiNY-a0CU+Pt+KjQxbBZ1SzYN7m0cx02fKF4hpEMK3Qoq4UBIzexmwpIUvvwgYBJasx417exZHif3dfD-XtC5o2Q-5wPhZsGOHtvcWE6l5PZbTkYXAVCwnHsmbSSuUVC8PKviHocC6K8nBKAAMzoNyBeL82JrKwn6-jyWk5l1P5bb0wrOlezBgpbPIgHuiccoZhIehhgz4vqGYeIWBKBwYg8DAEWbYRSxSY8Nw7EdPuLKoheqYeM9gMybUCCfPKN9L4LDwLA2gWBqCo0gO-MK7YsTJTMG9WyzsIjU0Ik2B8lUm5ZigXPSgmhiBQEYE-Wgp09CPwnsjHAk9fK0AABTvFkAASnoKDHKAcfJUJoXQvqaDQzJntmiEwrhkTkkUstdORw97tAikSZE+0QZ7kEUXShJBRE4HoX5RhT9fIWFYewrhXReH8J0TrQewiDG0KMeIxe91yrVixKKfkcV86onsNcNucjLCKneqhcMLZNYCIcXRSeJAICMDAN5Echtsa81DhYeJxBEnJLAAyCRXi5GzU+G4fxgFFQfibAJIU9lyTSntD-ch2TckpI1Gk42mSWlJLaXQC2tdPG3hsmtb+m1FLYgfB+RS9tAYPnzhcFsThmkJJ6fkjUo88rjynjPLJKy8kFPcdbdBwzqrCjGRcV4gQLIWkjMRIkvsuyKTMOQ2AeBTyeU8nwagQhvJuTAMQSgZd0kmwsK895nzvm-P+ZQQpQzbBWTzhRP6ZklFtwiHyFqxJXpXAcBRF5bzqAfK+T8sAfyAVAs6fzMFhKIUkrJTCy2OlBm8QMgi4yyLmyorxDaSwkR84ZlCJtPo+LwXEqheSjZFgtnT1oLPalRLIWkuhbCllH1M5bTcHEYkFEpluEjPeHoUS-7kLcsgsAt8r70HgXfRBZqIAqpaBFXlCkIjplMIBKmbY7jPHQnIlwPR3AKXIdQAARrAY8KC6XQvoCgZQEBmF410g68Klh4iYQ+i2ACcQFxtz-lJQC5I7agPtEqbR2snKHlDeG2gkbxWAryfSzgagYWHNjtWZEVlrRXCFFmGyFopn2RCABN4jwbS2F9sGsNEawBRvJSQdh+A3EDOXrxDtSI7I9qbFGft6cbTJSXLJZsnwIg2GBllPMFa6JVunbOwF50IQ8BYkIAMra66ru2uu7tjS+05rxOOpEw7favEeM4LR56hyHQsNemtM662jiYiNUo7AJyPq1C+5dotHUfq7VFXt27f2jAtASci5J1yDGeO0Sd1ba1KvJZwMgLFUPPuTQgNdOHN0-pWg+ToT5myihIgBUtO5iDUEwPAWoMTL20CZSux1VyvW2AdrtNWjNnllovZ1PKGyZOYZQnI4IkQWoDEZpRK4FlXjWTcHVBU9kbDkOOr1SAOmP6jAVB0RK0pyIWnlBcRqBITCkk+ABdMS41PgbBqpMAegNDOfQR9a0IQnZvENRhPCIxnCdsSsevaPbjD2YQbDbysWKoDE7P0bOyIYiyTCNTe47RHjYXcE4B85Ch7FerP0BOXYXgaLqlvPEYzkr+vePGbELhyEwJte128dx3Cd0cGEQLp72gEfDOGfdD5lvWkcGFrWGnINsxES44xEBpu8RjP0QkvZnDbtXNTBLYSPpPDjFEJ4yycmrIZGd-S8QCSolkvVT8gwpkWZ6M2fOXZUSfDy+piD4N5W0rrd9vTURrDjKFYnRKnq0WJWsKA7V7RBOlvC7ow8pqUEWroMj1jMY1oWj-sly4qWPzbUfNaX6GIlw9CozepHk1mUtB3SMO4gE8dOBagE0kcjkjJCAA */
    id: "guideMachineActor",
    context: ({ input: e, self: t, spawn: a }) => ({
      id: (e == null ? void 0 : e.id) || (e == null ? void 0 : e.guidanceFlow.id),
      steps: e == null ? void 0 : e.guidanceFlow.steps,
      knowledgeFetching: !1,
      metadata: e == null ? void 0 : e.metadata,
      guidanceFlow: e == null ? void 0 : e.guidanceFlow,
      progressSteps: S3(e == null ? void 0 : e.guidanceFlow.steps),
      query: e == null ? void 0 : e.query,
      currentStepIndex: (e == null ? void 0 : e.currentStepIndex) || 0,
      currentSelection: (e == null ? void 0 : e.currentSelection) || null,
      currentActionsMap: (e == null ? void 0 : e.currentActionsMap) || [],
      feedback: !1,
      firstCursorMoved: !1,
      flowStatus: e == null ? void 0 : e.flowStatus,
      feedbackStatus: "null",
      error: null,
      knowledgeMessage: [],
      knowledgeMachine: a(k3, { id: "knowledgeMachine" }),
      showKnowledge: !1,
      showText: !0,
      theme: e == null ? void 0 : e.theme,
      status: null,
      tips: !1,
      notify: "",
      attachEvent: null,
      scrollUp: !1,
      scrollDown: !1,
      isOnboarding: (e == null ? void 0 : e.isOnboarding) || !1,
      isAnnouncement: (e == null ? void 0 : e.isAnnouncement) || !1,
      query_id: e == null ? void 0 : e.query_id,
      flow_id: e == null ? void 0 : e.flow_id,
      cursorInstance: null,
      position: {
        x: 0,
        y: 0
      },
      popoverSide: "right",
      isMoving: !1,
      text: "",
      initCursorCheck: !1,
      action: null,
      visible: !1,
      currentElement: null,
      highlightedElement: null
    }),
    initial: "getAction",
    states: {
      error: {
        entry: ["setError", "setStatus"],
        invoke: {
          id: "updatePosition",
          src: Oi(({ sendBack: e }) => {
            setTimeout(() => {
              e({ type: "updatePosition" });
            }, 400);
          })
        },
        on: {
          updatePosition: {
            actions: "updatePositionToBack"
          },
          RELOAD: {
            guard: "canReload",
            actions: ["reloadToFirstStep"]
          },
          BACK: {
            target: "findSelector",
            guard: "canPreviousAction",
            actions: ["backStep"]
          },
          RESTART: {
            target: "getAction",
            actions: ["restartContext"]
          },
          EXIT: {
            target: "exit"
          }
        }
      },
      completed: {
        entry: [
          "clearLocalStorage",
          re({
            showKnowledge: !1,
            showText: !0,
            tips: !1,
            scrollUp: !1,
            scrollDown: !1,
            notify: "",
            knowledgeMessage: []
          }),
          "setStatusCompleted",
          "clearContext",
          "clearLocalStorage",
          "removeCursor"
        ],
        on: {
          RESTART: {
            target: "getAction",
            actions: ["restartContext"]
          },
          EXIT: {
            actions: ["removeCursor"],
            target: "exit"
          },
          POSITIVE: {
            actions: ["positiveFeedback"]
          },
          NEGATIVE: {
            actions: ["negativeFeedback"]
          }
        }
      },
      waitBeforeObserve: {
        after: {
          400: {
            target: "findSelector"
          }
        }
      },
      exit: {
        entry: ["updateQueryStatus"],
        type: "final"
      },
      cursorIdle: {
        invoke: {
          id: "initPosition",
          src: "getInitPosition",
          onDone: {
            actions: re({
              position: ({ event: e }) => e.output
            }),
            target: "initCursor"
          }
        }
      },
      getAction: {
        entry: ["setLocalStorage"],
        invoke: {
          id: "getAction",
          src: "getAction",
          input: ({ context: e }) => e,
          onError: {
            target: "error"
          },
          onDone: [
            {
              guard: ia([
                "statusCompleted",
                ({ context: e }) => e.isOnboarding
              ]),
              target: "exit",
              actions: [
                "setStatusCompleted",
                "clearLocalStorage",
                re({
                  showKnowledge: !1,
                  showText: !0,
                  tips: !1,
                  scrollUp: !1,
                  scrollDown: !1,
                  notify: "",
                  knowledgeMessage: []
                }),
                "setStatusCompleted",
                "clearContext",
                "clearLocalStorage",
                "removeCursor"
              ]
            },
            {
              guard: "statusCompleted",
              target: "completed",
              actions: ["setStatusCompleted", "clearContext"]
            },
            {
              guard: "checkCompletedStep",
              actions: ["nextStep"],
              target: "getAction",
              // Reattempt getting the next action
              reenter: !0
            },
            {
              actions: ["setActions"],
              guard: ia(["actionAvailable", "isInitCursor"]),
              target: "cursorIdle"
            },
            {
              actions: ["setActions"],
              guard: "actionAvailable",
              target: "waitBeforeObserve"
            }
          ]
        }
      },
      initCursor: {
        invoke: {
          id: "initCursor",
          src: "initCursor",
          input: ({ self: e, context: t }) => ({
            self: e,
            context: t
          })
        },
        on: {
          initCursorInstance: {
            actions: re({
              cursorInstance: ({ event: e }) => e.data
            })
          },
          cursorMoved: {
            target: "gettingStarted"
          }
        }
      },
      gettingStarted: {
        after: {
          100: {
            actions: [
              "makeVisible",
              re({
                initCursorCheck: !0
              })
            ]
          },
          500: {
            target: "findSelector"
          }
        }
      },
      findSelector: {
        invoke: {
          id: "findSelector",
          src: "findSelector",
          input: ({ context: e }) => ({
            currentAction: e.currentActionsMap[e.currentActionsMap.length - 1],
            currentActionsMap: e.currentActionsMap
          }),
          onDone: [
            {
              guard: "checkElementOpen",
              target: "getAction"
            },
            {
              actions: re({
                currentElement: ({ event: e }) => e.output.elements[0]
              }),
              target: "scrollToElement"
            }
          ],
          onError: {
            target: "error"
          }
        }
      },
      scrollToElement: {
        invoke: {
          id: "scrollToElement",
          src: wt(async ({ input: e }) => {
            var s, i, l, u, f, p;
            await Mp(e.event.output.elements[0]);
            const a = ((i = (s = e == null ? void 0 : e.event) == null ? void 0 : s.output) != null && i.attachEvent ? (u = (l = e == null ? void 0 : e.event) == null ? void 0 : l.output) == null ? void 0 : u.attachEvent : (p = (f = e == null ? void 0 : e.event) == null ? void 0 : f.output) == null ? void 0 : p.elements[0]).getBoundingClientRect(), r = 16, n = a.right - r, o = a.bottom - r;
            return {
              element: e.event.output.elements[0],
              position: {
                x: n,
                y: o
              },
              action: e.context.currentActionsMap[e.context.currentActionsMap.length - 1],
              attachEvent: e.event.output.attachEvent
            };
          }),
          input: ({ context: e, event: t }) => ({
            context: e,
            event: t
          }),
          onDone: [
            {
              actions: ["setElement", "updatePopoverSide"],
              target: "observeElement"
            }
          ],
          onError: {
            target: "findSelector"
          }
        }
      },
      observeElement: {
        invoke: {
          id: "observeElement",
          src: "observeElement",
          input: ({ context: e }) => e
        },
        on: {
          cursorMoved: {
            guard: ({ context: e }) => !(e != null && e.firstCursorMoved),
            actions: [
              re({
                text: ({ context: e }) => {
                  var t;
                  return (t = e == null ? void 0 : e.action) == null ? void 0 : t.guideText;
                },
                firstCursorMoved: !0
              })
            ]
          },
          updatePosition: {
            guard: ({ event: e, context: t }) => {
              var n, o, s, i, l;
              const a = !t.position || Math.abs(((n = e.data) == null ? void 0 : n.x) - ((o = t.position) == null ? void 0 : o.x)) > 1 || Math.abs(((s = e.data) == null ? void 0 : s.y) - ((i = t.position) == null ? void 0 : i.y)) > 1, r = ((l = e.data) == null ? void 0 : l.popoverSide) !== t.popoverSide;
              return a || r;
            },
            actions: ["updatePositionAndPopover"]
          },
          elementLost: {
            target: "findSelector"
          },
          interacted: {
            actions: [
              "clearText",
              re({
                firstCursorMoved: !1
              })
            ],
            target: "getAction"
          },
          NEXT_STEP: {
            actions: re({
              currentStepIndex: ({ context: e }) => e.currentActionsMap[e.currentActionsMap.length - 1].children.length === 0 ? e.currentStepIndex + 1 : e.currentStepIndex,
              currentActionsMap: ({ context: e }) => e.currentActionsMap[e.currentActionsMap.length - 1].children.length === 0 ? [
                e.steps[e.currentStepIndex + 1].actions[0]
              ] : [
                ...e.currentActionsMap,
                e.currentActionsMap[e.currentActionsMap.length - 1].children[0]
              ]
            }),
            guard: "canNextAction",
            target: "#guideMachineActor.findSelector"
          },
          PREVIOUS_STEP: {
            actions: re({
              currentActionsMap: ({ context: e }) => e.currentActionsMap.slice(0, -1)
            }),
            guard: "canPreviousAction",
            target: "#guideMachineActor.findSelector"
          },
          LAST_STEP: [
            {
              guard: ia(["isLastStep", ({ context: e }) => e.isOnboarding]),
              actions: [
                "setStatusCompleted",
                "clearContext",
                "clearLocalStorage",
                re({
                  showKnowledge: !1,
                  showText: !0,
                  tips: !1,
                  scrollUp: !1,
                  scrollDown: !1,
                  notify: "",
                  knowledgeMessage: []
                }),
                "removeCursor"
              ],
              target: "#guideMachineActor.exit"
            },
            {
              guard: "isLastStep",
              actions: ["setStatusCompleted"],
              target: "#guideMachineActor.completed"
            }
          ]
        }
      }
    },
    on: {
      HIDE_KNOWLEDGE: {
        actions: [
          re({
            showKnowledge: !1
          })
        ]
      },
      SHOW_KNOWLEDGE: {
        actions: [
          re({
            showKnowledge: !0
          })
        ]
      },
      sendTipsMessage: {
        actions: [
          re({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "user",
                content: t.data.title
              },
              {
                role: "assistant",
                content: t.data.description
              }
            ]
          })
        ]
      },
      sendKnowledgeMessage: {
        guard: ({ context: e }) => e.showKnowledge,
        actions: [
          re({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "user",
                content: t.data
              }
            ],
            knowledgeFetching: !0
          }),
          "sendKnowledgeMessage"
        ]
      },
      KNOWLEDGE_QUERY_RESPONSE: {
        actions: [
          re({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "assistant",
                content: t.data.answer,
                source: t.data.source
              }
            ],
            knowledgeFetching: !1
          })
        ]
      },
      KNOWLEDGE_QUERY_ERROR: {
        actions: [
          re({
            knowledgeMessage: ({ context: e, event: t }) => [
              ...e.knowledgeMessage,
              {
                role: "assistant",
                content: "No knowledge found",
                source: null
              }
            ],
            knowledgeFetching: !1
          })
        ]
      },
      SCROLL_TO_ELEMENT: {
        actions: ["scrollToElement"]
      },
      SHOW_TIPS: {
        guard: "tipsPresent",
        actions: [
          re({
            tips: !0
          })
        ]
      },
      HIDE_TIPS: {
        guard: "tipsPresent",
        actions: re({
          tips: !1
        })
      },
      SHOW_TEXT: {
        guard: "textNotDisplayed",
        actions: ["setShowTextTrue"]
      },
      HIDE_TEXT: {
        guard: "textDisplayed",
        actions: ["setShowTextFalse"]
      },
      TERMINATE: [
        {
          guard: ({ context: e }) => e.isOnboarding,
          target: ".exit",
          actions: [
            "setStatusCompleted",
            "clearContext",
            "clearLocalStorage",
            re({
              showKnowledge: !1,
              showText: !0,
              tips: !1,
              scrollUp: !1,
              scrollDown: !1,
              notify: "",
              knowledgeMessage: []
            }),
            "removeCursor"
          ]
        },
        {
          target: ".completed",
          actions: ["setStatus", "clearContext"]
        }
      ],
      SCROLL_UP: {
        actions: re({
          scrollUp: ({ event: e }) => e.scrollUp
        })
      },
      SCROLL_DOWN: {
        actions: re({
          scrollDown: ({ event: e }) => e.scrollDown
        })
      },
      PAUSE: {
        actions: ["setStatus"],
        target: ".exit"
      }
    },
    output: ({ context: e }) => ({
      id: e.id,
      status: e.status,
      query: e.query,
      feedbackStatus: e.feedbackStatus,
      error: e.error,
      steps: e.steps,
      isOnboarding: e.isOnboarding,
      isAnnouncement: e.isAnnouncement,
      flowStatus: e.flowStatus,
      query_id: e.query_id,
      flow_id: e.flow_id,
      progressSteps: e.progressSteps,
      guidanceFlow: e.guidanceFlow,
      currentStepIndex: e.currentStepIndex,
      currentSelection: e.currentSelection,
      currentActionsMap: e.status === "PAUSE" ? e.currentActionsMap.slice(0, -1) : e.currentActionsMap
    })
  },
  {
    actors: {
      observeElement: Oi(({ input: e, sendBack: t }) => {
        const a = e == null ? void 0 : e.currentElement;
        if (!a) return;
        const r = e == null ? void 0 : e.currentActionsMap[(e == null ? void 0 : e.currentActionsMap.length) - 1], n = e == null ? void 0 : e.attachEvent, o = a, s = /* @__PURE__ */ new Set();
        let i = !1, l = null, u = null, f = null;
        const p = () => {
          f || (f = document.createElement("layup-overlay"), f.classList.add("layup-virtual-pointer"), document.body.appendChild(f)), c();
        }, c = () => {
          if (!f || !o) return;
          const v = o.getBoundingClientRect(), y = 4;
          f.style.top = `${v.top - y}px`, f.style.left = `${v.left - y}px`, f.style.width = `${v.width + y * 2}px`, f.style.height = `${v.height + y * 2}px`;
        }, h = {
          click: () => {
            (!r.waitForInput || n) && t({ type: "interacted" });
          },
          scroll: () => {
            l || (l = setTimeout(() => {
              g(), c(), l = null;
            }, 16));
          },
          resize: () => {
            u || (u = setTimeout(() => {
              g(), c(), u = null;
            }, 100));
          }
        }, g = () => {
          if (!o || !document.body.contains(o)) {
            i || (i = !0, t({ type: "elementLost" }));
            return;
          }
          const y = (n || o).getBoundingClientRect(), k = 24, x = 24, T = 30, F = window.innerWidth, P = y.right / F;
          let O;
          const I = P > 0.7 ? "left" : "right";
          I === "left" ? O = Math.min(y.right - k, y.left + k) : O = Math.max(y.left + k, y.right - k);
          let E = y.bottom - x;
          y.top < window.innerHeight && y.bottom > 0 && y.left < window.innerWidth && y.right > 0 && y.bottom > window.innerHeight && (E = Math.min(
            window.innerHeight - T,
            y.bottom - x
          ), E = Math.max(y.top + x, E)), i = !1, t({
            type: "updatePosition",
            data: {
              x: O,
              y: E,
              popoverSide: I
            }
          });
        };
        r != null && r.glow && p();
        const _ = n || o;
        let b;
        const m = (v) => {
          if (r.waitForInput && !n) return;
          const y = v.target.value;
          if (r.validation && new RegExp(r.validation.regex).test(y)) {
            clearTimeout(b), t({
              type: "interacted",
              data: y
            });
            return;
          }
          clearTimeout(b), b = setTimeout(() => {
            t({
              type: "interacted",
              data: y
            });
          }, 2e3);
        };
        (r == null ? void 0 : r.type) === "Type" ? _.addEventListener("input", m, { passive: !0 }) : (r == null ? void 0 : r.type) === "Click" && _.addEventListener("click", h.click);
        const S = (() => {
          const v = new IntersectionObserver(
            (k) => {
              k[0].isIntersecting || g();
            },
            {
              root: null,
              // viewport
              threshold: 0.1
              // trigger when at least 10% is visible
            }
          );
          v.observe(o), n && v.observe(n);
          const y = (k) => {
            if (!k) return;
            const x = (F) => {
              const P = window.getComputedStyle(F), O = P.getPropertyValue("overflow-y"), I = P.getPropertyValue("overflow-x");
              return O === "auto" || O === "scroll" || I === "auto" || I === "scroll";
            };
            let T = k.parentElement;
            for (; T; ) {
              if (x(T) && !s.has(T)) {
                s.add(T), T.addEventListener("scroll", h.scroll, {
                  passive: !0
                });
                break;
              }
              T = T.parentElement;
            }
          };
          return y(o), n && y(n), () => {
            v.disconnect(), s.forEach((k) => {
              k.removeEventListener("scroll", h.scroll);
            });
          };
        })(), C = new MutationObserver((v) => {
          for (const y of v) {
            if (y.type === "childList" && Array.from(y.removedNodes).some(
              (x) => x === o || x instanceof Element && x.contains(o)
            )) {
              t({ type: "elementLost" });
              return;
            }
            c();
            break;
          }
        });
        return window.addEventListener("resize", h.resize, { passive: !0 }), window.addEventListener("scroll", h.scroll, { passive: !0 }), C.observe(document.body, {
          childList: !0,
          subtree: !0,
          attributes: !0
          // Only watch for DOM changes, not attribute changes
        }), g(), () => {
          (r == null ? void 0 : r.type) === "Type" ? (_.removeEventListener("input", m), clearTimeout(b)) : (r == null ? void 0 : r.type) === "Click" && _.removeEventListener("click", h.click), f && (f.remove(), f = null), C.disconnect(), window.removeEventListener("resize", h.resize), window.removeEventListener("scroll", h.scroll), clearTimeout(l), clearTimeout(u), S();
        };
      }),
      getInitPosition: wt(async () => {
        await new Promise((a) => setTimeout(a, 100));
        const e = document.getElementById("layup-widget");
        if (!e)
          return { x: 0, y: 0 };
        const t = e.getBoundingClientRect();
        return {
          x: t.left + t.width / 2,
          y: t.top + t.height / 2
        };
      }),
      initCursor: Oi(({ input: e, sendBack: t }) => {
        var r;
        const a = qu(b3, {
          target: document.body,
          props: {
            actorRef: e == null ? void 0 : e.self,
            initialPosition: (r = e == null ? void 0 : e.context) == null ? void 0 : r.position
          }
        });
        t({ type: "initCursorInstance", data: a });
      }),
      findSelector: wt(async ({ input: e }) => {
        const { currentAction: t, currentActionsMap: a } = e;
        try {
          const r = await Op(t.selector);
          let n = null;
          if (t.attachEvent)
            try {
              n = await Op(t.attachEvent);
            } catch (o) {
              console.warn("Failed to find attach event elements:", o), n = null;
            }
          return {
            elements: r,
            selector: t.selector[0][0],
            attachEvent: n ? n[0] : null
          };
        } catch {
          throw a.length === 1 ? new Dc(
            "FirstElementNotFound",
            "It looks like you off the path",
            "Do you want to restart?"
          ) : new Dc(
            "ElementNotFound",
            "Hmm... Something went wrong.",
            `Try going back and letting ${Z.config.name} retry.`
          );
        }
      }),
      getAction: wt(async ({ input: e }) => {
        try {
          const {
            currentStepIndex: t,
            steps: a,
            currentSelection: r,
            currentActionsMap: n
          } = e;
          if (a.length === t)
            return { status: "completed" };
          if (n.length === 0)
            return { action: a[t].actions[0] };
          const o = n[n.length - 1];
          return o.children.length === 0 ? { status: "completedStep" } : o.children.length === 1 ? { action: o.children[0] } : { action: o.children.find(
            (i) => i.id === o.criteria[r]
          ) || null };
        } catch {
          throw new Dc(
            "InternalError",
            "We might have encountered Machine Error",
            "Please try again"
          );
        }
      })
    },
    actions: {
      updateQueryStatus: async ({ context: e }) => {
        if (e != null && e.isOnboarding || e != null && e.isAnnouncement) {
          await Uy({
            query: e == null ? void 0 : e.query,
            flow_id: e == null ? void 0 : e.flow_id,
            is_knowledge_query: !1,
            is_guide_query: !0,
            type: e != null && e.isOnboarding ? "Onboarding" : "Announcement",
            completed_flow_steps: e.currentStepIndex + 1 / e.steps.length
          });
          return;
        }
        if (!e || e != null && e.error) {
          await sf(
            e.query_id,
            "Failed",
            e.currentStepIndex + 1 / e.steps.length,
            !1
          );
          return;
        }
        e.feedbackStatus !== "null" && await sf(
          e.query_id,
          "Engaged",
          e.currentStepIndex + 1 / e.steps.length,
          e.feedbackStatus === "positive"
        ), e != null && e.query_id && (e != null && e.flow_id) && await fw({
          flow: e.flow_id,
          query: e.query_id,
          had_full_run: e.status === "completed",
          from_cache: !1,
          is_helpful: e.feedbackStatus === "positive"
        });
      },
      updatePositionToBack: re({
        position: () => {
          const e = document.getElementById("error-button");
          if (e) {
            const t = e.getBoundingClientRect();
            return {
              x: t.left + t.width / 2,
              y: t.top + t.height / 2
            };
          }
          return { x: 0, y: 0 };
        }
      }),
      reloadToFirstStep: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        t != null && t.url && (window.location.href = t.url);
      },
      sendKnowledgeMessage: ({ context: e, event: t }) => {
        e.knowledgeMachine.send({
          type: "QUERY",
          query: t.data
        });
      },
      setLocalStorage: ({ context: e }) => {
        var a;
        const t = {
          id: e.id,
          query: e.query,
          isOnboarding: e.isOnboarding,
          isAnnouncement: e.isAnnouncement,
          flow_id: e.flow_id,
          query_id: e.query_id,
          currentStepIndex: e.currentStepIndex,
          currentSelection: e.currentSelection,
          currentActionsMap: (a = e.currentActionsMap) == null ? void 0 : a.map((r) => {
            var n;
            return {
              ...r,
              tips: (n = r.tips) == null ? void 0 : n.map((o) => ({
                title: o.title,
                content: o.content
              }))
            };
          }),
          steps_length: e.steps.length,
          startTime: (/* @__PURE__ */ new Date()).toISOString(),
          guidanceFlow: e.guidanceFlow
        };
        localStorage.setItem(
          "incomplete_flow",
          JSON.stringify(t)
        );
      },
      clearLocalStorage: () => {
        localStorage.removeItem("incomplete_flow");
      },
      removeCursor: ({ context: e }) => {
        const t = e.cursorInstance;
        Jc(t);
      },
      clearText: re({
        text: ""
      }),
      updatePosition: re({
        position: ({ event: e }) => e.data.position,
        popoverSide: ({ event: e }) => e.data.popoverSide
      }),
      makeVisible: re({
        visible: !0
      }),
      makeInvisible: re({
        visible: !1
      }),
      setText: re({
        text: ({ event: e }) => e.data
      }),
      setHighlightedElement: re({
        highlightedElement: ({ event: e }) => e.data
      }),
      scrollToElement: async ({ context: e }) => {
        const t = e.currentElement;
        t && await Mp(t);
      },
      setShowTextTrue: re({
        showText: !0
      }),
      setShowTextFalse: re({
        showText: !1
      }),
      setStatusCompleted: re({
        status: "completed"
      }),
      backStep: re({
        currentActionsMap: ({ context: e }) => e.currentActionsMap.slice(0, -1)
      }),
      setStatus: re({
        status: ({ event: e }) => e.type
      }),
      setError: re({
        error: ({ event: e }) => {
          var t, a;
          return {
            message: e.error.message,
            subMessage: (t = e.error) == null ? void 0 : t.subMessage,
            type: (a = e.error) == null ? void 0 : a.type
          };
        }
      }),
      clearError: re({
        error: null
      }),
      positiveFeedback: re({
        feedback: !0,
        feedbackStatus: "positive"
      }),
      negativeFeedback: re({
        feedback: !0,
        feedbackStatus: "negative"
      }),
      restartContext: re({
        currentStepIndex: 0,
        currentActionsMap: []
      }),
      nextStep: re({
        currentStepIndex: ({ context: e }) => e.currentStepIndex + 1,
        currentActionsMap: []
      }),
      setActions: re({
        currentActionsMap: ({ event: e, context: t }) => [
          ...t.currentActionsMap,
          e.output.action
        ]
      }),
      log: ({ context: e, event: t }) => console.log("log guide-machine", e, t),
      clearContext: re({
        currentStepIndex: 0,
        currentActionsMap: []
      }),
      updateClampedPosition: re({
        position: ({ context: e, event: t }) => {
          const n = t.data || e.position, o = 400 / 2;
          let s = "right", i = n.x;
          return n.x > window.innerWidth - o ? (s = "left", i = n.x - 30) : n.x < o && (s = "right", i = n.x + 30), e.popoverSide = s, {
            x: i,
            y: n.y
          };
        },
        popoverSide: ({ context: e }) => e.popoverSide
      }),
      setElement: re({
        currentElement: ({ event: e }) => e.output.element,
        attachEvent: ({ event: e }) => e.output.attachEvent,
        action: ({ event: e }) => e.output.action
      }),
      setElementPosition: re({
        position: ({ event: e }) => e.output.position
      }),
      updatePositionAndPopover: re({
        position: ({ event: e }) => ({
          x: e.data.x,
          y: e.data.y
        }),
        popoverSide: ({ event: e }) => e.data.popoverSide
      }),
      updatePopoverSide: re({
        popoverSide: ({ event: e, context: t }) => {
          const a = t.element;
          return a && a.getBoundingClientRect().right / window.innerWidth > 0.7 ? "left" : "right";
        },
        position: ({ event: e, context: t }) => {
          var g;
          const a = (g = e.output) == null ? void 0 : g.position;
          if (!a) return t.position;
          const r = t.element;
          if (!r) return a;
          const n = r.getBoundingClientRect(), o = window.innerHeight, s = 24, i = 24, l = 30, u = n.width, f = window.innerWidth, p = n.right / f;
          let c;
          if (p > 0.7) {
            const _ = (p - 0.7) / 0.3;
            c = n.left + u * (1 - _) - s;
          } else
            c = n.right - s;
          const h = Math.max(
            n.top + i,
            Math.min(
              n.bottom - i,
              Math.min(o - l, a.y)
            )
          );
          return {
            x: c,
            y: h
          };
        }
      })
    },
    guards: {
      canReload: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t == null ? void 0 : t.url;
      },
      isInitCursor: ({ context: e }) => !e.initCursorCheck,
      checkElementOpen: ({ event: e }) => C3(e.output.elements[0]),
      tipsPresent: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t && Array.isArray(t.tips) && t.tips.length > 0;
      },
      textNotDisplayed: ({ context: e }) => !e.showText,
      textDisplayed: ({ context: e }) => e.showText,
      checkCompletedStep: ({ event: e }) => e.output.status === "completedStep",
      actionAvailable: ({ event: e }) => !!e.output.action,
      statusCompleted: ({ event: e }) => e.output.status === "completed",
      completedSteps: ({ context: e }) => e.currentStepIndex >= e.steps.length,
      canNextAction: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return t ? !!(t != null && t.show_next || t != null && t.waitForInput) : !1;
      },
      isLastStep: ({ context: e }) => {
        const t = e.currentActionsMap[e.currentActionsMap.length - 1];
        return e.currentStepIndex === e.steps.length - 1 && t.children.length === 0;
      },
      canPreviousAction: ({ context: e }) => e.currentActionsMap.length > 1,
      firstError: ({ context: e }) => {
        var t;
        return ((t = e.error) == null ? void 0 : t.type) === "FirstElementNotFound";
      },
      canNextStep: ({ context: e }) => e.currentStepIndex < e.steps.length,
      shouldUpdatePopoverSide: ({ event: e }) => {
        const t = e.output.position, r = 400 / 2;
        return t.x > window.innerWidth - r || t.x < r;
      }
    }
  }
), A3 = $u(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QFcCWBaAtgQwMYAtUA7MAYn2yIgBswBlMMAQWuoFUAHCbAFzgG0ADAF1EoDgHtYqHqglExIAJ6J0ARgDsAVgA0IAB6IAzABY1agHQAmABxqAnPYBsJrVe2CNAXy960WPEISckoaMAAxMF5kACcBEUVJaVl5RUMEEys9FQQ7Cy1BQsFnNUEtGyMNIx8-DBwCYjIKKloAeSIAIwlsGIhiKCFRJBAkmTkFYfTM7MQrcxMLGy17VyXXdxsakH96oKbQ2gBFZDAYpUHEqTHUycRp5TvzQXzBCvMKotctncDG0j4YphiLwwBdhqMUhNQFMsg8EGonBoFlZBEYEfYbBoNEtvL5tnVfiQLMQxthqKgAF79YlEGSkCDyMA0gBuEgA1kySbIyZTQQlwVdIWljOVrPYNII1DZ7FoTOLUTMEFYCvYLM4bJjlpUqjLvgSGkSuageVSiFAaXSGYaiKyORbueSKaC1ENxILxsKEEYnDYxRKpTK5RKjIrtE41RonD7JUZbJG9QEDZzaQ7KdSufTGSz2cnSY7QVZXSN3TdQDkseGtNirO4oxpbCGDI8tItbGplQndo17cbHemU6RTjEJDELBxqLwAGYjzA9k18osQj23L0+v2S6Wy+WNnI2OVqqwY0o+2UaRydwm51NOgASqFgPBHSkHsFwYLdyWX0NmZlVmRrNgbii2iKrGSIWEYWgOO4Rj2MUZRaBeSZzvmd4Pk+9qZtatpXr2vJoY+ZzvsWn6lk2SomMUFj-rYQGeLocKVFoRgQbYJg2C4TimNiSF7Ch+H3oRSiYUOI5jhOPDToC-G3oJT7EUuZHpFYv7UTWtFSsBDE5EYlTPEYghyvYaJIipSy8d2RrzgRGEQGAtB8FhyY4RYdkOWANlEfyH7XFC5FSvu9hzNKh5OGokFlKBuksbGSzmO47zVHiPzIVZqFyWcrn2WAjmiaO45TjOWXuZ55zeSRvmegFqpBQGoXhQU2nGCp+naFYulWE4zFLEltSJnxhDoWc9LZXwCkln5ymUX+6mAZp9GgRKVitnuVZuMxLhWBZRKDUJpBxOgMTIEQ42kZNiBOLCOl7uGbaRiYJhOEF8bJfqA0Zc+cBvuVinnUqVTLYiNbevdryRYxqILEF7Vxmo5T2Go21MrtT6kLAUQxAQp2VSuMGA-W7WIi4YNNRksbIuYBnGRiJj1kjFgo8NYD6DI2NCrjpkWEDhOg4BpNogZizaLBD2OO1Jj0+jPQEKVTnZnaUuY-gpVs1+5HuJkXMEyDxN84qmRotY5SxpdjiCJd9PIFwIKwBY8hdD0fRmnLxAuWlvLtA7vT9KrZE5GYkZazdhkOJoTh6OkWiimolGXYhr39d2VvcHwtv2903vO3l4mFdJ7tOp7GdOwMP0TYo-th0Hj0hwjkYR4gUe+jH5sdgnXZEsnNsWJOUQ8LEcAuzaOYyREvf97Avt+f7kFN9i1e-mH9cIG4lhtq3fXt0ynep93Y9xLAg4xMO+USVJs756P0T75P5d3DPFiaMHC91+RK-WHY6-4onhphMSYSkFANAdkb64w4s8Q8EonCeARNAxU7VDZaDjkYTE4pES4g3peP+tAsFkHTo7EB34lRgPXFAjQMCyGKjhpKCCBklhVkjNGdBX9N44JwaQHuV8FyXDOp6WwUCSHQNIWofWLgIxdR6sZCKW026YIAI4nGGgVMqi4y4rjlM8TIUoQJwglL6VB0ZwpxicPTeRpxnz72QJgLhAoeFqLgmpLRpMozPH0XNWKL0MHIVMcNI6J1S62MIeohxmpFRhWWq4mMRiTEKPMcdOgyAoAwAfJAcI1AJAAHcJ7+JxoE+xmiQlwkQVDBhbiokyK8TE-ax0AAqEgODxMSXAPgEBUkZKySogJ5Egn5O0TkKC4YImGMxMY8pfFvHPkVljbJ7NckaOCr0u4a5BnuJGZ4sZlTJn4H4C6bhOTyLSg0Isds-NXiWEehqUyYEY7RLMftMApiHwEPVpzbmOtKJ60YisBYBk3BQKglWKUqzmFyMqV9J5yliEQPNoI2BcJgYtigSsKokoTC6S+KM7s4zyAfXBYgGOjghZBmVJUfRcCJQaKeoIOYWIHBnglhiok4yLAwB4K09JAAhJQAA5bAVjB4uRZWyzlPKrG4oyJrHppNMguJKZE4Z9MOF933mwsF0y1bpACpQ0wXNEGfxSnxRV482GGriAwMAfiOl7I1XuUJy145rO7CauAbD0bmrFZquEtKH66vtcC5CTrbaoH-r491Nq4XLB1XHBVe9nVBtoKQHAMQ2RmotbsmZ-kw05GVKqLqUaGVMgDRYV1RAAD6AaXzfUtem5SiCLDBmOaBREdbTBMWjZw22xay0xoPmCnZNirWzFrfW5U+tBbi1bfm3e7ai2MFLeWgEQIiAgjFcqcMw6pVjpbdoNtSrnWdvnacRdy6+0+WrYOtdqIG1wjlMtKoqLt2TsLfu7tVTU39rPUqIdl6R3XqCs2+9vr9XdjwZnKAFaV2QvlEIoRipjLLRjrpSUcGkSZHpiB4ur6IP8KhdB2FOQHArAfsUB6lFIw1nNmhzoRd+gJp6GyJgsAADCEhMDjhypAMVukuLvwIy4NwHgNCKnUO2fIlGvYYcTfR2AXKJA8DoDwHozTOPehYm2RwfH3AFEE3C+DPr6Y8CCGyakgq0npPCCOQujsaNWmcsPEzGTzMxEs6B91cwWzBQ4pUcwGJM14vaho82EVHrmC6vpwzxmcpssc85jD2cCqSSKvZszFmqNWbNE8rNtMWzqkAoZZxmQGIav89YLRVMHqAXcGF4gRmzTMsi6ZzlABJCA-K7P1YyU1iAGXZhBRYjly5CUTBL3ir6JEjhAJfIq0woDRIDPVYi6y0zrW7RJdc8qErGouJkIcBqIbnq3AsRsP5+BZDliAbet2ObRAavmiS4fY+OcEvSVW2qpSfm4Ybc89tnze2dKIOeHFZwywwzLCq9dhbxxbk2flkyFlkOvJVvVX5yCn2tved22SglYszCaGgSsMHN26s8Hh8+aHrs2vE5idsxHb34TtXc1KL76PfPwgBaxUKzhlRYkQQTiHoKj5iXi2fInJO1sM8215nbLPbB-pWIgg57Yxb00AUGsAABZEFZjwjDkwAABWwMgdGy3YdAPV5ebr8IwnUUC3QxwlFwrDYqAMuYRNsR8bKMr03GuKla51-rw3ZAydDxW1783J6Krpvw1b2OyCo525jI770B4ESRjd64D3k6Vd2W9+s33LH-dG7i6fRLoekwW4RCJmPtuVgJ4zUn2qruOLp-O9-E3quc-dlgAkpJzS2UHyDwK0vexQ2xgfmZSUafGpatsNb4mcEDIGXpQ6okWezfIS7405JLTTP96zOTkP7ew807+lKUf7Z2IT6b1Pz1sVZ-TVRA-pffq+Kr470SDfPeUk7-u4L4vz2h+NAj7wbj6Pzu6kxDJ37wQL6GSe6H7+oNZKDNbG7MoAEkChrrZjZzST7gz4a36xz37QFP4zZt7Z6YKTgIFIED52aoHOjH5VRHYtiYGX5gHT6+j4FQGP6wGkHwEdaIEtZF65yziv7m6vYn4MF1pyhYFX44F4p4HmwEGcGZ40F2ypagadbIHCFl6iFVQIzPC5qeAohQKXT3D4buD6TtTzBIiohVhcFr58Tob9DqFUEH7cHD7h6-S3zwjQRqjyEcGL7DYyh9YnhQTYEt4sKaH2GqHFzqECFPZCE0HupBR6H-b1jQrGFXQXQfZFAhyK7ihVC2Fv5MgOHOzOEkF2GAHaErihzJGkKGEtwmF4r26tihRhRLDuA1gFGYLFFgalEoFwFuF0FVHiFMGgHN6sGQHz6KHL5lGFEqHiY0axHC4REVGDGEIOCCz6GpFGEqQZHwgfA+FcTuBiyIjIKdH+ovq9HLFoGVFrFJGRoGFpE7GULqStgGRzCoiHhHa9TP7dhXEFoXF77B4zFH5ppqz4bmxnItxLCFBzTuABGPTs5CJVCRibBKH9GOovqLEl7onXGrH+S6H3FbH1G7GxgsTZEojmASjsTfHEF9GuGYqVKXEJE3H4koiEl1HpFwIByLBahYiEymBEEXYr7KFYpMk4m0Ggl+x4pQQLAx4GTaDogO4ZoagOLaAFZIhLRnG55MwC4nyCF0nlG4mSkn4EmbEclPHhqVDWBdTaBfEHb2BakMlmK64Tik6AmD7inoGMGSHMFjE34z7sGTGL6OmMoxIunYBunYTUGenuGqJrHDE+mjHX64EBm+FBkwFon0mhnOmuk-56lxEGmFFekSEYi+nJmyGplz4P7BlbBEASB2TwDDDEHGmejoDOBCadTLRGRy5PSPSrD0x5QtlqK7EIzLSeBHYYhcTsTGH0z5z9BDmEIqShLSgWDjlzDBYIi0zSLTEyT9gyALnkT1ihiBxVhHa1hAwVCzkph4SyRDQ5CnpI7whyiWCYhErMRngMKgRwzLSahxhVieCwRAq0kXylT2gHnKSGTLRti6qODtjShRSvArRmAohQRSjMRXl5gCR3nFTsbgXSmwSErijEoflRigTKg-lQTQy6RwRzA0lCnIwfR4VKiXS3oFCUSmBA4GyLTmwPxzxQLPw2GTqbKlRMWHhWmRjLAVAIxQJ2BSoqQtj26oqXR7iQWWzWypyiW-bGCBhBzyW0SILOBqUpyxphBMVHnXqQW8VPyhzaDTb0UWDbzOrdFmW7EBzhiIjWW1xAX2WOW2wBouWjrRx8U1xhyzmmXvqPnZqqgoU44Yj1gfL4ZmDZbATyHARRjbk-E-zYJxpgCiUuCHIxXo7xUyGs6ohqTmwrxwzIUZW0njJMXoDsRRQsS0xRiIieD1j252Wt4WBMo5VMWCCgQQm8UWGZDnKmA3KZRJbCq8q5URW04DWMQOAIr1hoijU+jjWPrdr1WNVwjoAqRqiOA9krB8aAR0XdWFp9VzV-QLX+xdTWCdTlBoK2DlCok7lPqzpdrtr9WKjLCqj1jiJPVLAahibUZmhMVojuDUTIIqQaYCaUKNQ6rizODFAto1X2VXY3ZMVdR6GQTLAhydnmVZrkwPyZASjGRaLmSToY3pjhUPm05tEPyQSpEwxRjmBwJ1hcyk1xhzRUq861ZJbRZRHzlXWehPS+hcRx742XSE0-jmCc0PUFDhSooUZU3hb83tYcp8FY0Yhcy41wTIXS27HPU5pc2Yg81o3dXU3q2LYZJmUEqXogyGRLDGTaZZr-Uk3PVLQyUOmq3zbW0k5mXYgvCHiGQrB7gAxwIbQe1tRzClCGRnXhE0FMUxwIiLDGRmBZbzykzYiqhMTMQIiIg0wJ2YJ-E4LJ2IKHL8UFZHZ2DkyULhSqiah8ZogFCvCvWZXAk+5nDa754G7ozJ19lp2mAxxqn8XgGk1CxFL52t3A2ZmGlMgf5NJf5tID2iLSjD2Z1j2UKIoQRhiuAt0wnt20ml3kG8HNar0LDr0Z2j2GTgFngA573T2H0hlFFC1midYX1D3X2yhb2eowm72II+hIjLDmBhEl3KHOUi1VGD1X0j0-2331061MRhTIIYgUmCndUn1bVQNrFZZcx7jygp3QyKjDKT2yhbnegogW2J3ik9UxLl2Q2IIbQEy6oNHwixiN3aB42PT1hxUv10M5kRmf2wOb0IOepEUAPN1UJt0+A+BAA */
    id: "ui-machine",
    initial: "preInitializing",
    context: {
      plans: null,
      features: null,
      messages: [],
      isFetching: !1,
      theme: null,
      metadata: null,
      history: [],
      searchedHistory: [],
      suggestedFlowsByName: [],
      topSuggestedFlows: [],
      isInitialized: !1,
      query: null,
      query_id: null,
      isFetched: !1,
      showWidget: !1,
      startOnboardingFlow: !1,
      showDialog: !1,
      flowFound: null,
      isHistory: !1,
      loadingId: null
    },
    states: {
      error: {
        type: "final"
      },
      waitForInitialization: {
        on: {
          initialized: {
            target: "#ui-machine.initializing",
            actions: ["setGuidanceConfig"]
          }
        }
      },
      preInitializing: {
        invoke: {
          id: "checkIfInitialized",
          src: wt(() => Promise.resolve(Z.config.isSSR || !1)),
          onDone: [
            {
              guard: ({ event: e }) => e.output === !0,
              target: "#ui-machine.waitForInitialization"
            },
            {
              target: "#ui-machine.initializing"
            }
          ]
        }
      },
      loadingWidgetData: {
        initial: "idle",
        states: {
          idle: {},
          loadingOnboarding: {
            entry: [re({ isFetching: !0 })],
            invoke: {
              id: "loadOnboardingData",
              src: wt(async () => await pi()),
              onDone: [
                {
                  guard: ({ event: e }) => e.output,
                  target: "#ui-machine.onboarding",
                  actions: [
                    re({
                      plans: ({ event: e }) => e.output,
                      isFetched: !0,
                      isFetching: !1
                    })
                  ]
                },
                {
                  target: "#ui-machine.error",
                  actions: ["setError"]
                }
              ],
              onError: {
                target: "#ui-machine.error",
                actions: ["setError"]
              }
            },
            on: {
              toggleWidgetVisibility: {
                actions: [
                  re({
                    showWidget: !1
                  }),
                  () => {
                    var e, t;
                    (t = (e = Z.config).onClose) == null || t.call(e);
                  }
                ]
              }
            }
          },
          loadingFeatures: {
            entry: [re({ isFetching: !0 })],
            invoke: {
              id: "loadFeaturesData",
              src: wt(async () => await fi()),
              onDone: {
                target: "#ui-machine.features",
                actions: [
                  re({
                    features: ({ event: e }) => e.output,
                    isFetched: !0,
                    isFetching: !1
                  })
                ]
              },
              onError: {
                target: "#ui-machine.error",
                actions: ["setError"]
              }
            },
            on: {
              toggleWidgetVisibility: {
                actions: [
                  re({
                    showWidget: !1
                  }),
                  () => {
                    var e, t;
                    (t = (e = Z.config).onClose) == null || t.call(e);
                  }
                ]
              }
            }
          },
          loadingQueries: {
            entry: [re({ isFetching: !0 })],
            invoke: {
              id: "loadQueriesData",
              src: wt(async () => {
                const e = await hi(), t = await pi(), a = await fi();
                return { queries: e, onboardingFlows: t, features: a };
              }),
              onDone: {
                target: "#ui-machine.query",
                actions: [
                  re({
                    topSuggestedFlows: ({ event: e }) => e.output.queries,
                    plans: ({ event: e }) => e.output.onboardingFlows,
                    features: ({ event: e }) => e.output.features,
                    isFetched: !0,
                    isFetching: !1
                  })
                ]
              },
              onError: {
                target: "#ui-machine.error",
                actions: ["setError"]
              }
            },
            on: {
              toggleWidgetVisibility: {
                actions: [
                  re({
                    showWidget: !1
                  }),
                  () => {
                    var e, t;
                    (t = (e = Z.config).onClose) == null || t.call(e);
                  }
                ]
              }
            }
          }
        }
      },
      newUserOnboarding: {
        entry: [re({ showWidget: !0 }), re({ showDialog: !0 })],
        on: {
          terminate: {
            actions: [
              re({ showWidget: !1 }),
              re({ showDialog: !1 })
            ],
            target: "#ui-machine.idle"
          },
          run: [
            {
              guard: "hasSameStartingPointOnboarding",
              target: "guideMachine.onboarding"
            },
            {
              actions: ["newPageOnboarding"]
            }
          ],
          markAsCompleted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsCompletedOnboarding",
              "apiMarkAsCompletedOnboarding",
              "setOnboardingFlowCount"
            ]
          },
          markAsNotStarted: {
            target: "#ui-machine.onboarding",
            actions: [
              "markAsNotStartedOnboarding",
              "apiMarkAsNotStartedOnboarding",
              "setOnboardingFlowCount"
            ]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      newUserFeatures: {
        entry: [re({ showWidget: !0 }), re({ showDialog: !0 })],
        on: {
          terminate: {
            actions: [
              re({ showWidget: !1 }),
              re({ showDialog: !1 })
            ],
            target: "#ui-machine.idle"
          },
          featureSeen: {
            target: "idle",
            actions: ["markFeatureSeenLocally", "markSeen"]
          },
          run: {
            target: "#ui-machine.guideMachine.features",
            reenter: !0
          },
          markSeen: {
            target: "idle",
            actions: ["markSeen"]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      waiting: {
        initial: "idle",
        states: {
          idle: {}
        }
      },
      forceInit: {
        initial: "init",
        states: {
          init: {
            invoke: {
              id: "forceInit",
              src: "forceInit",
              input: ({ context: e }) => ({
                metadata: e.metadata
              }),
              onDone: [
                {
                  guard: "hasOnboardingFlowId",
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.thinking.getFlowForOnboarding"
                },
                {
                  guard: "hasFlowId",
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.thinking.getFlowById"
                },
                {
                  guard: "hasIncompleteFlow",
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.thinking.incompleteFlow"
                },
                {
                  guard: "hasNewPageFlow",
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.thinking.newPageFlow"
                },
                {
                  guard: "hasSavedOnboardingFlow",
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.thinking.savedOnboardingFlow"
                },
                {
                  guard: ({ context: e }) => e.startOnboardingFlow,
                  actions: [
                    re({
                      isFetched: !0,
                      plans: ({ event: e }) => e.output.plans,
                      features: ({ event: e }) => e.output.features,
                      topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
                    }),
                    "setOnboardingFlowCount"
                  ],
                  target: "#ui-machine.newUserOnboarding"
                },
                {
                  target: "#ui-machine.waiting",
                  actions: ["setContext"]
                }
              ],
              onError: {
                actions: ["setError"],
                target: "#ui-machine.error"
              }
            }
          }
        }
      },
      initializing: {
        initial: "init",
        states: {
          init: {
            invoke: {
              id: "initialize",
              src: "initialize",
              onDone: [
                {
                  guard: "hasOnboardingFlowId",
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  guard: "hasFlowId",
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  guard: "hasIncompleteFlow",
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  guard: "hasNewPageFlow",
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  guard: "hasSavedOnboardingFlow",
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  guard: ({ event: e }) => {
                    var t;
                    return !!((t = e.output) != null && t.startOnboardingFlow);
                  },
                  actions: ["setContext"],
                  target: "#ui-machine.forceInit"
                },
                {
                  target: "#ui-machine.waiting",
                  actions: ["setContext"]
                }
              ],
              onError: {
                actions: ["setError"],
                target: "#ui-machine.error"
              }
            }
          }
        }
      },
      initializeHistory: {
        initial: "init",
        states: {
          init: {
            invoke: {
              id: "initializeHistory",
              src: "initializeHistory",
              onDone: {
                target: "#ui-machine.history",
                actions: ["setHistory"]
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.query"
              }
            }
          },
          delete: {
            invoke: {
              id: "deleteHistory",
              src: "deleteHistory",
              input: ({ event: e }) => e,
              onDone: {
                target: "init"
              },
              onError: {
                actions: ["setError"],
                target: "init"
              }
            }
          }
        },
        on: {
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.query"
          }
        }
      },
      history: {
        on: {
          delete: {
            target: "initializeHistory.delete"
          },
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.query"
          },
          search: {
            target: "searchHistory"
          },
          openHistory: {
            target: "#ui-machine.query",
            actions: ["setLayupMessagesHistory"]
          },
          exit: {
            target: "query",
            actions: ["clearMessages"]
          }
        }
      },
      searchHistory: {
        invoke: {
          id: "searchHistory",
          src: "searchHistory",
          onDone: {
            target: "history",
            actions: ["setSearchedHistory"]
          }
        }
      },
      updates: {
        initial: "idle",
        states: {
          idle: {},
          onboarding: {
            invoke: {
              id: "initializeOnboarding",
              input: ({ event: e }) => e,
              src: "initializeOnboarding",
              onDone: [
                {
                  target: "#ui-machine.onboarding",
                  actions: [
                    re({
                      plans: ({ event: e }) => e.output
                    }),
                    "setOnboardingFlowCount"
                  ]
                }
              ],
              onError: {
                actions: [
                  ({ event: e }) => {
                    console.error("Onboarding error:", e.error), Rr.error("Failed to initialize onboarding");
                  }
                ],
                target: "#ui-machine.error"
              }
            }
          },
          features: {
            invoke: {
              id: "initializeFeatures",
              src: "initializeFeatures",
              input: ({ event: e }) => e,
              onDone: {
                target: "#ui-machine.idle",
                actions: ["setFeatures"]
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.idle"
              }
            }
          }
        }
      },
      idle: {
        initial: "idle",
        states: {
          idle: {
            on: {
              guide: [
                {
                  guard: "hasOnlyOnboarding",
                  target: "#ui-machine.onboarding"
                },
                {
                  guard: "hasOnlyFeature",
                  target: "#ui-machine.features"
                },
                {
                  target: "#ui-machine.query"
                }
              ],
              onboard: {
                guard: "hasOnboarding",
                target: "#ui-machine.onboarding"
              },
              feature: {
                guard: "hasFeatures",
                target: "#ui-machine.features"
              },
              getAndRunFlow: {
                guard: "isInitialized",
                target: "#ui-machine.thinking.getAndRunFlow"
              },
              locationChange: {
                guard: "isInitialized",
                actions: async ({ self: e, event: t }) => {
                  const a = await hi();
                  e.send({ type: "updateTopQueries", data: a });
                }
              },
              updateTopQueries: {
                actions: re({
                  topSuggestedFlows: ({ event: e }) => e.data
                })
              }
            }
          }
        }
      },
      query: {
        initial: "idle",
        states: {
          idle: {},
          getFlowByName: {
            invoke: {
              id: "getFlowByName",
              src: "getFlowByName",
              input: ({ event: e }) => e,
              onDone: {
                target: "idle",
                actions: ["setSuggestedFlowsByName"]
              }
            }
          }
        },
        on: {
          locationChange: {
            guard: "isInitialized",
            actions: async ({ self: e, event: t }) => {
              const a = await hi();
              e.send({ type: "updateTopQueries", data: a });
            }
          },
          updateTopQueries: {
            actions: re({
              topSuggestedFlows: ({ event: e }) => e.data
            })
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          },
          playNewPage: {
            actions: ["playNewPage"]
          },
          play: {
            target: "guideMachine.queryPlay"
          },
          resume: {
            target: "guideMachine.queryFromPause"
          },
          run: {
            target: "guideMachine.query",
            reenter: !0
          },
          runSuggestedFlows: {
            target: "guideMachine.suggestedFlows"
          },
          runTopSuggestedFlows: [
            {
              guard: "hasSameStartingPoint",
              target: "guideMachine.suggestedFlows"
            },
            {
              actions: ["takeToStartingUrl"]
            }
          ],
          search: [
            {
              guard: "hasQuerySearch",
              actions: ["setQueryBySearch"],
              target: ".getFlowByName"
            },
            {
              actions: ["clearQuerySearch"],
              target: ".idle"
            }
          ],
          request: {
            actions: ["setUserQuery"],
            target: "thinking.getQuery"
          },
          esc: {
            actions: ["clearMessages"],
            target: "#ui-machine.idle"
          },
          goToHistory: {
            actions: ["clearMessages", re({ isHistory: !1 })],
            target: "#ui-machine.history"
          },
          history: {
            target: "initializeHistory.init"
          }
        }
      },
      features: {
        initial: "idle",
        states: {
          idle: {
            on: {
              esc: {
                target: "#ui-machine.idle"
              },
              featureSeen: {
                target: "idle",
                actions: ["markFeatureSeenLocally", "markSeen"]
              },
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              },
              markSeen: {
                target: "idle",
                actions: ["markSeen"]
              },
              getAndRunFlow: {
                guard: "isInitialized",
                target: "#ui-machine.thinking.getAndRunFlow"
              },
              openFeature: {
                target: "open_new_feature"
              }
            }
          },
          open_new_feature: {
            entry: ["markFeatureSeenLocally", "markSeen"],
            on: {
              esc: {
                target: "idle"
              },
              run: {
                target: "#ui-machine.guideMachine.features",
                reenter: !0
              }
            }
          }
        }
      },
      onboarding: {
        initial: "idle",
        states: {
          idle: {},
          updating: {
            invoke: {
              id: "updateOnboardingStatus",
              src: wt(async ({ input: e }) => {
                const { item: t, status: a } = e;
                return await yn(t.id, a), { item: t, status: a };
              }),
              input: ({ event: e }) => ({
                item: e.item,
                status: e.type === "markAsCompleted" ? "Completed" : "NotStarted"
              }),
              onDone: {
                target: "idle",
                actions: [
                  re({
                    plans: ({ context: e, event: t }) => {
                      var n;
                      const a = e.plans;
                      if (!a) return null;
                      const r = (n = a == null ? void 0 : a.onboarding_flows) == null ? void 0 : n.map(
                        (o) => (o.id === t.output.item.id && (o.state.status = t.output.status), o)
                      );
                      return { ...a, onboarding_flows: r };
                    },
                    loadingId: null
                    // Clear loading state
                  }),
                  "setOnboardingFlowCount"
                ]
              },
              onError: {
                target: "idle",
                actions: [
                  ({ event: e }) => {
                    console.error("Onboarding update error:", e.error), Rr.error("Failed to update onboarding status");
                  },
                  re({
                    loadingId: null
                    // Clear loading state on error
                  })
                ]
              }
            }
          }
        },
        on: {
          esc: {
            target: "#ui-machine.idle"
          },
          run: [
            {
              guard: "hasSameStartingPointOnboarding",
              target: "guideMachine.onboarding"
            },
            {
              actions: ["newPageOnboarding"]
            }
          ],
          markAsCompleted: {
            target: "onboarding.updating",
            actions: [
              re({
                loadingId: ({ event: e }) => e.item.id
              })
            ]
          },
          clearLoading: {
            actions: [
              re({
                loadingId: null
              })
            ]
          },
          markAsNotStarted: {
            target: "onboarding.updating",
            actions: [
              re({
                loadingId: ({ event: e }) => e.item.id
              })
            ]
          },
          getAndRunFlow: {
            guard: "isInitialized",
            target: "#ui-machine.thinking.getAndRunFlow"
          }
        }
      },
      thinking: {
        id: "thinking",
        initial: "idle",
        entry: () => {
          var e, t;
          (t = (e = Z.config).onOpen) == null || t.call(e);
        },
        states: {
          idle: {},
          getAndRunFlow: {
            invoke: {
              id: "getAndRunFlow",
              src: "getAndRunFlow",
              input: ({ event: e }) => e,
              onDone: {
                target: "#ui-machine.guideMachine.flowById"
              },
              onError: {
                target: "#ui-machine.idle"
              }
            }
          },
          newPageFlow: {
            invoke: {
              id: "getNewPageFlow",
              src: "getNewPageFlow",
              onDone: [
                {
                  guard: "hasFlowObject",
                  actions: [
                    re({ showWidget: !0 }),
                    re({ showDialog: !0 })
                  ],
                  target: "#ui-machine.guideMachine.newPageFlow"
                }
              ]
            }
          },
          savedOnboardingFlow: {
            invoke: {
              id: "getSavedOnboardingFlow",
              src: "getSavedOnboardingFlow",
              onDone: [
                {
                  guard: "hasFlowObject",
                  actions: [
                    re({ showWidget: !0 }),
                    re({ showDialog: !0 })
                  ],
                  target: "#ui-machine.guideMachine.startSavedOnboardingFlow"
                }
              ]
            }
          },
          incompleteFlow: {
            invoke: {
              id: "getIncompleteFlow",
              src: "getIncompleteFlow",
              onDone: [
                {
                  guard: "validateIncompleteFlow",
                  actions: [
                    re({ showWidget: !0 }),
                    re({ showDialog: !0 })
                  ],
                  target: "#ui-machine.guideMachine.incompleteFlow"
                },
                {
                  guard: vv("validateIncompleteFlow"),
                  actions: ["createQuickQuery", "clearIncompleteFlow"],
                  target: "#ui-machine.idle"
                },
                {
                  actions: ["clearIncompleteFlow"],
                  target: "#ui-machine.idle"
                }
              ],
              onError: {
                target: "#ui-machine.idle"
              }
            }
          },
          getFlowForOnboarding: {
            invoke: {
              id: "getFlowForOnboarding",
              src: "getFlowForOnboarding",
              onDone: {
                actions: [
                  re({ showWidget: !0 }),
                  re({ showDialog: !0 })
                ],
                target: "#ui-machine.guideMachine.onboardingById"
              },
              onError: {
                actions: ["setError"],
                target: "#ui-machine.idle"
              }
            }
          },
          getFlowById: {
            invoke: {
              id: "getFlowById",
              src: "getFlowById",
              input: ({ event: e }) => e,
              onDone: {
                guard: "hasFlowObject",
                actions: [
                  re({ showWidget: !0 }),
                  re({ showDialog: !0 })
                ],
                target: "#ui-machine.guideMachine.flowById"
              }
            }
          },
          getQuery: {
            id: "getQuery",
            invoke: {
              src: Oi(({ input: e, sendBack: t }) => {
                const a = new AbortController();
                try {
                  Kw(
                    `${Z.config.api_host}/automation/platforms/guidance/stream`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "x-api-token": Z.internal_config.api_key
                      },
                      body: JSON.stringify({
                        query: e.query,
                        messages: e.messages,
                        id: e.query_id,
                        user_id: Z.config.user_data.user_id,
                        group_id: Z.config.group_id,
                        current_user_location: window.location.href
                      }),
                      signal: a.signal,
                      onmessage(r) {
                        if (r.data)
                          try {
                            if (r.event === "in-progress") {
                              const o = r.data.replace(/'/g, '"').replace(/None/g, "null");
                              r.data = o;
                            }
                            const n = JSON.parse(r.data);
                            switch (r.event) {
                              case "stream":
                                t({
                                  type: "STREAMING_MESSAGE",
                                  data: n
                                });
                                break;
                              case "in-progress":
                                t({
                                  type: "STREAMING_STATUS",
                                  data: n.message
                                });
                                break;
                              case "guide_json":
                                t({ type: "GUIDE_JSON", data: n });
                                break;
                              case "general_json":
                                t({ type: "GENERAL_JSON", data: n });
                                break;
                            }
                          } catch (n) {
                            console.error(
                              "Error parsing event data:",
                              n,
                              r.data
                            );
                          }
                      },
                      onclose() {
                        a.abort(), t({ type: "STREAMING_COMPLETE" });
                      },
                      onerror(r) {
                        throw console.error("EventSource error:", r), a.abort(), t({ type: "STREAMING_COMPLETE" }), new Error("EventSource closed");
                      }
                    }
                  );
                } catch (r) {
                  console.error("Error fetching EventSource:", r);
                }
              }),
              input: ({ context: e }) => ({
                query: e.query,
                messages: e.messages,
                query_id: e.query_id
              })
            },
            on: {
              STREAMING_MESSAGE: {
                actions: re({
                  messages: ({ context: e, event: t }) => {
                    const a = [...e.messages], r = a[a.length - 1];
                    if ((r == null ? void 0 : r.role) === "assistant") {
                      const n = r.content || "";
                      r.content = n + t.data.replace(/"/g, "").replace(/\\/g, "_");
                    }
                    return a;
                  }
                })
              },
              STREAMING_STATUS: {
                actions: [
                  re({
                    messages: ({ context: e, event: t }) => {
                      const a = [...e.messages], r = a[a.length - 1];
                      return (r == null ? void 0 : r.role) === "assistant" && (r.status = t.data), a;
                    }
                  })
                ]
              },
              GUIDE_JSON: {
                target: "#ui-machine.query",
                actions: re({
                  messages: ({ context: e, event: t }) => {
                    var n, o, s, i, l, u, f, p, c, h, g, _, b, m, w;
                    const a = [...e.messages], r = a[a.length - 1];
                    return (r == null ? void 0 : r.role) === "assistant" && (r.flow = (l = (i = (n = t.data) == null ? void 0 : n.conversation) == null ? void 0 : i[((s = (o = t.data) == null ? void 0 : o.conversation) == null ? void 0 : s.length) - 1]) == null ? void 0 : l.flow, r.content = (h = (c = (u = t.data) == null ? void 0 : u.conversation) == null ? void 0 : c[((p = (f = t.data) == null ? void 0 : f.conversation) == null ? void 0 : p.length) - 1]) == null ? void 0 : h.content, r.suggested_queries = (w = (m = (g = t.data) == null ? void 0 : g.conversation) == null ? void 0 : m[((b = (_ = t.data) == null ? void 0 : _.conversation) == null ? void 0 : b.length) - 1]) == null ? void 0 : w.suggested_queries), a;
                  },
                  query_id: ({ event: e }) => {
                    var t;
                    return (t = e.data) == null ? void 0 : t.query_id;
                  }
                })
              },
              GENERAL_JSON: {
                target: "#ui-machine.query",
                actions: re({
                  messages: ({ context: e, event: t }) => {
                    var n, o, s, i, l;
                    const a = [...e.messages], r = a[a.length - 1];
                    return (r == null ? void 0 : r.role) === "assistant" && (r.sources = (l = (i = (n = t.data) == null ? void 0 : n.conversation) == null ? void 0 : i[((s = (o = t.data) == null ? void 0 : o.conversation) == null ? void 0 : s.length) - 1]) == null ? void 0 : l.sources), a;
                  },
                  query_id: ({ event: e }) => {
                    var t;
                    return (t = e.data) == null ? void 0 : t.query_id;
                  }
                })
              },
              STREAMING_COMPLETE: {
                target: "#ui-machine.query"
              },
              playNewPage: {
                actions: ["playNewPage"]
              },
              play: {
                target: "#ui-machine.guideMachine.queryPlay"
              }
            }
          }
        }
      },
      guideMachine: {
        id: "guideMachine",
        initial: "idle",
        states: {
          idle: {},
          newPageFlow: {
            entry: ["clearNewPageFlow"],
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i;
                return {
                  id: (a = e == null ? void 0 : e.output) == null ? void 0 : a.query_id,
                  query: (r = e == null ? void 0 : e.output) == null ? void 0 : r.query,
                  flow_id: (o = (n = e == null ? void 0 : e.output) == null ? void 0 : n.flow) == null ? void 0 : o.id,
                  query_id: (s = e == null ? void 0 : e.output) == null ? void 0 : s.query_id,
                  guidanceFlow: Lr({
                    flow: e == null ? void 0 : e.output.flow,
                    id: (i = e == null ? void 0 : e.output) == null ? void 0 : i.query_id
                  }),
                  theme: t.theme,
                  metadata: t.metadata
                };
              },
              onDone: {
                actions: ["clearLocalStorage"],
                target: "#ui-machine.idle"
              }
            }
          },
          startSavedOnboardingFlow: {
            entry: ["clearNewPageOnboarding"],
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i;
                return {
                  id: (a = e == null ? void 0 : e.output) == null ? void 0 : a.id,
                  isOnboarding: !0,
                  metadata: t.metadata,
                  query: (n = (r = e == null ? void 0 : e.output) == null ? void 0 : r.template_onboarding_flow) == null ? void 0 : n.title,
                  guidanceFlow: Lr(
                    (o = e == null ? void 0 : e.output) == null ? void 0 : o.template_onboarding_flow
                  ),
                  flowStatus: (i = (s = e == null ? void 0 : e.output) == null ? void 0 : s.state) == null ? void 0 : i.status,
                  theme: t == null ? void 0 : t.theme
                };
              },
              onDone: {
                target: "#ui-machine.updates.onboarding"
              },
              onError: {
                target: "#ui-machine.onboarding",
                actions: ["setError"]
              }
            }
          },
          incompleteFlow: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i, l, u, f, p;
                return {
                  id: (a = e == null ? void 0 : e.output) == null ? void 0 : a.id,
                  query: (r = e == null ? void 0 : e.output) == null ? void 0 : r.query,
                  metadata: t.metadata,
                  query_id: (n = e == null ? void 0 : e.output) == null ? void 0 : n.query_id,
                  flow_id: (o = e == null ? void 0 : e.output) == null ? void 0 : o.flow_id,
                  isOnboarding: (s = e == null ? void 0 : e.output) == null ? void 0 : s.isOnboarding,
                  isAnnouncement: (i = e == null ? void 0 : e.output) == null ? void 0 : i.isAnnouncement,
                  currentStepIndex: (l = e == null ? void 0 : e.output) == null ? void 0 : l.currentStepIndex,
                  currentSelection: (u = e == null ? void 0 : e.output) == null ? void 0 : u.currentSelection,
                  currentActionsMap: (f = e == null ? void 0 : e.output) == null ? void 0 : f.currentActionsMap,
                  guidanceFlow: (p = e == null ? void 0 : e.output) == null ? void 0 : p.guidanceFlow,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: ({ event: e }) => {
                    var t;
                    return (t = e == null ? void 0 : e.output) == null ? void 0 : t.isOnboarding;
                  },
                  target: "#ui-machine.updates.onboarding"
                },
                {
                  guard: ({ event: e }) => {
                    var t;
                    return (t = e == null ? void 0 : e.output) == null ? void 0 : t.isAnnouncement;
                  },
                  target: "#ui-machine.updates.features"
                },
                {
                  actions: ["clearIncompleteFlow"],
                  target: "#ui-machine.idle"
                }
              ]
            }
          },
          suggestedFlows: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => ({
                guidanceFlow: Ip(e.flow),
                theme: t.theme,
                metadata: t.metadata
              }),
              onDone: {
                actions: ["clearQuerySearch"],
                target: "#ui-machine.idle"
              },
              onError: {
                target: "#ui-machine.idle",
                actions: ["setError"]
              }
            }
          },
          queryFromPause: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i, l, u;
                return {
                  id: (a = e == null ? void 0 : e.item) == null ? void 0 : a.id,
                  src: na,
                  query: (r = e == null ? void 0 : e.item) == null ? void 0 : r.query,
                  flow_id: (o = (n = e == null ? void 0 : e.item) == null ? void 0 : n.flow) == null ? void 0 : o.id,
                  currentStepIndex: (s = e == null ? void 0 : e.item) == null ? void 0 : s.currentStepIndex,
                  currentSelection: (i = e == null ? void 0 : e.item) == null ? void 0 : i.currentSelection,
                  currentActionsMap: (l = e == null ? void 0 : e.item) == null ? void 0 : l.currentActionsMap,
                  guidanceFlow: (u = e == null ? void 0 : e.item) == null ? void 0 : u.guidanceFlow,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["removePausedMessage", "clearMessages"],
                  target: "#ui-machine.query",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.idle",
                actions: ["setError"]
              }
            }
          },
          flowById: {
            entry: [re({ showWidget: !0 }), re({ showDialog: !0 })],
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i;
                return {
                  guidanceFlow: Ip(e.output),
                  theme: t.theme,
                  metadata: t.metadata,
                  id: (r = (a = e == null ? void 0 : e.output) == null ? void 0 : a.flow) == null ? void 0 : r.id,
                  query: (o = (n = e == null ? void 0 : e.output) == null ? void 0 : n.flow) == null ? void 0 : o.name,
                  flow_id: (i = (s = e == null ? void 0 : e.output) == null ? void 0 : s.flow) == null ? void 0 : i.id
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: [
                    "appendPausedMessage",
                    "clearLocalStorage",
                    re({ showWidget: !1 }),
                    re({ showDialog: !1 })
                  ],
                  target: "#ui-machine.idle"
                },
                {
                  target: "#ui-machine.idle"
                }
              ],
              onError: {
                target: "#ui-machine.idle",
                actions: ["setError"]
              }
            }
          },
          onboardingById: {
            entry: ["markInProgressOnboarding"],
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i;
                return {
                  id: (a = e == null ? void 0 : e.output) == null ? void 0 : a.id,
                  guidanceFlow: Lr(
                    (r = e == null ? void 0 : e.output) == null ? void 0 : r.template_onboarding_flow
                  ),
                  metadata: t.metadata,
                  isOnboarding: !0,
                  flowStatus: (o = (n = e == null ? void 0 : e.output) == null ? void 0 : n.state) == null ? void 0 : o.status,
                  theme: t == null ? void 0 : t.theme,
                  query: (i = (s = e == null ? void 0 : e.output) == null ? void 0 : s.template_onboarding_flow) == null ? void 0 : i.title
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  target: "#ui-machine.updates.onboarding"
                }
              ],
              onError: {
                target: "#ui-machine.onboarding",
                actions: ["setError"]
              }
            }
          },
          onboarding: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i, l;
                return {
                  id: (a = e == null ? void 0 : e.item) == null ? void 0 : a.id,
                  metadata: t.metadata,
                  query: (o = (n = (r = e == null ? void 0 : e.item) == null ? void 0 : r.template_onboarding_flow) == null ? void 0 : n.flow) == null ? void 0 : o.name,
                  guidanceFlow: Lr(
                    (s = e == null ? void 0 : e.item) == null ? void 0 : s.template_onboarding_flow
                  ),
                  isOnboarding: !0,
                  flowStatus: (l = (i = e == null ? void 0 : e.item) == null ? void 0 : i.state) == null ? void 0 : l.status,
                  theme: t == null ? void 0 : t.theme
                };
              },
              onDone: [
                {
                  target: "#ui-machine.updates.onboarding"
                }
              ],
              onError: {
                target: "#ui-machine.onboarding",
                actions: ["setError"]
              }
            }
          },
          features: {
            entry: ["markInProgressFeatures"],
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o;
                return {
                  id: (a = e == null ? void 0 : e.item) == null ? void 0 : a.id,
                  isAnnouncement: !0,
                  metadata: t.metadata,
                  guidanceFlow: Lr((r = e == null ? void 0 : e.item) == null ? void 0 : r.template_announcement),
                  theme: t == null ? void 0 : t.theme,
                  query: (o = (n = e == null ? void 0 : e.item) == null ? void 0 : n.template_announcement) == null ? void 0 : o.title
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  target: "#ui-machine.updates.features",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.features",
                actions: ["setError"]
              }
            }
          },
          query: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s, i;
                return {
                  guidanceFlow: Lr({
                    flow: (a = e == null ? void 0 : e.output) == null ? void 0 : a.flow,
                    id: (n = (r = e == null ? void 0 : e.output) == null ? void 0 : r.query) == null ? void 0 : n.id
                  }),
                  query: (s = (o = e == null ? void 0 : e.output) == null ? void 0 : o.query) == null ? void 0 : s.query,
                  flow_id: (i = e == null ? void 0 : e.output.flow) == null ? void 0 : i.id,
                  metadata: t.metadata,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["clearMessages"],
                  target: "#ui-machine.query",
                  reenter: !0
                }
              ],
              onError: {
                target: "#ui-machine.query",
                actions: ["setError"]
              }
            }
          },
          queryPlay: {
            invoke: {
              id: "guideMachine",
              src: na,
              input: ({ event: e, context: t }) => {
                var a, r, n, o, s;
                return {
                  guidanceFlow: Lr({
                    flow: e == null ? void 0 : e.item.flow,
                    id: (r = (a = e == null ? void 0 : e.item) == null ? void 0 : a.flow) == null ? void 0 : r.id
                  }),
                  metadata: t.metadata,
                  query_id: t.query_id,
                  query: (n = e == null ? void 0 : e.item) == null ? void 0 : n.content,
                  data: (o = e == null ? void 0 : e.item) == null ? void 0 : o.flow,
                  flow_id: (s = e.item.flow) == null ? void 0 : s.id,
                  theme: t.theme
                };
              },
              onDone: [
                {
                  guard: "isPaused",
                  actions: ["appendPausedMessage"],
                  target: "#ui-machine.query"
                },
                {
                  actions: ["clearMessages"],
                  target: "#ui-machine.query"
                }
              ],
              onError: {
                target: "#ui-machine.query",
                actions: ["setError"]
              }
            }
          }
        }
      }
    },
    on: {
      exit_everything: {
        target: ".idle",
        actions: [
          "clearContext",
          "clearMessages",
          "clearLoadingItems",
          re({ showWidget: !1 }),
          re({ showDialog: !1 })
        ]
      },
      showWidgetOn: {
        actions: re({
          showWidget: ({ event: e }) => e.showWidget
        })
      },
      dialogOn: {
        actions: re({
          showDialog: !0
        })
      },
      dialogOff: {
        actions: re({
          showDialog: !1
        })
      },
      handleFeatures: {
        guard: ia(["hasFeatures", "isInitialized"]),
        target: ".features"
      },
      handleOnboarding: {
        guard: ia(["hasOnboarding", "isInitialized"]),
        target: ".onboarding"
      },
      handleQuery: {
        guard: ia(["hasQuery", "isInitialized"]),
        target: ".query"
      },
      handleOpenWidget: [
        {
          guard: ({ context: e }) => e.isFetching
        },
        {
          guard: ia([
            "hasOnlyOnboarding",
            ({ context: e }) => !e.isFetched
          ]),
          target: ".loadingWidgetData.loadingOnboarding"
        },
        {
          guard: ia(["hasOnlyOnboarding", ({ context: e }) => e.isFetched]),
          target: ".onboarding"
        },
        {
          guard: ia(["hasOnlyFeature", ({ context: e }) => !e.isFetched]),
          target: ".loadingWidgetData.loadingFeatures"
        },
        {
          guard: ia(["hasOnlyFeature", ({ context: e }) => e.isFetched]),
          target: ".features"
        },
        {
          guard: ia(["hasQuery", ({ context: e }) => !e.isFetched]),
          target: ".loadingWidgetData.loadingQueries"
        },
        {
          guard: ia(["hasQuery", ({ context: e }) => e.isFetched]),
          target: ".query"
        }
      ],
      terminate: {
        target: ".idle",
        actions: ["clearContext", "clearMessages"]
      },
      reinitialize: {
        target: ".initializing",
        actions: ["clearEveryState"]
      }
    }
  },
  {
    actors: {
      getAndRunFlow: wt(async ({ input: e }) => await lf(e == null ? void 0 : e.flow_id)),
      getIncompleteFlow: wt(async () => {
        const e = localStorage.getItem("incomplete_flow");
        if (e)
          return JSON.parse(e);
      }),
      getNewPageFlow: wt(async () => {
        const e = localStorage.getItem("new_page_flow");
        if (e)
          return JSON.parse(e);
      }),
      getSavedOnboardingFlow: wt(async () => {
        const e = localStorage.getItem(
          "saved_onboarding_flow"
        );
        if (e)
          return JSON.parse(e);
      }),
      getFlowByName: wt(
        async ({ input: e }) => !e || !e.query ? void 0 : await pw(e.query)
      ),
      getFlowById: wt(async () => {
        const t = new URLSearchParams(window.location.search).get("flow_id");
        if (!t)
          throw new Error("No flow ID provided");
        const a = await lf(t);
        if (a.starting_url)
          if (!Co(a.starting_url))
            xi(a.starting_url, { flow: a });
          else
            return a;
      }),
      getFlowForOnboarding: wt(async () => {
        const t = new URLSearchParams(window.location.search).get("onboarding_flow");
        if (!t)
          throw new Error("No flow ID provided");
        const a = await uw(t);
        if (!a) throw new Error("No flow found");
        return a;
      }),
      initializeOnboarding: wt(async ({ input: e }) => {
        var n, o, s, i, l, u, f;
        !e || e.output.error && e.output.flowStatus !== "Completed" ? await yn((n = e == null ? void 0 : e.output) == null ? void 0 : n.id, "NotStarted") : await yn((o = e == null ? void 0 : e.output) == null ? void 0 : o.id, "Completed");
        const t = await pi(), a = ((i = (s = t == null ? void 0 : t.onboarding_flows) == null ? void 0 : s.filter(
          (p) => p.state.status === "Completed"
        )) == null ? void 0 : i.length) || 0, r = ((u = (l = t == null ? void 0 : t.onboarding_flows) == null ? void 0 : l.filter(
          (p) => p.state.status !== "Completed"
        )) == null ? void 0 : u.length) || 0;
        return (f = Z.config) != null && f.onMetadata && Z.config.onMetadata({
          completedOnboardingFlowCount: a,
          notCompletedOnboardingFlowCount: r
        }), t;
      }),
      initializeFeatures: wt(async ({ input: e }) => {
        var a, r;
        return e ? (e.output.error || e.output.feedbackStatus === "negative" ? await yi((a = e == null ? void 0 : e.output) == null ? void 0 : a.id, "NotStarted") : await yi((r = e == null ? void 0 : e.output) == null ? void 0 : r.id, "Completed"), await fi()) : void 0;
      }),
      deleteHistory: wt(async ({ input: e }) => e ? await dw(e == null ? void 0 : e.id) : void 0),
      initializeHistory: wt(async () => {
        try {
          return await cw();
        } catch {
          throw new Error("Something went wrong");
        }
      }),
      searchHistory: wt(async () => " "),
      forceInit: wt(async ({ input: e }) => {
        var t, a, r;
        try {
          let n = null;
          (t = e == null ? void 0 : e.metadata) != null && t.is_onboarding_active && (n = await pi());
          let o = null;
          (a = e == null ? void 0 : e.metadata) != null && a.is_announcement_active && (o = await fi());
          let s = null;
          return (r = e == null ? void 0 : e.metadata) != null && r.is_guidance_active && (s = await hi()), {
            features: o,
            topSuggestedFlows: s,
            plans: n
          };
        } catch (n) {
          throw console.log("error", n), new Error("Something went wrong", { cause: n });
        }
      }),
      initialize: wt(async () => {
        var e, t, a, r, n, o, s, i, l, u;
        try {
          const f = await lw();
          if (!f)
            throw new Error("Failed to initialize widget");
          const p = JSON.parse(f.platform.metadata);
          Z.config.name = ((e = f.platform) == null ? void 0 : e.display_name) || ((t = f.platform) == null ? void 0 : t.name.charAt(0).toUpperCase()) + ((a = f.platform) == null ? void 0 : a.name.slice(1)), Z.internal_config.platform_id = f.platform.id;
          const c = E3(f.theme), h = ((r = f.onbording_flows) == null ? void 0 : r.completed) || 0, g = (((n = f.onbording_flows) == null ? void 0 : n.not_started) || 0) + (((o = f.onbording_flows) == null ? void 0 : o.in_progress) || 0), _ = ((s = f.announcements) == null ? void 0 : s.completed) || 0, b = (((i = f.announcements) == null ? void 0 : i.not_started) || 0) + (((l = f.announcements) == null ? void 0 : l.in_progress) || 0);
          return (u = Z.config) != null && u.onMetadata && Z.config.onMetadata({
            completedOnboardingFlowCount: h,
            notCompletedOnboardingFlowCount: g,
            completedAnnouncementFlowCount: _,
            notCompletedAnnouncementFlowCount: b
          }), {
            metadata: {
              is_guidance_active: p.is_guidance_active,
              is_onboarding_active: p.is_onboarding_active,
              is_announcement_active: p.is_announcement_active
            },
            theme: c,
            startOnboardingFlow: f.show_onboarding || !1,
            platform: f.platform
          };
        } catch (f) {
          throw console.log("error", f), new Error("Something went wrong", { cause: f });
        }
      })
    },
    actions: {
      clearEveryState: re({
        isInitialized: !1,
        plans: null,
        features: null,
        metadata: null,
        theme: null
      }),
      setGuidanceConfig: ({ event: e }) => {
        Z.config = {
          ...Z.config,
          ...e == null ? void 0 : e.data
        };
      },
      setOnboardingFlowCount: ({ context: e }) => {
        var r, n, o, s, i;
        const t = ((n = (r = e == null ? void 0 : e.plans) == null ? void 0 : r.onboarding_flows.filter(
          (l) => l.state.status === "Completed"
        )) == null ? void 0 : n.length) || 0, a = ((s = (o = e == null ? void 0 : e.plans) == null ? void 0 : o.onboarding_flows.filter(
          (l) => l.state.status !== "Completed"
        )) == null ? void 0 : s.length) || 0;
        (i = Z.config) != null && i.onMetadata && Z.config.onMetadata({
          completedOnboardingFlowCount: t,
          notCompletedOnboardingFlowCount: a
        });
      },
      setLayupMessagesHistory: re({
        messages: ({ context: e, event: t }) => JSON.parse(t.item.conversation),
        isHistory: !0
      }),
      newPageOnboarding: ({ context: e, event: t }) => {
        var a, r, n, o, s, i, l, u, f;
        xi(
          (n = (r = (a = t == null ? void 0 : t.item) == null ? void 0 : a.template_onboarding_flow) == null ? void 0 : r.flow) == null ? void 0 : n.starting_url,
          {
            id: (o = t == null ? void 0 : t.item) == null ? void 0 : o.id,
            query: (i = (s = t == null ? void 0 : t.item) == null ? void 0 : s.template_onboarding_flow) == null ? void 0 : i.title,
            template_onboarding_flow: (l = t == null ? void 0 : t.item) == null ? void 0 : l.template_onboarding_flow,
            flowStatus: (f = (u = t == null ? void 0 : t.item) == null ? void 0 : u.state) == null ? void 0 : f.status
          },
          "saved_onboarding_flow"
        );
      },
      takeToStartingUrl: ({ context: e, event: t }) => {
        var a, r, n;
        (a = t == null ? void 0 : t.flow) != null && a.starting_url && !Co((r = t == null ? void 0 : t.flow) == null ? void 0 : r.starting_url) && xi((n = t == null ? void 0 : t.flow) == null ? void 0 : n.starting_url, {
          flow: t == null ? void 0 : t.flow,
          query: e.query,
          query_id: e.query_id,
          messages: e.messages
        });
      },
      playNewPage: ({ context: e, event: t }) => {
        var a, r, n, o, s, i, l;
        (r = (a = t.item) == null ? void 0 : a.flow) != null && r.starting_url && !Co((o = (n = t.item) == null ? void 0 : n.flow) == null ? void 0 : o.starting_url) && xi((i = (s = t.item) == null ? void 0 : s.flow) == null ? void 0 : i.starting_url, {
          flow: (l = t.item) == null ? void 0 : l.flow,
          query: e.query,
          query_id: e.query_id,
          messages: e.messages
        });
      },
      clearLocalStorage: () => {
        localStorage.removeItem("incomplete_flow"), localStorage.removeItem("new_page_flow");
      },
      appendLayupErrorMessages: re({
        messages: ({ context: e }) => [
          ...e.messages,
          {
            role: "assistant",
            content: "There was an error fetching your query",
            error: !0
          }
        ]
      }),
      handleProgress: re({
        agentMessage: ({ event: e }) => e.data
      }),
      handleDone: re({
        agentMessage: null,
        sessionId: ({ event: e }) => {
          var t, a;
          return (a = (t = e.data) == null ? void 0 : t.query) == null ? void 0 : a.id;
        },
        messages: ({ context: e, event: t }) => {
          var a, r, n;
          return [
            ...e.messages,
            t.data.messages[((a = t.data.messages) == null ? void 0 : a.length) - 1].content[((n = t.data.messages[((r = t.data.messages) == null ? void 0 : r.length) - 1].content) == null ? void 0 : n.length) - 1]
          ];
        }
      }),
      appendKnowledgeQuery: re({
        messages: ({ context: e, event: t }) => [
          ...e.messages,
          {
            role: "assistant",
            content: t.output.answer
          }
        ]
      }),
      markAsNotStartedOnboarding: re({
        plans: ({ event: e, context: t }) => {
          var n;
          const a = t.plans, r = (n = a == null ? void 0 : a.onboarding_flows) == null ? void 0 : n.map((o) => (o.id === e.item.id && (o.state.status = "NotStarted"), o));
          return { ...a, onboarding_flows: r };
        }
      }),
      apiMarkAsNotStartedOnboarding: ({ event: e }) => {
        yn(e.item.id, "NotStarted");
      },
      markAsCompletedOnboarding: re({
        plans: ({ event: e, context: t }) => {
          var n;
          const a = t.plans, r = (n = a == null ? void 0 : a.onboarding_flows) == null ? void 0 : n.map((o) => (o.id === e.item.id && (o.state.status = "Completed"), o));
          return { ...a, onboarding_flows: r };
        }
      }),
      apiMarkAsCompletedOnboarding: ({ event: e }) => {
        yn(e.item.id, "Completed");
      },
      removePausedMessage: re({
        messages: ({ context: e, event: t }) => e.messages.filter(
          (a) => {
            var r;
            return a.role !== "guidance-machine" && a.id !== ((r = t == null ? void 0 : t.output) == null ? void 0 : r.id);
          }
        )
      }),
      appendPausedMessage: re({
        messages: ({ context: e, event: t }) => {
          var n, o, s, i, l, u, f, p, c, h;
          const a = {
            role: "guidance-machine",
            content: (n = t == null ? void 0 : t.output) == null ? void 0 : n.query,
            query: (o = t == null ? void 0 : t.output) == null ? void 0 : o.query,
            id: (s = t == null ? void 0 : t.output) == null ? void 0 : s.id,
            flow_id: (l = (i = t == null ? void 0 : t.output) == null ? void 0 : i.flow) == null ? void 0 : l.id,
            currentStepIndex: (u = t == null ? void 0 : t.output) == null ? void 0 : u.currentStepIndex,
            currentSelection: (f = t == null ? void 0 : t.output) == null ? void 0 : f.currentSelection,
            currentActionsMap: (p = t == null ? void 0 : t.output) == null ? void 0 : p.currentActionsMap,
            progressSteps: (c = t == null ? void 0 : t.output) == null ? void 0 : c.progressSteps,
            guidanceFlow: (h = t == null ? void 0 : t.output) == null ? void 0 : h.guidanceFlow
          }, r = e.messages.findIndex(
            (g) => {
              var _;
              return g.role === "guidance-machine" && g.id === ((_ = t == null ? void 0 : t.output) == null ? void 0 : _.id);
            }
          );
          if (r >= 0) {
            const g = [...e.messages];
            return g[r] = a, g;
          }
          return [...e.messages, a];
        }
      }),
      addFlowFound: re({
        flowFound: ({ event: e }) => e.output
      }),
      clearQuerySearch: re({
        query: null,
        suggestedFlowsByName: []
      }),
      setQueryBySearch: re({
        query: ({ event: e }) => e.query
      }),
      setSuggestedFlowsByName: re({
        suggestedFlowsByName: ({ event: e }) => e.output
      }),
      setQuery: re({
        query: ({ event: e }) => e.output.query.query
      }),
      markSeen: async ({ event: e }) => {
        var t;
        await yi((t = e == null ? void 0 : e.item) == null ? void 0 : t.id, "Seen");
      },
      markFeatureSeenLocally: re({
        features: ({ context: e, event: t }) => {
          const a = e.features, r = a == null ? void 0 : a.find(
            (n) => {
              var o;
              return (n == null ? void 0 : n.id) === ((o = t == null ? void 0 : t.item) == null ? void 0 : o.id);
            }
          );
          return r && (r.state.status = "Seen"), a;
        }
      }),
      markInProgressFeatures: async ({ event: e }) => {
        var a, r;
        const t = ((a = e == null ? void 0 : e.item) == null ? void 0 : a.id) || ((r = e == null ? void 0 : e.output) == null ? void 0 : r.id);
        t && await yi(t, "InProgress");
      },
      markInProgressOnboarding: async ({ event: e }) => {
        var a, r;
        const t = ((a = e == null ? void 0 : e.item) == null ? void 0 : a.id) || ((r = e == null ? void 0 : e.output) == null ? void 0 : r.id);
        t && await yn(t, "InProgress");
      },
      setOnboarding: re({
        plans: ({ event: e }) => e.output
      }),
      setFeatures: re({
        features: ({ event: e }) => e.output
      }),
      clearMessages: re({
        messages: [],
        query_id: null
      }),
      setError: ({ event: e }) => {
        switch (e.actorId) {
          case "getFlowForOnboarding":
            Rr.error("There was an error fetching your onboarding flow!");
            break;
          case "getQuery":
            Rr.error("There was an error fetching your query!");
            break;
          case "getFlow":
            Rr.error("We were not able to fetch the flow!");
            break;
          case "initializeHistory":
            Rr.error("There is an issue with the history API!");
            break;
          case "guideMachine":
            Rr.error("There is an issue with the guide flow!");
            break;
        }
      },
      setHistory: re({
        history: ({ event: e }) => e.output
      }),
      log: ({ context: e, event: t }) => console.log("log", e, t),
      setTopSuggestedFlows: re({
        messages: ({ event: e, context: t }) => [
          ...t.messages,
          { role: "user", content: e.name },
          { role: "assistant", content: "" }
        ],
        query: ({ event: e }) => e.name
      }),
      setUserQuery: re({
        messages: ({ event: e, context: t }) => [
          ...t.messages,
          { role: "user", content: e.userMessages },
          { role: "assistant", content: "" }
        ],
        query: ({ event: e }) => e.userMessages
      }),
      appendLayupMessages: re({
        query_id: ({ event: e }) => {
          var t;
          return (t = e == null ? void 0 : e.output) == null ? void 0 : t.query_id;
        },
        messages: ({ event: e, context: t }) => {
          var r;
          let a;
          return (r = e.output) != null && r.conversation && (a = e.output.conversation), [...t.messages, a == null ? void 0 : a[(a == null ? void 0 : a.length) - 1]];
        }
      }),
      setContext: re({
        isInitialized: !0,
        startOnboardingFlow: ({ event: e }) => e.output.startOnboardingFlow,
        metadata: ({ event: e }) => e.output.metadata,
        theme: ({ event: e }) => e.output.theme,
        plans: ({ event: e }) => e.output.plans,
        features: ({ event: e }) => e.output.features,
        topSuggestedFlows: ({ event: e }) => e.output.topSuggestedFlows
      }),
      clearContext: re({
        messages: [],
        query_id: null
      }),
      clearIncompleteFlow: () => {
        localStorage.removeItem("incomplete_flow");
      },
      createQuickQuery: async ({ event: e }) => {
        var t, a, r, n, o, s, i;
        ((t = e == null ? void 0 : e.output) != null && t.isOnboarding || (a = e == null ? void 0 : e.output) != null && a.isAnnouncement) && await Uy({
          query: (r = e == null ? void 0 : e.output) == null ? void 0 : r.query,
          flow_id: (n = e == null ? void 0 : e.output) == null ? void 0 : n.flow_id,
          is_knowledge_query: !1,
          is_guide_query: !0,
          type: (o = e == null ? void 0 : e.output) != null && o.isOnboarding ? "Onboarding" : "Announcement",
          completed_flow_steps: ((s = e == null ? void 0 : e.output) == null ? void 0 : s.currentStepIndex) + 1 / ((i = e == null ? void 0 : e.output) == null ? void 0 : i.steps_length)
        });
      },
      clearNewPageFlow: () => {
        localStorage.removeItem("new_page_flow");
      },
      clearNewPageOnboarding: () => {
        localStorage.removeItem("saved_onboarding_flow");
      },
      clearLoadingItems: re({
        loadingId: null
      })
    },
    guards: {
      hasSameStartingPoint: ({ event: e }) => {
        var t, a;
        return (t = e == null ? void 0 : e.flow) != null && t.starting_url ? Co((a = e == null ? void 0 : e.flow) == null ? void 0 : a.starting_url) : !0;
      },
      hasSameStartingPointOnboarding: ({ event: e }) => {
        var t, a, r, n, o, s;
        return (r = (a = (t = e == null ? void 0 : e.item) == null ? void 0 : t.template_onboarding_flow) == null ? void 0 : a.flow) != null && r.starting_url ? (console.log("event", e), Co(
          (s = (o = (n = e == null ? void 0 : e.item) == null ? void 0 : n.template_onboarding_flow) == null ? void 0 : o.flow) == null ? void 0 : s.starting_url
        )) : !0;
      },
      hasOnlyFeature: ({ context: e }) => {
        var t, a, r;
        return !!((t = e == null ? void 0 : e.metadata) != null && t.is_announcement_active && !((a = e.metadata) != null && a.is_guidance_active) && !((r = e.metadata) != null && r.is_onboarding_active));
      },
      hasOnlyOnboarding: ({ context: e }) => {
        var t, a, r;
        return !!((t = e == null ? void 0 : e.metadata) != null && t.is_onboarding_active && !((a = e.metadata) != null && a.is_guidance_active) && !((r = e.metadata) != null && r.is_announcement_active));
      },
      isInitialized: ({ context: e }) => e == null ? void 0 : e.isInitialized,
      hasSeenFeatures: ({ context: e }) => {
        var t, a, r;
        return !!(((t = e == null ? void 0 : e.features) == null ? void 0 : t.length) > 0 && ((a = e == null ? void 0 : e.metadata) != null && a.is_announcement_active) && ((r = e == null ? void 0 : e.features) != null && r.some(
          (n) => {
            var o;
            return ((o = n == null ? void 0 : n.state) == null ? void 0 : o.status) !== "NotStarted";
          }
        )));
      },
      isKnowledgeQuery: ({ event: e }) => {
        var t;
        return (t = e == null ? void 0 : e.output) == null ? void 0 : t.answer;
      },
      isPaused: ({ event: e }) => {
        var t;
        return ((t = e == null ? void 0 : e.output) == null ? void 0 : t.status) === "PAUSE";
      },
      hasQuerySearch: ({ event: e }) => e == null ? void 0 : e.query,
      hasFeatures: ({ context: e }) => {
        var t, a;
        return !!(((t = e == null ? void 0 : e.features) == null ? void 0 : t.length) > 0 && ((a = e == null ? void 0 : e.metadata) != null && a.is_announcement_active));
      },
      hasOnboardingNewUser: ({ event: e }) => {
        var t, a, r, n, o, s, i, l, u, f;
        return !!((t = e == null ? void 0 : e.output) != null && t.startOnboardingFlow && ((r = (a = e == null ? void 0 : e.output) == null ? void 0 : a.metadata) != null && r.is_onboarding_active) && ((n = e == null ? void 0 : e.output) != null && n.plans) && ((i = (s = (o = e == null ? void 0 : e.output) == null ? void 0 : o.plans) == null ? void 0 : s.onboarding_flows) == null ? void 0 : i.length) > 0 && ((f = (u = (l = e == null ? void 0 : e.output) == null ? void 0 : l.plans) == null ? void 0 : u.onboarding_flows) != null && f.some(
          (p) => {
            var c;
            return ((c = p == null ? void 0 : p.state) == null ? void 0 : c.status) !== "Completed";
          }
        )));
      },
      hasOnboarding: ({ context: e }) => {
        var t, a, r;
        return !!((t = e == null ? void 0 : e.metadata) != null && t.is_onboarding_active && (e != null && e.plans) && ((r = (a = e == null ? void 0 : e.plans) == null ? void 0 : a.onboarding_flows) == null ? void 0 : r.length) > 0);
      },
      hasQuery: ({ context: e }) => {
        var t;
        return !!((t = e == null ? void 0 : e.metadata) != null && t.is_guidance_active);
      },
      hasOnboardingId: ({ event: e }) => (e == null ? void 0 : e.id) !== null,
      hasFlowObject: ({ event: e }) => (e == null ? void 0 : e.output) !== null,
      validateIncompleteFlow: ({ event: e }) => {
        const t = e == null ? void 0 : e.output;
        if (!t)
          return !1;
        if (t.startTime) {
          const a = new Date(t.startTime);
          return (/* @__PURE__ */ new Date()).getTime() - a.getTime() < 1e3 * 60 * 60;
        }
        return !0;
      },
      noSteps: ({ event: e }) => !e.output.flow,
      hasIncompleteFlow: () => localStorage.getItem("incomplete_flow") !== null,
      hasNewPageFlow: () => localStorage.getItem("new_page_flow") !== null,
      hasSavedOnboardingFlow: () => localStorage.getItem("saved_onboarding_flow") !== null,
      hasOnboardingFlowId: () => new URLSearchParams(window.location.search).get("onboarding_flow") !== null,
      hasFlowId: () => new URLSearchParams(window.location.search).get("flow_id") !== null
    }
  }
);
function T3(e, ...[t]) {
  const a = No(e, t).start();
  return Wu(() => a.stop()), a;
}
function P3(e, ...[t]) {
  const a = T3(e, t);
  let r = a.getSnapshot();
  return {
    snapshot: xw(r, (o) => a.subscribe((s) => {
      r !== s && (r = s, o(r));
    }).unsubscribe),
    send: a.send,
    actorRef: a
  };
}
function O3(e, ...[t]) {
  return P3(e, t);
}
var am = { exports: {} };
(function(e) {
  (function(t, a, r) {
    if (!t)
      return;
    for (var n = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    }, o = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    }, s = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      $: "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      _: "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    }, i = {
      option: "alt",
      command: "meta",
      return: "enter",
      escape: "esc",
      plus: "+",
      mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    }, l, u = 1; u < 20; ++u)
      n[111 + u] = "f" + u;
    for (u = 0; u <= 9; ++u)
      n[u + 96] = u.toString();
    function f(k, x, T) {
      if (k.addEventListener) {
        k.addEventListener(x, T, !1);
        return;
      }
      k.attachEvent("on" + x, T);
    }
    function p(k) {
      if (k.type == "keypress") {
        var x = String.fromCharCode(k.which);
        return k.shiftKey || (x = x.toLowerCase()), x;
      }
      return n[k.which] ? n[k.which] : o[k.which] ? o[k.which] : String.fromCharCode(k.which).toLowerCase();
    }
    function c(k, x) {
      return k.sort().join(",") === x.sort().join(",");
    }
    function h(k) {
      var x = [];
      return k.shiftKey && x.push("shift"), k.altKey && x.push("alt"), k.ctrlKey && x.push("ctrl"), k.metaKey && x.push("meta"), x;
    }
    function g(k) {
      if (k.preventDefault) {
        k.preventDefault();
        return;
      }
      k.returnValue = !1;
    }
    function _(k) {
      if (k.stopPropagation) {
        k.stopPropagation();
        return;
      }
      k.cancelBubble = !0;
    }
    function b(k) {
      return k == "shift" || k == "ctrl" || k == "alt" || k == "meta";
    }
    function m() {
      if (!l) {
        l = {};
        for (var k in n)
          k > 95 && k < 112 || n.hasOwnProperty(k) && (l[n[k]] = k);
      }
      return l;
    }
    function w(k, x, T) {
      return T || (T = m()[k] ? "keydown" : "keypress"), T == "keypress" && x.length && (T = "keydown"), T;
    }
    function S(k) {
      return k === "+" ? ["+"] : (k = k.replace(/\+{2}/g, "+plus"), k.split("+"));
    }
    function C(k, x) {
      var T, F, P, O = [];
      for (T = S(k), P = 0; P < T.length; ++P)
        F = T[P], i[F] && (F = i[F]), x && x != "keypress" && s[F] && (F = s[F], O.push("shift")), b(F) && O.push(F);
      return x = w(F, O, x), {
        key: F,
        modifiers: O,
        action: x
      };
    }
    function v(k, x) {
      return k === null || k === a ? !1 : k === x ? !0 : v(k.parentNode, x);
    }
    function y(k) {
      var x = this;
      if (k = k || a, !(x instanceof y))
        return new y(k);
      x.target = k, x._callbacks = {}, x._directMap = {};
      var T = {}, F, P = !1, O = !1, I = !1;
      function E(W) {
        W = W || {};
        var G = !1, J;
        for (J in T) {
          if (W[J]) {
            G = !0;
            continue;
          }
          T[J] = 0;
        }
        G || (I = !1);
      }
      function N(W, G, J, te, ae, ie) {
        var oe, Q, le = [], he = J.type;
        if (!x._callbacks[W])
          return [];
        for (he == "keyup" && b(W) && (G = [W]), oe = 0; oe < x._callbacks[W].length; ++oe)
          if (Q = x._callbacks[W][oe], !(!te && Q.seq && T[Q.seq] != Q.level) && he == Q.action && (he == "keypress" && !J.metaKey && !J.ctrlKey || c(G, Q.modifiers))) {
            var pe = !te && Q.combo == ae, se = te && Q.seq == te && Q.level == ie;
            (pe || se) && x._callbacks[W].splice(oe, 1), le.push(Q);
          }
        return le;
      }
      function H(W, G, J, te) {
        x.stopCallback(G, G.target || G.srcElement, J, te) || W(G, J) === !1 && (g(G), _(G));
      }
      x._handleKey = function(W, G, J) {
        var te = N(W, G, J), ae, ie = {}, oe = 0, Q = !1;
        for (ae = 0; ae < te.length; ++ae)
          te[ae].seq && (oe = Math.max(oe, te[ae].level));
        for (ae = 0; ae < te.length; ++ae) {
          if (te[ae].seq) {
            if (te[ae].level != oe)
              continue;
            Q = !0, ie[te[ae].seq] = 1, H(te[ae].callback, J, te[ae].combo, te[ae].seq);
            continue;
          }
          Q || H(te[ae].callback, J, te[ae].combo);
        }
        var le = J.type == "keypress" && O;
        J.type == I && !b(W) && !le && E(ie), O = Q && J.type == "keydown";
      };
      function Y(W) {
        typeof W.which != "number" && (W.which = W.keyCode);
        var G = p(W);
        if (G) {
          if (W.type == "keyup" && P === G) {
            P = !1;
            return;
          }
          x.handleKey(G, h(W), W);
        }
      }
      function V() {
        clearTimeout(F), F = setTimeout(E, 1e3);
      }
      function U(W, G, J, te) {
        T[W] = 0;
        function ae(he) {
          return function() {
            I = he, ++T[W], V();
          };
        }
        function ie(he) {
          H(J, he, W), te !== "keyup" && (P = p(he)), setTimeout(E, 10);
        }
        for (var oe = 0; oe < G.length; ++oe) {
          var Q = oe + 1 === G.length, le = Q ? ie : ae(te || C(G[oe + 1]).action);
          ee(G[oe], le, te, W, oe);
        }
      }
      function ee(W, G, J, te, ae) {
        x._directMap[W + ":" + J] = G, W = W.replace(/\s+/g, " ");
        var ie = W.split(" "), oe;
        if (ie.length > 1) {
          U(W, ie, G, J);
          return;
        }
        oe = C(W, J), x._callbacks[oe.key] = x._callbacks[oe.key] || [], N(oe.key, oe.modifiers, { type: oe.action }, te, W, ae), x._callbacks[oe.key][te ? "unshift" : "push"]({
          callback: G,
          modifiers: oe.modifiers,
          action: oe.action,
          seq: te,
          level: ae,
          combo: W
        });
      }
      x._bindMultiple = function(W, G, J) {
        for (var te = 0; te < W.length; ++te)
          ee(W[te], G, J);
      }, f(k, "keypress", Y), f(k, "keydown", Y), f(k, "keyup", Y);
    }
    y.prototype.bind = function(k, x, T) {
      var F = this;
      return k = k instanceof Array ? k : [k], F._bindMultiple.call(F, k, x, T), F;
    }, y.prototype.unbind = function(k, x) {
      var T = this;
      return T.bind.call(T, k, function() {
      }, x);
    }, y.prototype.trigger = function(k, x) {
      var T = this;
      return T._directMap[k + ":" + x] && T._directMap[k + ":" + x]({}, k), T;
    }, y.prototype.reset = function() {
      var k = this;
      return k._callbacks = {}, k._directMap = {}, k;
    }, y.prototype.stopCallback = function(k, x) {
      var T = this;
      if ((" " + x.className + " ").indexOf(" mousetrap ") > -1 || v(x, T.target))
        return !1;
      if ("composedPath" in k && typeof k.composedPath == "function") {
        var F = k.composedPath()[0];
        F !== k.target && (x = F);
      }
      return x.tagName == "INPUT" || x.tagName == "SELECT" || x.tagName == "TEXTAREA" || x.isContentEditable;
    }, y.prototype.handleKey = function() {
      var k = this;
      return k._handleKey.apply(k, arguments);
    }, y.addKeycodes = function(k) {
      for (var x in k)
        k.hasOwnProperty(x) && (n[x] = k[x]);
      l = null;
    }, y.init = function() {
      var k = y(a);
      for (var x in k)
        x.charAt(0) !== "_" && (y[x] = /* @__PURE__ */ function(T) {
          return function() {
            return k[T].apply(k, arguments);
          };
        }(x));
    }, y.init(), t.Mousetrap = y, e.exports && (e.exports = y);
  })(typeof window < "u" ? window : null, typeof window < "u" ? document : null);
})(am);
var M3 = am.exports;
const I3 = /* @__PURE__ */ cc(M3);
var F3 = /* @__PURE__ */ St(`<svg><path d="M12,24H6v-7c-3.3,0-6-2.7-6-6s2.7-6,6-6h5c3.6,0,7.3-3.4,7.3-3.4L20,0v7c2.2,0,4,1.8,4,4s-1.8,4-4,4v6.8l-1.7-1.5
			c0,0-3.1-2.8-6.3-3.3V24z M8,22h2v-5H8V22z M12,15.1c2.4,0.3,4.6,1.5,6,2.5V4.4c-1.4,1-3.6,2.3-6,2.6V15.1z M6,15h4V7H6
			c-2.2,0-4,1.8-4,4S3.8,15,6,15z M20,11v2c1.1,0,2-0.9,2-2s-0.9-2-2-2V11z"></path></svg>`);
function j3(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = F3();
  let n;
  $(() => n = at(
    r,
    n,
    {
      class: t.class,
      ...a,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      "stroke-width": "0"
    },
    void 0,
    !0
  )), z(e, r);
}
var R3 = /* @__PURE__ */ St('<svg><path fill-rule="evenodd" clip-rule="evenodd" d="M1.54621 1.54621C1.97598 1.11644 2.55888 0.875 3.16667 0.875H14.8333C15.4411 0.875 16.024 1.11644 16.4538 1.54621C16.8836 1.97598 17.125 2.55888 17.125 3.16667V8.16667C17.125 8.51184 16.8452 8.79167 16.5 8.79167C16.1548 8.79167 15.875 8.51184 15.875 8.16667V3.16667C15.875 2.8904 15.7653 2.62545 15.5699 2.4301C15.3746 2.23475 15.1096 2.125 14.8333 2.125H3.16667C2.8904 2.125 2.62545 2.23475 2.4301 2.4301C2.23475 2.62545 2.125 2.8904 2.125 3.16667V14.8333C2.125 15.1096 2.23475 15.3746 2.4301 15.5699C2.62545 15.7653 2.8904 15.875 3.16667 15.875H8.16667C8.51184 15.875 8.79167 16.1548 8.79167 16.5C8.79167 16.8452 8.51184 17.125 8.16667 17.125H3.16667C2.55888 17.125 1.97598 16.8836 1.54621 16.4538C1.11644 16.024 0.875 15.4411 0.875 14.8333V3.16667C0.875 2.55888 1.11644 1.97598 1.54621 1.54621ZM9.78257 9.78257L12.3108 16.2838L13.0229 13.9862C13.0229 13.9861 13.0228 13.9864 13.0229 13.9862C13.093 13.7598 13.2173 13.5534 13.385 13.3858C13.5525 13.2182 13.7585 13.094 13.9849 13.0239M13.9849 13.0239L16.284 12.3109L9.78257 9.78257M9.79596 8.44658C9.60789 8.37228 9.40222 8.35441 9.20411 8.3952C9.00497 8.4362 8.82221 8.53468 8.67845 8.67845C8.53468 8.82221 8.4362 9.00497 8.3952 9.20411C8.35441 9.40222 8.37228 9.60789 8.44658 9.79596C8.44697 9.79695 8.44736 9.79793 8.44776 9.79892L11.3629 17.295C11.4414 17.496 11.5805 17.6676 11.7608 17.7862C11.9411 17.9048 12.1538 17.9644 12.3695 17.9569C12.5852 17.9493 12.7932 17.875 12.9648 17.7441C13.1364 17.6132 13.2631 17.4322 13.3274 17.2262L13.3278 17.225L14.217 14.3558C14.227 14.3235 14.2449 14.2936 14.2688 14.2697C14.2928 14.2457 14.3222 14.228 14.3546 14.2179L17.2251 13.3278L17.2262 13.3274C17.4322 13.2631 17.6132 13.1364 17.7441 12.9648C17.875 12.7932 17.9493 12.5852 17.9569 12.3695C17.9644 12.1538 17.9048 11.9411 17.7862 11.7608C17.6676 11.5805 17.496 11.4414 17.295 11.3629L9.79892 8.44776C9.79793 8.44736 9.79695 8.44697 9.79596 8.44658Z"></path></svg>');
function Fp(e, t) {
  let a = R(t, "class", 3, "layup-fill-white"), r = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var n = R3();
  let o;
  $(() => o = at(
    n,
    o,
    {
      class: a(),
      ...r,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, n);
}
var L3 = /* @__PURE__ */ St('<svg><path d="M790 790H208V208h291v-83H208q-35 0-59 24.5T125 208v582q0 35 24 59t59 24h582q35 0 59-24t24-59V499h-83v291zM582 125v83h150L323 617l58 58 409-408v149h83V125H582z"></path></svg>');
function D3(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = L3();
  let n;
  $(() => n = at(
    r,
    n,
    {
      class: t.class,
      ...a,
      viewBox: "0 0 1000 1000",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var N3 = /* @__PURE__ */ St('<svg><path d="M10.75 4.50003V8.57534L14.1363 10.6069C14.3068 10.7093 14.4297 10.8753 14.4779 11.0684C14.5261 11.2614 14.4956 11.4657 14.3931 11.6363C14.2907 11.8068 14.1247 11.9297 13.9316 11.9779C13.7386 12.0261 13.5343 11.9956 13.3638 11.8932L9.61375 9.64315C9.50276 9.57647 9.41093 9.48219 9.34719 9.36949C9.28344 9.25679 9.24996 9.12951 9.25 9.00003V4.50003C9.25 4.30112 9.32902 4.11035 9.46967 3.9697C9.61032 3.82905 9.80109 3.75003 10 3.75003C10.1989 3.75003 10.3897 3.82905 10.5303 3.9697C10.671 4.11035 10.75 4.30112 10.75 4.50003ZM10 2.77605e-05C8.81687 -0.00291932 7.64491 0.22881 6.55193 0.681803C5.45895 1.1348 4.46667 1.80006 3.6325 2.63909C2.95094 3.32909 2.34531 3.99284 1.75 4.68753V3.00003C1.75 2.80112 1.67098 2.61035 1.53033 2.4697C1.38968 2.32905 1.19891 2.25003 1 2.25003C0.801088 2.25003 0.610322 2.32905 0.46967 2.4697C0.329018 2.61035 0.25 2.80112 0.25 3.00003V6.75003C0.25 6.94894 0.329018 7.13971 0.46967 7.28036C0.610322 7.42101 0.801088 7.50003 1 7.50003H4.75C4.94891 7.50003 5.13968 7.42101 5.28033 7.28036C5.42098 7.13971 5.5 6.94894 5.5 6.75003C5.5 6.55112 5.42098 6.36035 5.28033 6.2197C5.13968 6.07905 4.94891 6.00003 4.75 6.00003H2.59375C3.26406 5.21065 3.93156 4.46722 4.69281 3.69659C5.73518 2.65423 7.0616 1.94216 8.50635 1.64935C9.95109 1.35654 11.4501 1.49598 12.816 2.05023C14.182 2.60449 15.3543 3.54899 16.1866 4.76572C17.0188 5.98245 17.474 7.41745 17.4953 8.89142C17.5166 10.3654 17.1031 11.813 16.3064 13.0532C15.5098 14.2935 14.3652 15.2716 13.0159 15.8651C11.6665 16.4586 10.1722 16.6414 8.71959 16.3905C7.26698 16.1396 5.92052 15.4662 4.84844 14.4544C4.77679 14.3867 4.6925 14.3338 4.60039 14.2986C4.50828 14.2635 4.41015 14.2468 4.3116 14.2496C4.21305 14.2524 4.11602 14.2746 4.02604 14.3149C3.93606 14.3551 3.8549 14.4128 3.78719 14.4844C3.71947 14.5561 3.66654 14.6403 3.6314 14.7325C3.59626 14.8246 3.57961 14.9227 3.5824 15.0212C3.58518 15.1198 3.60735 15.2168 3.64764 15.3068C3.68792 15.3968 3.74554 15.4779 3.81719 15.5457C4.88542 16.5537 6.18414 17.285 7.6 17.6757C9.01587 18.0665 10.5058 18.1047 11.9399 17.7872C13.3739 17.4696 14.7085 16.806 15.827 15.854C16.9456 14.9021 17.8142 13.6909 18.357 12.3261C18.8998 10.9613 19.1003 9.48439 18.9411 8.02426C18.7818 6.56414 18.2677 5.16517 17.4434 3.94947C16.6192 2.73376 15.5099 1.73825 14.2125 1.04982C12.915 0.361401 11.4688 0.000983756 10 2.77605e-05Z"></path></svg>');
function V3(e, t) {
  let a = R(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var n = N3();
  let o;
  $(() => o = at(
    n,
    o,
    {
      viewBox: "0 0 19 18",
      class: a(),
      ...r
    },
    void 0,
    !0
  )), z(e, n);
}
var q3 = /* @__PURE__ */ L('<div class="layup-block dark:layup-hidden"><svg><path d="M17.8497 54.1549L0 44.2793V68.5144C0 72.0945 2.90566 75.0004 6.48577 75.0004H30.7194L20.8402 57.1497C20.1445 55.89 19.1053 54.8547 17.8454 54.1549H17.8497Z" fill="#2E2E2C"></path><path d="M68.5099 0H6.48577C2.90566 0 0 2.90583 0 6.48615V28.5322L52.2469 14.5334C57.2393 13.1971 61.8037 17.7616 60.4676 22.7545L46.4692 75H68.5144C72.0945 75 75 72.0983 75 68.514V6.48615C74.9959 2.90583 72.0945 0 68.5099 0Z" fill="#2E2E2C"></path></svg></div> <div class="layup-hidden dark:layup-block"><svg><path d="M4.28392 12.9971L0 10.627V16.4434C0 17.3026 0.697359 18 1.55659 18H7.37267L5.00164 13.7158C4.83468 13.4135 4.58527 13.165 4.2829 12.9971H4.28392Z" fill="white"></path><path d="M16.4424 0H1.55659C0.697359 0 0 0.697398 0 1.55668V6.84774L12.5393 3.48801C13.7374 3.16731 14.8329 4.26278 14.5122 5.46108L11.1526 18H16.4435C17.3027 18 18 17.3036 18 16.4434V1.55668C17.999 0.697398 17.3027 0 16.4424 0Z" fill="white"></path></svg></div>', 1);
function rr(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy"]);
  var r = q3(), n = D(r), o = A(n);
  let s;
  var i = X(n, 2), l = A(i);
  let u;
  $(() => {
    s = at(
      o,
      s,
      {
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        viewBox: "0 0 75 75",
        fill: "none"
      },
      void 0,
      !0
    ), u = at(
      l,
      u,
      {
        ...a,
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg"
      },
      void 0,
      !0
    );
  }), z(e, r);
}
var B3 = /* @__PURE__ */ St('<svg><path d="M8.86076 9.29209C8.83672 9.2318 8.83089 9.16578 8.84398 9.10221C8.85707 9.03864 8.8885 8.98029 8.9344 8.9344C8.98029 8.8885 9.03864 8.85707 9.10221 8.84398C9.16578 8.83089 9.2318 8.83672 9.29209 8.86076L15.2921 11.1941C15.3564 11.2192 15.4113 11.2637 15.4493 11.3214C15.4872 11.3791 15.5063 11.4472 15.5039 11.5162C15.5015 11.5852 15.4777 11.6518 15.4358 11.7067C15.3939 11.7616 15.336 11.8022 15.2701 11.8228L12.9741 12.5348C12.8705 12.5668 12.7763 12.6236 12.6996 12.7003C12.6229 12.7769 12.5661 12.8712 12.5341 12.9748L11.8228 15.2701C11.8022 15.336 11.7616 15.3939 11.7067 15.4358C11.6518 15.4777 11.5852 15.5015 11.5162 15.5039C11.4472 15.5063 11.3791 15.4872 11.3214 15.4493C11.2637 15.4113 11.2192 15.3564 11.1941 15.2921L8.86076 9.29209Z" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.8381 8.17147V4.17147C14.8381 3.81785 14.6977 3.47871 14.4476 3.22866C14.1976 2.97861 13.8584 2.83813 13.5048 2.83813H4.17147C3.81785 2.83813 3.47871 2.97861 3.22866 3.22866C2.97861 3.47871 2.83813 3.81785 2.83813 4.17147V13.5048C2.83813 13.8584 2.97861 14.1976 3.22866 14.4476C3.47871 14.6977 3.81785 14.8381 4.17147 14.8381H8.17147" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
function W3(e, t) {
  let a = R(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var n = B3();
  let o;
  $(() => o = at(
    n,
    o,
    {
      class: a(),
      ...r,
      viewBox: "2 2 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, n);
}
function rm(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, ["class", "orientation", "decorative"]);
  ke(t, !1);
  let n = R(t, "class", 8, void 0), o = R(t, "orientation", 8, "horizontal"), s = R(t, "decorative", 8, void 0);
  ca();
  var i = /* @__PURE__ */ kt(() => Oe("layup-shrink-0 layup-bg-border", o() === "horizontal" ? "layup-h-[1px] layup-w-full" : "layup-min-h-full layup-w-[1px]", n()));
  Uz(e, it(
    {
      get class() {
        return d(i);
      },
      get orientation() {
        return o();
      },
      get decorative() {
        return s();
      }
    },
    () => r
  )), xe();
}
var H3 = /* @__PURE__ */ St("<title> </title>"), U3 = /* @__PURE__ */ St("<desc> </desc>"), G3 = /* @__PURE__ */ St('<svg><!><!><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"></path></svg>');
function Ra(e, t) {
  var b, m;
  ke(t, !0);
  const a = rc("iconCtx") ?? {};
  let r = R(t, "size", 19, () => a.size || "24"), n = R(t, "role", 19, () => a.role || "img"), o = R(t, "color", 19, () => a.color || "currentColor"), s = R(t, "ariaLabel", 3, "cross 2"), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "size",
    "role",
    "color",
    "title",
    "desc",
    "ariaLabel"
  ]), l = `${((b = t.title) == null ? void 0 : b.id) || ""} ${((m = t.desc) == null ? void 0 : m.id) || ""}`;
  const u = /* @__PURE__ */ M(() => {
    var w, S;
    return !!((w = t.title) != null && w.id || (S = t.desc) != null && S.id);
  });
  var f = G3();
  let p;
  var c = A(f);
  {
    var h = (w) => {
      var S = H3(), C = A(S);
      $(() => {
        be(S, "id", t.title.id), Me(C, t.title.title);
      }), z(w, S);
    };
    B(c, (w) => {
      var S;
      (S = t.title) != null && S.id && t.title.title && w(h);
    });
  }
  var g = X(c);
  {
    var _ = (w) => {
      var S = U3(), C = A(S);
      $(() => {
        be(S, "id", t.desc.id), Me(C, t.desc.desc);
      }), z(w, S);
    };
    B(g, (w) => {
      var S;
      (S = t.desc) != null && S.id && t.desc.desc && w(_);
    });
  }
  $(() => p = at(
    f,
    p,
    {
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      role: n(),
      width: r(),
      height: r(),
      fill: o(),
      "aria-label": s(),
      "aria-describedby": d(u) ? l : void 0,
      viewBox: "0 0 15 15"
    },
    void 0,
    !0
  )), z(e, f), xe();
}
function K3() {
  const e = console.warn;
  console.warn = (t) => {
    t.includes("unknown prop") || t.includes("unexpected slot") || e(t);
  }, Da(() => {
    console.warn = e;
  });
}
var Z3 = /* @__PURE__ */ L("<!> <!>", 1);
function Dr(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, [
    "type",
    "tokens",
    "header",
    "rows",
    "ordered",
    "renderers"
  ]);
  ke(t, !1);
  let n = R(t, "type", 8, void 0), o = R(t, "tokens", 8, void 0), s = R(t, "header", 8, void 0), i = R(t, "rows", 8, void 0), l = R(t, "ordered", 8, !1), u = R(t, "renderers", 8);
  K3(), ca();
  var f = K(), p = D(f);
  {
    var c = (g) => {
      var _ = K(), b = D(_);
      et(b, 1, o, yt, (m, w) => {
        var S = K(), C = D(S);
        Dr(C, it(() => d(w), {
          get renderers() {
            return u();
          }
        })), z(m, S);
      }), z(g, _);
    }, h = (g) => {
      var _ = K(), b = D(_);
      {
        var m = (w) => {
          var S = K(), C = D(S);
          {
            var v = (k) => {
              var x = K(), T = D(x);
              Xe(T, () => u().table, (F, P) => {
                P(F, {
                  children: (O, I) => {
                    var E = Z3(), N = D(E);
                    Xe(N, () => u().tablehead, (Y, V) => {
                      V(Y, {
                        children: (U, ee) => {
                          var W = K(), G = D(W);
                          Xe(G, () => u().tablerow, (J, te) => {
                            te(J, {
                              children: (ae, ie) => {
                                var oe = K(), Q = D(oe);
                                et(Q, 1, s, yt, (le, he, pe) => {
                                  var se = K(), ye = D(se), ge = /* @__PURE__ */ kt(() => r.align[pe] || "center");
                                  Xe(ye, () => u().tablecell, (ue, _e) => {
                                    _e(ue, {
                                      header: !0,
                                      get align() {
                                        return d(ge);
                                      },
                                      children: (Se, Re) => {
                                        var ve = K(), ze = D(ve);
                                        Dr(ze, {
                                          get tokens() {
                                            return d(he).tokens;
                                          },
                                          get renderers() {
                                            return u();
                                          }
                                        }), z(Se, ve);
                                      },
                                      $$slots: { default: !0 }
                                    });
                                  }), z(le, se);
                                }), z(ae, oe);
                              },
                              $$slots: { default: !0 }
                            });
                          }), z(U, W);
                        },
                        $$slots: { default: !0 }
                      });
                    });
                    var H = X(N, 2);
                    Xe(H, () => u().tablebody, (Y, V) => {
                      V(Y, {
                        children: (U, ee) => {
                          var W = K(), G = D(W);
                          et(G, 1, i, yt, (J, te) => {
                            var ae = K(), ie = D(ae);
                            Xe(ie, () => u().tablerow, (oe, Q) => {
                              Q(oe, {
                                children: (le, he) => {
                                  var pe = K(), se = D(pe);
                                  et(se, 1, () => d(te), yt, (ye, ge, ue) => {
                                    var _e = K(), Se = D(_e), Re = /* @__PURE__ */ kt(() => r.align[ue] || "center");
                                    Xe(Se, () => u().tablecell, (ve, ze) => {
                                      ze(ve, {
                                        header: !1,
                                        get align() {
                                          return d(Re);
                                        },
                                        children: (fe, Ce) => {
                                          var Ne = K(), je = D(Ne);
                                          Dr(je, {
                                            get tokens() {
                                              return d(ge).tokens;
                                            },
                                            get renderers() {
                                              return u();
                                            }
                                          }), z(fe, Ne);
                                        },
                                        $$slots: { default: !0 }
                                      });
                                    }), z(ye, _e);
                                  }), z(le, pe);
                                },
                                $$slots: { default: !0 }
                              });
                            }), z(J, ae);
                          }), z(U, W);
                        },
                        $$slots: { default: !0 }
                      });
                    }), z(O, E);
                  },
                  $$slots: { default: !0 }
                });
              }), z(k, x);
            }, y = (k) => {
              var x = K(), T = D(x);
              {
                var F = (O) => {
                  var I = K(), E = D(I);
                  {
                    var N = (Y) => {
                      var V = K(), U = D(V);
                      Xe(U, () => u().list, (ee, W) => {
                        W(ee, it(
                          {
                            get ordered() {
                              return l();
                            }
                          },
                          () => r,
                          {
                            children: (G, J) => {
                              var te = K(), ae = D(te);
                              et(ae, 1, () => r.items, yt, (ie, oe) => {
                                var Q = K(), le = D(Q);
                                Xe(le, () => u().orderedlistitem || u().listitem, (he, pe) => {
                                  pe(he, it(() => d(oe), {
                                    children: (se, ye) => {
                                      var ge = K(), ue = D(ge);
                                      Dr(ue, {
                                        get tokens() {
                                          return d(oe).tokens;
                                        },
                                        get renderers() {
                                          return u();
                                        }
                                      }), z(se, ge);
                                    },
                                    $$slots: { default: !0 }
                                  }));
                                }), z(ie, Q);
                              }), z(G, te);
                            },
                            $$slots: { default: !0 }
                          }
                        ));
                      }), z(Y, V);
                    }, H = (Y) => {
                      var V = K(), U = D(V);
                      Xe(U, () => u().list, (ee, W) => {
                        W(ee, it(
                          {
                            get ordered() {
                              return l();
                            }
                          },
                          () => r,
                          {
                            children: (G, J) => {
                              var te = K(), ae = D(te);
                              et(ae, 1, () => r.items, yt, (ie, oe) => {
                                var Q = K(), le = D(Q);
                                Xe(le, () => u().unorderedlistitem || u().listitem, (he, pe) => {
                                  pe(he, it(() => d(oe), {
                                    children: (se, ye) => {
                                      var ge = K(), ue = D(ge);
                                      Dr(ue, {
                                        get tokens() {
                                          return d(oe).tokens;
                                        },
                                        get renderers() {
                                          return u();
                                        }
                                      }), z(se, ge);
                                    },
                                    $$slots: { default: !0 }
                                  }));
                                }), z(ie, Q);
                              }), z(G, te);
                            },
                            $$slots: { default: !0 }
                          }
                        ));
                      }), z(Y, V);
                    };
                    B(E, (Y) => {
                      l() ? Y(N) : Y(H, !1);
                    });
                  }
                  z(O, I);
                }, P = (O) => {
                  var I = K(), E = D(I);
                  Xe(E, () => u()[n()], (N, H) => {
                    H(N, it(() => r, {
                      children: (Y, V) => {
                        var U = K(), ee = D(U);
                        {
                          var W = (J) => {
                            var te = K(), ae = D(te);
                            Dr(ae, {
                              get tokens() {
                                return o();
                              },
                              get renderers() {
                                return u();
                              }
                            }), z(J, te);
                          }, G = (J) => {
                            var te = Xn();
                            $(() => Me(te, r.raw)), z(J, te);
                          };
                          B(ee, (J) => {
                            o() ? J(W) : J(G, !1);
                          });
                        }
                        z(Y, U);
                      },
                      $$slots: { default: !0 }
                    }));
                  }), z(O, I);
                };
                B(
                  T,
                  (O) => {
                    n() === "list" ? O(F) : O(P, !1);
                  },
                  !0
                );
              }
              z(k, x);
            };
            B(C, (k) => {
              n() === "table" ? k(v) : k(y, !1);
            });
          }
          z(w, S);
        };
        B(b, (w) => {
          u()[n()] && w(m);
        });
      }
      z(g, _);
    };
    B(p, (g) => {
      n() ? g(h, !1) : g(c);
    });
  }
  z(e, f), xe();
}
function jd() {
  return {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    hooks: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
}
let Mr = jd();
function nm(e) {
  Mr = e;
}
const om = /[&<>"']/, Y3 = new RegExp(om.source, "g"), sm = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, X3 = new RegExp(sm.source, "g"), J3 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, jp = (e) => J3[e];
function Rt(e, t) {
  if (t) {
    if (om.test(e))
      return e.replace(Y3, jp);
  } else if (sm.test(e))
    return e.replace(X3, jp);
  return e;
}
const Q3 = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function im(e) {
  return e.replace(Q3, (t, a) => (a = a.toLowerCase(), a === "colon" ? ":" : a.charAt(0) === "#" ? a.charAt(1) === "x" ? String.fromCharCode(parseInt(a.substring(2), 16)) : String.fromCharCode(+a.substring(1)) : ""));
}
const $3 = /(^|[^\[])\^/g;
function ot(e, t) {
  e = typeof e == "string" ? e : e.source, t = t || "";
  const a = {
    replace: (r, n) => (n = n.source || n, n = n.replace($3, "$1"), e = e.replace(r, n), a),
    getRegex: () => new RegExp(e, t)
  };
  return a;
}
const eS = /[^\w:]/g, tS = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function Rp(e, t, a) {
  if (e) {
    let r;
    try {
      r = decodeURIComponent(im(a)).replace(eS, "").toLowerCase();
    } catch {
      return null;
    }
    if (r.indexOf("javascript:") === 0 || r.indexOf("vbscript:") === 0 || r.indexOf("data:") === 0)
      return null;
  }
  t && !tS.test(a) && (a = oS(t, a));
  try {
    a = encodeURI(a).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return a;
}
const zi = {}, aS = /^[^:]+:\/*[^/]*$/, rS = /^([^:]+:)[\s\S]*$/, nS = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function oS(e, t) {
  zi[" " + e] || (aS.test(e) ? zi[" " + e] = e + "/" : zi[" " + e] = ji(e, "/", !0)), e = zi[" " + e];
  const a = e.indexOf(":") === -1;
  return t.substring(0, 2) === "//" ? a ? t : e.replace(rS, "$1") + t : t.charAt(0) === "/" ? a ? t : e.replace(nS, "$1") + t : e + t;
}
const rl = { exec: function() {
} };
function Lp(e, t) {
  const a = e.replace(/\|/g, (o, s, i) => {
    let l = !1, u = s;
    for (; --u >= 0 && i[u] === "\\"; ) l = !l;
    return l ? "|" : " |";
  }), r = a.split(/ \|/);
  let n = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), r.length > t)
    r.splice(t);
  else
    for (; r.length < t; ) r.push("");
  for (; n < r.length; n++)
    r[n] = r[n].trim().replace(/\\\|/g, "|");
  return r;
}
function ji(e, t, a) {
  const r = e.length;
  if (r === 0)
    return "";
  let n = 0;
  for (; n < r; ) {
    const o = e.charAt(r - n - 1);
    if (o === t && !a)
      n++;
    else if (o !== t && a)
      n++;
    else
      break;
  }
  return e.slice(0, r - n);
}
function sS(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  const a = e.length;
  let r = 0, n = 0;
  for (; n < a; n++)
    if (e[n] === "\\")
      n++;
    else if (e[n] === t[0])
      r++;
    else if (e[n] === t[1] && (r--, r < 0))
      return n;
  return -1;
}
function iS(e, t) {
  !e || e.silent || (t && console.warn("marked(): callback is deprecated since version 5.0.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/using_pro#async"), (e.sanitize || e.sanitizer) && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options"), (e.highlight || e.langPrefix !== "language-") && console.warn("marked(): highlight and langPrefix parameters are deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-highlight."), e.mangle && console.warn("marked(): mangle parameter is enabled by default, but is deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install https://www.npmjs.com/package/marked-mangle, or disable by setting `{mangle: false}`."), e.baseUrl && console.warn("marked(): baseUrl parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-base-url."), e.smartypants && console.warn("marked(): smartypants parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-smartypants."), e.xhtml && console.warn("marked(): xhtml parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-xhtml."), (e.headerIds || e.headerPrefix) && console.warn("marked(): headerIds and headerPrefix parameters enabled by default, but are deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install  https://www.npmjs.com/package/marked-gfm-heading-id, or disable by setting `{headerIds: false}`."));
}
function Dp(e, t, a, r) {
  const n = t.href, o = t.title ? Rt(t.title) : null, s = e[1].replace(/\\([\[\]])/g, "$1");
  if (e[0].charAt(0) !== "!") {
    r.state.inLink = !0;
    const i = {
      type: "link",
      raw: a,
      href: n,
      title: o,
      text: s,
      tokens: r.inlineTokens(s)
    };
    return r.state.inLink = !1, i;
  }
  return {
    type: "image",
    raw: a,
    href: n,
    title: o,
    text: Rt(s)
  };
}
function lS(e, t) {
  const a = e.match(/^(\s+)(?:```)/);
  if (a === null)
    return t;
  const r = a[1];
  return t.split(`
`).map((n) => {
    const o = n.match(/^\s+/);
    if (o === null)
      return n;
    const [s] = o;
    return s.length >= r.length ? n.slice(r.length) : n;
  }).join(`
`);
}
class nl {
  constructor(t) {
    this.options = t || Mr;
  }
  space(t) {
    const a = this.rules.block.newline.exec(t);
    if (a && a[0].length > 0)
      return {
        type: "space",
        raw: a[0]
      };
  }
  code(t) {
    const a = this.rules.block.code.exec(t);
    if (a) {
      const r = a[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: a[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? r : ji(r, `
`)
      };
    }
  }
  fences(t) {
    const a = this.rules.block.fences.exec(t);
    if (a) {
      const r = a[0], n = lS(r, a[3] || "");
      return {
        type: "code",
        raw: r,
        lang: a[2] ? a[2].trim().replace(this.rules.inline._escapes, "$1") : a[2],
        text: n
      };
    }
  }
  heading(t) {
    const a = this.rules.block.heading.exec(t);
    if (a) {
      let r = a[2].trim();
      if (/#$/.test(r)) {
        const n = ji(r, "#");
        (this.options.pedantic || !n || / $/.test(n)) && (r = n.trim());
      }
      return {
        type: "heading",
        raw: a[0],
        depth: a[1].length,
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  hr(t) {
    const a = this.rules.block.hr.exec(t);
    if (a)
      return {
        type: "hr",
        raw: a[0]
      };
  }
  blockquote(t) {
    const a = this.rules.block.blockquote.exec(t);
    if (a) {
      const r = a[0].replace(/^ *>[ \t]?/gm, ""), n = this.lexer.state.top;
      this.lexer.state.top = !0;
      const o = this.lexer.blockTokens(r);
      return this.lexer.state.top = n, {
        type: "blockquote",
        raw: a[0],
        tokens: o,
        text: r
      };
    }
  }
  list(t) {
    let a = this.rules.block.list.exec(t);
    if (a) {
      let r, n, o, s, i, l, u, f, p, c, h, g, _ = a[1].trim();
      const b = _.length > 1, m = {
        type: "list",
        raw: "",
        ordered: b,
        start: b ? +_.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      _ = b ? `\\d{1,9}\\${_.slice(-1)}` : `\\${_}`, this.options.pedantic && (_ = b ? _ : "[*+-]");
      const w = new RegExp(`^( {0,3}${_})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      for (; t && (g = !1, !(!(a = w.exec(t)) || this.rules.block.hr.test(t))); ) {
        if (r = a[0], t = t.substring(r.length), f = a[2].split(`
`, 1)[0].replace(/^\t+/, (C) => " ".repeat(3 * C.length)), p = t.split(`
`, 1)[0], this.options.pedantic ? (s = 2, h = f.trimLeft()) : (s = a[2].search(/[^ ]/), s = s > 4 ? 1 : s, h = f.slice(s), s += a[1].length), l = !1, !f && /^ *$/.test(p) && (r += p + `
`, t = t.substring(p.length + 1), g = !0), !g) {
          const C = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), v = new RegExp(`^ {0,${Math.min(3, s - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), y = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:\`\`\`|~~~)`), k = new RegExp(`^ {0,${Math.min(3, s - 1)}}#`);
          for (; t && (c = t.split(`
`, 1)[0], p = c, this.options.pedantic && (p = p.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(y.test(p) || k.test(p) || C.test(p) || v.test(t))); ) {
            if (p.search(/[^ ]/) >= s || !p.trim())
              h += `
` + p.slice(s);
            else {
              if (l || f.search(/[^ ]/) >= 4 || y.test(f) || k.test(f) || v.test(f))
                break;
              h += `
` + p;
            }
            !l && !p.trim() && (l = !0), r += c + `
`, t = t.substring(c.length + 1), f = p.slice(s);
          }
        }
        m.loose || (u ? m.loose = !0 : /\n *\n *$/.test(r) && (u = !0)), this.options.gfm && (n = /^\[[ xX]\] /.exec(h), n && (o = n[0] !== "[ ] ", h = h.replace(/^\[[ xX]\] +/, ""))), m.items.push({
          type: "list_item",
          raw: r,
          task: !!n,
          checked: o,
          loose: !1,
          text: h
        }), m.raw += r;
      }
      m.items[m.items.length - 1].raw = r.trimRight(), m.items[m.items.length - 1].text = h.trimRight(), m.raw = m.raw.trimRight();
      const S = m.items.length;
      for (i = 0; i < S; i++)
        if (this.lexer.state.top = !1, m.items[i].tokens = this.lexer.blockTokens(m.items[i].text, []), !m.loose) {
          const C = m.items[i].tokens.filter((y) => y.type === "space"), v = C.length > 0 && C.some((y) => /\n.*\n/.test(y.raw));
          m.loose = v;
        }
      if (m.loose)
        for (i = 0; i < S; i++)
          m.items[i].loose = !0;
      return m;
    }
  }
  html(t) {
    const a = this.rules.block.html.exec(t);
    if (a) {
      const r = {
        type: "html",
        block: !0,
        raw: a[0],
        pre: !this.options.sanitizer && (a[1] === "pre" || a[1] === "script" || a[1] === "style"),
        text: a[0]
      };
      if (this.options.sanitize) {
        const n = this.options.sanitizer ? this.options.sanitizer(a[0]) : Rt(a[0]);
        r.type = "paragraph", r.text = n, r.tokens = this.lexer.inline(n);
      }
      return r;
    }
  }
  def(t) {
    const a = this.rules.block.def.exec(t);
    if (a) {
      const r = a[1].toLowerCase().replace(/\s+/g, " "), n = a[2] ? a[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", o = a[3] ? a[3].substring(1, a[3].length - 1).replace(this.rules.inline._escapes, "$1") : a[3];
      return {
        type: "def",
        tag: r,
        raw: a[0],
        href: n,
        title: o
      };
    }
  }
  table(t) {
    const a = this.rules.block.table.exec(t);
    if (a) {
      const r = {
        type: "table",
        header: Lp(a[1]).map((n) => ({ text: n })),
        align: a[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: a[3] && a[3].trim() ? a[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (r.header.length === r.align.length) {
        r.raw = a[0];
        let n = r.align.length, o, s, i, l;
        for (o = 0; o < n; o++)
          /^ *-+: *$/.test(r.align[o]) ? r.align[o] = "right" : /^ *:-+: *$/.test(r.align[o]) ? r.align[o] = "center" : /^ *:-+ *$/.test(r.align[o]) ? r.align[o] = "left" : r.align[o] = null;
        for (n = r.rows.length, o = 0; o < n; o++)
          r.rows[o] = Lp(r.rows[o], r.header.length).map((u) => ({ text: u }));
        for (n = r.header.length, s = 0; s < n; s++)
          r.header[s].tokens = this.lexer.inline(r.header[s].text);
        for (n = r.rows.length, s = 0; s < n; s++)
          for (l = r.rows[s], i = 0; i < l.length; i++)
            l[i].tokens = this.lexer.inline(l[i].text);
        return r;
      }
    }
  }
  lheading(t) {
    const a = this.rules.block.lheading.exec(t);
    if (a)
      return {
        type: "heading",
        raw: a[0],
        depth: a[2].charAt(0) === "=" ? 1 : 2,
        text: a[1],
        tokens: this.lexer.inline(a[1])
      };
  }
  paragraph(t) {
    const a = this.rules.block.paragraph.exec(t);
    if (a) {
      const r = a[1].charAt(a[1].length - 1) === `
` ? a[1].slice(0, -1) : a[1];
      return {
        type: "paragraph",
        raw: a[0],
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  text(t) {
    const a = this.rules.block.text.exec(t);
    if (a)
      return {
        type: "text",
        raw: a[0],
        text: a[0],
        tokens: this.lexer.inline(a[0])
      };
  }
  escape(t) {
    const a = this.rules.inline.escape.exec(t);
    if (a)
      return {
        type: "escape",
        raw: a[0],
        text: Rt(a[1])
      };
  }
  tag(t) {
    const a = this.rules.inline.tag.exec(t);
    if (a)
      return !this.lexer.state.inLink && /^<a /i.test(a[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(a[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(a[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(a[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: a[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(a[0]) : Rt(a[0]) : a[0]
      };
  }
  link(t) {
    const a = this.rules.inline.link.exec(t);
    if (a) {
      const r = a[2].trim();
      if (!this.options.pedantic && /^</.test(r)) {
        if (!/>$/.test(r))
          return;
        const s = ji(r.slice(0, -1), "\\");
        if ((r.length - s.length) % 2 === 0)
          return;
      } else {
        const s = sS(a[2], "()");
        if (s > -1) {
          const l = (a[0].indexOf("!") === 0 ? 5 : 4) + a[1].length + s;
          a[2] = a[2].substring(0, s), a[0] = a[0].substring(0, l).trim(), a[3] = "";
        }
      }
      let n = a[2], o = "";
      if (this.options.pedantic) {
        const s = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
        s && (n = s[1], o = s[3]);
      } else
        o = a[3] ? a[3].slice(1, -1) : "";
      return n = n.trim(), /^</.test(n) && (this.options.pedantic && !/>$/.test(r) ? n = n.slice(1) : n = n.slice(1, -1)), Dp(a, {
        href: n && n.replace(this.rules.inline._escapes, "$1"),
        title: o && o.replace(this.rules.inline._escapes, "$1")
      }, a[0], this.lexer);
    }
  }
  reflink(t, a) {
    let r;
    if ((r = this.rules.inline.reflink.exec(t)) || (r = this.rules.inline.nolink.exec(t))) {
      let n = (r[2] || r[1]).replace(/\s+/g, " ");
      if (n = a[n.toLowerCase()], !n) {
        const o = r[0].charAt(0);
        return {
          type: "text",
          raw: o,
          text: o
        };
      }
      return Dp(r, n, r[0], this.lexer);
    }
  }
  emStrong(t, a, r = "") {
    let n = this.rules.inline.emStrong.lDelim.exec(t);
    if (!n || n[3] && r.match(/[\p{L}\p{N}]/u)) return;
    if (!(n[1] || n[2] || "") || !r || this.rules.inline.punctuation.exec(r)) {
      const s = n[0].length - 1;
      let i, l, u = s, f = 0;
      const p = n[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (p.lastIndex = 0, a = a.slice(-1 * t.length + s); (n = p.exec(a)) != null; ) {
        if (i = n[1] || n[2] || n[3] || n[4] || n[5] || n[6], !i) continue;
        if (l = i.length, n[3] || n[4]) {
          u += l;
          continue;
        } else if ((n[5] || n[6]) && s % 3 && !((s + l) % 3)) {
          f += l;
          continue;
        }
        if (u -= l, u > 0) continue;
        l = Math.min(l, l + u + f);
        const c = t.slice(0, s + n.index + l + 1);
        if (Math.min(s, l) % 2) {
          const g = c.slice(1, -1);
          return {
            type: "em",
            raw: c,
            text: g,
            tokens: this.lexer.inlineTokens(g)
          };
        }
        const h = c.slice(2, -2);
        return {
          type: "strong",
          raw: c,
          text: h,
          tokens: this.lexer.inlineTokens(h)
        };
      }
    }
  }
  codespan(t) {
    const a = this.rules.inline.code.exec(t);
    if (a) {
      let r = a[2].replace(/\n/g, " ");
      const n = /[^ ]/.test(r), o = /^ /.test(r) && / $/.test(r);
      return n && o && (r = r.substring(1, r.length - 1)), r = Rt(r, !0), {
        type: "codespan",
        raw: a[0],
        text: r
      };
    }
  }
  br(t) {
    const a = this.rules.inline.br.exec(t);
    if (a)
      return {
        type: "br",
        raw: a[0]
      };
  }
  del(t) {
    const a = this.rules.inline.del.exec(t);
    if (a)
      return {
        type: "del",
        raw: a[0],
        text: a[2],
        tokens: this.lexer.inlineTokens(a[2])
      };
  }
  autolink(t, a) {
    const r = this.rules.inline.autolink.exec(t);
    if (r) {
      let n, o;
      return r[2] === "@" ? (n = Rt(this.options.mangle ? a(r[1]) : r[1]), o = "mailto:" + n) : (n = Rt(r[1]), o = n), {
        type: "link",
        raw: r[0],
        text: n,
        href: o,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  url(t, a) {
    let r;
    if (r = this.rules.inline.url.exec(t)) {
      let n, o;
      if (r[2] === "@")
        n = Rt(this.options.mangle ? a(r[0]) : r[0]), o = "mailto:" + n;
      else {
        let s;
        do
          s = r[0], r[0] = this.rules.inline._backpedal.exec(r[0])[0];
        while (s !== r[0]);
        n = Rt(r[0]), r[1] === "www." ? o = "http://" + r[0] : o = r[0];
      }
      return {
        type: "link",
        raw: r[0],
        text: n,
        href: o,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  inlineText(t, a) {
    const r = this.rules.inline.text.exec(t);
    if (r) {
      let n;
      return this.lexer.state.inRawBlock ? n = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : Rt(r[0]) : r[0] : n = Rt(this.options.smartypants ? a(r[0]) : r[0]), {
        type: "text",
        raw: r[0],
        text: n
      };
    }
  }
}
const Ee = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: rl,
  lheading: /^((?:(?!^bull ).|\n(?!\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
Ee._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
Ee._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
Ee.def = ot(Ee.def).replace("label", Ee._label).replace("title", Ee._title).getRegex();
Ee.bullet = /(?:[*+-]|\d{1,9}[.)])/;
Ee.listItemStart = ot(/^( *)(bull) */).replace("bull", Ee.bullet).getRegex();
Ee.list = ot(Ee.list).replace(/bull/g, Ee.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + Ee.def.source + ")").getRegex();
Ee._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
Ee._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
Ee.html = ot(Ee.html, "i").replace("comment", Ee._comment).replace("tag", Ee._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
Ee.lheading = ot(Ee.lheading).replace(/bull/g, Ee.bullet).getRegex();
Ee.paragraph = ot(Ee._paragraph).replace("hr", Ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ee._tag).getRegex();
Ee.blockquote = ot(Ee.blockquote).replace("paragraph", Ee.paragraph).getRegex();
Ee.normal = { ...Ee };
Ee.gfm = {
  ...Ee.normal,
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
Ee.gfm.table = ot(Ee.gfm.table).replace("hr", Ee.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ee._tag).getRegex();
Ee.gfm.paragraph = ot(Ee._paragraph).replace("hr", Ee.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", Ee.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Ee._tag).getRegex();
Ee.pedantic = {
  ...Ee.normal,
  html: ot(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", Ee._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: rl,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: ot(Ee.normal._paragraph).replace("hr", Ee.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Ee.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const we = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: rl,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
    //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
    rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: rl,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^((?![*_])[\spunctuation])/
};
we._punctuation = "\\p{P}$+<=>`^|~";
we.punctuation = ot(we.punctuation, "u").replace(/punctuation/g, we._punctuation).getRegex();
we.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
we.anyPunctuation = /\\[punct]/g;
we._escapes = /\\([punct])/g;
we._comment = ot(Ee._comment).replace("(?:-->|$)", "-->").getRegex();
we.emStrong.lDelim = ot(we.emStrong.lDelim, "u").replace(/punct/g, we._punctuation).getRegex();
we.emStrong.rDelimAst = ot(we.emStrong.rDelimAst, "gu").replace(/punct/g, we._punctuation).getRegex();
we.emStrong.rDelimUnd = ot(we.emStrong.rDelimUnd, "gu").replace(/punct/g, we._punctuation).getRegex();
we.anyPunctuation = ot(we.anyPunctuation, "gu").replace(/punct/g, we._punctuation).getRegex();
we._escapes = ot(we._escapes, "gu").replace(/punct/g, we._punctuation).getRegex();
we._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
we._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
we.autolink = ot(we.autolink).replace("scheme", we._scheme).replace("email", we._email).getRegex();
we._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
we.tag = ot(we.tag).replace("comment", we._comment).replace("attribute", we._attribute).getRegex();
we._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
we._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
we._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
we.link = ot(we.link).replace("label", we._label).replace("href", we._href).replace("title", we._title).getRegex();
we.reflink = ot(we.reflink).replace("label", we._label).replace("ref", Ee._label).getRegex();
we.nolink = ot(we.nolink).replace("ref", Ee._label).getRegex();
we.reflinkSearch = ot(we.reflinkSearch, "g").replace("reflink", we.reflink).replace("nolink", we.nolink).getRegex();
we.normal = { ...we };
we.pedantic = {
  ...we.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: ot(/^!?\[(label)\]\((.*?)\)/).replace("label", we._label).getRegex(),
  reflink: ot(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", we._label).getRegex()
};
we.gfm = {
  ...we.normal,
  escape: ot(we.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
we.gfm.url = ot(we.gfm.url, "i").replace("email", we.gfm._extended_email).getRegex();
we.breaks = {
  ...we.gfm,
  br: ot(we.br).replace("{2,}", "*").getRegex(),
  text: ot(we.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
function cS(e) {
  return e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function Np(e) {
  let t = "", a, r;
  const n = e.length;
  for (a = 0; a < n; a++)
    r = e.charCodeAt(a), Math.random() > 0.5 && (r = "x" + r.toString(16)), t += "&#" + r + ";";
  return t;
}
class ya {
  constructor(t) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || Mr, this.options.tokenizer = this.options.tokenizer || new nl(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const a = {
      block: Ee.normal,
      inline: we.normal
    };
    this.options.pedantic ? (a.block = Ee.pedantic, a.inline = we.pedantic) : this.options.gfm && (a.block = Ee.gfm, this.options.breaks ? a.inline = we.breaks : a.inline = we.gfm), this.tokenizer.rules = a;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: Ee,
      inline: we
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, a) {
    return new ya(a).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, a) {
    return new ya(a).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(/\r\n|\r/g, `
`), this.blockTokens(t, this.tokens);
    let a;
    for (; a = this.inlineQueue.shift(); )
      this.inlineTokens(a.src, a.tokens);
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(t, a = []) {
    this.options.pedantic ? t = t.replace(/\t/g, "    ").replace(/^ +$/gm, "") : t = t.replace(/^( *)(\t+)/gm, (i, l, u) => l + "    ".repeat(u.length));
    let r, n, o, s;
    for (; t; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((i) => (r = i.call({ lexer: this }, t, a)) ? (t = t.substring(r.raw.length), a.push(r), !0) : !1))) {
        if (r = this.tokenizer.space(t)) {
          t = t.substring(r.raw.length), r.raw.length === 1 && a.length > 0 ? a[a.length - 1].raw += `
` : a.push(r);
          continue;
        }
        if (r = this.tokenizer.code(t)) {
          t = t.substring(r.raw.length), n = a[a.length - 1], n && (n.type === "paragraph" || n.type === "text") ? (n.raw += `
` + r.raw, n.text += `
` + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : a.push(r);
          continue;
        }
        if (r = this.tokenizer.fences(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.heading(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.hr(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.blockquote(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.list(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.html(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.def(t)) {
          t = t.substring(r.raw.length), n = a[a.length - 1], n && (n.type === "paragraph" || n.type === "text") ? (n.raw += `
` + r.raw, n.text += `
` + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
            href: r.href,
            title: r.title
          });
          continue;
        }
        if (r = this.tokenizer.table(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.lheading(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (o = t, this.options.extensions && this.options.extensions.startBlock) {
          let i = 1 / 0;
          const l = t.slice(1);
          let u;
          this.options.extensions.startBlock.forEach(function(f) {
            u = f.call({ lexer: this }, l), typeof u == "number" && u >= 0 && (i = Math.min(i, u));
          }), i < 1 / 0 && i >= 0 && (o = t.substring(0, i + 1));
        }
        if (this.state.top && (r = this.tokenizer.paragraph(o))) {
          n = a[a.length - 1], s && n.type === "paragraph" ? (n.raw += `
` + r.raw, n.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : a.push(r), s = o.length !== t.length, t = t.substring(r.raw.length);
          continue;
        }
        if (r = this.tokenizer.text(t)) {
          t = t.substring(r.raw.length), n = a[a.length - 1], n && n.type === "text" ? (n.raw += `
` + r.raw, n.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : a.push(r);
          continue;
        }
        if (t) {
          const i = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(i);
            break;
          } else
            throw new Error(i);
        }
      }
    return this.state.top = !0, a;
  }
  inline(t, a = []) {
    return this.inlineQueue.push({ src: t, tokens: a }), a;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, a = []) {
    let r, n, o, s = t, i, l, u;
    if (this.tokens.links) {
      const f = Object.keys(this.tokens.links);
      if (f.length > 0)
        for (; (i = this.tokenizer.rules.inline.reflinkSearch.exec(s)) != null; )
          f.includes(i[0].slice(i[0].lastIndexOf("[") + 1, -1)) && (s = s.slice(0, i.index) + "[" + "a".repeat(i[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (i = this.tokenizer.rules.inline.blockSkip.exec(s)) != null; )
      s = s.slice(0, i.index) + "[" + "a".repeat(i[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (i = this.tokenizer.rules.inline.anyPunctuation.exec(s)) != null; )
      s = s.slice(0, i.index) + "++" + s.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; t; )
      if (l || (u = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((f) => (r = f.call({ lexer: this }, t, a)) ? (t = t.substring(r.raw.length), a.push(r), !0) : !1))) {
        if (r = this.tokenizer.escape(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.tag(t)) {
          t = t.substring(r.raw.length), n = a[a.length - 1], n && r.type === "text" && n.type === "text" ? (n.raw += r.raw, n.text += r.text) : a.push(r);
          continue;
        }
        if (r = this.tokenizer.link(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.reflink(t, this.tokens.links)) {
          t = t.substring(r.raw.length), n = a[a.length - 1], n && r.type === "text" && n.type === "text" ? (n.raw += r.raw, n.text += r.text) : a.push(r);
          continue;
        }
        if (r = this.tokenizer.emStrong(t, s, u)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.codespan(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.br(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.del(t)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (r = this.tokenizer.autolink(t, Np)) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (!this.state.inLink && (r = this.tokenizer.url(t, Np))) {
          t = t.substring(r.raw.length), a.push(r);
          continue;
        }
        if (o = t, this.options.extensions && this.options.extensions.startInline) {
          let f = 1 / 0;
          const p = t.slice(1);
          let c;
          this.options.extensions.startInline.forEach(function(h) {
            c = h.call({ lexer: this }, p), typeof c == "number" && c >= 0 && (f = Math.min(f, c));
          }), f < 1 / 0 && f >= 0 && (o = t.substring(0, f + 1));
        }
        if (r = this.tokenizer.inlineText(o, cS)) {
          t = t.substring(r.raw.length), r.raw.slice(-1) !== "_" && (u = r.raw.slice(-1)), l = !0, n = a[a.length - 1], n && n.type === "text" ? (n.raw += r.raw, n.text += r.text) : a.push(r);
          continue;
        }
        if (t) {
          const f = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(f);
            break;
          } else
            throw new Error(f);
        }
      }
    return a;
  }
}
class ol {
  constructor(t) {
    this.options = t || Mr;
  }
  code(t, a, r) {
    const n = (a || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const o = this.options.highlight(t, n);
      o != null && o !== t && (r = !0, t = o);
    }
    return t = t.replace(/\n$/, "") + `
`, n ? '<pre><code class="' + this.options.langPrefix + Rt(n) + '">' + (r ? t : Rt(t, !0)) + `</code></pre>
` : "<pre><code>" + (r ? t : Rt(t, !0)) + `</code></pre>
`;
  }
  /**
   * @param {string} quote
   */
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t, a) {
    return t;
  }
  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(t, a, r, n) {
    if (this.options.headerIds) {
      const o = this.options.headerPrefix + n.slug(r);
      return `<h${a} id="${o}">${t}</h${a}>
`;
    }
    return `<h${a}>${t}</h${a}>
`;
  }
  hr() {
    return this.options.xhtml ? `<hr/>
` : `<hr>
`;
  }
  list(t, a, r) {
    const n = a ? "ol" : "ul", o = a && r !== 1 ? ' start="' + r + '"' : "";
    return "<" + n + o + `>
` + t + "</" + n + `>
`;
  }
  /**
   * @param {string} text
   */
  listitem(t) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  /**
   * @param {string} text
   */
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  /**
   * @param {string} header
   * @param {string} body
   */
  table(t, a) {
    return a && (a = `<tbody>${a}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + a + `</table>
`;
  }
  /**
   * @param {string} content
   */
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, a) {
    const r = a.header ? "th" : "td";
    return (a.align ? `<${r} align="${a.align}">` : `<${r}>`) + t + `</${r}>
`;
  }
  /**
   * span level renderer
   * @param {string} text
   */
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  /**
   * @param {string} text
   */
  em(t) {
    return `<em>${t}</em>`;
  }
  /**
   * @param {string} text
   */
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  /**
   * @param {string} text
   */
  del(t) {
    return `<del>${t}</del>`;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(t, a, r) {
    if (t = Rp(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let n = '<a href="' + t + '"';
    return a && (n += ' title="' + a + '"'), n += ">" + r + "</a>", n;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(t, a, r) {
    if (t = Rp(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let n = `<img src="${t}" alt="${r}"`;
    return a && (n += ` title="${a}"`), n += this.options.xhtml ? "/>" : ">", n;
  }
  text(t) {
    return t;
  }
}
class Rd {
  // no need for block level renderers
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, a, r) {
    return "" + r;
  }
  image(t, a, r) {
    return "" + r;
  }
  br() {
    return "";
  }
}
class Ko {
  constructor() {
    this.seen = {};
  }
  /**
   * @param {string} value
   */
  serialize(t) {
    return t.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(t, a) {
    let r = t, n = 0;
    if (this.seen.hasOwnProperty(r)) {
      n = this.seen[t];
      do
        n++, r = t + "-" + n;
      while (this.seen.hasOwnProperty(r));
    }
    return a || (this.seen[t] = n, this.seen[r] = 0), r;
  }
  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(t, a = {}) {
    const r = this.serialize(t);
    return this.getNextSafeSlug(r, a.dryrun);
  }
}
class Aa {
  constructor(t) {
    this.options = t || Mr, this.options.renderer = this.options.renderer || new ol(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Rd(), this.slugger = new Ko();
  }
  /**
   * Static Parse Method
   */
  static parse(t, a) {
    return new Aa(a).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, a) {
    return new Aa(a).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, a = !0) {
    let r = "", n, o, s, i, l, u, f, p, c, h, g, _, b, m, w, S, C, v, y;
    const k = t.length;
    for (n = 0; n < k; n++) {
      if (h = t[n], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[h.type] && (y = this.options.extensions.renderers[h.type].call({ parser: this }, h), y !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(h.type))) {
        r += y || "";
        continue;
      }
      switch (h.type) {
        case "space":
          continue;
        case "hr": {
          r += this.renderer.hr();
          continue;
        }
        case "heading": {
          r += this.renderer.heading(
            this.parseInline(h.tokens),
            h.depth,
            im(this.parseInline(h.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          r += this.renderer.code(
            h.text,
            h.lang,
            h.escaped
          );
          continue;
        }
        case "table": {
          for (p = "", f = "", i = h.header.length, o = 0; o < i; o++)
            f += this.renderer.tablecell(
              this.parseInline(h.header[o].tokens),
              { header: !0, align: h.align[o] }
            );
          for (p += this.renderer.tablerow(f), c = "", i = h.rows.length, o = 0; o < i; o++) {
            for (u = h.rows[o], f = "", l = u.length, s = 0; s < l; s++)
              f += this.renderer.tablecell(
                this.parseInline(u[s].tokens),
                { header: !1, align: h.align[s] }
              );
            c += this.renderer.tablerow(f);
          }
          r += this.renderer.table(p, c);
          continue;
        }
        case "blockquote": {
          c = this.parse(h.tokens), r += this.renderer.blockquote(c);
          continue;
        }
        case "list": {
          for (g = h.ordered, _ = h.start, b = h.loose, i = h.items.length, c = "", o = 0; o < i; o++)
            w = h.items[o], S = w.checked, C = w.task, m = "", w.task && (v = this.renderer.checkbox(S), b ? w.tokens.length > 0 && w.tokens[0].type === "paragraph" ? (w.tokens[0].text = v + " " + w.tokens[0].text, w.tokens[0].tokens && w.tokens[0].tokens.length > 0 && w.tokens[0].tokens[0].type === "text" && (w.tokens[0].tokens[0].text = v + " " + w.tokens[0].tokens[0].text)) : w.tokens.unshift({
              type: "text",
              text: v
            }) : m += v), m += this.parse(w.tokens, b), c += this.renderer.listitem(m, C, S);
          r += this.renderer.list(c, g, _);
          continue;
        }
        case "html": {
          r += this.renderer.html(h.text, h.block);
          continue;
        }
        case "paragraph": {
          r += this.renderer.paragraph(this.parseInline(h.tokens));
          continue;
        }
        case "text": {
          for (c = h.tokens ? this.parseInline(h.tokens) : h.text; n + 1 < k && t[n + 1].type === "text"; )
            h = t[++n], c += `
` + (h.tokens ? this.parseInline(h.tokens) : h.text);
          r += a ? this.renderer.paragraph(c) : c;
          continue;
        }
        default: {
          const x = 'Token with "' + h.type + '" type was not found.';
          if (this.options.silent) {
            console.error(x);
            return;
          } else
            throw new Error(x);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, a) {
    a = a || this.renderer;
    let r = "", n, o, s;
    const i = t.length;
    for (n = 0; n < i; n++) {
      if (o = t[n], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[o.type] && (s = this.options.extensions.renderers[o.type].call({ parser: this }, o), s !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(o.type))) {
        r += s || "";
        continue;
      }
      switch (o.type) {
        case "escape": {
          r += a.text(o.text);
          break;
        }
        case "html": {
          r += a.html(o.text);
          break;
        }
        case "link": {
          r += a.link(o.href, o.title, this.parseInline(o.tokens, a));
          break;
        }
        case "image": {
          r += a.image(o.href, o.title, o.text);
          break;
        }
        case "strong": {
          r += a.strong(this.parseInline(o.tokens, a));
          break;
        }
        case "em": {
          r += a.em(this.parseInline(o.tokens, a));
          break;
        }
        case "codespan": {
          r += a.codespan(o.text);
          break;
        }
        case "br": {
          r += a.br();
          break;
        }
        case "del": {
          r += a.del(this.parseInline(o.tokens, a));
          break;
        }
        case "text": {
          r += a.text(o.text);
          break;
        }
        default: {
          const l = 'Token with "' + o.type + '" type was not found.';
          if (this.options.silent) {
            console.error(l);
            return;
          } else
            throw new Error(l);
        }
      }
    }
    return r;
  }
}
class Io {
  constructor(t) {
    this.options = t || Mr;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
}
Ve(Io, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
var on, Au, lm;
class uS {
  constructor(...t) {
    ne(this, on);
    Ve(this, "defaults", jd());
    Ve(this, "options", this.setOptions);
    Ve(this, "parse", Gt(this, on, Au).call(this, ya.lex, Aa.parse));
    Ve(this, "parseInline", Gt(this, on, Au).call(this, ya.lexInline, Aa.parseInline));
    Ve(this, "Parser", Aa);
    Ve(this, "parser", Aa.parse);
    Ve(this, "Renderer", ol);
    Ve(this, "TextRenderer", Rd);
    Ve(this, "Lexer", ya);
    Ve(this, "lexer", ya.lex);
    Ve(this, "Tokenizer", nl);
    Ve(this, "Slugger", Ko);
    Ve(this, "Hooks", Io);
    this.use(...t);
  }
  walkTokens(t, a) {
    let r = [];
    for (const n of t)
      switch (r = r.concat(a.call(this, n)), n.type) {
        case "table": {
          for (const o of n.header)
            r = r.concat(this.walkTokens(o.tokens, a));
          for (const o of n.rows)
            for (const s of o)
              r = r.concat(this.walkTokens(s.tokens, a));
          break;
        }
        case "list": {
          r = r.concat(this.walkTokens(n.items, a));
          break;
        }
        default:
          this.defaults.extensions && this.defaults.extensions.childTokens && this.defaults.extensions.childTokens[n.type] ? this.defaults.extensions.childTokens[n.type].forEach((o) => {
            r = r.concat(this.walkTokens(n[o], a));
          }) : n.tokens && (r = r.concat(this.walkTokens(n.tokens, a)));
      }
    return r;
  }
  use(...t) {
    const a = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((r) => {
      const n = { ...r };
      if (n.async = this.defaults.async || n.async || !1, r.extensions && (r.extensions.forEach((o) => {
        if (!o.name)
          throw new Error("extension name required");
        if (o.renderer) {
          const s = a.renderers[o.name];
          s ? a.renderers[o.name] = function(...i) {
            let l = o.renderer.apply(this, i);
            return l === !1 && (l = s.apply(this, i)), l;
          } : a.renderers[o.name] = o.renderer;
        }
        if (o.tokenizer) {
          if (!o.level || o.level !== "block" && o.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          a[o.level] ? a[o.level].unshift(o.tokenizer) : a[o.level] = [o.tokenizer], o.start && (o.level === "block" ? a.startBlock ? a.startBlock.push(o.start) : a.startBlock = [o.start] : o.level === "inline" && (a.startInline ? a.startInline.push(o.start) : a.startInline = [o.start]));
        }
        o.childTokens && (a.childTokens[o.name] = o.childTokens);
      }), n.extensions = a), r.renderer) {
        const o = this.defaults.renderer || new ol(this.defaults);
        for (const s in r.renderer) {
          const i = o[s];
          o[s] = (...l) => {
            let u = r.renderer[s].apply(o, l);
            return u === !1 && (u = i.apply(o, l)), u;
          };
        }
        n.renderer = o;
      }
      if (r.tokenizer) {
        const o = this.defaults.tokenizer || new nl(this.defaults);
        for (const s in r.tokenizer) {
          const i = o[s];
          o[s] = (...l) => {
            let u = r.tokenizer[s].apply(o, l);
            return u === !1 && (u = i.apply(o, l)), u;
          };
        }
        n.tokenizer = o;
      }
      if (r.hooks) {
        const o = this.defaults.hooks || new Io();
        for (const s in r.hooks) {
          const i = o[s];
          Io.passThroughHooks.has(s) ? o[s] = (l) => {
            if (this.defaults.async)
              return Promise.resolve(r.hooks[s].call(o, l)).then((f) => i.call(o, f));
            const u = r.hooks[s].call(o, l);
            return i.call(o, u);
          } : o[s] = (...l) => {
            let u = r.hooks[s].apply(o, l);
            return u === !1 && (u = i.apply(o, l)), u;
          };
        }
        n.hooks = o;
      }
      if (r.walkTokens) {
        const o = this.defaults.walkTokens;
        n.walkTokens = function(s) {
          let i = [];
          return i.push(r.walkTokens.call(this, s)), o && (i = i.concat(o.call(this, s))), i;
        };
      }
      this.defaults = { ...this.defaults, ...n };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
}
on = new WeakSet(), Au = function(t, a) {
  return (r, n, o) => {
    typeof n == "function" && (o = n, n = null);
    const s = { ...n };
    n = { ...this.defaults, ...s };
    const i = Gt(this, on, lm).call(this, n.silent, n.async, o);
    if (typeof r > "u" || r === null)
      return i(new Error("marked(): input parameter is undefined or null"));
    if (typeof r != "string")
      return i(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(r) + ", string expected"));
    if (iS(n, o), n.hooks && (n.hooks.options = n), o) {
      const l = n.highlight;
      let u;
      try {
        n.hooks && (r = n.hooks.preprocess(r)), u = t(r, n);
      } catch (c) {
        return i(c);
      }
      const f = (c) => {
        let h;
        if (!c)
          try {
            n.walkTokens && this.walkTokens(u, n.walkTokens), h = a(u, n), n.hooks && (h = n.hooks.postprocess(h));
          } catch (g) {
            c = g;
          }
        return n.highlight = l, c ? i(c) : o(null, h);
      };
      if (!l || l.length < 3 || (delete n.highlight, !u.length)) return f();
      let p = 0;
      this.walkTokens(u, (c) => {
        c.type === "code" && (p++, setTimeout(() => {
          l(c.text, c.lang, (h, g) => {
            if (h)
              return f(h);
            g != null && g !== c.text && (c.text = g, c.escaped = !0), p--, p === 0 && f();
          });
        }, 0));
      }), p === 0 && f();
      return;
    }
    if (n.async)
      return Promise.resolve(n.hooks ? n.hooks.preprocess(r) : r).then((l) => t(l, n)).then((l) => n.walkTokens ? Promise.all(this.walkTokens(l, n.walkTokens)).then(() => l) : l).then((l) => a(l, n)).then((l) => n.hooks ? n.hooks.postprocess(l) : l).catch(i);
    try {
      n.hooks && (r = n.hooks.preprocess(r));
      const l = t(r, n);
      n.walkTokens && this.walkTokens(l, n.walkTokens);
      let u = a(l, n);
      return n.hooks && (u = n.hooks.postprocess(u)), u;
    } catch (l) {
      return i(l);
    }
  };
}, lm = function(t, a, r) {
  return (n) => {
    if (n.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
      const o = "<p>An error occurred:</p><pre>" + Rt(n.message + "", !0) + "</pre>";
      if (a)
        return Promise.resolve(o);
      if (r) {
        r(null, o);
        return;
      }
      return o;
    }
    if (a)
      return Promise.reject(n);
    if (r) {
      r(n);
      return;
    }
    throw n;
  };
};
const nn = new uS(Mr);
function lt(e, t, a) {
  return nn.parse(e, t, a);
}
lt.options = lt.setOptions = function(e) {
  return nn.setOptions(e), lt.defaults = nn.defaults, nm(lt.defaults), lt;
};
lt.getDefaults = jd;
lt.defaults = Mr;
lt.use = function(...e) {
  return nn.use(...e), lt.defaults = nn.defaults, nm(lt.defaults), lt;
};
lt.walkTokens = function(e, t) {
  return nn.walkTokens(e, t);
};
lt.parseInline = nn.parseInline;
lt.Parser = Aa;
lt.parser = Aa.parse;
lt.Renderer = ol;
lt.TextRenderer = Rd;
lt.Lexer = ya;
lt.lexer = ya.lex;
lt.Tokenizer = nl;
lt.Slugger = Ko;
lt.Hooks = Io;
lt.parse = lt;
lt.options;
lt.setOptions;
lt.use;
lt.walkTokens;
lt.parseInline;
Aa.parse;
ya.lex;
const cm = {};
var dS = /* @__PURE__ */ L("<h1><!></h1>"), fS = /* @__PURE__ */ L("<h2><!></h2>"), pS = /* @__PURE__ */ L("<h3><!></h3>"), yS = /* @__PURE__ */ L("<h4><!></h4>"), hS = /* @__PURE__ */ L("<h5><!></h5>"), gS = /* @__PURE__ */ L("<h6><!></h6>");
function mS(e, t) {
  ke(t, !1);
  const a = Ke();
  let r = R(t, "depth", 8), n = R(t, "raw", 8), o = R(t, "text", 8);
  const { slug: s, getOptions: i } = rc(cm), l = i();
  Qe(() => $e(o()), () => {
    q(a, l.headerIds ? l.headerPrefix + s(o()) : void 0);
  }), $l(), ca();
  var u = K(), f = D(u);
  {
    var p = (h) => {
      var g = dS(), _ = A(g);
      Ze(_, t, "default", {}, null), $(() => be(g, "id", d(a))), z(h, g);
    }, c = (h) => {
      var g = K(), _ = D(g);
      {
        var b = (w) => {
          var S = fS(), C = A(S);
          Ze(C, t, "default", {}, null), $(() => be(S, "id", d(a))), z(w, S);
        }, m = (w) => {
          var S = K(), C = D(S);
          {
            var v = (k) => {
              var x = pS(), T = A(x);
              Ze(T, t, "default", {}, null), $(() => be(x, "id", d(a))), z(k, x);
            }, y = (k) => {
              var x = K(), T = D(x);
              {
                var F = (O) => {
                  var I = yS(), E = A(I);
                  Ze(E, t, "default", {}, null), $(() => be(I, "id", d(a))), z(O, I);
                }, P = (O) => {
                  var I = K(), E = D(I);
                  {
                    var N = (Y) => {
                      var V = hS(), U = A(V);
                      Ze(U, t, "default", {}, null), $(() => be(V, "id", d(a))), z(Y, V);
                    }, H = (Y) => {
                      var V = K(), U = D(V);
                      {
                        var ee = (G) => {
                          var J = gS(), te = A(J);
                          Ze(te, t, "default", {}, null), $(() => be(J, "id", d(a))), z(G, J);
                        }, W = (G) => {
                          var J = Xn();
                          $(() => Me(J, n())), z(G, J);
                        };
                        B(
                          U,
                          (G) => {
                            r() === 6 ? G(ee) : G(W, !1);
                          },
                          !0
                        );
                      }
                      z(Y, V);
                    };
                    B(
                      E,
                      (Y) => {
                        r() === 5 ? Y(N) : Y(H, !1);
                      },
                      !0
                    );
                  }
                  z(O, I);
                };
                B(
                  T,
                  (O) => {
                    r() === 4 ? O(F) : O(P, !1);
                  },
                  !0
                );
              }
              z(k, x);
            };
            B(
              C,
              (k) => {
                r() === 3 ? k(v) : k(y, !1);
              },
              !0
            );
          }
          z(w, S);
        };
        B(
          _,
          (w) => {
            r() === 2 ? w(b) : w(m, !1);
          },
          !0
        );
      }
      z(h, g);
    };
    B(f, (h) => {
      r() === 1 ? h(p) : h(c, !1);
    });
  }
  z(e, u), xe();
}
var _S = /* @__PURE__ */ L("<p><!></p>");
function wS(e, t) {
  var a = _S(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
function vS(e, t) {
  R(t, "text", 8)(), R(t, "raw", 8)();
  var n = K(), o = D(n);
  Ze(o, t, "default", {}, null), z(e, n);
}
var bS = /* @__PURE__ */ L("<img>");
function kS(e, t) {
  let a = R(t, "href", 8, ""), r = R(t, "title", 8, void 0), n = R(t, "text", 8, "");
  var o = bS();
  $(() => {
    be(o, "src", a()), be(o, "title", r()), be(o, "alt", n());
  }), z(e, o);
}
var xS = /* @__PURE__ */ L("<a><!></a>");
function zS(e, t) {
  let a = R(t, "href", 8, ""), r = R(t, "title", 8, void 0);
  var n = xS(), o = A(n);
  Ze(o, t, "default", {}, null), $(() => {
    be(n, "href", a()), be(n, "title", r());
  }), z(e, n);
}
var SS = /* @__PURE__ */ L("<em><!></em>");
function CS(e, t) {
  var a = SS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var ES = /* @__PURE__ */ L("<del><!></del>");
function AS(e, t) {
  var a = ES(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var TS = /* @__PURE__ */ L("<code> </code>");
function PS(e, t) {
  ke(t, !1);
  let a = R(t, "raw", 8);
  ca();
  var r = TS(), n = A(r);
  $(() => Me(n, a().replace(/`/g, ""))), z(e, r), xe();
}
var OS = /* @__PURE__ */ L("<strong><!></strong>");
function MS(e, t) {
  var a = OS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var IS = /* @__PURE__ */ L("<table><!></table>");
function FS(e, t) {
  var a = IS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var jS = /* @__PURE__ */ L("<thead><!></thead>");
function RS(e, t) {
  var a = jS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var LS = /* @__PURE__ */ L("<tbody><!></tbody>");
function DS(e, t) {
  var a = LS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var NS = /* @__PURE__ */ L("<tr><!></tr>");
function VS(e, t) {
  var a = NS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var qS = /* @__PURE__ */ L("<th><!></th>"), BS = /* @__PURE__ */ L("<td><!></td>");
function WS(e, t) {
  let a = R(t, "header", 8), r = R(t, "align", 8);
  var n = K(), o = D(n);
  {
    var s = (l) => {
      var u = qS(), f = A(u);
      Ze(f, t, "default", {}, null), $(() => be(u, "align", r())), z(l, u);
    }, i = (l) => {
      var u = BS(), f = A(u);
      Ze(f, t, "default", {}, null), $(() => be(u, "align", r())), z(l, u);
    };
    B(o, (l) => {
      a() ? l(s) : l(i, !1);
    });
  }
  z(e, n);
}
var HS = /* @__PURE__ */ L("<ol><!></ol>"), US = /* @__PURE__ */ L("<ul><!></ul>");
function GS(e, t) {
  let a = R(t, "ordered", 8), r = R(t, "start", 8);
  var n = K(), o = D(n);
  {
    var s = (l) => {
      var u = HS(), f = A(u);
      Ze(f, t, "default", {}, null), $(() => be(u, "start", r())), z(l, u);
    }, i = (l) => {
      var u = US(), f = A(u);
      Ze(f, t, "default", {}, null), z(l, u);
    };
    B(o, (l) => {
      a() ? l(s) : l(i, !1);
    });
  }
  z(e, n);
}
var KS = /* @__PURE__ */ L("<li><!></li>");
function ZS(e, t) {
  var a = KS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var YS = /* @__PURE__ */ L("<hr>");
function XS(e) {
  var t = YS();
  z(e, t);
}
function JS(e, t) {
  let a = R(t, "text", 8);
  var r = K(), n = D(r);
  At(n, a), z(e, r);
}
var QS = /* @__PURE__ */ L("<blockquote><!></blockquote>");
function $S(e, t) {
  var a = QS(), r = A(a);
  Ze(r, t, "default", {}, null), z(e, a);
}
var e5 = /* @__PURE__ */ L("<pre><code> </code></pre>");
function t5(e, t) {
  let a = R(t, "lang", 8), r = R(t, "text", 8);
  var n = e5(), o = A(n), s = A(o);
  $(() => {
    Ue(n, a()), Me(s, r());
  }), z(e, n);
}
var a5 = /* @__PURE__ */ L("<br><!>", 1);
function r5(e, t) {
  var a = a5(), r = X(D(a));
  Ze(r, t, "default", {}, null), z(e, a);
}
const n5 = {
  heading: mS,
  paragraph: wS,
  text: vS,
  image: kS,
  link: zS,
  em: CS,
  strong: MS,
  codespan: PS,
  del: AS,
  table: FS,
  tablehead: RS,
  tablebody: DS,
  tablerow: VS,
  tablecell: WS,
  list: GS,
  orderedlistitem: null,
  unorderedlistitem: null,
  listitem: ZS,
  hr: XS,
  html: JS,
  blockquote: $S,
  code: t5,
  br: r5
}, o5 = {
  baseUrl: null,
  breaks: !1,
  gfm: !0,
  headerIds: !0,
  headerPrefix: "",
  highlight: null,
  langPrefix: "language-",
  mangle: !0,
  pedantic: !1,
  renderer: null,
  sanitize: !1,
  sanitizer: null,
  silent: !1,
  smartLists: !1,
  smartypants: !1,
  tokenizer: null,
  xhtml: !1
};
function s5(e, t) {
  ke(t, !1);
  const a = Ke(), r = Ke(), n = Ke(), o = Ke();
  let s = R(t, "source", 24, () => []), i = R(t, "renderers", 24, () => ({})), l = R(t, "options", 24, () => ({})), u = R(t, "isInline", 8, !1);
  const f = ew();
  let p = Ke(), c = Ke(), h = Ke();
  Ny(cm, {
    slug: (g) => d(r) ? d(r).slug(g) : "",
    getOptions: () => d(n)
  }), Da(() => {
    q(h, !0);
  }), Qe(() => $e(s()), () => {
    q(a, Array.isArray(s()));
  }), Qe(() => ($e(s()), Ko), () => {
    q(r, s() ? new Ko() : void 0);
  }), Qe(
    () => $e(l()),
    () => {
      q(n, { ...o5, ...l() });
    }
  ), Qe(
    () => (d(a), d(p), $e(s()), d(c), d(n), $e(u())),
    () => {
      d(a) ? q(p, s()) : (q(c, new ya(d(n))), q(p, u() ? d(c).inlineTokens(s()) : d(c).lex(s())), f("parsed", { tokens: d(p) }));
    }
  ), Qe(
    () => $e(i()),
    () => {
      q(o, { ...n5, ...i() });
    }
  ), Qe(
    () => (d(h), d(a), d(p)),
    () => {
      d(h) && !d(a) && f("parsed", { tokens: d(p) });
    }
  ), $l(), ca(), Dr(e, {
    get tokens() {
      return d(p);
    },
    get renderers() {
      return d(o);
    }
  }), xe();
}
var i5 = /* @__PURE__ */ L('<a class="!layup-break-words !layup-text-accent !layup-no-underline visited:!layup-text-accent hover:!layup-text-accent" target="_blank" rel="noopener noreferrer"> </a>');
function l5(e, t) {
  var a = i5(), r = A(a);
  $(() => {
    be(a, "href", t.href), be(a, "title", t.title), Me(r, t.text);
  }), z(e, a);
}
var c5 = /* @__PURE__ */ L('<li class="!layup-mb-1 !layup-flex !layup-items-start !layup-gap-2"><p class="!layup-flex-1 !layup-break-words"><!></p></li>'), u5 = /* @__PURE__ */ L('<ol class="!layup-my-2 !layup-list-decimal !layup-pl-2"></ol>'), d5 = /* @__PURE__ */ L('<li class="!layup-mb-1 !layup-flex !layup-items-start !layup-gap-2"><p class="!layup-mt-2 !layup-min-h-[6px] !layup-min-w-[6px] !layup-rounded-full !layup-bg-primary" style="margin-top: 8px !important;"></p> <p class="!layup-flex-1 !layup-break-words"><!></p></li>'), f5 = /* @__PURE__ */ L('<ul class="!layup-my-2 !layup-list-none !layup-pl-2"></ul>');
function p5(e, t) {
  let a = R(t, "ordered", 3, !1), r = R(t, "items", 19, () => []);
  function n(u) {
    let f = u.replace(/\*\*(.*?)\*\*/g, '<p class="!layup-font-bold">$1</p>');
    return f = f.replace(/\[(.*?)\]\((.*?)\)/g, '<a class="!layup-text-accent !layup-no-underline hover:!layup-text-accent visited:!layup-text-accent !layup-break-words" href="$2" target="_blank" rel="noopener noreferrer">$1</a>'), f;
  }
  var o = K(), s = D(o);
  {
    var i = (u) => {
      var f = u5();
      et(f, 21, r, yt, (p, c) => {
        var h = c5(), g = A(h), _ = A(g);
        At(_, () => n(d(c).text)), z(p, h);
      }), z(u, f);
    }, l = (u) => {
      var f = f5();
      et(f, 21, r, yt, (p, c) => {
        var h = d5(), g = X(A(h), 2), _ = A(g);
        At(_, () => n(d(c).text)), z(p, h);
      }), z(u, f);
    };
    B(s, (u) => {
      a() ? u(i) : u(l, !1);
    });
  }
  z(e, o);
}
var y5 = /* @__PURE__ */ L('<div class="!layup-max-h-fit !layup-whitespace-pre-wrap !layup-break-words !layup-text-base"><!></div>');
function sl(e, t) {
  var a = y5(), r = A(a);
  s5(r, {
    get source() {
      return t.responseContent;
    },
    renderers: { link: l5, list: p5 },
    options: { breaks: !0, gfm: !0 }
  }), z(e, a);
}
/**
 * @license lucide-svelte v0.460.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
var g5 = /* @__PURE__ */ St("<svg><!><!></svg>");
function Ld(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, [
    "name",
    "color",
    "size",
    "strokeWidth",
    "absoluteStrokeWidth",
    "iconNode"
  ]);
  ke(t, !1);
  let n = R(t, "name", 8, void 0), o = R(t, "color", 8, "currentColor"), s = R(t, "size", 8, 24), i = R(t, "strokeWidth", 8, 2), l = R(t, "absoluteStrokeWidth", 8, !1), u = R(t, "iconNode", 24, () => []);
  const f = (..._) => _.filter((b, m, w) => !!b && w.indexOf(b) === m).join(" ");
  ca();
  var p = g5();
  let c;
  var h = A(p);
  et(h, 1, u, yt, (_, b) => {
    let m = () => d(b)[0], w = () => d(b)[1];
    var S = K(), C = D(S);
    U_(C, m, !0, (v, y) => {
      let k;
      $(() => k = at(v, k, { ...w() }, void 0, v.namespaceURI === oy, v.nodeName.includes("-")));
    }), z(_, S);
  });
  var g = X(h);
  Ze(g, t, "default", {}, null), $(() => c = at(
    p,
    c,
    {
      ...h5,
      ...r,
      width: s(),
      height: s(),
      stroke: o(),
      "stroke-width": l() ? Number(i()) * 24 / Number(s()) : i(),
      class: f("lucide-icon", "lucide", n() ? `lucide-${n()}` : "", a.class)
    },
    void 0,
    !0
  )), z(e, p), xe();
}
function Nc(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Ld(e, it({ name: "check" }, () => a, {
    iconNode: [["path", { d: "M20 6 9 17l-5-5" }]],
    children: (n, o) => {
      var s = K(), i = D(s);
      Ze(i, t, "default", {}, null), z(n, s);
    },
    $$slots: { default: !0 }
  }));
}
function m5(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Ld(e, it({ name: "mouse-pointer-2" }, () => a, {
    iconNode: [
      [
        "path",
        {
          d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z"
        }
      ]
    ],
    children: (n, o) => {
      var s = K(), i = D(s);
      Ze(i, t, "default", {}, null), z(n, s);
    },
    $$slots: { default: !0 }
  }));
}
function _5(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]);
  Ld(e, it({ name: "trash-2" }, () => a, {
    iconNode: [
      ["path", { d: "M3 6h18" }],
      [
        "path",
        { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }
      ],
      [
        "path",
        { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }
      ],
      [
        "line",
        {
          x1: "10",
          x2: "10",
          y1: "11",
          y2: "17"
        }
      ],
      [
        "line",
        {
          x1: "14",
          x2: "14",
          y1: "11",
          y2: "17"
        }
      ]
    ],
    children: (n, o) => {
      var s = K(), i = D(s);
      Ze(i, t, "default", {}, null), z(n, s);
    },
    $$slots: { default: !0 }
  }));
}
var w5 = /* @__PURE__ */ L('<button><div class="layup-group layup-flex layup-h-10 layup-w-full layup-cursor-pointer layup-items-center !layup-gap-3 layup-rounded-button-outer !layup-border !layup-border-transparent layup-px-2 hover:!layup-border-accent hover:!layup-bg-accent-bg"><!> <p class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </p></div></button>');
function Vp(e, t) {
  ke(t, !1);
  let a = R(t, "name", 8), r = R(t, "onclick", 8);
  ca();
  var n = w5();
  const o = /* @__PURE__ */ kt(() => Oe("layup-w-full"));
  n.__click = function(...f) {
    var p;
    (p = r()) == null || p.apply(this, f);
  };
  var s = A(n), i = A(s);
  m5(i, {
    class: "layup-size-4 layup-fill-none layup-stroke-secondary group-hover:layup-stroke-primary"
  });
  var l = X(i, 2), u = A(l);
  $(() => {
    Ue(n, d(o)), Me(u, a());
  }), z(e, n), xe();
}
nr(["click"]);
var v5 = /* @__PURE__ */ L('<div class="layup-relative layup-z-50 layup-block layup-w-fit layup-overflow-hidden layup-rounded-inner !layup-border !layup-border-border layup-bg-transparent layup-p-[1.5px] layup-text-center layup-text-base layup-text-white layup-transition layup-duration-200"><div class="layup-relative layup-z-[53] !layup-max-w-[384px] !layup-rounded-inner !layup-bg-background !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary dark:!layup-bg-background" style="border-radius: calc(var(--layup-radius) - 2px)"> </div> <div class="layup-absolute layup-inset-0 -layup-z-[1] layup-h-full layup-w-full layup-animate-rotate-css layup-rounded-full layup-bg-[conic-gradient(var(--layup-accent)_60deg,transparent_250deg)]"></div></div>');
function b5(e, t) {
  var a = v5(), r = A(a), n = A(r);
  $(() => Me(n, t.content || "Thinking...")), z(e, a);
}
var k5 = /* @__PURE__ */ L('<div class="layup-flex layup-h-[20px] layup-w-[30px] layup-items-center layup-justify-center layup-rounded-xl layup-bg-accent-bg layup-text-accent"><p class="layup-text-sm !layup-text-accent"> </p></div>');
function x5(e, t) {
  var a = K(), r = D(a);
  {
    var n = (o) => {
      var s = k5(), i = A(s), l = A(i);
      $(() => Me(l, t.count)), z(o, s);
    };
    B(r, (o) => {
      t.count > 0 && o(n);
    });
  }
  z(e, a);
}
var z5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-gap-2 !layup-rounded-inner !layup-bg-accent-bg !layup-px-3 !layup-py-1"><p class="!layup-text-label !layup-text-primary"> </p> <div class="!layup-relative !layup-size-4"><svg class="!layup-h-full !layup-w-full !layup--rotate-90 !layup-transform" viewBox="0 0 20 20"><circle class="!layup-text-accent-bg svelte-1m9ls09" stroke="currentColor" stroke-width="2" fill="none" cx="10" cy="10"></circle><circle class="!layup-text-accent !layup-transition-all !layup-duration-300 svelte-1m9ls09" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" cx="10" cy="10"></circle></svg></div></div>');
function um(e, t) {
  const r = 2 * Math.PI * 8, n = /* @__PURE__ */ M(() => r - t.progress * r);
  var o = z5(), s = A(o), i = A(s);
  $(() => Me(i, `${Math.round(t.progress * 100) ?? ""}% complete`));
  var l = X(s, 2), u = A(l), f = A(u);
  be(f, "r", 8);
  var p = X(f);
  be(p, "r", 8), $(() => be(p, "style", `stroke-dasharray: ${r ?? ""}; stroke-dashoffset: ${d(n) ?? ""}`)), z(e, o);
}
var S5 = /* @__PURE__ */ L('<button class="layup-group layup-w-full"><div class="layup-flex layup-h-10 layup-w-full layup-items-center layup-rounded-button-outer !layup-border !layup-border-transparent layup-px-2 hover:!layup-border-accent hover:!layup-bg-accent-bg"><div class="layup-flex layup-w-full layup-items-center layup-justify-between"><div class="layup-flex layup-items-center layup-gap-3"><!> <p class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </p></div> <!></div></div></button>');
function Vc(e, t) {
  let a = R(t, "showBadge", 3, !1), r = R(t, "badgeCount", 3, 0), n = R(t, "progress", 3, 0), o = R(t, "isStrokeIcon", 3, !1), s = R(t, "badgeType", 3, "count");
  var i = S5();
  i.__click = function(...m) {
    var w;
    (w = t.onclick) == null || w.apply(this, m);
  };
  var l = A(i), u = A(l), f = A(u), p = A(f), c = /* @__PURE__ */ M(() => `layup-h-4 layup-w-4 ${(o() ? "layup-stroke-secondary group-hover:layup-stroke-primary" : "layup-fill-secondary group-hover:layup-fill-primary") ?? ""}`);
  Xe(p, () => t.icon, (m, w) => {
    w(m, {
      get class() {
        return d(c);
      }
    });
  });
  var h = X(p, 2), g = A(h), _ = X(f, 2);
  {
    var b = (m) => {
      var w = K(), S = D(w);
      {
        var C = (y) => {
          um(y, {
            get progress() {
              return n();
            }
          });
        }, v = (y) => {
          x5(y, {
            get count() {
              return r();
            }
          });
        };
        B(S, (y) => {
          s() === "progress" ? y(C) : y(v, !1);
        });
      }
      z(m, w);
    };
    B(_, (m) => {
      a() && m(b);
    });
  }
  $(() => Me(g, t.text)), z(e, i);
}
nr(["click"]);
var C5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-flex-row !layup-items-center !layup-justify-end"><div class="!layup-flex !layup-max-w-[70%] !layup-justify-end"><div class="layup-flex !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center !layup-whitespace-pre-wrap !layup-break-words !layup-rounded-inner !layup-border !layup-border-border layup-bg-background !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary dark:!layup-border-border"><p class="!layup-m-0 !layup-w-full !layup-whitespace-pre-wrap !layup-break-words !layup-text-base !layup-font-normal"> </p></div></div></div>'), E5 = /* @__PURE__ */ L('<!> <p class="!layup-text-white"> </p>', 1), A5 = /* @__PURE__ */ L("<div><!></div>"), T5 = /* @__PURE__ */ L("<div> </div>"), P5 = /* @__PURE__ */ L("<div><!></div>"), O5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-row !layup-flex-wrap !layup-gap-2"></div>'), M5 = /* @__PURE__ */ L("<!> <p> </p>", 1), I5 = /* @__PURE__ */ L('<div><a target="_blank" rel="noopener noreferrer"><!></a></div>'), F5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-row !layup-flex-wrap !layup-gap-2"></div>'), j5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-2"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div><!></div> <!></div> <!> <!></div>'), R5 = /* @__PURE__ */ L('<!> <p class="!layup-text-white"> </p>', 1), L5 = /* @__PURE__ */ L("<div><!></div>"), D5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-3"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div><!></div> <!></div></div>'), N5 = /* @__PURE__ */ L('<div class="layup-flex layup-w-full layup-items-start"><!></div>'), V5 = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-[500px] !layup-w-full !layup-flex-col !layup-px-custom"><div class="layup-custom-scrollbar !layup-inline-flex !layup-h-full !layup-max-h-full !layup-w-full !layup-flex-col !layup-gap-item !layup-overflow-y-auto !layup-py-custom"></div></div>'), q5 = /* @__PURE__ */ L('<div class="!layup-hidden !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-w-20 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-fill-primary"><!></div>', 1), B5 = /* @__PURE__ */ L('<div class="layup-min-h-14 layup-w-full !layup-p-default"><div class="layup-flex layup-h-full layup-items-center layup-justify-between layup-font-medium layup-text-primary"><div class="layup-flex layup-items-center layup-gap-2"><!></div> <!></div></div> <!>', 1), W5 = /* @__PURE__ */ L('<div class="layup-flex !layup-h-fit layup-w-full layup-flex-col layup-items-center !layup-gap-item"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Top guides</p></div> <!></div>'), H5 = /* @__PURE__ */ L('<div class="layup-flex !layup-h-fit layup-w-full layup-flex-col layup-items-center !layup-gap-item"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Suggestions</p></div> <!></div>'), U5 = /* @__PURE__ */ L('<div class="layup-flex !layup-h-fit layup-w-full layup-flex-col !layup-gap-item"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Modules</p></div> <!> <!> <!></div>'), G5 = /* @__PURE__ */ L('<!> <div class="layup-flex layup-h-full layup-w-full layup-flex-col  !layup-p-default !layup-gap-section"><!> <!> <!></div>', 1), K5 = /* @__PURE__ */ L("<!> <!>", 1), Z5 = /* @__PURE__ */ L("<div><!></div>");
function Y5(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a);
  let n = /* @__PURE__ */ M(() => r().context.messages);
  const o = /* @__PURE__ */ M(() => r().context.suggestedFlowsByName), s = /* @__PURE__ */ M(() => r().context.topSuggestedFlows), i = /* @__PURE__ */ M(() => {
    var C;
    return (C = r().context.theme) == null ? void 0 : C.icons;
  }), l = (C) => {
    t.send({ type: "runTopSuggestedFlows", flow: C.flow });
  };
  let u = me(void 0), f = me(!1);
  function p() {
    d(u) && (d(u).scrollTop = d(u).scrollHeight);
  }
  function c() {
    if (d(u)) {
      const { scrollTop: C, scrollHeight: v, clientHeight: y } = d(u);
      q(f, C + y < v - 100);
    }
  }
  Pe(() => {
    var C, v, y, k;
    d(n), (v = (C = d(n)) == null ? void 0 : C[d(n).length - 1]) == null || v.content, (k = (y = d(n)) == null ? void 0 : y[d(n).length - 1]) == null || k.status, d(f) || p();
  }), Pe(() => {
    const C = d(u);
    if (C) {
      const v = C.scrollHeight;
      requestAnimationFrame(() => {
        C.scrollTo({ top: v, behavior: "smooth" });
      });
    }
  }), Pe(() => {
    const C = d(u);
    if (g && C) {
      const v = C.scrollHeight;
      requestAnimationFrame(() => {
        C.scrollTo({ top: v, behavior: "smooth" });
      });
    }
  });
  const h = /* @__PURE__ */ M(() => {
    var C, v;
    return (v = (C = r().context.plans) == null ? void 0 : C.onboarding_flows) != null && v.length ? r().context.plans.onboarding_flows.filter((y) => y.state.status === "Completed").length / r().context.plans.onboarding_flows.length : 0;
  });
  let g = !0, _ = me(0), b = me(0);
  Pe(() => {
    var C, v;
    q(_, ce(bg((C = r().context) == null ? void 0 : C.plans))), q(b, ce(vg((v = r().context) == null ? void 0 : v.features)));
  });
  var m = Z5();
  const w = /* @__PURE__ */ M(() => Oe("layup-chat-container !layup-relative !layup-flex !layup-h-full layup-w-full !layup-flex-1 !layup-flex-col layup-items-center layup-justify-start !layup-rounded-outer !layup-rounded-b-none layup-bg-background"));
  var S = A(m);
  zr(S, () => d(n), (C) => {
    var v = K5(), y = D(v);
    {
      var k = (F) => {
        var P = V5(), O = A(P);
        et(O, 21, () => d(n), yt, (I, E, N) => {
          var H = K(), Y = D(H);
          {
            var V = (ee) => {
              var W = C5(), G = A(W), J = A(G), te = A(J), ae = A(te);
              $(() => Me(ae, d(E).content)), z(ee, W);
            }, U = (ee) => {
              var W = K(), G = D(W);
              {
                var J = (ae) => {
                  var ie = j5(), oe = A(ie), Q = A(oe);
                  const le = /* @__PURE__ */ M(() => Oe("layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-inner !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-base !layup-font-medium layup-text-primary"));
                  var he = A(Q), pe = /* @__PURE__ */ M(() => d(E).content.trim());
                  sl(he, {
                    get responseContent() {
                      return d(pe);
                    }
                  });
                  var se = X(Q, 2);
                  {
                    var ye = (Re) => {
                      var ve = A5();
                      const ze = /* @__PURE__ */ M(() => d(E).flow.starting_url ? (() => {
                        try {
                          return new URL(d(E).flow.starting_url);
                        } catch {
                          return console.error("Invalid URL:", d(E).flow.starting_url), null;
                        }
                      })() : null), fe = /* @__PURE__ */ M(() => new URL(window.location.href)), Ce = /* @__PURE__ */ M(() => d(ze) && d(ze).pathname === d(fe).pathname);
                      var Ne = A(ve);
                      He(Ne, {
                        onclick: () => {
                          d(Ce) ? t.send({ type: "play", item: d(E) }) : t.send({ type: "playNewPage", item: d(E) });
                        },
                        variant: "ghost",
                        size: "icon",
                        class: "!layup-mt-2 !layup-flex !layup-h-8 !layup-w-fit !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-button-outer !layup-bg-accent !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary hover:!layup-bg-accent-secondary hover:!layup-text-primary",
                        children: (je, Be) => {
                          var Fe = E5(), Ae = D(Fe);
                          Fp(Ae, { class: "!layup-size-4 layup-fill-white" });
                          var mt = X(Ae, 2), ut = A(mt);
                          $(() => Me(ut, d(Ce) ? "Show me" : "Take me there")), z(je, Fe);
                        },
                        $$slots: { default: !0 }
                      }), xt(5, ve, () => al, () => ({ duration: 400 })), z(Re, ve);
                    };
                    B(se, (Re) => {
                      var ve;
                      (ve = d(E)) != null && ve.flow && Re(ye);
                    });
                  }
                  var ge = X(oe, 2);
                  {
                    var ue = (Re) => {
                      var ve = O5();
                      et(ve, 21, () => {
                        var ze;
                        return (ze = d(E)) == null ? void 0 : ze.suggested_queries;
                      }, yt, (ze, fe, Ce) => {
                        var Ne = P5(), je = A(Ne);
                        He(je, {
                          variant: "outline",
                          size: "sm",
                          class: "!layup-h-6 !layup-rounded-button-outer !layup-border !layup-border-accent-bg !layup-bg-accent-bg !layup-p-2 !layup-text-primary hover:!layup-bg-accent-secondary hover:!layup-text-accent-text hover:!layup-no-underline dark:!layup-bg-accent-bg dark:!layup-text-primary hover:dark:!layup-text-primary",
                          onclick: () => {
                            t.send({
                              type: "request",
                              userMessages: d(fe)
                            }), p();
                          },
                          children: (Be, Fe) => {
                            var Ae = T5(), mt = A(Ae);
                            $(() => Me(mt, d(fe))), z(Be, Ae);
                          },
                          $$slots: { default: !0 }
                        }), xt(5, Ne, () => ha, () => ({
                          duration: 400,
                          delay: Ce * 50,
                          easing: an(0.4, 0, 0.2, 1)
                        })), z(ze, Ne);
                      }), z(Re, ve);
                    };
                    B(ge, (Re) => {
                      var ve;
                      (ve = d(E)) != null && ve.suggested_queries && g && Re(ue);
                    });
                  }
                  var _e = X(ge, 2);
                  {
                    var Se = (Re) => {
                      var ve = F5();
                      et(ve, 21, () => d(E).sources, yt, (ze, fe, Ce) => {
                        var Ne = I5(), je = A(Ne), Be = A(je);
                        He(Be, {
                          variant: "outline",
                          size: "sm",
                          class: "group layup-group !layup-h-6 !layup-rounded-button-outer !layup-border !layup-border-accent-bg !layup-bg-accent-bg !layup-p-2 !layup-text-primary hover:!layup-bg-accent-secondary hover:!layup-text-accent-text hover:!layup-no-underline dark:!layup-bg-accent-bg dark:!layup-text-primary hover:dark:!layup-text-primary",
                          children: (Fe, Ae) => {
                            var mt = M5(), ut = D(mt);
                            D3(ut, {
                              class: "!layup-size-3 !layup-fill-secondary group-hover:!layup-fill-accent-text"
                            });
                            var De = X(ut, 2), dt = A(De);
                            $(() => Me(dt, d(fe).title)), z(Fe, mt);
                          },
                          $$slots: { default: !0 }
                        }), $(() => be(je, "href", d(fe).url)), xt(5, Ne, () => ha, () => ({
                          duration: 400,
                          delay: Ce * 50,
                          easing: an(0.4, 0, 0.2, 1)
                        })), z(ze, Ne);
                      }), z(Re, ve);
                    };
                    B(_e, (Re) => {
                      var ve;
                      (ve = d(E)) != null && ve.sources && d(E).sources.length > 0 && g && Re(Se);
                    });
                  }
                  $(() => Ue(Q, d(le))), z(ae, ie);
                }, te = (ae) => {
                  var ie = K(), oe = D(ie);
                  {
                    var Q = (he) => {
                      var pe = D5(), se = A(pe), ye = A(se);
                      const ge = /* @__PURE__ */ M(() => Oe("layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-inner !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-base !layup-font-medium layup-text-primary"));
                      var ue = A(ye), _e = /* @__PURE__ */ M(() => d(E).content.trim());
                      sl(ue, {
                        get responseContent() {
                          return d(_e);
                        }
                      });
                      var Se = X(ye, 2);
                      {
                        var Re = (ve) => {
                          var ze = L5();
                          const fe = /* @__PURE__ */ M(() => d(E).flow.starting_url ? (() => {
                            try {
                              return new URL(d(E).flow.starting_url);
                            } catch {
                              return console.error("Invalid URL:", d(E).flow.starting_url), null;
                            }
                          })() : null), Ce = /* @__PURE__ */ M(() => new URL(window.location.href)), Ne = /* @__PURE__ */ M(() => d(fe) && d(fe).pathname === d(Ce).pathname);
                          var je = A(ze);
                          He(je, {
                            onclick: () => {
                              d(Ne) ? t.send({ type: "play", item: d(E) }) : t.send({ type: "playNewPage", item: d(E) });
                            },
                            variant: "ghost",
                            size: "icon",
                            class: "!layup-mt-2 !layup-flex !layup-h-8 !layup-w-fit !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-button-outer !layup-bg-accent !layup-p-2 !layup-text-base !layup-font-medium !layup-text-primary hover:!layup-bg-accent-secondary hover:!layup-text-primary",
                            children: (Be, Fe) => {
                              var Ae = R5(), mt = D(Ae);
                              Fp(mt, { class: "!layup-size-4 layup-fill-white" });
                              var ut = X(mt, 2), De = A(ut);
                              $(() => Me(De, d(Ne) ? "Show me" : "Take me there")), z(Be, Ae);
                            },
                            $$slots: { default: !0 }
                          }), xt(5, ze, () => al, () => ({ duration: 400 })), z(ve, ze);
                        };
                        B(Se, (ve) => {
                          var ze;
                          (ze = d(E)) != null && ze.flow && ve(Re);
                        });
                      }
                      $(() => Ue(ye, d(ge))), z(he, pe);
                    }, le = (he) => {
                      var pe = K(), se = D(pe);
                      {
                        var ye = (ge) => {
                          var ue = N5(), _e = A(ue), Se = /* @__PURE__ */ M(() => {
                            var Re;
                            return (Re = d(E)) == null ? void 0 : Re.status;
                          });
                          b5(_e, {
                            get content() {
                              return d(Se);
                            }
                          }), z(ge, ue);
                        };
                        B(
                          se,
                          (ge) => {
                            var ue, _e;
                            d(E).role === "assistant" && N === ((ue = d(n)) == null ? void 0 : ue.length) - 1 && ((_e = d(E)) == null ? void 0 : _e.content.trim()) === "" && ge(ye);
                          },
                          !0
                        );
                      }
                      z(he, pe);
                    };
                    B(
                      oe,
                      (he) => {
                        var pe, se;
                        d(E).role === "assistant" && N !== ((pe = d(n)) == null ? void 0 : pe.length) - 1 && ((se = d(E)) == null ? void 0 : se.content.trim()) !== "" ? he(Q) : he(le, !1);
                      },
                      !0
                    );
                  }
                  z(ae, ie);
                };
                B(
                  G,
                  (ae) => {
                    var ie, oe, Q;
                    ((ie = d(E)) == null ? void 0 : ie.role) === "assistant" && N === ((oe = d(n)) == null ? void 0 : oe.length) - 1 && ((Q = d(E)) == null ? void 0 : Q.content.trim()) !== "" ? ae(J) : ae(te, !1);
                  },
                  !0
                );
              }
              z(ee, W);
            };
            B(Y, (ee) => {
              d(E).role === "user" ? ee(V) : ee(U, !1);
            });
          }
          z(I, H);
        }), aa(O, (I) => q(u, I), () => d(u)), pt("scroll", O, c), z(F, P);
      };
      B(y, (F) => {
        var P;
        ((P = d(n)) == null ? void 0 : P.length) > 0 && F(k);
      });
    }
    var x = X(y, 2);
    {
      var T = (F) => {
        var P = G5(), O = D(P);
        {
          var I = (W) => {
            var G = B5(), J = D(G), te = A(J), ae = A(te), ie = A(ae);
            {
              var oe = (pe) => {
                var se = q5(), ye = D(se), ge = A(ye);
                At(ge, () => {
                  var Se, Re, ve;
                  return (ve = (Re = (Se = d(i)) == null ? void 0 : Se.logo) == null ? void 0 : Re.dark_mode) == null ? void 0 : ve.xml;
                });
                var ue = X(ye, 2), _e = A(ue);
                At(_e, () => {
                  var Se, Re, ve;
                  return (ve = (Re = (Se = d(i)) == null ? void 0 : Se.logo) == null ? void 0 : Re.light_mode) == null ? void 0 : ve.xml;
                }), z(pe, se);
              }, Q = (pe) => {
                rr(pe, { class: "!layup-size-6" });
              };
              B(ie, (pe) => {
                var se, ye, ge;
                (ge = (ye = (se = d(i)) == null ? void 0 : se.logo) == null ? void 0 : ye.dark_mode) != null && ge.xml ? pe(oe) : pe(Q, !1);
              });
            }
            var le = X(ae, 2);
            He(le, {
              variant: "ghost",
              size: "sm",
              class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
              get onclick() {
                return t.handleClose;
              },
              children: (pe, se) => {
                Ra(pe, { class: "!layup-size-full" });
              },
              $$slots: { default: !0 }
            });
            var he = X(J, 2);
            rm(he, { class: "!layup-border-border" }), z(W, G);
          };
          B(O, (W) => {
            t.showHeading || W(I);
          });
        }
        var E = X(O, 2), N = A(E);
        {
          var H = (W) => {
            var G = W5(), J = X(A(G), 2);
            et(J, 17, () => d(s), yt, (te, ae) => {
              var ie = /* @__PURE__ */ M(() => {
                var oe, Q;
                return ((Q = (oe = d(ae)) == null ? void 0 : oe.flow) == null ? void 0 : Q.name) || d(ae).name;
              });
              Vp(te, {
                get name() {
                  return d(ie);
                },
                onclick: () => l(d(ae))
              });
            }), z(W, G);
          };
          B(N, (W) => {
            var G, J;
            ((G = d(s)) == null ? void 0 : G.length) > 0 && ((J = d(o)) == null ? void 0 : J.length) === 0 && W(H);
          });
        }
        var Y = X(N, 2);
        {
          var V = (W) => {
            var G = H5(), J = X(A(G), 2);
            et(J, 17, () => d(o), yt, (te, ae) => {
              var ie = /* @__PURE__ */ M(() => {
                var oe, Q;
                return ((Q = (oe = d(ae)) == null ? void 0 : oe.flow) == null ? void 0 : Q.name) || d(ae).name;
              });
              Vp(te, {
                get name() {
                  return d(ie);
                },
                onclick: () => l(d(ae))
              });
            }), z(W, G);
          };
          B(Y, (W) => {
            var G, J;
            ((G = d(o)) == null ? void 0 : G.length) > 0 && ((J = d(n)) == null ? void 0 : J.length) === 0 && W(V);
          });
        }
        var U = X(Y, 2);
        {
          var ee = (W) => {
            var G = U5(), J = X(A(G), 2);
            Vc(J, {
              icon: V3,
              text: "History",
              onclick: () => t.send({ type: "history" })
            });
            var te = X(J, 2);
            {
              var ae = (Q) => {
                Vc(Q, {
                  icon: W3,
                  text: "Onboarding",
                  onclick: () => t.send({ type: "handleOnboarding" }),
                  showBadge: !0,
                  get progress() {
                    return d(h);
                  },
                  badgeType: "progress",
                  isStrokeIcon: !0
                });
              };
              B(te, (Q) => {
                r().can({ type: "handleOnboarding" }) && Q(ae);
              });
            }
            var ie = X(te, 2);
            {
              var oe = (Q) => {
                Vc(Q, {
                  icon: j3,
                  text: "Announcements",
                  onclick: () => t.send({ type: "handleFeatures" }),
                  showBadge: !0,
                  get badgeCount() {
                    return d(b);
                  },
                  badgeType: "count"
                });
              };
              B(ie, (Q) => {
                r().can({ type: "handleFeatures" }) && Q(oe);
              });
            }
            z(W, G);
          };
          B(U, (W) => {
            var G, J;
            ((G = d(n)) == null ? void 0 : G.length) === 0 && ((J = d(o)) == null ? void 0 : J.length) === 0 && W(ee);
          });
        }
        z(F, P);
      };
      B(x, (F) => {
        var P;
        ((P = d(n)) == null ? void 0 : P.length) === 0 && F(T);
      });
    }
    z(C, v);
  }), $(() => Ue(m, d(w))), z(e, m), xe();
}
var X5 = /* @__PURE__ */ St("<title> </title>"), J5 = /* @__PURE__ */ St("<desc> </desc>"), Q5 = /* @__PURE__ */ St('<svg><!><!><path fill-rule="evenodd" clip-rule="evenodd" d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"></path></svg>');
function $5(e, t) {
  var b, m;
  ke(t, !0);
  const a = rc("iconCtx") ?? {};
  let r = R(t, "size", 19, () => a.size || "24"), n = R(t, "role", 19, () => a.role || "img"), o = R(t, "color", 19, () => a.color || "currentColor"), s = R(t, "ariaLabel", 3, "chevron down"), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "size",
    "role",
    "color",
    "title",
    "desc",
    "ariaLabel"
  ]), l = `${((b = t.title) == null ? void 0 : b.id) || ""} ${((m = t.desc) == null ? void 0 : m.id) || ""}`;
  const u = /* @__PURE__ */ M(() => {
    var w, S;
    return !!((w = t.title) != null && w.id || (S = t.desc) != null && S.id);
  });
  var f = Q5();
  let p;
  var c = A(f);
  {
    var h = (w) => {
      var S = X5(), C = A(S);
      $(() => {
        be(S, "id", t.title.id), Me(C, t.title.title);
      }), z(w, S);
    };
    B(c, (w) => {
      var S;
      (S = t.title) != null && S.id && t.title.title && w(h);
    });
  }
  var g = X(c);
  {
    var _ = (w) => {
      var S = J5(), C = A(S);
      $(() => {
        be(S, "id", t.desc.id), Me(C, t.desc.desc);
      }), z(w, S);
    };
    B(g, (w) => {
      var S;
      (S = t.desc) != null && S.id && t.desc.desc && w(_);
    });
  }
  $(() => p = at(
    f,
    p,
    {
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      role: n(),
      width: r(),
      height: r(),
      fill: o(),
      "aria-label": s(),
      "aria-describedby": d(u) ? l : void 0,
      viewBox: "0 0 15 15"
    },
    void 0,
    !0
  )), z(e, f), xe();
}
var e4 = /* @__PURE__ */ L('<div class="!layup-hidden !layup-h-6 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-size-6 [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-size-6 [&amp;>svg]:!layup-fill-primary"><!></div>', 1), t4 = /* @__PURE__ */ L("<div></div>"), a4 = /* @__PURE__ */ L('<div class="!layup-relative !layup-flex !layup-h-6 !layup-w-6 !layup-items-center !layup-justify-center"><div class="!layup-absolute !layup-flex !layup-h-6 !layup-w-6 !layup-items-center !layup-justify-center"><!></div> <div class="!layup-absolute !layup-flex !layup-h-6 !layup-w-6 !layup-items-center !layup-justify-center"><!></div></div> <!>', 1), r4 = /* @__PURE__ */ L("<div>Start cursor-based guidance</div>"), n4 = /* @__PURE__ */ L('<div class="!layup-relative"><!> <!></div>');
function qp(e, t) {
  ke(t, !0);
  let a = me(!1), r = me(0), n = me(1), o = me(0);
  Pe(() => {
    t.isOpen ? (q(r, 120), setTimeout(
      () => {
        q(n, 0), q(o, 1);
      },
      150
    )) : (q(r, 0), q(n, 1), q(o, 0));
  });
  var s = n4(), i = A(s);
  He(i, {
    variant: "ghost",
    class: "!layup-pointer-events-auto !layup-relative !layup-h-12 !layup-w-12 !layup-rounded-full !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-sm hover:!layup-bg-background dark:!layup-border-gray-700/50 dark:!layup-bg-background dark:hover:!layup-bg-background",
    onmouseenter: () => q(a, !0),
    onmouseleave: () => q(a, !1),
    get onclick() {
      return t.handleClick;
    },
    children: (f, p) => {
      var c = a4(), h = D(c), g = A(h), _ = A(g);
      {
        var b = (y) => {
          var k = e4(), x = D(k), T = A(x);
          At(T, () => {
            var O, I, E;
            return (E = (I = (O = t.icons) == null ? void 0 : O.trigger_icon) == null ? void 0 : I.dark_mode) == null ? void 0 : E.xml;
          });
          var F = X(x, 2), P = A(F);
          At(P, () => {
            var O, I, E;
            return (E = (I = (O = t.icons) == null ? void 0 : O.trigger_icon) == null ? void 0 : I.light_mode) == null ? void 0 : E.xml;
          }), z(y, k);
        }, m = (y) => {
          rr(y, { class: "!layup-size-5" });
        };
        B(_, (y) => {
          var k, x, T;
          (T = (x = (k = t.icons) == null ? void 0 : k.trigger_icon) == null ? void 0 : x.dark_mode) != null && T.xml ? y(b) : y(m, !1);
        });
      }
      var w = X(g, 2), S = A(w);
      $5(S, { class: "!layup-size-5 !layup-fill-primary" });
      var C = X(h, 2);
      {
        var v = (y) => {
          var k = t4();
          const x = /* @__PURE__ */ M(() => Oe("!layup-absolute !layup-right-1 !layup-top-1 !layup-size-3 !layup-translate-x-1/3 !layup-translate-y-[-25%] !layup-rounded-full !layup-bg-accent", d(a) ? "!layup-opacity-0" : ""));
          $(() => Ue(k, d(x))), xt(5, k, () => ha, () => ({ duration: 200 })), z(y, k);
        };
        B(C, (y) => {
          t.count && !t.isOpen && y(v);
        });
      }
      $(() => {
        be(g, "style", `opacity: ${d(n) ?? ""}; transform: rotate(${d(r) ?? ""}deg) scale(${(t.isOpen ? 0.8 : 1) ?? ""}); transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s ease;`), be(w, "style", `opacity: ${d(o) ?? ""}; transition: opacity 0.15s ease;`);
      }), z(f, c);
    },
    $$slots: { default: !0 }
  });
  var l = X(i, 2);
  {
    var u = (f) => {
      var p = r4();
      const c = /* @__PURE__ */ M(() => Oe("!layup-absolute !layup-bottom-full !layup-mb-2 !layup-whitespace-nowrap !layup-rounded-outer !layup-bg-white !layup-px-3 !layup-py-2 !layup-text-base !layup-text-[#999999] !layup-shadow-md dark:!layup-bg-black", t.widget_position === "BottomCenter" ? "!layup-left-1/2 !-layup-translate-x-1/2" : "!-layup-left-[60px] !-layup-translate-x-1/2"));
      $(() => Ue(p, d(c))), xt(5, p, () => ha, () => ({ duration: 400 })), z(f, p);
    };
    B(l, (f) => {
      d(a) && !t.isOpen && f(u);
    });
  }
  xt(1, s, () => ha, () => ({ duration: 500 })), z(e, s), xe();
}
var o4 = /* @__PURE__ */ St('<svg><path d="M14.9888 9.8125L14.2388 3.8125C14.1931 3.44993 14.0166 3.1165 13.7425 2.87483C13.4684 2.63316 13.1154 2.49987 12.75 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89464 1.73478 10 2 10H4.69125L7.0525 14.7238C7.09407 14.8068 7.15795 14.8767 7.237 14.9255C7.31604 14.9743 7.40711 15.0001 7.5 15C8.16304 15 8.79893 14.7366 9.26777 14.2678C9.73661 13.7989 10 13.163 10 12.5V11.5H13.5C13.7129 11.5001 13.9233 11.4548 14.1173 11.3673C14.3113 11.2798 14.4845 11.152 14.6253 10.9923C14.7662 10.8327 14.8714 10.645 14.9341 10.4415C14.9967 10.2381 15.0154 10.0237 14.9888 9.8125ZM4.5 9H2V3.5H4.5V9ZM13.875 10.3306C13.8284 10.3842 13.7708 10.4271 13.706 10.4564C13.6413 10.4856 13.571 10.5005 13.5 10.5H9.5C9.36739 10.5 9.24021 10.5527 9.14645 10.6464C9.05268 10.7402 9 10.8674 9 11V12.5C9.0001 12.8468 8.88002 13.1829 8.66021 13.4512C8.4404 13.7194 8.13443 13.9032 7.79437 13.9712L5.5 9.38188V3.5H12.75C12.8718 3.49996 12.9895 3.54439 13.0808 3.62494C13.1722 3.7055 13.231 3.81664 13.2463 3.9375L13.9963 9.9375C14.0056 10.0079 13.9996 10.0795 13.9787 10.1473C13.9578 10.2152 13.9224 10.2777 13.875 10.3306Z"></path></svg>');
function s4(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = o4();
  let n;
  $(() => n = at(
    r,
    n,
    {
      class: t.class,
      ...a,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var i4 = /* @__PURE__ */ St('<svg><path d="M14.625 5.0075C14.4842 4.84795 14.3111 4.72019 14.1171 4.63269C13.9231 4.54519 13.7128 4.49996 13.5 4.5H10V3.5C10 2.83696 9.73661 2.20107 9.26777 1.73223C8.79893 1.26339 8.16304 1 7.5 1C7.40711 0.999934 7.31604 1.02574 7.237 1.07454C7.15795 1.12333 7.09407 1.19318 7.0525 1.27625L4.69125 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V12.5C1 12.7652 1.10536 13.0196 1.29289 13.2071C1.48043 13.3946 1.73478 13.5 2 13.5H12.75C13.1154 13.5001 13.4684 13.3668 13.7425 13.1252C14.0166 12.8835 14.1931 12.5501 14.2388 12.1875L14.9888 6.1875C15.0153 5.97626 14.9966 5.76179 14.9339 5.55833C14.8712 5.35488 14.7659 5.16711 14.625 5.0075ZM2 7H4.5V12.5H2V7ZM13.9963 6.0625L13.2463 12.0625C13.231 12.1834 13.1722 12.2945 13.0808 12.3751C12.9895 12.4556 12.8718 12.5 12.75 12.5H5.5V6.61812L7.79437 2.02875C8.13443 2.09681 8.4404 2.2806 8.66021 2.54884C8.88002 2.81708 9.0001 3.1532 9 3.5V5C9 5.13261 9.05268 5.25979 9.14645 5.35355C9.24021 5.44732 9.36739 5.5 9.5 5.5H13.5C13.571 5.49998 13.6411 5.51505 13.7058 5.54423C13.7704 5.5734 13.8282 5.61601 13.8751 5.66922C13.9221 5.72242 13.9571 5.78501 13.978 5.85282C13.9989 5.92063 14.0051 5.9921 13.9963 6.0625Z"></path></svg>');
function l4(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = i4();
  let n;
  $(() => n = at(
    r,
    n,
    {
      class: t.class,
      ...a,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var c4 = /* @__PURE__ */ L('<!> <p class="layup-text-base layup-text-primary !layup-font-items"> </p>', 1), u4 = /* @__PURE__ */ L('<!> <p class="layup-text-base layup-text-primary !layup-font-items"> </p>', 1), d4 = /* @__PURE__ */ L('<div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex !layup-w-fit !layup-flex-row !layup-items-center !layup-justify-center !layup-gap-2 !layup-rounded-outer !layup-border !layup-border-background-secondary !layup-bg-background layup-p-2"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-inner !layup-bg-accent layup-text-base !layup-text-primary"><p class="layup-text-base layup-text-accent-text !layup-font-items">?</p></div> <p class="layup-text-base layup-text-primary !layup-font-items"> </p> <!> <!></div></div>');
function f4(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => {
    var s, i;
    return (i = (s = t.guideMachineContext) == null ? void 0 : s.context) == null ? void 0 : i.status;
  });
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = K(), l = D(i);
      {
        var u = (f) => {
          var p = d4(), c = A(p), h = X(A(c), 2), g = A(h), _ = X(h, 2);
          He(_, {
            variant: "outline",
            size: "sm",
            class: "!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
            onclick: () => {
              var m;
              return (m = t.guideMachineRef) == null ? void 0 : m.send({ type: "POSITIVE" });
            },
            children: (m, w) => {
              var S = c4(), C = D(S);
              l4(C, { class: "!layup-fill-primary" });
              var v = X(C, 2), y = A(v);
              $(() => Me(y, d(a) === "TERMINATE" ? "Helpful" : "Yes")), z(m, S);
            },
            $$slots: { default: !0 }
          });
          var b = X(_, 2);
          He(b, {
            variant: "outline",
            size: "sm",
            class: "!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
            onclick: () => {
              var m;
              return (m = t.guideMachineRef) == null ? void 0 : m.send({ type: "NEGATIVE" });
            },
            children: (m, w) => {
              var S = u4(), C = D(S);
              s4(C, { class: "!layup-fill-primary" });
              var v = X(C, 2), y = A(v);
              $(() => Me(y, d(a) === "TERMINATE" ? "Not helpful" : "No")), z(m, S);
            },
            $$slots: { default: !0 }
          }), $(() => Me(g, d(a) === "TERMINATE" ? "You finished early?" : "Did we help?")), z(f, p);
        };
        B(l, (f) => {
          var p, c;
          (c = (p = t.guideMachineContext) == null ? void 0 : p.context) != null && c.feedback || f(u);
        });
      }
      z(s, i);
    };
    B(n, (s) => {
      var i;
      (i = t.guideMachineContext) != null && i.matches("completed") && s(o);
    });
  }
  z(e, r), xe();
}
var p4 = /* @__PURE__ */ L('<div role="button" tabindex="0"><!></div>');
function y4(e, t) {
  var S, C, v, y, k;
  ke(t, !0);
  let a = !1, r = me(ce((S = t.positionStyles) == null ? void 0 : S.left)), n = me(ce((C = t.positionStyles) == null ? void 0 : C.right)), o = me(ce((v = t.positionStyles) == null ? void 0 : v.top)), s = me(ce((y = t.positionStyles) == null ? void 0 : y.bottom)), i = me(ce((k = t.positionStyles) == null ? void 0 : k.transform)), l = me(null);
  function u() {
    var T;
    const x = (T = Z.config.anchor) == null ? void 0 : T.id;
    return x ? document.getElementById(x) : null;
  }
  function f() {
    const x = document.getElementById(t.id);
    if (!x) return !0;
    const T = x.getBoundingClientRect();
    return T.top >= 0 && T.left >= 0 && T.bottom <= window.innerHeight && T.right <= window.innerWidth;
  }
  function p() {
    var T, F, P, O, I;
    q(r, ce((T = t.positionStyles) == null ? void 0 : T.left)), q(n, ce((F = t.positionStyles) == null ? void 0 : F.right)), q(o, ce((P = t.positionStyles) == null ? void 0 : P.top)), q(s, ce((O = t.positionStyles) == null ? void 0 : O.bottom)), q(i, ce((I = t.positionStyles) == null ? void 0 : I.transform));
    const x = document.getElementById(t.id);
    x && (d(r) !== void 0 && (x.style.left = d(r)), d(n) !== void 0 && (x.style.right = d(n)), d(o) !== void 0 && (x.style.top = d(o)), d(s) !== void 0 && (x.style.bottom = d(s)), d(i) !== void 0 && (x.style.transform = d(i)));
  }
  function c(x) {
    if (x.preventDefault(), x.stopPropagation(), !t.isDraggable) return;
    const T = document.getElementById(t.id);
    T && (x.target === T || T.contains(x.target)) && (a = !0, document.addEventListener("mousemove", h), document.addEventListener("mouseup", g));
  }
  function h(x) {
    var F, P, O, I;
    if (!a || !t.isDraggable) return;
    const T = (E, N, H, Y) => {
      if (N === "rem")
        return `${parseFloat(E) + H / 16}${N}`;
      if (N === "%") {
        const U = Y === "horizontal" ? window.innerWidth : window.innerHeight, ee = H / U * 100 * 1;
        return `${Math.max(0, Math.min(100, parseFloat(E) + ee))}${N}`;
      }
      return `${parseFloat(E) + H}px`;
    };
    if (d(r) !== void 0) {
      const E = parseFloat(d(r)), N = ((F = d(r).match(/[a-z%]+$/i)) == null ? void 0 : F[0]) || "px";
      q(r, ce(T(E.toString(), N, x.movementX, "horizontal")));
    }
    if (d(n) !== void 0) {
      const E = parseFloat(d(n)), N = ((P = d(n).match(/[a-z%]+$/i)) == null ? void 0 : P[0]) || "px";
      q(n, ce(T(E.toString(), N, -x.movementX, "horizontal")));
    }
    if (d(o) !== void 0) {
      const E = parseFloat(d(o)), N = ((O = d(o).match(/[a-z%]+$/i)) == null ? void 0 : O[0]) || "px";
      q(o, ce(T(E.toString(), N, x.movementY, "vertical")));
    }
    if (d(s) !== void 0) {
      const E = parseFloat(d(s)), N = ((I = d(s).match(/[a-z%]+$/i)) == null ? void 0 : I[0]) || "px";
      q(s, ce(T(E.toString(), N, -x.movementY, "vertical")));
    }
    f() || p();
  }
  function g() {
    a = !1, document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", g);
  }
  Da(() => {
    f() || p();
    const x = new MutationObserver(() => {
      f() || p();
    }), T = document.getElementById(t.id);
    T && x.observe(T, {
      attributes: !0,
      attributeFilter: ["style"]
    });
    const F = new MutationObserver(() => {
      const P = u();
      P !== d(l) && q(l, ce(P));
    });
    return F.observe(document.body, { childList: !0, subtree: !0 }), q(l, ce(u())), () => {
      x.disconnect(), F.disconnect();
    };
  }), Pe(() => {
    var x, T, F, P, O;
    q(r, ce((x = t.positionStyles) == null ? void 0 : x.left)), q(n, ce((T = t.positionStyles) == null ? void 0 : T.right)), q(o, ce((F = t.positionStyles) == null ? void 0 : F.top)), q(s, ce((P = t.positionStyles) == null ? void 0 : P.bottom)), q(i, ce((O = t.positionStyles) == null ? void 0 : O.transform));
  }), Pe(() => {
    q(l, ce(u()));
  });
  var _ = K(), b = D(_);
  {
    var m = (x) => {
      var T = K(), F = D(T);
      Xe(F, () => tm, (P, O) => {
        O(P, {
          open: !0,
          controlledOpen: !0,
          children: (I, E) => {
            var N = K(), H = D(N), Y = /* @__PURE__ */ M(() => {
              var W;
              return ((W = Z.config.anchor) == null ? void 0 : W.sideOffset) ?? 10;
            }), V = /* @__PURE__ */ M(() => {
              var W;
              return ((W = Z.config.anchor) == null ? void 0 : W.side) ?? "right";
            }), U = /* @__PURE__ */ M(() => {
              var W;
              return ((W = Z.config.anchor) == null ? void 0 : W.align) ?? "center";
            }), ee = /* @__PURE__ */ M(() => {
              var W;
              return ((W = Z.config.anchor) == null ? void 0 : W.alignOffset) ?? 20;
            });
            Xe(H, () => em, (W, G) => {
              G(W, {
                trapFocus: !1,
                get customAnchor() {
                  return d(l);
                },
                get sideOffset() {
                  return d(Y);
                },
                get side() {
                  return d(V);
                },
                get align() {
                  return d(U);
                },
                get alignOffset() {
                  return d(ee);
                },
                draggable: !1,
                onclick: (J) => {
                  J.preventDefault(), J.stopPropagation();
                },
                onOpenAutoFocus: (J) => {
                  J.preventDefault(), J.stopPropagation();
                },
                onCloseAutoFocus: (J) => {
                  J.preventDefault(), J.stopPropagation();
                },
                portal: !0,
                style: { boxShadow: "var(--layup-shadow)" },
                class: "layup-cursor-popover !layup-pointer-events-auto !layup-z-[9999999] !layup-w-fit !layup-transform-gpu !layup-rounded-lg !layup-border-none !layup-p-0 !layup-text-base !layup-text-white focus-visible:!layup-ring-0",
                children: (J, te) => {
                  var ae = K(), ie = D(ae);
                  nt(ie, () => t.children ?? qe), z(J, ae);
                },
                $$slots: { default: !0 }
              });
            }), z(I, N);
          },
          $$slots: { default: !0 }
        });
      }), z(x, T);
    }, w = (x) => {
      var T = p4();
      T.__mousedown = c;
      var F = A(T);
      nt(F, () => t.children ?? qe), $(() => {
        be(T, "id", t.id), Ue(T, `${(t.isDraggable ? "!layup-cursor-move" : "!layup-cursor-default") ?? ""} !layup-flex !layup-select-none !layup-flex-col !layup-items-center !layup-justify-center focus-visible:!layup-outline-none focus-visible:!layup-ring-0 ${t.className ?? ""}`), be(T, "style", `position: fixed;
        ${(d(r) !== void 0 ? `left: ${d(r)};` : "") ?? ""}
        ${(d(n) !== void 0 ? `right: ${d(n)};` : "") ?? ""}
        ${(d(o) !== void 0 ? `top: ${d(o)};` : "") ?? ""}
        ${(d(s) !== void 0 ? `bottom: ${d(s)};` : "") ?? ""}
        ${(d(i) ? `transform: ${d(i)};` : "") ?? ""}`);
      }), xt(1, T, () => ha, () => ({ duration: 500, start: 0.5, opacity: 0 })), z(x, T);
    };
    B(b, (x) => {
      d(l) && !t.isDraggable ? x(m) : x(w, !1);
    });
  }
  z(e, _), xe();
}
nr(["mousedown"]);
var h4 = /* @__PURE__ */ L('<p class="layup-text-base layup-text-primary !layup-font-button"> </p>'), g4 = /* @__PURE__ */ L('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-outer !layup-border !layup-border-border !layup-bg-background layup-p-2 layup-shadow-sm"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-inner !layup-bg-accent layup-text-sm !layup-text-accent-text"><p class="layup-text-base !layup-font-items">?</p></div> <p class="layup-text-base  layup-text-primary !layup-font-items"> </p> <!></div></div></div>');
function m4(e, t) {
  ke(t, !0);
  const a = /* @__PURE__ */ M(() => {
    var i;
    const s = (i = t.guideMachineContext) == null ? void 0 : i.context.error;
    return {
      message: (s == null ? void 0 : s.message) || "Something went wrong",
      type: (s == null ? void 0 : s.type) || "Error"
    };
  });
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = g4(), l = A(i), u = A(l), f = X(A(u), 2), p = A(f), c = X(f, 2);
      He(c, {
        variant: "outline",
        size: "sm",
        id: "error-button",
        class: "!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
        onclick: () => {
          var h, g;
          d(a).type === "FirstElementNotFound" ? (h = t.guideMachineRef) == null || h.send({ type: "RELOAD" }) : (g = t.guideMachineRef) == null || g.send({ type: "BACK" });
        },
        children: (h, g) => {
          var _ = h4(), b = A(_);
          $(() => Me(b, d(a).type === "FirstElementNotFound" ? "Reload" : "Back")), z(h, _);
        },
        $$slots: { default: !0 }
      }), $(() => Me(p, d(a).message)), xt(1, l, () => ha, () => ({ start: 0.95, duration: 300 })), xt(1, i, () => oi, () => ({ y: 20, duration: 300 })), z(s, i);
    };
    B(n, (s) => {
      var i;
      (i = t.guideMachineContext) != null && i.matches("error") && s(o);
    });
  }
  z(e, r), xe();
}
var _4 = /* @__PURE__ */ St('<svg><path d="M18.0006 8.00042C18.0006 8.19933 17.9216 8.39009 17.7809 8.53075C17.6403 8.6714 17.4495 8.75042 17.2506 8.75042H2.5609L8.03122 14.2198C8.1009 14.2895 8.15617 14.3722 8.19389 14.4632C8.2316 14.5543 8.25101 14.6519 8.25101 14.7504C8.25101 14.849 8.2316 14.9465 8.19389 15.0376C8.15617 15.1286 8.1009 15.2114 8.03122 15.281C7.96153 15.3507 7.87881 15.406 7.78776 15.4437C7.69672 15.4814 7.59914 15.5008 7.50059 15.5008C7.40204 15.5008 7.30446 15.4814 7.21342 15.4437C7.12237 15.406 7.03965 15.3507 6.96996 15.281L0.219965 8.53104C0.150233 8.46139 0.0949134 8.37867 0.0571702 8.28762C0.019427 8.19657 0 8.09898 0 8.00042C0 7.90185 0.019427 7.80426 0.0571702 7.71321C0.0949134 7.62216 0.150233 7.53945 0.219965 7.46979L6.96996 0.719792C7.1107 0.579062 7.30157 0.5 7.50059 0.5C7.69961 0.5 7.89048 0.579062 8.03122 0.719792C8.17195 0.860522 8.25101 1.05139 8.25101 1.25042C8.25101 1.44944 8.17195 1.64031 8.03122 1.78104L2.5609 7.25042H17.2506C17.4495 7.25042 17.6403 7.32943 17.7809 7.47009C17.9216 7.61074 18.0006 7.8015 18.0006 8.00042Z"></path></svg>');
function hc(e, t) {
  let a = R(t, "class", 3, "fill-none text-[#6F5FEC]"), r = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var n = _4();
  let o;
  $(() => o = at(
    n,
    o,
    {
      viewBox: "0 0 18 16",
      class: a(),
      ...r,
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, n);
}
function w4(e, t) {
  ke(t, !0);
  let a = R(t, "ref", 15, null), r = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class"
  ]);
  var n = K(), o = D(n), s = /* @__PURE__ */ M(() => Oe("fixed inset-0 z-[9990] bg-black/30  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", t.class));
  Xe(o, () => j2, (i, l) => {
    l(i, it(
      {
        get class() {
          return d(s);
        }
      },
      () => r,
      {
        get ref() {
          return a();
        },
        set ref(u) {
          a(u);
        }
      }
    ));
  }), z(e, n), xe();
}
var v4 = /* @__PURE__ */ L('<!> <p class="!layup-sr-only">Close</p>', 1), b4 = /* @__PURE__ */ L("<!> <!>", 1), k4 = /* @__PURE__ */ L("<!> <!>", 1);
function dm(e, t) {
  ke(t, !0);
  let a = R(t, "ref", 15, null), r = R(t, "hideCloseButton", 3, !1), n = R(t, "hideOverlay", 3, !1), o = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class",
    "children",
    "hideCloseButton",
    "hideOverlay"
  ]);
  var s = K(), i = D(s);
  Xe(i, () => x4, (l, u) => {
    u(l, {
      children: (f, p) => {
        var c = k4(), h = D(c);
        {
          var g = (m) => {
            var w = K(), S = D(w);
            Xe(S, () => w4, (C, v) => {
              v(C, {
                class: "layup-fixed layup-inset-0 layup-z-[9999999] layup-bg-black/50"
              });
            }), z(m, w);
          };
          B(h, (m) => {
            n() || m(g);
          });
        }
        var _ = X(h, 2), b = /* @__PURE__ */ M(() => Oe("layup-sm:layup-rounded-lg layup-fixed layup-left-[50%] layup-top-[50%] layup-z-[9999999] layup-grid layup-w-full layup-max-w-lg layup-translate-x-[-50%] layup-translate-y-[-50%] layup-gap-4 layup-border layup-bg-background layup-p-6 layup-shadow-xl !layup-backdrop-blur-md layup-duration-300 data-[state=open]:layup-animate-in data-[state=closed]:layup-animate-out data-[state=closed]:layup-fade-out-0 data-[state=open]:layup-fade-in-0 data-[state=closed]:layup-zoom-out-95 data-[state=open]:layup-zoom-in-95 data-[state=closed]:layup-slide-out-to-left-1/2 data-[state=closed]:layup-slide-out-to-top-[48%] data-[state=open]:layup-slide-in-from-left-1/2 data-[state=open]:layup-slide-in-from-top-[48%]", t.class));
        Xe(_, () => c3, (m, w) => {
          w(m, it(
            {
              get class() {
                return d(b);
              }
            },
            () => o,
            {
              get ref() {
                return a();
              },
              set ref(S) {
                a(S);
              },
              children: (S, C) => {
                var v = b4(), y = D(v);
                nt(y, () => t.children ?? qe);
                var k = X(y, 2);
                {
                  var x = (T) => {
                    var F = K(), P = D(F);
                    Xe(P, () => s3, (O, I) => {
                      I(O, {
                        class: "data-[state=open]:layup-bg-accentdata-[state=open]:layup-text-muted-foreground !layup-absolute !layup-right-4 !layup-top-4 !layup-rounded-sm !layup-opacity-70 !layup-ring-offset-background !layup-transition-opacity hover:!layup-opacity-100 focus:!layup-outline-none focus:!layup-ring-2 focus:!layup-ring-ring focus:!layup-ring-offset-2 disabled:!layup-pointer-events-none",
                        children: (E, N) => {
                          var H = v4(), Y = D(H);
                          Ra(Y, { class: "layup-size-4" }), z(E, H);
                        },
                        $$slots: { default: !0 }
                      });
                    }), z(T, F);
                  };
                  B(k, (T) => {
                    r() || T(x);
                  });
                }
                z(S, v);
              },
              $$slots: { default: !0 }
            }
          ));
        }), z(f, c);
      },
      $$slots: { default: !0 }
    });
  }), z(e, s), xe();
}
const fm = n3, x4 = Fg;
var z4 = /* @__PURE__ */ L('<p class="layup-flex layup-items-center layup-text-base"> </p>');
function Bp(e, t) {
  ke(t, !0);
  let a = R(t, "variant", 3, "default");
  function r(o) {
    const s = "!layup-h-8 !layup-items-center !layup-justify-center !layup-gap-[4px] !layup-rounded-button-inner !layup-border-[0px]  !layup-bg-accent !layup-px-2 !layup-py-1 !layup-text-base !layup-text-accent-text !layup-duration-200 hover:!layup-bg-accent-secondary dark:hover:!layup-bg-accent-secondary hover:!layup-text-accent-text hover:!layup-opacity-90  dark:!layup-bg-accent", i = "!layup-pointer-events-auto !layup-h-8 !layup-w-fit !layup-rounded-button-inner !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-bg-background-secondary layup-text-base";
    switch (o) {
      case "default":
        return s;
      case "secondary":
        return i;
      default:
        return s;
    }
  }
  var n = /* @__PURE__ */ M(() => r(a()));
  He(e, {
    onclick: (o) => {
      o.preventDefault(), o.stopPropagation(), t.onclick();
    },
    get class() {
      return d(n);
    },
    children: (o, s) => {
      var i = z4(), l = A(i);
      $(() => Me(l, t.text)), z(o, i);
    },
    $$slots: { default: !0 }
  }), xe();
}
var S4 = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-full !layup-min-h-[200px] !layup-w-full !layup-items-center !layup-justify-center !layup-rounded-sm !layup-bg-transparent"><div class="!layup-text-center !layup-text-primary"><p class="!layup-flex !layup-items-center !layup-justify-center !layup-gap-1"> </p></div></div>');
function pm(e, t) {
  var a = S4(), r = A(a), n = A(r), o = A(n);
  $(() => Me(o, t.title)), z(e, a);
}
var C4 = (e, t, a) => t(a()), E4 = /* @__PURE__ */ L('<div class="layup-h-2 layup-w-2 layup-shrink-0 layup-rounded-full layup-bg-accent"></div>'), A4 = /* @__PURE__ */ L('<div class="layup-flex layup-h-fit layup-w-full layup-items-center layup-justify-start layup-rounded-sm layup-text-primary"><p class="!layup-shrink-0 !layup-text-left !layup-text-sm !layup-text-secondary"> </p></div>'), T4 = /* @__PURE__ */ L('<button><div><div class="!layup-flex !layup-w-full !layup-flex-col layup-justify-between !layup-bg-transparent !layup-p-4"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-center !layup-gap-3"><div class="!layup-w-full !layup-flex !layup-flex-col"><div class="!layup-flex !layup-w-full !layup-items-center layup-justify-start !layup-gap-2"><!> <h3 class="!layup-line-clamp-2 layup-text-wrap layup-text-left !layup-text-base !layup-font-medium !layup-text-primary"> </h3></div> <!></div> <div class="!layup-w-full"><p class="!layup-line-clamp-2 !layup-w-full !layup-text-wrap !layup-break-words !layup-text-left !layup-text-sm !layup-leading-relaxed !layup-text-primary"> </p></div> <div class="!layup-flex !layup-w-full !layup-flex-row-reverse !layup-justify-between !layup-gap-2"><!> <!></div></div></div></div></button>'), P4 = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <p class="layup-text-base">Back</p></div>'), O4 = /* @__PURE__ */ L('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), M4 = /* @__PURE__ */ L('<div class="layup-custom-scrollbar !layup-flex !layup-h-full !layup-flex-col !layup-gap-3 !layup-overflow-y-auto !layup-overscroll-contain !layup-p-default !layup-pt-0"><div class="!layup-flex !layup-h-full !layup-flex-col !layup-gap-section"><div class="!layup-flex !layup-h-[30px] !layup-w-full !layup-items-center !layup-justify-between"><h2 class="!layup-text-2xl !layup-font-medium !layup-leading-none !layup-text-primary">Announcements</h2></div> <div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-col !layup-gap-item"><!> <!> <div class="layup-py-[1px]"></div></div></div></div>'), I4 = /* @__PURE__ */ L('<p class="!layup-text-sm !layup-text-secondary"> </p>'), F4 = /* @__PURE__ */ L('<div type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></div>'), j4 = (e, t, a) => t("video", d(a).template_announcement.image), R4 = /* @__PURE__ */ L('<video autoplay loop playsinline="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-cover"><source type="video/mp4"></video>', 2), L4 = /* @__PURE__ */ L('<div class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></div>'), D4 = /* @__PURE__ */ L('<div class="layup-bg-background-secondary/50 layup-flex layup-h-[200px] layup-w-full layup-items-center layup-justify-center layup-overflow-hidden layup-rounded-lg"><!></div>'), N4 = /* @__PURE__ */ L('<p class="layup-flex layup-items-center">Show me</p>'), V4 = /* @__PURE__ */ L('<div class="layup-flex layup-h-full layup-w-full layup-flex-1 layup-flex-col layup-bg-background layup-p-default !layup-pt-0"><div class="layup-custom-scrollbars layup-flex layup-w-full layup-flex-1 layup-flex-col layup-overflow-y-auto !layup-gap-section"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-2"><h2 class="!layup-line-clamp-2 !layup-text-wrap !layup-text-xl !layup-font-semibold !layup-text-primary"> </h2> <!></div> <div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-center !layup-justify-center layup-gap-2"><!> <p class="layup-custom-scrollbars !layup-max-h-[200px] !layup-w-full !layup-overflow-y-auto !layup-text-wrap !layup-break-words !layup-text-left !layup-text-base !layup-leading-relaxed !layup-text-primary"> </p></div> <!></div></div>'), q4 = (e) => e.stopPropagation(), B4 = /* @__PURE__ */ L('<img alt="" class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-object-contain layup-shadow-2xl">'), W4 = (e) => e.stopPropagation(), H4 = /* @__PURE__ */ L('<video autoplay controls class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-shadow-2xl"><source type="video/mp4"> <track kind="captions" src="" label="English captions"></video>', 2), U4 = /* @__PURE__ */ L('<div><div class="!layup-flex !layup-h-fit !layup-w-full !layup-items-center !layup-justify-between !layup-p-default"><!> <!></div> <!></div> <!>', 1);
function G4(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = (P, O = qe) => {
    var I = T4();
    Ue(I, "!layup-flex !layup-h-fit !layup-w-full !layup-flex-col layup-items-start !layup-rounded-inner !layup-border !layup-border-border hover:!layup-border-accent-bg hover:!layup-bg-accent-bg"), I.__click = [C4, p, O];
    var E = A(I);
    const N = /* @__PURE__ */ M(() => Oe("layup-group !layup-flex !layup-w-full !layup-items-start !layup-rounded-button-outer !layup-border !layup-border-background-secondary !layup-text-primary hover:!layup-text-primary"));
    var H = A(E), Y = A(H), V = A(Y), U = A(V), ee = A(U);
    {
      var W = (se) => {
        var ye = E4();
        z(se, ye);
      };
      B(ee, (se) => {
        O().isSeenFeature || se(W);
      });
    }
    var G = X(ee, 2), J = A(G), te = X(U, 2);
    {
      var ae = (se) => {
        var ye = A4(), ge = A(ye), ue = A(ge);
        $(() => {
          var _e, Se;
          return Me(ue, new Date(((Se = (_e = O()) == null ? void 0 : _e.template_announcement) == null ? void 0 : Se.created_at) * 1e3).toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric"
          }));
        }), z(se, ye);
      };
      B(te, (se) => {
        var ye, ge;
        (ge = (ye = O()) == null ? void 0 : ye.template_announcement) != null && ge.created_at && se(ae);
      });
    }
    var ie = X(V, 2), oe = A(ie), Q = A(oe), le = X(ie, 2), he = A(le);
    Bp(he, {
      text: "Show me",
      onclick: () => {
        t.send({ type: "run", item: O() });
      }
    });
    var pe = X(he, 2);
    Bp(pe, {
      text: "Read more",
      onclick: () => p(O()),
      variant: "secondary"
    }), $(() => {
      var se, ye, ge, ue;
      Ue(E, d(N)), Me(J, (ye = (se = O()) == null ? void 0 : se.template_announcement) == null ? void 0 : ye.title), Me(Q, (ue = (ge = O()) == null ? void 0 : ge.template_announcement) == null ? void 0 : ue.description);
    }), z(P, I);
  };
  let o = /* @__PURE__ */ M(() => {
    var P;
    return (P = r().context.features) == null ? void 0 : P.sort((O, I) => O.state.status === "NotStarted" && I.state.status !== "NotStarted" ? -1 : O.state.status !== "NotStarted" && I.state.status === "NotStarted" ? 1 : 0);
  }), s = me(null), i = me(!1), l = me(ce({ type: "", url: "" }));
  const u = /* @__PURE__ */ M(() => {
    var P, O, I;
    return !((P = r().context.metadata) != null && P.is_guidance_active) && !((O = r().context.metadata) != null && O.is_onboarding_active) && ((I = r().context.metadata) == null ? void 0 : I.is_announcement_active);
  }), f = /* @__PURE__ */ M(() => {
    var P;
    return (P = r().context.theme) == null ? void 0 : P.icons;
  }), p = (P) => {
    q(s, ce(P)), t.send({ type: "openFeature", item: P });
  }, c = (P, O) => {
    q(l, ce({ type: P, url: O })), q(i, !0);
  }, h = () => {
    q(i, !1);
  };
  var g = U4(), _ = D(g);
  const b = /* @__PURE__ */ M(() => Oe("!layup-flex  !layup-w-full !layup-flex-col !layup-bg-background", r().matches({ features: "open_new_feature" }) ? "!layup-h-full" : "!layup-h-[455px]"));
  var m = A(_), w = A(m);
  {
    var S = (P) => {
      He(P, {
        variant: "ghost",
        size: "sm",
        class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
        get onclick() {
          return t.onTerminate;
        },
        children: (O, I) => {
          var E = P4(), N = A(E);
          hc(N, { class: "!layup-size-4" }), z(O, E);
        },
        $$slots: { default: !0 }
      });
    }, C = (P) => {
      var O = K(), I = D(O);
      {
        var E = (H) => {
          var Y = O4(), V = D(Y), U = A(V);
          At(U, () => {
            var G, J, te;
            return (te = (J = (G = d(f)) == null ? void 0 : G.logo) == null ? void 0 : J.dark_mode) == null ? void 0 : te.xml;
          });
          var ee = X(V, 2), W = A(ee);
          At(W, () => {
            var G, J, te;
            return (te = (J = (G = d(f)) == null ? void 0 : G.logo) == null ? void 0 : J.light_mode) == null ? void 0 : te.xml;
          }), z(H, Y);
        }, N = (H) => {
          rr(H, { class: "!layup-size-6" });
        };
        B(
          I,
          (H) => {
            var Y, V, U;
            (U = (V = (Y = d(f)) == null ? void 0 : Y.logo) == null ? void 0 : V.dark_mode) != null && U.xml ? H(E) : H(N, !1);
          },
          !0
        );
      }
      z(P, O);
    };
    B(w, (P) => {
      d(u) ? P(C, !1) : P(S);
    });
  }
  var v = X(w, 2);
  He(v, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onClose;
    },
    children: (P, O) => {
      Ra(P, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var y = X(m, 2);
  {
    var k = (P) => {
      var O = M4(), I = A(O), E = X(A(I), 2), N = A(E);
      et(N, 19, () => d(o), (V) => V.id, (V, U, ee) => {
        n(V, () => ({
          ...d(U),
          index: d(ee),
          isLast: d(ee) === d(o).length - 1,
          isSeenFeature: d(U).state.status !== "NotStarted"
        }));
      });
      var H = X(N, 2);
      {
        var Y = (V) => {
          pm(V, { title: "No new updates" });
        };
        B(H, (V) => {
          d(o).length === 0 && V(Y);
        });
      }
      z(P, O);
    }, x = (P) => {
      var O = V4(), I = A(O), E = A(I), N = A(E), H = A(N), Y = X(N, 2);
      {
        var V = (ae) => {
          var ie = I4(), oe = A(ie);
          $(() => {
            var Q, le;
            return Me(oe, new Date(((le = (Q = d(s)) == null ? void 0 : Q.template_announcement) == null ? void 0 : le.created_at) * 1e3).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric"
            }));
          }), z(ae, ie);
        };
        B(Y, (ae) => {
          var ie, oe;
          (oe = (ie = d(s)) == null ? void 0 : ie.template_announcement) != null && oe.created_at && ae(V);
        });
      }
      var U = X(E, 2), ee = A(U);
      {
        var W = (ae) => {
          var ie = D4(), oe = A(ie);
          {
            var Q = (he) => {
              var pe = F4(), se = A(pe);
              $(() => be(se, "src", d(s).template_announcement.image)), z(he, pe);
            }, le = (he) => {
              var pe = K(), se = D(pe);
              {
                var ye = (ue) => {
                  var _e = R4();
                  _e.muted = !0, _e.__click = [j4, c, s];
                  var Se = A(_e);
                  $(() => be(Se, "src", d(s).template_announcement.image)), z(ue, _e);
                }, ge = (ue) => {
                  var _e = L4(), Se = A(_e);
                  $(() => be(Se, "src", d(s).template_announcement.image)), z(ue, _e);
                };
                B(
                  se,
                  (ue) => {
                    d(s).template_announcement.image.endsWith(".mp4") ? ue(ye) : ue(ge, !1);
                  },
                  !0
                );
              }
              z(he, pe);
            };
            B(oe, (he) => {
              d(s).template_announcement.image.endsWith(".svg") ? he(Q) : he(le, !1);
            });
          }
          z(ae, ie);
        };
        B(ee, (ae) => {
          var ie, oe;
          (oe = (ie = d(s)) == null ? void 0 : ie.template_announcement) != null && oe.image && ae(W);
        });
      }
      var G = X(ee, 2), J = A(G), te = X(U, 2);
      He(te, {
        variant: "ghost",
        type: "button",
        onclick: () => {
          t.send({ type: "run", item: d(s) });
        },
        class: "layup-h-8 !layup-w-full !layup-items-center !layup-justify-center !layup-rounded-button-outer !layup-border-none !layup-bg-accent !layup-px-3 !layup-py-1.5 !layup-text-sm !layup-text-white/90 !layup-duration-200 hover:!layup-bg-accent-secondary hover:!layup-text-white hover:!layup-opacity-90",
        children: (ae, ie) => {
          var oe = N4();
          z(ae, oe);
        },
        $$slots: { default: !0 }
      }), $(() => {
        var ae, ie, oe, Q;
        Me(H, (ie = (ae = d(s)) == null ? void 0 : ae.template_announcement) == null ? void 0 : ie.title), Me(J, (Q = (oe = d(s)) == null ? void 0 : oe.template_announcement) == null ? void 0 : Q.description);
      }), z(P, O);
    };
    B(y, (P) => {
      r().matches({ features: "open_new_feature" }) ? P(x, !1) : P(k);
    });
  }
  var T = X(_, 2);
  {
    var F = (P) => {
      var O = K(), I = D(O);
      Xe(I, () => fm, (E, N) => {
        N(E, {
          get open() {
            return d(i);
          },
          controlledOpen: !0,
          onOpenChange: (H) => {
            var Y;
            (Y = H == null ? void 0 : H.stopPropagation) == null || Y.call(H), q(i, !d(i));
          },
          children: (H, Y) => {
            var V = K(), U = D(V);
            Xe(U, () => dm, (ee, W) => {
              W(ee, {
                trapFocus: !1,
                hideCloseButton: !0,
                class: "layup-feature !layup-left-1/2 !layup-top-1/2 !layup-z-[999999999] !layup-m-0 !layup-w-fit layup-translate-x-[-50%] layup-translate-y-[-50%] !layup-cursor-pointer !layup-border-none !layup-bg-transparent !layup-p-0 focus:layup-outline-none",
                onclick: (G) => {
                  G.stopPropagation(), h();
                },
                onkeydown: (G) => {
                  G.key === "Escape" && (G.stopPropagation(), h());
                },
                children: (G, J) => {
                  var te = K(), ae = D(te);
                  {
                    var ie = (Q) => {
                      var le = B4();
                      le.__click = [q4], $(() => be(le, "src", d(l).url)), z(Q, le);
                    }, oe = (Q) => {
                      var le = K(), he = D(le);
                      {
                        var pe = (se) => {
                          var ye = H4();
                          ye.__click = [W4];
                          var ge = A(ye);
                          $(() => be(ge, "src", d(l).url)), z(se, ye);
                        };
                        B(
                          he,
                          (se) => {
                            d(l).type === "video" && se(pe);
                          },
                          !0
                        );
                      }
                      z(Q, le);
                    };
                    B(ae, (Q) => {
                      d(l).type === "image" ? Q(ie) : Q(oe, !1);
                    });
                  }
                  z(G, te);
                },
                $$slots: { default: !0 }
              });
            }), z(H, V);
          },
          $$slots: { default: !0 }
        });
      }), z(P, O);
    };
    B(T, (P) => {
      d(i) && P(F);
    });
  }
  $(() => Ue(_, d(b))), z(e, g), xe();
}
nr(["click"]);
var K4 = /* @__PURE__ */ L('<p class="animated-letter !layup-font-light !layup-text-primary dark:!layup-text-primary svelte-s3fx26"> </p>'), Z4 = /* @__PURE__ */ L("<div></div>");
function Y4(e, t) {
  ke(t, !0);
  let a = [];
  Da(() => {
    const n = () => {
      const i = a.filter((p) => p.textContent !== " "), l = 50, u = 300, f = i.length * l + u;
      return i.forEach((p) => {
        p.style.transform = "translateY(0)", p.style.opacity = "0.7", p.style.textShadow = "0 0 5px rgba(255, 255, 255, 0.3)";
      }), i.forEach((p, c) => {
        setTimeout(
          () => {
            p.style.transform = "translateY(-2px)", p.style.opacity = "1", p.style.textShadow = "0 0 8px rgba(255, 255, 255, 0.8)", setTimeout(
              () => {
                p.style.transform = "translateY(0)", p.style.opacity = "0.7", p.style.textShadow = "0 0 5px rgba(255, 255, 255, 0.3)";
              },
              u
            );
          },
          c * l
        );
      }), f + 200;
    };
    let o = n();
    const s = setInterval(
      () => {
        o = n();
      },
      o
    );
    return () => clearInterval(s);
  });
  var r = Z4();
  et(r, 21, () => {
    var n;
    return (n = t.text) == null ? void 0 : n.split("");
  }, yt, (n, o, s) => {
    var i = K4(), l = A(i);
    aa(i, (u, f) => a[f] = u, (u) => a == null ? void 0 : a[u], () => [s]), $(() => {
      be(i, "style", `display: ${(d(o) === " " ? "inline" : "inline-block") ?? ""}`), Me(l, d(o));
    }), z(n, i);
  }), $(() => {
    Ue(r, `layup-relative layup-z-50 !layup-w-full !layup-rounded-lg !layup-text-base
    !layup-font-light !layup-text-primary dark:!layup-text-primary ${t.padding ?? ""} svelte-s3fx26`), be(r, "style", `background-color: ${t.backgroundColor ?? ""}; text-align: ${t.textAlign ?? ""}`);
  }), z(e, r), xe();
}
var X4 = /* @__PURE__ */ St('<svg><path d="M11 17V5.414l3.293 3.293a.999.999 0 101.414-1.414l-5-5a.999.999 0 00-1.414 0l-5 5a.997.997 0 000 1.414.999.999 0 001.414 0L9 5.414V17a1 1 0 102 0z"></path></svg>');
function Dd(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "fill"]);
  var r = X4();
  let n;
  $(() => n = at(
    r,
    n,
    {
      ...a,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var J4 = /* @__PURE__ */ L("<textarea></textarea>");
function ym(e, t) {
  ke(t, !0);
  let a = R(t, "ref", 15, null), r = R(t, "value", 15), n = R(t, "initialHeight", 3, 20), o = R(t, "resizeVertical", 3, !1), s = R(t, "submitOnEnter", 3, void 0), i = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "value",
    "class",
    "initialHeight",
    "resizeVertical",
    "submitOnEnter"
  ]);
  const l = (_, b) => {
    const m = (w) => {
      _.style.height = `${n()}px`;
      const S = parseInt(getComputedStyle(_).paddingTop) + parseInt(getComputedStyle(_).paddingBottom), C = _.scrollHeight - S;
      _.style.height = C + "px";
    };
    return b && _.addEventListener("input", m), {
      update(w) {
        b && _.removeEventListener("input", m), w && _.addEventListener("input", m), b = w;
      },
      destroy() {
        b && _.removeEventListener("input", m);
      }
    };
  }, u = (_, b) => {
    const m = (w) => {
      if (w.key === "Enter" && !w.shiftKey) {
        w.preventDefault();
        const S = document.getElementById(b ?? "");
        S && S.dispatchEvent(new Event("submit", { cancelable: !0 }));
      }
    };
    return b && _.addEventListener("keydown", m), {
      update(w) {
        b && _.removeEventListener("keydown", m), w && _.addEventListener("keydown", m), b = w;
      },
      destroy() {
        _.removeEventListener("keydown", m);
      }
    };
  };
  var f = J4(), p = (_) => {
    var b;
    (b = _ == null ? void 0 : _.target) == null || b.focus(), _.stopPropagation();
  }, c = (_) => {
    _.stopPropagation();
  }, h = (_) => {
    _.stopPropagation();
  };
  let g;
  aa(f, (_) => a(_), () => a()), lo(() => Q_(f, r)), Qc(f, (_, b) => l == null ? void 0 : l(_, b), o), Qc(f, (_, b) => u == null ? void 0 : u(_, b), s), $(() => g = at(f, g, {
    onfocus: p,
    onmousedown: c,
    onpointerdown: h,
    class: Oe("focus-visible:outline-none layup-flex layup-w-full layup-resize-none layup-rounded-md layup-border layup-border-input layup-bg-transparent layup-px-3 layup-py-2 layup-shadow-sm placeholder:!layup-text-muted-foreground disabled:layup-cursor-not-allowed disabled:layup-opacity-50", t.class),
    ...i
  })), z(e, f), xe();
}
var Q4 = /* @__PURE__ */ L('<div class="!layup-flex layup-max-h-[56px] !layup-min-w-full !layup-items-center !layup-justify-center !layup-rounded-b-sm !layup-border-t-[1px] !layup-border-border !layup-p-default"><form id="layup-ai-form"><!> <div><!></div> <!></form></div>');
function $4(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a);
  let n = me(""), o = me(!1), s, i = me(void 0);
  Pe(() => {
    var b;
    r().matches("query") && ((b = document.getElementById("layup-ai-form-input")) == null || b.focus());
  });
  const l = (b) => {
    b.altKey && b.code === "KeyH" && t.send({ type: "history" });
  }, u = (b) => {
    b.preventDefault(), d(n).trim() !== "" && (t.send({
      type: "request",
      userMessages: d(n)
    }), q(n, ""), q(o, !0), setTimeout(
      () => {
        q(o, !1);
      },
      100
    ));
  }, f = (b) => {
    b.preventDefault(), b.stopPropagation(), r().context.messages.length === 0 && t.send({ type: "search", query: d(n) });
  };
  let p = /* @__PURE__ */ M(() => r().context.messages);
  const c = L1(f, 1e3), h = /* @__PURE__ */ M(() => r().matches({ thinking: "getQuery" }));
  var g = K(), _ = D(g);
  zr(_, () => d(o), (b) => {
    var m = Q4(), w = A(m);
    const S = /* @__PURE__ */ M(() => Oe("!layup-mx-auto !layup-flex !layup-h-[56px] !layup-w-full !layup-flex-row !layup-items-center !layup-gap-1 !layup-rounded-lg !layup-p-0", !(r().matches("query") || r().matches({ thinking: "getQuery" }) || r().matches("loadingWidgetData.loadingQueries")) && "!layup-hidden"));
    var C = A(w);
    {
      var v = (E) => {
        var N = /* @__PURE__ */ M(() => Oe("!layup-flex !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-start !layup-rounded-sm !layup-bg-transparent !layup-fill-secondary hover:!layup-bg-background  hover:!layup-fill-primary"));
        He(E, {
          variant: "ghost",
          size: "icon",
          get class() {
            return d(N);
          },
          onclick: () => {
            r().context.isHistory ? t.send({ type: "goToHistory" }) : (t.send({ type: "esc" }), t.send({ type: "terminate" }));
          },
          children: (H, Y) => {
            hc(H, { class: "!layup-size-4 " });
          },
          $$slots: { default: !0 }
        });
      };
      B(C, (E) => {
        var N;
        ((N = d(p)) == null ? void 0 : N.length) > 0 && E(v);
      });
    }
    var y = X(C, 2);
    const k = /* @__PURE__ */ M(() => Oe("!layup-flex layup-h-14 !layup-flex-1 !layup-items-center !layup-justify-between !layup-rounded-lg !layup-bg-transparent !layup-p-1 !layup-transition-[width] !layup-duration-300 !layup-ease-in-out"));
    var x = A(y), T = /* @__PURE__ */ M(() => Oe("!layup-mb-2 !layup-mt-2 !layup-max-h-12 !layup-min-h-[24px] !layup-w-full !layup-resize-none !layup-overflow-y-auto !layup-rounded-none !layup-border-none !layup-bg-transparent !layup-text-base !layup-text-primary layup-caret-primary !layup-shadow-none placeholder:!layup-pl-[1px] placeholder:!layup-text-base placeholder:!layup-text-secondary focus-visible:!layup-outline-none focus-visible:!layup-ring-0")), F = /* @__PURE__ */ M(() => d(h) || r().matches("loadingWidgetData.loadingQueries"));
    aa(
      ym(x, {
        id: "layup-ai-form-input",
        onkeydown: l,
        get ref() {
          return s;
        },
        placeholder: "How can Layup guide you?",
        get class() {
          return d(T);
        },
        autofocus: !0,
        resizeVertical: !0,
        rows: 1,
        oninput: c,
        submitOnEnter: "layup-ai-form",
        get disabled() {
          return d(F);
        },
        get value() {
          return d(n);
        },
        set value(E) {
          q(n, ce(E));
        }
      }),
      (E) => q(i, ce(E)),
      () => d(i)
    );
    var P = X(y, 2), O = /* @__PURE__ */ M(() => Oe(" !layup-flex !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-center !layup-rounded-button-outer !layup-border-accent !layup-bg-accent !layup-fill-accent-text hover:!layup-bg-accent-secondary disabled:!layup-border-none disabled:!layup-bg-background-secondary disabled:!layup-fill-secondary dark:disabled:!layup-bg-background-secondary", d(h) && "!layup-cursor-not-allowed !layup-opacity-50")), I = /* @__PURE__ */ M(() => d(n).length === 0 || d(h));
    He(P, {
      variant: "default",
      size: "icon",
      get class() {
        return d(O);
      },
      type: "submit",
      get disabled() {
        return d(I);
      },
      children: (E, N) => {
        Dd(E, { class: "!layup-size-5" });
      },
      $$slots: { default: !0 }
    }), $(() => {
      Ue(w, d(S)), Ue(y, d(k));
    }), pt("submit", w, u), z(b, m);
  }), z(e, g), xe();
}
var Tu = /* @__PURE__ */ ((e) => (e.KNOWLEDGE = "knowledge", e))(Tu || {});
const e9 = {
  knowledge: [
    "is_onboarding_active",
    "is_announcement_active",
    "is_guidance_active"
    /* GUIDANCE */
  ]
}, Wp = (e, t) => e ? e9[t].every((r) => e[r] === !0) : !1;
var t9 = /* @__PURE__ */ L('<div class="confetti svelte-15ksp55"></div>'), a9 = /* @__PURE__ */ L('<div class="confetti-holder svelte-15ksp55"></div>');
function r9(e, t) {
  ke(t, !0);
  const a = R(t, "size", 3, 10), r = R(t, "x", 19, () => [-0.5, 0.5]), n = R(t, "y", 19, () => [0.25, 1]), o = R(t, "duration", 3, 2e3), s = R(t, "infinite", 3, !1), i = R(t, "delay", 19, () => [0, 50]), l = R(t, "colorRange", 19, () => [0, 360]), u = R(t, "colorArray", 19, () => []), f = R(t, "amount", 3, 50), p = R(t, "iterationCount", 3, 1), c = R(t, "fallDistance", 3, "100px"), h = R(t, "rounded", 3, !1), g = R(t, "cone", 3, !1), _ = R(t, "noGravity", 3, !1), b = R(t, "xSpread", 3, 0.15), m = R(t, "destroyOnComplete", 3, !0), w = R(t, "disableForReducedMotion", 3, !1);
  let S = me(!1);
  Da(() => {
    !m() || s() || typeof p() == "string" || setTimeout(() => q(S, !0), (o() + i()[1]) * p());
  });
  function C(T, F) {
    return Math.random() * (F - T) + T;
  }
  function v() {
    return u().length ? u()[Math.round(Math.random() * (u().length - 1))] : `hsl(${Math.round(C(l()[0], l()[1]))}, 75%, 50%)`;
  }
  var y = K(), k = D(y);
  {
    var x = (T) => {
      var F = a9();
      et(F, 21, () => ({ length: f() }), yt, (P, O) => {
        var I = t9();
        const E = /* @__PURE__ */ M(() => v() ?? ""), N = /* @__PURE__ */ M(() => C(-45, 45) ?? ""), H = /* @__PURE__ */ M(() => C(-45, 45) ?? ""), Y = /* @__PURE__ */ M(() => C(-10, 10) ?? ""), V = /* @__PURE__ */ M(() => C(-10, 10) ?? ""), U = /* @__PURE__ */ M(() => C(-10, 10) ?? ""), ee = /* @__PURE__ */ M(() => C(0, 360) ?? ""), W = /* @__PURE__ */ M(() => C(n()[0], n()[1]) ?? ""), G = /* @__PURE__ */ M(() => C(r()[0], r()[1]) ?? ""), J = /* @__PURE__ */ M(() => 0.1 * C(2, 10)), te = /* @__PURE__ */ M(() => C(i()[0], i()[1]) ?? ""), ae = /* @__PURE__ */ M(() => (s() ? `calc(${o()}ms * var(--scale))` : `${o()}ms`) ?? ""), ie = /* @__PURE__ */ M(() => `
        --color: ${d(E)};
        --skew: ${d(N)}deg,${d(H)}deg;
        --rotation-xyz: ${d(Y)}, ${d(V)}, ${d(U)};
        --rotation-deg: ${d(ee)}deg;
        --translate-y-multiplier: ${d(W)};
        --translate-x-multiplier: ${d(G)};
        --scale: ${d(J)};
        --transition-delay: ${d(te)}ms;
        --transition-duration: ${d(ae)};`);
        $(() => be(I, "style", d(ie))), z(P, I);
      }), $(() => {
        be(F, "style", `
    --fall-distance: ${c() ?? ""};
    --size: ${a() ?? ""}px;
    --x-spread: ${1 - b()};
    --transition-iteration-count: ${(s() ? "infinite" : p()) ?? ""};`), ci(F, "rounded", h()), ci(F, "cone", g()), ci(F, "no-gravity", _()), ci(F, "reduced-motion", w());
      }), z(T, F);
    };
    B(k, (T) => {
      d(S) || T(x);
    });
  }
  z(e, y), xe();
}
function n9(e) {
  const t = e - 1;
  return t * t * t + 1;
}
function o9(e, { from: t, to: a }, r = {}) {
  var n = getComputedStyle(e), o = s9(e), s = n.transform === "none" ? "" : n.transform, [i, l] = n.transformOrigin.split(" ").map(parseFloat), u = t.width / a.width, f = t.height / a.height, p = (t.left + u * i - (a.left + i)) / o, c = (t.top + f * l - (a.top + l)) / o, { delay: h = 0, duration: g = (b) => Math.sqrt(b) * 120, easing: _ = n9 } = r;
  return {
    delay: h,
    duration: typeof g == "function" ? g(Math.sqrt(p * p + c * c)) : g,
    easing: _,
    css: (b, m) => {
      var w = m * p, S = m * c, C = b + m * u, v = b + m * f;
      return `transform: ${s} scale(${C}, ${v}) translate(${w}px, ${S}px);`;
    }
  };
}
function s9(e) {
  if ("currentCSSZoom" in e)
    return (
      /** @type {number} */
      e.currentCSSZoom
    );
  for (var t = e, a = 1; t !== null; )
    a *= +getComputedStyle(t).zoom, t = /** @type {Element | null} */
    t.parentElement;
  return a;
}
const i9 = (e) => {
  var t = c9();
  z(e, t);
}, l9 = (e) => {
  var t = u9();
  z(e, t);
};
var c9 = /* @__PURE__ */ L('<div class="layup-relative layup-h-3 layup-w-3 layup-overflow-hidden layup-rounded-[4px] !layup-border-[0px] !layup-border-accent !layup-bg-accent layup-outline-none"><div class="layup-absolute layup-inset-0 layup-rounded-[4px] layup-border layup-border-accent layup-bg-accent layup-transition-all layup-duration-300 hover:layup-bg-accent"></div></div>'), u9 = /* @__PURE__ */ L('<div class="layup-relative layup-h-3 layup-w-3 layup-overflow-hidden layup-rounded-[4px] !layup-border !layup-border-accent-secondary"><div class="layup-absolute layup-inset-0 layup-rounded-[4px] layup-border layup-border-accent layup-bg-accent-bg"></div></div>'), d9 = /* @__PURE__ */ L('<div class="!layup-relative !layup-h-3 !layup-w-3 !layup-rounded-[4px] !layup-bg-background-secondary layup-transition-transform" role="progressbar" aria-valuemin="1"><!></div>'), f9 = /* @__PURE__ */ L('<div class="layup-flex layup-w-fit layup-items-center layup-justify-center layup-gap-2 layup-overflow-hidden layup-px-1 layup-py-2"></div>');
function Hp(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => Math.max(0, Math.min(t.currentStep - 2, t.totalBars - 5))), r = /* @__PURE__ */ M(() => Math.min(d(a) + 5, t.totalBars));
  const n = { duration: 300, delay: 0 }, o = { duration: 250 }, s = {
    duration: 300,
    x: 16
    // Slightly reduced for more subtle movement
  };
  var i = f9();
  et(i, 31, () => Array(t.totalBars).slice(d(a), d(r)), (l, u) => u + d(a), (l, u, f) => {
    var p = d9();
    const c = /* @__PURE__ */ M(() => d(f) === 0), h = /* @__PURE__ */ M(() => d(f) === d(r) - d(a) - 1), g = /* @__PURE__ */ M(() => d(f) + d(a));
    var _ = A(p);
    {
      var b = (w) => {
        l9(w);
      }, m = (w) => {
        var S = K(), C = D(S);
        {
          var v = (y) => {
            i9(y);
          };
          B(
            C,
            (y) => {
              d(g) < t.currentStep && y(v);
            },
            !0
          );
        }
        z(w, S);
      };
      B(_, (w) => {
        d(g) === t.currentStep ? w(b) : w(m, !1);
      });
    }
    $(() => {
      be(p, "aria-valuenow", d(g) + 1), be(p, "aria-valuemax", t.totalBars), be(p, "aria-label", `Step ${d(g) + 1} of ${t.totalBars}`);
    }), pt("mouseenter", p, () => d(g)), pt("mouseleave", p, () => -1), J_(p, () => o9, () => n), xt(1, p, () => Cu, () => d(h) ? s : void 0), xt(2, p, () => al, () => d(c) ? o : void 0), z(l, p);
  }), z(e, i), xe();
}
var p9 = /* @__PURE__ */ L('<p class="layup-text-base layup-text-accent-text !layup-font-button">Next</p>'), y9 = /* @__PURE__ */ L('<p class="layup-text-button layup-text-primary !layup-font-button">Ask</p>'), h9 = /* @__PURE__ */ L('<p class="layup-text-button layup-text-primary !layup-font-button">Close</p>'), g9 = /* @__PURE__ */ L("<!> <!>", 1), m9 = /* @__PURE__ */ L('<div class="layup-absolute layup-left-1/2 layup-top-1/2 layup-translate-x-[-50%] layup-translate-y-[-50%] layup-transform"><!></div>'), _9 = /* @__PURE__ */ L('<div class="layup-w-[100px] !layup-flex layup-items-center layup-justify-center !layup-overflow-hidden"><!></div> <div class="layup-min-w-[80px] layup-select-none layup-text-center layup-text-items layup-text-primary layup-font-items" style="-webkit-user-select: none;"> </div>', 1), w9 = /* @__PURE__ */ L("<!> All done!", 1), v9 = /* @__PURE__ */ L('<p class="layup-text-button">Finish</p>'), b9 = /* @__PURE__ */ L('<p class="layup-text-button !layup-font-button"><!></p>'), k9 = /* @__PURE__ */ L('<div class="!layup-pointer-events-none layup-flex layup-h-fit layup-items-center layup-justify-between layup-gap-2 layup-px-controller-horizontal layup-py-controller-vertical layup-text-center layup-text-base layup-font-medium layup-text-primary"><div class="layup-flex layup-items-center layup-gap-2 layup-w-[120px]"><!></div> <!> <div class="layup-flex layup-items-center layup-justify-center layup-gap-4 layup-text-items"><!></div> <div class="layup-flex layup-items-center"><!></div></div>');
function x9(e, t) {
  var S, C;
  ke(t, !0);
  const a = /* @__PURE__ */ M(() => {
    var v, y;
    return ((y = (v = t.guideMachineContext) == null ? void 0 : v.context) == null ? void 0 : y.currentStepIndex) || 0;
  }), r = /* @__PURE__ */ M(() => {
    var v;
    return ((v = t.guideMachineContext) == null ? void 0 : v.can({ type: "LAST_STEP" })) ?? !1;
  });
  let n = me(!1);
  Pe(() => {
    var v;
    (v = t.guideMachineContext) != null && v.matches("completed") && q(n, !0);
  });
  const o = /* @__PURE__ */ M(() => {
    var v, y;
    return ((y = (v = t.guideMachineContext) == null ? void 0 : v.context) == null ? void 0 : y.steps.length) || 0;
  });
  console.log(Wp((C = (S = t.guideMachineContext) == null ? void 0 : S.context) == null ? void 0 : C.metadata, Tu.KNOWLEDGE));
  var s = k9(), i = A(s), l = A(i);
  zr(l, () => {
    var v, y;
    return (y = (v = t.guideMachineContext) == null ? void 0 : v.context) == null ? void 0 : y.metadata;
  }, (v) => {
    var y = g9(), k = D(y);
    {
      var x = (P) => {
        var O = /* @__PURE__ */ M(() => {
          var E;
          return !((E = t.guideMachineContext) != null && E.can({ type: "NEXT_STEP" }));
        }), I = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border-[1px] !layup-border-accent !layup-bg-accent !layup-p-2 !layup-shadow-none   hover:layup-bg-accent-secondary hover:!layup-no-underline"));
        He(P, {
          get disabled() {
            return d(O);
          },
          variant: "outline",
          get class() {
            return d(I);
          },
          onclick: (E) => {
            var N;
            E.preventDefault(), E.stopPropagation(), (N = t.guideMachineRef) == null || N.send({ type: "NEXT_STEP" });
          },
          children: (E, N) => {
            var H = p9();
            z(E, H);
          },
          $$slots: { default: !0 }
        });
      };
      B(k, (P) => {
        var O;
        !d(n) && !((O = t.guideMachineContext) != null && O.can({ type: "LAST_STEP" })) && P(x);
      });
    }
    var T = X(k, 2);
    {
      var F = (P) => {
        var O = K(), I = D(O);
        {
          var E = (H) => {
            var Y = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 layup-w-14 !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none hover:!layup-bg-background-secondary"));
            He(H, {
              variant: "outline",
              get class() {
                return d(Y);
              },
              onclick: (V) => {
                var U;
                V.preventDefault(), V.stopPropagation(), (U = t.guideMachineRef) == null || U.send({ type: "SHOW_KNOWLEDGE" });
              },
              children: (V, U) => {
                var ee = y9();
                z(V, ee);
              },
              $$slots: { default: !0 }
            });
          }, N = (H) => {
            var Y = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 layup-w-14 !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none hover:!layup-bg-background-secondary"));
            He(H, {
              variant: "outline",
              get class() {
                return d(Y);
              },
              onclick: (V) => {
                var U;
                V.preventDefault(), V.stopPropagation(), (U = t.guideMachineRef) == null || U.send({ type: "HIDE_KNOWLEDGE" });
              },
              children: (V, U) => {
                var ee = h9();
                z(V, ee);
              },
              $$slots: { default: !0 }
            });
          };
          B(I, (H) => {
            var Y, V;
            (V = (Y = t.guideMachineContext) == null ? void 0 : Y.context) != null && V.showKnowledge ? H(N, !1) : H(E);
          });
        }
        z(P, O);
      };
      B(T, (P) => {
        var O, I;
        Wp((I = (O = t.guideMachineContext) == null ? void 0 : O.context) == null ? void 0 : I.metadata, Tu.KNOWLEDGE) && P(F);
      });
    }
    z(v, y);
  });
  var u = X(i, 2);
  {
    var f = (v) => {
      var y = m9(), k = A(y);
      r9(k, {
        x: [-0.5, 0.5],
        y: [-0.5, 0.5],
        size: 5
      }), z(v, y);
    };
    B(u, (v) => {
      d(n) && v(f);
    });
  }
  var p = X(u, 2), c = A(p);
  {
    var h = (v) => {
      var y = _9(), k = D(y), x = A(k), T = /* @__PURE__ */ M(() => {
        var I, E;
        return d(o) > 1 ? d(o) : ((E = (I = t.guideMachineContext) == null ? void 0 : I.context) == null ? void 0 : E.progressSteps[0]) || 1;
      }), F = /* @__PURE__ */ M(() => {
        var I, E;
        return d(o) > 1 ? d(a) : ((E = (I = t.guideMachineContext) == null ? void 0 : I.context) == null ? void 0 : E.currentActionsMap.length) - 1;
      });
      Hp(x, {
        get totalBars() {
          return d(T);
        },
        get currentStep() {
          return d(F);
        }
      });
      var P = X(k, 2), O = A(P);
      $(() => {
        var I, E, N, H, Y, V, U, ee;
        return Me(O, (((E = (I = t.guideMachineContext) == null ? void 0 : I.context) == null ? void 0 : E.progressSteps[0]) || 1) - (((H = (N = t.guideMachineContext) == null ? void 0 : N.context) == null ? void 0 : H.currentActionsMap.length) || 0) === 0 ? "Last step!" : `${(((V = (Y = t.guideMachineContext) == null ? void 0 : Y.context) == null ? void 0 : V.progressSteps[0]) || 1) - (((ee = (U = t.guideMachineContext) == null ? void 0 : U.context) == null ? void 0 : ee.currentActionsMap.length) - 1 || 0)} steps left`);
      }), z(v, y);
    }, g = (v) => {
      var y = w9(), k = D(y), x = /* @__PURE__ */ M(() => {
        var F, P;
        return (P = (F = t.guideMachineContext) == null ? void 0 : F.context) == null ? void 0 : P.progressSteps[0];
      }), T = /* @__PURE__ */ M(() => {
        var F, P;
        return (P = (F = t.guideMachineContext) == null ? void 0 : F.context) == null ? void 0 : P.progressSteps[0];
      });
      Hp(k, {
        get totalBars() {
          return d(x);
        },
        get currentStep() {
          return d(T);
        }
      }), z(v, y);
    };
    B(c, (v) => {
      d(n) ? v(g, !1) : v(h);
    });
  }
  var _ = X(p, 2), b = A(_);
  {
    var m = (v) => {
      var y = /* @__PURE__ */ M(() => Oe("!layup-pointer-events-auto !layup-h-8 layup-w-fit !layup-rounded-button-outer !layup-border-[1px] !layup-border-accent !layup-text-accent-text !layup-bg-accent !layup-p-2 !layup-shadow-none   hover:!layup-bg-accent-secondary hover:!layup-no-underline"));
      He(v, {
        variant: "ghost",
        size: "sm",
        get class() {
          return d(y);
        },
        onclick: (k) => {
          var x, T;
          k.preventDefault(), k.stopPropagation(), d(n) ? (T = t.guideMachineRef) == null || T.send({ type: "EXIT" }) : (x = t.guideMachineRef) == null || x.send({ type: "TERMINATE" });
        },
        children: (k, x) => {
          var T = v9();
          z(k, T);
        },
        $$slots: { default: !0 }
      });
    }, w = (v) => {
      var y = /* @__PURE__ */ M(() => Oe(" !layup-pointer-events-auto !layup-h-8 !layup-rounded-button-outer !layup-p-2 !layup-text-primary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-background-secondary hover:!layup-text-primary hover:!layup-ease-in-out dark:hover:!layup-bg-background-secondary", d(n) ? "!layup-pointer-events-auto layup-w-fit !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary" : ""));
      He(v, {
        variant: "ghost",
        size: "sm",
        get class() {
          return d(y);
        },
        onclick: (k) => {
          var x, T;
          k.preventDefault(), k.stopPropagation(), d(n) ? (T = t.guideMachineRef) == null || T.send({ type: "EXIT" }) : (x = t.guideMachineRef) == null || x.send({ type: "TERMINATE" });
        },
        children: (k, x) => {
          var T = b9(), F = A(T);
          {
            var P = (I) => {
              var E = Xn("Finish");
              z(I, E);
            }, O = (I) => {
              var E = Xn("Exit");
              z(I, E);
            };
            B(F, (I) => {
              d(n) ? I(O, !1) : I(P);
            });
          }
          z(k, T);
        },
        $$slots: { default: !0 }
      });
    };
    B(b, (v) => {
      d(r) ? v(m) : v(w, !1);
    });
  }
  z(e, s), xe();
}
var z9 = /* @__PURE__ */ L('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), S9 = /* @__PURE__ */ L('<p class="!layup-text-sm !layup-text-primary"> </p>'), C9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-4 layup-rounded-md layup-bg-background !layup-p-6 !layup-pb-1"><div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div> <div class="!layup-flex !layup-flex-col !layup-gap-0.5"><h2 class="!layup-text-xl !layup-font-semibold !layup-text-primary"> </h2> <!></div></div>');
function E9(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = /* @__PURE__ */ M(() => {
    var w;
    return (w = r().context.theme) == null ? void 0 : w.icons;
  });
  let o = /* @__PURE__ */ M(() => t.features.filter((w) => w.state.status === "NotStarted").sort((w, S) => {
    var C, v;
    return (((C = S.template_announcement) == null ? void 0 : C.created_at) || 0) - (((v = w.template_announcement) == null ? void 0 : v.created_at) || 0);
  })[0]);
  var s = C9(), i = A(s), l = A(i), u = A(l);
  {
    var f = (w) => {
      var S = z9(), C = D(S), v = A(C);
      At(v, () => {
        var x, T, F;
        return (F = (T = (x = d(n)) == null ? void 0 : x.logo) == null ? void 0 : T.dark_mode) == null ? void 0 : F.xml;
      });
      var y = X(C, 2), k = A(y);
      At(k, () => {
        var x, T, F;
        return (F = (T = (x = d(n)) == null ? void 0 : x.logo) == null ? void 0 : T.light_mode) == null ? void 0 : F.xml;
      }), z(w, S);
    }, p = (w) => {
      rr(w, { class: "!layup-size-6" });
    };
    B(u, (w) => {
      var S, C, v;
      (v = (C = (S = d(n)) == null ? void 0 : S.logo) == null ? void 0 : C.dark_mode) != null && v.xml ? w(f) : w(p, !1);
    });
  }
  var c = X(l, 2);
  He(c, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (w, S) => {
      Ra(w, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var h = X(i, 2), g = A(h), _ = A(g), b = X(g, 2);
  {
    var m = (w) => {
      var S = S9(), C = A(S);
      $(() => Me(C, new Date(d(o).template_announcement.created_at * 1e3).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      }))), z(w, S);
    };
    B(b, (w) => {
      var S, C;
      (C = (S = d(o)) == null ? void 0 : S.template_announcement) != null && C.created_at && w(m);
    });
  }
  $(() => {
    var w, S;
    return Me(_, (S = (w = d(o)) == null ? void 0 : w.template_announcement) == null ? void 0 : S.title);
  }), z(e, s), xe();
}
var A9 = /* @__PURE__ */ L('<p class="layup-text-base layup-text-primary !layup-font-button">Show</p>'), T9 = /* @__PURE__ */ L('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-outer !layup-border !layup-border-border !layup-bg-background layup-p-2 layup-shadow-sm"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-inner !layup-bg-accent layup-text-sm layup-font-medium !layup-text-accent-text"><p class="layup-text-base !layup-font-items">!</p></div> <p class=" layup-text-base layup-font-items layup-text-primary">The guide text is hidden</p> <!></div></div></div>');
function P9(e, t) {
  ke(t, !0);
  const a = /* @__PURE__ */ M(() => {
    var o;
    return (o = t.guideMachineContext) == null ? void 0 : o.can({ type: "SHOW_TEXT" });
  });
  var r = K(), n = D(r);
  zr(n, () => d(a), (o) => {
    var s = K(), i = D(s);
    {
      var l = (u) => {
        var f = T9(), p = A(f), c = A(p), h = X(A(c), 4);
        He(h, {
          variant: "outline",
          size: "sm",
          class: "!layup-pointer-events-auto !layup-h-8 layup-w-14 !layup-rounded-button-outer !layup-border !layup-border-border !layup-bg-background !layup-p-2 !layup-shadow-none !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-scale-105 hover:!layup-bg-background-secondary",
          onclick: () => {
            var g;
            (g = t.guideMachineRef) == null || g.send({ type: "SHOW_TEXT" });
          },
          children: (g, _) => {
            var b = A9();
            z(g, b);
          },
          $$slots: { default: !0 }
        }), xt(5, p, () => ha, () => ({ start: 0.95, duration: 300 })), xt(5, f, () => oi, () => ({ y: 20, duration: 300 })), z(u, f);
      };
      B(i, (u) => {
        d(a) && u(l);
      });
    }
    z(o, s);
  }), z(e, r), xe();
}
var O9 = /* @__PURE__ */ L("<div></div>");
function Et(e, t) {
  const a = Dt(t, [
    "children",
    "$$slots",
    "$$events",
    "$$legacy"
  ]), r = Dt(a, ["class"]);
  ke(t, !1);
  let n = R(t, "class", 8, void 0);
  ca();
  var o = O9();
  let s;
  $(() => s = at(o, s, {
    class: Oe("layup-animate-pulse layup-rounded-md layup-bg-accent-secondary", n()),
    ...r
  })), z(e, o), xe();
}
var M9 = (e, t, a) => t.send({ type: "openHistory", item: a() }), I9 = /* @__PURE__ */ L('<div class="!layup-rounded-sm layup-text-left !layup-text-secondary"><p class="!layup-text-sm"> </p></div>'), F9 = /* @__PURE__ */ L('<button class="group layup-group !layup-flex !layup-flex-row !layup-items-center !layup-justify-between !layup-gap-1 !layup-rounded-inner !layup-border !layup-border-border !layup-bg-transparent !layup-p-3 !layup-transition-all !layup-duration-300 hover:!layup-border-accent-bg hover:!layup-bg-accent-bg"><div class="!layup-flex !layup-flex-col !layup-gap-1"><h3 class="layup-text-left !layup-text-base !layup-font-medium !layup-text-primary"> </h3> <!></div> <div class="!layup-flex !layup-w-fit !layup-items-center !layup-gap-2 !layup-opacity-0 !layup-transition-opacity !layup-duration-200 group-hover:!layup-opacity-100"><!></div></button>'), j9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <p class="layup-text-base">Back</p></div>'), R9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-2 !layup-rounded-lg !layup-border !layup-border-background-secondary !layup-p-3"><div class="!layup-flex !layup-flex-col !layup-gap-2"><!> <!></div></div>'), L9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-4"></div>'), D9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-1 !layup-items-center !layup-justify-center"><!></div>'), N9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-flex-1 !layup-flex-col !layup-gap-item !layup-pb-custom"></div>'), V9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-full layup-max-h-[455px] layup-min-h-[455px] !layup-w-full !layup-flex-col !layup-rounded-lg !layup-bg-background"><div class="!layup-flex !layup-h-fit !layup-w-full !layup-items-center !layup-justify-between !layup-p-default"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div> <div><div class="!layup-flex !layup-flex-col !layup-gap-1"><h2 class="!layup-text-2xl !layup-font-medium !layup-text-primary">History</h2></div> <!></div></div>');
function q9(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = (m, w = qe, S = qe) => {
    var C = F9();
    C.__click = [M9, t, w];
    var v = A(C), y = A(v), k = A(y), x = X(y, 2);
    {
      var T = (O) => {
        var I = I9(), E = A(I), N = A(E);
        $(() => Me(N, new Date(w().created_at * 1e3).toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        }))), z(O, I);
      };
      B(x, (O) => {
        w().created_at && O(T);
      });
    }
    var F = X(v, 2), P = A(F);
    He(P, {
      size: "icon",
      variant: "ghost",
      onclick: () => t.send({ type: "delete", id: w().id }),
      class: "!layup-item-center !layup-pointer-events-auto !layup-flex !layup-justify-center !layup-rounded-button-inner !layup-border-[1px] !layup-border-red-600 !layup-bg-red-600 !layup-text-gray-700 !layup-transition-transform !layup-duration-200 !layup-ease-in-out hover:!layup-bg-red-700 hover:!layup-text-gray-900 hover:!layup-no-underline dark:!layup-border-red-600 dark:!layup-bg-red-600 dark:!layup-text-primary dark:hover:!layup-bg-red-700 dark:hover:!layup-text-primary",
      children: (O, I) => {
        _5(O, {
          class: "layup-h-4 layup-w-4 layup-stroke-white"
        });
      },
      $$slots: { default: !0 }
    }), $(() => Me(k, w().query)), z(m, C);
  };
  let o = /* @__PURE__ */ M(() => r().context.history), s;
  var i = V9(), l = A(i), u = A(l), f = A(u);
  He(f, {
    variant: "ghost",
    size: "sm",
    class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onTerminate;
    },
    children: (m, w) => {
      var S = j9(), C = A(S);
      hc(C, { class: "!layup-size-4" }), z(m, S);
    },
    $$slots: { default: !0 }
  });
  var p = X(u, 2);
  He(p, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    get onclick() {
      return t.onClose;
    },
    children: (m, w) => {
      Ra(m, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var c = X(l, 2);
  const h = /* @__PURE__ */ M(() => Oe("layup-custom-scrollbar !layup-flex !layup-h-full !layup-flex-1 !layup-flex-col !layup-gap-section !layup-overflow-y-auto !layup-overscroll-contain !layup-p-default !layup-duration-300 !layup-pt-0"));
  var g = X(A(c), 2);
  {
    var _ = (m) => {
      var w = L9();
      et(w, 20, () => Array(2), yt, (S, C) => {
        var v = R9(), y = A(v), k = A(y);
        Et(k, {
          class: "!layup-h-5 !layup-w-[300px] layup-bg-secondary "
        });
        var x = X(k, 2);
        Et(x, {
          class: "!layup-h-4 !layup-w-[150px] layup-bg-secondary "
        }), z(S, v);
      }), z(m, w);
    }, b = (m) => {
      var w = K(), S = D(w);
      {
        var C = (y) => {
          var k = D9(), x = A(k);
          pm(x, { title: "No history available" }), z(y, k);
        }, v = (y) => {
          var k = N9();
          et(k, 23, () => [...d(o)], (x) => x.id, (x, T, F) => {
            n(x, () => d(T), () => d(F));
          }), z(y, k);
        };
        B(
          S,
          (y) => {
            d(o).length === 0 ? y(C) : y(v, !1);
          },
          !0
        );
      }
      z(m, w);
    };
    B(g, (m) => {
      t.isLoading ? m(_) : m(b, !1);
    });
  }
  aa(c, (m) => s = m, () => s), $(() => Ue(c, d(h))), z(e, i), xe();
}
nr(["click"]);
var B9 = /* @__PURE__ */ St('<svg><path d="M7.00044 0.5C5.87823 0.499755 4.77508 0.790055 3.79835 1.34264C2.82162 1.89523 2.0046 2.69128 1.4268 3.65331C0.849003 4.61534 0.530118 5.71058 0.501185 6.83241C0.472251 7.95425 0.734254 9.06446 1.26169 10.055L0.552317 12.1831C0.493558 12.3593 0.48503 12.5484 0.527691 12.7292C0.570351 12.9099 0.662514 13.0753 0.793849 13.2066C0.925184 13.3379 1.0905 13.4301 1.27127 13.4728C1.45204 13.5154 1.64112 13.5069 1.81732 13.4481L3.94544 12.7388C4.81717 13.2024 5.78308 13.4614 6.76983 13.496C7.75659 13.5306 8.73827 13.34 9.64036 12.9386C10.5424 12.5372 11.3412 11.9355 11.9761 11.1793C12.6109 10.4231 13.0651 9.53218 13.3043 8.57421C13.5434 7.61624 13.5611 6.61638 13.3561 5.65052C13.1512 4.68467 12.7288 3.77821 12.1212 2.99995C11.5136 2.22169 10.7367 1.59208 9.84938 1.15891C8.96211 0.725743 7.98781 0.500405 7.00044 0.5ZM7.00044 12.5C6.03355 12.5007 5.08363 12.246 4.24669 11.7619C4.18541 11.7263 4.11729 11.7042 4.04682 11.697C3.97635 11.6898 3.90515 11.6976 3.83794 11.72L1.50044 12.5L2.27982 10.1625C2.30228 10.0953 2.31022 10.0242 2.30311 9.95369C2.296 9.88323 2.274 9.81507 2.23857 9.75375C1.6323 8.70557 1.38889 7.48661 1.54609 6.28598C1.70329 5.08534 2.25231 3.97014 3.108 3.11337C3.96368 2.2566 5.07819 1.70617 6.27863 1.54745C7.47906 1.38873 8.69833 1.63061 9.74727 2.23555C10.7962 2.8405 11.6162 3.77469 12.08 4.89322C12.5439 6.01175 12.6256 7.25208 12.3126 8.42181C11.9996 9.59153 11.3093 10.6253 10.3488 11.3626C9.3883 12.1 8.21133 12.4998 7.00044 12.5Z"></path></svg>');
function W9(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "class"]);
  var r = B9();
  let n;
  $(() => n = at(
    r,
    n,
    {
      class: t.class,
      ...a,
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var H9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-flex-row !layup-items-center !layup-justify-end"><div class="!layup-flex !layup-max-w-[70%] !layup-justify-end"><div class="layup-flex !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center !layup-whitespace-pre-wrap !layup-break-words !layup-rounded-inner !layup-border !layup-border-border layup-bg-background !layup-p-2 !layup-text-sm !layup-font-medium !layup-text-primary dark:!layup-border-border"><p class="!layup-m-0 !layup-w-full !layup-whitespace-pre-wrap !layup-break-words !layup-text-base !layup-font-normal"> </p></div></div></div>'), U9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-item"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-inner !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-sm !layup-font-medium layup-text-primary"><!></div></div></div>'), G9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-item"><div class="!layup-flex !layup-w-fit !layup-max-w-[80%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] !layup-w-fit !layup-max-w-full layup-flex-col layup-items-center layup-justify-center layup-rounded-inner !layup-border !layup-border-accent-secondary !layup-bg-accent-bg !layup-p-2 !layup-text-sm !layup-font-medium layup-text-primary"><!></div></div></div>'), K9 = /* @__PURE__ */ L('<div class="!layup-flex !layup-flex-col !layup-gap-2"><div class="!layup-flex !layup-w-fit !layup-max-w-[90%] !layup-flex-col !layup-justify-start"><div class="layup-relative layup-flex !layup-min-h-[40px] layup-max-w-sm layup-items-center layup-justify-center layup-rounded-inner !layup-border !layup-border-border !layup-bg-accent-bg !layup-px-3 !layup-py-2 !layup-text-sm !layup-font-medium layup-text-accent dark:!layup-border-accent-secondary"><!></div></div></div>'), Z9 = /* @__PURE__ */ L('<div class="!layup-scrollbar-thin !layup-scrollbar-track-transparent hover:!layup-scrollbar-thumb-gray-400 dark:!layup-scrollbar-thumb-gray-600 dark:hover:!layup-scrollbar-thumb-gray-500 layup-custom-scrollbar !layup-max-h-[300px] !layup-w-full !layup-flex-1 !layup-overflow-y-auto !layup-p-default"><div class="!layup-w-full"><div class="!layup-flex !layup-flex-col !layup-gap-item"><!> <!></div></div></div>'), Y9 = (e, t, a) => {
  var r;
  (r = t.guideMachineRef) == null || r.send({
    type: "sendTipsMessage",
    data: d(a)
  });
}, X9 = /* @__PURE__ */ L('<button class="layup-w-full"><div class="layup-group layup-flex layup-h-10 layup-w-full layup-cursor-pointer layup-items-center !layup-gap-item !layup-border !layup-border-transparent layup-px-2 hover:!layup-bg-accent-bg !layup-rounded-button-inner"><!> <p class="layup-text-base layup-font-medium layup-text-primary group-hover:layup-text-primary"> </p></div></button>'), J9 = /* @__PURE__ */ L('<div class="!layup-w-full !layup-overflow-hidden !layup-border-t !layup-border-border"><div class="layup-flex !layup-h-fit layup-w-full layup-flex-col layup-items-center !layup-gap-item  !layup-p-default"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Suggestions</p></div> <!></div></div>'), Q9 = /* @__PURE__ */ L('<div class="layup-chat-container !layup-relative !layup-mb-2 !layup-flex layup-w-full !layup-flex-col !layup-items-center layup-justify-center !layup-overflow-hidden !layup-rounded-outer !layup-border !layup-border-border !layup-bg-background"><!> <div><form id="layup-ai-form" class="!layup-mx-auto !layup-flex !layup-h-[56px] !layup-w-full !layup-flex-row !layup-items-center !layup-gap-2 !layup-rounded-lg !layup-p-0"><div class="!layup-flex !layup-flex-1 !layup-items-center"><!></div> <!></form></div> <!></div>');
function $9(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => {
    var x, T;
    return (T = (x = t.guideMachineContext) == null ? void 0 : x.context) == null ? void 0 : T.knowledgeMessage;
  }), r = me(void 0), n = me(""), o = /* @__PURE__ */ M(() => {
    var x, T;
    return (T = (x = t.guideMachineContext) == null ? void 0 : x.context) == null ? void 0 : T.knowledgeFetching;
  }), s = me(void 0);
  const i = () => {
    d(r) && requestAnimationFrame(() => {
      var x;
      (x = d(r)) == null || x.scrollTo({
        top: d(r).scrollHeight,
        behavior: "smooth"
      });
    });
  }, l = () => {
    var x, T, F;
    (x = d(n)) != null && x.trim() && ((T = t.guideMachineRef) == null || T.send({
      type: "sendKnowledgeMessage",
      data: d(n)
    }), q(n, ""), (F = d(s)) != null && F.element && (d(s).element.style.height = "24px"), i());
  }, u = (x) => {
    x.preventDefault(), l();
  };
  let f = /* @__PURE__ */ M(() => {
    var x, T, F, P, O;
    return (O = (P = (x = t.guideMachineContext) == null ? void 0 : x.context) == null ? void 0 : P.currentActionsMap[((F = (T = t.guideMachineContext) == null ? void 0 : T.context) == null ? void 0 : F.currentActionsMap.length) - 1]) == null ? void 0 : O.tips;
  });
  Pe(() => {
    var x, T, F;
    ((x = d(a)) != null && x.length || (F = (T = t.guideMachineContext) == null ? void 0 : T.context) != null && F.knowledgeFetching) && setTimeout(i, 50);
  }), Pe(() => {
    setTimeout(i, 50);
  });
  var p = Q9(), c = A(p);
  {
    var h = (x) => {
      var T = Z9(), F = A(T), P = A(F), O = A(P);
      et(O, 17, () => d(a), yt, (N, H, Y) => {
        var V = K(), U = D(V);
        {
          var ee = (G) => {
            var J = H9(), te = A(J), ae = A(te), ie = A(ae), oe = A(ie);
            $(() => Me(oe, d(H).content)), z(G, J);
          }, W = (G) => {
            var J = K(), te = D(J);
            {
              var ae = (oe) => {
                var Q = U9(), le = A(Q), he = A(le), pe = A(he), se = /* @__PURE__ */ M(() => d(H).content.trim());
                sl(pe, {
                  get responseContent() {
                    return d(se);
                  }
                }), z(oe, Q);
              }, ie = (oe) => {
                var Q = K(), le = D(Q);
                {
                  var he = (pe) => {
                    var se = G9(), ye = A(se), ge = A(ye), ue = A(ge), _e = /* @__PURE__ */ M(() => d(H).content.trim());
                    sl(ue, {
                      get responseContent() {
                        return d(_e);
                      }
                    }), z(pe, se);
                  };
                  B(
                    le,
                    (pe) => {
                      var se, ye;
                      ((se = d(H)) == null ? void 0 : se.role) === "assistant" && Y === ((ye = d(a)) == null ? void 0 : ye.length) - 1 && pe(he);
                    },
                    !0
                  );
                }
                z(oe, Q);
              };
              B(
                te,
                (oe) => {
                  var Q, le;
                  ((Q = d(H)) == null ? void 0 : Q.role) === "assistant" && Y !== ((le = d(a)) == null ? void 0 : le.length) - 1 ? oe(ae) : oe(ie, !1);
                },
                !0
              );
            }
            z(G, J);
          };
          B(U, (G) => {
            d(H).role === "user" ? G(ee) : G(W, !1);
          });
        }
        z(N, V);
      });
      var I = X(O, 2);
      {
        var E = (N) => {
          var H = K9(), Y = A(H), V = A(Y), U = A(V);
          kg(U, {
            text: "Thinking...",
            textAlign: "left",
            textColor: "text-primary",
            padding: "!layup-p-0"
          }), xt(5, H, () => Cu, () => ({ duration: 200, delay: 0 })), z(N, H);
        };
        B(I, (N) => {
          var H, Y;
          (Y = (H = t.guideMachineContext) == null ? void 0 : H.context) != null && Y.knowledgeFetching && N(E);
        });
      }
      aa(T, (N) => q(r, N), () => d(r)), pt("introend", F, i), xt(5, F, () => Cu, () => ({ duration: 400, delay: 0 })), z(x, T);
    };
    B(c, (x) => {
      var T;
      ((T = d(a)) == null ? void 0 : T.length) > 0 && x(h);
    });
  }
  var g = X(c, 2);
  const _ = /* @__PURE__ */ M(() => {
    var x;
    return `${Oe("!layup-flex layup-min-h-[56px] !layup-min-w-full !layup-items-center !layup-justify-center !layup-rounded-b-sm !layup-border-border !layup-px-custom !layup-cursor-default", ((x = d(a)) == null ? void 0 : x.length) > 0 ? "!layup-border-t-[1px]" : "") ?? ""} svelte-su32hh`;
  });
  var b = A(g), m = A(b), w = A(m), S = /* @__PURE__ */ M(() => Oe("!layup-mb-2 !layup-mt-2 !layup-h-[24px] !layup-w-full !layup-resize-none !layup-overflow-y-auto !layup-rounded-none !layup-border-none !layup-bg-transparent !layup-text-base !layup-text-primary layup-caret-primary !layup-shadow-none placeholder:!layup-pl-[1px] placeholder:!layup-text-base placeholder:!layup-text-secondary focus-visible:!layup-outline-none focus-visible:!layup-ring-0"));
  aa(
    ym(w, {
      id: "layup-ai-form-input",
      placeholder: "Tell me what's you're looking for",
      get class() {
        return d(S);
      },
      rows: 1,
      get disabled() {
        return d(o);
      },
      autofocus: !0,
      resizeVertical: !0,
      onkeydown: (x) => {
        x.key === "Enter" && !x.shiftKey && (x.preventDefault(), l());
      },
      get value() {
        return d(n);
      },
      set value(x) {
        q(n, ce(x));
      }
    }),
    (x) => q(s, ce(x)),
    () => d(s)
  );
  var C = X(m, 2), v = /* @__PURE__ */ M(() => {
    var x;
    return ((x = d(n)) == null ? void 0 : x.trim()) === "" || d(o);
  });
  He(C, {
    variant: "default",
    size: "icon",
    class: "!layup-flex-shrink-0 !layup-h-[32px] !layup-w-[32px] !layup-items-center !layup-justify-center !layup-rounded-button-outer !layup-border-accent !layup-bg-accent !layup-fill-accent-text hover:!layup-bg-accent-secondary disabled:!layup-border-none disabled:!layup-bg-background-secondary disabled:!layup-fill-secondary dark:disabled:!layup-bg-background-secondary",
    type: "submit",
    get disabled() {
      return d(v);
    },
    children: (x, T) => {
      Dd(x, { class: "!layup-size-5" });
    },
    $$slots: { default: !0 }
  });
  var y = X(g, 2);
  {
    var k = (x) => {
      var T = J9(), F = A(T), P = X(A(F), 2);
      et(P, 17, () => d(f), yt, (O, I) => {
        var E = X9();
        E.__click = [Y9, t, I];
        var N = A(E), H = A(N);
        W9(H, {
          class: "!layup-size-4 !layup-fill-secondary group-hover:!layup-fill-secondary"
        });
        var Y = X(H, 2), V = A(Y);
        $(() => Me(V, d(I).title)), z(O, E);
      }), z(x, T);
    };
    B(y, (x) => {
      var T, F, P, O;
      ((T = d(f)) == null ? void 0 : T.length) > 0 && ((O = (P = (F = t.guideMachineContext) == null ? void 0 : F.context) == null ? void 0 : P.knowledgeMessage) == null ? void 0 : O.length) === 0 && x(k);
    });
  }
  $(() => Ue(g, d(_))), pt("submit", b, u), z(e, p), xe();
}
nr(["click"]);
var e6 = /* @__PURE__ */ L('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), t6 = (e, t, a) => t("video", d(a).template_announcement.image), a6 = /* @__PURE__ */ L('<video autoplay loop playsinline="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-cover"><source type="video/mp4"></video>', 2), r6 = (e, t, a) => t("image", d(a).template_announcement.image), n6 = /* @__PURE__ */ L('<button type="button" class="layup-h-full layup-w-full"><img alt="" class="layup-h-full layup-w-full layup-cursor-pointer layup-rounded-lg layup-object-contain"></button>'), o6 = /* @__PURE__ */ L('<div class="layup-bg-background-secondary/50 layup-flex layup-h-[200px] layup-w-full layup-items-center layup-justify-center layup-overflow-hidden layup-rounded-lg"><!></div>'), s6 = /* @__PURE__ */ L('<div class="layup-flex layup-items-center">Show me</div>'), i6 = (e) => e.stopPropagation(), l6 = /* @__PURE__ */ L('<img alt="" class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-object-contain layup-shadow-2xl">'), c6 = (e) => e.stopPropagation(), u6 = /* @__PURE__ */ L('<video autoplay controls class="layup-h-auto layup-max-h-[85vh] layup-w-auto layup-max-w-[85vw] layup-rounded-lg layup-shadow-2xl"><source type="video/mp4"> <track kind="captions" src="" label="English captions"></video>', 2), d6 = /* @__PURE__ */ L('<div class="layup-flex !layup-h-full layup-w-full layup-flex-col !layup-gap-3 layup-rounded-b-lg layup-bg-background layup-p-6 !layup-pt-3"><div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-col layup-justify-between !layup-gap-3"><!> <p class="!layup-w-full !layup-text-wrap !layup-break-words !layup-text-left !layup-text-sm !layup-leading-relaxed !layup-text-primary"> </p> <!></div></div> <!>', 1);
function f6(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => t.features.filter((m) => m.state.status === "NotStarted").sort((m, w) => {
    var S, C;
    return (((S = w.template_announcement) == null ? void 0 : S.created_at) || 0) - (((C = m.template_announcement) == null ? void 0 : C.created_at) || 0);
  })[0]), r = me(!1), n = me(ce({ type: "", url: "" }));
  const o = (m, w) => {
    q(n, ce({ type: m, url: w })), q(r, !0);
  }, s = () => {
    q(r, !1);
  };
  var i = d6(), l = D(i), u = A(l), f = A(u);
  {
    var p = (m) => {
      var w = o6(), S = A(w);
      {
        var C = (y) => {
          var k = e6(), x = A(k);
          $(() => be(x, "src", d(a).template_announcement.image)), z(y, k);
        }, v = (y) => {
          var k = K(), x = D(k);
          {
            var T = (P) => {
              var O = a6();
              O.muted = !0, O.__click = [t6, o, a];
              var I = A(O);
              $(() => be(I, "src", d(a).template_announcement.image)), z(P, O);
            }, F = (P) => {
              var O = n6();
              O.__click = [r6, o, a];
              var I = A(O);
              $(() => be(I, "src", d(a).template_announcement.image)), z(P, O);
            };
            B(
              x,
              (P) => {
                d(a).template_announcement.image.endsWith(".mp4") ? P(T) : P(F, !1);
              },
              !0
            );
          }
          z(y, k);
        };
        B(S, (y) => {
          d(a).template_announcement.image.endsWith(".svg") ? y(C) : y(v, !1);
        });
      }
      z(m, w);
    };
    B(f, (m) => {
      var w, S;
      (S = (w = d(a)) == null ? void 0 : w.template_announcement) != null && S.image && m(p);
    });
  }
  var c = X(f, 2), h = A(c), g = X(c, 2);
  He(g, {
    variant: "outline",
    type: "button",
    onclick: () => {
      t.send({ type: "run", item: d(a) });
    },
    class: "layup-h-8 !layup-w-full !layup-items-center !layup-justify-center !layup-gap-[4px] !layup-rounded-sm !layup-border-none !layup-bg-accent !layup-px-3 !layup-py-1.5 !layup-text-sm !layup-text-white/90 !layup-duration-200 hover:!layup-bg-accent-secondary hover:!layup-text-white hover:!layup-opacity-90",
    children: (m, w) => {
      var S = s6();
      z(m, S);
    },
    $$slots: { default: !0 }
  });
  var _ = X(l, 2);
  {
    var b = (m) => {
      var w = K(), S = D(w);
      Xe(S, () => fm, (C, v) => {
        v(C, {
          get open() {
            return d(r);
          },
          controlledOpen: !0,
          onOpenChange: (y) => {
            var k;
            (k = y == null ? void 0 : y.stopPropagation) == null || k.call(y), q(r, !d(r));
          },
          children: (y, k) => {
            var x = K(), T = D(x);
            Xe(T, () => dm, (F, P) => {
              P(F, {
                trapFocus: !1,
                autofocus: !1,
                hideCloseButton: !0,
                class: "layup-feature !layup-left-1/2 !layup-top-1/2 !layup-z-[999999999] !layup-m-0 layup-translate-x-[-50%] layup-translate-y-[-50%] !layup-cursor-pointer !layup-border-none !layup-bg-transparent !layup-p-0 focus:layup-outline-none",
                onclick: (O) => {
                  O.stopPropagation(), s();
                },
                onkeydown: (O) => {
                  O.key === "Escape" && (O.stopPropagation(), s());
                },
                children: (O, I) => {
                  var E = K(), N = D(E);
                  {
                    var H = (V) => {
                      var U = l6();
                      U.__click = [i6], $(() => be(U, "src", d(n).url)), z(V, U);
                    }, Y = (V) => {
                      var U = K(), ee = D(U);
                      {
                        var W = (G) => {
                          var J = u6();
                          J.__click = [c6];
                          var te = A(J);
                          $(() => be(te, "src", d(n).url)), z(G, J);
                        };
                        B(
                          ee,
                          (G) => {
                            d(n).type === "video" && G(W);
                          },
                          !0
                        );
                      }
                      z(V, U);
                    };
                    B(N, (V) => {
                      d(n).type === "image" ? V(H) : V(Y, !1);
                    });
                  }
                  z(O, E);
                },
                $$slots: { default: !0 }
              });
            }), z(y, x);
          },
          $$slots: { default: !0 }
        });
      }), z(m, w);
    };
    B(_, (m) => {
      d(r) && m(b);
    });
  }
  $(() => {
    var m, w;
    return Me(h, (w = (m = d(a)) == null ? void 0 : m.template_announcement) == null ? void 0 : w.description);
  }), z(e, i), xe();
}
nr(["click"]);
var p6 = /* @__PURE__ */ L('<div><div class="layup-flex layup-flex-col layup-items-center layup-gap-2"><div class="layup-flex layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-md !layup-border !layup-border-background-secondary !layup-bg-background layup-p-2"><div class="layup-flex layup-h-8 layup-w-8 layup-items-center layup-justify-center layup-rounded-sm !layup-bg-background-secondary layup-text-sm layup-font-medium !layup-text-primary"><p class="layup-text-base">!</p></div> <p class=" layup-text-base layup-text-primary"> </p></div></div></div>');
function y6(e, t) {
  ke(t, !0);
  let a = R(t, "notification", 15);
  Pe(() => {
    a() && setTimeout(
      () => {
        a(null);
      },
      3e3
    );
  });
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = p6(), l = A(i), u = A(l), f = X(A(u), 2), p = A(f);
      $(() => Me(p, a())), xt(3, l, () => ha, () => ({ start: 0.95, duration: 300 })), xt(3, i, () => oi, () => ({ y: 20, duration: 300 })), z(s, i);
    };
    B(n, (s) => {
      a() && s(o);
    });
  }
  z(e, r), xe();
}
var Pu = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const a = [
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",
    "BigInt64Array",
    "BigUint64Array"
  ];
  function r(y) {
    return a.includes(y);
  }
  const n = [
    "Function",
    "Generator",
    "AsyncGenerator",
    "GeneratorFunction",
    "AsyncGeneratorFunction",
    "AsyncFunction",
    "Observable",
    "Array",
    "Buffer",
    "Blob",
    "Object",
    "RegExp",
    "Date",
    "Error",
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",
    "ArrayBuffer",
    "SharedArrayBuffer",
    "DataView",
    "Promise",
    "URL",
    "FormData",
    "URLSearchParams",
    "HTMLElement",
    ...a
  ];
  function o(y) {
    return n.includes(y);
  }
  const s = [
    "null",
    "undefined",
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol"
  ];
  function i(y) {
    return s.includes(y);
  }
  function l(y) {
    return (k) => typeof k === y;
  }
  const { toString: u } = Object.prototype, f = (y) => {
    const k = u.call(y).slice(8, -1);
    if (/HTML\w+Element/.test(k) && c.domElement(y))
      return "HTMLElement";
    if (o(k))
      return k;
  }, p = (y) => (k) => f(k) === y;
  function c(y) {
    if (y === null)
      return "null";
    switch (typeof y) {
      case "undefined":
        return "undefined";
      case "string":
        return "string";
      case "number":
        return "number";
      case "boolean":
        return "boolean";
      case "function":
        return "Function";
      case "bigint":
        return "bigint";
      case "symbol":
        return "symbol";
    }
    if (c.observable(y))
      return "Observable";
    if (c.array(y))
      return "Array";
    if (c.buffer(y))
      return "Buffer";
    const k = f(y);
    if (k)
      return k;
    if (y instanceof String || y instanceof Boolean || y instanceof Number)
      throw new TypeError("Please don't use object wrappers for primitive types");
    return "Object";
  }
  c.undefined = l("undefined"), c.string = l("string");
  const h = l("number");
  c.number = (y) => h(y) && !c.nan(y), c.bigint = l("bigint"), c.function_ = l("function"), c.null_ = (y) => y === null, c.class_ = (y) => c.function_(y) && y.toString().startsWith("class "), c.boolean = (y) => y === !0 || y === !1, c.symbol = l("symbol"), c.numericString = (y) => c.string(y) && !c.emptyStringOrWhitespace(y) && !Number.isNaN(Number(y)), c.array = (y, k) => Array.isArray(y) ? c.function_(k) ? y.every(k) : !0 : !1, c.buffer = (y) => {
    var k, x, T, F;
    return (F = (T = (x = (k = y) === null || k === void 0 ? void 0 : k.constructor) === null || x === void 0 ? void 0 : x.isBuffer) === null || T === void 0 ? void 0 : T.call(x, y)) !== null && F !== void 0 ? F : !1;
  }, c.blob = (y) => p("Blob")(y), c.nullOrUndefined = (y) => c.null_(y) || c.undefined(y), c.object = (y) => !c.null_(y) && (typeof y == "object" || c.function_(y)), c.iterable = (y) => {
    var k;
    return c.function_((k = y) === null || k === void 0 ? void 0 : k[Symbol.iterator]);
  }, c.asyncIterable = (y) => {
    var k;
    return c.function_((k = y) === null || k === void 0 ? void 0 : k[Symbol.asyncIterator]);
  }, c.generator = (y) => {
    var k, x;
    return c.iterable(y) && c.function_((k = y) === null || k === void 0 ? void 0 : k.next) && c.function_((x = y) === null || x === void 0 ? void 0 : x.throw);
  }, c.asyncGenerator = (y) => c.asyncIterable(y) && c.function_(y.next) && c.function_(y.throw), c.nativePromise = (y) => p("Promise")(y);
  const g = (y) => {
    var k, x;
    return c.function_((k = y) === null || k === void 0 ? void 0 : k.then) && c.function_((x = y) === null || x === void 0 ? void 0 : x.catch);
  };
  c.promise = (y) => c.nativePromise(y) || g(y), c.generatorFunction = p("GeneratorFunction"), c.asyncGeneratorFunction = (y) => f(y) === "AsyncGeneratorFunction", c.asyncFunction = (y) => f(y) === "AsyncFunction", c.boundFunction = (y) => c.function_(y) && !y.hasOwnProperty("prototype"), c.regExp = p("RegExp"), c.date = p("Date"), c.error = p("Error"), c.map = (y) => p("Map")(y), c.set = (y) => p("Set")(y), c.weakMap = (y) => p("WeakMap")(y), c.weakSet = (y) => p("WeakSet")(y), c.int8Array = p("Int8Array"), c.uint8Array = p("Uint8Array"), c.uint8ClampedArray = p("Uint8ClampedArray"), c.int16Array = p("Int16Array"), c.uint16Array = p("Uint16Array"), c.int32Array = p("Int32Array"), c.uint32Array = p("Uint32Array"), c.float32Array = p("Float32Array"), c.float64Array = p("Float64Array"), c.bigInt64Array = p("BigInt64Array"), c.bigUint64Array = p("BigUint64Array"), c.arrayBuffer = p("ArrayBuffer"), c.sharedArrayBuffer = p("SharedArrayBuffer"), c.dataView = p("DataView"), c.enumCase = (y, k) => Object.values(k).includes(y), c.directInstanceOf = (y, k) => Object.getPrototypeOf(y) === k.prototype, c.urlInstance = (y) => p("URL")(y), c.urlString = (y) => {
    if (!c.string(y))
      return !1;
    try {
      return new URL(y), !0;
    } catch {
      return !1;
    }
  }, c.truthy = (y) => !!y, c.falsy = (y) => !y, c.nan = (y) => Number.isNaN(y), c.primitive = (y) => c.null_(y) || i(typeof y), c.integer = (y) => Number.isInteger(y), c.safeInteger = (y) => Number.isSafeInteger(y), c.plainObject = (y) => {
    if (u.call(y) !== "[object Object]")
      return !1;
    const k = Object.getPrototypeOf(y);
    return k === null || k === Object.getPrototypeOf({});
  }, c.typedArray = (y) => r(f(y));
  const _ = (y) => c.safeInteger(y) && y >= 0;
  c.arrayLike = (y) => !c.nullOrUndefined(y) && !c.function_(y) && _(y.length), c.inRange = (y, k) => {
    if (c.number(k))
      return y >= Math.min(0, k) && y <= Math.max(k, 0);
    if (c.array(k) && k.length === 2)
      return y >= Math.min(...k) && y <= Math.max(...k);
    throw new TypeError(`Invalid range: ${JSON.stringify(k)}`);
  };
  const b = 1, m = [
    "innerHTML",
    "ownerDocument",
    "style",
    "attributes",
    "nodeValue"
  ];
  c.domElement = (y) => c.object(y) && y.nodeType === b && c.string(y.nodeName) && !c.plainObject(y) && m.every((k) => k in y), c.observable = (y) => {
    var k, x, T, F;
    return y ? y === ((x = (k = y)[Symbol.observable]) === null || x === void 0 ? void 0 : x.call(k)) || y === ((F = (T = y)["@@observable"]) === null || F === void 0 ? void 0 : F.call(T)) : !1;
  }, c.nodeStream = (y) => c.object(y) && c.function_(y.pipe) && !c.observable(y), c.infinite = (y) => y === 1 / 0 || y === -1 / 0;
  const w = (y) => (k) => c.integer(k) && Math.abs(k % 2) === y;
  c.evenInteger = w(0), c.oddInteger = w(1), c.emptyArray = (y) => c.array(y) && y.length === 0, c.nonEmptyArray = (y) => c.array(y) && y.length > 0, c.emptyString = (y) => c.string(y) && y.length === 0;
  const S = (y) => c.string(y) && !/\S/.test(y);
  c.emptyStringOrWhitespace = (y) => c.emptyString(y) || S(y), c.nonEmptyString = (y) => c.string(y) && y.length > 0, c.nonEmptyStringAndNotWhitespace = (y) => c.string(y) && !c.emptyStringOrWhitespace(y), c.emptyObject = (y) => c.object(y) && !c.map(y) && !c.set(y) && Object.keys(y).length === 0, c.nonEmptyObject = (y) => c.object(y) && !c.map(y) && !c.set(y) && Object.keys(y).length > 0, c.emptySet = (y) => c.set(y) && y.size === 0, c.nonEmptySet = (y) => c.set(y) && y.size > 0, c.emptyMap = (y) => c.map(y) && y.size === 0, c.nonEmptyMap = (y) => c.map(y) && y.size > 0, c.propertyKey = (y) => c.any([c.string, c.number, c.symbol], y), c.formData = (y) => p("FormData")(y), c.urlSearchParams = (y) => p("URLSearchParams")(y);
  const C = (y, k, x) => {
    if (!c.function_(k))
      throw new TypeError(`Invalid predicate: ${JSON.stringify(k)}`);
    if (x.length === 0)
      throw new TypeError("Invalid number of values");
    return y.call(x, k);
  };
  c.any = (y, ...k) => (c.array(y) ? y : [y]).some((T) => C(Array.prototype.some, T, k)), c.all = (y, ...k) => C(Array.prototype.every, y, k);
  const v = (y, k, x, T = {}) => {
    if (!y) {
      const { multipleValues: F } = T, P = F ? `received values of types ${[
        ...new Set(x.map((O) => `\`${c(O)}\``))
      ].join(", ")}` : `received value of type \`${c(x)}\``;
      throw new TypeError(`Expected value which is \`${k}\`, ${P}.`);
    }
  };
  t.assert = {
    // Unknowns.
    undefined: (y) => v(c.undefined(y), "undefined", y),
    string: (y) => v(c.string(y), "string", y),
    number: (y) => v(c.number(y), "number", y),
    bigint: (y) => v(c.bigint(y), "bigint", y),
    // eslint-disable-next-line @typescript-eslint/ban-types
    function_: (y) => v(c.function_(y), "Function", y),
    null_: (y) => v(c.null_(y), "null", y),
    class_: (y) => v(c.class_(y), "Class", y),
    boolean: (y) => v(c.boolean(y), "boolean", y),
    symbol: (y) => v(c.symbol(y), "symbol", y),
    numericString: (y) => v(c.numericString(y), "string with a number", y),
    array: (y, k) => {
      v(c.array(y), "Array", y), k && y.forEach(k);
    },
    buffer: (y) => v(c.buffer(y), "Buffer", y),
    blob: (y) => v(c.blob(y), "Blob", y),
    nullOrUndefined: (y) => v(c.nullOrUndefined(y), "null or undefined", y),
    object: (y) => v(c.object(y), "Object", y),
    iterable: (y) => v(c.iterable(y), "Iterable", y),
    asyncIterable: (y) => v(c.asyncIterable(y), "AsyncIterable", y),
    generator: (y) => v(c.generator(y), "Generator", y),
    asyncGenerator: (y) => v(c.asyncGenerator(y), "AsyncGenerator", y),
    nativePromise: (y) => v(c.nativePromise(y), "native Promise", y),
    promise: (y) => v(c.promise(y), "Promise", y),
    generatorFunction: (y) => v(c.generatorFunction(y), "GeneratorFunction", y),
    asyncGeneratorFunction: (y) => v(c.asyncGeneratorFunction(y), "AsyncGeneratorFunction", y),
    // eslint-disable-next-line @typescript-eslint/ban-types
    asyncFunction: (y) => v(c.asyncFunction(y), "AsyncFunction", y),
    // eslint-disable-next-line @typescript-eslint/ban-types
    boundFunction: (y) => v(c.boundFunction(y), "Function", y),
    regExp: (y) => v(c.regExp(y), "RegExp", y),
    date: (y) => v(c.date(y), "Date", y),
    error: (y) => v(c.error(y), "Error", y),
    map: (y) => v(c.map(y), "Map", y),
    set: (y) => v(c.set(y), "Set", y),
    weakMap: (y) => v(c.weakMap(y), "WeakMap", y),
    weakSet: (y) => v(c.weakSet(y), "WeakSet", y),
    int8Array: (y) => v(c.int8Array(y), "Int8Array", y),
    uint8Array: (y) => v(c.uint8Array(y), "Uint8Array", y),
    uint8ClampedArray: (y) => v(c.uint8ClampedArray(y), "Uint8ClampedArray", y),
    int16Array: (y) => v(c.int16Array(y), "Int16Array", y),
    uint16Array: (y) => v(c.uint16Array(y), "Uint16Array", y),
    int32Array: (y) => v(c.int32Array(y), "Int32Array", y),
    uint32Array: (y) => v(c.uint32Array(y), "Uint32Array", y),
    float32Array: (y) => v(c.float32Array(y), "Float32Array", y),
    float64Array: (y) => v(c.float64Array(y), "Float64Array", y),
    bigInt64Array: (y) => v(c.bigInt64Array(y), "BigInt64Array", y),
    bigUint64Array: (y) => v(c.bigUint64Array(y), "BigUint64Array", y),
    arrayBuffer: (y) => v(c.arrayBuffer(y), "ArrayBuffer", y),
    sharedArrayBuffer: (y) => v(c.sharedArrayBuffer(y), "SharedArrayBuffer", y),
    dataView: (y) => v(c.dataView(y), "DataView", y),
    enumCase: (y, k) => v(c.enumCase(y, k), "EnumCase", y),
    urlInstance: (y) => v(c.urlInstance(y), "URL", y),
    urlString: (y) => v(c.urlString(y), "string with a URL", y),
    truthy: (y) => v(c.truthy(y), "truthy", y),
    falsy: (y) => v(c.falsy(y), "falsy", y),
    nan: (y) => v(c.nan(y), "NaN", y),
    primitive: (y) => v(c.primitive(y), "primitive", y),
    integer: (y) => v(c.integer(y), "integer", y),
    safeInteger: (y) => v(c.safeInteger(y), "integer", y),
    plainObject: (y) => v(c.plainObject(y), "plain object", y),
    typedArray: (y) => v(c.typedArray(y), "TypedArray", y),
    arrayLike: (y) => v(c.arrayLike(y), "array-like", y),
    domElement: (y) => v(c.domElement(y), "HTMLElement", y),
    observable: (y) => v(c.observable(y), "Observable", y),
    nodeStream: (y) => v(c.nodeStream(y), "Node.js Stream", y),
    infinite: (y) => v(c.infinite(y), "infinite number", y),
    emptyArray: (y) => v(c.emptyArray(y), "empty array", y),
    nonEmptyArray: (y) => v(c.nonEmptyArray(y), "non-empty array", y),
    emptyString: (y) => v(c.emptyString(y), "empty string", y),
    emptyStringOrWhitespace: (y) => v(c.emptyStringOrWhitespace(y), "empty string or whitespace", y),
    nonEmptyString: (y) => v(c.nonEmptyString(y), "non-empty string", y),
    nonEmptyStringAndNotWhitespace: (y) => v(c.nonEmptyStringAndNotWhitespace(y), "non-empty string and not whitespace", y),
    emptyObject: (y) => v(c.emptyObject(y), "empty object", y),
    nonEmptyObject: (y) => v(c.nonEmptyObject(y), "non-empty object", y),
    emptySet: (y) => v(c.emptySet(y), "empty set", y),
    nonEmptySet: (y) => v(c.nonEmptySet(y), "non-empty set", y),
    emptyMap: (y) => v(c.emptyMap(y), "empty map", y),
    nonEmptyMap: (y) => v(c.nonEmptyMap(y), "non-empty map", y),
    propertyKey: (y) => v(c.propertyKey(y), "PropertyKey", y),
    formData: (y) => v(c.formData(y), "FormData", y),
    urlSearchParams: (y) => v(c.urlSearchParams(y), "URLSearchParams", y),
    // Numbers.
    evenInteger: (y) => v(c.evenInteger(y), "even integer", y),
    oddInteger: (y) => v(c.oddInteger(y), "odd integer", y),
    // Two arguments.
    directInstanceOf: (y, k) => v(c.directInstanceOf(y, k), "T", y),
    inRange: (y, k) => v(c.inRange(y, k), "in range", y),
    // Variadic functions.
    any: (y, ...k) => v(c.any(y, ...k), "predicate returns truthy for any value", k, { multipleValues: !0 }),
    all: (y, ...k) => v(c.all(y, ...k), "predicate returns truthy for all values", k, { multipleValues: !0 })
  }, Object.defineProperties(c, {
    class: {
      value: c.class_
    },
    function: {
      value: c.function_
    },
    null: {
      value: c.null_
    }
  }), Object.defineProperties(t.assert, {
    class: {
      value: t.assert.class_
    },
    function: {
      value: t.assert.function_
    },
    null: {
      value: t.assert.null_
    }
  }), t.default = c, e.exports = c, e.exports.default = c, e.exports.assert = t.assert;
})(Pu, Pu.exports);
var hm = Pu.exports;
const Eo = /* @__PURE__ */ cc(hm), h6 = {
  keywords: [
    "face",
    "smile",
    "happy",
    "joy",
    ":D",
    "grin"
  ],
  char: "😀",
  fitzpatrick_scale: !1,
  category: "people"
}, g6 = {
  keywords: [
    "face",
    "grimace",
    "teeth"
  ],
  char: "😬",
  fitzpatrick_scale: !1,
  category: "people"
}, m6 = {
  keywords: [
    "face",
    "happy",
    "smile",
    "joy",
    "kawaii"
  ],
  char: "😁",
  fitzpatrick_scale: !1,
  category: "people"
}, _6 = {
  keywords: [
    "face",
    "cry",
    "tears",
    "weep",
    "happy",
    "happytears",
    "haha"
  ],
  char: "😂",
  fitzpatrick_scale: !1,
  category: "people"
}, w6 = {
  keywords: [
    "face",
    "rolling",
    "floor",
    "laughing",
    "lol",
    "haha"
  ],
  char: "🤣",
  fitzpatrick_scale: !1,
  category: "people"
}, v6 = {
  keywords: [
    "face",
    "celebration",
    "woohoo"
  ],
  char: "🥳",
  fitzpatrick_scale: !1,
  category: "people"
}, b6 = {
  keywords: [
    "face",
    "happy",
    "joy",
    "haha",
    ":D",
    ":)",
    "smile",
    "funny"
  ],
  char: "😃",
  fitzpatrick_scale: !1,
  category: "people"
}, k6 = {
  keywords: [
    "face",
    "happy",
    "joy",
    "funny",
    "haha",
    "laugh",
    "like",
    ":D",
    ":)"
  ],
  char: "😄",
  fitzpatrick_scale: !1,
  category: "people"
}, x6 = {
  keywords: [
    "face",
    "hot",
    "happy",
    "laugh",
    "sweat",
    "smile",
    "relief"
  ],
  char: "😅",
  fitzpatrick_scale: !1,
  category: "people"
}, z6 = {
  keywords: [
    "happy",
    "joy",
    "lol",
    "satisfied",
    "haha",
    "face",
    "glad",
    "XD",
    "laugh"
  ],
  char: "😆",
  fitzpatrick_scale: !1,
  category: "people"
}, S6 = {
  keywords: [
    "face",
    "angel",
    "heaven",
    "halo"
  ],
  char: "😇",
  fitzpatrick_scale: !1,
  category: "people"
}, C6 = {
  keywords: [
    "face",
    "happy",
    "mischievous",
    "secret",
    ";)",
    "smile",
    "eye"
  ],
  char: "😉",
  fitzpatrick_scale: !1,
  category: "people"
}, E6 = {
  keywords: [
    "face",
    "smile",
    "happy",
    "flushed",
    "crush",
    "embarrassed",
    "shy",
    "joy"
  ],
  char: "😊",
  fitzpatrick_scale: !1,
  category: "people"
}, A6 = {
  keywords: [
    "face",
    "smile"
  ],
  char: "🙂",
  fitzpatrick_scale: !1,
  category: "people"
}, T6 = {
  keywords: [
    "face",
    "flipped",
    "silly",
    "smile"
  ],
  char: "🙃",
  fitzpatrick_scale: !1,
  category: "people"
}, P6 = {
  keywords: [
    "face",
    "blush",
    "massage",
    "happiness"
  ],
  char: "☺️",
  fitzpatrick_scale: !1,
  category: "people"
}, O6 = {
  keywords: [
    "happy",
    "joy",
    "tongue",
    "smile",
    "face",
    "silly",
    "yummy",
    "nom",
    "delicious",
    "savouring"
  ],
  char: "😋",
  fitzpatrick_scale: !1,
  category: "people"
}, M6 = {
  keywords: [
    "face",
    "relaxed",
    "phew",
    "massage",
    "happiness"
  ],
  char: "😌",
  fitzpatrick_scale: !1,
  category: "people"
}, I6 = {
  keywords: [
    "face",
    "love",
    "like",
    "affection",
    "valentines",
    "infatuation",
    "crush",
    "heart"
  ],
  char: "😍",
  fitzpatrick_scale: !1,
  category: "people"
}, F6 = {
  keywords: [
    "face",
    "love",
    "like",
    "affection",
    "valentines",
    "infatuation",
    "crush",
    "hearts",
    "adore"
  ],
  char: "🥰",
  fitzpatrick_scale: !1,
  category: "people"
}, j6 = {
  keywords: [
    "face",
    "love",
    "like",
    "affection",
    "valentines",
    "infatuation",
    "kiss"
  ],
  char: "😘",
  fitzpatrick_scale: !1,
  category: "people"
}, R6 = {
  keywords: [
    "love",
    "like",
    "face",
    "3",
    "valentines",
    "infatuation",
    "kiss"
  ],
  char: "😗",
  fitzpatrick_scale: !1,
  category: "people"
}, L6 = {
  keywords: [
    "face",
    "affection",
    "valentines",
    "infatuation",
    "kiss"
  ],
  char: "😙",
  fitzpatrick_scale: !1,
  category: "people"
}, D6 = {
  keywords: [
    "face",
    "love",
    "like",
    "affection",
    "valentines",
    "infatuation",
    "kiss"
  ],
  char: "😚",
  fitzpatrick_scale: !1,
  category: "people"
}, N6 = {
  keywords: [
    "face",
    "prank",
    "childish",
    "playful",
    "mischievous",
    "smile",
    "wink",
    "tongue"
  ],
  char: "😜",
  fitzpatrick_scale: !1,
  category: "people"
}, V6 = {
  keywords: [
    "face",
    "goofy",
    "crazy"
  ],
  char: "🤪",
  fitzpatrick_scale: !1,
  category: "people"
}, q6 = {
  keywords: [
    "face",
    "distrust",
    "scepticism",
    "disapproval",
    "disbelief",
    "surprise"
  ],
  char: "🤨",
  fitzpatrick_scale: !1,
  category: "people"
}, B6 = {
  keywords: [
    "face",
    "stuffy",
    "wealthy"
  ],
  char: "🧐",
  fitzpatrick_scale: !1,
  category: "people"
}, W6 = {
  keywords: [
    "face",
    "prank",
    "playful",
    "mischievous",
    "smile",
    "tongue"
  ],
  char: "😝",
  fitzpatrick_scale: !1,
  category: "people"
}, H6 = {
  keywords: [
    "face",
    "prank",
    "childish",
    "playful",
    "mischievous",
    "smile",
    "tongue"
  ],
  char: "😛",
  fitzpatrick_scale: !1,
  category: "people"
}, U6 = {
  keywords: [
    "face",
    "rich",
    "dollar",
    "money"
  ],
  char: "🤑",
  fitzpatrick_scale: !1,
  category: "people"
}, G6 = {
  keywords: [
    "face",
    "nerdy",
    "geek",
    "dork"
  ],
  char: "🤓",
  fitzpatrick_scale: !1,
  category: "people"
}, K6 = {
  keywords: [
    "face",
    "cool",
    "smile",
    "summer",
    "beach",
    "sunglass"
  ],
  char: "😎",
  fitzpatrick_scale: !1,
  category: "people"
}, Z6 = {
  keywords: [
    "face",
    "smile",
    "starry",
    "eyes",
    "grinning"
  ],
  char: "🤩",
  fitzpatrick_scale: !1,
  category: "people"
}, Y6 = {
  keywords: [
    "face"
  ],
  char: "🤡",
  fitzpatrick_scale: !1,
  category: "people"
}, X6 = {
  keywords: [
    "face",
    "cowgirl",
    "hat"
  ],
  char: "🤠",
  fitzpatrick_scale: !1,
  category: "people"
}, J6 = {
  keywords: [
    "face",
    "smile",
    "hug"
  ],
  char: "🤗",
  fitzpatrick_scale: !1,
  category: "people"
}, Q6 = {
  keywords: [
    "face",
    "smile",
    "mean",
    "prank",
    "smug",
    "sarcasm"
  ],
  char: "😏",
  fitzpatrick_scale: !1,
  category: "people"
}, $6 = {
  keywords: [
    "face",
    "hellokitty"
  ],
  char: "😶",
  fitzpatrick_scale: !1,
  category: "people"
}, eC = {
  keywords: [
    "indifference",
    "meh",
    ":|",
    "neutral"
  ],
  char: "😐",
  fitzpatrick_scale: !1,
  category: "people"
}, tC = {
  keywords: [
    "face",
    "indifferent",
    "-_-",
    "meh",
    "deadpan"
  ],
  char: "😑",
  fitzpatrick_scale: !1,
  category: "people"
}, aC = {
  keywords: [
    "indifference",
    "bored",
    "straight face",
    "serious",
    "sarcasm",
    "unimpressed",
    "skeptical",
    "dubious",
    "side_eye"
  ],
  char: "😒",
  fitzpatrick_scale: !1,
  category: "people"
}, rC = {
  keywords: [
    "face",
    "eyeroll",
    "frustrated"
  ],
  char: "🙄",
  fitzpatrick_scale: !1,
  category: "people"
}, nC = {
  keywords: [
    "face",
    "hmmm",
    "think",
    "consider"
  ],
  char: "🤔",
  fitzpatrick_scale: !1,
  category: "people"
}, oC = {
  keywords: [
    "face",
    "lie",
    "pinocchio"
  ],
  char: "🤥",
  fitzpatrick_scale: !1,
  category: "people"
}, sC = {
  keywords: [
    "face",
    "whoops",
    "shock",
    "surprise"
  ],
  char: "🤭",
  fitzpatrick_scale: !1,
  category: "people"
}, iC = {
  keywords: [
    "face",
    "quiet",
    "shhh"
  ],
  char: "🤫",
  fitzpatrick_scale: !1,
  category: "people"
}, lC = {
  keywords: [
    "face",
    "swearing",
    "cursing",
    "cussing",
    "profanity",
    "expletive"
  ],
  char: "🤬",
  fitzpatrick_scale: !1,
  category: "people"
}, cC = {
  keywords: [
    "face",
    "shocked",
    "mind",
    "blown"
  ],
  char: "🤯",
  fitzpatrick_scale: !1,
  category: "people"
}, uC = {
  keywords: [
    "face",
    "blush",
    "shy",
    "flattered"
  ],
  char: "😳",
  fitzpatrick_scale: !1,
  category: "people"
}, dC = {
  keywords: [
    "face",
    "sad",
    "upset",
    "depressed",
    ":("
  ],
  char: "😞",
  fitzpatrick_scale: !1,
  category: "people"
}, fC = {
  keywords: [
    "face",
    "concern",
    "nervous",
    ":("
  ],
  char: "😟",
  fitzpatrick_scale: !1,
  category: "people"
}, pC = {
  keywords: [
    "mad",
    "face",
    "annoyed",
    "frustrated"
  ],
  char: "😠",
  fitzpatrick_scale: !1,
  category: "people"
}, yC = {
  keywords: [
    "angry",
    "mad",
    "hate",
    "despise"
  ],
  char: "😡",
  fitzpatrick_scale: !1,
  category: "people"
}, hC = {
  keywords: [
    "face",
    "sad",
    "depressed",
    "upset"
  ],
  char: "😔",
  fitzpatrick_scale: !1,
  category: "people"
}, gC = {
  keywords: [
    "face",
    "indifference",
    "huh",
    "weird",
    "hmmm",
    ":/"
  ],
  char: "😕",
  fitzpatrick_scale: !1,
  category: "people"
}, mC = {
  keywords: [
    "face",
    "frowning",
    "disappointed",
    "sad",
    "upset"
  ],
  char: "🙁",
  fitzpatrick_scale: !1,
  category: "people"
}, _C = {
  keywords: [
    "face",
    "sad",
    "upset",
    "frown"
  ],
  char: "☹",
  fitzpatrick_scale: !1,
  category: "people"
}, wC = {
  keywords: [
    "face",
    "sick",
    "no",
    "upset",
    "oops"
  ],
  char: "😣",
  fitzpatrick_scale: !1,
  category: "people"
}, vC = {
  keywords: [
    "face",
    "confused",
    "sick",
    "unwell",
    "oops",
    ":S"
  ],
  char: "😖",
  fitzpatrick_scale: !1,
  category: "people"
}, bC = {
  keywords: [
    "sick",
    "whine",
    "upset",
    "frustrated"
  ],
  char: "😫",
  fitzpatrick_scale: !1,
  category: "people"
}, kC = {
  keywords: [
    "face",
    "tired",
    "sleepy",
    "sad",
    "frustrated",
    "upset"
  ],
  char: "😩",
  fitzpatrick_scale: !1,
  category: "people"
}, xC = {
  keywords: [
    "face",
    "begging",
    "mercy"
  ],
  char: "🥺",
  fitzpatrick_scale: !1,
  category: "people"
}, zC = {
  keywords: [
    "face",
    "gas",
    "phew",
    "proud",
    "pride"
  ],
  char: "😤",
  fitzpatrick_scale: !1,
  category: "people"
}, SC = {
  keywords: [
    "face",
    "surprise",
    "impressed",
    "wow",
    "whoa",
    ":O"
  ],
  char: "😮",
  fitzpatrick_scale: !1,
  category: "people"
}, CC = {
  keywords: [
    "face",
    "munch",
    "scared",
    "omg"
  ],
  char: "😱",
  fitzpatrick_scale: !1,
  category: "people"
}, EC = {
  keywords: [
    "face",
    "scared",
    "terrified",
    "nervous",
    "oops",
    "huh"
  ],
  char: "😨",
  fitzpatrick_scale: !1,
  category: "people"
}, AC = {
  keywords: [
    "face",
    "nervous",
    "sweat"
  ],
  char: "😰",
  fitzpatrick_scale: !1,
  category: "people"
}, TC = {
  keywords: [
    "face",
    "woo",
    "shh"
  ],
  char: "😯",
  fitzpatrick_scale: !1,
  category: "people"
}, PC = {
  keywords: [
    "face",
    "aw",
    "what"
  ],
  char: "😦",
  fitzpatrick_scale: !1,
  category: "people"
}, OC = {
  keywords: [
    "face",
    "stunned",
    "nervous"
  ],
  char: "😧",
  fitzpatrick_scale: !1,
  category: "people"
}, MC = {
  keywords: [
    "face",
    "tears",
    "sad",
    "depressed",
    "upset",
    ":'("
  ],
  char: "😢",
  fitzpatrick_scale: !1,
  category: "people"
}, IC = {
  keywords: [
    "face",
    "phew",
    "sweat",
    "nervous"
  ],
  char: "😥",
  fitzpatrick_scale: !1,
  category: "people"
}, FC = {
  keywords: [
    "face"
  ],
  char: "🤤",
  fitzpatrick_scale: !1,
  category: "people"
}, jC = {
  keywords: [
    "face",
    "tired",
    "rest",
    "nap"
  ],
  char: "😪",
  fitzpatrick_scale: !1,
  category: "people"
}, RC = {
  keywords: [
    "face",
    "hot",
    "sad",
    "tired",
    "exercise"
  ],
  char: "😓",
  fitzpatrick_scale: !1,
  category: "people"
}, LC = {
  keywords: [
    "face",
    "feverish",
    "heat",
    "red",
    "sweating"
  ],
  char: "🥵",
  fitzpatrick_scale: !1,
  category: "people"
}, DC = {
  keywords: [
    "face",
    "blue",
    "freezing",
    "frozen",
    "frostbite",
    "icicles"
  ],
  char: "🥶",
  fitzpatrick_scale: !1,
  category: "people"
}, NC = {
  keywords: [
    "face",
    "cry",
    "tears",
    "sad",
    "upset",
    "depressed"
  ],
  char: "😭",
  fitzpatrick_scale: !1,
  category: "people"
}, VC = {
  keywords: [
    "spent",
    "unconscious",
    "xox",
    "dizzy"
  ],
  char: "😵",
  fitzpatrick_scale: !1,
  category: "people"
}, qC = {
  keywords: [
    "face",
    "xox",
    "surprised",
    "poisoned"
  ],
  char: "😲",
  fitzpatrick_scale: !1,
  category: "people"
}, BC = {
  keywords: [
    "face",
    "sealed",
    "zipper",
    "secret"
  ],
  char: "🤐",
  fitzpatrick_scale: !1,
  category: "people"
}, WC = {
  keywords: [
    "face",
    "vomit",
    "gross",
    "green",
    "sick",
    "throw up",
    "ill"
  ],
  char: "🤢",
  fitzpatrick_scale: !1,
  category: "people"
}, HC = {
  keywords: [
    "face",
    "gesundheit",
    "sneeze",
    "sick",
    "allergy"
  ],
  char: "🤧",
  fitzpatrick_scale: !1,
  category: "people"
}, UC = {
  keywords: [
    "face",
    "sick"
  ],
  char: "🤮",
  fitzpatrick_scale: !1,
  category: "people"
}, GC = {
  keywords: [
    "face",
    "sick",
    "ill",
    "disease"
  ],
  char: "😷",
  fitzpatrick_scale: !1,
  category: "people"
}, KC = {
  keywords: [
    "sick",
    "temperature",
    "thermometer",
    "cold",
    "fever"
  ],
  char: "🤒",
  fitzpatrick_scale: !1,
  category: "people"
}, ZC = {
  keywords: [
    "injured",
    "clumsy",
    "bandage",
    "hurt"
  ],
  char: "🤕",
  fitzpatrick_scale: !1,
  category: "people"
}, YC = {
  keywords: [
    "face",
    "dizzy",
    "intoxicated",
    "tipsy",
    "wavy"
  ],
  char: "🥴",
  fitzpatrick_scale: !1,
  category: "people"
}, XC = {
  keywords: [
    "face",
    "tired",
    "sleepy",
    "night",
    "zzz"
  ],
  char: "😴",
  fitzpatrick_scale: !1,
  category: "people"
}, JC = {
  keywords: [
    "sleepy",
    "tired",
    "dream"
  ],
  char: "💤",
  fitzpatrick_scale: !1,
  category: "people"
}, QC = {
  keywords: [
    "hankey",
    "shitface",
    "fail",
    "turd",
    "shit"
  ],
  char: "💩",
  fitzpatrick_scale: !1,
  category: "people"
}, $C = {
  keywords: [
    "devil",
    "horns"
  ],
  char: "😈",
  fitzpatrick_scale: !1,
  category: "people"
}, eE = {
  keywords: [
    "devil",
    "angry",
    "horns"
  ],
  char: "👿",
  fitzpatrick_scale: !1,
  category: "people"
}, tE = {
  keywords: [
    "monster",
    "red",
    "mask",
    "halloween",
    "scary",
    "creepy",
    "devil",
    "demon",
    "japanese",
    "ogre"
  ],
  char: "👹",
  fitzpatrick_scale: !1,
  category: "people"
}, aE = {
  keywords: [
    "red",
    "evil",
    "mask",
    "monster",
    "scary",
    "creepy",
    "japanese",
    "goblin"
  ],
  char: "👺",
  fitzpatrick_scale: !1,
  category: "people"
}, rE = {
  keywords: [
    "dead",
    "skeleton",
    "creepy",
    "death"
  ],
  char: "💀",
  fitzpatrick_scale: !1,
  category: "people"
}, nE = {
  keywords: [
    "halloween",
    "spooky",
    "scary"
  ],
  char: "👻",
  fitzpatrick_scale: !1,
  category: "people"
}, oE = {
  keywords: [
    "UFO",
    "paul",
    "weird",
    "outer_space"
  ],
  char: "👽",
  fitzpatrick_scale: !1,
  category: "people"
}, sE = {
  keywords: [
    "computer",
    "machine",
    "bot"
  ],
  char: "🤖",
  fitzpatrick_scale: !1,
  category: "people"
}, iE = {
  keywords: [
    "animal",
    "cats",
    "happy",
    "smile"
  ],
  char: "😺",
  fitzpatrick_scale: !1,
  category: "people"
}, lE = {
  keywords: [
    "animal",
    "cats",
    "smile"
  ],
  char: "😸",
  fitzpatrick_scale: !1,
  category: "people"
}, cE = {
  keywords: [
    "animal",
    "cats",
    "haha",
    "happy",
    "tears"
  ],
  char: "😹",
  fitzpatrick_scale: !1,
  category: "people"
}, uE = {
  keywords: [
    "animal",
    "love",
    "like",
    "affection",
    "cats",
    "valentines",
    "heart"
  ],
  char: "😻",
  fitzpatrick_scale: !1,
  category: "people"
}, dE = {
  keywords: [
    "animal",
    "cats",
    "smirk"
  ],
  char: "😼",
  fitzpatrick_scale: !1,
  category: "people"
}, fE = {
  keywords: [
    "animal",
    "cats",
    "kiss"
  ],
  char: "😽",
  fitzpatrick_scale: !1,
  category: "people"
}, pE = {
  keywords: [
    "animal",
    "cats",
    "munch",
    "scared",
    "scream"
  ],
  char: "🙀",
  fitzpatrick_scale: !1,
  category: "people"
}, yE = {
  keywords: [
    "animal",
    "tears",
    "weep",
    "sad",
    "cats",
    "upset",
    "cry"
  ],
  char: "😿",
  fitzpatrick_scale: !1,
  category: "people"
}, hE = {
  keywords: [
    "animal",
    "cats"
  ],
  char: "😾",
  fitzpatrick_scale: !1,
  category: "people"
}, gE = {
  keywords: [
    "hands",
    "gesture",
    "cupped",
    "prayer"
  ],
  char: "🤲",
  fitzpatrick_scale: !0,
  category: "people"
}, mE = {
  keywords: [
    "gesture",
    "hooray",
    "yea",
    "celebration",
    "hands"
  ],
  char: "🙌",
  fitzpatrick_scale: !0,
  category: "people"
}, _E = {
  keywords: [
    "hands",
    "praise",
    "applause",
    "congrats",
    "yay"
  ],
  char: "👏",
  fitzpatrick_scale: !0,
  category: "people"
}, wE = {
  keywords: [
    "hands",
    "gesture",
    "goodbye",
    "solong",
    "farewell",
    "hello",
    "hi",
    "palm"
  ],
  char: "👋",
  fitzpatrick_scale: !0,
  category: "people"
}, vE = {
  keywords: [
    "hands",
    "gesture"
  ],
  char: "🤙",
  fitzpatrick_scale: !0,
  category: "people"
}, bE = {
  keywords: [
    "angry",
    "violence",
    "fist",
    "hit",
    "attack",
    "hand"
  ],
  char: "👊",
  fitzpatrick_scale: !0,
  category: "people"
}, kE = {
  keywords: [
    "fingers",
    "hand",
    "grasp"
  ],
  char: "✊",
  fitzpatrick_scale: !0,
  category: "people"
}, xE = {
  keywords: [
    "hand",
    "fistbump"
  ],
  char: "🤛",
  fitzpatrick_scale: !0,
  category: "people"
}, zE = {
  keywords: [
    "hand",
    "fistbump"
  ],
  char: "🤜",
  fitzpatrick_scale: !0,
  category: "people"
}, SE = {
  keywords: [
    "fingers",
    "ohyeah",
    "hand",
    "peace",
    "victory",
    "two"
  ],
  char: "✌",
  fitzpatrick_scale: !0,
  category: "people"
}, CE = {
  keywords: [
    "fingers",
    "limbs",
    "perfect",
    "ok",
    "okay"
  ],
  char: "👌",
  fitzpatrick_scale: !0,
  category: "people"
}, EE = {
  keywords: [
    "fingers",
    "stop",
    "highfive",
    "palm",
    "ban"
  ],
  char: "✋",
  fitzpatrick_scale: !0,
  category: "people"
}, AE = {
  keywords: [
    "fingers",
    "raised",
    "backhand"
  ],
  char: "🤚",
  fitzpatrick_scale: !0,
  category: "people"
}, TE = {
  keywords: [
    "fingers",
    "butterfly",
    "hands",
    "open"
  ],
  char: "👐",
  fitzpatrick_scale: !0,
  category: "people"
}, PE = {
  keywords: [
    "arm",
    "flex",
    "hand",
    "summer",
    "strong",
    "biceps"
  ],
  char: "💪",
  fitzpatrick_scale: !0,
  category: "people"
}, OE = {
  keywords: [
    "please",
    "hope",
    "wish",
    "namaste",
    "highfive"
  ],
  char: "🙏",
  fitzpatrick_scale: !0,
  category: "people"
}, ME = {
  keywords: [
    "kick",
    "stomp"
  ],
  char: "🦶",
  fitzpatrick_scale: !0,
  category: "people"
}, IE = {
  keywords: [
    "kick",
    "limb"
  ],
  char: "🦵",
  fitzpatrick_scale: !0,
  category: "people"
}, FE = {
  keywords: [
    "agreement",
    "shake"
  ],
  char: "🤝",
  fitzpatrick_scale: !1,
  category: "people"
}, jE = {
  keywords: [
    "hand",
    "fingers",
    "direction",
    "up"
  ],
  char: "☝",
  fitzpatrick_scale: !0,
  category: "people"
}, RE = {
  keywords: [
    "fingers",
    "hand",
    "direction",
    "up"
  ],
  char: "👆",
  fitzpatrick_scale: !0,
  category: "people"
}, LE = {
  keywords: [
    "fingers",
    "hand",
    "direction",
    "down"
  ],
  char: "👇",
  fitzpatrick_scale: !0,
  category: "people"
}, DE = {
  keywords: [
    "direction",
    "fingers",
    "hand",
    "left"
  ],
  char: "👈",
  fitzpatrick_scale: !0,
  category: "people"
}, NE = {
  keywords: [
    "fingers",
    "hand",
    "direction",
    "right"
  ],
  char: "👉",
  fitzpatrick_scale: !0,
  category: "people"
}, VE = {
  keywords: [
    "hand",
    "fingers",
    "rude",
    "middle",
    "flipping"
  ],
  char: "🖕",
  fitzpatrick_scale: !0,
  category: "people"
}, qE = {
  keywords: [
    "hand",
    "fingers",
    "palm"
  ],
  char: "🖐",
  fitzpatrick_scale: !0,
  category: "people"
}, BE = {
  keywords: [
    "hand",
    "fingers",
    "gesture"
  ],
  char: "🤟",
  fitzpatrick_scale: !0,
  category: "people"
}, WE = {
  keywords: [
    "hand",
    "fingers",
    "evil_eye",
    "sign_of_horns",
    "rock_on"
  ],
  char: "🤘",
  fitzpatrick_scale: !0,
  category: "people"
}, HE = {
  keywords: [
    "good",
    "lucky"
  ],
  char: "🤞",
  fitzpatrick_scale: !0,
  category: "people"
}, UE = {
  keywords: [
    "hand",
    "fingers",
    "spock",
    "star trek"
  ],
  char: "🖖",
  fitzpatrick_scale: !0,
  category: "people"
}, GE = {
  keywords: [
    "lower_left_ballpoint_pen",
    "stationery",
    "write",
    "compose"
  ],
  char: "✍",
  fitzpatrick_scale: !0,
  category: "people"
}, KE = {
  keywords: [
    "camera",
    "phone"
  ],
  char: "🤳",
  fitzpatrick_scale: !0,
  category: "people"
}, ZE = {
  keywords: [
    "beauty",
    "manicure",
    "finger",
    "fashion",
    "nail"
  ],
  char: "💅",
  fitzpatrick_scale: !0,
  category: "people"
}, YE = {
  keywords: [
    "mouth",
    "kiss"
  ],
  char: "👄",
  fitzpatrick_scale: !1,
  category: "people"
}, XE = {
  keywords: [
    "teeth",
    "dentist"
  ],
  char: "🦷",
  fitzpatrick_scale: !1,
  category: "people"
}, JE = {
  keywords: [
    "mouth",
    "playful"
  ],
  char: "👅",
  fitzpatrick_scale: !1,
  category: "people"
}, QE = {
  keywords: [
    "face",
    "hear",
    "sound",
    "listen"
  ],
  char: "👂",
  fitzpatrick_scale: !0,
  category: "people"
}, $E = {
  keywords: [
    "smell",
    "sniff"
  ],
  char: "👃",
  fitzpatrick_scale: !0,
  category: "people"
}, e8 = {
  keywords: [
    "face",
    "look",
    "see",
    "watch",
    "stare"
  ],
  char: "👁",
  fitzpatrick_scale: !1,
  category: "people"
}, t8 = {
  keywords: [
    "look",
    "watch",
    "stalk",
    "peek",
    "see"
  ],
  char: "👀",
  fitzpatrick_scale: !1,
  category: "people"
}, a8 = {
  keywords: [
    "smart",
    "intelligent"
  ],
  char: "🧠",
  fitzpatrick_scale: !1,
  category: "people"
}, r8 = {
  keywords: [
    "user",
    "person",
    "human"
  ],
  char: "👤",
  fitzpatrick_scale: !1,
  category: "people"
}, n8 = {
  keywords: [
    "user",
    "person",
    "human",
    "group",
    "team"
  ],
  char: "👥",
  fitzpatrick_scale: !1,
  category: "people"
}, o8 = {
  keywords: [
    "user",
    "person",
    "human",
    "sing",
    "say",
    "talk"
  ],
  char: "🗣",
  fitzpatrick_scale: !1,
  category: "people"
}, s8 = {
  keywords: [
    "child",
    "boy",
    "girl",
    "toddler"
  ],
  char: "👶",
  fitzpatrick_scale: !0,
  category: "people"
}, i8 = {
  keywords: [
    "gender-neutral",
    "young"
  ],
  char: "🧒",
  fitzpatrick_scale: !0,
  category: "people"
}, l8 = {
  keywords: [
    "man",
    "male",
    "guy",
    "teenager"
  ],
  char: "👦",
  fitzpatrick_scale: !0,
  category: "people"
}, c8 = {
  keywords: [
    "female",
    "woman",
    "teenager"
  ],
  char: "👧",
  fitzpatrick_scale: !0,
  category: "people"
}, u8 = {
  keywords: [
    "gender-neutral",
    "person"
  ],
  char: "🧑",
  fitzpatrick_scale: !0,
  category: "people"
}, d8 = {
  keywords: [
    "mustache",
    "father",
    "dad",
    "guy",
    "classy",
    "sir",
    "moustache"
  ],
  char: "👨",
  fitzpatrick_scale: !0,
  category: "people"
}, f8 = {
  keywords: [
    "female",
    "girls",
    "lady"
  ],
  char: "👩",
  fitzpatrick_scale: !0,
  category: "people"
}, p8 = {
  keywords: [
    "woman",
    "female",
    "girl",
    "blonde",
    "person"
  ],
  char: "👱‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, y8 = {
  keywords: [
    "man",
    "male",
    "boy",
    "blonde",
    "guy",
    "person"
  ],
  char: "👱",
  fitzpatrick_scale: !0,
  category: "people"
}, h8 = {
  keywords: [
    "person",
    "bewhiskered"
  ],
  char: "🧔",
  fitzpatrick_scale: !0,
  category: "people"
}, g8 = {
  keywords: [
    "human",
    "elder",
    "senior",
    "gender-neutral"
  ],
  char: "🧓",
  fitzpatrick_scale: !0,
  category: "people"
}, m8 = {
  keywords: [
    "human",
    "male",
    "men",
    "old",
    "elder",
    "senior"
  ],
  char: "👴",
  fitzpatrick_scale: !0,
  category: "people"
}, _8 = {
  keywords: [
    "human",
    "female",
    "women",
    "lady",
    "old",
    "elder",
    "senior"
  ],
  char: "👵",
  fitzpatrick_scale: !0,
  category: "people"
}, w8 = {
  keywords: [
    "male",
    "boy",
    "chinese"
  ],
  char: "👲",
  fitzpatrick_scale: !0,
  category: "people"
}, v8 = {
  keywords: [
    "female",
    "hijab",
    "mantilla",
    "tichel"
  ],
  char: "🧕",
  fitzpatrick_scale: !0,
  category: "people"
}, b8 = {
  keywords: [
    "female",
    "indian",
    "hinduism",
    "arabs",
    "woman"
  ],
  char: "👳‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, k8 = {
  keywords: [
    "male",
    "indian",
    "hinduism",
    "arabs"
  ],
  char: "👳",
  fitzpatrick_scale: !0,
  category: "people"
}, x8 = {
  keywords: [
    "woman",
    "police",
    "law",
    "legal",
    "enforcement",
    "arrest",
    "911",
    "female"
  ],
  char: "👮‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, z8 = {
  keywords: [
    "man",
    "police",
    "law",
    "legal",
    "enforcement",
    "arrest",
    "911"
  ],
  char: "👮",
  fitzpatrick_scale: !0,
  category: "people"
}, S8 = {
  keywords: [
    "female",
    "human",
    "wip",
    "build",
    "construction",
    "worker",
    "labor",
    "woman"
  ],
  char: "👷‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, C8 = {
  keywords: [
    "male",
    "human",
    "wip",
    "guy",
    "build",
    "construction",
    "worker",
    "labor"
  ],
  char: "👷",
  fitzpatrick_scale: !0,
  category: "people"
}, E8 = {
  keywords: [
    "uk",
    "gb",
    "british",
    "female",
    "royal",
    "woman"
  ],
  char: "💂‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, A8 = {
  keywords: [
    "uk",
    "gb",
    "british",
    "male",
    "guy",
    "royal"
  ],
  char: "💂",
  fitzpatrick_scale: !0,
  category: "people"
}, T8 = {
  keywords: [
    "human",
    "spy",
    "detective",
    "female",
    "woman"
  ],
  char: "🕵️‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, P8 = {
  keywords: [
    "human",
    "spy",
    "detective"
  ],
  char: "🕵",
  fitzpatrick_scale: !0,
  category: "people"
}, O8 = {
  keywords: [
    "doctor",
    "nurse",
    "therapist",
    "healthcare",
    "woman",
    "human"
  ],
  char: "👩‍⚕️",
  fitzpatrick_scale: !0,
  category: "people"
}, M8 = {
  keywords: [
    "doctor",
    "nurse",
    "therapist",
    "healthcare",
    "man",
    "human"
  ],
  char: "👨‍⚕️",
  fitzpatrick_scale: !0,
  category: "people"
}, I8 = {
  keywords: [
    "rancher",
    "gardener",
    "woman",
    "human"
  ],
  char: "👩‍🌾",
  fitzpatrick_scale: !0,
  category: "people"
}, F8 = {
  keywords: [
    "rancher",
    "gardener",
    "man",
    "human"
  ],
  char: "👨‍🌾",
  fitzpatrick_scale: !0,
  category: "people"
}, j8 = {
  keywords: [
    "chef",
    "woman",
    "human"
  ],
  char: "👩‍🍳",
  fitzpatrick_scale: !0,
  category: "people"
}, R8 = {
  keywords: [
    "chef",
    "man",
    "human"
  ],
  char: "👨‍🍳",
  fitzpatrick_scale: !0,
  category: "people"
}, L8 = {
  keywords: [
    "graduate",
    "woman",
    "human"
  ],
  char: "👩‍🎓",
  fitzpatrick_scale: !0,
  category: "people"
}, D8 = {
  keywords: [
    "graduate",
    "man",
    "human"
  ],
  char: "👨‍🎓",
  fitzpatrick_scale: !0,
  category: "people"
}, N8 = {
  keywords: [
    "rockstar",
    "entertainer",
    "woman",
    "human"
  ],
  char: "👩‍🎤",
  fitzpatrick_scale: !0,
  category: "people"
}, V8 = {
  keywords: [
    "rockstar",
    "entertainer",
    "man",
    "human"
  ],
  char: "👨‍🎤",
  fitzpatrick_scale: !0,
  category: "people"
}, q8 = {
  keywords: [
    "instructor",
    "professor",
    "woman",
    "human"
  ],
  char: "👩‍🏫",
  fitzpatrick_scale: !0,
  category: "people"
}, B8 = {
  keywords: [
    "instructor",
    "professor",
    "man",
    "human"
  ],
  char: "👨‍🏫",
  fitzpatrick_scale: !0,
  category: "people"
}, W8 = {
  keywords: [
    "assembly",
    "industrial",
    "woman",
    "human"
  ],
  char: "👩‍🏭",
  fitzpatrick_scale: !0,
  category: "people"
}, H8 = {
  keywords: [
    "assembly",
    "industrial",
    "man",
    "human"
  ],
  char: "👨‍🏭",
  fitzpatrick_scale: !0,
  category: "people"
}, U8 = {
  keywords: [
    "coder",
    "developer",
    "engineer",
    "programmer",
    "software",
    "woman",
    "human",
    "laptop",
    "computer"
  ],
  char: "👩‍💻",
  fitzpatrick_scale: !0,
  category: "people"
}, G8 = {
  keywords: [
    "coder",
    "developer",
    "engineer",
    "programmer",
    "software",
    "man",
    "human",
    "laptop",
    "computer"
  ],
  char: "👨‍💻",
  fitzpatrick_scale: !0,
  category: "people"
}, K8 = {
  keywords: [
    "business",
    "manager",
    "woman",
    "human"
  ],
  char: "👩‍💼",
  fitzpatrick_scale: !0,
  category: "people"
}, Z8 = {
  keywords: [
    "business",
    "manager",
    "man",
    "human"
  ],
  char: "👨‍💼",
  fitzpatrick_scale: !0,
  category: "people"
}, Y8 = {
  keywords: [
    "plumber",
    "woman",
    "human",
    "wrench"
  ],
  char: "👩‍🔧",
  fitzpatrick_scale: !0,
  category: "people"
}, X8 = {
  keywords: [
    "plumber",
    "man",
    "human",
    "wrench"
  ],
  char: "👨‍🔧",
  fitzpatrick_scale: !0,
  category: "people"
}, J8 = {
  keywords: [
    "biologist",
    "chemist",
    "engineer",
    "physicist",
    "woman",
    "human"
  ],
  char: "👩‍🔬",
  fitzpatrick_scale: !0,
  category: "people"
}, Q8 = {
  keywords: [
    "biologist",
    "chemist",
    "engineer",
    "physicist",
    "man",
    "human"
  ],
  char: "👨‍🔬",
  fitzpatrick_scale: !0,
  category: "people"
}, $8 = {
  keywords: [
    "painter",
    "woman",
    "human"
  ],
  char: "👩‍🎨",
  fitzpatrick_scale: !0,
  category: "people"
}, eA = {
  keywords: [
    "painter",
    "man",
    "human"
  ],
  char: "👨‍🎨",
  fitzpatrick_scale: !0,
  category: "people"
}, tA = {
  keywords: [
    "fireman",
    "woman",
    "human"
  ],
  char: "👩‍🚒",
  fitzpatrick_scale: !0,
  category: "people"
}, aA = {
  keywords: [
    "fireman",
    "man",
    "human"
  ],
  char: "👨‍🚒",
  fitzpatrick_scale: !0,
  category: "people"
}, rA = {
  keywords: [
    "aviator",
    "plane",
    "woman",
    "human"
  ],
  char: "👩‍✈️",
  fitzpatrick_scale: !0,
  category: "people"
}, nA = {
  keywords: [
    "aviator",
    "plane",
    "man",
    "human"
  ],
  char: "👨‍✈️",
  fitzpatrick_scale: !0,
  category: "people"
}, oA = {
  keywords: [
    "space",
    "rocket",
    "woman",
    "human"
  ],
  char: "👩‍🚀",
  fitzpatrick_scale: !0,
  category: "people"
}, sA = {
  keywords: [
    "space",
    "rocket",
    "man",
    "human"
  ],
  char: "👨‍🚀",
  fitzpatrick_scale: !0,
  category: "people"
}, iA = {
  keywords: [
    "justice",
    "court",
    "woman",
    "human"
  ],
  char: "👩‍⚖️",
  fitzpatrick_scale: !0,
  category: "people"
}, lA = {
  keywords: [
    "justice",
    "court",
    "man",
    "human"
  ],
  char: "👨‍⚖️",
  fitzpatrick_scale: !0,
  category: "people"
}, cA = {
  keywords: [
    "woman",
    "female",
    "good",
    "heroine",
    "superpowers"
  ],
  char: "🦸‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, uA = {
  keywords: [
    "man",
    "male",
    "good",
    "hero",
    "superpowers"
  ],
  char: "🦸‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, dA = {
  keywords: [
    "woman",
    "female",
    "evil",
    "bad",
    "criminal",
    "heroine",
    "superpowers"
  ],
  char: "🦹‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, fA = {
  keywords: [
    "man",
    "male",
    "evil",
    "bad",
    "criminal",
    "hero",
    "superpowers"
  ],
  char: "🦹‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, pA = {
  keywords: [
    "woman",
    "female",
    "xmas",
    "mother christmas"
  ],
  char: "🤶",
  fitzpatrick_scale: !0,
  category: "people"
}, yA = {
  keywords: [
    "festival",
    "man",
    "male",
    "xmas",
    "father christmas"
  ],
  char: "🎅",
  fitzpatrick_scale: !0,
  category: "people"
}, hA = {
  keywords: [
    "woman",
    "female",
    "mage",
    "witch"
  ],
  char: "🧙‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, gA = {
  keywords: [
    "man",
    "male",
    "mage",
    "sorcerer"
  ],
  char: "🧙‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, mA = {
  keywords: [
    "woman",
    "female"
  ],
  char: "🧝‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, _A = {
  keywords: [
    "man",
    "male"
  ],
  char: "🧝‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, wA = {
  keywords: [
    "woman",
    "female"
  ],
  char: "🧛‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, vA = {
  keywords: [
    "man",
    "male",
    "dracula"
  ],
  char: "🧛‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, bA = {
  keywords: [
    "woman",
    "female",
    "undead",
    "walking dead"
  ],
  char: "🧟‍♀️",
  fitzpatrick_scale: !1,
  category: "people"
}, kA = {
  keywords: [
    "man",
    "male",
    "dracula",
    "undead",
    "walking dead"
  ],
  char: "🧟‍♂️",
  fitzpatrick_scale: !1,
  category: "people"
}, xA = {
  keywords: [
    "woman",
    "female"
  ],
  char: "🧞‍♀️",
  fitzpatrick_scale: !1,
  category: "people"
}, zA = {
  keywords: [
    "man",
    "male"
  ],
  char: "🧞‍♂️",
  fitzpatrick_scale: !1,
  category: "people"
}, SA = {
  keywords: [
    "woman",
    "female",
    "merwoman",
    "ariel"
  ],
  char: "🧜‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, CA = {
  keywords: [
    "man",
    "male",
    "triton"
  ],
  char: "🧜‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, EA = {
  keywords: [
    "woman",
    "female"
  ],
  char: "🧚‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, AA = {
  keywords: [
    "man",
    "male"
  ],
  char: "🧚‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, TA = {
  keywords: [
    "heaven",
    "wings",
    "halo"
  ],
  char: "👼",
  fitzpatrick_scale: !0,
  category: "people"
}, PA = {
  keywords: [
    "baby"
  ],
  char: "🤰",
  fitzpatrick_scale: !0,
  category: "people"
}, OA = {
  keywords: [
    "nursing",
    "baby"
  ],
  char: "🤱",
  fitzpatrick_scale: !0,
  category: "people"
}, MA = {
  keywords: [
    "girl",
    "woman",
    "female",
    "blond",
    "crown",
    "royal",
    "queen"
  ],
  char: "👸",
  fitzpatrick_scale: !0,
  category: "people"
}, IA = {
  keywords: [
    "boy",
    "man",
    "male",
    "crown",
    "royal",
    "king"
  ],
  char: "🤴",
  fitzpatrick_scale: !0,
  category: "people"
}, FA = {
  keywords: [
    "couple",
    "marriage",
    "wedding",
    "woman",
    "bride"
  ],
  char: "👰",
  fitzpatrick_scale: !0,
  category: "people"
}, jA = {
  keywords: [
    "couple",
    "marriage",
    "wedding",
    "groom"
  ],
  char: "🤵",
  fitzpatrick_scale: !0,
  category: "people"
}, RA = {
  keywords: [
    "woman",
    "walking",
    "exercise",
    "race",
    "running",
    "female"
  ],
  char: "🏃‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, LA = {
  keywords: [
    "man",
    "walking",
    "exercise",
    "race",
    "running"
  ],
  char: "🏃",
  fitzpatrick_scale: !0,
  category: "people"
}, DA = {
  keywords: [
    "human",
    "feet",
    "steps",
    "woman",
    "female"
  ],
  char: "🚶‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, NA = {
  keywords: [
    "human",
    "feet",
    "steps"
  ],
  char: "🚶",
  fitzpatrick_scale: !0,
  category: "people"
}, VA = {
  keywords: [
    "female",
    "girl",
    "woman",
    "fun"
  ],
  char: "💃",
  fitzpatrick_scale: !0,
  category: "people"
}, qA = {
  keywords: [
    "male",
    "boy",
    "fun",
    "dancer"
  ],
  char: "🕺",
  fitzpatrick_scale: !0,
  category: "people"
}, BA = {
  keywords: [
    "female",
    "bunny",
    "women",
    "girls"
  ],
  char: "👯",
  fitzpatrick_scale: !1,
  category: "people"
}, WA = {
  keywords: [
    "male",
    "bunny",
    "men",
    "boys"
  ],
  char: "👯‍♂️",
  fitzpatrick_scale: !1,
  category: "people"
}, HA = {
  keywords: [
    "pair",
    "people",
    "human",
    "love",
    "date",
    "dating",
    "like",
    "affection",
    "valentines",
    "marriage"
  ],
  char: "👫",
  fitzpatrick_scale: !1,
  category: "people"
}, UA = {
  keywords: [
    "pair",
    "couple",
    "love",
    "like",
    "bromance",
    "friendship",
    "people",
    "human"
  ],
  char: "👬",
  fitzpatrick_scale: !1,
  category: "people"
}, GA = {
  keywords: [
    "pair",
    "friendship",
    "couple",
    "love",
    "like",
    "female",
    "people",
    "human"
  ],
  char: "👭",
  fitzpatrick_scale: !1,
  category: "people"
}, KA = {
  keywords: [
    "woman",
    "female",
    "girl"
  ],
  char: "🙇‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, ZA = {
  keywords: [
    "man",
    "male",
    "boy"
  ],
  char: "🙇",
  fitzpatrick_scale: !0,
  category: "people"
}, YA = {
  keywords: [
    "man",
    "male",
    "boy",
    "disbelief"
  ],
  char: "🤦‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, XA = {
  keywords: [
    "woman",
    "female",
    "girl",
    "disbelief"
  ],
  char: "🤦‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, JA = {
  keywords: [
    "woman",
    "female",
    "girl",
    "confused",
    "indifferent",
    "doubt"
  ],
  char: "🤷",
  fitzpatrick_scale: !0,
  category: "people"
}, QA = {
  keywords: [
    "man",
    "male",
    "boy",
    "confused",
    "indifferent",
    "doubt"
  ],
  char: "🤷‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, $A = {
  keywords: [
    "female",
    "girl",
    "woman",
    "human",
    "information"
  ],
  char: "💁",
  fitzpatrick_scale: !0,
  category: "people"
}, eT = {
  keywords: [
    "male",
    "boy",
    "man",
    "human",
    "information"
  ],
  char: "💁‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, tT = {
  keywords: [
    "female",
    "girl",
    "woman",
    "nope"
  ],
  char: "🙅",
  fitzpatrick_scale: !0,
  category: "people"
}, aT = {
  keywords: [
    "male",
    "boy",
    "man",
    "nope"
  ],
  char: "🙅‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, rT = {
  keywords: [
    "women",
    "girl",
    "female",
    "pink",
    "human",
    "woman"
  ],
  char: "🙆",
  fitzpatrick_scale: !0,
  category: "people"
}, nT = {
  keywords: [
    "men",
    "boy",
    "male",
    "blue",
    "human",
    "man"
  ],
  char: "🙆‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, oT = {
  keywords: [
    "female",
    "girl",
    "woman"
  ],
  char: "🙋",
  fitzpatrick_scale: !0,
  category: "people"
}, sT = {
  keywords: [
    "male",
    "boy",
    "man"
  ],
  char: "🙋‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, iT = {
  keywords: [
    "female",
    "girl",
    "woman"
  ],
  char: "🙎",
  fitzpatrick_scale: !0,
  category: "people"
}, lT = {
  keywords: [
    "male",
    "boy",
    "man"
  ],
  char: "🙎‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, cT = {
  keywords: [
    "female",
    "girl",
    "woman",
    "sad",
    "depressed",
    "discouraged",
    "unhappy"
  ],
  char: "🙍",
  fitzpatrick_scale: !0,
  category: "people"
}, uT = {
  keywords: [
    "male",
    "boy",
    "man",
    "sad",
    "depressed",
    "discouraged",
    "unhappy"
  ],
  char: "🙍‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, dT = {
  keywords: [
    "female",
    "girl",
    "woman"
  ],
  char: "💇",
  fitzpatrick_scale: !0,
  category: "people"
}, fT = {
  keywords: [
    "male",
    "boy",
    "man"
  ],
  char: "💇‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, pT = {
  keywords: [
    "female",
    "girl",
    "woman",
    "head"
  ],
  char: "💆",
  fitzpatrick_scale: !0,
  category: "people"
}, yT = {
  keywords: [
    "male",
    "boy",
    "man",
    "head"
  ],
  char: "💆‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, hT = {
  keywords: [
    "female",
    "woman",
    "spa",
    "steamroom",
    "sauna"
  ],
  char: "🧖‍♀️",
  fitzpatrick_scale: !0,
  category: "people"
}, gT = {
  keywords: [
    "male",
    "man",
    "spa",
    "steamroom",
    "sauna"
  ],
  char: "🧖‍♂️",
  fitzpatrick_scale: !0,
  category: "people"
}, mT = {
  keywords: [
    "pair",
    "love",
    "like",
    "affection",
    "human",
    "dating",
    "valentines",
    "marriage"
  ],
  char: "💑",
  fitzpatrick_scale: !1,
  category: "people"
}, _T = {
  keywords: [
    "pair",
    "love",
    "like",
    "affection",
    "human",
    "dating",
    "valentines",
    "marriage"
  ],
  char: "👩‍❤️‍👩",
  fitzpatrick_scale: !1,
  category: "people"
}, wT = {
  keywords: [
    "pair",
    "love",
    "like",
    "affection",
    "human",
    "dating",
    "valentines",
    "marriage"
  ],
  char: "👨‍❤️‍👨",
  fitzpatrick_scale: !1,
  category: "people"
}, vT = {
  keywords: [
    "pair",
    "valentines",
    "love",
    "like",
    "dating",
    "marriage"
  ],
  char: "💏",
  fitzpatrick_scale: !1,
  category: "people"
}, bT = {
  keywords: [
    "pair",
    "valentines",
    "love",
    "like",
    "dating",
    "marriage"
  ],
  char: "👩‍❤️‍💋‍👩",
  fitzpatrick_scale: !1,
  category: "people"
}, kT = {
  keywords: [
    "pair",
    "valentines",
    "love",
    "like",
    "dating",
    "marriage"
  ],
  char: "👨‍❤️‍💋‍👨",
  fitzpatrick_scale: !1,
  category: "people"
}, xT = {
  keywords: [
    "home",
    "parents",
    "child",
    "mom",
    "dad",
    "father",
    "mother",
    "people",
    "human"
  ],
  char: "👪",
  fitzpatrick_scale: !1,
  category: "people"
}, zT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "child"
  ],
  char: "👨‍👩‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, ST = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👩‍👧‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, CT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👩‍👦‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, ET = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👩‍👧‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, AT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👩‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, TT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👩‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, PT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👩‍👧‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, OT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👩‍👦‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, MT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👩‍👧‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, IT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👨‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, FT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👨‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, jT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👨‍👧‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, RT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👨‍👦‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, LT = {
  keywords: [
    "home",
    "parents",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👨‍👧‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, DT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "child"
  ],
  char: "👩‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, NT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "child"
  ],
  char: "👩‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, VT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👧‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, qT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👦‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, BT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👩‍👧‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, WT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "child"
  ],
  char: "👨‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, HT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "child"
  ],
  char: "👨‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, UT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👧‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, GT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👦‍👦",
  fitzpatrick_scale: !1,
  category: "people"
}, KT = {
  keywords: [
    "home",
    "parent",
    "people",
    "human",
    "children"
  ],
  char: "👨‍👧‍👧",
  fitzpatrick_scale: !1,
  category: "people"
}, ZT = {
  keywords: [
    "ball",
    "crochet",
    "knit"
  ],
  char: "🧶",
  fitzpatrick_scale: !1,
  category: "people"
}, YT = {
  keywords: [
    "needle",
    "sewing",
    "spool",
    "string"
  ],
  char: "🧵",
  fitzpatrick_scale: !1,
  category: "people"
}, XT = {
  keywords: [
    "jacket"
  ],
  char: "🧥",
  fitzpatrick_scale: !1,
  category: "people"
}, JT = {
  keywords: [
    "doctor",
    "experiment",
    "scientist",
    "chemist"
  ],
  char: "🥼",
  fitzpatrick_scale: !1,
  category: "people"
}, QT = {
  keywords: [
    "fashion",
    "shopping_bags",
    "female"
  ],
  char: "👚",
  fitzpatrick_scale: !1,
  category: "people"
}, $T = {
  keywords: [
    "fashion",
    "cloth",
    "casual",
    "shirt",
    "tee"
  ],
  char: "👕",
  fitzpatrick_scale: !1,
  category: "people"
}, e7 = {
  keywords: [
    "fashion",
    "shopping"
  ],
  char: "👖",
  fitzpatrick_scale: !1,
  category: "people"
}, t7 = {
  keywords: [
    "shirt",
    "suitup",
    "formal",
    "fashion",
    "cloth",
    "business"
  ],
  char: "👔",
  fitzpatrick_scale: !1,
  category: "people"
}, a7 = {
  keywords: [
    "clothes",
    "fashion",
    "shopping"
  ],
  char: "👗",
  fitzpatrick_scale: !1,
  category: "people"
}, r7 = {
  keywords: [
    "swimming",
    "female",
    "woman",
    "girl",
    "fashion",
    "beach",
    "summer"
  ],
  char: "👙",
  fitzpatrick_scale: !1,
  category: "people"
}, n7 = {
  keywords: [
    "dress",
    "fashion",
    "women",
    "female",
    "japanese"
  ],
  char: "👘",
  fitzpatrick_scale: !1,
  category: "people"
}, o7 = {
  keywords: [
    "female",
    "girl",
    "fashion",
    "woman"
  ],
  char: "💄",
  fitzpatrick_scale: !1,
  category: "people"
}, s7 = {
  keywords: [
    "face",
    "lips",
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💋",
  fitzpatrick_scale: !1,
  category: "people"
}, i7 = {
  keywords: [
    "feet",
    "tracking",
    "walking",
    "beach"
  ],
  char: "👣",
  fitzpatrick_scale: !1,
  category: "people"
}, l7 = {
  keywords: [
    "ballet",
    "slip-on",
    "slipper"
  ],
  char: "🥿",
  fitzpatrick_scale: !1,
  category: "people"
}, c7 = {
  keywords: [
    "fashion",
    "shoes",
    "female",
    "pumps",
    "stiletto"
  ],
  char: "👠",
  fitzpatrick_scale: !1,
  category: "people"
}, u7 = {
  keywords: [
    "shoes",
    "fashion",
    "flip flops"
  ],
  char: "👡",
  fitzpatrick_scale: !1,
  category: "people"
}, d7 = {
  keywords: [
    "shoes",
    "fashion"
  ],
  char: "👢",
  fitzpatrick_scale: !1,
  category: "people"
}, f7 = {
  keywords: [
    "fashion",
    "male"
  ],
  char: "👞",
  fitzpatrick_scale: !1,
  category: "people"
}, p7 = {
  keywords: [
    "shoes",
    "sports",
    "sneakers"
  ],
  char: "👟",
  fitzpatrick_scale: !1,
  category: "people"
}, y7 = {
  keywords: [
    "backpacking",
    "camping",
    "hiking"
  ],
  char: "🥾",
  fitzpatrick_scale: !1,
  category: "people"
}, h7 = {
  keywords: [
    "stockings",
    "clothes"
  ],
  char: "🧦",
  fitzpatrick_scale: !1,
  category: "people"
}, g7 = {
  keywords: [
    "hands",
    "winter",
    "clothes"
  ],
  char: "🧤",
  fitzpatrick_scale: !1,
  category: "people"
}, m7 = {
  keywords: [
    "neck",
    "winter",
    "clothes"
  ],
  char: "🧣",
  fitzpatrick_scale: !1,
  category: "people"
}, _7 = {
  keywords: [
    "fashion",
    "accessories",
    "female",
    "lady",
    "spring"
  ],
  char: "👒",
  fitzpatrick_scale: !1,
  category: "people"
}, w7 = {
  keywords: [
    "magic",
    "gentleman",
    "classy",
    "circus"
  ],
  char: "🎩",
  fitzpatrick_scale: !1,
  category: "people"
}, v7 = {
  keywords: [
    "cap",
    "baseball"
  ],
  char: "🧢",
  fitzpatrick_scale: !1,
  category: "people"
}, b7 = {
  keywords: [
    "construction",
    "build"
  ],
  char: "⛑",
  fitzpatrick_scale: !1,
  category: "people"
}, k7 = {
  keywords: [
    "school",
    "college",
    "degree",
    "university",
    "graduation",
    "cap",
    "hat",
    "legal",
    "learn",
    "education"
  ],
  char: "🎓",
  fitzpatrick_scale: !1,
  category: "people"
}, x7 = {
  keywords: [
    "king",
    "kod",
    "leader",
    "royalty",
    "lord"
  ],
  char: "👑",
  fitzpatrick_scale: !1,
  category: "people"
}, z7 = {
  keywords: [
    "student",
    "education",
    "bag",
    "backpack"
  ],
  char: "🎒",
  fitzpatrick_scale: !1,
  category: "people"
}, S7 = {
  keywords: [
    "packing",
    "travel"
  ],
  char: "🧳",
  fitzpatrick_scale: !1,
  category: "people"
}, C7 = {
  keywords: [
    "bag",
    "accessories",
    "shopping"
  ],
  char: "👝",
  fitzpatrick_scale: !1,
  category: "people"
}, E7 = {
  keywords: [
    "fashion",
    "accessories",
    "money",
    "sales",
    "shopping"
  ],
  char: "👛",
  fitzpatrick_scale: !1,
  category: "people"
}, A7 = {
  keywords: [
    "fashion",
    "accessory",
    "accessories",
    "shopping"
  ],
  char: "👜",
  fitzpatrick_scale: !1,
  category: "people"
}, T7 = {
  keywords: [
    "business",
    "documents",
    "work",
    "law",
    "legal",
    "job",
    "career"
  ],
  char: "💼",
  fitzpatrick_scale: !1,
  category: "people"
}, P7 = {
  keywords: [
    "fashion",
    "accessories",
    "eyesight",
    "nerdy",
    "dork",
    "geek"
  ],
  char: "👓",
  fitzpatrick_scale: !1,
  category: "people"
}, O7 = {
  keywords: [
    "face",
    "cool",
    "accessories"
  ],
  char: "🕶",
  fitzpatrick_scale: !1,
  category: "people"
}, M7 = {
  keywords: [
    "eyes",
    "protection",
    "safety"
  ],
  char: "🥽",
  fitzpatrick_scale: !1,
  category: "people"
}, I7 = {
  keywords: [
    "wedding",
    "propose",
    "marriage",
    "valentines",
    "diamond",
    "fashion",
    "jewelry",
    "gem",
    "engagement"
  ],
  char: "💍",
  fitzpatrick_scale: !1,
  category: "people"
}, F7 = {
  keywords: [
    "weather",
    "rain",
    "drizzle"
  ],
  char: "🌂",
  fitzpatrick_scale: !1,
  category: "people"
}, j7 = {
  keywords: [
    "animal",
    "friend",
    "nature",
    "woof",
    "puppy",
    "pet",
    "faithful"
  ],
  char: "🐶",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, R7 = {
  keywords: [
    "animal",
    "meow",
    "nature",
    "pet",
    "kitten"
  ],
  char: "🐱",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, L7 = {
  keywords: [
    "animal",
    "nature",
    "cheese_wedge",
    "rodent"
  ],
  char: "🐭",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, D7 = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐹",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, N7 = {
  keywords: [
    "animal",
    "nature",
    "pet",
    "spring",
    "magic",
    "bunny"
  ],
  char: "🐰",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, V7 = {
  keywords: [
    "animal",
    "nature",
    "face"
  ],
  char: "🦊",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, q7 = {
  keywords: [
    "animal",
    "nature",
    "wild"
  ],
  char: "🐻",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, B7 = {
  keywords: [
    "animal",
    "nature",
    "panda"
  ],
  char: "🐼",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, W7 = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐨",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, H7 = {
  keywords: [
    "animal",
    "cat",
    "danger",
    "wild",
    "nature",
    "roar"
  ],
  char: "🐯",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, U7 = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🦁",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, G7 = {
  keywords: [
    "beef",
    "ox",
    "animal",
    "nature",
    "moo",
    "milk"
  ],
  char: "🐮",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, K7 = {
  keywords: [
    "animal",
    "oink",
    "nature"
  ],
  char: "🐷",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, Z7 = {
  keywords: [
    "animal",
    "oink"
  ],
  char: "🐽",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, Y7 = {
  keywords: [
    "animal",
    "nature",
    "croak",
    "toad"
  ],
  char: "🐸",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, X7 = {
  keywords: [
    "animal",
    "nature",
    "ocean",
    "sea"
  ],
  char: "🦑",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, J7 = {
  keywords: [
    "animal",
    "creature",
    "ocean",
    "sea",
    "nature",
    "beach"
  ],
  char: "🐙",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, Q7 = {
  keywords: [
    "animal",
    "ocean",
    "nature",
    "seafood"
  ],
  char: "🦐",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, $7 = {
  keywords: [
    "animal",
    "nature",
    "circus"
  ],
  char: "🐵",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, eP = {
  keywords: [
    "animal",
    "nature",
    "circus"
  ],
  char: "🦍",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, tP = {
  keywords: [
    "monkey",
    "animal",
    "nature",
    "haha"
  ],
  char: "🙈",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, aP = {
  keywords: [
    "animal",
    "monkey",
    "nature"
  ],
  char: "🙉",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, rP = {
  keywords: [
    "monkey",
    "animal",
    "nature",
    "omg"
  ],
  char: "🙊",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, nP = {
  keywords: [
    "animal",
    "nature",
    "banana",
    "circus"
  ],
  char: "🐒",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, oP = {
  keywords: [
    "animal",
    "cluck",
    "nature",
    "bird"
  ],
  char: "🐔",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, sP = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐧",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, iP = {
  keywords: [
    "animal",
    "nature",
    "fly",
    "tweet",
    "spring"
  ],
  char: "🐦",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, lP = {
  keywords: [
    "animal",
    "chicken",
    "bird"
  ],
  char: "🐤",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, cP = {
  keywords: [
    "animal",
    "chicken",
    "egg",
    "born",
    "baby",
    "bird"
  ],
  char: "🐣",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, uP = {
  keywords: [
    "animal",
    "chicken",
    "baby",
    "bird"
  ],
  char: "🐥",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, dP = {
  keywords: [
    "animal",
    "nature",
    "bird",
    "mallard"
  ],
  char: "🦆",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, fP = {
  keywords: [
    "animal",
    "nature",
    "bird"
  ],
  char: "🦅",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, pP = {
  keywords: [
    "animal",
    "nature",
    "bird",
    "hoot"
  ],
  char: "🦉",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, yP = {
  keywords: [
    "animal",
    "nature",
    "blind",
    "vampire"
  ],
  char: "🦇",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, hP = {
  keywords: [
    "animal",
    "nature",
    "wild"
  ],
  char: "🐺",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, gP = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐗",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, mP = {
  keywords: [
    "animal",
    "brown",
    "nature"
  ],
  char: "🐴",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, _P = {
  keywords: [
    "animal",
    "nature",
    "mystical"
  ],
  char: "🦄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, wP = {
  keywords: [
    "animal",
    "insect",
    "nature",
    "bug",
    "spring",
    "honey"
  ],
  char: "🐝",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, vP = {
  keywords: [
    "animal",
    "insect",
    "nature",
    "worm"
  ],
  char: "🐛",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, bP = {
  keywords: [
    "animal",
    "insect",
    "nature",
    "caterpillar"
  ],
  char: "🦋",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, kP = {
  keywords: [
    "slow",
    "animal",
    "shell"
  ],
  char: "🐌",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, xP = {
  keywords: [
    "animal",
    "insect",
    "nature",
    "ladybug"
  ],
  char: "🐞",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, zP = {
  keywords: [
    "animal",
    "insect",
    "nature",
    "bug"
  ],
  char: "🐜",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, SP = {
  keywords: [
    "animal",
    "cricket",
    "chirp"
  ],
  char: "🦗",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, CP = {
  keywords: [
    "animal",
    "arachnid"
  ],
  char: "🕷",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, EP = {
  keywords: [
    "animal",
    "arachnid"
  ],
  char: "🦂",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, AP = {
  keywords: [
    "animal",
    "crustacean"
  ],
  char: "🦀",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, TP = {
  keywords: [
    "animal",
    "evil",
    "nature",
    "hiss",
    "python"
  ],
  char: "🐍",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, PP = {
  keywords: [
    "animal",
    "nature",
    "reptile"
  ],
  char: "🦎",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, OP = {
  keywords: [
    "animal",
    "nature",
    "dinosaur",
    "brachiosaurus",
    "brontosaurus",
    "diplodocus",
    "extinct"
  ],
  char: "🦕",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, MP = {
  keywords: [
    "animal",
    "slow",
    "nature",
    "tortoise"
  ],
  char: "🐢",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, IP = {
  keywords: [
    "animal",
    "swim",
    "ocean",
    "beach",
    "nemo"
  ],
  char: "🐠",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, FP = {
  keywords: [
    "animal",
    "food",
    "nature"
  ],
  char: "🐟",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, jP = {
  keywords: [
    "animal",
    "nature",
    "food",
    "sea",
    "ocean"
  ],
  char: "🐡",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, RP = {
  keywords: [
    "animal",
    "nature",
    "fish",
    "sea",
    "ocean",
    "flipper",
    "fins",
    "beach"
  ],
  char: "🐬",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, LP = {
  keywords: [
    "animal",
    "nature",
    "fish",
    "sea",
    "ocean",
    "jaws",
    "fins",
    "beach"
  ],
  char: "🦈",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, DP = {
  keywords: [
    "animal",
    "nature",
    "sea",
    "ocean"
  ],
  char: "🐳",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, NP = {
  keywords: [
    "animal",
    "nature",
    "sea",
    "ocean"
  ],
  char: "🐋",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, VP = {
  keywords: [
    "animal",
    "nature",
    "reptile",
    "lizard",
    "alligator"
  ],
  char: "🐊",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, qP = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐆",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, BP = {
  keywords: [
    "animal",
    "nature",
    "stripes",
    "safari"
  ],
  char: "🦓",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, WP = {
  keywords: [
    "animal",
    "nature",
    "roar"
  ],
  char: "🐅",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, HP = {
  keywords: [
    "animal",
    "nature",
    "ox",
    "cow"
  ],
  char: "🐃",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, UP = {
  keywords: [
    "animal",
    "cow",
    "beef"
  ],
  char: "🐂",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, GP = {
  keywords: [
    "beef",
    "ox",
    "animal",
    "nature",
    "moo",
    "milk"
  ],
  char: "🐄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, KP = {
  keywords: [
    "animal",
    "nature",
    "horns",
    "venison"
  ],
  char: "🦌",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, ZP = {
  keywords: [
    "animal",
    "hot",
    "desert",
    "hump"
  ],
  char: "🐪",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, YP = {
  keywords: [
    "animal",
    "nature",
    "hot",
    "desert",
    "hump"
  ],
  char: "🐫",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, XP = {
  keywords: [
    "animal",
    "nature",
    "spots",
    "safari"
  ],
  char: "🦒",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, JP = {
  keywords: [
    "animal",
    "nature",
    "nose",
    "th",
    "circus"
  ],
  char: "🐘",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, QP = {
  keywords: [
    "animal",
    "nature",
    "horn"
  ],
  char: "🦏",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, $P = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐐",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, eO = {
  keywords: [
    "animal",
    "sheep",
    "nature"
  ],
  char: "🐏",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, tO = {
  keywords: [
    "animal",
    "nature",
    "wool",
    "shipit"
  ],
  char: "🐑",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, aO = {
  keywords: [
    "animal",
    "gamble",
    "luck"
  ],
  char: "🐎",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, rO = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🐖",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, nO = {
  keywords: [
    "animal",
    "mouse",
    "rodent"
  ],
  char: "🐀",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, oO = {
  keywords: [
    "animal",
    "nature",
    "rodent"
  ],
  char: "🐁",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, sO = {
  keywords: [
    "animal",
    "nature",
    "chicken"
  ],
  char: "🐓",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, iO = {
  keywords: [
    "animal",
    "bird"
  ],
  char: "🦃",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, lO = {
  keywords: [
    "animal",
    "bird"
  ],
  char: "🕊",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, cO = {
  keywords: [
    "animal",
    "nature",
    "friend",
    "doge",
    "pet",
    "faithful"
  ],
  char: "🐕",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, uO = {
  keywords: [
    "dog",
    "animal",
    "101",
    "nature",
    "pet"
  ],
  char: "🐩",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, dO = {
  keywords: [
    "animal",
    "meow",
    "pet",
    "cats"
  ],
  char: "🐈",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, fO = {
  keywords: [
    "animal",
    "nature",
    "pet",
    "magic",
    "spring"
  ],
  char: "🐇",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, pO = {
  keywords: [
    "animal",
    "nature",
    "rodent",
    "squirrel"
  ],
  char: "🐿",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, yO = {
  keywords: [
    "animal",
    "nature",
    "spiny"
  ],
  char: "🦔",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, hO = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🦝",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, gO = {
  keywords: [
    "animal",
    "nature",
    "alpaca"
  ],
  char: "🦙",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, mO = {
  keywords: [
    "animal",
    "nature"
  ],
  char: "🦛",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, _O = {
  keywords: [
    "animal",
    "nature",
    "australia",
    "joey",
    "hop",
    "marsupial"
  ],
  char: "🦘",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, wO = {
  keywords: [
    "animal",
    "nature",
    "honey"
  ],
  char: "🦡",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, vO = {
  keywords: [
    "animal",
    "nature",
    "bird"
  ],
  char: "🦢",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, bO = {
  keywords: [
    "animal",
    "nature",
    "peahen",
    "bird"
  ],
  char: "🦚",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, kO = {
  keywords: [
    "animal",
    "nature",
    "bird",
    "pirate",
    "talk"
  ],
  char: "🦜",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, xO = {
  keywords: [
    "animal",
    "nature",
    "bisque",
    "claws",
    "seafood"
  ],
  char: "🦞",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, zO = {
  keywords: [
    "animal",
    "nature",
    "insect",
    "malaria"
  ],
  char: "🦟",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, SO = {
  keywords: [
    "animal",
    "tracking",
    "footprints",
    "dog",
    "cat",
    "pet",
    "feet"
  ],
  char: "🐾",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, CO = {
  keywords: [
    "animal",
    "myth",
    "nature",
    "chinese",
    "green"
  ],
  char: "🐉",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, EO = {
  keywords: [
    "animal",
    "myth",
    "nature",
    "chinese",
    "green"
  ],
  char: "🐲",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, AO = {
  keywords: [
    "vegetable",
    "plant",
    "nature"
  ],
  char: "🌵",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, TO = {
  keywords: [
    "festival",
    "vacation",
    "december",
    "xmas",
    "celebration"
  ],
  char: "🎄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, PO = {
  keywords: [
    "plant",
    "nature"
  ],
  char: "🌲",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, OO = {
  keywords: [
    "plant",
    "nature"
  ],
  char: "🌳",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, MO = {
  keywords: [
    "plant",
    "vegetable",
    "nature",
    "summer",
    "beach",
    "mojito",
    "tropical"
  ],
  char: "🌴",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, IO = {
  keywords: [
    "plant",
    "nature",
    "grass",
    "lawn",
    "spring"
  ],
  char: "🌱",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, FO = {
  keywords: [
    "vegetable",
    "plant",
    "medicine",
    "weed",
    "grass",
    "lawn"
  ],
  char: "🌿",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, jO = {
  keywords: [
    "vegetable",
    "plant",
    "nature",
    "irish",
    "clover"
  ],
  char: "☘",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, RO = {
  keywords: [
    "vegetable",
    "plant",
    "nature",
    "lucky",
    "irish"
  ],
  char: "🍀",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, LO = {
  keywords: [
    "plant",
    "nature",
    "vegetable",
    "panda",
    "pine_decoration"
  ],
  char: "🎍",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, DO = {
  keywords: [
    "plant",
    "nature",
    "branch",
    "summer"
  ],
  char: "🎋",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, NO = {
  keywords: [
    "nature",
    "plant",
    "tree",
    "vegetable",
    "grass",
    "lawn",
    "spring"
  ],
  char: "🍃",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, VO = {
  keywords: [
    "nature",
    "plant",
    "vegetable",
    "leaves"
  ],
  char: "🍂",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, qO = {
  keywords: [
    "nature",
    "plant",
    "vegetable",
    "ca",
    "fall"
  ],
  char: "🍁",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, BO = {
  keywords: [
    "nature",
    "plant"
  ],
  char: "🌾",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, WO = {
  keywords: [
    "plant",
    "vegetable",
    "flowers",
    "beach"
  ],
  char: "🌺",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, HO = {
  keywords: [
    "nature",
    "plant",
    "fall"
  ],
  char: "🌻",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, UO = {
  keywords: [
    "flowers",
    "valentines",
    "love",
    "spring"
  ],
  char: "🌹",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, GO = {
  keywords: [
    "plant",
    "nature",
    "flower"
  ],
  char: "🥀",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, KO = {
  keywords: [
    "flowers",
    "plant",
    "nature",
    "summer",
    "spring"
  ],
  char: "🌷",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, ZO = {
  keywords: [
    "nature",
    "flowers",
    "yellow"
  ],
  char: "🌼",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, YO = {
  keywords: [
    "nature",
    "plant",
    "spring",
    "flower"
  ],
  char: "🌸",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, XO = {
  keywords: [
    "flowers",
    "nature",
    "spring"
  ],
  char: "💐",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, JO = {
  keywords: [
    "plant",
    "vegetable"
  ],
  char: "🍄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, QO = {
  keywords: [
    "food",
    "squirrel"
  ],
  char: "🌰",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, $O = {
  keywords: [
    "halloween",
    "light",
    "pumpkin",
    "creepy",
    "fall"
  ],
  char: "🎃",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, eM = {
  keywords: [
    "nature",
    "sea",
    "beach"
  ],
  char: "🐚",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, tM = {
  keywords: [
    "animal",
    "insect",
    "arachnid",
    "silk"
  ],
  char: "🕸",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, aM = {
  keywords: [
    "globe",
    "world",
    "USA",
    "international"
  ],
  char: "🌎",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, rM = {
  keywords: [
    "globe",
    "world",
    "international"
  ],
  char: "🌍",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, nM = {
  keywords: [
    "globe",
    "world",
    "east",
    "international"
  ],
  char: "🌏",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, oM = {
  keywords: [
    "nature",
    "yellow",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌕",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, sM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep",
    "waxing_gibbous_moon"
  ],
  char: "🌖",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, iM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌗",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, lM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌘",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, cM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌑",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, uM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌒",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, dM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌓",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, fM = {
  keywords: [
    "nature",
    "night",
    "sky",
    "gray",
    "twilight",
    "planet",
    "space",
    "evening",
    "sleep"
  ],
  char: "🌔",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, pM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌚",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, yM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌝",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, hM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌛",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, gM = {
  keywords: [
    "nature",
    "twilight",
    "planet",
    "space",
    "night",
    "evening",
    "sleep"
  ],
  char: "🌜",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, mM = {
  keywords: [
    "nature",
    "morning",
    "sky"
  ],
  char: "🌞",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, _M = {
  keywords: [
    "night",
    "sleep",
    "sky",
    "evening",
    "magic"
  ],
  char: "🌙",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, wM = {
  keywords: [
    "night",
    "yellow"
  ],
  char: "⭐",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, vM = {
  keywords: [
    "night",
    "sparkle",
    "awesome",
    "good",
    "magic"
  ],
  char: "🌟",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, bM = {
  keywords: [
    "star",
    "sparkle",
    "shoot",
    "magic"
  ],
  char: "💫",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, kM = {
  keywords: [
    "stars",
    "shine",
    "shiny",
    "cool",
    "awesome",
    "good",
    "magic"
  ],
  char: "✨",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, xM = {
  keywords: [
    "space"
  ],
  char: "☄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, zM = {
  keywords: [
    "weather",
    "nature",
    "brightness",
    "summer",
    "beach",
    "spring"
  ],
  char: "☀️",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, SM = {
  keywords: [
    "weather"
  ],
  char: "🌤",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, CM = {
  keywords: [
    "weather",
    "nature",
    "cloudy",
    "morning",
    "fall",
    "spring"
  ],
  char: "⛅",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, EM = {
  keywords: [
    "weather"
  ],
  char: "🌥",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, AM = {
  keywords: [
    "weather"
  ],
  char: "🌦",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, TM = {
  keywords: [
    "weather",
    "sky"
  ],
  char: "☁️",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, PM = {
  keywords: [
    "weather"
  ],
  char: "🌧",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, OM = {
  keywords: [
    "weather",
    "lightning"
  ],
  char: "⛈",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, MM = {
  keywords: [
    "weather",
    "thunder"
  ],
  char: "🌩",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, IM = {
  keywords: [
    "thunder",
    "weather",
    "lightning bolt",
    "fast"
  ],
  char: "⚡",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, FM = {
  keywords: [
    "hot",
    "cook",
    "flame"
  ],
  char: "🔥",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, jM = {
  keywords: [
    "bomb",
    "explode",
    "explosion",
    "collision",
    "blown"
  ],
  char: "💥",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, RM = {
  keywords: [
    "winter",
    "season",
    "cold",
    "weather",
    "christmas",
    "xmas"
  ],
  char: "❄️",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, LM = {
  keywords: [
    "weather"
  ],
  char: "🌨",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, DM = {
  keywords: [
    "winter",
    "season",
    "cold",
    "weather",
    "christmas",
    "xmas",
    "frozen",
    "without_snow"
  ],
  char: "⛄",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, NM = {
  keywords: [
    "winter",
    "season",
    "cold",
    "weather",
    "christmas",
    "xmas",
    "frozen"
  ],
  char: "☃",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, VM = {
  keywords: [
    "gust",
    "air"
  ],
  char: "🌬",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, qM = {
  keywords: [
    "wind",
    "air",
    "fast",
    "shoo",
    "fart",
    "smoke",
    "puff"
  ],
  char: "💨",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, BM = {
  keywords: [
    "weather",
    "cyclone",
    "twister"
  ],
  char: "🌪",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, WM = {
  keywords: [
    "weather"
  ],
  char: "🌫",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, HM = {
  keywords: [
    "weather",
    "spring"
  ],
  char: "☂",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, UM = {
  keywords: [
    "rainy",
    "weather",
    "spring"
  ],
  char: "☔",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, GM = {
  keywords: [
    "water",
    "drip",
    "faucet",
    "spring"
  ],
  char: "💧",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, KM = {
  keywords: [
    "water",
    "drip",
    "oops"
  ],
  char: "💦",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, ZM = {
  keywords: [
    "sea",
    "water",
    "wave",
    "nature",
    "tsunami",
    "disaster"
  ],
  char: "🌊",
  fitzpatrick_scale: !1,
  category: "animals_and_nature"
}, YM = {
  keywords: [
    "fruit",
    "nature"
  ],
  char: "🍏",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, XM = {
  keywords: [
    "fruit",
    "mac",
    "school"
  ],
  char: "🍎",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, JM = {
  keywords: [
    "fruit",
    "nature",
    "food"
  ],
  char: "🍐",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, QM = {
  keywords: [
    "food",
    "fruit",
    "nature",
    "orange"
  ],
  char: "🍊",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, $M = {
  keywords: [
    "fruit",
    "nature"
  ],
  char: "🍋",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, eI = {
  keywords: [
    "fruit",
    "food",
    "monkey"
  ],
  char: "🍌",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, tI = {
  keywords: [
    "fruit",
    "food",
    "picnic",
    "summer"
  ],
  char: "🍉",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, aI = {
  keywords: [
    "fruit",
    "food",
    "wine"
  ],
  char: "🍇",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, rI = {
  keywords: [
    "fruit",
    "food",
    "nature"
  ],
  char: "🍓",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, nI = {
  keywords: [
    "fruit",
    "nature",
    "food"
  ],
  char: "🍈",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, oI = {
  keywords: [
    "food",
    "fruit"
  ],
  char: "🍒",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, sI = {
  keywords: [
    "fruit",
    "nature",
    "food"
  ],
  char: "🍑",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, iI = {
  keywords: [
    "fruit",
    "nature",
    "food"
  ],
  char: "🍍",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, lI = {
  keywords: [
    "fruit",
    "nature",
    "food",
    "palm"
  ],
  char: "🥥",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, cI = {
  keywords: [
    "fruit",
    "food"
  ],
  char: "🥝",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, uI = {
  keywords: [
    "fruit",
    "food",
    "tropical"
  ],
  char: "🥭",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, dI = {
  keywords: [
    "fruit",
    "food"
  ],
  char: "🥑",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, fI = {
  keywords: [
    "fruit",
    "food",
    "vegetable"
  ],
  char: "🥦",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, pI = {
  keywords: [
    "fruit",
    "vegetable",
    "nature",
    "food"
  ],
  char: "🍅",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, yI = {
  keywords: [
    "vegetable",
    "nature",
    "food",
    "aubergine"
  ],
  char: "🍆",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, hI = {
  keywords: [
    "fruit",
    "food",
    "pickle"
  ],
  char: "🥒",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, gI = {
  keywords: [
    "vegetable",
    "food",
    "orange"
  ],
  char: "🥕",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, mI = {
  keywords: [
    "food",
    "spicy",
    "chilli",
    "chili"
  ],
  char: "🌶",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, _I = {
  keywords: [
    "food",
    "tuber",
    "vegatable",
    "starch"
  ],
  char: "🥔",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, wI = {
  keywords: [
    "food",
    "vegetable",
    "plant"
  ],
  char: "🌽",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, vI = {
  keywords: [
    "food",
    "vegetable",
    "plant",
    "bok choy",
    "cabbage",
    "kale",
    "lettuce"
  ],
  char: "🥬",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, bI = {
  keywords: [
    "food",
    "nature"
  ],
  char: "🍠",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, kI = {
  keywords: [
    "food",
    "nut"
  ],
  char: "🥜",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, xI = {
  keywords: [
    "bees",
    "sweet",
    "kitchen"
  ],
  char: "🍯",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, zI = {
  keywords: [
    "food",
    "bread",
    "french"
  ],
  char: "🥐",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, SI = {
  keywords: [
    "food",
    "wheat",
    "breakfast",
    "toast"
  ],
  char: "🍞",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, CI = {
  keywords: [
    "food",
    "bread",
    "french"
  ],
  char: "🥖",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, EI = {
  keywords: [
    "food",
    "bread",
    "bakery",
    "schmear"
  ],
  char: "🥯",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, AI = {
  keywords: [
    "food",
    "bread",
    "twisted"
  ],
  char: "🥨",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, TI = {
  keywords: [
    "food",
    "chadder"
  ],
  char: "🧀",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, PI = {
  keywords: [
    "food",
    "chicken",
    "breakfast"
  ],
  char: "🥚",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, OI = {
  keywords: [
    "food",
    "breakfast",
    "pork",
    "pig",
    "meat"
  ],
  char: "🥓",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, MI = {
  keywords: [
    "food",
    "cow",
    "meat",
    "cut",
    "chop",
    "lambchop",
    "porkchop"
  ],
  char: "🥩",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, II = {
  keywords: [
    "food",
    "breakfast",
    "flapjacks",
    "hotcakes"
  ],
  char: "🥞",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, FI = {
  keywords: [
    "food",
    "meat",
    "drumstick",
    "bird",
    "chicken",
    "turkey"
  ],
  char: "🍗",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, jI = {
  keywords: [
    "good",
    "food",
    "drumstick"
  ],
  char: "🍖",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, RI = {
  keywords: [
    "skeleton"
  ],
  char: "🦴",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, LI = {
  keywords: [
    "food",
    "animal",
    "appetizer",
    "summer"
  ],
  char: "🍤",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, DI = {
  keywords: [
    "food",
    "breakfast",
    "kitchen",
    "egg"
  ],
  char: "🍳",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, NI = {
  keywords: [
    "meat",
    "fast food",
    "beef",
    "cheeseburger",
    "mcdonalds",
    "burger king"
  ],
  char: "🍔",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, VI = {
  keywords: [
    "chips",
    "snack",
    "fast food"
  ],
  char: "🍟",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, qI = {
  keywords: [
    "food",
    "flatbread",
    "stuffed",
    "gyro"
  ],
  char: "🥙",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, BI = {
  keywords: [
    "food",
    "frankfurter"
  ],
  char: "🌭",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, WI = {
  keywords: [
    "food",
    "party"
  ],
  char: "🍕",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, HI = {
  keywords: [
    "food",
    "lunch",
    "bread"
  ],
  char: "🥪",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, UI = {
  keywords: [
    "food",
    "soup"
  ],
  char: "🥫",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, GI = {
  keywords: [
    "food",
    "italian",
    "noodle"
  ],
  char: "🍝",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, KI = {
  keywords: [
    "food",
    "mexican"
  ],
  char: "🌮",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, ZI = {
  keywords: [
    "food",
    "mexican"
  ],
  char: "🌯",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, YI = {
  keywords: [
    "food",
    "healthy",
    "lettuce"
  ],
  char: "🥗",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, XI = {
  keywords: [
    "food",
    "cooking",
    "casserole",
    "paella"
  ],
  char: "🥘",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, JI = {
  keywords: [
    "food",
    "japanese",
    "noodle",
    "chopsticks"
  ],
  char: "🍜",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, QI = {
  keywords: [
    "food",
    "meat",
    "soup"
  ],
  char: "🍲",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, $I = {
  keywords: [
    "food",
    "japan",
    "sea",
    "beach",
    "narutomaki",
    "pink",
    "swirl",
    "kamaboko",
    "surimi",
    "ramen"
  ],
  char: "🍥",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, eF = {
  keywords: [
    "food",
    "prophecy"
  ],
  char: "🥠",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, tF = {
  keywords: [
    "food",
    "fish",
    "japanese",
    "rice"
  ],
  char: "🍣",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, aF = {
  keywords: [
    "food",
    "japanese",
    "box"
  ],
  char: "🍱",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, rF = {
  keywords: [
    "food",
    "spicy",
    "hot",
    "indian"
  ],
  char: "🍛",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, nF = {
  keywords: [
    "food",
    "japanese"
  ],
  char: "🍙",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, oF = {
  keywords: [
    "food",
    "china",
    "asian"
  ],
  char: "🍚",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, sF = {
  keywords: [
    "food",
    "japanese"
  ],
  char: "🍘",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, iF = {
  keywords: [
    "food",
    "japanese"
  ],
  char: "🍢",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, lF = {
  keywords: [
    "food",
    "dessert",
    "sweet",
    "japanese",
    "barbecue",
    "meat"
  ],
  char: "🍡",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, cF = {
  keywords: [
    "hot",
    "dessert",
    "summer"
  ],
  char: "🍧",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, uF = {
  keywords: [
    "food",
    "hot",
    "dessert"
  ],
  char: "🍨",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, dF = {
  keywords: [
    "food",
    "hot",
    "dessert",
    "summer"
  ],
  char: "🍦",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, fF = {
  keywords: [
    "food",
    "dessert",
    "pastry"
  ],
  char: "🥧",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, pF = {
  keywords: [
    "food",
    "dessert"
  ],
  char: "🍰",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, yF = {
  keywords: [
    "food",
    "dessert",
    "bakery",
    "sweet"
  ],
  char: "🧁",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, hF = {
  keywords: [
    "food",
    "autumn"
  ],
  char: "🥮",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, gF = {
  keywords: [
    "food",
    "dessert",
    "cake"
  ],
  char: "🎂",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, mF = {
  keywords: [
    "dessert",
    "food"
  ],
  char: "🍮",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, _F = {
  keywords: [
    "snack",
    "dessert",
    "sweet",
    "lolly"
  ],
  char: "🍬",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, wF = {
  keywords: [
    "food",
    "snack",
    "candy",
    "sweet"
  ],
  char: "🍭",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, vF = {
  keywords: [
    "food",
    "snack",
    "dessert",
    "sweet"
  ],
  char: "🍫",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, bF = {
  keywords: [
    "food",
    "movie theater",
    "films",
    "snack"
  ],
  char: "🍿",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, kF = {
  keywords: [
    "food",
    "empanada",
    "pierogi",
    "potsticker"
  ],
  char: "🥟",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, xF = {
  keywords: [
    "food",
    "dessert",
    "snack",
    "sweet",
    "donut"
  ],
  char: "🍩",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, zF = {
  keywords: [
    "food",
    "snack",
    "oreo",
    "chocolate",
    "sweet",
    "dessert"
  ],
  char: "🍪",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, SF = {
  keywords: [
    "beverage",
    "drink",
    "cow"
  ],
  char: "🥛",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, CF = {
  keywords: [
    "relax",
    "beverage",
    "drink",
    "drunk",
    "party",
    "pub",
    "summer",
    "alcohol",
    "booze"
  ],
  char: "🍺",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, EF = {
  keywords: [
    "relax",
    "beverage",
    "drink",
    "drunk",
    "party",
    "pub",
    "summer",
    "alcohol",
    "booze"
  ],
  char: "🍻",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, AF = {
  keywords: [
    "beverage",
    "drink",
    "party",
    "alcohol",
    "celebrate",
    "cheers",
    "wine",
    "champagne",
    "toast"
  ],
  char: "🥂",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, TF = {
  keywords: [
    "drink",
    "beverage",
    "drunk",
    "alcohol",
    "booze"
  ],
  char: "🍷",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, PF = {
  keywords: [
    "drink",
    "beverage",
    "drunk",
    "alcohol",
    "liquor",
    "booze",
    "bourbon",
    "scotch",
    "whisky",
    "glass",
    "shot"
  ],
  char: "🥃",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, OF = {
  keywords: [
    "drink",
    "drunk",
    "alcohol",
    "beverage",
    "booze",
    "mojito"
  ],
  char: "🍸",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, MF = {
  keywords: [
    "beverage",
    "cocktail",
    "summer",
    "beach",
    "alcohol",
    "booze",
    "mojito"
  ],
  char: "🍹",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, IF = {
  keywords: [
    "drink",
    "wine",
    "bottle",
    "celebration"
  ],
  char: "🍾",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, FF = {
  keywords: [
    "wine",
    "drink",
    "drunk",
    "beverage",
    "japanese",
    "alcohol",
    "booze"
  ],
  char: "🍶",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, jF = {
  keywords: [
    "drink",
    "bowl",
    "breakfast",
    "green",
    "british"
  ],
  char: "🍵",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, RF = {
  keywords: [
    "drink",
    "soda"
  ],
  char: "🥤",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, LF = {
  keywords: [
    "beverage",
    "caffeine",
    "latte",
    "espresso"
  ],
  char: "☕",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, DF = {
  keywords: [
    "food",
    "container",
    "milk"
  ],
  char: "🍼",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, NF = {
  keywords: [
    "condiment",
    "shaker"
  ],
  char: "🧂",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, VF = {
  keywords: [
    "cutlery",
    "kitchen",
    "tableware"
  ],
  char: "🥄",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, qF = {
  keywords: [
    "cutlery",
    "kitchen"
  ],
  char: "🍴",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, BF = {
  keywords: [
    "food",
    "eat",
    "meal",
    "lunch",
    "dinner",
    "restaurant"
  ],
  char: "🍽",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, WF = {
  keywords: [
    "food",
    "breakfast",
    "cereal",
    "oatmeal",
    "porridge"
  ],
  char: "🥣",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, HF = {
  keywords: [
    "food",
    "leftovers"
  ],
  char: "🥡",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, UF = {
  keywords: [
    "food"
  ],
  char: "🥢",
  fitzpatrick_scale: !1,
  category: "food_and_drink"
}, GF = {
  keywords: [
    "sports",
    "football"
  ],
  char: "⚽",
  fitzpatrick_scale: !1,
  category: "activity"
}, KF = {
  keywords: [
    "sports",
    "balls",
    "NBA"
  ],
  char: "🏀",
  fitzpatrick_scale: !1,
  category: "activity"
}, ZF = {
  keywords: [
    "sports",
    "balls",
    "NFL"
  ],
  char: "🏈",
  fitzpatrick_scale: !1,
  category: "activity"
}, YF = {
  keywords: [
    "sports",
    "balls"
  ],
  char: "⚾",
  fitzpatrick_scale: !1,
  category: "activity"
}, XF = {
  keywords: [
    "sports",
    "balls"
  ],
  char: "🥎",
  fitzpatrick_scale: !1,
  category: "activity"
}, JF = {
  keywords: [
    "sports",
    "balls",
    "green"
  ],
  char: "🎾",
  fitzpatrick_scale: !1,
  category: "activity"
}, QF = {
  keywords: [
    "sports",
    "balls"
  ],
  char: "🏐",
  fitzpatrick_scale: !1,
  category: "activity"
}, $F = {
  keywords: [
    "sports",
    "team"
  ],
  char: "🏉",
  fitzpatrick_scale: !1,
  category: "activity"
}, ej = {
  keywords: [
    "sports",
    "frisbee",
    "ultimate"
  ],
  char: "🥏",
  fitzpatrick_scale: !1,
  category: "activity"
}, tj = {
  keywords: [
    "sports",
    "business",
    "flag",
    "hole",
    "summer"
  ],
  char: "⛳",
  fitzpatrick_scale: !1,
  category: "activity"
}, aj = {
  keywords: [
    "sports",
    "business",
    "woman",
    "female"
  ],
  char: "🏌️‍♀️",
  fitzpatrick_scale: !1,
  category: "activity"
}, rj = {
  keywords: [
    "sports",
    "business"
  ],
  char: "🏌",
  fitzpatrick_scale: !0,
  category: "activity"
}, nj = {
  keywords: [
    "sports",
    "pingpong"
  ],
  char: "🏓",
  fitzpatrick_scale: !1,
  category: "activity"
}, oj = {
  keywords: [
    "sports"
  ],
  char: "🏸",
  fitzpatrick_scale: !1,
  category: "activity"
}, sj = {
  keywords: [
    "sports"
  ],
  char: "🥅",
  fitzpatrick_scale: !1,
  category: "activity"
}, ij = {
  keywords: [
    "sports"
  ],
  char: "🏒",
  fitzpatrick_scale: !1,
  category: "activity"
}, lj = {
  keywords: [
    "sports"
  ],
  char: "🏑",
  fitzpatrick_scale: !1,
  category: "activity"
}, cj = {
  keywords: [
    "sports",
    "ball",
    "stick"
  ],
  char: "🥍",
  fitzpatrick_scale: !1,
  category: "activity"
}, uj = {
  keywords: [
    "sports"
  ],
  char: "🏏",
  fitzpatrick_scale: !1,
  category: "activity"
}, dj = {
  keywords: [
    "sports",
    "winter",
    "cold",
    "snow"
  ],
  char: "🎿",
  fitzpatrick_scale: !1,
  category: "activity"
}, fj = {
  keywords: [
    "sports",
    "winter",
    "snow"
  ],
  char: "⛷",
  fitzpatrick_scale: !1,
  category: "activity"
}, pj = {
  keywords: [
    "sports",
    "winter"
  ],
  char: "🏂",
  fitzpatrick_scale: !0,
  category: "activity"
}, yj = {
  keywords: [
    "sports",
    "fencing",
    "sword"
  ],
  char: "🤺",
  fitzpatrick_scale: !1,
  category: "activity"
}, hj = {
  keywords: [
    "sports",
    "wrestlers"
  ],
  char: "🤼‍♀️",
  fitzpatrick_scale: !1,
  category: "activity"
}, gj = {
  keywords: [
    "sports",
    "wrestlers"
  ],
  char: "🤼‍♂️",
  fitzpatrick_scale: !1,
  category: "activity"
}, mj = {
  keywords: [
    "gymnastics"
  ],
  char: "🤸‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, _j = {
  keywords: [
    "gymnastics"
  ],
  char: "🤸‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, wj = {
  keywords: [
    "sports"
  ],
  char: "🤾‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, vj = {
  keywords: [
    "sports"
  ],
  char: "🤾‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, bj = {
  keywords: [
    "sports"
  ],
  char: "⛸",
  fitzpatrick_scale: !1,
  category: "activity"
}, kj = {
  keywords: [
    "sports"
  ],
  char: "🥌",
  fitzpatrick_scale: !1,
  category: "activity"
}, xj = {
  keywords: [
    "board"
  ],
  char: "🛹",
  fitzpatrick_scale: !1,
  category: "activity"
}, zj = {
  keywords: [
    "sleigh",
    "luge",
    "toboggan"
  ],
  char: "🛷",
  fitzpatrick_scale: !1,
  category: "activity"
}, Sj = {
  keywords: [
    "sports"
  ],
  char: "🏹",
  fitzpatrick_scale: !1,
  category: "activity"
}, Cj = {
  keywords: [
    "food",
    "hobby",
    "summer"
  ],
  char: "🎣",
  fitzpatrick_scale: !1,
  category: "activity"
}, Ej = {
  keywords: [
    "sports",
    "fighting"
  ],
  char: "🥊",
  fitzpatrick_scale: !1,
  category: "activity"
}, Aj = {
  keywords: [
    "judo",
    "karate",
    "taekwondo"
  ],
  char: "🥋",
  fitzpatrick_scale: !1,
  category: "activity"
}, Tj = {
  keywords: [
    "sports",
    "hobby",
    "water",
    "ship",
    "woman",
    "female"
  ],
  char: "🚣‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Pj = {
  keywords: [
    "sports",
    "hobby",
    "water",
    "ship"
  ],
  char: "🚣",
  fitzpatrick_scale: !0,
  category: "activity"
}, Oj = {
  keywords: [
    "sports",
    "hobby",
    "woman",
    "female",
    "rock"
  ],
  char: "🧗‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Mj = {
  keywords: [
    "sports",
    "hobby",
    "man",
    "male",
    "rock"
  ],
  char: "🧗‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Ij = {
  keywords: [
    "sports",
    "exercise",
    "human",
    "athlete",
    "water",
    "summer",
    "woman",
    "female"
  ],
  char: "🏊‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Fj = {
  keywords: [
    "sports",
    "exercise",
    "human",
    "athlete",
    "water",
    "summer"
  ],
  char: "🏊",
  fitzpatrick_scale: !0,
  category: "activity"
}, jj = {
  keywords: [
    "sports",
    "pool"
  ],
  char: "🤽‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Rj = {
  keywords: [
    "sports",
    "pool"
  ],
  char: "🤽‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Lj = {
  keywords: [
    "woman",
    "female",
    "meditation",
    "yoga",
    "serenity",
    "zen",
    "mindfulness"
  ],
  char: "🧘‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Dj = {
  keywords: [
    "man",
    "male",
    "meditation",
    "yoga",
    "serenity",
    "zen",
    "mindfulness"
  ],
  char: "🧘‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Nj = {
  keywords: [
    "sports",
    "ocean",
    "sea",
    "summer",
    "beach",
    "woman",
    "female"
  ],
  char: "🏄‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Vj = {
  keywords: [
    "sports",
    "ocean",
    "sea",
    "summer",
    "beach"
  ],
  char: "🏄",
  fitzpatrick_scale: !0,
  category: "activity"
}, qj = {
  keywords: [
    "clean",
    "shower",
    "bathroom"
  ],
  char: "🛀",
  fitzpatrick_scale: !0,
  category: "activity"
}, Bj = {
  keywords: [
    "sports",
    "human",
    "woman",
    "female"
  ],
  char: "⛹️‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Wj = {
  keywords: [
    "sports",
    "human"
  ],
  char: "⛹",
  fitzpatrick_scale: !0,
  category: "activity"
}, Hj = {
  keywords: [
    "sports",
    "training",
    "exercise",
    "woman",
    "female"
  ],
  char: "🏋️‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Uj = {
  keywords: [
    "sports",
    "training",
    "exercise"
  ],
  char: "🏋",
  fitzpatrick_scale: !0,
  category: "activity"
}, Gj = {
  keywords: [
    "sports",
    "bike",
    "exercise",
    "hipster",
    "woman",
    "female"
  ],
  char: "🚴‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Kj = {
  keywords: [
    "sports",
    "bike",
    "exercise",
    "hipster"
  ],
  char: "🚴",
  fitzpatrick_scale: !0,
  category: "activity"
}, Zj = {
  keywords: [
    "transportation",
    "sports",
    "human",
    "race",
    "bike",
    "woman",
    "female"
  ],
  char: "🚵‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, Yj = {
  keywords: [
    "transportation",
    "sports",
    "human",
    "race",
    "bike"
  ],
  char: "🚵",
  fitzpatrick_scale: !0,
  category: "activity"
}, Xj = {
  keywords: [
    "animal",
    "betting",
    "competition",
    "gambling",
    "luck"
  ],
  char: "🏇",
  fitzpatrick_scale: !0,
  category: "activity"
}, Jj = {
  keywords: [
    "suit",
    "business",
    "levitate",
    "hover",
    "jump"
  ],
  char: "🕴",
  fitzpatrick_scale: !0,
  category: "activity"
}, Qj = {
  keywords: [
    "win",
    "award",
    "contest",
    "place",
    "ftw",
    "ceremony"
  ],
  char: "🏆",
  fitzpatrick_scale: !1,
  category: "activity"
}, $j = {
  keywords: [
    "play",
    "pageant"
  ],
  char: "🎽",
  fitzpatrick_scale: !1,
  category: "activity"
}, eR = {
  keywords: [
    "award",
    "winning"
  ],
  char: "🏅",
  fitzpatrick_scale: !1,
  category: "activity"
}, tR = {
  keywords: [
    "award",
    "winning",
    "army"
  ],
  char: "🎖",
  fitzpatrick_scale: !1,
  category: "activity"
}, aR = {
  keywords: [
    "sports",
    "cause",
    "support",
    "awareness"
  ],
  char: "🎗",
  fitzpatrick_scale: !1,
  category: "activity"
}, rR = {
  keywords: [
    "flower",
    "decoration",
    "military"
  ],
  char: "🏵",
  fitzpatrick_scale: !1,
  category: "activity"
}, nR = {
  keywords: [
    "event",
    "concert",
    "pass"
  ],
  char: "🎫",
  fitzpatrick_scale: !1,
  category: "activity"
}, oR = {
  keywords: [
    "sports",
    "concert",
    "entrance"
  ],
  char: "🎟",
  fitzpatrick_scale: !1,
  category: "activity"
}, sR = {
  keywords: [
    "acting",
    "theater",
    "drama"
  ],
  char: "🎭",
  fitzpatrick_scale: !1,
  category: "activity"
}, iR = {
  keywords: [
    "design",
    "paint",
    "draw",
    "colors"
  ],
  char: "🎨",
  fitzpatrick_scale: !1,
  category: "activity"
}, lR = {
  keywords: [
    "festival",
    "carnival",
    "party"
  ],
  char: "🎪",
  fitzpatrick_scale: !1,
  category: "activity"
}, cR = {
  keywords: [
    "juggle",
    "balance",
    "skill",
    "multitask"
  ],
  char: "🤹‍♀️",
  fitzpatrick_scale: !0,
  category: "activity"
}, uR = {
  keywords: [
    "juggle",
    "balance",
    "skill",
    "multitask"
  ],
  char: "🤹‍♂️",
  fitzpatrick_scale: !0,
  category: "activity"
}, dR = {
  keywords: [
    "sound",
    "music",
    "PA",
    "sing",
    "talkshow"
  ],
  char: "🎤",
  fitzpatrick_scale: !1,
  category: "activity"
}, fR = {
  keywords: [
    "music",
    "score",
    "gadgets"
  ],
  char: "🎧",
  fitzpatrick_scale: !1,
  category: "activity"
}, pR = {
  keywords: [
    "treble",
    "clef",
    "compose"
  ],
  char: "🎼",
  fitzpatrick_scale: !1,
  category: "activity"
}, yR = {
  keywords: [
    "piano",
    "instrument",
    "compose"
  ],
  char: "🎹",
  fitzpatrick_scale: !1,
  category: "activity"
}, hR = {
  keywords: [
    "music",
    "instrument",
    "drumsticks",
    "snare"
  ],
  char: "🥁",
  fitzpatrick_scale: !1,
  category: "activity"
}, gR = {
  keywords: [
    "music",
    "instrument",
    "jazz",
    "blues"
  ],
  char: "🎷",
  fitzpatrick_scale: !1,
  category: "activity"
}, mR = {
  keywords: [
    "music",
    "brass"
  ],
  char: "🎺",
  fitzpatrick_scale: !1,
  category: "activity"
}, _R = {
  keywords: [
    "music",
    "instrument"
  ],
  char: "🎸",
  fitzpatrick_scale: !1,
  category: "activity"
}, wR = {
  keywords: [
    "music",
    "instrument",
    "orchestra",
    "symphony"
  ],
  char: "🎻",
  fitzpatrick_scale: !1,
  category: "activity"
}, vR = {
  keywords: [
    "movie",
    "film",
    "record"
  ],
  char: "🎬",
  fitzpatrick_scale: !1,
  category: "activity"
}, bR = {
  keywords: [
    "play",
    "console",
    "PS4",
    "controller"
  ],
  char: "🎮",
  fitzpatrick_scale: !1,
  category: "activity"
}, kR = {
  keywords: [
    "game",
    "arcade",
    "play"
  ],
  char: "👾",
  fitzpatrick_scale: !1,
  category: "activity"
}, xR = {
  keywords: [
    "game",
    "play",
    "bar",
    "target",
    "bullseye"
  ],
  char: "🎯",
  fitzpatrick_scale: !1,
  category: "activity"
}, zR = {
  keywords: [
    "dice",
    "random",
    "tabletop",
    "play",
    "luck"
  ],
  char: "🎲",
  fitzpatrick_scale: !1,
  category: "activity"
}, SR = {
  keywords: [
    "expendable"
  ],
  char: "♟",
  fitzpatrick_scale: !1,
  category: "activity"
}, CR = {
  keywords: [
    "bet",
    "gamble",
    "vegas",
    "fruit machine",
    "luck",
    "casino"
  ],
  char: "🎰",
  fitzpatrick_scale: !1,
  category: "activity"
}, ER = {
  keywords: [
    "interlocking",
    "puzzle",
    "piece"
  ],
  char: "🧩",
  fitzpatrick_scale: !1,
  category: "activity"
}, AR = {
  keywords: [
    "sports",
    "fun",
    "play"
  ],
  char: "🎳",
  fitzpatrick_scale: !1,
  category: "activity"
}, TR = {
  keywords: [
    "red",
    "transportation",
    "vehicle"
  ],
  char: "🚗",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, PR = {
  keywords: [
    "uber",
    "vehicle",
    "cars",
    "transportation"
  ],
  char: "🚕",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, OR = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚙",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, MR = {
  keywords: [
    "car",
    "vehicle",
    "transportation"
  ],
  char: "🚌",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, IR = {
  keywords: [
    "bart",
    "transportation",
    "vehicle"
  ],
  char: "🚎",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, FR = {
  keywords: [
    "sports",
    "race",
    "fast",
    "formula",
    "f1"
  ],
  char: "🏎",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, jR = {
  keywords: [
    "vehicle",
    "cars",
    "transportation",
    "law",
    "legal",
    "enforcement"
  ],
  char: "🚓",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, RR = {
  keywords: [
    "health",
    "911",
    "hospital"
  ],
  char: "🚑",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, LR = {
  keywords: [
    "transportation",
    "cars",
    "vehicle"
  ],
  char: "🚒",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, DR = {
  keywords: [
    "vehicle",
    "car",
    "transportation"
  ],
  char: "🚐",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, NR = {
  keywords: [
    "cars",
    "transportation"
  ],
  char: "🚚",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, VR = {
  keywords: [
    "vehicle",
    "cars",
    "transportation",
    "express"
  ],
  char: "🚛",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, qR = {
  keywords: [
    "vehicle",
    "car",
    "farming",
    "agriculture"
  ],
  char: "🚜",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, BR = {
  keywords: [
    "vehicle",
    "kick",
    "razor"
  ],
  char: "🛴",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, WR = {
  keywords: [
    "race",
    "sports",
    "fast"
  ],
  char: "🏍",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, HR = {
  keywords: [
    "sports",
    "bicycle",
    "exercise",
    "hipster"
  ],
  char: "🚲",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, UR = {
  keywords: [
    "vehicle",
    "vespa",
    "sasha"
  ],
  char: "🛵",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, GR = {
  keywords: [
    "police",
    "ambulance",
    "911",
    "emergency",
    "alert",
    "error",
    "pinged",
    "law",
    "legal"
  ],
  char: "🚨",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, KR = {
  keywords: [
    "vehicle",
    "law",
    "legal",
    "enforcement",
    "911"
  ],
  char: "🚔",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ZR = {
  keywords: [
    "vehicle",
    "transportation"
  ],
  char: "🚍",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, YR = {
  keywords: [
    "car",
    "vehicle",
    "transportation"
  ],
  char: "🚘",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, XR = {
  keywords: [
    "vehicle",
    "cars",
    "uber"
  ],
  char: "🚖",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, JR = {
  keywords: [
    "transportation",
    "vehicle",
    "ski"
  ],
  char: "🚡",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, QR = {
  keywords: [
    "transportation",
    "vehicle",
    "ski"
  ],
  char: "🚠",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, $R = {
  keywords: [
    "vehicle",
    "transportation"
  ],
  char: "🚟",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, eL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚃",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, tL = {
  keywords: [
    "transportation",
    "vehicle",
    "carriage",
    "public",
    "travel"
  ],
  char: "🚋",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, aL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚝",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, rL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚄",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, nL = {
  keywords: [
    "transportation",
    "vehicle",
    "speed",
    "fast",
    "public",
    "travel"
  ],
  char: "🚅",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, oL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚈",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, sL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚞",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, iL = {
  keywords: [
    "transportation",
    "vehicle",
    "train"
  ],
  char: "🚂",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, lL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚆",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, cL = {
  keywords: [
    "transportation",
    "blue-square",
    "mrt",
    "underground",
    "tube"
  ],
  char: "🚇",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, uL = {
  keywords: [
    "transportation",
    "vehicle"
  ],
  char: "🚊",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, dL = {
  keywords: [
    "transportation",
    "vehicle",
    "public"
  ],
  char: "🚉",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, fL = {
  keywords: [
    "transportation",
    "vehicle",
    "ufo"
  ],
  char: "🛸",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, pL = {
  keywords: [
    "transportation",
    "vehicle",
    "fly"
  ],
  char: "🚁",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, yL = {
  keywords: [
    "flight",
    "transportation",
    "fly",
    "vehicle"
  ],
  char: "🛩",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, hL = {
  keywords: [
    "vehicle",
    "transportation",
    "flight",
    "fly"
  ],
  char: "✈️",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, gL = {
  keywords: [
    "airport",
    "flight",
    "landing"
  ],
  char: "🛫",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, mL = {
  keywords: [
    "airport",
    "flight",
    "boarding"
  ],
  char: "🛬",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, _L = {
  keywords: [
    "ship",
    "summer",
    "transportation",
    "water",
    "sailing"
  ],
  char: "⛵",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, wL = {
  keywords: [
    "ship"
  ],
  char: "🛥",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, vL = {
  keywords: [
    "ship",
    "transportation",
    "vehicle",
    "summer"
  ],
  char: "🚤",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, bL = {
  keywords: [
    "boat",
    "ship",
    "yacht"
  ],
  char: "⛴",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, kL = {
  keywords: [
    "yacht",
    "cruise",
    "ferry"
  ],
  char: "🛳",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, xL = {
  keywords: [
    "launch",
    "ship",
    "staffmode",
    "NASA",
    "outer space",
    "outer_space",
    "fly"
  ],
  char: "🚀",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, zL = {
  keywords: [
    "communication",
    "gps",
    "orbit",
    "spaceflight",
    "NASA",
    "ISS"
  ],
  char: "🛰",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, SL = {
  keywords: [
    "sit",
    "airplane",
    "transport",
    "bus",
    "flight",
    "fly"
  ],
  char: "💺",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, CL = {
  keywords: [
    "boat",
    "paddle",
    "water",
    "ship"
  ],
  char: "🛶",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, EL = {
  keywords: [
    "ship",
    "ferry",
    "sea",
    "boat"
  ],
  char: "⚓",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, AL = {
  keywords: [
    "wip",
    "progress",
    "caution",
    "warning"
  ],
  char: "🚧",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, TL = {
  keywords: [
    "gas station",
    "petroleum"
  ],
  char: "⛽",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, PL = {
  keywords: [
    "transportation",
    "wait"
  ],
  char: "🚏",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, OL = {
  keywords: [
    "transportation",
    "driving"
  ],
  char: "🚦",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ML = {
  keywords: [
    "transportation",
    "signal"
  ],
  char: "🚥",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, IL = {
  keywords: [
    "contest",
    "finishline",
    "race",
    "gokart"
  ],
  char: "🏁",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, FL = {
  keywords: [
    "transportation",
    "titanic",
    "deploy"
  ],
  char: "🚢",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, jL = {
  keywords: [
    "photo",
    "carnival",
    "londoneye"
  ],
  char: "🎡",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, RL = {
  keywords: [
    "carnival",
    "playground",
    "photo",
    "fun"
  ],
  char: "🎢",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, LL = {
  keywords: [
    "photo",
    "carnival"
  ],
  char: "🎠",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, DL = {
  keywords: [
    "wip",
    "working",
    "progress"
  ],
  char: "🏗",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, NL = {
  keywords: [
    "photo",
    "mountain"
  ],
  char: "🌁",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, VL = {
  keywords: [
    "photo",
    "japanese"
  ],
  char: "🗼",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, qL = {
  keywords: [
    "building",
    "industry",
    "pollution",
    "smoke"
  ],
  char: "🏭",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, BL = {
  keywords: [
    "photo",
    "summer",
    "water",
    "fresh"
  ],
  char: "⛲",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, WL = {
  keywords: [
    "photo",
    "japan",
    "asia",
    "tsukimi"
  ],
  char: "🎑",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, HL = {
  keywords: [
    "photo",
    "nature",
    "environment"
  ],
  char: "⛰",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, UL = {
  keywords: [
    "photo",
    "nature",
    "environment",
    "winter",
    "cold"
  ],
  char: "🏔",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, GL = {
  keywords: [
    "photo",
    "mountain",
    "nature",
    "japanese"
  ],
  char: "🗻",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, KL = {
  keywords: [
    "photo",
    "nature",
    "disaster"
  ],
  char: "🌋",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ZL = {
  keywords: [
    "nation",
    "country",
    "japanese",
    "asia"
  ],
  char: "🗾",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, YL = {
  keywords: [
    "photo",
    "outdoors",
    "tent"
  ],
  char: "🏕",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, XL = {
  keywords: [
    "photo",
    "camping",
    "outdoors"
  ],
  char: "⛺",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, JL = {
  keywords: [
    "photo",
    "environment",
    "nature"
  ],
  char: "🏞",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, QL = {
  keywords: [
    "road",
    "cupertino",
    "interstate",
    "highway"
  ],
  char: "🛣",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, $L = {
  keywords: [
    "train",
    "transportation"
  ],
  char: "🛤",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, eD = {
  keywords: [
    "morning",
    "view",
    "vacation",
    "photo"
  ],
  char: "🌅",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, tD = {
  keywords: [
    "view",
    "vacation",
    "photo"
  ],
  char: "🌄",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, aD = {
  keywords: [
    "photo",
    "warm",
    "saharah"
  ],
  char: "🏜",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, rD = {
  keywords: [
    "weather",
    "summer",
    "sunny",
    "sand",
    "mojito"
  ],
  char: "🏖",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, nD = {
  keywords: [
    "photo",
    "tropical",
    "mojito"
  ],
  char: "🏝",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, oD = {
  keywords: [
    "photo",
    "good morning",
    "dawn"
  ],
  char: "🌇",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, sD = {
  keywords: [
    "photo",
    "evening",
    "sky",
    "buildings"
  ],
  char: "🌆",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, iD = {
  keywords: [
    "photo",
    "night life",
    "urban"
  ],
  char: "🏙",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, lD = {
  keywords: [
    "evening",
    "city",
    "downtown"
  ],
  char: "🌃",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, cD = {
  keywords: [
    "photo",
    "sanfrancisco"
  ],
  char: "🌉",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, uD = {
  keywords: [
    "photo",
    "space",
    "stars"
  ],
  char: "🌌",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, dD = {
  keywords: [
    "night",
    "photo"
  ],
  char: "🌠",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, fD = {
  keywords: [
    "stars",
    "night",
    "shine"
  ],
  char: "🎇",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, pD = {
  keywords: [
    "photo",
    "festival",
    "carnival",
    "congratulations"
  ],
  char: "🎆",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, yD = {
  keywords: [
    "nature",
    "happy",
    "unicorn_face",
    "photo",
    "sky",
    "spring"
  ],
  char: "🌈",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, hD = {
  keywords: [
    "buildings",
    "photo"
  ],
  char: "🏘",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, gD = {
  keywords: [
    "building",
    "royalty",
    "history"
  ],
  char: "🏰",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, mD = {
  keywords: [
    "photo",
    "building"
  ],
  char: "🏯",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, _D = {
  keywords: [
    "photo",
    "place",
    "sports",
    "concert",
    "venue"
  ],
  char: "🏟",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, wD = {
  keywords: [
    "american",
    "newyork"
  ],
  char: "🗽",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, vD = {
  keywords: [
    "building",
    "home"
  ],
  char: "🏠",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, bD = {
  keywords: [
    "home",
    "plant",
    "nature"
  ],
  char: "🏡",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, kD = {
  keywords: [
    "abandon",
    "evict",
    "broken",
    "building"
  ],
  char: "🏚",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, xD = {
  keywords: [
    "building",
    "bureau",
    "work"
  ],
  char: "🏢",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, zD = {
  keywords: [
    "building",
    "shopping",
    "mall"
  ],
  char: "🏬",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, SD = {
  keywords: [
    "building",
    "envelope",
    "communication"
  ],
  char: "🏣",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, CD = {
  keywords: [
    "building",
    "email"
  ],
  char: "🏤",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ED = {
  keywords: [
    "building",
    "health",
    "surgery",
    "doctor"
  ],
  char: "🏥",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, AD = {
  keywords: [
    "building",
    "money",
    "sales",
    "cash",
    "business",
    "enterprise"
  ],
  char: "🏦",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, TD = {
  keywords: [
    "building",
    "accomodation",
    "checkin"
  ],
  char: "🏨",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, PD = {
  keywords: [
    "building",
    "shopping",
    "groceries"
  ],
  char: "🏪",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, OD = {
  keywords: [
    "building",
    "student",
    "education",
    "learn",
    "teach"
  ],
  char: "🏫",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, MD = {
  keywords: [
    "like",
    "affection",
    "dating"
  ],
  char: "🏩",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ID = {
  keywords: [
    "love",
    "like",
    "affection",
    "couple",
    "marriage",
    "bride",
    "groom"
  ],
  char: "💒",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, FD = {
  keywords: [
    "art",
    "culture",
    "history"
  ],
  char: "🏛",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, jD = {
  keywords: [
    "building",
    "religion",
    "christ"
  ],
  char: "⛪",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, RD = {
  keywords: [
    "islam",
    "worship",
    "minaret"
  ],
  char: "🕌",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, LD = {
  keywords: [
    "judaism",
    "worship",
    "temple",
    "jewish"
  ],
  char: "🕍",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, DD = {
  keywords: [
    "mecca",
    "mosque",
    "islam"
  ],
  char: "🕋",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, ND = {
  keywords: [
    "temple",
    "japan",
    "kyoto"
  ],
  char: "⛩",
  fitzpatrick_scale: !1,
  category: "travel_and_places"
}, VD = {
  keywords: [
    "time",
    "accessories"
  ],
  char: "⌚",
  fitzpatrick_scale: !1,
  category: "objects"
}, qD = {
  keywords: [
    "technology",
    "apple",
    "gadgets",
    "dial"
  ],
  char: "📱",
  fitzpatrick_scale: !1,
  category: "objects"
}, BD = {
  keywords: [
    "iphone",
    "incoming"
  ],
  char: "📲",
  fitzpatrick_scale: !1,
  category: "objects"
}, WD = {
  keywords: [
    "technology",
    "laptop",
    "screen",
    "display",
    "monitor"
  ],
  char: "💻",
  fitzpatrick_scale: !1,
  category: "objects"
}, HD = {
  keywords: [
    "technology",
    "computer",
    "type",
    "input",
    "text"
  ],
  char: "⌨",
  fitzpatrick_scale: !1,
  category: "objects"
}, UD = {
  keywords: [
    "technology",
    "computing",
    "screen"
  ],
  char: "🖥",
  fitzpatrick_scale: !1,
  category: "objects"
}, GD = {
  keywords: [
    "paper",
    "ink"
  ],
  char: "🖨",
  fitzpatrick_scale: !1,
  category: "objects"
}, KD = {
  keywords: [
    "click"
  ],
  char: "🖱",
  fitzpatrick_scale: !1,
  category: "objects"
}, ZD = {
  keywords: [
    "technology",
    "trackpad"
  ],
  char: "🖲",
  fitzpatrick_scale: !1,
  category: "objects"
}, YD = {
  keywords: [
    "game",
    "play"
  ],
  char: "🕹",
  fitzpatrick_scale: !1,
  category: "objects"
}, XD = {
  keywords: [
    "tool"
  ],
  char: "🗜",
  fitzpatrick_scale: !1,
  category: "objects"
}, JD = {
  keywords: [
    "technology",
    "record",
    "data",
    "disk",
    "90s"
  ],
  char: "💽",
  fitzpatrick_scale: !1,
  category: "objects"
}, QD = {
  keywords: [
    "oldschool",
    "technology",
    "save",
    "90s",
    "80s"
  ],
  char: "💾",
  fitzpatrick_scale: !1,
  category: "objects"
}, $D = {
  keywords: [
    "technology",
    "dvd",
    "disk",
    "disc",
    "90s"
  ],
  char: "💿",
  fitzpatrick_scale: !1,
  category: "objects"
}, eN = {
  keywords: [
    "cd",
    "disk",
    "disc"
  ],
  char: "📀",
  fitzpatrick_scale: !1,
  category: "objects"
}, tN = {
  keywords: [
    "record",
    "video",
    "oldschool",
    "90s",
    "80s"
  ],
  char: "📼",
  fitzpatrick_scale: !1,
  category: "objects"
}, aN = {
  keywords: [
    "gadgets",
    "photography"
  ],
  char: "📷",
  fitzpatrick_scale: !1,
  category: "objects"
}, rN = {
  keywords: [
    "photography",
    "gadgets"
  ],
  char: "📸",
  fitzpatrick_scale: !1,
  category: "objects"
}, nN = {
  keywords: [
    "film",
    "record"
  ],
  char: "📹",
  fitzpatrick_scale: !1,
  category: "objects"
}, oN = {
  keywords: [
    "film",
    "record"
  ],
  char: "🎥",
  fitzpatrick_scale: !1,
  category: "objects"
}, sN = {
  keywords: [
    "video",
    "tape",
    "record",
    "movie"
  ],
  char: "📽",
  fitzpatrick_scale: !1,
  category: "objects"
}, iN = {
  keywords: [
    "movie"
  ],
  char: "🎞",
  fitzpatrick_scale: !1,
  category: "objects"
}, lN = {
  keywords: [
    "technology",
    "communication",
    "dial"
  ],
  char: "📞",
  fitzpatrick_scale: !1,
  category: "objects"
}, cN = {
  keywords: [
    "technology",
    "communication",
    "dial",
    "telephone"
  ],
  char: "☎️",
  fitzpatrick_scale: !1,
  category: "objects"
}, uN = {
  keywords: [
    "bbcall",
    "oldschool",
    "90s"
  ],
  char: "📟",
  fitzpatrick_scale: !1,
  category: "objects"
}, dN = {
  keywords: [
    "communication",
    "technology"
  ],
  char: "📠",
  fitzpatrick_scale: !1,
  category: "objects"
}, fN = {
  keywords: [
    "technology",
    "program",
    "oldschool",
    "show",
    "television"
  ],
  char: "📺",
  fitzpatrick_scale: !1,
  category: "objects"
}, pN = {
  keywords: [
    "communication",
    "music",
    "podcast",
    "program"
  ],
  char: "📻",
  fitzpatrick_scale: !1,
  category: "objects"
}, yN = {
  keywords: [
    "sing",
    "recording",
    "artist",
    "talkshow"
  ],
  char: "🎙",
  fitzpatrick_scale: !1,
  category: "objects"
}, hN = {
  keywords: [
    "scale"
  ],
  char: "🎚",
  fitzpatrick_scale: !1,
  category: "objects"
}, gN = {
  keywords: [
    "dial"
  ],
  char: "🎛",
  fitzpatrick_scale: !1,
  category: "objects"
}, mN = {
  keywords: [
    "magnetic",
    "navigation",
    "orienteering"
  ],
  char: "🧭",
  fitzpatrick_scale: !1,
  category: "objects"
}, _N = {
  keywords: [
    "time",
    "deadline"
  ],
  char: "⏱",
  fitzpatrick_scale: !1,
  category: "objects"
}, wN = {
  keywords: [
    "alarm"
  ],
  char: "⏲",
  fitzpatrick_scale: !1,
  category: "objects"
}, vN = {
  keywords: [
    "time",
    "wake"
  ],
  char: "⏰",
  fitzpatrick_scale: !1,
  category: "objects"
}, bN = {
  keywords: [
    "time"
  ],
  char: "🕰",
  fitzpatrick_scale: !1,
  category: "objects"
}, kN = {
  keywords: [
    "oldschool",
    "time",
    "countdown"
  ],
  char: "⏳",
  fitzpatrick_scale: !1,
  category: "objects"
}, xN = {
  keywords: [
    "time",
    "clock",
    "oldschool",
    "limit",
    "exam",
    "quiz",
    "test"
  ],
  char: "⌛",
  fitzpatrick_scale: !1,
  category: "objects"
}, zN = {
  keywords: [
    "communication",
    "future",
    "radio",
    "space"
  ],
  char: "📡",
  fitzpatrick_scale: !1,
  category: "objects"
}, SN = {
  keywords: [
    "power",
    "energy",
    "sustain"
  ],
  char: "🔋",
  fitzpatrick_scale: !1,
  category: "objects"
}, CN = {
  keywords: [
    "charger",
    "power"
  ],
  char: "🔌",
  fitzpatrick_scale: !1,
  category: "objects"
}, EN = {
  keywords: [
    "light",
    "electricity",
    "idea"
  ],
  char: "💡",
  fitzpatrick_scale: !1,
  category: "objects"
}, AN = {
  keywords: [
    "dark",
    "camping",
    "sight",
    "night"
  ],
  char: "🔦",
  fitzpatrick_scale: !1,
  category: "objects"
}, TN = {
  keywords: [
    "fire",
    "wax"
  ],
  char: "🕯",
  fitzpatrick_scale: !1,
  category: "objects"
}, PN = {
  keywords: [
    "quench"
  ],
  char: "🧯",
  fitzpatrick_scale: !1,
  category: "objects"
}, ON = {
  keywords: [
    "bin",
    "trash",
    "rubbish",
    "garbage",
    "toss"
  ],
  char: "🗑",
  fitzpatrick_scale: !1,
  category: "objects"
}, MN = {
  keywords: [
    "barrell"
  ],
  char: "🛢",
  fitzpatrick_scale: !1,
  category: "objects"
}, IN = {
  keywords: [
    "dollar",
    "bills",
    "payment",
    "sale"
  ],
  char: "💸",
  fitzpatrick_scale: !1,
  category: "objects"
}, FN = {
  keywords: [
    "money",
    "sales",
    "bill",
    "currency"
  ],
  char: "💵",
  fitzpatrick_scale: !1,
  category: "objects"
}, jN = {
  keywords: [
    "money",
    "sales",
    "japanese",
    "dollar",
    "currency"
  ],
  char: "💴",
  fitzpatrick_scale: !1,
  category: "objects"
}, RN = {
  keywords: [
    "money",
    "sales",
    "dollar",
    "currency"
  ],
  char: "💶",
  fitzpatrick_scale: !1,
  category: "objects"
}, LN = {
  keywords: [
    "british",
    "sterling",
    "money",
    "sales",
    "bills",
    "uk",
    "england",
    "currency"
  ],
  char: "💷",
  fitzpatrick_scale: !1,
  category: "objects"
}, DN = {
  keywords: [
    "dollar",
    "payment",
    "coins",
    "sale"
  ],
  char: "💰",
  fitzpatrick_scale: !1,
  category: "objects"
}, NN = {
  keywords: [
    "money",
    "sales",
    "dollar",
    "bill",
    "payment",
    "shopping"
  ],
  char: "💳",
  fitzpatrick_scale: !1,
  category: "objects"
}, VN = {
  keywords: [
    "blue",
    "ruby",
    "diamond",
    "jewelry"
  ],
  char: "💎",
  fitzpatrick_scale: !1,
  category: "objects"
}, qN = {
  keywords: [
    "law",
    "fairness",
    "weight"
  ],
  char: "⚖",
  fitzpatrick_scale: !1,
  category: "objects"
}, BN = {
  keywords: [
    "tools",
    "diy",
    "fix",
    "maintainer",
    "mechanic"
  ],
  char: "🧰",
  fitzpatrick_scale: !1,
  category: "objects"
}, WN = {
  keywords: [
    "tools",
    "diy",
    "ikea",
    "fix",
    "maintainer"
  ],
  char: "🔧",
  fitzpatrick_scale: !1,
  category: "objects"
}, HN = {
  keywords: [
    "tools",
    "build",
    "create"
  ],
  char: "🔨",
  fitzpatrick_scale: !1,
  category: "objects"
}, UN = {
  keywords: [
    "tools",
    "build",
    "create"
  ],
  char: "⚒",
  fitzpatrick_scale: !1,
  category: "objects"
}, GN = {
  keywords: [
    "tools",
    "build",
    "create"
  ],
  char: "🛠",
  fitzpatrick_scale: !1,
  category: "objects"
}, KN = {
  keywords: [
    "tools",
    "dig"
  ],
  char: "⛏",
  fitzpatrick_scale: !1,
  category: "objects"
}, ZN = {
  keywords: [
    "handy",
    "tools",
    "fix"
  ],
  char: "🔩",
  fitzpatrick_scale: !1,
  category: "objects"
}, YN = {
  keywords: [
    "cog"
  ],
  char: "⚙",
  fitzpatrick_scale: !1,
  category: "objects"
}, XN = {
  keywords: [
    "bricks"
  ],
  char: "🧱",
  fitzpatrick_scale: !1,
  category: "objects"
}, JN = {
  keywords: [
    "lock",
    "arrest"
  ],
  char: "⛓",
  fitzpatrick_scale: !1,
  category: "objects"
}, QN = {
  keywords: [
    "attraction",
    "magnetic"
  ],
  char: "🧲",
  fitzpatrick_scale: !1,
  category: "objects"
}, $N = {
  keywords: [
    "violence",
    "weapon",
    "pistol",
    "revolver"
  ],
  char: "🔫",
  fitzpatrick_scale: !1,
  category: "objects"
}, eV = {
  keywords: [
    "boom",
    "explode",
    "explosion",
    "terrorism"
  ],
  char: "💣",
  fitzpatrick_scale: !1,
  category: "objects"
}, tV = {
  keywords: [
    "dynamite",
    "boom",
    "explode",
    "explosion",
    "explosive"
  ],
  char: "🧨",
  fitzpatrick_scale: !1,
  category: "objects"
}, aV = {
  keywords: [
    "knife",
    "blade",
    "cutlery",
    "kitchen",
    "weapon"
  ],
  char: "🔪",
  fitzpatrick_scale: !1,
  category: "objects"
}, rV = {
  keywords: [
    "weapon"
  ],
  char: "🗡",
  fitzpatrick_scale: !1,
  category: "objects"
}, nV = {
  keywords: [
    "weapon"
  ],
  char: "⚔",
  fitzpatrick_scale: !1,
  category: "objects"
}, oV = {
  keywords: [
    "protection",
    "security"
  ],
  char: "🛡",
  fitzpatrick_scale: !1,
  category: "objects"
}, sV = {
  keywords: [
    "kills",
    "tobacco",
    "cigarette",
    "joint",
    "smoke"
  ],
  char: "🚬",
  fitzpatrick_scale: !1,
  category: "objects"
}, iV = {
  keywords: [
    "poison",
    "danger",
    "deadly",
    "scary",
    "death",
    "pirate",
    "evil"
  ],
  char: "☠",
  fitzpatrick_scale: !1,
  category: "objects"
}, lV = {
  keywords: [
    "vampire",
    "dead",
    "die",
    "death",
    "rip",
    "graveyard",
    "cemetery",
    "casket",
    "funeral",
    "box"
  ],
  char: "⚰",
  fitzpatrick_scale: !1,
  category: "objects"
}, cV = {
  keywords: [
    "dead",
    "die",
    "death",
    "rip",
    "ashes"
  ],
  char: "⚱",
  fitzpatrick_scale: !1,
  category: "objects"
}, uV = {
  keywords: [
    "vase",
    "jar"
  ],
  char: "🏺",
  fitzpatrick_scale: !1,
  category: "objects"
}, dV = {
  keywords: [
    "disco",
    "party",
    "magic",
    "circus",
    "fortune_teller"
  ],
  char: "🔮",
  fitzpatrick_scale: !1,
  category: "objects"
}, fV = {
  keywords: [
    "dhikr",
    "religious"
  ],
  char: "📿",
  fitzpatrick_scale: !1,
  category: "objects"
}, pV = {
  keywords: [
    "bead",
    "charm"
  ],
  char: "🧿",
  fitzpatrick_scale: !1,
  category: "objects"
}, yV = {
  keywords: [
    "hair",
    "salon",
    "style"
  ],
  char: "💈",
  fitzpatrick_scale: !1,
  category: "objects"
}, hV = {
  keywords: [
    "distilling",
    "science",
    "experiment",
    "chemistry"
  ],
  char: "⚗",
  fitzpatrick_scale: !1,
  category: "objects"
}, gV = {
  keywords: [
    "stars",
    "space",
    "zoom",
    "science",
    "astronomy"
  ],
  char: "🔭",
  fitzpatrick_scale: !1,
  category: "objects"
}, mV = {
  keywords: [
    "laboratory",
    "experiment",
    "zoomin",
    "science",
    "study"
  ],
  char: "🔬",
  fitzpatrick_scale: !1,
  category: "objects"
}, _V = {
  keywords: [
    "embarrassing"
  ],
  char: "🕳",
  fitzpatrick_scale: !1,
  category: "objects"
}, wV = {
  keywords: [
    "health",
    "medicine",
    "doctor",
    "pharmacy",
    "drug"
  ],
  char: "💊",
  fitzpatrick_scale: !1,
  category: "objects"
}, vV = {
  keywords: [
    "health",
    "hospital",
    "drugs",
    "blood",
    "medicine",
    "needle",
    "doctor",
    "nurse"
  ],
  char: "💉",
  fitzpatrick_scale: !1,
  category: "objects"
}, bV = {
  keywords: [
    "biologist",
    "genetics",
    "life"
  ],
  char: "🧬",
  fitzpatrick_scale: !1,
  category: "objects"
}, kV = {
  keywords: [
    "amoeba",
    "bacteria",
    "germs"
  ],
  char: "🦠",
  fitzpatrick_scale: !1,
  category: "objects"
}, xV = {
  keywords: [
    "bacteria",
    "biology",
    "culture",
    "lab"
  ],
  char: "🧫",
  fitzpatrick_scale: !1,
  category: "objects"
}, zV = {
  keywords: [
    "chemistry",
    "experiment",
    "lab",
    "science"
  ],
  char: "🧪",
  fitzpatrick_scale: !1,
  category: "objects"
}, SV = {
  keywords: [
    "weather",
    "temperature",
    "hot",
    "cold"
  ],
  char: "🌡",
  fitzpatrick_scale: !1,
  category: "objects"
}, CV = {
  keywords: [
    "cleaning",
    "sweeping",
    "witch"
  ],
  char: "🧹",
  fitzpatrick_scale: !1,
  category: "objects"
}, EV = {
  keywords: [
    "laundry"
  ],
  char: "🧺",
  fitzpatrick_scale: !1,
  category: "objects"
}, AV = {
  keywords: [
    "roll"
  ],
  char: "🧻",
  fitzpatrick_scale: !1,
  category: "objects"
}, TV = {
  keywords: [
    "sale",
    "tag"
  ],
  char: "🏷",
  fitzpatrick_scale: !1,
  category: "objects"
}, PV = {
  keywords: [
    "favorite",
    "label",
    "save"
  ],
  char: "🔖",
  fitzpatrick_scale: !1,
  category: "objects"
}, OV = {
  keywords: [
    "restroom",
    "wc",
    "washroom",
    "bathroom",
    "potty"
  ],
  char: "🚽",
  fitzpatrick_scale: !1,
  category: "objects"
}, MV = {
  keywords: [
    "clean",
    "water",
    "bathroom"
  ],
  char: "🚿",
  fitzpatrick_scale: !1,
  category: "objects"
}, IV = {
  keywords: [
    "clean",
    "shower",
    "bathroom"
  ],
  char: "🛁",
  fitzpatrick_scale: !1,
  category: "objects"
}, FV = {
  keywords: [
    "bar",
    "bathing",
    "cleaning",
    "lather"
  ],
  char: "🧼",
  fitzpatrick_scale: !1,
  category: "objects"
}, jV = {
  keywords: [
    "absorbing",
    "cleaning",
    "porous"
  ],
  char: "🧽",
  fitzpatrick_scale: !1,
  category: "objects"
}, RV = {
  keywords: [
    "moisturizer",
    "sunscreen"
  ],
  char: "🧴",
  fitzpatrick_scale: !1,
  category: "objects"
}, LV = {
  keywords: [
    "lock",
    "door",
    "password"
  ],
  char: "🔑",
  fitzpatrick_scale: !1,
  category: "objects"
}, DV = {
  keywords: [
    "lock",
    "door",
    "password"
  ],
  char: "🗝",
  fitzpatrick_scale: !1,
  category: "objects"
}, NV = {
  keywords: [
    "read",
    "chill"
  ],
  char: "🛋",
  fitzpatrick_scale: !1,
  category: "objects"
}, VV = {
  keywords: [
    "bed",
    "rest"
  ],
  char: "🛌",
  fitzpatrick_scale: !0,
  category: "objects"
}, qV = {
  keywords: [
    "sleep",
    "rest"
  ],
  char: "🛏",
  fitzpatrick_scale: !1,
  category: "objects"
}, BV = {
  keywords: [
    "house",
    "entry",
    "exit"
  ],
  char: "🚪",
  fitzpatrick_scale: !1,
  category: "objects"
}, WV = {
  keywords: [
    "service"
  ],
  char: "🛎",
  fitzpatrick_scale: !1,
  category: "objects"
}, HV = {
  keywords: [
    "plush",
    "stuffed"
  ],
  char: "🧸",
  fitzpatrick_scale: !1,
  category: "objects"
}, UV = {
  keywords: [
    "photography"
  ],
  char: "🖼",
  fitzpatrick_scale: !1,
  category: "objects"
}, GV = {
  keywords: [
    "location",
    "direction"
  ],
  char: "🗺",
  fitzpatrick_scale: !1,
  category: "objects"
}, KV = {
  keywords: [
    "weather",
    "summer"
  ],
  char: "⛱",
  fitzpatrick_scale: !1,
  category: "objects"
}, ZV = {
  keywords: [
    "rock",
    "easter island",
    "moai"
  ],
  char: "🗿",
  fitzpatrick_scale: !1,
  category: "objects"
}, YV = {
  keywords: [
    "mall",
    "buy",
    "purchase"
  ],
  char: "🛍",
  fitzpatrick_scale: !1,
  category: "objects"
}, XV = {
  keywords: [
    "trolley"
  ],
  char: "🛒",
  fitzpatrick_scale: !1,
  category: "objects"
}, JV = {
  keywords: [
    "party",
    "celebration",
    "birthday",
    "circus"
  ],
  char: "🎈",
  fitzpatrick_scale: !1,
  category: "objects"
}, QV = {
  keywords: [
    "fish",
    "japanese",
    "koinobori",
    "carp",
    "banner"
  ],
  char: "🎏",
  fitzpatrick_scale: !1,
  category: "objects"
}, $V = {
  keywords: [
    "decoration",
    "pink",
    "girl",
    "bowtie"
  ],
  char: "🎀",
  fitzpatrick_scale: !1,
  category: "objects"
}, eq = {
  keywords: [
    "present",
    "birthday",
    "christmas",
    "xmas"
  ],
  char: "🎁",
  fitzpatrick_scale: !1,
  category: "objects"
}, tq = {
  keywords: [
    "festival",
    "party",
    "birthday",
    "circus"
  ],
  char: "🎊",
  fitzpatrick_scale: !1,
  category: "objects"
}, aq = {
  keywords: [
    "party",
    "congratulations",
    "birthday",
    "magic",
    "circus",
    "celebration"
  ],
  char: "🎉",
  fitzpatrick_scale: !1,
  category: "objects"
}, rq = {
  keywords: [
    "japanese",
    "toy",
    "kimono"
  ],
  char: "🎎",
  fitzpatrick_scale: !1,
  category: "objects"
}, nq = {
  keywords: [
    "nature",
    "ding",
    "spring",
    "bell"
  ],
  char: "🎐",
  fitzpatrick_scale: !1,
  category: "objects"
}, oq = {
  keywords: [
    "japanese",
    "nation",
    "country",
    "border"
  ],
  char: "🎌",
  fitzpatrick_scale: !1,
  category: "objects"
}, sq = {
  keywords: [
    "light",
    "paper",
    "halloween",
    "spooky"
  ],
  char: "🏮",
  fitzpatrick_scale: !1,
  category: "objects"
}, iq = {
  keywords: [
    "gift"
  ],
  char: "🧧",
  fitzpatrick_scale: !1,
  category: "objects"
}, lq = {
  keywords: [
    "letter",
    "postal",
    "inbox",
    "communication"
  ],
  char: "✉️",
  fitzpatrick_scale: !1,
  category: "objects"
}, cq = {
  keywords: [
    "email",
    "communication"
  ],
  char: "📩",
  fitzpatrick_scale: !1,
  category: "objects"
}, uq = {
  keywords: [
    "email",
    "inbox"
  ],
  char: "📨",
  fitzpatrick_scale: !1,
  category: "objects"
}, dq = {
  keywords: [
    "email",
    "like",
    "affection",
    "envelope",
    "valentines"
  ],
  char: "💌",
  fitzpatrick_scale: !1,
  category: "objects"
}, fq = {
  keywords: [
    "email",
    "letter",
    "envelope"
  ],
  char: "📮",
  fitzpatrick_scale: !1,
  category: "objects"
}, pq = {
  keywords: [
    "email",
    "communication",
    "inbox"
  ],
  char: "📪",
  fitzpatrick_scale: !1,
  category: "objects"
}, yq = {
  keywords: [
    "email",
    "inbox",
    "communication"
  ],
  char: "📫",
  fitzpatrick_scale: !1,
  category: "objects"
}, hq = {
  keywords: [
    "email",
    "inbox",
    "communication"
  ],
  char: "📬",
  fitzpatrick_scale: !1,
  category: "objects"
}, gq = {
  keywords: [
    "email",
    "inbox"
  ],
  char: "📭",
  fitzpatrick_scale: !1,
  category: "objects"
}, mq = {
  keywords: [
    "instrument",
    "music"
  ],
  char: "📯",
  fitzpatrick_scale: !1,
  category: "objects"
}, _q = {
  keywords: [
    "email",
    "documents"
  ],
  char: "📥",
  fitzpatrick_scale: !1,
  category: "objects"
}, wq = {
  keywords: [
    "inbox",
    "email"
  ],
  char: "📤",
  fitzpatrick_scale: !1,
  category: "objects"
}, vq = {
  keywords: [
    "documents",
    "ancient",
    "history",
    "paper"
  ],
  char: "📜",
  fitzpatrick_scale: !1,
  category: "objects"
}, bq = {
  keywords: [
    "documents",
    "office",
    "paper"
  ],
  char: "📃",
  fitzpatrick_scale: !1,
  category: "objects"
}, kq = {
  keywords: [
    "favorite",
    "save",
    "order",
    "tidy"
  ],
  char: "📑",
  fitzpatrick_scale: !1,
  category: "objects"
}, xq = {
  keywords: [
    "accounting",
    "expenses"
  ],
  char: "🧾",
  fitzpatrick_scale: !1,
  category: "objects"
}, zq = {
  keywords: [
    "graph",
    "presentation",
    "stats"
  ],
  char: "📊",
  fitzpatrick_scale: !1,
  category: "objects"
}, Sq = {
  keywords: [
    "graph",
    "presentation",
    "stats",
    "recovery",
    "business",
    "economics",
    "money",
    "sales",
    "good",
    "success"
  ],
  char: "📈",
  fitzpatrick_scale: !1,
  category: "objects"
}, Cq = {
  keywords: [
    "graph",
    "presentation",
    "stats",
    "recession",
    "business",
    "economics",
    "money",
    "sales",
    "bad",
    "failure"
  ],
  char: "📉",
  fitzpatrick_scale: !1,
  category: "objects"
}, Eq = {
  keywords: [
    "documents",
    "office",
    "paper",
    "information"
  ],
  char: "📄",
  fitzpatrick_scale: !1,
  category: "objects"
}, Aq = {
  keywords: [
    "calendar",
    "schedule"
  ],
  char: "📅",
  fitzpatrick_scale: !1,
  category: "objects"
}, Tq = {
  keywords: [
    "schedule",
    "date",
    "planning"
  ],
  char: "📆",
  fitzpatrick_scale: !1,
  category: "objects"
}, Pq = {
  keywords: [
    "date",
    "schedule",
    "planning"
  ],
  char: "🗓",
  fitzpatrick_scale: !1,
  category: "objects"
}, Oq = {
  keywords: [
    "business",
    "stationery"
  ],
  char: "📇",
  fitzpatrick_scale: !1,
  category: "objects"
}, Mq = {
  keywords: [
    "business",
    "stationery"
  ],
  char: "🗃",
  fitzpatrick_scale: !1,
  category: "objects"
}, Iq = {
  keywords: [
    "election",
    "vote"
  ],
  char: "🗳",
  fitzpatrick_scale: !1,
  category: "objects"
}, Fq = {
  keywords: [
    "filing",
    "organizing"
  ],
  char: "🗄",
  fitzpatrick_scale: !1,
  category: "objects"
}, jq = {
  keywords: [
    "stationery",
    "documents"
  ],
  char: "📋",
  fitzpatrick_scale: !1,
  category: "objects"
}, Rq = {
  keywords: [
    "memo",
    "stationery"
  ],
  char: "🗒",
  fitzpatrick_scale: !1,
  category: "objects"
}, Lq = {
  keywords: [
    "documents",
    "business",
    "office"
  ],
  char: "📁",
  fitzpatrick_scale: !1,
  category: "objects"
}, Dq = {
  keywords: [
    "documents",
    "load"
  ],
  char: "📂",
  fitzpatrick_scale: !1,
  category: "objects"
}, Nq = {
  keywords: [
    "organizing",
    "business",
    "stationery"
  ],
  char: "🗂",
  fitzpatrick_scale: !1,
  category: "objects"
}, Vq = {
  keywords: [
    "press",
    "headline"
  ],
  char: "🗞",
  fitzpatrick_scale: !1,
  category: "objects"
}, qq = {
  keywords: [
    "press",
    "headline"
  ],
  char: "📰",
  fitzpatrick_scale: !1,
  category: "objects"
}, Bq = {
  keywords: [
    "stationery",
    "record",
    "notes",
    "paper",
    "study"
  ],
  char: "📓",
  fitzpatrick_scale: !1,
  category: "objects"
}, Wq = {
  keywords: [
    "read",
    "library",
    "knowledge",
    "textbook",
    "learn"
  ],
  char: "📕",
  fitzpatrick_scale: !1,
  category: "objects"
}, Hq = {
  keywords: [
    "read",
    "library",
    "knowledge",
    "study"
  ],
  char: "📗",
  fitzpatrick_scale: !1,
  category: "objects"
}, Uq = {
  keywords: [
    "read",
    "library",
    "knowledge",
    "learn",
    "study"
  ],
  char: "📘",
  fitzpatrick_scale: !1,
  category: "objects"
}, Gq = {
  keywords: [
    "read",
    "library",
    "knowledge",
    "textbook",
    "study"
  ],
  char: "📙",
  fitzpatrick_scale: !1,
  category: "objects"
}, Kq = {
  keywords: [
    "classroom",
    "notes",
    "record",
    "paper",
    "study"
  ],
  char: "📔",
  fitzpatrick_scale: !1,
  category: "objects"
}, Zq = {
  keywords: [
    "notes",
    "paper"
  ],
  char: "📒",
  fitzpatrick_scale: !1,
  category: "objects"
}, Yq = {
  keywords: [
    "literature",
    "library",
    "study"
  ],
  char: "📚",
  fitzpatrick_scale: !1,
  category: "objects"
}, Xq = {
  keywords: [
    "book",
    "read",
    "library",
    "knowledge",
    "literature",
    "learn",
    "study"
  ],
  char: "📖",
  fitzpatrick_scale: !1,
  category: "objects"
}, Jq = {
  keywords: [
    "diaper"
  ],
  char: "🧷",
  fitzpatrick_scale: !1,
  category: "objects"
}, Qq = {
  keywords: [
    "rings",
    "url"
  ],
  char: "🔗",
  fitzpatrick_scale: !1,
  category: "objects"
}, $q = {
  keywords: [
    "documents",
    "stationery"
  ],
  char: "📎",
  fitzpatrick_scale: !1,
  category: "objects"
}, eB = {
  keywords: [
    "documents",
    "stationery"
  ],
  char: "🖇",
  fitzpatrick_scale: !1,
  category: "objects"
}, tB = {
  keywords: [
    "stationery",
    "cut"
  ],
  char: "✂️",
  fitzpatrick_scale: !1,
  category: "objects"
}, aB = {
  keywords: [
    "stationery",
    "math",
    "architect",
    "sketch"
  ],
  char: "📐",
  fitzpatrick_scale: !1,
  category: "objects"
}, rB = {
  keywords: [
    "stationery",
    "calculate",
    "length",
    "math",
    "school",
    "drawing",
    "architect",
    "sketch"
  ],
  char: "📏",
  fitzpatrick_scale: !1,
  category: "objects"
}, nB = {
  keywords: [
    "calculation"
  ],
  char: "🧮",
  fitzpatrick_scale: !1,
  category: "objects"
}, oB = {
  keywords: [
    "stationery",
    "mark",
    "here"
  ],
  char: "📌",
  fitzpatrick_scale: !1,
  category: "objects"
}, sB = {
  keywords: [
    "stationery",
    "location",
    "map",
    "here"
  ],
  char: "📍",
  fitzpatrick_scale: !1,
  category: "objects"
}, iB = {
  keywords: [
    "mark",
    "milestone",
    "place"
  ],
  char: "🚩",
  fitzpatrick_scale: !1,
  category: "objects"
}, lB = {
  keywords: [
    "losing",
    "loser",
    "lost",
    "surrender",
    "give up",
    "fail"
  ],
  char: "🏳",
  fitzpatrick_scale: !1,
  category: "objects"
}, cB = {
  keywords: [
    "pirate"
  ],
  char: "🏴",
  fitzpatrick_scale: !1,
  category: "objects"
}, uB = {
  keywords: [
    "flag",
    "rainbow",
    "pride",
    "gay",
    "lgbt",
    "glbt",
    "queer",
    "homosexual",
    "lesbian",
    "bisexual",
    "transgender"
  ],
  char: "🏳️‍🌈",
  fitzpatrick_scale: !1,
  category: "objects"
}, dB = {
  keywords: [
    "security",
    "privacy"
  ],
  char: "🔐",
  fitzpatrick_scale: !1,
  category: "objects"
}, fB = {
  keywords: [
    "security",
    "password",
    "padlock"
  ],
  char: "🔒",
  fitzpatrick_scale: !1,
  category: "objects"
}, pB = {
  keywords: [
    "privacy",
    "security"
  ],
  char: "🔓",
  fitzpatrick_scale: !1,
  category: "objects"
}, yB = {
  keywords: [
    "security",
    "secret"
  ],
  char: "🔏",
  fitzpatrick_scale: !1,
  category: "objects"
}, hB = {
  keywords: [
    "stationery",
    "writing",
    "write"
  ],
  char: "🖊",
  fitzpatrick_scale: !1,
  category: "objects"
}, gB = {
  keywords: [
    "stationery",
    "writing",
    "write"
  ],
  char: "🖋",
  fitzpatrick_scale: !1,
  category: "objects"
}, mB = {
  keywords: [
    "pen",
    "stationery",
    "writing",
    "write"
  ],
  char: "✒️",
  fitzpatrick_scale: !1,
  category: "objects"
}, _B = {
  keywords: [
    "write",
    "documents",
    "stationery",
    "pencil",
    "paper",
    "writing",
    "legal",
    "exam",
    "quiz",
    "test",
    "study",
    "compose"
  ],
  char: "📝",
  fitzpatrick_scale: !1,
  category: "objects"
}, wB = {
  keywords: [
    "stationery",
    "write",
    "paper",
    "writing",
    "school",
    "study"
  ],
  char: "✏️",
  fitzpatrick_scale: !1,
  category: "objects"
}, vB = {
  keywords: [
    "drawing",
    "creativity"
  ],
  char: "🖍",
  fitzpatrick_scale: !1,
  category: "objects"
}, bB = {
  keywords: [
    "drawing",
    "creativity",
    "art"
  ],
  char: "🖌",
  fitzpatrick_scale: !1,
  category: "objects"
}, kB = {
  keywords: [
    "search",
    "zoom",
    "find",
    "detective"
  ],
  char: "🔍",
  fitzpatrick_scale: !1,
  category: "objects"
}, xB = {
  keywords: [
    "search",
    "zoom",
    "find",
    "detective"
  ],
  char: "🔎",
  fitzpatrick_scale: !1,
  category: "objects"
}, zB = {
  keywords: [
    "love",
    "like",
    "valentines"
  ],
  char: "❤️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, SB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "🧡",
  fitzpatrick_scale: !1,
  category: "symbols"
}, CB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, EB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💚",
  fitzpatrick_scale: !1,
  category: "symbols"
}, AB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💙",
  fitzpatrick_scale: !1,
  category: "symbols"
}, TB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💜",
  fitzpatrick_scale: !1,
  category: "symbols"
}, PB = {
  keywords: [
    "evil"
  ],
  char: "🖤",
  fitzpatrick_scale: !1,
  category: "symbols"
}, OB = {
  keywords: [
    "sad",
    "sorry",
    "break",
    "heart",
    "heartbreak"
  ],
  char: "💔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, MB = {
  keywords: [
    "decoration",
    "love"
  ],
  char: "❣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, IB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines",
    "heart"
  ],
  char: "💕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, FB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💞",
  fitzpatrick_scale: !1,
  category: "symbols"
}, jB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines",
    "pink",
    "heart"
  ],
  char: "💓",
  fitzpatrick_scale: !1,
  category: "symbols"
}, RB = {
  keywords: [
    "like",
    "love",
    "affection",
    "valentines",
    "pink"
  ],
  char: "💗",
  fitzpatrick_scale: !1,
  category: "symbols"
}, LB = {
  keywords: [
    "love",
    "like",
    "affection",
    "valentines"
  ],
  char: "💖",
  fitzpatrick_scale: !1,
  category: "symbols"
}, DB = {
  keywords: [
    "love",
    "like",
    "heart",
    "affection",
    "valentines"
  ],
  char: "💘",
  fitzpatrick_scale: !1,
  category: "symbols"
}, NB = {
  keywords: [
    "love",
    "valentines"
  ],
  char: "💝",
  fitzpatrick_scale: !1,
  category: "symbols"
}, VB = {
  keywords: [
    "purple-square",
    "love",
    "like"
  ],
  char: "💟",
  fitzpatrick_scale: !1,
  category: "symbols"
}, qB = {
  keywords: [
    "hippie"
  ],
  char: "☮",
  fitzpatrick_scale: !1,
  category: "symbols"
}, BB = {
  keywords: [
    "christianity"
  ],
  char: "✝",
  fitzpatrick_scale: !1,
  category: "symbols"
}, WB = {
  keywords: [
    "islam"
  ],
  char: "☪",
  fitzpatrick_scale: !1,
  category: "symbols"
}, HB = {
  keywords: [
    "hinduism",
    "buddhism",
    "sikhism",
    "jainism"
  ],
  char: "🕉",
  fitzpatrick_scale: !1,
  category: "symbols"
}, UB = {
  keywords: [
    "hinduism",
    "buddhism",
    "sikhism",
    "jainism"
  ],
  char: "☸",
  fitzpatrick_scale: !1,
  category: "symbols"
}, GB = {
  keywords: [
    "judaism"
  ],
  char: "✡",
  fitzpatrick_scale: !1,
  category: "symbols"
}, KB = {
  keywords: [
    "purple-square",
    "religion",
    "jewish",
    "hexagram"
  ],
  char: "🔯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, ZB = {
  keywords: [
    "hanukkah",
    "candles",
    "jewish"
  ],
  char: "🕎",
  fitzpatrick_scale: !1,
  category: "symbols"
}, YB = {
  keywords: [
    "balance"
  ],
  char: "☯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, XB = {
  keywords: [
    "suppedaneum",
    "religion"
  ],
  char: "☦",
  fitzpatrick_scale: !1,
  category: "symbols"
}, JB = {
  keywords: [
    "religion",
    "church",
    "temple",
    "prayer"
  ],
  char: "🛐",
  fitzpatrick_scale: !1,
  category: "symbols"
}, QB = {
  keywords: [
    "sign",
    "purple-square",
    "constellation",
    "astrology"
  ],
  char: "⛎",
  fitzpatrick_scale: !1,
  category: "symbols"
}, $B = {
  keywords: [
    "sign",
    "purple-square",
    "zodiac",
    "astrology"
  ],
  char: "♈",
  fitzpatrick_scale: !1,
  category: "symbols"
}, eW = {
  keywords: [
    "purple-square",
    "sign",
    "zodiac",
    "astrology"
  ],
  char: "♉",
  fitzpatrick_scale: !1,
  category: "symbols"
}, tW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology"
  ],
  char: "♊",
  fitzpatrick_scale: !1,
  category: "symbols"
}, aW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology"
  ],
  char: "♋",
  fitzpatrick_scale: !1,
  category: "symbols"
}, rW = {
  keywords: [
    "sign",
    "purple-square",
    "zodiac",
    "astrology"
  ],
  char: "♌",
  fitzpatrick_scale: !1,
  category: "symbols"
}, nW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology"
  ],
  char: "♍",
  fitzpatrick_scale: !1,
  category: "symbols"
}, oW = {
  keywords: [
    "sign",
    "purple-square",
    "zodiac",
    "astrology"
  ],
  char: "♎",
  fitzpatrick_scale: !1,
  category: "symbols"
}, sW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology",
    "scorpio"
  ],
  char: "♏",
  fitzpatrick_scale: !1,
  category: "symbols"
}, iW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology"
  ],
  char: "♐",
  fitzpatrick_scale: !1,
  category: "symbols"
}, lW = {
  keywords: [
    "sign",
    "zodiac",
    "purple-square",
    "astrology"
  ],
  char: "♑",
  fitzpatrick_scale: !1,
  category: "symbols"
}, cW = {
  keywords: [
    "sign",
    "purple-square",
    "zodiac",
    "astrology"
  ],
  char: "♒",
  fitzpatrick_scale: !1,
  category: "symbols"
}, uW = {
  keywords: [
    "purple-square",
    "sign",
    "zodiac",
    "astrology"
  ],
  char: "♓",
  fitzpatrick_scale: !1,
  category: "symbols"
}, dW = {
  keywords: [
    "purple-square",
    "words"
  ],
  char: "🆔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, fW = {
  keywords: [
    "science",
    "physics",
    "chemistry"
  ],
  char: "⚛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, pW = {
  keywords: [
    "kanji",
    "japanese",
    "chinese",
    "empty",
    "sky",
    "blue-square"
  ],
  char: "🈳",
  fitzpatrick_scale: !1,
  category: "symbols"
}, yW = {
  keywords: [
    "cut",
    "divide",
    "chinese",
    "kanji",
    "pink-square"
  ],
  char: "🈹",
  fitzpatrick_scale: !1,
  category: "symbols"
}, hW = {
  keywords: [
    "nuclear",
    "danger"
  ],
  char: "☢",
  fitzpatrick_scale: !1,
  category: "symbols"
}, gW = {
  keywords: [
    "danger"
  ],
  char: "☣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, mW = {
  keywords: [
    "mute",
    "orange-square",
    "silence",
    "quiet"
  ],
  char: "📴",
  fitzpatrick_scale: !1,
  category: "symbols"
}, _W = {
  keywords: [
    "orange-square",
    "phone"
  ],
  char: "📳",
  fitzpatrick_scale: !1,
  category: "symbols"
}, wW = {
  keywords: [
    "orange-square",
    "chinese",
    "have",
    "kanji"
  ],
  char: "🈶",
  fitzpatrick_scale: !1,
  category: "symbols"
}, vW = {
  keywords: [
    "nothing",
    "chinese",
    "kanji",
    "japanese",
    "orange-square"
  ],
  char: "🈚",
  fitzpatrick_scale: !1,
  category: "symbols"
}, bW = {
  keywords: [
    "chinese",
    "japanese",
    "kanji",
    "orange-square"
  ],
  char: "🈸",
  fitzpatrick_scale: !1,
  category: "symbols"
}, kW = {
  keywords: [
    "japanese",
    "opening hours",
    "orange-square"
  ],
  char: "🈺",
  fitzpatrick_scale: !1,
  category: "symbols"
}, xW = {
  keywords: [
    "chinese",
    "month",
    "moon",
    "japanese",
    "orange-square",
    "kanji"
  ],
  char: "🈷️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, zW = {
  keywords: [
    "orange-square",
    "shape",
    "polygon"
  ],
  char: "✴️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, SW = {
  keywords: [
    "words",
    "orange-square"
  ],
  char: "🆚",
  fitzpatrick_scale: !1,
  category: "symbols"
}, CW = {
  keywords: [
    "ok",
    "good",
    "chinese",
    "kanji",
    "agree",
    "yes",
    "orange-circle"
  ],
  char: "🉑",
  fitzpatrick_scale: !1,
  category: "symbols"
}, EW = {
  keywords: [
    "japanese",
    "spring"
  ],
  char: "💮",
  fitzpatrick_scale: !1,
  category: "symbols"
}, AW = {
  keywords: [
    "chinese",
    "kanji",
    "obtain",
    "get",
    "circle"
  ],
  char: "🉐",
  fitzpatrick_scale: !1,
  category: "symbols"
}, TW = {
  keywords: [
    "privacy",
    "chinese",
    "sshh",
    "kanji",
    "red-circle"
  ],
  char: "㊙️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, PW = {
  keywords: [
    "chinese",
    "kanji",
    "japanese",
    "red-circle"
  ],
  char: "㊗️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, OW = {
  keywords: [
    "japanese",
    "chinese",
    "join",
    "kanji",
    "red-square"
  ],
  char: "🈴",
  fitzpatrick_scale: !1,
  category: "symbols"
}, MW = {
  keywords: [
    "full",
    "chinese",
    "japanese",
    "red-square",
    "kanji"
  ],
  char: "🈵",
  fitzpatrick_scale: !1,
  category: "symbols"
}, IW = {
  keywords: [
    "kanji",
    "japanese",
    "chinese",
    "forbidden",
    "limit",
    "restricted",
    "red-square"
  ],
  char: "🈲",
  fitzpatrick_scale: !1,
  category: "symbols"
}, FW = {
  keywords: [
    "red-square",
    "alphabet",
    "letter"
  ],
  char: "🅰️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, jW = {
  keywords: [
    "red-square",
    "alphabet",
    "letter"
  ],
  char: "🅱️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, RW = {
  keywords: [
    "red-square",
    "alphabet"
  ],
  char: "🆎",
  fitzpatrick_scale: !1,
  category: "symbols"
}, LW = {
  keywords: [
    "alphabet",
    "words",
    "red-square"
  ],
  char: "🆑",
  fitzpatrick_scale: !1,
  category: "symbols"
}, DW = {
  keywords: [
    "alphabet",
    "red-square",
    "letter"
  ],
  char: "🅾️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, NW = {
  keywords: [
    "help",
    "red-square",
    "words",
    "emergency",
    "911"
  ],
  char: "🆘",
  fitzpatrick_scale: !1,
  category: "symbols"
}, VW = {
  keywords: [
    "limit",
    "security",
    "privacy",
    "bad",
    "denied",
    "stop",
    "circle"
  ],
  char: "⛔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, qW = {
  keywords: [
    "fire",
    "forbid"
  ],
  char: "📛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, BW = {
  keywords: [
    "forbid",
    "stop",
    "limit",
    "denied",
    "disallow",
    "circle"
  ],
  char: "🚫",
  fitzpatrick_scale: !1,
  category: "symbols"
}, WW = {
  keywords: [
    "no",
    "delete",
    "remove",
    "cancel",
    "red"
  ],
  char: "❌",
  fitzpatrick_scale: !1,
  category: "symbols"
}, HW = {
  keywords: [
    "circle",
    "round"
  ],
  char: "⭕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, UW = {
  keywords: [
    "stop"
  ],
  char: "🛑",
  fitzpatrick_scale: !1,
  category: "symbols"
}, GW = {
  keywords: [
    "angry",
    "mad"
  ],
  char: "💢",
  fitzpatrick_scale: !1,
  category: "symbols"
}, KW = {
  keywords: [
    "bath",
    "warm",
    "relax"
  ],
  char: "♨️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, ZW = {
  keywords: [
    "rules",
    "crossing",
    "walking",
    "circle"
  ],
  char: "🚷",
  fitzpatrick_scale: !1,
  category: "symbols"
}, YW = {
  keywords: [
    "trash",
    "bin",
    "garbage",
    "circle"
  ],
  char: "🚯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, XW = {
  keywords: [
    "cyclist",
    "prohibited",
    "circle"
  ],
  char: "🚳",
  fitzpatrick_scale: !1,
  category: "symbols"
}, JW = {
  keywords: [
    "18",
    "drink",
    "pub",
    "night",
    "minor",
    "circle"
  ],
  char: "🔞",
  fitzpatrick_scale: !1,
  category: "symbols"
}, QW = {
  keywords: [
    "iphone",
    "mute",
    "circle"
  ],
  char: "📵",
  fitzpatrick_scale: !1,
  category: "symbols"
}, $W = {
  keywords: [
    "heavy_exclamation_mark",
    "danger",
    "surprise",
    "punctuation",
    "wow",
    "warning"
  ],
  char: "❗",
  fitzpatrick_scale: !1,
  category: "symbols"
}, eH = {
  keywords: [
    "surprise",
    "punctuation",
    "gray",
    "wow",
    "warning"
  ],
  char: "❕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, tH = {
  keywords: [
    "doubt",
    "confused"
  ],
  char: "❓",
  fitzpatrick_scale: !1,
  category: "symbols"
}, aH = {
  keywords: [
    "doubts",
    "gray",
    "huh",
    "confused"
  ],
  char: "❔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, rH = {
  keywords: [
    "exclamation",
    "surprise"
  ],
  char: "‼️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, nH = {
  keywords: [
    "wat",
    "punctuation",
    "surprise"
  ],
  char: "⁉️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, oH = {
  keywords: [
    "sun",
    "afternoon",
    "warm",
    "summer"
  ],
  char: "🔅",
  fitzpatrick_scale: !1,
  category: "symbols"
}, sH = {
  keywords: [
    "sun",
    "light"
  ],
  char: "🔆",
  fitzpatrick_scale: !1,
  category: "symbols"
}, iH = {
  keywords: [
    "weapon",
    "spear"
  ],
  char: "🔱",
  fitzpatrick_scale: !1,
  category: "symbols"
}, lH = {
  keywords: [
    "decorative",
    "scout"
  ],
  char: "⚜",
  fitzpatrick_scale: !1,
  category: "symbols"
}, cH = {
  keywords: [
    "graph",
    "presentation",
    "stats",
    "business",
    "economics",
    "bad"
  ],
  char: "〽️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, uH = {
  keywords: [
    "exclamation",
    "wip",
    "alert",
    "error",
    "problem",
    "issue"
  ],
  char: "⚠️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, dH = {
  keywords: [
    "school",
    "warning",
    "danger",
    "sign",
    "driving",
    "yellow-diamond"
  ],
  char: "🚸",
  fitzpatrick_scale: !1,
  category: "symbols"
}, fH = {
  keywords: [
    "badge",
    "shield"
  ],
  char: "🔰",
  fitzpatrick_scale: !1,
  category: "symbols"
}, pH = {
  keywords: [
    "arrow",
    "environment",
    "garbage",
    "trash"
  ],
  char: "♻️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, yH = {
  keywords: [
    "chinese",
    "point",
    "green-square",
    "kanji"
  ],
  char: "🈯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, hH = {
  keywords: [
    "green-square",
    "graph",
    "presentation",
    "stats"
  ],
  char: "💹",
  fitzpatrick_scale: !1,
  category: "symbols"
}, gH = {
  keywords: [
    "stars",
    "green-square",
    "awesome",
    "good",
    "fireworks"
  ],
  char: "❇️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, mH = {
  keywords: [
    "star",
    "sparkle",
    "green-square"
  ],
  char: "✳️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, _H = {
  keywords: [
    "x",
    "green-square",
    "no",
    "deny"
  ],
  char: "❎",
  fitzpatrick_scale: !1,
  category: "symbols"
}, wH = {
  keywords: [
    "green-square",
    "ok",
    "agree",
    "vote",
    "election",
    "answer",
    "tick"
  ],
  char: "✅",
  fitzpatrick_scale: !1,
  category: "symbols"
}, vH = {
  keywords: [
    "jewel",
    "blue",
    "gem",
    "crystal",
    "fancy"
  ],
  char: "💠",
  fitzpatrick_scale: !1,
  category: "symbols"
}, bH = {
  keywords: [
    "weather",
    "swirl",
    "blue",
    "cloud",
    "vortex",
    "spiral",
    "whirlpool",
    "spin",
    "tornado",
    "hurricane",
    "typhoon"
  ],
  char: "🌀",
  fitzpatrick_scale: !1,
  category: "symbols"
}, kH = {
  keywords: [
    "tape",
    "cassette"
  ],
  char: "➿",
  fitzpatrick_scale: !1,
  category: "symbols"
}, xH = {
  keywords: [
    "earth",
    "international",
    "world",
    "internet",
    "interweb",
    "i18n"
  ],
  char: "🌐",
  fitzpatrick_scale: !1,
  category: "symbols"
}, zH = {
  keywords: [
    "alphabet",
    "blue-circle",
    "letter"
  ],
  char: "Ⓜ️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, SH = {
  keywords: [
    "money",
    "sales",
    "cash",
    "blue-square",
    "payment",
    "bank"
  ],
  char: "🏧",
  fitzpatrick_scale: !1,
  category: "symbols"
}, CH = {
  keywords: [
    "japanese",
    "blue-square",
    "katakana"
  ],
  char: "🈂️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, EH = {
  keywords: [
    "custom",
    "blue-square"
  ],
  char: "🛂",
  fitzpatrick_scale: !1,
  category: "symbols"
}, AH = {
  keywords: [
    "passport",
    "border",
    "blue-square"
  ],
  char: "🛃",
  fitzpatrick_scale: !1,
  category: "symbols"
}, TH = {
  keywords: [
    "blue-square",
    "airport",
    "transport"
  ],
  char: "🛄",
  fitzpatrick_scale: !1,
  category: "symbols"
}, PH = {
  keywords: [
    "blue-square",
    "travel"
  ],
  char: "🛅",
  fitzpatrick_scale: !1,
  category: "symbols"
}, OH = {
  keywords: [
    "blue-square",
    "disabled",
    "a11y",
    "accessibility"
  ],
  char: "♿",
  fitzpatrick_scale: !1,
  category: "symbols"
}, MH = {
  keywords: [
    "cigarette",
    "blue-square",
    "smell",
    "smoke"
  ],
  char: "🚭",
  fitzpatrick_scale: !1,
  category: "symbols"
}, IH = {
  keywords: [
    "toilet",
    "restroom",
    "blue-square"
  ],
  char: "🚾",
  fitzpatrick_scale: !1,
  category: "symbols"
}, FH = {
  keywords: [
    "cars",
    "blue-square",
    "alphabet",
    "letter"
  ],
  char: "🅿️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, jH = {
  keywords: [
    "blue-square",
    "liquid",
    "restroom",
    "cleaning",
    "faucet"
  ],
  char: "🚰",
  fitzpatrick_scale: !1,
  category: "symbols"
}, RH = {
  keywords: [
    "toilet",
    "restroom",
    "wc",
    "blue-square",
    "gender",
    "male"
  ],
  char: "🚹",
  fitzpatrick_scale: !1,
  category: "symbols"
}, LH = {
  keywords: [
    "purple-square",
    "woman",
    "female",
    "toilet",
    "loo",
    "restroom",
    "gender"
  ],
  char: "🚺",
  fitzpatrick_scale: !1,
  category: "symbols"
}, DH = {
  keywords: [
    "orange-square",
    "child"
  ],
  char: "🚼",
  fitzpatrick_scale: !1,
  category: "symbols"
}, NH = {
  keywords: [
    "blue-square",
    "toilet",
    "refresh",
    "wc",
    "gender"
  ],
  char: "🚻",
  fitzpatrick_scale: !1,
  category: "symbols"
}, VH = {
  keywords: [
    "blue-square",
    "sign",
    "human",
    "info"
  ],
  char: "🚮",
  fitzpatrick_scale: !1,
  category: "symbols"
}, qH = {
  keywords: [
    "blue-square",
    "record",
    "film",
    "movie",
    "curtain",
    "stage",
    "theater"
  ],
  char: "🎦",
  fitzpatrick_scale: !1,
  category: "symbols"
}, BH = {
  keywords: [
    "blue-square",
    "reception",
    "phone",
    "internet",
    "connection",
    "wifi",
    "bluetooth",
    "bars"
  ],
  char: "📶",
  fitzpatrick_scale: !1,
  category: "symbols"
}, WH = {
  keywords: [
    "blue-square",
    "here",
    "katakana",
    "japanese",
    "destination"
  ],
  char: "🈁",
  fitzpatrick_scale: !1,
  category: "symbols"
}, HH = {
  keywords: [
    "blue-square",
    "words",
    "shape",
    "icon"
  ],
  char: "🆖",
  fitzpatrick_scale: !1,
  category: "symbols"
}, UH = {
  keywords: [
    "good",
    "agree",
    "yes",
    "blue-square"
  ],
  char: "🆗",
  fitzpatrick_scale: !1,
  category: "symbols"
}, GH = {
  keywords: [
    "blue-square",
    "above",
    "high"
  ],
  char: "🆙",
  fitzpatrick_scale: !1,
  category: "symbols"
}, KH = {
  keywords: [
    "words",
    "blue-square"
  ],
  char: "🆒",
  fitzpatrick_scale: !1,
  category: "symbols"
}, ZH = {
  keywords: [
    "blue-square",
    "words"
  ],
  char: "🆓",
  fitzpatrick_scale: !1,
  category: "symbols"
}, YH = {
  keywords: [
    "0",
    "numbers",
    "blue-square",
    "null"
  ],
  char: "0️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, XH = {
  keywords: [
    "blue-square",
    "numbers",
    "1"
  ],
  char: "1️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, JH = {
  keywords: [
    "numbers",
    "2",
    "prime",
    "blue-square"
  ],
  char: "2️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, QH = {
  keywords: [
    "3",
    "numbers",
    "prime",
    "blue-square"
  ],
  char: "3️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, $H = {
  keywords: [
    "4",
    "numbers",
    "blue-square"
  ],
  char: "4️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, eU = {
  keywords: [
    "5",
    "numbers",
    "blue-square",
    "prime"
  ],
  char: "5️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, tU = {
  keywords: [
    "6",
    "numbers",
    "blue-square"
  ],
  char: "6️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, aU = {
  keywords: [
    "7",
    "numbers",
    "blue-square",
    "prime"
  ],
  char: "7️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, rU = {
  keywords: [
    "8",
    "blue-square",
    "numbers"
  ],
  char: "8️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, nU = {
  keywords: [
    "blue-square",
    "numbers",
    "9"
  ],
  char: "9️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, oU = {
  keywords: [
    "numbers",
    "10",
    "blue-square"
  ],
  char: "🔟",
  fitzpatrick_scale: !1,
  category: "symbols"
}, sU = {
  keywords: [
    "star",
    "keycap"
  ],
  char: "*⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, iU = {
  keywords: [
    "blue-square"
  ],
  char: "⏏️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, lU = {
  keywords: [
    "blue-square",
    "right",
    "direction",
    "play"
  ],
  char: "▶️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, cU = {
  keywords: [
    "pause",
    "blue-square"
  ],
  char: "⏸",
  fitzpatrick_scale: !1,
  category: "symbols"
}, uU = {
  keywords: [
    "forward",
    "next",
    "blue-square"
  ],
  char: "⏭",
  fitzpatrick_scale: !1,
  category: "symbols"
}, dU = {
  keywords: [
    "blue-square"
  ],
  char: "⏹",
  fitzpatrick_scale: !1,
  category: "symbols"
}, fU = {
  keywords: [
    "blue-square"
  ],
  char: "⏺",
  fitzpatrick_scale: !1,
  category: "symbols"
}, pU = {
  keywords: [
    "blue-square",
    "play",
    "pause"
  ],
  char: "⏯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, yU = {
  keywords: [
    "backward"
  ],
  char: "⏮",
  fitzpatrick_scale: !1,
  category: "symbols"
}, hU = {
  keywords: [
    "blue-square",
    "play",
    "speed",
    "continue"
  ],
  char: "⏩",
  fitzpatrick_scale: !1,
  category: "symbols"
}, gU = {
  keywords: [
    "play",
    "blue-square"
  ],
  char: "⏪",
  fitzpatrick_scale: !1,
  category: "symbols"
}, mU = {
  keywords: [
    "blue-square",
    "shuffle",
    "music",
    "random"
  ],
  char: "🔀",
  fitzpatrick_scale: !1,
  category: "symbols"
}, _U = {
  keywords: [
    "loop",
    "record"
  ],
  char: "🔁",
  fitzpatrick_scale: !1,
  category: "symbols"
}, wU = {
  keywords: [
    "blue-square",
    "loop"
  ],
  char: "🔂",
  fitzpatrick_scale: !1,
  category: "symbols"
}, vU = {
  keywords: [
    "blue-square",
    "left",
    "direction"
  ],
  char: "◀️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, bU = {
  keywords: [
    "blue-square",
    "triangle",
    "direction",
    "point",
    "forward",
    "top"
  ],
  char: "🔼",
  fitzpatrick_scale: !1,
  category: "symbols"
}, kU = {
  keywords: [
    "blue-square",
    "direction",
    "bottom"
  ],
  char: "🔽",
  fitzpatrick_scale: !1,
  category: "symbols"
}, xU = {
  keywords: [
    "blue-square",
    "direction",
    "top"
  ],
  char: "⏫",
  fitzpatrick_scale: !1,
  category: "symbols"
}, zU = {
  keywords: [
    "blue-square",
    "direction",
    "bottom"
  ],
  char: "⏬",
  fitzpatrick_scale: !1,
  category: "symbols"
}, SU = {
  keywords: [
    "blue-square",
    "next"
  ],
  char: "➡️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, CU = {
  keywords: [
    "blue-square",
    "previous",
    "back"
  ],
  char: "⬅️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, EU = {
  keywords: [
    "blue-square",
    "continue",
    "top",
    "direction"
  ],
  char: "⬆️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, AU = {
  keywords: [
    "blue-square",
    "direction",
    "bottom"
  ],
  char: "⬇️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, TU = {
  keywords: [
    "blue-square",
    "point",
    "direction",
    "diagonal",
    "northeast"
  ],
  char: "↗️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, PU = {
  keywords: [
    "blue-square",
    "direction",
    "diagonal",
    "southeast"
  ],
  char: "↘️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, OU = {
  keywords: [
    "blue-square",
    "direction",
    "diagonal",
    "southwest"
  ],
  char: "↙️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, MU = {
  keywords: [
    "blue-square",
    "point",
    "direction",
    "diagonal",
    "northwest"
  ],
  char: "↖️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, IU = {
  keywords: [
    "blue-square",
    "direction",
    "way",
    "vertical"
  ],
  char: "↕️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, FU = {
  keywords: [
    "shape",
    "direction",
    "horizontal",
    "sideways"
  ],
  char: "↔️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, jU = {
  keywords: [
    "blue-square",
    "sync",
    "cycle"
  ],
  char: "🔄",
  fitzpatrick_scale: !1,
  category: "symbols"
}, RU = {
  keywords: [
    "blue-square",
    "return",
    "rotate",
    "direction"
  ],
  char: "↪️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, LU = {
  keywords: [
    "back",
    "return",
    "blue-square",
    "undo",
    "enter"
  ],
  char: "↩️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, DU = {
  keywords: [
    "blue-square",
    "direction",
    "top"
  ],
  char: "⤴️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, NU = {
  keywords: [
    "blue-square",
    "direction",
    "bottom"
  ],
  char: "⤵️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, VU = {
  keywords: [
    "symbol",
    "blue-square",
    "twitter"
  ],
  char: "#️⃣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, qU = {
  keywords: [
    "blue-square",
    "alphabet",
    "letter"
  ],
  char: "ℹ️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, BU = {
  keywords: [
    "blue-square",
    "alphabet"
  ],
  char: "🔤",
  fitzpatrick_scale: !1,
  category: "symbols"
}, WU = {
  keywords: [
    "blue-square",
    "alphabet"
  ],
  char: "🔡",
  fitzpatrick_scale: !1,
  category: "symbols"
}, HU = {
  keywords: [
    "alphabet",
    "words",
    "blue-square"
  ],
  char: "🔠",
  fitzpatrick_scale: !1,
  category: "symbols"
}, UU = {
  keywords: [
    "blue-square",
    "music",
    "note",
    "ampersand",
    "percent",
    "glyphs",
    "characters"
  ],
  char: "🔣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, GU = {
  keywords: [
    "score",
    "tone",
    "sound"
  ],
  char: "🎵",
  fitzpatrick_scale: !1,
  category: "symbols"
}, KU = {
  keywords: [
    "music",
    "score"
  ],
  char: "🎶",
  fitzpatrick_scale: !1,
  category: "symbols"
}, ZU = {
  keywords: [
    "draw",
    "line",
    "moustache",
    "mustache",
    "squiggle",
    "scribble"
  ],
  char: "〰️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, YU = {
  keywords: [
    "scribble",
    "draw",
    "shape",
    "squiggle"
  ],
  char: "➰",
  fitzpatrick_scale: !1,
  category: "symbols"
}, XU = {
  keywords: [
    "ok",
    "nike",
    "answer",
    "yes",
    "tick"
  ],
  char: "✔️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, JU = {
  keywords: [
    "sync",
    "cycle",
    "round",
    "repeat"
  ],
  char: "🔃",
  fitzpatrick_scale: !1,
  category: "symbols"
}, QU = {
  keywords: [
    "math",
    "calculation",
    "addition",
    "more",
    "increase"
  ],
  char: "➕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, $U = {
  keywords: [
    "math",
    "calculation",
    "subtract",
    "less"
  ],
  char: "➖",
  fitzpatrick_scale: !1,
  category: "symbols"
}, eG = {
  keywords: [
    "divide",
    "math",
    "calculation"
  ],
  char: "➗",
  fitzpatrick_scale: !1,
  category: "symbols"
}, tG = {
  keywords: [
    "math",
    "calculation"
  ],
  char: "✖️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, aG = {
  keywords: [
    "forever"
  ],
  char: "♾",
  fitzpatrick_scale: !1,
  category: "symbols"
}, rG = {
  keywords: [
    "money",
    "sales",
    "payment",
    "currency",
    "buck"
  ],
  char: "💲",
  fitzpatrick_scale: !1,
  category: "symbols"
}, nG = {
  keywords: [
    "money",
    "sales",
    "dollar",
    "travel"
  ],
  char: "💱",
  fitzpatrick_scale: !1,
  category: "symbols"
}, oG = {
  keywords: [
    "ip",
    "license",
    "circle",
    "law",
    "legal"
  ],
  char: "©️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, sG = {
  keywords: [
    "alphabet",
    "circle"
  ],
  char: "®️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, iG = {
  keywords: [
    "trademark",
    "brand",
    "law",
    "legal"
  ],
  char: "™️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, lG = {
  keywords: [
    "words",
    "arrow"
  ],
  char: "🔚",
  fitzpatrick_scale: !1,
  category: "symbols"
}, cG = {
  keywords: [
    "arrow",
    "words",
    "return"
  ],
  char: "🔙",
  fitzpatrick_scale: !1,
  category: "symbols"
}, uG = {
  keywords: [
    "arrow",
    "words"
  ],
  char: "🔛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, dG = {
  keywords: [
    "words",
    "blue-square"
  ],
  char: "🔝",
  fitzpatrick_scale: !1,
  category: "symbols"
}, fG = {
  keywords: [
    "arrow",
    "words"
  ],
  char: "🔜",
  fitzpatrick_scale: !1,
  category: "symbols"
}, pG = {
  keywords: [
    "ok",
    "agree",
    "confirm",
    "black-square",
    "vote",
    "election",
    "yes",
    "tick"
  ],
  char: "☑️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, yG = {
  keywords: [
    "input",
    "old",
    "music",
    "circle"
  ],
  char: "🔘",
  fitzpatrick_scale: !1,
  category: "symbols"
}, hG = {
  keywords: [
    "shape",
    "round"
  ],
  char: "⚪",
  fitzpatrick_scale: !1,
  category: "symbols"
}, gG = {
  keywords: [
    "shape",
    "button",
    "round"
  ],
  char: "⚫",
  fitzpatrick_scale: !1,
  category: "symbols"
}, mG = {
  keywords: [
    "shape",
    "error",
    "danger"
  ],
  char: "🔴",
  fitzpatrick_scale: !1,
  category: "symbols"
}, _G = {
  keywords: [
    "shape",
    "icon",
    "button"
  ],
  char: "🔵",
  fitzpatrick_scale: !1,
  category: "symbols"
}, wG = {
  keywords: [
    "shape",
    "jewel",
    "gem"
  ],
  char: "🔸",
  fitzpatrick_scale: !1,
  category: "symbols"
}, vG = {
  keywords: [
    "shape",
    "jewel",
    "gem"
  ],
  char: "🔹",
  fitzpatrick_scale: !1,
  category: "symbols"
}, bG = {
  keywords: [
    "shape",
    "jewel",
    "gem"
  ],
  char: "🔶",
  fitzpatrick_scale: !1,
  category: "symbols"
}, kG = {
  keywords: [
    "shape",
    "jewel",
    "gem"
  ],
  char: "🔷",
  fitzpatrick_scale: !1,
  category: "symbols"
}, xG = {
  keywords: [
    "shape",
    "direction",
    "up",
    "top"
  ],
  char: "🔺",
  fitzpatrick_scale: !1,
  category: "symbols"
}, zG = {
  keywords: [
    "shape",
    "icon"
  ],
  char: "▪️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, SG = {
  keywords: [
    "shape",
    "icon"
  ],
  char: "▫️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, CG = {
  keywords: [
    "shape",
    "icon",
    "button"
  ],
  char: "⬛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, EG = {
  keywords: [
    "shape",
    "icon",
    "stone",
    "button"
  ],
  char: "⬜",
  fitzpatrick_scale: !1,
  category: "symbols"
}, AG = {
  keywords: [
    "shape",
    "direction",
    "bottom"
  ],
  char: "🔻",
  fitzpatrick_scale: !1,
  category: "symbols"
}, TG = {
  keywords: [
    "shape",
    "button",
    "icon"
  ],
  char: "◼️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, PG = {
  keywords: [
    "shape",
    "stone",
    "icon"
  ],
  char: "◻️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, OG = {
  keywords: [
    "icon",
    "shape",
    "button"
  ],
  char: "◾",
  fitzpatrick_scale: !1,
  category: "symbols"
}, MG = {
  keywords: [
    "shape",
    "stone",
    "icon",
    "button"
  ],
  char: "◽",
  fitzpatrick_scale: !1,
  category: "symbols"
}, IG = {
  keywords: [
    "shape",
    "input",
    "frame"
  ],
  char: "🔲",
  fitzpatrick_scale: !1,
  category: "symbols"
}, FG = {
  keywords: [
    "shape",
    "input"
  ],
  char: "🔳",
  fitzpatrick_scale: !1,
  category: "symbols"
}, jG = {
  keywords: [
    "sound",
    "volume",
    "silence",
    "broadcast"
  ],
  char: "🔈",
  fitzpatrick_scale: !1,
  category: "symbols"
}, RG = {
  keywords: [
    "volume",
    "speaker",
    "broadcast"
  ],
  char: "🔉",
  fitzpatrick_scale: !1,
  category: "symbols"
}, LG = {
  keywords: [
    "volume",
    "noise",
    "noisy",
    "speaker",
    "broadcast"
  ],
  char: "🔊",
  fitzpatrick_scale: !1,
  category: "symbols"
}, DG = {
  keywords: [
    "sound",
    "volume",
    "silence",
    "quiet"
  ],
  char: "🔇",
  fitzpatrick_scale: !1,
  category: "symbols"
}, NG = {
  keywords: [
    "sound",
    "speaker",
    "volume"
  ],
  char: "📣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, VG = {
  keywords: [
    "volume",
    "sound"
  ],
  char: "📢",
  fitzpatrick_scale: !1,
  category: "symbols"
}, qG = {
  keywords: [
    "sound",
    "notification",
    "christmas",
    "xmas",
    "chime"
  ],
  char: "🔔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, BG = {
  keywords: [
    "sound",
    "volume",
    "mute",
    "quiet",
    "silent"
  ],
  char: "🔕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, WG = {
  keywords: [
    "poker",
    "cards",
    "game",
    "play",
    "magic"
  ],
  char: "🃏",
  fitzpatrick_scale: !1,
  category: "symbols"
}, HG = {
  keywords: [
    "game",
    "play",
    "chinese",
    "kanji"
  ],
  char: "🀄",
  fitzpatrick_scale: !1,
  category: "symbols"
}, UG = {
  keywords: [
    "poker",
    "cards",
    "suits",
    "magic"
  ],
  char: "♠️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, GG = {
  keywords: [
    "poker",
    "cards",
    "magic",
    "suits"
  ],
  char: "♣️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, KG = {
  keywords: [
    "poker",
    "cards",
    "magic",
    "suits"
  ],
  char: "♥️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, ZG = {
  keywords: [
    "poker",
    "cards",
    "magic",
    "suits"
  ],
  char: "♦️",
  fitzpatrick_scale: !1,
  category: "symbols"
}, YG = {
  keywords: [
    "game",
    "sunset",
    "red"
  ],
  char: "🎴",
  fitzpatrick_scale: !1,
  category: "symbols"
}, XG = {
  keywords: [
    "bubble",
    "cloud",
    "speech",
    "thinking",
    "dream"
  ],
  char: "💭",
  fitzpatrick_scale: !1,
  category: "symbols"
}, JG = {
  keywords: [
    "caption",
    "speech",
    "thinking",
    "mad"
  ],
  char: "🗯",
  fitzpatrick_scale: !1,
  category: "symbols"
}, QG = {
  keywords: [
    "bubble",
    "words",
    "message",
    "talk",
    "chatting"
  ],
  char: "💬",
  fitzpatrick_scale: !1,
  category: "symbols"
}, $G = {
  keywords: [
    "words",
    "message",
    "talk",
    "chatting"
  ],
  char: "🗨",
  fitzpatrick_scale: !1,
  category: "symbols"
}, eK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕐",
  fitzpatrick_scale: !1,
  category: "symbols"
}, tK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕑",
  fitzpatrick_scale: !1,
  category: "symbols"
}, aK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕒",
  fitzpatrick_scale: !1,
  category: "symbols"
}, rK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕓",
  fitzpatrick_scale: !1,
  category: "symbols"
}, nK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕔",
  fitzpatrick_scale: !1,
  category: "symbols"
}, oK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule",
    "dawn",
    "dusk"
  ],
  char: "🕕",
  fitzpatrick_scale: !1,
  category: "symbols"
}, sK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕖",
  fitzpatrick_scale: !1,
  category: "symbols"
}, iK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕗",
  fitzpatrick_scale: !1,
  category: "symbols"
}, lK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕘",
  fitzpatrick_scale: !1,
  category: "symbols"
}, cK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕙",
  fitzpatrick_scale: !1,
  category: "symbols"
}, uK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕚",
  fitzpatrick_scale: !1,
  category: "symbols"
}, dK = {
  keywords: [
    "time",
    "noon",
    "midnight",
    "midday",
    "late",
    "early",
    "schedule"
  ],
  char: "🕛",
  fitzpatrick_scale: !1,
  category: "symbols"
}, fK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕜",
  fitzpatrick_scale: !1,
  category: "symbols"
}, pK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕝",
  fitzpatrick_scale: !1,
  category: "symbols"
}, yK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕞",
  fitzpatrick_scale: !1,
  category: "symbols"
}, hK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕟",
  fitzpatrick_scale: !1,
  category: "symbols"
}, gK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕠",
  fitzpatrick_scale: !1,
  category: "symbols"
}, mK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕡",
  fitzpatrick_scale: !1,
  category: "symbols"
}, _K = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕢",
  fitzpatrick_scale: !1,
  category: "symbols"
}, wK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕣",
  fitzpatrick_scale: !1,
  category: "symbols"
}, vK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕤",
  fitzpatrick_scale: !1,
  category: "symbols"
}, bK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕥",
  fitzpatrick_scale: !1,
  category: "symbols"
}, kK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕦",
  fitzpatrick_scale: !1,
  category: "symbols"
}, xK = {
  keywords: [
    "time",
    "late",
    "early",
    "schedule"
  ],
  char: "🕧",
  fitzpatrick_scale: !1,
  category: "symbols"
}, zK = {
  keywords: [
    "af",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, SK = {
  keywords: [
    "Åland",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇽",
  fitzpatrick_scale: !1,
  category: "flags"
}, CK = {
  keywords: [
    "al",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, EK = {
  keywords: [
    "dz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇩🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, AK = {
  keywords: [
    "american",
    "ws",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, TK = {
  keywords: [
    "ad",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, PK = {
  keywords: [
    "ao",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, OK = {
  keywords: [
    "ai",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, MK = {
  keywords: [
    "aq",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇶",
  fitzpatrick_scale: !1,
  category: "flags"
}, IK = {
  keywords: [
    "antigua",
    "barbuda",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, FK = {
  keywords: [
    "ar",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, jK = {
  keywords: [
    "am",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, RK = {
  keywords: [
    "aw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, LK = {
  keywords: [
    "au",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, DK = {
  keywords: [
    "at",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, NK = {
  keywords: [
    "az",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, VK = {
  keywords: [
    "bs",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, qK = {
  keywords: [
    "bh",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, BK = {
  keywords: [
    "bd",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, WK = {
  keywords: [
    "bb",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇧",
  fitzpatrick_scale: !1,
  category: "flags"
}, HK = {
  keywords: [
    "by",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, UK = {
  keywords: [
    "be",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, GK = {
  keywords: [
    "bz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, KK = {
  keywords: [
    "bj",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇯",
  fitzpatrick_scale: !1,
  category: "flags"
}, ZK = {
  keywords: [
    "bm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, YK = {
  keywords: [
    "bt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, XK = {
  keywords: [
    "bo",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, JK = {
  keywords: [
    "bonaire",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇶",
  fitzpatrick_scale: !1,
  category: "flags"
}, QK = {
  keywords: [
    "bosnia",
    "herzegovina",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, $K = {
  keywords: [
    "bw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, eZ = {
  keywords: [
    "br",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, tZ = {
  keywords: [
    "british",
    "indian",
    "ocean",
    "territory",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, aZ = {
  keywords: [
    "british",
    "virgin",
    "islands",
    "bvi",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, rZ = {
  keywords: [
    "bn",
    "darussalam",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, nZ = {
  keywords: [
    "bg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, oZ = {
  keywords: [
    "burkina",
    "faso",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, sZ = {
  keywords: [
    "bi",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, iZ = {
  keywords: [
    "cabo",
    "verde",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇻",
  fitzpatrick_scale: !1,
  category: "flags"
}, lZ = {
  keywords: [
    "kh",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, cZ = {
  keywords: [
    "cm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, uZ = {
  keywords: [
    "ca",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, dZ = {
  keywords: [
    "canary",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, fZ = {
  keywords: [
    "cayman",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, pZ = {
  keywords: [
    "central",
    "african",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, yZ = {
  keywords: [
    "td",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, hZ = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, gZ = {
  keywords: [
    "china",
    "chinese",
    "prc",
    "flag",
    "country",
    "nation",
    "banner"
  ],
  char: "🇨🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, mZ = {
  keywords: [
    "christmas",
    "island",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇽",
  fitzpatrick_scale: !1,
  category: "flags"
}, _Z = {
  keywords: [
    "cocos",
    "keeling",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, wZ = {
  keywords: [
    "co",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, vZ = {
  keywords: [
    "km",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, bZ = {
  keywords: [
    "congo",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, kZ = {
  keywords: [
    "congo",
    "democratic",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, xZ = {
  keywords: [
    "cook",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, zZ = {
  keywords: [
    "costa",
    "rica",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, SZ = {
  keywords: [
    "hr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇭🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, CZ = {
  keywords: [
    "cu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, EZ = {
  keywords: [
    "curaçao",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, AZ = {
  keywords: [
    "cy",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, TZ = {
  keywords: [
    "cz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, PZ = {
  keywords: [
    "dk",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇩🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, OZ = {
  keywords: [
    "dj",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇩🇯",
  fitzpatrick_scale: !1,
  category: "flags"
}, MZ = {
  keywords: [
    "dm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇩🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, IZ = {
  keywords: [
    "dominican",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇩🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, FZ = {
  keywords: [
    "ec",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, jZ = {
  keywords: [
    "eg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, RZ = {
  keywords: [
    "el",
    "salvador",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇻",
  fitzpatrick_scale: !1,
  category: "flags"
}, LZ = {
  keywords: [
    "equatorial",
    "gn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇶",
  fitzpatrick_scale: !1,
  category: "flags"
}, DZ = {
  keywords: [
    "er",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, NZ = {
  keywords: [
    "ee",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, VZ = {
  keywords: [
    "et",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, qZ = {
  keywords: [
    "european",
    "union",
    "flag",
    "banner"
  ],
  char: "🇪🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, BZ = {
  keywords: [
    "falkland",
    "islands",
    "malvinas",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇫🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, WZ = {
  keywords: [
    "faroe",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇫🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, HZ = {
  keywords: [
    "fj",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇫🇯",
  fitzpatrick_scale: !1,
  category: "flags"
}, UZ = {
  keywords: [
    "fi",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇫🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, GZ = {
  keywords: [
    "banner",
    "flag",
    "nation",
    "france",
    "french",
    "country"
  ],
  char: "🇫🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, KZ = {
  keywords: [
    "french",
    "guiana",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, ZZ = {
  keywords: [
    "french",
    "polynesia",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, YZ = {
  keywords: [
    "french",
    "southern",
    "territories",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, XZ = {
  keywords: [
    "ga",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, JZ = {
  keywords: [
    "gm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, QZ = {
  keywords: [
    "ge",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, $Z = {
  keywords: [
    "german",
    "nation",
    "flag",
    "country",
    "banner"
  ],
  char: "🇩🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, eY = {
  keywords: [
    "gh",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, tY = {
  keywords: [
    "gi",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, aY = {
  keywords: [
    "gr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, rY = {
  keywords: [
    "gl",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, nY = {
  keywords: [
    "gd",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, oY = {
  keywords: [
    "gp",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇵",
  fitzpatrick_scale: !1,
  category: "flags"
}, sY = {
  keywords: [
    "gu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, iY = {
  keywords: [
    "gt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, lY = {
  keywords: [
    "gg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, cY = {
  keywords: [
    "gn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, uY = {
  keywords: [
    "gw",
    "bissau",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, dY = {
  keywords: [
    "gy",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, fY = {
  keywords: [
    "ht",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇭🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, pY = {
  keywords: [
    "hn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇭🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, yY = {
  keywords: [
    "hong",
    "kong",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇭🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, hY = {
  keywords: [
    "hu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇭🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, gY = {
  keywords: [
    "is",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, mY = {
  keywords: [
    "in",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, _Y = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, wY = {
  keywords: [
    "iran,",
    "islamic",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, vY = {
  keywords: [
    "iq",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇶",
  fitzpatrick_scale: !1,
  category: "flags"
}, bY = {
  keywords: [
    "ie",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, kY = {
  keywords: [
    "isle",
    "man",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, xY = {
  keywords: [
    "il",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, zY = {
  keywords: [
    "italy",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇮🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, SY = {
  keywords: [
    "ivory",
    "coast",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, CY = {
  keywords: [
    "jm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇯🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, EY = {
  keywords: [
    "japanese",
    "nation",
    "flag",
    "country",
    "banner"
  ],
  char: "🇯🇵",
  fitzpatrick_scale: !1,
  category: "flags"
}, AY = {
  keywords: [
    "je",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇯🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, TY = {
  keywords: [
    "jo",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇯🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, PY = {
  keywords: [
    "kz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, OY = {
  keywords: [
    "ke",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, MY = {
  keywords: [
    "ki",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, IY = {
  keywords: [
    "xk",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇽🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, FY = {
  keywords: [
    "kw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, jY = {
  keywords: [
    "kg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, RY = {
  keywords: [
    "lao",
    "democratic",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, LY = {
  keywords: [
    "lv",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇻",
  fitzpatrick_scale: !1,
  category: "flags"
}, DY = {
  keywords: [
    "lb",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇧",
  fitzpatrick_scale: !1,
  category: "flags"
}, NY = {
  keywords: [
    "ls",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, VY = {
  keywords: [
    "lr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, qY = {
  keywords: [
    "ly",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, BY = {
  keywords: [
    "li",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, WY = {
  keywords: [
    "lt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, HY = {
  keywords: [
    "lu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, UY = {
  keywords: [
    "macao",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, GY = {
  keywords: [
    "macedonia,",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, KY = {
  keywords: [
    "mg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, ZY = {
  keywords: [
    "mw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, YY = {
  keywords: [
    "my",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, XY = {
  keywords: [
    "mv",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇻",
  fitzpatrick_scale: !1,
  category: "flags"
}, JY = {
  keywords: [
    "ml",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, QY = {
  keywords: [
    "mt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, $Y = {
  keywords: [
    "marshall",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, eX = {
  keywords: [
    "mq",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇶",
  fitzpatrick_scale: !1,
  category: "flags"
}, tX = {
  keywords: [
    "mr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, aX = {
  keywords: [
    "mu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, rX = {
  keywords: [
    "yt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇾🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, nX = {
  keywords: [
    "mx",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇽",
  fitzpatrick_scale: !1,
  category: "flags"
}, oX = {
  keywords: [
    "micronesia,",
    "federated",
    "states",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇫🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, sX = {
  keywords: [
    "moldova,",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, iX = {
  keywords: [
    "mc",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, lX = {
  keywords: [
    "mn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, cX = {
  keywords: [
    "me",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, uX = {
  keywords: [
    "ms",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, dX = {
  keywords: [
    "ma",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, fX = {
  keywords: [
    "mz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, pX = {
  keywords: [
    "mm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, yX = {
  keywords: [
    "na",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, hX = {
  keywords: [
    "nr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, gX = {
  keywords: [
    "np",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇵",
  fitzpatrick_scale: !1,
  category: "flags"
}, mX = {
  keywords: [
    "nl",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, _X = {
  keywords: [
    "new",
    "caledonia",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, wX = {
  keywords: [
    "new",
    "zealand",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, vX = {
  keywords: [
    "ni",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, bX = {
  keywords: [
    "ne",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, kX = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, xX = {
  keywords: [
    "nu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, zX = {
  keywords: [
    "norfolk",
    "island",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, SX = {
  keywords: [
    "northern",
    "mariana",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇲🇵",
  fitzpatrick_scale: !1,
  category: "flags"
}, CX = {
  keywords: [
    "north",
    "korea",
    "nation",
    "flag",
    "country",
    "banner"
  ],
  char: "🇰🇵",
  fitzpatrick_scale: !1,
  category: "flags"
}, EX = {
  keywords: [
    "no",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇳🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, AX = {
  keywords: [
    "om_symbol",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇴🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, TX = {
  keywords: [
    "pk",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, PX = {
  keywords: [
    "pw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, OX = {
  keywords: [
    "palestine",
    "palestinian",
    "territories",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, MX = {
  keywords: [
    "pa",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, IX = {
  keywords: [
    "papua",
    "new",
    "guinea",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, FX = {
  keywords: [
    "py",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, jX = {
  keywords: [
    "pe",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, RX = {
  keywords: [
    "ph",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, LX = {
  keywords: [
    "pitcairn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, DX = {
  keywords: [
    "pl",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, NX = {
  keywords: [
    "pt",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, VX = {
  keywords: [
    "puerto",
    "rico",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, qX = {
  keywords: [
    "qa",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇶🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, BX = {
  keywords: [
    "réunion",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇷🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, WX = {
  keywords: [
    "ro",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇷🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, HX = {
  keywords: [
    "russian",
    "federation",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇷🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, UX = {
  keywords: [
    "rw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇷🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, GX = {
  keywords: [
    "saint",
    "barthélemy",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇧🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, KX = {
  keywords: [
    "saint",
    "helena",
    "ascension",
    "tristan",
    "cunha",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, ZX = {
  keywords: [
    "saint",
    "kitts",
    "nevis",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇰🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, YX = {
  keywords: [
    "saint",
    "lucia",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, XX = {
  keywords: [
    "saint",
    "pierre",
    "miquelon",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇵🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, JX = {
  keywords: [
    "saint",
    "vincent",
    "grenadines",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, QX = {
  keywords: [
    "ws",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇼🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, $X = {
  keywords: [
    "san",
    "marino",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, eJ = {
  keywords: [
    "sao",
    "tome",
    "principe",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, tJ = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, aJ = {
  keywords: [
    "sn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, rJ = {
  keywords: [
    "rs",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇷🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, nJ = {
  keywords: [
    "sc",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, oJ = {
  keywords: [
    "sierra",
    "leone",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, sJ = {
  keywords: [
    "sg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, iJ = {
  keywords: [
    "sint",
    "maarten",
    "dutch",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇽",
  fitzpatrick_scale: !1,
  category: "flags"
}, lJ = {
  keywords: [
    "sk",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, cJ = {
  keywords: [
    "si",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, uJ = {
  keywords: [
    "solomon",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇧",
  fitzpatrick_scale: !1,
  category: "flags"
}, dJ = {
  keywords: [
    "so",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, fJ = {
  keywords: [
    "south",
    "africa",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇿🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, pJ = {
  keywords: [
    "south",
    "georgia",
    "sandwich",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇬🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, yJ = {
  keywords: [
    "south",
    "korea",
    "nation",
    "flag",
    "country",
    "banner"
  ],
  char: "🇰🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, hJ = {
  keywords: [
    "south",
    "sd",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, gJ = {
  keywords: [
    "spain",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, mJ = {
  keywords: [
    "sri",
    "lanka",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇱🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, _J = {
  keywords: [
    "sd",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇩",
  fitzpatrick_scale: !1,
  category: "flags"
}, wJ = {
  keywords: [
    "sr",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, vJ = {
  keywords: [
    "sz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, bJ = {
  keywords: [
    "se",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, kJ = {
  keywords: [
    "ch",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇨🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, xJ = {
  keywords: [
    "syrian",
    "arab",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇸🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, zJ = {
  keywords: [
    "tw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, SJ = {
  keywords: [
    "tj",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇯",
  fitzpatrick_scale: !1,
  category: "flags"
}, CJ = {
  keywords: [
    "tanzania,",
    "united",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, EJ = {
  keywords: [
    "th",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, AJ = {
  keywords: [
    "timor",
    "leste",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇱",
  fitzpatrick_scale: !1,
  category: "flags"
}, TJ = {
  keywords: [
    "tg",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, PJ = {
  keywords: [
    "tk",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇰",
  fitzpatrick_scale: !1,
  category: "flags"
}, OJ = {
  keywords: [
    "to",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇴",
  fitzpatrick_scale: !1,
  category: "flags"
}, MJ = {
  keywords: [
    "trinidad",
    "tobago",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇹",
  fitzpatrick_scale: !1,
  category: "flags"
}, IJ = {
  keywords: [
    "tn",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, FJ = {
  keywords: [
    "turkey",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇷",
  fitzpatrick_scale: !1,
  category: "flags"
}, jJ = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, RJ = {
  keywords: [
    "turks",
    "caicos",
    "islands",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇨",
  fitzpatrick_scale: !1,
  category: "flags"
}, LJ = {
  keywords: [
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇹🇻",
  fitzpatrick_scale: !1,
  category: "flags"
}, DJ = {
  keywords: [
    "ug",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇺🇬",
  fitzpatrick_scale: !1,
  category: "flags"
}, NJ = {
  keywords: [
    "ua",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇺🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, VJ = {
  keywords: [
    "united",
    "arab",
    "emirates",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇦🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, qJ = {
  keywords: [
    "united",
    "kingdom",
    "great",
    "britain",
    "northern",
    "ireland",
    "flag",
    "nation",
    "country",
    "banner",
    "british",
    "UK",
    "english",
    "england",
    "union jack"
  ],
  char: "🇬🇧",
  fitzpatrick_scale: !1,
  category: "flags"
}, BJ = {
  keywords: [
    "flag",
    "english"
  ],
  char: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
  fitzpatrick_scale: !1,
  category: "flags"
}, WJ = {
  keywords: [
    "flag",
    "scottish"
  ],
  char: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  fitzpatrick_scale: !1,
  category: "flags"
}, HJ = {
  keywords: [
    "flag",
    "welsh"
  ],
  char: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
  fitzpatrick_scale: !1,
  category: "flags"
}, UJ = {
  keywords: [
    "united",
    "states",
    "america",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇺🇸",
  fitzpatrick_scale: !1,
  category: "flags"
}, GJ = {
  keywords: [
    "virgin",
    "islands",
    "us",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇮",
  fitzpatrick_scale: !1,
  category: "flags"
}, KJ = {
  keywords: [
    "uy",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇺🇾",
  fitzpatrick_scale: !1,
  category: "flags"
}, ZJ = {
  keywords: [
    "uz",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇺🇿",
  fitzpatrick_scale: !1,
  category: "flags"
}, YJ = {
  keywords: [
    "vu",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇺",
  fitzpatrick_scale: !1,
  category: "flags"
}, XJ = {
  keywords: [
    "vatican",
    "city",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇦",
  fitzpatrick_scale: !1,
  category: "flags"
}, JJ = {
  keywords: [
    "ve",
    "bolivarian",
    "republic",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, QJ = {
  keywords: [
    "viet",
    "nam",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇻🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, $J = {
  keywords: [
    "wallis",
    "futuna",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇼🇫",
  fitzpatrick_scale: !1,
  category: "flags"
}, eQ = {
  keywords: [
    "western",
    "sahara",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇪🇭",
  fitzpatrick_scale: !1,
  category: "flags"
}, tQ = {
  keywords: [
    "ye",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇾🇪",
  fitzpatrick_scale: !1,
  category: "flags"
}, aQ = {
  keywords: [
    "zm",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇿🇲",
  fitzpatrick_scale: !1,
  category: "flags"
}, rQ = {
  keywords: [
    "zw",
    "flag",
    "nation",
    "country",
    "banner"
  ],
  char: "🇿🇼",
  fitzpatrick_scale: !1,
  category: "flags"
}, nQ = {
  keywords: [
    "un",
    "flag",
    "banner"
  ],
  char: "🇺🇳",
  fitzpatrick_scale: !1,
  category: "flags"
}, oQ = {
  keywords: [
    "skull",
    "crossbones",
    "flag",
    "banner"
  ],
  char: "🏴‍☠️",
  fitzpatrick_scale: !1,
  category: "flags"
}, sQ = {
  100: {
    keywords: [
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass",
      "hundred"
    ],
    char: "💯",
    fitzpatrick_scale: !1,
    category: "symbols"
  },
  1234: {
    keywords: [
      "numbers",
      "blue-square"
    ],
    char: "🔢",
    fitzpatrick_scale: !1,
    category: "symbols"
  },
  grinning: h6,
  grimacing: g6,
  grin: m6,
  joy: _6,
  rofl: w6,
  partying: v6,
  smiley: b6,
  smile: k6,
  sweat_smile: x6,
  laughing: z6,
  innocent: S6,
  wink: C6,
  blush: E6,
  slightly_smiling_face: A6,
  upside_down_face: T6,
  relaxed: P6,
  yum: O6,
  relieved: M6,
  heart_eyes: I6,
  smiling_face_with_three_hearts: F6,
  kissing_heart: j6,
  kissing: R6,
  kissing_smiling_eyes: L6,
  kissing_closed_eyes: D6,
  stuck_out_tongue_winking_eye: N6,
  zany: V6,
  raised_eyebrow: q6,
  monocle: B6,
  stuck_out_tongue_closed_eyes: W6,
  stuck_out_tongue: H6,
  money_mouth_face: U6,
  nerd_face: G6,
  sunglasses: K6,
  star_struck: Z6,
  clown_face: Y6,
  cowboy_hat_face: X6,
  hugs: J6,
  smirk: Q6,
  no_mouth: $6,
  neutral_face: eC,
  expressionless: tC,
  unamused: aC,
  roll_eyes: rC,
  thinking: nC,
  lying_face: oC,
  hand_over_mouth: sC,
  shushing: iC,
  symbols_over_mouth: lC,
  exploding_head: cC,
  flushed: uC,
  disappointed: dC,
  worried: fC,
  angry: pC,
  rage: yC,
  pensive: hC,
  confused: gC,
  slightly_frowning_face: mC,
  frowning_face: _C,
  persevere: wC,
  confounded: vC,
  tired_face: bC,
  weary: kC,
  pleading: xC,
  triumph: zC,
  open_mouth: SC,
  scream: CC,
  fearful: EC,
  cold_sweat: AC,
  hushed: TC,
  frowning: PC,
  anguished: OC,
  cry: MC,
  disappointed_relieved: IC,
  drooling_face: FC,
  sleepy: jC,
  sweat: RC,
  hot: LC,
  cold: DC,
  sob: NC,
  dizzy_face: VC,
  astonished: qC,
  zipper_mouth_face: BC,
  nauseated_face: WC,
  sneezing_face: HC,
  vomiting: UC,
  mask: GC,
  face_with_thermometer: KC,
  face_with_head_bandage: ZC,
  woozy: YC,
  sleeping: XC,
  zzz: JC,
  poop: QC,
  smiling_imp: $C,
  imp: eE,
  japanese_ogre: tE,
  japanese_goblin: aE,
  skull: rE,
  ghost: nE,
  alien: oE,
  robot: sE,
  smiley_cat: iE,
  smile_cat: lE,
  joy_cat: cE,
  heart_eyes_cat: uE,
  smirk_cat: dE,
  kissing_cat: fE,
  scream_cat: pE,
  crying_cat_face: yE,
  pouting_cat: hE,
  palms_up: gE,
  raised_hands: mE,
  clap: _E,
  wave: wE,
  call_me_hand: vE,
  "+1": {
    keywords: [
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    char: "👍",
    fitzpatrick_scale: !0,
    category: "people"
  },
  "-1": {
    keywords: [
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    char: "👎",
    fitzpatrick_scale: !0,
    category: "people"
  },
  facepunch: bE,
  fist: kE,
  fist_left: xE,
  fist_right: zE,
  v: SE,
  ok_hand: CE,
  raised_hand: EE,
  raised_back_of_hand: AE,
  open_hands: TE,
  muscle: PE,
  pray: OE,
  foot: ME,
  leg: IE,
  handshake: FE,
  point_up: jE,
  point_up_2: RE,
  point_down: LE,
  point_left: DE,
  point_right: NE,
  fu: VE,
  raised_hand_with_fingers_splayed: qE,
  love_you: BE,
  metal: WE,
  crossed_fingers: HE,
  vulcan_salute: UE,
  writing_hand: GE,
  selfie: KE,
  nail_care: ZE,
  lips: YE,
  tooth: XE,
  tongue: JE,
  ear: QE,
  nose: $E,
  eye: e8,
  eyes: t8,
  brain: a8,
  bust_in_silhouette: r8,
  busts_in_silhouette: n8,
  speaking_head: o8,
  baby: s8,
  child: i8,
  boy: l8,
  girl: c8,
  adult: u8,
  man: d8,
  woman: f8,
  blonde_woman: p8,
  blonde_man: y8,
  bearded_person: h8,
  older_adult: g8,
  older_man: m8,
  older_woman: _8,
  man_with_gua_pi_mao: w8,
  woman_with_headscarf: v8,
  woman_with_turban: b8,
  man_with_turban: k8,
  policewoman: x8,
  policeman: z8,
  construction_worker_woman: S8,
  construction_worker_man: C8,
  guardswoman: E8,
  guardsman: A8,
  female_detective: T8,
  male_detective: P8,
  woman_health_worker: O8,
  man_health_worker: M8,
  woman_farmer: I8,
  man_farmer: F8,
  woman_cook: j8,
  man_cook: R8,
  woman_student: L8,
  man_student: D8,
  woman_singer: N8,
  man_singer: V8,
  woman_teacher: q8,
  man_teacher: B8,
  woman_factory_worker: W8,
  man_factory_worker: H8,
  woman_technologist: U8,
  man_technologist: G8,
  woman_office_worker: K8,
  man_office_worker: Z8,
  woman_mechanic: Y8,
  man_mechanic: X8,
  woman_scientist: J8,
  man_scientist: Q8,
  woman_artist: $8,
  man_artist: eA,
  woman_firefighter: tA,
  man_firefighter: aA,
  woman_pilot: rA,
  man_pilot: nA,
  woman_astronaut: oA,
  man_astronaut: sA,
  woman_judge: iA,
  man_judge: lA,
  woman_superhero: cA,
  man_superhero: uA,
  woman_supervillain: dA,
  man_supervillain: fA,
  mrs_claus: pA,
  santa: yA,
  sorceress: hA,
  wizard: gA,
  woman_elf: mA,
  man_elf: _A,
  woman_vampire: wA,
  man_vampire: vA,
  woman_zombie: bA,
  man_zombie: kA,
  woman_genie: xA,
  man_genie: zA,
  mermaid: SA,
  merman: CA,
  woman_fairy: EA,
  man_fairy: AA,
  angel: TA,
  pregnant_woman: PA,
  breastfeeding: OA,
  princess: MA,
  prince: IA,
  bride_with_veil: FA,
  man_in_tuxedo: jA,
  running_woman: RA,
  running_man: LA,
  walking_woman: DA,
  walking_man: NA,
  dancer: VA,
  man_dancing: qA,
  dancing_women: BA,
  dancing_men: WA,
  couple: HA,
  two_men_holding_hands: UA,
  two_women_holding_hands: GA,
  bowing_woman: KA,
  bowing_man: ZA,
  man_facepalming: YA,
  woman_facepalming: XA,
  woman_shrugging: JA,
  man_shrugging: QA,
  tipping_hand_woman: $A,
  tipping_hand_man: eT,
  no_good_woman: tT,
  no_good_man: aT,
  ok_woman: rT,
  ok_man: nT,
  raising_hand_woman: oT,
  raising_hand_man: sT,
  pouting_woman: iT,
  pouting_man: lT,
  frowning_woman: cT,
  frowning_man: uT,
  haircut_woman: dT,
  haircut_man: fT,
  massage_woman: pT,
  massage_man: yT,
  woman_in_steamy_room: hT,
  man_in_steamy_room: gT,
  couple_with_heart_woman_man: mT,
  couple_with_heart_woman_woman: _T,
  couple_with_heart_man_man: wT,
  couplekiss_man_woman: vT,
  couplekiss_woman_woman: bT,
  couplekiss_man_man: kT,
  family_man_woman_boy: xT,
  family_man_woman_girl: zT,
  family_man_woman_girl_boy: ST,
  family_man_woman_boy_boy: CT,
  family_man_woman_girl_girl: ET,
  family_woman_woman_boy: AT,
  family_woman_woman_girl: TT,
  family_woman_woman_girl_boy: PT,
  family_woman_woman_boy_boy: OT,
  family_woman_woman_girl_girl: MT,
  family_man_man_boy: IT,
  family_man_man_girl: FT,
  family_man_man_girl_boy: jT,
  family_man_man_boy_boy: RT,
  family_man_man_girl_girl: LT,
  family_woman_boy: DT,
  family_woman_girl: NT,
  family_woman_girl_boy: VT,
  family_woman_boy_boy: qT,
  family_woman_girl_girl: BT,
  family_man_boy: WT,
  family_man_girl: HT,
  family_man_girl_boy: UT,
  family_man_boy_boy: GT,
  family_man_girl_girl: KT,
  yarn: ZT,
  thread: YT,
  coat: XT,
  labcoat: JT,
  womans_clothes: QT,
  tshirt: $T,
  jeans: e7,
  necktie: t7,
  dress: a7,
  bikini: r7,
  kimono: n7,
  lipstick: o7,
  kiss: s7,
  footprints: i7,
  flat_shoe: l7,
  high_heel: c7,
  sandal: u7,
  boot: d7,
  mans_shoe: f7,
  athletic_shoe: p7,
  hiking_boot: y7,
  socks: h7,
  gloves: g7,
  scarf: m7,
  womans_hat: _7,
  tophat: w7,
  billed_hat: v7,
  rescue_worker_helmet: b7,
  mortar_board: k7,
  crown: x7,
  school_satchel: z7,
  luggage: S7,
  pouch: C7,
  purse: E7,
  handbag: A7,
  briefcase: T7,
  eyeglasses: P7,
  dark_sunglasses: O7,
  goggles: M7,
  ring: I7,
  closed_umbrella: F7,
  dog: j7,
  cat: R7,
  mouse: L7,
  hamster: D7,
  rabbit: N7,
  fox_face: V7,
  bear: q7,
  panda_face: B7,
  koala: W7,
  tiger: H7,
  lion: U7,
  cow: G7,
  pig: K7,
  pig_nose: Z7,
  frog: Y7,
  squid: X7,
  octopus: J7,
  shrimp: Q7,
  monkey_face: $7,
  gorilla: eP,
  see_no_evil: tP,
  hear_no_evil: aP,
  speak_no_evil: rP,
  monkey: nP,
  chicken: oP,
  penguin: sP,
  bird: iP,
  baby_chick: lP,
  hatching_chick: cP,
  hatched_chick: uP,
  duck: dP,
  eagle: fP,
  owl: pP,
  bat: yP,
  wolf: hP,
  boar: gP,
  horse: mP,
  unicorn: _P,
  honeybee: wP,
  bug: vP,
  butterfly: bP,
  snail: kP,
  beetle: xP,
  ant: zP,
  grasshopper: SP,
  spider: CP,
  scorpion: EP,
  crab: AP,
  snake: TP,
  lizard: PP,
  "t-rex": {
    keywords: [
      "animal",
      "nature",
      "dinosaur",
      "tyrannosaurus",
      "extinct"
    ],
    char: "🦖",
    fitzpatrick_scale: !1,
    category: "animals_and_nature"
  },
  sauropod: OP,
  turtle: MP,
  tropical_fish: IP,
  fish: FP,
  blowfish: jP,
  dolphin: RP,
  shark: LP,
  whale: DP,
  whale2: NP,
  crocodile: VP,
  leopard: qP,
  zebra: BP,
  tiger2: WP,
  water_buffalo: HP,
  ox: UP,
  cow2: GP,
  deer: KP,
  dromedary_camel: ZP,
  camel: YP,
  giraffe: XP,
  elephant: JP,
  rhinoceros: QP,
  goat: $P,
  ram: eO,
  sheep: tO,
  racehorse: aO,
  pig2: rO,
  rat: nO,
  mouse2: oO,
  rooster: sO,
  turkey: iO,
  dove: lO,
  dog2: cO,
  poodle: uO,
  cat2: dO,
  rabbit2: fO,
  chipmunk: pO,
  hedgehog: yO,
  raccoon: hO,
  llama: gO,
  hippopotamus: mO,
  kangaroo: _O,
  badger: wO,
  swan: vO,
  peacock: bO,
  parrot: kO,
  lobster: xO,
  mosquito: zO,
  paw_prints: SO,
  dragon: CO,
  dragon_face: EO,
  cactus: AO,
  christmas_tree: TO,
  evergreen_tree: PO,
  deciduous_tree: OO,
  palm_tree: MO,
  seedling: IO,
  herb: FO,
  shamrock: jO,
  four_leaf_clover: RO,
  bamboo: LO,
  tanabata_tree: DO,
  leaves: NO,
  fallen_leaf: VO,
  maple_leaf: qO,
  ear_of_rice: BO,
  hibiscus: WO,
  sunflower: HO,
  rose: UO,
  wilted_flower: GO,
  tulip: KO,
  blossom: ZO,
  cherry_blossom: YO,
  bouquet: XO,
  mushroom: JO,
  chestnut: QO,
  jack_o_lantern: $O,
  shell: eM,
  spider_web: tM,
  earth_americas: aM,
  earth_africa: rM,
  earth_asia: nM,
  full_moon: oM,
  waning_gibbous_moon: sM,
  last_quarter_moon: iM,
  waning_crescent_moon: lM,
  new_moon: cM,
  waxing_crescent_moon: uM,
  first_quarter_moon: dM,
  waxing_gibbous_moon: fM,
  new_moon_with_face: pM,
  full_moon_with_face: yM,
  first_quarter_moon_with_face: hM,
  last_quarter_moon_with_face: gM,
  sun_with_face: mM,
  crescent_moon: _M,
  star: wM,
  star2: vM,
  dizzy: bM,
  sparkles: kM,
  comet: xM,
  sunny: zM,
  sun_behind_small_cloud: SM,
  partly_sunny: CM,
  sun_behind_large_cloud: EM,
  sun_behind_rain_cloud: AM,
  cloud: TM,
  cloud_with_rain: PM,
  cloud_with_lightning_and_rain: OM,
  cloud_with_lightning: MM,
  zap: IM,
  fire: FM,
  boom: jM,
  snowflake: RM,
  cloud_with_snow: LM,
  snowman: DM,
  snowman_with_snow: NM,
  wind_face: VM,
  dash: qM,
  tornado: BM,
  fog: WM,
  open_umbrella: HM,
  umbrella: UM,
  droplet: GM,
  sweat_drops: KM,
  ocean: ZM,
  green_apple: YM,
  apple: XM,
  pear: JM,
  tangerine: QM,
  lemon: $M,
  banana: eI,
  watermelon: tI,
  grapes: aI,
  strawberry: rI,
  melon: nI,
  cherries: oI,
  peach: sI,
  pineapple: iI,
  coconut: lI,
  kiwi_fruit: cI,
  mango: uI,
  avocado: dI,
  broccoli: fI,
  tomato: pI,
  eggplant: yI,
  cucumber: hI,
  carrot: gI,
  hot_pepper: mI,
  potato: _I,
  corn: wI,
  leafy_greens: vI,
  sweet_potato: bI,
  peanuts: kI,
  honey_pot: xI,
  croissant: zI,
  bread: SI,
  baguette_bread: CI,
  bagel: EI,
  pretzel: AI,
  cheese: TI,
  egg: PI,
  bacon: OI,
  steak: MI,
  pancakes: II,
  poultry_leg: FI,
  meat_on_bone: jI,
  bone: RI,
  fried_shrimp: LI,
  fried_egg: DI,
  hamburger: NI,
  fries: VI,
  stuffed_flatbread: qI,
  hotdog: BI,
  pizza: WI,
  sandwich: HI,
  canned_food: UI,
  spaghetti: GI,
  taco: KI,
  burrito: ZI,
  green_salad: YI,
  shallow_pan_of_food: XI,
  ramen: JI,
  stew: QI,
  fish_cake: $I,
  fortune_cookie: eF,
  sushi: tF,
  bento: aF,
  curry: rF,
  rice_ball: nF,
  rice: oF,
  rice_cracker: sF,
  oden: iF,
  dango: lF,
  shaved_ice: cF,
  ice_cream: uF,
  icecream: dF,
  pie: fF,
  cake: pF,
  cupcake: yF,
  moon_cake: hF,
  birthday: gF,
  custard: mF,
  candy: _F,
  lollipop: wF,
  chocolate_bar: vF,
  popcorn: bF,
  dumpling: kF,
  doughnut: xF,
  cookie: zF,
  milk_glass: SF,
  beer: CF,
  beers: EF,
  clinking_glasses: AF,
  wine_glass: TF,
  tumbler_glass: PF,
  cocktail: OF,
  tropical_drink: MF,
  champagne: IF,
  sake: FF,
  tea: jF,
  cup_with_straw: RF,
  coffee: LF,
  baby_bottle: DF,
  salt: NF,
  spoon: VF,
  fork_and_knife: qF,
  plate_with_cutlery: BF,
  bowl_with_spoon: WF,
  takeout_box: HF,
  chopsticks: UF,
  soccer: GF,
  basketball: KF,
  football: ZF,
  baseball: YF,
  softball: XF,
  tennis: JF,
  volleyball: QF,
  rugby_football: $F,
  flying_disc: ej,
  "8ball": {
    keywords: [
      "pool",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    char: "🎱",
    fitzpatrick_scale: !1,
    category: "activity"
  },
  golf: tj,
  golfing_woman: aj,
  golfing_man: rj,
  ping_pong: nj,
  badminton: oj,
  goal_net: sj,
  ice_hockey: ij,
  field_hockey: lj,
  lacrosse: cj,
  cricket: uj,
  ski: dj,
  skier: fj,
  snowboarder: pj,
  person_fencing: yj,
  women_wrestling: hj,
  men_wrestling: gj,
  woman_cartwheeling: mj,
  man_cartwheeling: _j,
  woman_playing_handball: wj,
  man_playing_handball: vj,
  ice_skate: bj,
  curling_stone: kj,
  skateboard: xj,
  sled: zj,
  bow_and_arrow: Sj,
  fishing_pole_and_fish: Cj,
  boxing_glove: Ej,
  martial_arts_uniform: Aj,
  rowing_woman: Tj,
  rowing_man: Pj,
  climbing_woman: Oj,
  climbing_man: Mj,
  swimming_woman: Ij,
  swimming_man: Fj,
  woman_playing_water_polo: jj,
  man_playing_water_polo: Rj,
  woman_in_lotus_position: Lj,
  man_in_lotus_position: Dj,
  surfing_woman: Nj,
  surfing_man: Vj,
  bath: qj,
  basketball_woman: Bj,
  basketball_man: Wj,
  weight_lifting_woman: Hj,
  weight_lifting_man: Uj,
  biking_woman: Gj,
  biking_man: Kj,
  mountain_biking_woman: Zj,
  mountain_biking_man: Yj,
  horse_racing: Xj,
  business_suit_levitating: Jj,
  trophy: Qj,
  running_shirt_with_sash: $j,
  medal_sports: eR,
  medal_military: tR,
  "1st_place_medal": {
    keywords: [
      "award",
      "winning",
      "first"
    ],
    char: "🥇",
    fitzpatrick_scale: !1,
    category: "activity"
  },
  "2nd_place_medal": {
    keywords: [
      "award",
      "second"
    ],
    char: "🥈",
    fitzpatrick_scale: !1,
    category: "activity"
  },
  "3rd_place_medal": {
    keywords: [
      "award",
      "third"
    ],
    char: "🥉",
    fitzpatrick_scale: !1,
    category: "activity"
  },
  reminder_ribbon: aR,
  rosette: rR,
  ticket: nR,
  tickets: oR,
  performing_arts: sR,
  art: iR,
  circus_tent: lR,
  woman_juggling: cR,
  man_juggling: uR,
  microphone: dR,
  headphones: fR,
  musical_score: pR,
  musical_keyboard: yR,
  drum: hR,
  saxophone: gR,
  trumpet: mR,
  guitar: _R,
  violin: wR,
  clapper: vR,
  video_game: bR,
  space_invader: kR,
  dart: xR,
  game_die: zR,
  chess_pawn: SR,
  slot_machine: CR,
  jigsaw: ER,
  bowling: AR,
  red_car: TR,
  taxi: PR,
  blue_car: OR,
  bus: MR,
  trolleybus: IR,
  racing_car: FR,
  police_car: jR,
  ambulance: RR,
  fire_engine: LR,
  minibus: DR,
  truck: NR,
  articulated_lorry: VR,
  tractor: qR,
  kick_scooter: BR,
  motorcycle: WR,
  bike: HR,
  motor_scooter: UR,
  rotating_light: GR,
  oncoming_police_car: KR,
  oncoming_bus: ZR,
  oncoming_automobile: YR,
  oncoming_taxi: XR,
  aerial_tramway: JR,
  mountain_cableway: QR,
  suspension_railway: $R,
  railway_car: eL,
  train: tL,
  monorail: aL,
  bullettrain_side: rL,
  bullettrain_front: nL,
  light_rail: oL,
  mountain_railway: sL,
  steam_locomotive: iL,
  train2: lL,
  metro: cL,
  tram: uL,
  station: dL,
  flying_saucer: fL,
  helicopter: pL,
  small_airplane: yL,
  airplane: hL,
  flight_departure: gL,
  flight_arrival: mL,
  sailboat: _L,
  motor_boat: wL,
  speedboat: vL,
  ferry: bL,
  passenger_ship: kL,
  rocket: xL,
  artificial_satellite: zL,
  seat: SL,
  canoe: CL,
  anchor: EL,
  construction: AL,
  fuelpump: TL,
  busstop: PL,
  vertical_traffic_light: OL,
  traffic_light: ML,
  checkered_flag: IL,
  ship: FL,
  ferris_wheel: jL,
  roller_coaster: RL,
  carousel_horse: LL,
  building_construction: DL,
  foggy: NL,
  tokyo_tower: VL,
  factory: qL,
  fountain: BL,
  rice_scene: WL,
  mountain: HL,
  mountain_snow: UL,
  mount_fuji: GL,
  volcano: KL,
  japan: ZL,
  camping: YL,
  tent: XL,
  national_park: JL,
  motorway: QL,
  railway_track: $L,
  sunrise: eD,
  sunrise_over_mountains: tD,
  desert: aD,
  beach_umbrella: rD,
  desert_island: nD,
  city_sunrise: oD,
  city_sunset: sD,
  cityscape: iD,
  night_with_stars: lD,
  bridge_at_night: cD,
  milky_way: uD,
  stars: dD,
  sparkler: fD,
  fireworks: pD,
  rainbow: yD,
  houses: hD,
  european_castle: gD,
  japanese_castle: mD,
  stadium: _D,
  statue_of_liberty: wD,
  house: vD,
  house_with_garden: bD,
  derelict_house: kD,
  office: xD,
  department_store: zD,
  post_office: SD,
  european_post_office: CD,
  hospital: ED,
  bank: AD,
  hotel: TD,
  convenience_store: PD,
  school: OD,
  love_hotel: MD,
  wedding: ID,
  classical_building: FD,
  church: jD,
  mosque: RD,
  synagogue: LD,
  kaaba: DD,
  shinto_shrine: ND,
  watch: VD,
  iphone: qD,
  calling: BD,
  computer: WD,
  keyboard: HD,
  desktop_computer: UD,
  printer: GD,
  computer_mouse: KD,
  trackball: ZD,
  joystick: YD,
  clamp: XD,
  minidisc: JD,
  floppy_disk: QD,
  cd: $D,
  dvd: eN,
  vhs: tN,
  camera: aN,
  camera_flash: rN,
  video_camera: nN,
  movie_camera: oN,
  film_projector: sN,
  film_strip: iN,
  telephone_receiver: lN,
  phone: cN,
  pager: uN,
  fax: dN,
  tv: fN,
  radio: pN,
  studio_microphone: yN,
  level_slider: hN,
  control_knobs: gN,
  compass: mN,
  stopwatch: _N,
  timer_clock: wN,
  alarm_clock: vN,
  mantelpiece_clock: bN,
  hourglass_flowing_sand: kN,
  hourglass: xN,
  satellite: zN,
  battery: SN,
  electric_plug: CN,
  bulb: EN,
  flashlight: AN,
  candle: TN,
  fire_extinguisher: PN,
  wastebasket: ON,
  oil_drum: MN,
  money_with_wings: IN,
  dollar: FN,
  yen: jN,
  euro: RN,
  pound: LN,
  moneybag: DN,
  credit_card: NN,
  gem: VN,
  balance_scale: qN,
  toolbox: BN,
  wrench: WN,
  hammer: HN,
  hammer_and_pick: UN,
  hammer_and_wrench: GN,
  pick: KN,
  nut_and_bolt: ZN,
  gear: YN,
  brick: XN,
  chains: JN,
  magnet: QN,
  gun: $N,
  bomb: eV,
  firecracker: tV,
  hocho: aV,
  dagger: rV,
  crossed_swords: nV,
  shield: oV,
  smoking: sV,
  skull_and_crossbones: iV,
  coffin: lV,
  funeral_urn: cV,
  amphora: uV,
  crystal_ball: dV,
  prayer_beads: fV,
  nazar_amulet: pV,
  barber: yV,
  alembic: hV,
  telescope: gV,
  microscope: mV,
  hole: _V,
  pill: wV,
  syringe: vV,
  dna: bV,
  microbe: kV,
  petri_dish: xV,
  test_tube: zV,
  thermometer: SV,
  broom: CV,
  basket: EV,
  toilet_paper: AV,
  label: TV,
  bookmark: PV,
  toilet: OV,
  shower: MV,
  bathtub: IV,
  soap: FV,
  sponge: jV,
  lotion_bottle: RV,
  key: LV,
  old_key: DV,
  couch_and_lamp: NV,
  sleeping_bed: VV,
  bed: qV,
  door: BV,
  bellhop_bell: WV,
  teddy_bear: HV,
  framed_picture: UV,
  world_map: GV,
  parasol_on_ground: KV,
  moyai: ZV,
  shopping: YV,
  shopping_cart: XV,
  balloon: JV,
  flags: QV,
  ribbon: $V,
  gift: eq,
  confetti_ball: tq,
  tada: aq,
  dolls: rq,
  wind_chime: nq,
  crossed_flags: oq,
  izakaya_lantern: sq,
  red_envelope: iq,
  email: lq,
  envelope_with_arrow: cq,
  incoming_envelope: uq,
  "e-mail": {
    keywords: [
      "communication",
      "inbox"
    ],
    char: "📧",
    fitzpatrick_scale: !1,
    category: "objects"
  },
  love_letter: dq,
  postbox: fq,
  mailbox_closed: pq,
  mailbox: yq,
  mailbox_with_mail: hq,
  mailbox_with_no_mail: gq,
  package: {
    keywords: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    char: "📦",
    fitzpatrick_scale: !1,
    category: "objects"
  },
  postal_horn: mq,
  inbox_tray: _q,
  outbox_tray: wq,
  scroll: vq,
  page_with_curl: bq,
  bookmark_tabs: kq,
  receipt: xq,
  bar_chart: zq,
  chart_with_upwards_trend: Sq,
  chart_with_downwards_trend: Cq,
  page_facing_up: Eq,
  date: Aq,
  calendar: Tq,
  spiral_calendar: Pq,
  card_index: Oq,
  card_file_box: Mq,
  ballot_box: Iq,
  file_cabinet: Fq,
  clipboard: jq,
  spiral_notepad: Rq,
  file_folder: Lq,
  open_file_folder: Dq,
  card_index_dividers: Nq,
  newspaper_roll: Vq,
  newspaper: qq,
  notebook: Bq,
  closed_book: Wq,
  green_book: Hq,
  blue_book: Uq,
  orange_book: Gq,
  notebook_with_decorative_cover: Kq,
  ledger: Zq,
  books: Yq,
  open_book: Xq,
  safety_pin: Jq,
  link: Qq,
  paperclip: $q,
  paperclips: eB,
  scissors: tB,
  triangular_ruler: aB,
  straight_ruler: rB,
  abacus: nB,
  pushpin: oB,
  round_pushpin: sB,
  triangular_flag_on_post: iB,
  white_flag: lB,
  black_flag: cB,
  rainbow_flag: uB,
  closed_lock_with_key: dB,
  lock: fB,
  unlock: pB,
  lock_with_ink_pen: yB,
  pen: hB,
  fountain_pen: gB,
  black_nib: mB,
  memo: _B,
  pencil2: wB,
  crayon: vB,
  paintbrush: bB,
  mag: kB,
  mag_right: xB,
  heart: zB,
  orange_heart: SB,
  yellow_heart: CB,
  green_heart: EB,
  blue_heart: AB,
  purple_heart: TB,
  black_heart: PB,
  broken_heart: OB,
  heavy_heart_exclamation: MB,
  two_hearts: IB,
  revolving_hearts: FB,
  heartbeat: jB,
  heartpulse: RB,
  sparkling_heart: LB,
  cupid: DB,
  gift_heart: NB,
  heart_decoration: VB,
  peace_symbol: qB,
  latin_cross: BB,
  star_and_crescent: WB,
  om: HB,
  wheel_of_dharma: UB,
  star_of_david: GB,
  six_pointed_star: KB,
  menorah: ZB,
  yin_yang: YB,
  orthodox_cross: XB,
  place_of_worship: JB,
  ophiuchus: QB,
  aries: $B,
  taurus: eW,
  gemini: tW,
  cancer: aW,
  leo: rW,
  virgo: nW,
  libra: oW,
  scorpius: sW,
  sagittarius: iW,
  capricorn: lW,
  aquarius: cW,
  pisces: uW,
  id: dW,
  atom_symbol: fW,
  u7a7a: pW,
  u5272: yW,
  radioactive: hW,
  biohazard: gW,
  mobile_phone_off: mW,
  vibration_mode: _W,
  u6709: wW,
  u7121: vW,
  u7533: bW,
  u55b6: kW,
  u6708: xW,
  eight_pointed_black_star: zW,
  vs: SW,
  accept: CW,
  white_flower: EW,
  ideograph_advantage: AW,
  secret: TW,
  congratulations: PW,
  u5408: OW,
  u6e80: MW,
  u7981: IW,
  a: FW,
  b: jW,
  ab: RW,
  cl: LW,
  o2: DW,
  sos: NW,
  no_entry: VW,
  name_badge: qW,
  no_entry_sign: BW,
  x: WW,
  o: HW,
  stop_sign: UW,
  anger: GW,
  hotsprings: KW,
  no_pedestrians: ZW,
  do_not_litter: YW,
  no_bicycles: XW,
  "non-potable_water": {
    keywords: [
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    char: "🚱",
    fitzpatrick_scale: !1,
    category: "symbols"
  },
  underage: JW,
  no_mobile_phones: QW,
  exclamation: $W,
  grey_exclamation: eH,
  question: tH,
  grey_question: aH,
  bangbang: rH,
  interrobang: nH,
  low_brightness: oH,
  high_brightness: sH,
  trident: iH,
  fleur_de_lis: lH,
  part_alternation_mark: cH,
  warning: uH,
  children_crossing: dH,
  beginner: fH,
  recycle: pH,
  u6307: yH,
  chart: hH,
  sparkle: gH,
  eight_spoked_asterisk: mH,
  negative_squared_cross_mark: _H,
  white_check_mark: wH,
  diamond_shape_with_a_dot_inside: vH,
  cyclone: bH,
  loop: kH,
  globe_with_meridians: xH,
  m: zH,
  atm: SH,
  sa: CH,
  passport_control: EH,
  customs: AH,
  baggage_claim: TH,
  left_luggage: PH,
  wheelchair: OH,
  no_smoking: MH,
  wc: IH,
  parking: FH,
  potable_water: jH,
  mens: RH,
  womens: LH,
  baby_symbol: DH,
  restroom: NH,
  put_litter_in_its_place: VH,
  cinema: qH,
  signal_strength: BH,
  koko: WH,
  ng: HH,
  ok: UH,
  up: GH,
  cool: KH,
  new: {
    keywords: [
      "blue-square",
      "words",
      "start"
    ],
    char: "🆕",
    fitzpatrick_scale: !1,
    category: "symbols"
  },
  free: ZH,
  zero: YH,
  one: XH,
  two: JH,
  three: QH,
  four: $H,
  five: eU,
  six: tU,
  seven: aU,
  eight: rU,
  nine: nU,
  keycap_ten: oU,
  asterisk: sU,
  eject_button: iU,
  arrow_forward: lU,
  pause_button: cU,
  next_track_button: uU,
  stop_button: dU,
  record_button: fU,
  play_or_pause_button: pU,
  previous_track_button: yU,
  fast_forward: hU,
  rewind: gU,
  twisted_rightwards_arrows: mU,
  repeat: _U,
  repeat_one: wU,
  arrow_backward: vU,
  arrow_up_small: bU,
  arrow_down_small: kU,
  arrow_double_up: xU,
  arrow_double_down: zU,
  arrow_right: SU,
  arrow_left: CU,
  arrow_up: EU,
  arrow_down: AU,
  arrow_upper_right: TU,
  arrow_lower_right: PU,
  arrow_lower_left: OU,
  arrow_upper_left: MU,
  arrow_up_down: IU,
  left_right_arrow: FU,
  arrows_counterclockwise: jU,
  arrow_right_hook: RU,
  leftwards_arrow_with_hook: LU,
  arrow_heading_up: DU,
  arrow_heading_down: NU,
  hash: VU,
  information_source: qU,
  abc: BU,
  abcd: WU,
  capital_abcd: HU,
  symbols: UU,
  musical_note: GU,
  notes: KU,
  wavy_dash: ZU,
  curly_loop: YU,
  heavy_check_mark: XU,
  arrows_clockwise: JU,
  heavy_plus_sign: QU,
  heavy_minus_sign: $U,
  heavy_division_sign: eG,
  heavy_multiplication_x: tG,
  infinity: aG,
  heavy_dollar_sign: rG,
  currency_exchange: nG,
  copyright: oG,
  registered: sG,
  tm: iG,
  end: lG,
  back: cG,
  on: uG,
  top: dG,
  soon: fG,
  ballot_box_with_check: pG,
  radio_button: yG,
  white_circle: hG,
  black_circle: gG,
  red_circle: mG,
  large_blue_circle: _G,
  small_orange_diamond: wG,
  small_blue_diamond: vG,
  large_orange_diamond: bG,
  large_blue_diamond: kG,
  small_red_triangle: xG,
  black_small_square: zG,
  white_small_square: SG,
  black_large_square: CG,
  white_large_square: EG,
  small_red_triangle_down: AG,
  black_medium_square: TG,
  white_medium_square: PG,
  black_medium_small_square: OG,
  white_medium_small_square: MG,
  black_square_button: IG,
  white_square_button: FG,
  speaker: jG,
  sound: RG,
  loud_sound: LG,
  mute: DG,
  mega: NG,
  loudspeaker: VG,
  bell: qG,
  no_bell: BG,
  black_joker: WG,
  mahjong: HG,
  spades: UG,
  clubs: GG,
  hearts: KG,
  diamonds: ZG,
  flower_playing_cards: YG,
  thought_balloon: XG,
  right_anger_bubble: JG,
  speech_balloon: QG,
  left_speech_bubble: $G,
  clock1: eK,
  clock2: tK,
  clock3: aK,
  clock4: rK,
  clock5: nK,
  clock6: oK,
  clock7: sK,
  clock8: iK,
  clock9: lK,
  clock10: cK,
  clock11: uK,
  clock12: dK,
  clock130: fK,
  clock230: pK,
  clock330: yK,
  clock430: hK,
  clock530: gK,
  clock630: mK,
  clock730: _K,
  clock830: wK,
  clock930: vK,
  clock1030: bK,
  clock1130: kK,
  clock1230: xK,
  afghanistan: zK,
  aland_islands: SK,
  albania: CK,
  algeria: EK,
  american_samoa: AK,
  andorra: TK,
  angola: PK,
  anguilla: OK,
  antarctica: MK,
  antigua_barbuda: IK,
  argentina: FK,
  armenia: jK,
  aruba: RK,
  australia: LK,
  austria: DK,
  azerbaijan: NK,
  bahamas: VK,
  bahrain: qK,
  bangladesh: BK,
  barbados: WK,
  belarus: HK,
  belgium: UK,
  belize: GK,
  benin: KK,
  bermuda: ZK,
  bhutan: YK,
  bolivia: XK,
  caribbean_netherlands: JK,
  bosnia_herzegovina: QK,
  botswana: $K,
  brazil: eZ,
  british_indian_ocean_territory: tZ,
  british_virgin_islands: aZ,
  brunei: rZ,
  bulgaria: nZ,
  burkina_faso: oZ,
  burundi: sZ,
  cape_verde: iZ,
  cambodia: lZ,
  cameroon: cZ,
  canada: uZ,
  canary_islands: dZ,
  cayman_islands: fZ,
  central_african_republic: pZ,
  chad: yZ,
  chile: hZ,
  cn: gZ,
  christmas_island: mZ,
  cocos_islands: _Z,
  colombia: wZ,
  comoros: vZ,
  congo_brazzaville: bZ,
  congo_kinshasa: kZ,
  cook_islands: xZ,
  costa_rica: zZ,
  croatia: SZ,
  cuba: CZ,
  curacao: EZ,
  cyprus: AZ,
  czech_republic: TZ,
  denmark: PZ,
  djibouti: OZ,
  dominica: MZ,
  dominican_republic: IZ,
  ecuador: FZ,
  egypt: jZ,
  el_salvador: RZ,
  equatorial_guinea: LZ,
  eritrea: DZ,
  estonia: NZ,
  ethiopia: VZ,
  eu: qZ,
  falkland_islands: BZ,
  faroe_islands: WZ,
  fiji: HZ,
  finland: UZ,
  fr: GZ,
  french_guiana: KZ,
  french_polynesia: ZZ,
  french_southern_territories: YZ,
  gabon: XZ,
  gambia: JZ,
  georgia: QZ,
  de: $Z,
  ghana: eY,
  gibraltar: tY,
  greece: aY,
  greenland: rY,
  grenada: nY,
  guadeloupe: oY,
  guam: sY,
  guatemala: iY,
  guernsey: lY,
  guinea: cY,
  guinea_bissau: uY,
  guyana: dY,
  haiti: fY,
  honduras: pY,
  hong_kong: yY,
  hungary: hY,
  iceland: gY,
  india: mY,
  indonesia: _Y,
  iran: wY,
  iraq: vY,
  ireland: bY,
  isle_of_man: kY,
  israel: xY,
  it: zY,
  cote_divoire: SY,
  jamaica: CY,
  jp: EY,
  jersey: AY,
  jordan: TY,
  kazakhstan: PY,
  kenya: OY,
  kiribati: MY,
  kosovo: IY,
  kuwait: FY,
  kyrgyzstan: jY,
  laos: RY,
  latvia: LY,
  lebanon: DY,
  lesotho: NY,
  liberia: VY,
  libya: qY,
  liechtenstein: BY,
  lithuania: WY,
  luxembourg: HY,
  macau: UY,
  macedonia: GY,
  madagascar: KY,
  malawi: ZY,
  malaysia: YY,
  maldives: XY,
  mali: JY,
  malta: QY,
  marshall_islands: $Y,
  martinique: eX,
  mauritania: tX,
  mauritius: aX,
  mayotte: rX,
  mexico: nX,
  micronesia: oX,
  moldova: sX,
  monaco: iX,
  mongolia: lX,
  montenegro: cX,
  montserrat: uX,
  morocco: dX,
  mozambique: fX,
  myanmar: pX,
  namibia: yX,
  nauru: hX,
  nepal: gX,
  netherlands: mX,
  new_caledonia: _X,
  new_zealand: wX,
  nicaragua: vX,
  niger: bX,
  nigeria: kX,
  niue: xX,
  norfolk_island: zX,
  northern_mariana_islands: SX,
  north_korea: CX,
  norway: EX,
  oman: AX,
  pakistan: TX,
  palau: PX,
  palestinian_territories: OX,
  panama: MX,
  papua_new_guinea: IX,
  paraguay: FX,
  peru: jX,
  philippines: RX,
  pitcairn_islands: LX,
  poland: DX,
  portugal: NX,
  puerto_rico: VX,
  qatar: qX,
  reunion: BX,
  romania: WX,
  ru: HX,
  rwanda: UX,
  st_barthelemy: GX,
  st_helena: KX,
  st_kitts_nevis: ZX,
  st_lucia: YX,
  st_pierre_miquelon: XX,
  st_vincent_grenadines: JX,
  samoa: QX,
  san_marino: $X,
  sao_tome_principe: eJ,
  saudi_arabia: tJ,
  senegal: aJ,
  serbia: rJ,
  seychelles: nJ,
  sierra_leone: oJ,
  singapore: sJ,
  sint_maarten: iJ,
  slovakia: lJ,
  slovenia: cJ,
  solomon_islands: uJ,
  somalia: dJ,
  south_africa: fJ,
  south_georgia_south_sandwich_islands: pJ,
  kr: yJ,
  south_sudan: hJ,
  es: gJ,
  sri_lanka: mJ,
  sudan: _J,
  suriname: wJ,
  swaziland: vJ,
  sweden: bJ,
  switzerland: kJ,
  syria: xJ,
  taiwan: zJ,
  tajikistan: SJ,
  tanzania: CJ,
  thailand: EJ,
  timor_leste: AJ,
  togo: TJ,
  tokelau: PJ,
  tonga: OJ,
  trinidad_tobago: MJ,
  tunisia: IJ,
  tr: FJ,
  turkmenistan: jJ,
  turks_caicos_islands: RJ,
  tuvalu: LJ,
  uganda: DJ,
  ukraine: NJ,
  united_arab_emirates: VJ,
  uk: qJ,
  england: BJ,
  scotland: WJ,
  wales: HJ,
  us: UJ,
  us_virgin_islands: GJ,
  uruguay: KJ,
  uzbekistan: ZJ,
  vanuatu: YJ,
  vatican_city: XJ,
  venezuela: JJ,
  vietnam: QJ,
  wallis_futuna: $J,
  western_sahara: eQ,
  yemen: tQ,
  zambia: aQ,
  zimbabwe: rQ,
  united_nations: nQ,
  pirate_flag: oQ
}, iQ = [
  "grinning",
  "smiley",
  "smile",
  "grin",
  "laughing",
  "sweat_smile",
  "joy",
  "rofl",
  "relaxed",
  "blush",
  "innocent",
  "slightly_smiling_face",
  "upside_down_face",
  "wink",
  "relieved",
  "heart_eyes",
  "smiling_face_with_three_hearts",
  "kissing_heart",
  "kissing",
  "kissing_smiling_eyes",
  "kissing_closed_eyes",
  "yum",
  "stuck_out_tongue",
  "stuck_out_tongue_closed_eyes",
  "stuck_out_tongue_winking_eye",
  "zany",
  "raised_eyebrow",
  "monocle",
  "nerd_face",
  "sunglasses",
  "star_struck",
  "partying",
  "smirk",
  "unamused",
  "disappointed",
  "pensive",
  "worried",
  "confused",
  "slightly_frowning_face",
  "frowning_face",
  "persevere",
  "confounded",
  "tired_face",
  "weary",
  "pleading",
  "cry",
  "sob",
  "triumph",
  "angry",
  "rage",
  "symbols_over_mouth",
  "exploding_head",
  "flushed",
  "hot",
  "cold",
  "scream",
  "fearful",
  "cold_sweat",
  "disappointed_relieved",
  "sweat",
  "hugs",
  "thinking",
  "hand_over_mouth",
  "shushing",
  "lying_face",
  "no_mouth",
  "neutral_face",
  "expressionless",
  "grimacing",
  "roll_eyes",
  "hushed",
  "frowning",
  "anguished",
  "open_mouth",
  "astonished",
  "sleeping",
  "drooling_face",
  "sleepy",
  "dizzy_face",
  "zipper_mouth_face",
  "woozy",
  "nauseated_face",
  "vomiting",
  "sneezing_face",
  "mask",
  "face_with_thermometer",
  "face_with_head_bandage",
  "money_mouth_face",
  "cowboy_hat_face",
  "smiling_imp",
  "imp",
  "japanese_ogre",
  "japanese_goblin",
  "clown_face",
  "poop",
  "ghost",
  "skull",
  "skull_and_crossbones",
  "alien",
  "space_invader",
  "robot",
  "jack_o_lantern",
  "smiley_cat",
  "smile_cat",
  "joy_cat",
  "heart_eyes_cat",
  "smirk_cat",
  "kissing_cat",
  "scream_cat",
  "crying_cat_face",
  "pouting_cat",
  "palms_up",
  "open_hands",
  "raised_hands",
  "clap",
  "handshake",
  "+1",
  "-1",
  "facepunch",
  "fist",
  "fist_left",
  "fist_right",
  "crossed_fingers",
  "v",
  "love_you",
  "metal",
  "ok_hand",
  "point_left",
  "point_right",
  "point_up",
  "point_down",
  "point_up_2",
  "raised_hand",
  "raised_back_of_hand",
  "raised_hand_with_fingers_splayed",
  "vulcan_salute",
  "wave",
  "call_me_hand",
  "muscle",
  "fu",
  "writing_hand",
  "pray",
  "foot",
  "leg",
  "ring",
  "lipstick",
  "kiss",
  "lips",
  "tooth",
  "tongue",
  "ear",
  "nose",
  "footprints",
  "eye",
  "eyes",
  "brain",
  "speaking_head",
  "bust_in_silhouette",
  "busts_in_silhouette",
  "baby",
  "girl",
  "child",
  "boy",
  "woman",
  "adult",
  "man",
  "blonde_woman",
  "blonde_man",
  "bearded_person",
  "older_woman",
  "older_adult",
  "older_man",
  "man_with_gua_pi_mao",
  "woman_with_headscarf",
  "woman_with_turban",
  "man_with_turban",
  "policewoman",
  "policeman",
  "construction_worker_woman",
  "construction_worker_man",
  "guardswoman",
  "guardsman",
  "female_detective",
  "male_detective",
  "woman_health_worker",
  "man_health_worker",
  "woman_farmer",
  "man_farmer",
  "woman_cook",
  "man_cook",
  "woman_student",
  "man_student",
  "woman_singer",
  "man_singer",
  "woman_teacher",
  "man_teacher",
  "woman_factory_worker",
  "man_factory_worker",
  "woman_technologist",
  "man_technologist",
  "woman_office_worker",
  "man_office_worker",
  "woman_mechanic",
  "man_mechanic",
  "woman_scientist",
  "man_scientist",
  "woman_artist",
  "man_artist",
  "woman_firefighter",
  "man_firefighter",
  "woman_pilot",
  "man_pilot",
  "woman_astronaut",
  "man_astronaut",
  "woman_judge",
  "man_judge",
  "bride_with_veil",
  "man_in_tuxedo",
  "princess",
  "prince",
  "woman_superhero",
  "man_superhero",
  "woman_supervillain",
  "man_supervillain",
  "mrs_claus",
  "santa",
  "sorceress",
  "wizard",
  "woman_elf",
  "man_elf",
  "woman_vampire",
  "man_vampire",
  "woman_zombie",
  "man_zombie",
  "woman_genie",
  "man_genie",
  "mermaid",
  "merman",
  "woman_fairy",
  "man_fairy",
  "angel",
  "pregnant_woman",
  "breastfeeding",
  "bowing_woman",
  "bowing_man",
  "tipping_hand_woman",
  "tipping_hand_man",
  "no_good_woman",
  "no_good_man",
  "ok_woman",
  "ok_man",
  "raising_hand_woman",
  "raising_hand_man",
  "woman_facepalming",
  "man_facepalming",
  "woman_shrugging",
  "man_shrugging",
  "pouting_woman",
  "pouting_man",
  "frowning_woman",
  "frowning_man",
  "haircut_woman",
  "haircut_man",
  "massage_woman",
  "massage_man",
  "woman_in_steamy_room",
  "man_in_steamy_room",
  "nail_care",
  "selfie",
  "dancer",
  "man_dancing",
  "dancing_women",
  "dancing_men",
  "business_suit_levitating",
  "walking_woman",
  "walking_man",
  "running_woman",
  "running_man",
  "couple",
  "two_women_holding_hands",
  "two_men_holding_hands",
  "couple_with_heart_woman_man",
  "couple_with_heart_woman_woman",
  "couple_with_heart_man_man",
  "couplekiss_man_woman",
  "couplekiss_woman_woman",
  "couplekiss_man_man",
  "family_man_woman_boy",
  "family_man_woman_girl",
  "family_man_woman_girl_boy",
  "family_man_woman_boy_boy",
  "family_man_woman_girl_girl",
  "family_woman_woman_boy",
  "family_woman_woman_girl",
  "family_woman_woman_girl_boy",
  "family_woman_woman_boy_boy",
  "family_woman_woman_girl_girl",
  "family_man_man_boy",
  "family_man_man_girl",
  "family_man_man_girl_boy",
  "family_man_man_boy_boy",
  "family_man_man_girl_girl",
  "family_woman_boy",
  "family_woman_girl",
  "family_woman_girl_boy",
  "family_woman_boy_boy",
  "family_woman_girl_girl",
  "family_man_boy",
  "family_man_girl",
  "family_man_girl_boy",
  "family_man_boy_boy",
  "family_man_girl_girl",
  "yarn",
  "thread",
  "coat",
  "labcoat",
  "womans_clothes",
  "tshirt",
  "jeans",
  "necktie",
  "dress",
  "bikini",
  "kimono",
  "flat_shoe",
  "high_heel",
  "sandal",
  "boot",
  "mans_shoe",
  "athletic_shoe",
  "hiking_boot",
  "socks",
  "gloves",
  "scarf",
  "tophat",
  "billed_hat",
  "womans_hat",
  "mortar_board",
  "rescue_worker_helmet",
  "crown",
  "pouch",
  "purse",
  "handbag",
  "briefcase",
  "school_satchel",
  "luggage",
  "eyeglasses",
  "dark_sunglasses",
  "goggles",
  "closed_umbrella",
  "dog",
  "cat",
  "mouse",
  "hamster",
  "rabbit",
  "fox_face",
  "bear",
  "panda_face",
  "koala",
  "tiger",
  "lion",
  "cow",
  "pig",
  "pig_nose",
  "frog",
  "monkey_face",
  "see_no_evil",
  "hear_no_evil",
  "speak_no_evil",
  "monkey",
  "chicken",
  "penguin",
  "bird",
  "baby_chick",
  "hatching_chick",
  "hatched_chick",
  "duck",
  "eagle",
  "owl",
  "bat",
  "wolf",
  "boar",
  "horse",
  "unicorn",
  "honeybee",
  "bug",
  "butterfly",
  "snail",
  "shell",
  "beetle",
  "ant",
  "mosquito",
  "grasshopper",
  "spider",
  "spider_web",
  "scorpion",
  "turtle",
  "snake",
  "lizard",
  "t-rex",
  "sauropod",
  "octopus",
  "squid",
  "shrimp",
  "lobster",
  "crab",
  "blowfish",
  "tropical_fish",
  "fish",
  "dolphin",
  "whale",
  "whale2",
  "shark",
  "crocodile",
  "tiger2",
  "leopard",
  "zebra",
  "gorilla",
  "elephant",
  "hippopotamus",
  "rhinoceros",
  "dromedary_camel",
  "giraffe",
  "kangaroo",
  "camel",
  "water_buffalo",
  "ox",
  "cow2",
  "racehorse",
  "pig2",
  "ram",
  "sheep",
  "llama",
  "goat",
  "deer",
  "dog2",
  "poodle",
  "cat2",
  "rooster",
  "turkey",
  "peacock",
  "parrot",
  "swan",
  "dove",
  "rabbit2",
  "raccoon",
  "badger",
  "rat",
  "mouse2",
  "chipmunk",
  "hedgehog",
  "paw_prints",
  "dragon",
  "dragon_face",
  "cactus",
  "christmas_tree",
  "evergreen_tree",
  "deciduous_tree",
  "palm_tree",
  "seedling",
  "herb",
  "shamrock",
  "four_leaf_clover",
  "bamboo",
  "tanabata_tree",
  "leaves",
  "fallen_leaf",
  "maple_leaf",
  "ear_of_rice",
  "hibiscus",
  "sunflower",
  "rose",
  "wilted_flower",
  "tulip",
  "blossom",
  "cherry_blossom",
  "bouquet",
  "mushroom",
  "earth_americas",
  "earth_africa",
  "earth_asia",
  "full_moon",
  "waning_gibbous_moon",
  "last_quarter_moon",
  "waning_crescent_moon",
  "new_moon",
  "waxing_crescent_moon",
  "first_quarter_moon",
  "waxing_gibbous_moon",
  "new_moon_with_face",
  "full_moon_with_face",
  "first_quarter_moon_with_face",
  "last_quarter_moon_with_face",
  "sun_with_face",
  "crescent_moon",
  "star",
  "star2",
  "dizzy",
  "sparkles",
  "comet",
  "sunny",
  "sun_behind_small_cloud",
  "partly_sunny",
  "sun_behind_large_cloud",
  "sun_behind_rain_cloud",
  "cloud",
  "cloud_with_rain",
  "cloud_with_lightning_and_rain",
  "cloud_with_lightning",
  "zap",
  "fire",
  "boom",
  "snowflake",
  "cloud_with_snow",
  "snowman",
  "snowman_with_snow",
  "wind_face",
  "dash",
  "tornado",
  "fog",
  "open_umbrella",
  "umbrella",
  "droplet",
  "sweat_drops",
  "ocean",
  "green_apple",
  "apple",
  "pear",
  "tangerine",
  "lemon",
  "banana",
  "watermelon",
  "grapes",
  "strawberry",
  "melon",
  "cherries",
  "peach",
  "mango",
  "pineapple",
  "coconut",
  "kiwi_fruit",
  "tomato",
  "eggplant",
  "avocado",
  "broccoli",
  "leafy_greens",
  "cucumber",
  "hot_pepper",
  "corn",
  "carrot",
  "potato",
  "sweet_potato",
  "croissant",
  "bagel",
  "bread",
  "baguette_bread",
  "pretzel",
  "cheese",
  "egg",
  "fried_egg",
  "pancakes",
  "bacon",
  "steak",
  "poultry_leg",
  "meat_on_bone",
  "bone",
  "hotdog",
  "hamburger",
  "fries",
  "pizza",
  "sandwich",
  "stuffed_flatbread",
  "taco",
  "burrito",
  "green_salad",
  "shallow_pan_of_food",
  "canned_food",
  "spaghetti",
  "ramen",
  "stew",
  "curry",
  "sushi",
  "bento",
  "fried_shrimp",
  "rice_ball",
  "rice",
  "rice_cracker",
  "fish_cake",
  "fortune_cookie",
  "moon_cake",
  "oden",
  "dango",
  "shaved_ice",
  "ice_cream",
  "icecream",
  "pie",
  "cupcake",
  "cake",
  "birthday",
  "custard",
  "lollipop",
  "candy",
  "chocolate_bar",
  "popcorn",
  "doughnut",
  "dumpling",
  "cookie",
  "chestnut",
  "peanuts",
  "honey_pot",
  "milk_glass",
  "baby_bottle",
  "coffee",
  "tea",
  "cup_with_straw",
  "sake",
  "beer",
  "beers",
  "clinking_glasses",
  "wine_glass",
  "tumbler_glass",
  "cocktail",
  "tropical_drink",
  "champagne",
  "spoon",
  "fork_and_knife",
  "plate_with_cutlery",
  "bowl_with_spoon",
  "takeout_box",
  "chopsticks",
  "salt",
  "soccer",
  "basketball",
  "football",
  "baseball",
  "softball",
  "tennis",
  "volleyball",
  "rugby_football",
  "flying_disc",
  "8ball",
  "golf",
  "golfing_woman",
  "golfing_man",
  "ping_pong",
  "badminton",
  "goal_net",
  "ice_hockey",
  "field_hockey",
  "lacrosse",
  "cricket",
  "ski",
  "skier",
  "snowboarder",
  "person_fencing",
  "women_wrestling",
  "men_wrestling",
  "woman_cartwheeling",
  "man_cartwheeling",
  "woman_playing_handball",
  "man_playing_handball",
  "ice_skate",
  "curling_stone",
  "skateboard",
  "sled",
  "bow_and_arrow",
  "fishing_pole_and_fish",
  "boxing_glove",
  "martial_arts_uniform",
  "rowing_woman",
  "rowing_man",
  "climbing_woman",
  "climbing_man",
  "swimming_woman",
  "swimming_man",
  "woman_playing_water_polo",
  "man_playing_water_polo",
  "woman_in_lotus_position",
  "man_in_lotus_position",
  "surfing_woman",
  "surfing_man",
  "basketball_woman",
  "basketball_man",
  "weight_lifting_woman",
  "weight_lifting_man",
  "biking_woman",
  "biking_man",
  "mountain_biking_woman",
  "mountain_biking_man",
  "horse_racing",
  "trophy",
  "running_shirt_with_sash",
  "medal_sports",
  "medal_military",
  "1st_place_medal",
  "2nd_place_medal",
  "3rd_place_medal",
  "reminder_ribbon",
  "rosette",
  "ticket",
  "tickets",
  "performing_arts",
  "art",
  "circus_tent",
  "woman_juggling",
  "man_juggling",
  "microphone",
  "headphones",
  "musical_score",
  "musical_keyboard",
  "drum",
  "saxophone",
  "trumpet",
  "guitar",
  "violin",
  "clapper",
  "video_game",
  "dart",
  "game_die",
  "chess_pawn",
  "slot_machine",
  "jigsaw",
  "bowling",
  "red_car",
  "taxi",
  "blue_car",
  "bus",
  "trolleybus",
  "racing_car",
  "police_car",
  "ambulance",
  "fire_engine",
  "minibus",
  "truck",
  "articulated_lorry",
  "tractor",
  "kick_scooter",
  "motorcycle",
  "bike",
  "motor_scooter",
  "rotating_light",
  "oncoming_police_car",
  "oncoming_bus",
  "oncoming_automobile",
  "oncoming_taxi",
  "aerial_tramway",
  "mountain_cableway",
  "suspension_railway",
  "railway_car",
  "train",
  "monorail",
  "bullettrain_side",
  "bullettrain_front",
  "light_rail",
  "mountain_railway",
  "steam_locomotive",
  "train2",
  "metro",
  "tram",
  "station",
  "flying_saucer",
  "helicopter",
  "small_airplane",
  "airplane",
  "flight_departure",
  "flight_arrival",
  "sailboat",
  "motor_boat",
  "speedboat",
  "ferry",
  "passenger_ship",
  "rocket",
  "artificial_satellite",
  "seat",
  "canoe",
  "anchor",
  "construction",
  "fuelpump",
  "busstop",
  "vertical_traffic_light",
  "traffic_light",
  "ship",
  "ferris_wheel",
  "roller_coaster",
  "carousel_horse",
  "building_construction",
  "foggy",
  "tokyo_tower",
  "factory",
  "fountain",
  "rice_scene",
  "mountain",
  "mountain_snow",
  "mount_fuji",
  "volcano",
  "japan",
  "camping",
  "tent",
  "national_park",
  "motorway",
  "railway_track",
  "sunrise",
  "sunrise_over_mountains",
  "desert",
  "beach_umbrella",
  "desert_island",
  "city_sunrise",
  "city_sunset",
  "cityscape",
  "night_with_stars",
  "bridge_at_night",
  "milky_way",
  "stars",
  "sparkler",
  "fireworks",
  "rainbow",
  "houses",
  "european_castle",
  "japanese_castle",
  "stadium",
  "statue_of_liberty",
  "house",
  "house_with_garden",
  "derelict_house",
  "office",
  "department_store",
  "post_office",
  "european_post_office",
  "hospital",
  "bank",
  "hotel",
  "convenience_store",
  "school",
  "love_hotel",
  "wedding",
  "classical_building",
  "church",
  "mosque",
  "synagogue",
  "kaaba",
  "shinto_shrine",
  "watch",
  "iphone",
  "calling",
  "computer",
  "keyboard",
  "desktop_computer",
  "printer",
  "computer_mouse",
  "trackball",
  "joystick",
  "clamp",
  "minidisc",
  "floppy_disk",
  "cd",
  "dvd",
  "vhs",
  "camera",
  "camera_flash",
  "video_camera",
  "movie_camera",
  "film_projector",
  "film_strip",
  "telephone_receiver",
  "phone",
  "pager",
  "fax",
  "tv",
  "radio",
  "studio_microphone",
  "level_slider",
  "control_knobs",
  "compass",
  "stopwatch",
  "timer_clock",
  "alarm_clock",
  "mantelpiece_clock",
  "hourglass_flowing_sand",
  "hourglass",
  "satellite",
  "battery",
  "electric_plug",
  "bulb",
  "flashlight",
  "candle",
  "fire_extinguisher",
  "wastebasket",
  "oil_drum",
  "money_with_wings",
  "dollar",
  "yen",
  "euro",
  "pound",
  "moneybag",
  "credit_card",
  "gem",
  "balance_scale",
  "toolbox",
  "wrench",
  "hammer",
  "hammer_and_pick",
  "hammer_and_wrench",
  "pick",
  "nut_and_bolt",
  "gear",
  "brick",
  "chains",
  "magnet",
  "gun",
  "bomb",
  "firecracker",
  "hocho",
  "dagger",
  "crossed_swords",
  "shield",
  "smoking",
  "coffin",
  "funeral_urn",
  "amphora",
  "crystal_ball",
  "prayer_beads",
  "nazar_amulet",
  "barber",
  "alembic",
  "telescope",
  "microscope",
  "hole",
  "pill",
  "syringe",
  "dna",
  "microbe",
  "petri_dish",
  "test_tube",
  "thermometer",
  "broom",
  "basket",
  "toilet_paper",
  "label",
  "bookmark",
  "toilet",
  "shower",
  "bathtub",
  "bath",
  "soap",
  "sponge",
  "lotion_bottle",
  "key",
  "old_key",
  "couch_and_lamp",
  "sleeping_bed",
  "bed",
  "door",
  "bellhop_bell",
  "teddy_bear",
  "framed_picture",
  "world_map",
  "parasol_on_ground",
  "moyai",
  "shopping",
  "shopping_cart",
  "balloon",
  "flags",
  "ribbon",
  "gift",
  "confetti_ball",
  "tada",
  "dolls",
  "wind_chime",
  "crossed_flags",
  "izakaya_lantern",
  "red_envelope",
  "email",
  "envelope_with_arrow",
  "incoming_envelope",
  "e-mail",
  "love_letter",
  "postbox",
  "mailbox_closed",
  "mailbox",
  "mailbox_with_mail",
  "mailbox_with_no_mail",
  "package",
  "postal_horn",
  "inbox_tray",
  "outbox_tray",
  "scroll",
  "page_with_curl",
  "bookmark_tabs",
  "receipt",
  "bar_chart",
  "chart_with_upwards_trend",
  "chart_with_downwards_trend",
  "page_facing_up",
  "date",
  "calendar",
  "spiral_calendar",
  "card_index",
  "card_file_box",
  "ballot_box",
  "file_cabinet",
  "clipboard",
  "spiral_notepad",
  "file_folder",
  "open_file_folder",
  "card_index_dividers",
  "newspaper_roll",
  "newspaper",
  "notebook",
  "closed_book",
  "green_book",
  "blue_book",
  "orange_book",
  "notebook_with_decorative_cover",
  "ledger",
  "books",
  "open_book",
  "safety_pin",
  "link",
  "paperclip",
  "paperclips",
  "scissors",
  "triangular_ruler",
  "straight_ruler",
  "abacus",
  "pushpin",
  "round_pushpin",
  "closed_lock_with_key",
  "lock",
  "unlock",
  "lock_with_ink_pen",
  "pen",
  "fountain_pen",
  "black_nib",
  "memo",
  "pencil2",
  "crayon",
  "paintbrush",
  "mag",
  "mag_right",
  "heart",
  "orange_heart",
  "yellow_heart",
  "green_heart",
  "blue_heart",
  "purple_heart",
  "black_heart",
  "broken_heart",
  "heavy_heart_exclamation",
  "two_hearts",
  "revolving_hearts",
  "heartbeat",
  "heartpulse",
  "sparkling_heart",
  "cupid",
  "gift_heart",
  "heart_decoration",
  "peace_symbol",
  "latin_cross",
  "star_and_crescent",
  "om",
  "wheel_of_dharma",
  "star_of_david",
  "six_pointed_star",
  "menorah",
  "yin_yang",
  "orthodox_cross",
  "place_of_worship",
  "ophiuchus",
  "aries",
  "taurus",
  "gemini",
  "cancer",
  "leo",
  "virgo",
  "libra",
  "scorpius",
  "sagittarius",
  "capricorn",
  "aquarius",
  "pisces",
  "id",
  "atom_symbol",
  "u7a7a",
  "u5272",
  "radioactive",
  "biohazard",
  "mobile_phone_off",
  "vibration_mode",
  "u6709",
  "u7121",
  "u7533",
  "u55b6",
  "u6708",
  "eight_pointed_black_star",
  "vs",
  "accept",
  "white_flower",
  "ideograph_advantage",
  "secret",
  "congratulations",
  "u5408",
  "u6e80",
  "u7981",
  "a",
  "b",
  "ab",
  "cl",
  "o2",
  "sos",
  "no_entry",
  "name_badge",
  "no_entry_sign",
  "x",
  "o",
  "stop_sign",
  "anger",
  "hotsprings",
  "no_pedestrians",
  "do_not_litter",
  "no_bicycles",
  "non-potable_water",
  "underage",
  "no_mobile_phones",
  "exclamation",
  "grey_exclamation",
  "question",
  "grey_question",
  "bangbang",
  "interrobang",
  "100",
  "low_brightness",
  "high_brightness",
  "trident",
  "fleur_de_lis",
  "part_alternation_mark",
  "warning",
  "children_crossing",
  "beginner",
  "recycle",
  "u6307",
  "chart",
  "sparkle",
  "eight_spoked_asterisk",
  "negative_squared_cross_mark",
  "white_check_mark",
  "diamond_shape_with_a_dot_inside",
  "cyclone",
  "loop",
  "globe_with_meridians",
  "m",
  "atm",
  "zzz",
  "sa",
  "passport_control",
  "customs",
  "baggage_claim",
  "left_luggage",
  "wheelchair",
  "no_smoking",
  "wc",
  "parking",
  "potable_water",
  "mens",
  "womens",
  "baby_symbol",
  "restroom",
  "put_litter_in_its_place",
  "cinema",
  "signal_strength",
  "koko",
  "ng",
  "ok",
  "up",
  "cool",
  "new",
  "free",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "keycap_ten",
  "asterisk",
  "1234",
  "eject_button",
  "arrow_forward",
  "pause_button",
  "next_track_button",
  "stop_button",
  "record_button",
  "play_or_pause_button",
  "previous_track_button",
  "fast_forward",
  "rewind",
  "twisted_rightwards_arrows",
  "repeat",
  "repeat_one",
  "arrow_backward",
  "arrow_up_small",
  "arrow_down_small",
  "arrow_double_up",
  "arrow_double_down",
  "arrow_right",
  "arrow_left",
  "arrow_up",
  "arrow_down",
  "arrow_upper_right",
  "arrow_lower_right",
  "arrow_lower_left",
  "arrow_upper_left",
  "arrow_up_down",
  "left_right_arrow",
  "arrows_counterclockwise",
  "arrow_right_hook",
  "leftwards_arrow_with_hook",
  "arrow_heading_up",
  "arrow_heading_down",
  "hash",
  "information_source",
  "abc",
  "abcd",
  "capital_abcd",
  "symbols",
  "musical_note",
  "notes",
  "wavy_dash",
  "curly_loop",
  "heavy_check_mark",
  "arrows_clockwise",
  "heavy_plus_sign",
  "heavy_minus_sign",
  "heavy_division_sign",
  "heavy_multiplication_x",
  "infinity",
  "heavy_dollar_sign",
  "currency_exchange",
  "copyright",
  "registered",
  "tm",
  "end",
  "back",
  "on",
  "top",
  "soon",
  "ballot_box_with_check",
  "radio_button",
  "white_circle",
  "black_circle",
  "red_circle",
  "large_blue_circle",
  "small_orange_diamond",
  "small_blue_diamond",
  "large_orange_diamond",
  "large_blue_diamond",
  "small_red_triangle",
  "black_small_square",
  "white_small_square",
  "black_large_square",
  "white_large_square",
  "small_red_triangle_down",
  "black_medium_square",
  "white_medium_square",
  "black_medium_small_square",
  "white_medium_small_square",
  "black_square_button",
  "white_square_button",
  "speaker",
  "sound",
  "loud_sound",
  "mute",
  "mega",
  "loudspeaker",
  "bell",
  "no_bell",
  "black_joker",
  "mahjong",
  "spades",
  "clubs",
  "hearts",
  "diamonds",
  "flower_playing_cards",
  "thought_balloon",
  "right_anger_bubble",
  "speech_balloon",
  "left_speech_bubble",
  "clock1",
  "clock2",
  "clock3",
  "clock4",
  "clock5",
  "clock6",
  "clock7",
  "clock8",
  "clock9",
  "clock10",
  "clock11",
  "clock12",
  "clock130",
  "clock230",
  "clock330",
  "clock430",
  "clock530",
  "clock630",
  "clock730",
  "clock830",
  "clock930",
  "clock1030",
  "clock1130",
  "clock1230",
  "white_flag",
  "black_flag",
  "pirate_flag",
  "checkered_flag",
  "triangular_flag_on_post",
  "rainbow_flag",
  "united_nations",
  "afghanistan",
  "aland_islands",
  "albania",
  "algeria",
  "american_samoa",
  "andorra",
  "angola",
  "anguilla",
  "antarctica",
  "antigua_barbuda",
  "argentina",
  "armenia",
  "aruba",
  "australia",
  "austria",
  "azerbaijan",
  "bahamas",
  "bahrain",
  "bangladesh",
  "barbados",
  "belarus",
  "belgium",
  "belize",
  "benin",
  "bermuda",
  "bhutan",
  "bolivia",
  "caribbean_netherlands",
  "bosnia_herzegovina",
  "botswana",
  "brazil",
  "british_indian_ocean_territory",
  "british_virgin_islands",
  "brunei",
  "bulgaria",
  "burkina_faso",
  "burundi",
  "cape_verde",
  "cambodia",
  "cameroon",
  "canada",
  "canary_islands",
  "cayman_islands",
  "central_african_republic",
  "chad",
  "chile",
  "cn",
  "christmas_island",
  "cocos_islands",
  "colombia",
  "comoros",
  "congo_brazzaville",
  "congo_kinshasa",
  "cook_islands",
  "costa_rica",
  "croatia",
  "cuba",
  "curacao",
  "cyprus",
  "czech_republic",
  "denmark",
  "djibouti",
  "dominica",
  "dominican_republic",
  "ecuador",
  "egypt",
  "el_salvador",
  "equatorial_guinea",
  "eritrea",
  "estonia",
  "ethiopia",
  "eu",
  "falkland_islands",
  "faroe_islands",
  "fiji",
  "finland",
  "fr",
  "french_guiana",
  "french_polynesia",
  "french_southern_territories",
  "gabon",
  "gambia",
  "georgia",
  "de",
  "ghana",
  "gibraltar",
  "greece",
  "greenland",
  "grenada",
  "guadeloupe",
  "guam",
  "guatemala",
  "guernsey",
  "guinea",
  "guinea_bissau",
  "guyana",
  "haiti",
  "honduras",
  "hong_kong",
  "hungary",
  "iceland",
  "india",
  "indonesia",
  "iran",
  "iraq",
  "ireland",
  "isle_of_man",
  "israel",
  "it",
  "cote_divoire",
  "jamaica",
  "jp",
  "jersey",
  "jordan",
  "kazakhstan",
  "kenya",
  "kiribati",
  "kosovo",
  "kuwait",
  "kyrgyzstan",
  "laos",
  "latvia",
  "lebanon",
  "lesotho",
  "liberia",
  "libya",
  "liechtenstein",
  "lithuania",
  "luxembourg",
  "macau",
  "macedonia",
  "madagascar",
  "malawi",
  "malaysia",
  "maldives",
  "mali",
  "malta",
  "marshall_islands",
  "martinique",
  "mauritania",
  "mauritius",
  "mayotte",
  "mexico",
  "micronesia",
  "moldova",
  "monaco",
  "mongolia",
  "montenegro",
  "montserrat",
  "morocco",
  "mozambique",
  "myanmar",
  "namibia",
  "nauru",
  "nepal",
  "netherlands",
  "new_caledonia",
  "new_zealand",
  "nicaragua",
  "niger",
  "nigeria",
  "niue",
  "norfolk_island",
  "northern_mariana_islands",
  "north_korea",
  "norway",
  "oman",
  "pakistan",
  "palau",
  "palestinian_territories",
  "panama",
  "papua_new_guinea",
  "paraguay",
  "peru",
  "philippines",
  "pitcairn_islands",
  "poland",
  "portugal",
  "puerto_rico",
  "qatar",
  "reunion",
  "romania",
  "ru",
  "rwanda",
  "st_barthelemy",
  "st_helena",
  "st_kitts_nevis",
  "st_lucia",
  "st_pierre_miquelon",
  "st_vincent_grenadines",
  "samoa",
  "san_marino",
  "sao_tome_principe",
  "saudi_arabia",
  "senegal",
  "serbia",
  "seychelles",
  "sierra_leone",
  "singapore",
  "sint_maarten",
  "slovakia",
  "slovenia",
  "solomon_islands",
  "somalia",
  "south_africa",
  "south_georgia_south_sandwich_islands",
  "kr",
  "south_sudan",
  "es",
  "sri_lanka",
  "sudan",
  "suriname",
  "swaziland",
  "sweden",
  "switzerland",
  "syria",
  "taiwan",
  "tajikistan",
  "tanzania",
  "thailand",
  "timor_leste",
  "togo",
  "tokelau",
  "tonga",
  "trinidad_tobago",
  "tunisia",
  "tr",
  "turkmenistan",
  "turks_caicos_islands",
  "tuvalu",
  "uganda",
  "ukraine",
  "united_arab_emirates",
  "uk",
  "england",
  "scotland",
  "wales",
  "us",
  "us_virgin_islands",
  "uruguay",
  "uzbekistan",
  "vanuatu",
  "vatican_city",
  "venezuela",
  "vietnam",
  "wallis_futuna",
  "western_sahara",
  "yemen",
  "zambia",
  "zimbabwe"
];
var lQ = {
  lib: sQ,
  ordered: iQ,
  fitzpatrick_scale_modifiers: ["🏻", "🏼", "🏽", "🏾", "🏿"]
};
const cQ = /* @__PURE__ */ cc(lQ);
var uQ = () => {
  const e = "\\ud800-\\udfff", s = "\\u0300-\\u036f" + "\\ufe20-\\ufe2f" + "\\u20d0-\\u20ff" + "\\u1ab0-\\u1aff" + "\\u1dc0-\\u1dff", i = "\\ufe0e\\ufe0f", l = "\\uD83D\\uDC69\\uD83C\\uDFFB\\u200D\\uD83C\\uDF93", u = `[${e}]`, f = `[${s}]`, p = "\\ud83c[\\udffb-\\udfff]", c = `(?:${f}|${p})`, h = `[^${e}]`, g = "(?:\\uD83C[\\uDDE6-\\uDDFF]){2}", _ = "[\\ud800-\\udbff][\\udc00-\\udfff]", b = "\\u200d", m = "(?:\\ud83c\\udff4\\udb40\\udc67\\udb40\\udc62\\udb40(?:\\udc65|\\udc73|\\udc77)\\udb40(?:\\udc6e|\\udc63|\\udc6c)\\udb40(?:\\udc67|\\udc74|\\udc73)\\udb40\\udc7f)", w = `[${l}]`, S = `${c}?`, C = `[${i}]?`, v = `(?:${b}(?:${[h, g, _].join("|")})${C + S})*`, y = C + S + v, x = `(?:${[`${h}${f}?`, f, g, _, u, w].join("|")})`;
  return new RegExp(`${m}|${p}(?=${p})|${x + y}`, "g");
};
const dQ = /* @__PURE__ */ cc(uQ);
dQ();
function fQ(e) {
  return typeof e == "function" ? e : () => e;
}
var pQ = "️", yQ = new RegExp(pQ, "g");
function hQ(e) {
  return e.replace(yQ, "");
}
function gm(e) {
  return /:.+:/.test(e) ? e.slice(1, -1) : e;
}
var mm = Object.entries(cQ.lib).map(
  ([e, { char: t }]) => [e, t]
), gQ = new Map(mm);
new Map(
  mm.map(([e, t]) => [hQ(t), e])
);
var mQ = (e) => {
  hm.assert.string(e);
  const t = gm(e), a = gQ.get(t);
  return a ? { emoji: a, key: t } : void 0;
}, _Q = (e, { fallback: t, format: a = (r) => r } = {}) => {
  const r = t === void 0 ? t : fQ(t);
  return Eo.assert.string(e), Eo.assert.any([Eo.default.undefined, Eo.default.function_], r), Eo.assert.function_(a), e.replace(/:[\w\-+]+:/g, (n) => {
    const o = mQ(n);
    return o ? a(o.emoji, n, e) : a(r ? r(gm(n)) : n);
  });
}, wQ = (e, t, a, r, n, o) => {
  var s, i;
  t() || d(a) && ((i = (s = r()) == null ? void 0 : s.state) == null ? void 0 : i.status) !== "Completed" && !d(n) && o.onShowItem(r());
}, vQ = (e, t, a, r, n, o) => {
  var s, i;
  t() || e.key === "Enter" && d(a) && ((i = (s = r()) == null ? void 0 : s.state) == null ? void 0 : i.status) !== "Completed" && !d(n) && o.onShowItem(r());
}, bQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-size-5 !layup-items-center !layup-justify-center"><div class="!layup-size-4 !layup-animate-spin !layup-rounded-full !layup-border-2 !layup-border-accent-icon !layup-border-t-transparent"></div></div>'), kQ = /* @__PURE__ */ L('<div class="layup-group/item !layup-relative"><!></div>'), xQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-10 !layup-w-full !layup-items-center"><div role="button" tabindex="0"><div class="!layup-flex !layup-w-full !layup-items-center !layup-gap-3"><!> <p> </p></div></div></div>'), zQ = /* @__PURE__ */ L('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), SQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-items-center !layup-justify-between"><div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <!></div>'), CQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-gap-4"><!> <p class="layup-text-base">Back</p></div>'), EQ = /* @__PURE__ */ L('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), AQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-gap-2"><!></div> <div class="!layup-flex !layup-items-center !layup-gap-2"><!></div>', 1), TQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-items-center !layup-justify-center !layup-gap-2"><!> <p class="layup-text-button !layup-font-button"> </p></div>'), PQ = /* @__PURE__ */ L('<div><div class="!layup-flex !layup-w-full !layup-flex-col layup-rounded-md !layup-bg-background layup-text-left"><div class="!layup-flex !layup-w-full !layup-flex-col"><div class="!layup-flex !layup-h-fit !layup-w-full !layup-items-center !layup-justify-between !layup-p-default"><!></div> <div class="!layup-flex !layup-w-full !layup-flex-col !layup-gap-section !layup-pt-0 !layup-p-default"><div class="!layup-flex !layup-flex-col"><h2 class="!layup-text-heading !layup-font-heading !layup-text-primary"> </h2> <p class="!layup-text-subheading !layup-text-secondary !layup-font-subheading"> </p></div> <div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-col !layup-justify-between !layup-gap-5"><div class="!layup-rounded-inner !layup-bg-accent-bg"><div class="layup-custom-scrollbar layup-flex layup-flex-col !layup-max-h-[500px] !layup-overflow-hidden !layup-p-2 !layup-gap-item"><!></div></div></div> <div class="!layup-flex !layup-h-fit !layup-w-full !layup-flex-col-reverse !layup-justify-between !layup-gap-5"><!></div></div></div></div></div>');
function OQ(e, t) {
  ke(t, !0);
  const a = (V, U = qe, ee = qe, W = qe) => {
    var G = xQ();
    const J = /* @__PURE__ */ M(() => o() === U().id), te = /* @__PURE__ */ M(() => {
      var ue, _e, Se, Re, ve, ze;
      return t.strictOrder ? ((_e = (ue = U()) == null ? void 0 : ue.state) == null ? void 0 : _e.status) === "Completed" && ee() > 0 && ((Re = (Se = n()[ee() + 1]) == null ? void 0 : Se.state) == null ? void 0 : Re.status) === "NotStarted" : ((ze = (ve = U()) == null ? void 0 : ve.state) == null ? void 0 : ze.status) === "Completed";
    }), ae = /* @__PURE__ */ M(() => {
      var ue, _e;
      return !t.strictOrder || ee() === 0 || ((_e = (ue = n()[ee() - 1]) == null ? void 0 : ue.state) == null ? void 0 : _e.status) === "Completed";
    });
    var ie = A(G);
    const oe = /* @__PURE__ */ M(() => {
      var ue, _e;
      return Oe("!layup-flex !layup-h-10 !layup-w-full !layup-cursor-default !layup-items-center !layup-rounded-button-inner !layup-px-2", d(ae) && ((_e = (ue = U()) == null ? void 0 : ue.state) == null ? void 0 : _e.status) !== "Completed" && !d(J) ? "!layup-cursor-pointer hover:!layup-bg-accent-bg-hover" : !d(ae) && "!layup-opacity-60");
    });
    ie.__click = [
      wQ,
      o,
      ae,
      U,
      J,
      t
    ], ie.__keydown = [
      vQ,
      o,
      ae,
      U,
      J,
      t
    ];
    var Q = A(ie), le = A(Q);
    {
      var he = (ue) => {
        var _e = bQ();
        z(ue, _e);
      }, pe = (ue) => {
        var _e = K(), Se = D(_e);
        {
          var Re = (ze) => {
            var fe = /* @__PURE__ */ M(() => !d(te) || d(J));
            He(ze, {
              variant: "ghost",
              size: "icon",
              class: "!layup-flex !layup-size-5 !layup-cursor-pointer !layup-items-center !layup-justify-center !layup-rounded-full !layup-bg-accent-icon !layup-opacity-70 hover:!layup-bg-accent-icon hover:!layup-opacity-100",
              onclick: (Ce) => {
                Ce.preventDefault(), Ce.stopPropagation(), d(te) && u(U(), "NotStarted");
              },
              get disabled() {
                return d(fe);
              },
              children: (Ce, Ne) => {
                Nc(Ce, {
                  class: "!layup-size-3 !layup-text-white dark:!layup-text-black"
                });
              },
              $$slots: { default: !0 }
            });
          }, ve = (ze) => {
            var fe = kQ(), Ce = A(fe), Ne = /* @__PURE__ */ M(() => Oe("!layup-flex !layup-size-5 !layup-items-center !layup-justify-center !layup-rounded-full !layup-border-2", d(ae) ? "!layup-cursor-pointer !layup-border-accent-icon group-hover/item:!layup-bg-background-secondary" : "!layup-cursor-default !layup-border-accent-secondary")), je = /* @__PURE__ */ M(() => !d(ae));
            He(Ce, {
              variant: "ghost",
              size: "icon",
              get class() {
                return d(Ne);
              },
              get disabled() {
                return d(je);
              },
              onclick: (Be) => {
                Be.preventDefault(), Be.stopPropagation(), u(U(), "Completed");
              },
              children: (Be, Fe) => {
                var Ae = /* @__PURE__ */ M(() => Oe("!layup-size-3", d(ae) ? "layup-stroke-accent-icon !layup-opacity-0 group-hover/item:!layup-opacity-100" : "!layup-opacity-0"));
                Nc(Be, {
                  get class() {
                    return d(Ae);
                  }
                });
              },
              $$slots: { default: !0 }
            }), z(ze, fe);
          };
          B(
            Se,
            (ze) => {
              var fe, Ce;
              ((Ce = (fe = U()) == null ? void 0 : fe.state) == null ? void 0 : Ce.status) === "Completed" ? ze(Re) : ze(ve, !1);
            },
            !0
          );
        }
        z(ue, _e);
      };
      B(le, (ue) => {
        d(J) ? ue(he) : ue(pe, !1);
      });
    }
    var se = X(le, 2);
    const ye = /* @__PURE__ */ M(() => {
      var ue, _e;
      return Oe("!layup-text-items !layup-font-items", ((_e = (ue = U()) == null ? void 0 : ue.state) == null ? void 0 : _e.status) === "Completed" || !d(ae) || d(J) ? "!layup-text-secondary" : "!layup-text-primary");
    });
    var ge = A(se);
    $(() => {
      var ue, _e;
      Ue(ie, d(oe)), Ue(se, d(ye)), Me(ge, (_e = (ue = U().template_onboarding_flow) == null ? void 0 : ue.flow) == null ? void 0 : _e.name);
    }), z(V, G);
  };
  R(t, "open", 11, !1);
  let r = R(t, "progress", 3, 0), n = R(t, "plan", 19, () => []), o = R(t, "loadingId", 3, null), s = /* @__PURE__ */ st(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "open",
    "title",
    "progress",
    "plan",
    "onShowItem",
    "styles",
    "isFit",
    "strictOrder",
    "send",
    "isNewUserOnboarding",
    "isOnlyOnboarding",
    "icons",
    "onClose",
    "heading",
    "subHeading",
    "onTerminate",
    "loadingId"
  ]), i = /* @__PURE__ */ M(() => {
    var V, U;
    if (!n().length) return null;
    if (t.strictOrder) {
      const ee = n().findIndex((W) => W.state.status !== "Completed");
      return ee === 0 || ((U = (V = n()[ee - 1]) == null ? void 0 : V.state) == null ? void 0 : U.status) === "Completed" ? n()[ee] : null;
    } else
      return n().find((ee) => ee.state.status !== "Completed");
  }), l = /* @__PURE__ */ M(() => {
    const V = n().filter((U) => U.state.status === "Completed").length;
    return V === n().length ? "You're all set!" : V === 0 ? "Start tour" : V === n().length - 1 ? "Finish last step" : "Start next step";
  });
  function u(V, U) {
    o() || o() !== V.id && t.send({
      type: U === "Completed" ? "markAsCompleted" : "markAsNotStarted",
      item: V
    });
  }
  function f() {
    t.send({ type: "clearLoading" }), t.onClose();
  }
  function p() {
    t.send({ type: "clearLoading" }), t.onTerminate();
  }
  var c = PQ();
  let h;
  var g = A(c), _ = A(g), b = A(_), m = A(b);
  {
    var w = (V) => {
      var U = SQ(), ee = A(U), W = A(ee);
      {
        var G = (ae) => {
          var ie = zQ(), oe = D(ie), Q = A(oe);
          At(Q, () => {
            var pe, se, ye;
            return (ye = (se = (pe = t.icons) == null ? void 0 : pe.logo) == null ? void 0 : se.dark_mode) == null ? void 0 : ye.xml;
          });
          var le = X(oe, 2), he = A(le);
          At(he, () => {
            var pe, se, ye;
            return (ye = (se = (pe = t.icons) == null ? void 0 : pe.logo) == null ? void 0 : se.light_mode) == null ? void 0 : ye.xml;
          }), z(ae, ie);
        }, J = (ae) => {
          rr(ae, { class: "!layup-size-6" });
        };
        B(W, (ae) => {
          var ie, oe, Q;
          (Q = (oe = (ie = t.icons) == null ? void 0 : ie.logo) == null ? void 0 : oe.dark_mode) != null && Q.xml ? ae(G) : ae(J, !1);
        });
      }
      var te = X(ee, 2);
      He(te, {
        variant: "ghost",
        size: "sm",
        class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
        onclick: f,
        children: (ae, ie) => {
          Ra(ae, { class: "!layup-size-full" });
        },
        $$slots: { default: !0 }
      }), z(V, U);
    }, S = (V) => {
      var U = AQ(), ee = D(U), W = A(ee);
      {
        var G = (Q) => {
          He(Q, {
            variant: "ghost",
            size: "sm",
            class: "!layup-h-8 !layup-rounded-sm !layup-border-none !layup-fill-secondary !layup-p-2 !layup-px-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-fill-primary hover:!layup-text-primary hover:!layup-ease-in-out",
            onclick: p,
            children: (le, he) => {
              var pe = CQ(), se = A(pe);
              hc(se, { class: "!layup-size-4" }), z(le, pe);
            },
            $$slots: { default: !0 }
          });
        }, J = (Q) => {
          var le = K(), he = D(le);
          {
            var pe = (ye) => {
              var ge = EQ(), ue = D(ge), _e = A(ue);
              At(_e, () => {
                var ve, ze, fe;
                return (fe = (ze = (ve = t.icons) == null ? void 0 : ve.logo) == null ? void 0 : ze.dark_mode) == null ? void 0 : fe.xml;
              });
              var Se = X(ue, 2), Re = A(Se);
              At(Re, () => {
                var ve, ze, fe;
                return (fe = (ze = (ve = t.icons) == null ? void 0 : ve.logo) == null ? void 0 : ze.light_mode) == null ? void 0 : fe.xml;
              }), z(ye, ge);
            }, se = (ye) => {
              rr(ye, { class: "!layup-size-6" });
            };
            B(
              he,
              (ye) => {
                var ge, ue, _e;
                (_e = (ue = (ge = t.icons) == null ? void 0 : ge.logo) == null ? void 0 : ue.dark_mode) != null && _e.xml ? ye(pe) : ye(se, !1);
              },
              !0
            );
          }
          z(Q, le);
        };
        B(W, (Q) => {
          t.isOnlyOnboarding ? Q(J, !1) : Q(G);
        });
      }
      var te = X(ee, 2), ae = A(te);
      {
        var ie = (Q) => {
          um(Q, {
            get progress() {
              return r();
            }
          });
        }, oe = (Q) => {
          He(Q, {
            variant: "ghost",
            size: "sm",
            class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
            onclick: f,
            children: (le, he) => {
              Ra(le, { class: "!layup-size-full" });
            },
            $$slots: { default: !0 }
          });
        };
        B(ae, (Q) => {
          t.isOnlyOnboarding ? Q(oe, !1) : Q(ie);
        });
      }
      z(V, U);
    };
    B(m, (V) => {
      t.isNewUserOnboarding ? V(w) : V(S, !1);
    });
  }
  var C = X(b, 2), v = A(C), y = A(v), k = A(y);
  $(() => Me(k, _Q(t.heading || "Welcome to Layup")));
  var x = X(y, 2), T = A(x), F = X(v, 2), P = A(F), O = A(P), I = A(O);
  zr(I, n, (V) => {
    var U = K(), ee = D(U);
    et(ee, 19, n, (W) => W == null ? void 0 : W.id, (W, G, J) => {
      a(W, () => ({ ...d(G) }), () => d(J), () => {
        var te;
        return d(J) === ((te = n()) == null ? void 0 : te.length) - 1;
      });
    }), z(V, U);
  });
  var E = X(F, 2), N = A(E), H = /* @__PURE__ */ M(() => Oe("!layup-h-9 !layup-w-full !layup-rounded-button-outer !layup-text-sm !layup-font-medium !layup-transition-all !layup-duration-200 disabled:!layup-border-0 disabled:!layup-text-primary disabled:layup-opacity-100 disabled:!layup-cursor-default disabled:!layup-shadow-none", d(i) ? "!layup-bg-accent !layup-text-accent-text !layup-shadow-md hover:!layup-bg-accent-secondary hover:!layup-shadow-lg active:!layup-scale-[0.98]" : "!layup-cursor-default !layup-border-0 !layup-text-primary")), Y = /* @__PURE__ */ M(() => !d(i));
  He(N, {
    variant: "default",
    get class() {
      return d(H);
    },
    get disabled() {
      return d(Y);
    },
    onclick: () => d(i) && t.onShowItem(d(i)),
    children: (V, U) => {
      var ee = TQ(), W = A(ee);
      {
        var G = (ae) => {
          Nc(ae, { class: "!layup-size-4" });
        };
        B(W, (ae) => {
          d(i) || ae(G);
        });
      }
      var J = X(W, 2), te = A(J);
      $(() => Me(te, d(l))), z(V, ee);
    },
    $$slots: { default: !0 }
  }), $(() => {
    h = at(c, h, {
      id: "layup-onboarding-plan",
      class: Oe("!layup-m-0 layup-flex !layup-w-full  layup-flex-col layup-justify-between !layup-border-none !layup-shadow-none", t.isFit ? "layup-h-fit" : "layup-h-full"),
      ...s,
      style: t.styles
    }), Me(T, t.subHeading || "Let's get you onboarded.");
  }), z(e, c), xe();
}
nr(["click", "keydown"]);
var MQ = /* @__PURE__ */ L("<div><!></div>");
function Up(e, t) {
  ke(t, !0);
  function a(m) {
    t.send({ type: "run", item: m });
  }
  let r = null;
  const n = /* @__PURE__ */ M(() => {
    var w;
    const m = t.snapshot.context.plans;
    return m != null && m.onboarding_flows && ((w = m == null ? void 0 : m.onboarding_flows) == null || w.sort((S, C) => (S == null ? void 0 : S.template_onboarding_flow.index) - (C == null ? void 0 : C.template_onboarding_flow.index))), m;
  }), o = /* @__PURE__ */ M(() => {
    var m;
    return (m = d(n).template_onboarding_plan) == null ? void 0 : m.strict_order;
  }), s = /* @__PURE__ */ M(() => t.snapshot.context.loadingId || null), i = /* @__PURE__ */ M(() => {
    var m, w, S, C;
    return (w = (m = t.snapshot.context.plans) == null ? void 0 : m.onboarding_flows) != null && w.length ? ((S = t.snapshot.context.plans) == null ? void 0 : S.onboarding_flows.filter((v) => v.state.status === "Completed").length) / ((C = t.snapshot.context.plans) == null ? void 0 : C.onboarding_flows.length) : 0;
  }), l = /* @__PURE__ */ M(() => {
    var m, w, S;
    return ((m = t.snapshot.context.metadata) == null ? void 0 : m.is_onboarding_active) && !((w = t.snapshot.context.metadata) != null && w.is_guidance_active) && !((S = t.snapshot.context.metadata) != null && S.is_announcement_active);
  }), u = /* @__PURE__ */ M(() => {
    var m;
    return (m = t.snapshot.context.theme) == null ? void 0 : m.icons;
  }), f = /* @__PURE__ */ M(() => {
    var m, w;
    return (w = (m = t.snapshot.context.plans) == null ? void 0 : m.template_onboarding_plan) == null ? void 0 : w.plan_heading;
  }), p = /* @__PURE__ */ M(() => {
    var m, w;
    return (w = (m = t.snapshot.context.plans) == null ? void 0 : m.template_onboarding_plan) == null ? void 0 : w.plan_subheading;
  });
  var c = MQ();
  const h = /* @__PURE__ */ M(() => Oe("layup-onboarding-plan  !layup-pointer-events-auto !layup-block layup-w-full layup-rounded-md layup-border layup-border-t-0 layup-border-background-secondary layup-bg-background", t.isFit ? "layup-h-fit" : "layup-h-full"));
  var g = A(c), _ = /* @__PURE__ */ M(() => t.snapshot.matches("onboarding")), b = /* @__PURE__ */ M(() => {
    var m;
    return (m = d(n)) == null ? void 0 : m.onboarding_flows;
  });
  OQ(g, {
    get send() {
      return t.send;
    },
    get isFit() {
      return t.isFit;
    },
    get isOnlyOnboarding() {
      return d(l);
    },
    get icons() {
      return d(u);
    },
    get loadingId() {
      return d(s);
    },
    get open() {
      return d(_);
    },
    side: "left",
    align: "end",
    get strictOrder() {
      return d(o);
    },
    sideOffset: 20,
    get progress() {
      return d(i);
    },
    get title() {
      return t.title;
    },
    get heading() {
      return d(f);
    },
    get subHeading() {
      return d(p);
    },
    get onClose() {
      return t.onClose;
    },
    get onTerminate() {
      return t.onTerminate;
    },
    get isNewUserOnboarding() {
      return t.isNewUserOnboarding;
    },
    alignOffset: 0,
    get customAnchor() {
      return r;
    },
    get plan() {
      return d(b);
    },
    onShowItem: a,
    styles: ""
  }), $(() => Ue(c, d(h))), z(e, c), xe();
}
var IQ = /* @__PURE__ */ St('<svg><path d="M10.707 17.707l5-5a.999.999 0 10-1.414-1.414L11 14.586V3a1 1 0 10-2 0v11.586l-3.293-3.293a.999.999 0 10-1.414 1.414l5 5a.999.999 0 001.414 0z"></path></svg>');
function FQ(e, t) {
  let a = /* @__PURE__ */ st(t, ["$$slots", "$$events", "$$legacy", "fill"]);
  var r = IQ();
  let n;
  $(() => n = at(
    r,
    n,
    {
      ...a,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    },
    void 0,
    !0
  )), z(e, r);
}
var jQ = /* @__PURE__ */ L('<div class="layup-flex layup-h-fit layup-w-fit layup-items-center layup-justify-center !layup-gap-2 layup-p-2 layup-font-medium layup-text-primary"><!> <p class="layup-text-base layup-font-medium layup-text-accent-text">Scroll down</p></div>'), RQ = /* @__PURE__ */ L('<div class="layup-flex layup-flex-col layup-items-center"><!></div>');
function LQ(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => {
    var s, i;
    return (i = (s = t.guideMachineContext) == null ? void 0 : s.context) == null ? void 0 : i.scrollDown;
  });
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = RQ(), l = A(i);
      He(l, {
        variant: "ghost",
        class: `layup-flex !layup-h-fit !layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2 layup-rounded-button-outer !layup-border-none
    !layup-bg-accent !layup-shadow-none !layup-outline-none hover:!layup-bg-accent-secondary hover:!layup-text-accent-text`,
        onclick: () => {
          var u;
          return (u = t.guideMachineRef) == null ? void 0 : u.send({ type: "SCROLL_TO_ELEMENT" });
        },
        children: (u, f) => {
          var p = K(), c = D(p);
          {
            var h = (g) => {
              var _ = jQ(), b = A(_);
              FQ(b, {
                class: "!layup-h-4 !layup-w-4 layup-fill-accent-text"
              }), z(g, _);
            };
            B(c, (g) => {
              var _, b;
              (b = (_ = t.guideMachineContext) == null ? void 0 : _.context) != null && b.feedback || g(h);
            });
          }
          z(u, p);
        },
        $$slots: { default: !0 }
      }), xt(1, i, () => oi, () => ({ y: 20, duration: 300 })), z(s, i);
    };
    B(n, (s) => {
      d(a) && s(o);
    });
  }
  z(e, r), xe();
}
var DQ = /* @__PURE__ */ L('<div class="layup-flex layup-h-fit layup-w-fit layup-items-center layup-justify-center !layup-gap-2 layup-p-2 layup-font-medium layup-text-primary"><!> <p class="layup-text-base layup-font-medium layup-text-accent-text">Scroll up</p></div>'), NQ = /* @__PURE__ */ L('<div class="layup-flex layup-flex-col layup-items-center"><!></div>');
function VQ(e, t) {
  ke(t, !0);
  let a = /* @__PURE__ */ M(() => {
    var s, i;
    return (i = (s = t.guideMachineContext) == null ? void 0 : s.context) == null ? void 0 : i.scrollUp;
  });
  var r = K(), n = D(r);
  {
    var o = (s) => {
      var i = NQ(), l = A(i);
      He(l, {
        variant: "ghost",
        class: `layup-flex !layup-h-fit !layup-w-fit layup-flex-row layup-items-center layup-justify-center layup-gap-2  layup-rounded-button-outer !layup-border-none
    !layup-bg-accent !layup-shadow-none !layup-outline-none hover:!layup-bg-accent-secondary hover:!layup-text-white`,
        onclick: () => {
          var u;
          return (u = t.guideMachineRef) == null ? void 0 : u.send({ type: "SCROLL_TO_ELEMENT" });
        },
        children: (u, f) => {
          var p = K(), c = D(p);
          {
            var h = (g) => {
              var _ = DQ(), b = A(_);
              Dd(b, {
                class: "!layup-h-4 !layup-w-4 layup-fill-accent-text"
              }), z(g, _);
            };
            B(c, (g) => {
              var _, b;
              (b = (_ = t.guideMachineContext) == null ? void 0 : _.context) != null && b.feedback || g(h);
            });
          }
          z(u, p);
        },
        $$slots: { default: !0 }
      }), xt(1, i, () => oi, () => ({ y: 20, duration: 300 })), z(s, i);
    };
    B(n, (s) => {
      d(a) && s(o);
    });
  }
  z(e, r), xe();
}
var qQ = /* @__PURE__ */ L('<div class="!layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-fill-primary"><!></div>', 1), BQ = /* @__PURE__ */ L('<div class="layup-chat-container !layup-relative !layup-flex !layup-h-full layup-w-full !layup-flex-1 !layup-flex-col layup-items-center layup-justify-start !layup-rounded-outer !layup-rounded-b-none layup-bg-background"><div class="layup-flex layup-h-full layup-w-full layup-flex-col"><div class="layup-min-h-14 layup-w-full !layup-p-default"><div class="layup-flex layup-h-full layup-items-center layup-justify-between layup-font-medium layup-text-primary"><div class="layup-flex layup-items-center layup-gap-2"><!></div> <!></div></div> <!> <div class="layup-flex layup-h-full layup-w-full layup-flex-col !layup-p-default !layup-gap-section"><div class="layup-flex !layup-h-fit layup-w-full layup-flex-col layup-items-center !layup-gap-item"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Top guides</p></div> <div class="layup-flex layup-w-full layup-flex-col !layup-gap-item"><div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div></div></div> <div class="layup-flex !layup-h-fit layup-w-full layup-flex-col !layup-gap-item"><div class="layup-w-full"><p class="layup-text-sm !layup-text-secondary">Modules</p></div> <div class="layup-flex layup-w-full layup-flex-col !layup-gap-item"><div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div></div></div></div></div></div>');
function WQ(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = /* @__PURE__ */ M(() => {
    var G;
    return (G = r().context.theme) == null ? void 0 : G.icons;
  });
  var o = BQ(), s = A(o), i = A(s), l = A(i), u = A(l), f = A(u);
  {
    var p = (G) => {
      var J = qQ(), te = D(J), ae = A(te);
      At(ae, () => {
        var Q, le, he;
        return (he = (le = (Q = d(n)) == null ? void 0 : Q.logo) == null ? void 0 : le.dark_mode) == null ? void 0 : he.xml;
      });
      var ie = X(te, 2), oe = A(ie);
      At(oe, () => {
        var Q, le, he;
        return (he = (le = (Q = d(n)) == null ? void 0 : Q.logo) == null ? void 0 : le.light_mode) == null ? void 0 : he.xml;
      }), z(G, J);
    }, c = (G) => {
      rr(G, { class: "!layup-size-6" });
    };
    B(f, (G) => {
      var J, te, ae;
      (ae = (te = (J = d(n)) == null ? void 0 : J.logo) == null ? void 0 : te.dark_mode) != null && ae.xml ? G(p) : G(c, !1);
    });
  }
  var h = X(u, 2);
  He(h, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    onclick: () => {
      t.send({ type: "toggleWidgetVisibility" });
    },
    children: (G, J) => {
      Ra(G, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var g = X(i, 2);
  rm(g, { class: "!layup-border-border" });
  var _ = X(g, 2), b = A(_), m = X(A(b), 2), w = A(m), S = A(w);
  Et(S, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var C = X(S, 2);
  Et(C, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  });
  var v = X(w, 2), y = A(v);
  Et(y, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var k = X(y, 2);
  Et(k, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  });
  var x = X(v, 2), T = A(x);
  Et(T, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var F = X(T, 2);
  Et(F, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  });
  var P = X(b, 2), O = X(A(P), 2), I = A(O), E = A(I);
  Et(E, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var N = X(E, 2);
  Et(N, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  });
  var H = X(I, 2), Y = A(H);
  Et(Y, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var V = X(Y, 2);
  Et(V, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  });
  var U = X(H, 2), ee = A(U);
  Et(ee, {
    class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
  });
  var W = X(ee, 2);
  Et(W, {
    class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
  }), z(e, o), xe();
}
var HQ = /* @__PURE__ */ L('<div class="[&amp;>svg]:!layup-fill-textPrimary !layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex"><!></div> <div class="[&amp;>svg]:!layup-fill-textPrimary !layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden"><!></div>', 1), UQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-h-fit !layup-w-full !layup-flex-col layup-items-start !layup-rounded-inner !layup-border !layup-border-border hover:!layup-border-accent-bg hover:!layup-bg-accent-bg"><div class="layup-group !layup-flex !layup-w-full !layup-items-start !layup-rounded-button-outer !layup-border !layup-border-background-secondary !layup-text-primary hover:!layup-text-primary"><div class="!layup-flex !layup-w-full !layup-flex-col layup-justify-between !layup-bg-transparent !layup-p-3"><div class="!layup-flex !layup-w-full !layup-flex-col !layup-items-center !layup-gap-3"><div class="!layup-w-full !layup-flex !layup-flex-col"><div class="!layup-flex !layup-w-full !layup-items-center layup-justify-start !layup-gap-2"><div class="layup-h-2 layup-w-2 layup-shrink-0 layup-rounded-full layup-bg-accent"></div> <!></div> <!></div> <div class="!layup-w-full"><!></div> <div class="!layup-flex !layup-w-full !layup-flex-row-reverse !layup-justify-between !layup-gap-2"><!> <!></div></div></div></div></div>'), GQ = /* @__PURE__ */ L('<div class="!layup-flex !layup-w-full !layup-flex-col !layup-bg-background !layup-h-[455px]"><div class="!layup-flex !layup-h-fit !layup-w-full !layup-items-center !layup-justify-between !layup-p-default"><!> <!></div> <div class="layup-custom-scrollbar !layup-flex !layup-h-full !layup-flex-col !layup-gap-3 !layup-overflow-y-auto !layup-overscroll-contain !layup-p-default !layup-pt-0"><div class="!layup-flex !layup-h-full !layup-flex-col !layup-gap-section"><div class="!layup-flex !layup-h-[30px] !layup-w-full !layup-items-center !layup-justify-between"><h2 class="!layup-text-2xl !layup-font-medium !layup-leading-none !layup-text-primary">Announcements</h2></div> <div class="!layup-flex !layup-h-full !layup-w-full !layup-flex-col !layup-gap-item"><!> <div class="layup-py-[1px]"></div></div></div></div></div>');
function KQ(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = /* @__PURE__ */ M(() => {
    var _;
    return (_ = r().context.theme) == null ? void 0 : _.icons;
  });
  var o = GQ(), s = A(o), i = A(s);
  {
    var l = (_) => {
      var b = HQ(), m = D(b), w = A(m);
      At(w, () => {
        var v, y, k;
        return (k = (y = (v = d(n)) == null ? void 0 : v.logo) == null ? void 0 : y.dark_mode) == null ? void 0 : k.xml;
      });
      var S = X(m, 2), C = A(S);
      At(C, () => {
        var v, y, k;
        return (k = (y = (v = d(n)) == null ? void 0 : v.logo) == null ? void 0 : y.light_mode) == null ? void 0 : k.xml;
      }), z(_, b);
    }, u = (_) => {
      rr(_, { class: "!layup-size-6" });
    };
    B(i, (_) => {
      var b, m, w;
      (w = (m = (b = d(n)) == null ? void 0 : b.logo) == null ? void 0 : m.dark_mode) != null && w.xml ? _(l) : _(u, !1);
    });
  }
  var f = X(i, 2);
  He(f, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-sm !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    onclick: () => {
      t.send({ type: "toggleWidgetVisibility" });
    },
    children: (_, b) => {
      Ra(_, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var p = X(s, 2), c = A(p), h = X(A(c), 2), g = A(h);
  et(g, 16, () => Array(3), yt, (_, b) => {
    var m = UQ(), w = A(m), S = A(w), C = A(S), v = A(C), y = A(v), k = X(A(y), 2);
    Et(k, {
      class: "!layup-h-6 !layup-w-[200px] !layup-text-base !layup-font-medium"
    });
    var x = X(y, 2);
    Et(x, {
      class: "!layup-h-4 !layup-w-[150px] !layup-text-sm !layup-text-secondary"
    });
    var T = X(v, 2), F = A(T);
    Et(F, {
      class: "!layup-h-12 !layup-w-full !layup-text-sm !layup-leading-relaxed"
    });
    var P = X(T, 2), O = A(P);
    Et(O, {
      class: "!layup-h-8 !layup-w-[80px] !layup-rounded-button-outer"
    });
    var I = X(O, 2);
    Et(I, {
      class: "!layup-h-8 !layup-w-[80px] !layup-rounded-button-outer"
    }), z(_, m);
  }), z(e, o), xe();
}
var ZQ = /* @__PURE__ */ L('<div class="!layup-hidden !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-flex [&amp;>svg]:!layup-fill-primary"><!></div> <div class="!layup-flex !layup-h-6 !layup-w-32 !layup-items-center !layup-justify-center dark:!layup-hidden [&amp;>svg]:!layup-fill-primary"><!></div>', 1), YQ = /* @__PURE__ */ L('<div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-1 !layup-rounded-button-outer"><!> <!></div>'), XQ = /* @__PURE__ */ L('<div><div class="layup-flex layup-w-full layup-flex-col layup-gap-4"><div class="layup-flex layup-w-full layup-items-center layup-justify-between !layup-p-default"><div class="layup-flex layup-items-center layup-gap-2"><!></div> <!></div> <div class="layup-flex layup-w-full layup-flex-col layup-gap-1 !layup-p-default !layup-rounded-button-outer"></div></div></div>');
function JQ(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(t.snapshot, "$snapshot", a), n = /* @__PURE__ */ M(() => {
    var _, b, m;
    return (m = (b = (_ = r()) == null ? void 0 : _.context) == null ? void 0 : b.theme) == null ? void 0 : m.icons;
  });
  var o = XQ();
  const s = /* @__PURE__ */ M(() => Oe("layup-flex layup-h-full layup-w-full layup-flex-col layup-bg-background", t.isFit ? "layup-h-fit" : "layup-h-full"));
  var i = A(o), l = A(i), u = A(l), f = A(u);
  {
    var p = (_) => {
      var b = ZQ(), m = D(b), w = A(m);
      At(w, () => {
        var v, y, k;
        return (k = (y = (v = d(n)) == null ? void 0 : v.logo) == null ? void 0 : y.dark_mode) == null ? void 0 : k.xml;
      });
      var S = X(m, 2), C = A(S);
      At(C, () => {
        var v, y, k;
        return (k = (y = (v = d(n)) == null ? void 0 : v.logo) == null ? void 0 : y.light_mode) == null ? void 0 : k.xml;
      }), z(_, b);
    }, c = (_) => {
      rr(_, { class: "!layup-size-6" });
    };
    B(f, (_) => {
      var b, m, w;
      (w = (m = (b = d(n)) == null ? void 0 : b.logo) == null ? void 0 : m.dark_mode) != null && w.xml ? _(p) : _(c, !1);
    });
  }
  var h = X(u, 2);
  He(h, {
    variant: "ghost",
    size: "sm",
    class: "layup-flex !layup-h-5 !layup-w-5 layup-items-center layup-justify-center !layup-rounded-outer !layup-border-none !layup-p-0 !layup-text-secondary !layup-shadow-none !layup-transition-transform !layup-duration-200 hover:!layup-bg-transparent hover:!layup-text-primary hover:!layup-ease-in-out",
    onclick: () => {
      t.send({ type: "toggleWidgetVisibility" });
    },
    children: (_, b) => {
      Ra(_, { class: "!layup-size-full" });
    },
    $$slots: { default: !0 }
  });
  var g = X(l, 2);
  et(g, 20, () => Array(3), yt, (_, b) => {
    var m = YQ(), w = A(m);
    Et(w, {
      class: "!layup-h-4 !layup-w-[80%] layup-bg-secondary"
    });
    var S = X(w, 2);
    Et(S, {
      class: "!layup-h-3 !layup-w-[60%] layup-bg-secondary"
    }), z(_, m);
  }), $(() => Ue(o, d(s))), z(e, o), xe();
}
var QQ = /* @__PURE__ */ L("<!> <!>", 1), $Q = /* @__PURE__ */ L("<div><!></div>"), e$ = /* @__PURE__ */ L("<div><!></div>"), t$ = /* @__PURE__ */ L('<div><div class="layup-flex layup-w-full layup-flex-col layup-items-center layup-justify-center layup-gap-2"><!> <!> <!> <!> <!> <!> <!></div></div> <div><!> <!> <!> <!> <!></div>', 1), a$ = /* @__PURE__ */ L("<div></div>"), r$ = /* @__PURE__ */ L("<div><!></div>"), n$ = /* @__PURE__ */ L('<div class="layup-flex layup-flex-col layup-items-center"><!> <!></div>'), o$ = /* @__PURE__ */ L("<!> <!>", 1);
function s$(e, t) {
  ke(t, !0);
  const a = ba(), r = () => Yt(o, "$snapshot", a), n = (I) => {
    var E = t$(), N = D(E);
    const H = /* @__PURE__ */ M(() => Oe("layup-mb-2", r().matches("query") || r().matches("onboarding") || r().matches("features") || r().matches("history") || r().matches("initializeHistory") || r().matches({ thinking: "getQuery" }) || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) || r().matches("newUserOnboarding") || r().matches("newUserFeatures") || r().matches("loadingWidgetData.loadingOnboarding") || r().matches("loadingWidgetData.loadingFeatures") || r().matches("loadingWidgetData.loadingQueries") ? "!layup-min-w-custom !layup-max-w-custom" : "", r().matches("guideMachine") && "layup-min-w-[450px] layup-max-w-[450px]"));
    var Y = A(N), V = A(Y);
    f4(V, {
      get guideMachineContext() {
        return d(k);
      },
      get guideMachineRef() {
        return d(y);
      }
    });
    var U = X(V, 2);
    m4(U, {
      get guideMachineContext() {
        return d(k);
      },
      get guideMachineRef() {
        return d(y);
      }
    });
    var ee = X(U, 2);
    VQ(ee, {
      get guideMachineContext() {
        return d(k);
      },
      get guideMachineRef() {
        return d(y);
      }
    });
    var W = X(ee, 2);
    LQ(W, {
      get guideMachineContext() {
        return d(k);
      },
      get guideMachineRef() {
        return d(y);
      }
    });
    var G = X(W, 2);
    y6(G, {
      get notification() {
        return d(C);
      },
      set notification(fe) {
        q(C, ce(fe));
      }
    });
    var J = X(G, 2);
    {
      var te = (fe) => {
        P9(fe, {
          get guideMachineContext() {
            return d(k);
          },
          get guideMachineRef() {
            return d(y);
          }
        });
      };
      B(J, (fe) => {
        var Ce;
        (Ce = d(k)) != null && Ce.matches("completed") || fe(te);
      });
    }
    var ae = X(J, 2);
    {
      var ie = (fe) => {
        $9(fe, {
          get guideMachineRef() {
            return d(y);
          },
          get guideMachineContext() {
            return d(k);
          }
        });
      };
      B(ae, (fe) => {
        var Ce, Ne;
        (Ne = (Ce = d(k)) == null ? void 0 : Ce.context) != null && Ne.showKnowledge && fe(ie);
      });
    }
    var oe = X(N, 2);
    const Q = /* @__PURE__ */ M(() => Oe("layup-flex layup-flex-col layup-overflow-hidden !layup-w-full  !layup-shadow-custom  layup-rounded-outer layup-bg-transparent layup-p-0 layup-ease-in-out layup-origin-center", d(u) || d(l) || d(f) ? "" : "!layup-origin-bottom-right", r().matches("query") || r().matches("onboarding") || r().matches("features") || r().matches("history") || r().matches("initializeHistory") || r().matches({ thinking: "getQuery" }) || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) || r().matches("newUserOnboarding") || r().matches("newUserFeatures") || r().matches("loadingWidgetData.loadingOnboarding") || r().matches("loadingWidgetData.loadingFeatures") || r().matches("loadingWidgetData.loadingQueries") ? "!layup-min-w-custom !layup-max-w-custom !layup-border !layup-border-background-secondary !layup-bg-background  dark:!layup-bg-background" : "", r().matches("guideMachine") && "layup-min-w-[450px] layup-max-w-[450px] !layup-border !layup-border-border !layup-bg-background dark:!layup-bg-background"));
    var le = A(oe);
    {
      var he = (fe) => {
        var Ce = /* @__PURE__ */ M(() => d(u) || d(l) || d(f));
        JQ(fe, {
          get isFit() {
            return d(Ce);
          },
          snapshot: o,
          send: s
        });
      }, pe = (fe) => {
        var Ce = K(), Ne = D(Ce);
        {
          var je = (Fe) => {
            KQ(Fe, { snapshot: o, send: s });
          }, Be = (Fe) => {
            var Ae = K(), mt = D(Ae);
            {
              var ut = (dt) => {
                WQ(dt, { snapshot: o, send: s });
              }, De = (dt) => {
                var ra = K(), ua = D(ra);
                {
                  var da = (fa) => {
                    var Te = /* @__PURE__ */ M(() => d(u) || d(l) || d(f));
                    Up(fa, {
                      send: s,
                      get isFit() {
                        return d(Te);
                      },
                      get snapshot() {
                        return r();
                      },
                      title: "Onboarding",
                      isNewUserOnboarding: !0,
                      onClose: () => {
                        var Ye, vt;
                        (vt = (Ye = Z.config).onClose) == null || vt.call(Ye), s({ type: "terminate" });
                      },
                      onTerminate: v
                    });
                  }, Ir = (fa) => {
                    var Te = K(), Ye = D(Te);
                    {
                      var vt = (Mt) => {
                        var ht = QQ(), Pt = D(ht), Fr = /* @__PURE__ */ M(() => {
                          var sr;
                          return (sr = r().context) == null ? void 0 : sr.features;
                        });
                        E9(Pt, {
                          snapshot: o,
                          send: s,
                          get features() {
                            return d(Fr);
                          },
                          onTerminate: () => s({ type: "terminate" })
                        });
                        var gc = X(Pt, 2), mc = /* @__PURE__ */ M(() => {
                          var sr;
                          return (sr = r().context) == null ? void 0 : sr.features;
                        });
                        f6(gc, {
                          snapshot: o,
                          send: s,
                          get features() {
                            return d(mc);
                          }
                        }), z(Mt, ht);
                      };
                      B(
                        Ye,
                        (Mt) => {
                          r().matches("newUserFeatures") && Mt(vt);
                        },
                        !0
                      );
                    }
                    z(fa, Te);
                  };
                  B(
                    ua,
                    (fa) => {
                      r().matches("newUserOnboarding") ? fa(da) : fa(Ir, !1);
                    },
                    !0
                  );
                }
                z(dt, ra);
              };
              B(
                mt,
                (dt) => {
                  r().matches("loadingWidgetData.loadingQueries") ? dt(ut) : dt(De, !1);
                },
                !0
              );
            }
            z(Fe, Ae);
          };
          B(
            Ne,
            (Fe) => {
              r().matches("loadingWidgetData.loadingFeatures") ? Fe(je) : Fe(Be, !1);
            },
            !0
          );
        }
        z(fe, Ce);
      };
      B(le, (fe) => {
        r().matches("loadingWidgetData.loadingOnboarding") ? fe(he) : fe(pe, !1);
      });
    }
    var se = X(le, 2);
    {
      var ye = (fe) => {
        var Ce = /* @__PURE__ */ M(() => r().matches("initializeHistory"));
        q9(fe, {
          send: s,
          onTerminate: () => s({ type: "esc" }),
          snapshot: o,
          get isLoading() {
            return d(Ce);
          },
          onClose: () => {
            var Ne, je;
            (je = (Ne = Z.config).onClose) == null || je.call(Ne), s({ type: "exit_everything" });
          }
        });
      }, ge = (fe) => {
        var Ce = K(), Ne = D(Ce);
        {
          var je = (Fe) => {
            var Ae = /* @__PURE__ */ M(() => d(l) || d(u) || d(f));
            Y5(Fe, {
              snapshot: o,
              send: s,
              handleClose: v,
              get showHeading() {
                return d(Ae);
              }
            });
          }, Be = (Fe) => {
            var Ae = K(), mt = D(Ae);
            {
              var ut = (dt) => {
                var ra = /* @__PURE__ */ M(() => d(u) || d(l) || d(f));
                Up(dt, {
                  send: s,
                  get isFit() {
                    return d(ra);
                  },
                  get snapshot() {
                    return r();
                  },
                  title: "Onboarding",
                  isNewUserOnboarding: !1,
                  onClose: () => {
                    var ua, da;
                    (da = (ua = Z.config).onClose) == null || da.call(ua), s({ type: "exit_everything" });
                  },
                  onTerminate: () => {
                    var ua, da;
                    (da = (ua = Z.config).onClose) == null || da.call(ua), s({ type: "terminate" });
                  }
                });
              }, De = (dt) => {
                var ra = K(), ua = D(ra);
                {
                  var da = (Ir) => {
                    G4(Ir, {
                      snapshot: o,
                      send: s,
                      onClose: () => {
                        var fa, Te;
                        (Te = (fa = Z.config).onClose) == null || Te.call(fa), s({ type: "exit_everything" });
                      },
                      onTerminate: () => s({ type: "esc" })
                    });
                  };
                  B(
                    ua,
                    (Ir) => {
                      r().matches("features") && Ir(da);
                    },
                    !0
                  );
                }
                z(dt, ra);
              };
              B(
                mt,
                (dt) => {
                  r().matches("onboarding") ? dt(ut) : dt(De, !1);
                },
                !0
              );
            }
            z(Fe, Ae);
          };
          B(
            Ne,
            (Fe) => {
              r().matches("query") || r().matches({ thinking: "getQuery" }) ? Fe(je) : Fe(Be, !1);
            },
            !0
          );
        }
        z(fe, Ce);
      };
      B(se, (fe) => {
        r().matches("history") || r().matches("initializeHistory") ? fe(ye) : fe(ge, !1);
      });
    }
    var ue = X(se, 2);
    {
      var _e = (fe) => {
        var Ce = $Q();
        const Ne = /* @__PURE__ */ M(() => Oe("layup-h-fit layup-justify-center layup-rounded-b-outer", r().matches("guideMachine") && "!layup-rounded-outer !layup-border !layup-border-border !layup-bg-background"));
        var je = A(Ce);
        $4(je, { send: s, snapshot: o }), $(() => Ue(Ce, d(Ne))), z(fe, Ce);
      };
      B(ue, (fe) => {
        !r().matches("newUserOnboarding") && !r().matches("newUserFeatures") && !r().matches("guideMachine") && !r().matches("history") && !r().matches("initializeHistory") && !r().matches({ thinking: "getFlow" }) && !r().matches({ thinking: "getFlowForOnboarding" }) && !r().matches({ thinking: "getFlowById" }) && !r().matches("onboarding") && !r().matches("features") && fe(_e);
      });
    }
    var Se = X(ue, 2);
    {
      var Re = (fe) => {
        x9(fe, {
          get guideMachineContext() {
            return d(k);
          },
          get guideMachineRef() {
            return d(y);
          }
        });
      };
      B(Se, (fe) => {
        r().matches("guideMachine") && fe(Re);
      });
    }
    var ve = X(Se, 2);
    {
      var ze = (fe) => {
        var Ce = e$();
        const Ne = /* @__PURE__ */ M(() => Oe("layup-h-fit layup-min-h-10 !layup-w-full layup-justify-center layup-rounded-b-lg", r().matches("guideMachine") || r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" }) ? "!layup-rounded-lg !layup-border !layup-border-background-secondary !layup-bg-background" : "!layup-bg-background-secondary"));
        var je = A(Ce);
        Y4(je, {
          text: "Thinking...",
          textAlign: "center",
          backgroundColor: "transparent",
          textColor: "text-textPrimary",
          padding: "!layup-p-3"
        }), $(() => Ue(Ce, d(Ne))), z(fe, Ce);
      };
      B(ve, (fe) => {
        (r().matches({ thinking: "getFlow" }) || r().matches({ thinking: "getFlowForOnboarding" }) || r().matches({ thinking: "getFlowById" })) && fe(ze);
      });
    }
    $(() => {
      Ue(N, d(H)), Ue(oe, d(Q));
    }), xt(1, oe, () => al, () => ({ duration: 100 })), z(I, E);
  }, { snapshot: o, send: s } = O3(A3);
  Pe(() => {
    const I = Z.config.URLpath;
    d(g) && s({ type: "locationChange", path: I });
  });
  let i = /* @__PURE__ */ M(() => {
    var I;
    return (I = r().context) == null ? void 0 : I.showWidget;
  }), l = /* @__PURE__ */ M(() => Z.config.variant === "modal"), u = /* @__PURE__ */ M(() => Z.config.variant === "sidebar"), f = /* @__PURE__ */ M(() => Z.config.variant === "sidebarcompact"), p = /* @__PURE__ */ M(() => Z.config.variant === "compact"), c = /* @__PURE__ */ M(() => d(u) && d(i)), h = /* @__PURE__ */ M(() => d(f) && d(i)), g = /* @__PURE__ */ M(() => {
    var I;
    return (I = r().context) == null ? void 0 : I.isInitialized;
  });
  Pe(() => {
    var I, E;
    d(g) && ((E = (I = Z.config).onInit) == null || E.call(I));
  });
  let _ = /* @__PURE__ */ M(() => {
    var I, E;
    switch ((E = (I = r().context) == null ? void 0 : I.theme) == null ? void 0 : E.widget_position) {
      case "BottomRight":
        return { bottom: "1.25rem", right: "1.25rem" };
      case "BottomLeft":
        return { bottom: "1.25rem", left: "1.25rem" };
      case "TopRight":
        return { top: "1.25rem", right: "1.25rem" };
      case "TopLeft":
        return { top: "1.25rem", left: "1.25rem" };
      default:
        return {
          bottom: "1.25rem",
          left: "50%",
          transform: "translateX(-50%)"
        };
    }
  });
  const b = () => {
    var I, E, N, H;
    if (r().matches("guideMachine") || r().matches("onboarding") || r().matches("features") || r().matches("newUserOnboarding") || r().matches("loadingWidgetData.loadingOnboarding") || r().matches("loadingWidgetData.loadingFeatures") || r().matches("loadingWidgetData.loadingQueries")) {
      (E = (I = Z.config).onOpen) == null || E.call(I), s({ type: "showWidgetOn", showWidget: !0 }), s({ type: "dialogOn" });
      return;
    }
    r().can({ type: "handleOpenWidget" }) && ((H = (N = Z.config).onOpen) == null || H.call(N), s({ type: "showWidgetOn", showWidget: !0 }), s({ type: "dialogOn" }), s({ type: "handleOpenWidget" }));
  };
  I3.bind(["command+k", "ctrl+k"], () => {
    b();
  }), Pe(() => {
    d(l) && d(S) && r().matches("idle") && b(), d(p) && d(i) && r().matches("idle") && b(), d(u) && d(i) && r().matches("idle") && b(), d(f) && d(i) && r().matches("idle") && b();
  });
  let m = me(0), w = me(0);
  Pe(() => {
    var I, E;
    q(m, ce(bg((I = r().context) == null ? void 0 : I.plans))), q(w, ce(vg((E = r().context) == null ? void 0 : E.features)));
  });
  let S = /* @__PURE__ */ M(() => {
    var I;
    return (I = r().context) == null ? void 0 : I.showDialog;
  }), C = me(!1);
  const v = () => {
    var I, E;
    r().matches("guideMachine") || (s({ type: "dialogOff" }), s({ type: "exit_everything" }), s({ type: "showWidgetOn", showWidget: !1 }), (E = (I = Z.config).onClose) == null || E.call(I), s({ type: "terminate" }), s({ type: "esc" }));
  };
  let y = /* @__PURE__ */ M(() => r().children.guideMachine), k = me(null);
  Pe(() => {
    var I;
    (I = d(y)) == null || I.subscribe((E) => {
      q(k, ce(E));
    });
  });
  var x = o$();
  pt("click", Ga, (I) => {
    var E;
    ((E = I == null ? void 0 : I.target) == null ? void 0 : E.id) === "layup-widget" && (r().matches({ loadingWidgetData: "loadingOnboarding" }) || r().matches({ loadingWidgetData: "loadingFeatures" }) || r().matches({ loadingWidgetData: "loadingQueries" }) ? s({ type: "toggleWidgetVisibility" }) : v());
  }), pt("keydown", Ga, (I) => {
    I.key === "Escape" && (r().matches({ loadingWidgetData: "loadingOnboarding" }) || r().matches({ loadingWidgetData: "loadingFeatures" }) || r().matches({ loadingWidgetData: "loadingQueries" }) ? s({ type: "toggleWidgetVisibility" }) : v());
  }), pt("layup-close-widget", Ga, () => {
    r().matches({ loadingWidgetData: "loadingOnboarding" }) || r().matches({ loadingWidgetData: "loadingFeatures" }) || r().matches({ loadingWidgetData: "loadingQueries" }) ? s({ type: "toggleWidgetVisibility" }) : v();
  }), pt("layup-show-widget", Ga, () => {
    b();
  }), pt("layup-initialize", Ga, (I) => {
    s({ type: "initialized", data: I.detail });
  }), pt("layup-reinitialize", Ga, (I) => {
    s({ type: "reinitialize" });
  }), pt("layup-run-guide", Ga, (I) => {
    s({
      type: "getAndRunFlow",
      flow_id: I.detail.flow_id
    });
  });
  var T = D(x);
  {
    var F = (I) => {
      var E = a$();
      z(I, E);
    }, P = (I) => {
      var E = K(), N = D(E);
      {
        var H = (Y) => {
          var V = /* @__PURE__ */ M(() => r().matches("guideMachine")), U = /* @__PURE__ */ M(() => Oe("tailwind-preflight layup-fixed layup-z-[1200] !layup-rounded-sm !layup-text-base ", (d(S) && d(l) || d(c)) && !r().matches("guideMachine") && !r().matches({ thinking: "getFlow" }) && !r().matches({ thinking: "getFlowForOnboarding" }) && !r().matches({ thinking: "getFlowById" }) ? "layup-min-w-screen !layup-left-[50%] !layup-top-[50%] layup-flex layup-h-screen layup-min-h-screen layup-w-screen !layup-translate-x-[-50%] !layup-translate-y-[-50%] layup-items-center  layup-justify-center !layup-backdrop-blur-sm backdrop:layup-bg-background/50 backdrop:!layup-backdrop-blur-xl" : ""));
          y4(Y, {
            get isDraggable() {
              return d(V);
            },
            id: "layup-widget",
            get className() {
              return d(U);
            },
            get positionStyles() {
              return d(_);
            },
            children: (ee, W) => {
              var G = K(), J = D(G);
              {
                var te = (ie) => {
                  var oe = n$(), Q = A(oe);
                  {
                    var le = (se) => {
                      n(se);
                    };
                    B(Q, (se) => {
                      d(i) && se(le);
                    });
                  }
                  var he = X(Q, 2);
                  {
                    var pe = (se) => {
                      var ye = r$();
                      const ge = /* @__PURE__ */ M(() => {
                        var ve, ze;
                        return Oe("layup-mt-2 layup-flex layup-w-full", ((ze = (ve = r().context) == null ? void 0 : ve.theme) == null ? void 0 : ze.widget_position) === "BottomRight" ? "layup-justify-end" : "layup-justify-center");
                      });
                      var ue = A(ye), _e = /* @__PURE__ */ M(() => d(m) + d(w)), Se = /* @__PURE__ */ M(() => {
                        var ve, ze;
                        return (ze = (ve = r().context) == null ? void 0 : ve.theme) == null ? void 0 : ze.icons;
                      }), Re = /* @__PURE__ */ M(() => {
                        var ve, ze;
                        return (ze = (ve = r().context) == null ? void 0 : ve.theme) == null ? void 0 : ze.widget_position;
                      });
                      qp(ue, {
                        isCompact: !0,
                        get isOpen() {
                          return d(i);
                        },
                        get count() {
                          return d(_e);
                        },
                        get icons() {
                          return d(Se);
                        },
                        get widget_position() {
                          return d(Re);
                        },
                        handleClick: () => {
                          d(i) ? r().matches({ loadingWidgetData: "loadingOnboarding" }) || r().matches({ loadingWidgetData: "loadingFeatures" }) || r().matches({ loadingWidgetData: "loadingQueries" }) ? s({ type: "toggleWidgetVisibility" }) : v() : b();
                        }
                      }), $(() => Ue(ye, d(ge))), z(se, ye);
                    };
                    B(he, (se) => {
                      r().matches("guideMachine") || se(pe);
                    });
                  }
                  z(ie, oe);
                }, ae = (ie) => {
                  var oe = K(), Q = D(oe);
                  {
                    var le = (pe) => {
                      var se = K(), ye = D(se);
                      {
                        var ge = (ue) => {
                          n(ue);
                        };
                        B(ye, (ue) => {
                          d(i) && ue(ge);
                        });
                      }
                      z(pe, se);
                    }, he = (pe) => {
                      var se = K(), ye = D(se);
                      {
                        var ge = (_e) => {
                          var Se = K(), Re = D(Se);
                          {
                            var ve = (fe) => {
                              var Ce = /* @__PURE__ */ M(() => d(m) + d(w)), Ne = /* @__PURE__ */ M(() => {
                                var Be, Fe;
                                return (Fe = (Be = r().context) == null ? void 0 : Be.theme) == null ? void 0 : Fe.icons;
                              }), je = /* @__PURE__ */ M(() => {
                                var Be, Fe;
                                return (Fe = (Be = r().context) == null ? void 0 : Be.theme) == null ? void 0 : Fe.widget_position;
                              });
                              qp(fe, {
                                isCompact: !1,
                                get isOpen() {
                                  return d(i);
                                },
                                get count() {
                                  return d(Ce);
                                },
                                get icons() {
                                  return d(Ne);
                                },
                                get widget_position() {
                                  return d(je);
                                },
                                handleClick: () => {
                                  d(i) ? r().matches({ loadingWidgetData: "loadingOnboarding" }) || r().matches({ loadingWidgetData: "loadingFeatures" }) || r().matches({ loadingWidgetData: "loadingQueries" }) ? s({ type: "toggleWidgetVisibility" }) : v() : b();
                                }
                              });
                            }, ze = (fe) => {
                              n(fe);
                            };
                            B(Re, (fe) => {
                              d(S) ? fe(ze, !1) : fe(ve);
                            });
                          }
                          z(_e, Se);
                        }, ue = (_e) => {
                          var Se = K(), Re = D(Se);
                          {
                            var ve = (ze) => {
                              var fe = K(), Ce = D(fe);
                              {
                                var Ne = (je) => {
                                  n(je);
                                };
                                B(Ce, (je) => {
                                  d(i) && je(Ne);
                                });
                              }
                              z(ze, fe);
                            };
                            B(
                              Re,
                              (ze) => {
                                d(u) && ze(ve);
                              },
                              !0
                            );
                          }
                          z(_e, Se);
                        };
                        B(
                          ye,
                          (_e) => {
                            d(l) ? _e(ge) : _e(ue, !1);
                          },
                          !0
                        );
                      }
                      z(pe, se);
                    };
                    B(
                      Q,
                      (pe) => {
                        d(h) ? pe(le) : pe(he, !1);
                      },
                      !0
                    );
                  }
                  z(ie, oe);
                };
                B(J, (ie) => {
                  d(p) ? ie(te) : ie(ae, !1);
                });
              }
              z(ee, G);
            },
            $$slots: { default: !0 }
          });
        };
        B(
          N,
          (Y) => {
            !r().matches("initializing") && !r().matches("updates") && !r().matches("error") && Y(H);
          },
          !0
        );
      }
      z(I, E);
    };
    B(T, (I) => {
      r().matches("error") ? I(F) : I(P, !1);
    });
  }
  var O = X(T, 2);
  Vw(O, {}), z(e, x), xe();
}
var Ou = function() {
  return Ou = Object.assign || function(t) {
    for (var a, r = 1, n = arguments.length; r < n; r++) {
      a = arguments[r];
      for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
    }
    return t;
  }, Ou.apply(this, arguments);
};
function Va(e, t, a, r) {
  function n(o) {
    return o instanceof a ? o : new a(function(s) {
      s(o);
    });
  }
  return new (a || (a = Promise))(function(o, s) {
    function i(f) {
      try {
        u(r.next(f));
      } catch (p) {
        s(p);
      }
    }
    function l(f) {
      try {
        u(r.throw(f));
      } catch (p) {
        s(p);
      }
    }
    function u(f) {
      f.done ? o(f.value) : n(f.value).then(i, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function qa(e, t) {
  var a = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, n, o, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = i(0), s.throw = i(1), s.return = i(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function i(u) {
    return function(f) {
      return l([u, f]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (a = 0)), a; ) try {
      if (r = 1, n && (o = u[0] & 2 ? n.return : u[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, u[1])).done) return o;
      switch (n = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return a.label++, { value: u[1], done: !1 };
        case 5:
          a.label++, n = u[1], u = [0];
          continue;
        case 7:
          u = a.ops.pop(), a.trys.pop();
          continue;
        default:
          if (o = a.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            a = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            a.label = u[1];
            break;
          }
          if (u[0] === 6 && a.label < o[1]) {
            a.label = o[1], o = u;
            break;
          }
          if (o && a.label < o[2]) {
            a.label = o[2], a.ops.push(u);
            break;
          }
          o[2] && a.ops.pop(), a.trys.pop();
          continue;
      }
      u = t.call(e, a);
    } catch (f) {
      u = [6, f], n = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function _m(e, t, a) {
  if (a || arguments.length === 2) for (var r = 0, n = t.length, o; r < n; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var wm = "4.5.1";
function il(e, t) {
  return new Promise(function(a) {
    return setTimeout(a, e, t);
  });
}
function i$() {
  return new Promise(function(e) {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(null);
  });
}
function l$(e, t) {
  t === void 0 && (t = 1 / 0);
  var a = window.requestIdleCallback;
  return a ? new Promise(function(r) {
    return a.call(window, function() {
      return r();
    }, { timeout: t });
  }) : il(Math.min(e, t));
}
function vm(e) {
  return !!e && typeof e.then == "function";
}
function Gp(e, t) {
  try {
    var a = e();
    vm(a) ? a.then(function(r) {
      return t(!0, r);
    }, function(r) {
      return t(!1, r);
    }) : t(!0, a);
  } catch (r) {
    t(!1, r);
  }
}
function Kp(e, t, a) {
  return a === void 0 && (a = 16), Va(this, void 0, void 0, function() {
    var r, n, o, s;
    return qa(this, function(i) {
      switch (i.label) {
        case 0:
          r = Array(e.length), n = Date.now(), o = 0, i.label = 1;
        case 1:
          return o < e.length ? (r[o] = t(e[o], o), s = Date.now(), s >= n + a ? (n = s, [4, i$()]) : [3, 3]) : [3, 4];
        case 2:
          i.sent(), i.label = 3;
        case 3:
          return ++o, [3, 1];
        case 4:
          return [2, r];
      }
    });
  });
}
function Zo(e) {
  return e.then(void 0, function() {
  }), e;
}
function c$(e, t) {
  for (var a = 0, r = e.length; a < r; ++a)
    if (e[a] === t)
      return !0;
  return !1;
}
function u$(e, t) {
  return !c$(e, t);
}
function Nd(e) {
  return parseInt(e);
}
function pa(e) {
  return parseFloat(e);
}
function Za(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function Ht(e) {
  return e.reduce(function(t, a) {
    return t + (a ? 1 : 0);
  }, 0);
}
function bm(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var a = 1 / t;
  return Math.round(e * a) / a;
}
function d$(e) {
  for (var t, a, r = "Unexpected syntax '".concat(e, "'"), n = /^\s*([a-z-]*)(.*)$/i.exec(e), o = n[1] || void 0, s = {}, i = /([.:#][\w-]+|\[.+?\])/gi, l = function(c, h) {
    s[c] = s[c] || [], s[c].push(h);
  }; ; ) {
    var u = i.exec(n[2]);
    if (!u)
      break;
    var f = u[0];
    switch (f[0]) {
      case ".":
        l("class", f.slice(1));
        break;
      case "#":
        l("id", f.slice(1));
        break;
      case "[": {
        var p = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(f);
        if (p)
          l(p[1], (a = (t = p[4]) !== null && t !== void 0 ? t : p[5]) !== null && a !== void 0 ? a : "");
        else
          throw new Error(r);
        break;
      }
      default:
        throw new Error(r);
    }
  }
  return [o, s];
}
function f$(e) {
  for (var t = new Uint8Array(e.length), a = 0; a < e.length; a++) {
    var r = e.charCodeAt(a);
    if (r > 127)
      return new TextEncoder().encode(e);
    t[a] = r;
  }
  return t;
}
function cr(e, t) {
  var a = e[0] >>> 16, r = e[0] & 65535, n = e[1] >>> 16, o = e[1] & 65535, s = t[0] >>> 16, i = t[0] & 65535, l = t[1] >>> 16, u = t[1] & 65535, f = 0, p = 0, c = 0, h = 0;
  h += o + u, c += h >>> 16, h &= 65535, c += n + l, p += c >>> 16, c &= 65535, p += r + i, f += p >>> 16, p &= 65535, f += a + s, f &= 65535, e[0] = f << 16 | p, e[1] = c << 16 | h;
}
function oa(e, t) {
  var a = e[0] >>> 16, r = e[0] & 65535, n = e[1] >>> 16, o = e[1] & 65535, s = t[0] >>> 16, i = t[0] & 65535, l = t[1] >>> 16, u = t[1] & 65535, f = 0, p = 0, c = 0, h = 0;
  h += o * u, c += h >>> 16, h &= 65535, c += n * u, p += c >>> 16, c &= 65535, c += o * l, p += c >>> 16, c &= 65535, p += r * u, f += p >>> 16, p &= 65535, p += n * l, f += p >>> 16, p &= 65535, p += o * i, f += p >>> 16, p &= 65535, f += a * u + r * l + n * i + o * s, f &= 65535, e[0] = f << 16 | p, e[1] = c << 16 | h;
}
function _n(e, t) {
  var a = e[0];
  t %= 64, t === 32 ? (e[0] = e[1], e[1] = a) : t < 32 ? (e[0] = a << t | e[1] >>> 32 - t, e[1] = e[1] << t | a >>> 32 - t) : (t -= 32, e[0] = e[1] << t | a >>> 32 - t, e[1] = a << t | e[1] >>> 32 - t);
}
function Jt(e, t) {
  t %= 64, t !== 0 && (t < 32 ? (e[0] = e[1] >>> 32 - t, e[1] = e[1] << t) : (e[0] = e[1] << t - 32, e[1] = 0));
}
function _t(e, t) {
  e[0] ^= t[0], e[1] ^= t[1];
}
var p$ = [4283543511, 3981806797], y$ = [3301882366, 444984403];
function Zp(e) {
  var t = [0, e[0] >>> 1];
  _t(e, t), oa(e, p$), t[1] = e[0] >>> 1, _t(e, t), oa(e, y$), t[1] = e[0] >>> 1, _t(e, t);
}
var Si = [2277735313, 289559509], Ci = [1291169091, 658871167], Yp = [0, 5], h$ = [0, 1390208809], g$ = [0, 944331445];
function m$(e, t) {
  var a = f$(e);
  t = t || 0;
  var r = [0, a.length], n = r[1] % 16, o = r[1] - n, s = [0, t], i = [0, t], l = [0, 0], u = [0, 0], f;
  for (f = 0; f < o; f = f + 16)
    l[0] = a[f + 4] | a[f + 5] << 8 | a[f + 6] << 16 | a[f + 7] << 24, l[1] = a[f] | a[f + 1] << 8 | a[f + 2] << 16 | a[f + 3] << 24, u[0] = a[f + 12] | a[f + 13] << 8 | a[f + 14] << 16 | a[f + 15] << 24, u[1] = a[f + 8] | a[f + 9] << 8 | a[f + 10] << 16 | a[f + 11] << 24, oa(l, Si), _n(l, 31), oa(l, Ci), _t(s, l), _n(s, 27), cr(s, i), oa(s, Yp), cr(s, h$), oa(u, Ci), _n(u, 33), oa(u, Si), _t(i, u), _n(i, 31), cr(i, s), oa(i, Yp), cr(i, g$);
  l[0] = 0, l[1] = 0, u[0] = 0, u[1] = 0;
  var p = [0, 0];
  switch (n) {
    case 15:
      p[1] = a[f + 14], Jt(p, 48), _t(u, p);
    case 14:
      p[1] = a[f + 13], Jt(p, 40), _t(u, p);
    case 13:
      p[1] = a[f + 12], Jt(p, 32), _t(u, p);
    case 12:
      p[1] = a[f + 11], Jt(p, 24), _t(u, p);
    case 11:
      p[1] = a[f + 10], Jt(p, 16), _t(u, p);
    case 10:
      p[1] = a[f + 9], Jt(p, 8), _t(u, p);
    case 9:
      p[1] = a[f + 8], _t(u, p), oa(u, Ci), _n(u, 33), oa(u, Si), _t(i, u);
    case 8:
      p[1] = a[f + 7], Jt(p, 56), _t(l, p);
    case 7:
      p[1] = a[f + 6], Jt(p, 48), _t(l, p);
    case 6:
      p[1] = a[f + 5], Jt(p, 40), _t(l, p);
    case 5:
      p[1] = a[f + 4], Jt(p, 32), _t(l, p);
    case 4:
      p[1] = a[f + 3], Jt(p, 24), _t(l, p);
    case 3:
      p[1] = a[f + 2], Jt(p, 16), _t(l, p);
    case 2:
      p[1] = a[f + 1], Jt(p, 8), _t(l, p);
    case 1:
      p[1] = a[f], _t(l, p), oa(l, Si), _n(l, 31), oa(l, Ci), _t(s, l);
  }
  return _t(s, r), _t(i, r), cr(s, i), cr(i, s), Zp(s), Zp(i), cr(s, i), cr(i, s), ("00000000" + (s[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[1] >>> 0).toString(16)).slice(-8);
}
function _$(e) {
  var t;
  return Ou({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function w$(e) {
  return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(e));
}
function v$(e) {
  return typeof e != "function";
}
function b$(e, t) {
  var a = Zo(new Promise(function(r) {
    var n = Date.now();
    Gp(e.bind(null, t), function() {
      for (var o = [], s = 0; s < arguments.length; s++)
        o[s] = arguments[s];
      var i = Date.now() - n;
      if (!o[0])
        return r(function() {
          return { error: o[1], duration: i };
        });
      var l = o[1];
      if (v$(l))
        return r(function() {
          return { value: l, duration: i };
        });
      r(function() {
        return new Promise(function(u) {
          var f = Date.now();
          Gp(l, function() {
            for (var p = [], c = 0; c < arguments.length; c++)
              p[c] = arguments[c];
            var h = i + Date.now() - f;
            if (!p[0])
              return u({ error: p[1], duration: h });
            u({ value: p[1], duration: h });
          });
        });
      });
    });
  }));
  return function() {
    return a.then(function(n) {
      return n();
    });
  };
}
function k$(e, t, a, r) {
  var n = Object.keys(e).filter(function(s) {
    return u$(a, s);
  }), o = Zo(Kp(n, function(s) {
    return b$(e[s], t);
  }, r));
  return function() {
    return Va(this, void 0, void 0, function() {
      var i, l, u, f, p;
      return qa(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, o];
          case 1:
            return i = c.sent(), [4, Kp(i, function(h) {
              return Zo(h());
            }, r)];
          case 2:
            return l = c.sent(), [
              4,
              Promise.all(l)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (u = c.sent(), f = {}, p = 0; p < n.length; ++p)
              f[n[p]] = u[p];
            return [2, f];
        }
      });
    });
  };
}
function km() {
  var e = window, t = navigator;
  return Ht([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function x$() {
  var e = window, t = navigator;
  return Ht(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !km();
}
function si() {
  var e = window, t = navigator;
  return Ht([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function ka() {
  var e = window, t = navigator;
  return Ht([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "RGBColor" in e,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function Vd() {
  var e = window, t = e.HTMLElement, a = e.Document;
  return Ht([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    t && !("autocapitalize" in t.prototype),
    a && "pointerLockElement" in a.prototype
  ]) >= 4;
}
function ii() {
  var e = window;
  return (
    // Filters-out Chrome, Yandex, DuckDuckGo (macOS and iOS), Edge
    w$(e.print) && // Doesn't work in Safari < 15.4
    String(e.browser) === "[object WebPageNamespace]"
  );
}
function xm() {
  var e, t, a = window;
  return Ht([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in a,
    "mozInnerScreenX" in a,
    "CSSMozDocumentRule" in a,
    "CanvasCaptureMediaStream" in a
  ]) >= 4;
}
function z$() {
  var e = window;
  return Ht([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function S$() {
  var e = window, t = e.URLPattern;
  return Ht([
    "union" in Set.prototype,
    "Iterator" in e,
    t && "hasRegExpGroups" in t.prototype,
    "RGB8" in WebGLRenderingContext.prototype
  ]) >= 3;
}
function C$() {
  var e = window;
  return Ht([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function li() {
  var e = window, t = navigator, a = e.CSS, r = e.HTMLButtonElement;
  return Ht([
    !("getStorageUpdates" in t),
    r && "popover" in r.prototype,
    "CSSCounterStyleRule" in e,
    a.supports("font-size-adjust: ex-height 0.5"),
    a.supports("text-transform: full-width")
  ]) >= 4;
}
function E$() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return Ht([
    // Since iOS 13. Doesn't work in Chrome on iPadOS <15, but works in desktop mode.
    "MediaSource" in window,
    // Since iOS 12. Doesn't work in Chrome on iPadOS.
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this, but it is not supported
    // Doesn't work in incognito mode of Safari ≥17 with split screen because of tracking prevention
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function A$() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function T$() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function qd() {
  var e = si(), t = xm(), a = window, r = navigator, n = "connection";
  return e ? Ht([
    !("SharedWorker" in a),
    // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
    // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
    // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
    r[n] && "ontypechange" in r[n],
    !("sinkId" in new Audio())
  ]) >= 2 : t ? Ht(["onorientationchange" in a, "orientation" in a, /android/i.test(r.appVersion)]) >= 2 : !1;
}
function P$() {
  var e = navigator, t = window, a = Audio.prototype, r = t.visualViewport;
  return Ht([
    "srLatency" in a,
    "srChannelCount" in a,
    "devicePosture" in e,
    r && "segments" in r,
    "getTextInformation" in Image.prototype
    // Not available in Samsung Internet 21
  ]) >= 3;
}
function O$() {
  return F$() ? -4 : M$();
}
function M$() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (I$())
    return -1;
  var a = 4500, r = 5e3, n = new t(1, r, 44100), o = n.createOscillator();
  o.type = "triangle", o.frequency.value = 1e4;
  var s = n.createDynamicsCompressor();
  s.threshold.value = -50, s.knee.value = 40, s.ratio.value = 12, s.attack.value = 0, s.release.value = 0.25, o.connect(s), s.connect(n.destination), o.start(0);
  var i = j$(n), l = i[0], u = i[1], f = Zo(l.then(function(p) {
    return R$(p.getChannelData(0).subarray(a));
  }, function(p) {
    if (p.name === "timeout" || p.name === "suspended")
      return -3;
    throw p;
  }));
  return function() {
    return u(), f;
  };
}
function I$() {
  return ka() && !Vd() && !C$();
}
function F$() {
  return (
    // Safari ≥17
    ka() && li() && ii() || // Samsung Internet ≥26
    si() && P$() && S$()
  );
}
function j$(e) {
  var t = 3, a = 500, r = 500, n = 5e3, o = function() {
  }, s = new Promise(function(i, l) {
    var u = !1, f = 0, p = 0;
    e.oncomplete = function(g) {
      return i(g.renderedBuffer);
    };
    var c = function() {
      setTimeout(function() {
        return l(Xp(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(r, p + n - Date.now()));
    }, h = function() {
      try {
        var g = e.startRendering();
        switch (vm(g) && Zo(g), e.state) {
          case "running":
            p = Date.now(), u && c();
            break;
          case "suspended":
            document.hidden || f++, u && f >= t ? l(Xp(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(h, a);
            break;
        }
      } catch (_) {
        l(_);
      }
    };
    h(), o = function() {
      u || (u = !0, p > 0 && c());
    };
  });
  return [s, o];
}
function R$(e) {
  for (var t = 0, a = 0; a < e.length; ++a)
    t += Math.abs(e[a]);
  return t;
}
function Xp(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function zm(e, t, a) {
  var r, n, o;
  return a === void 0 && (a = 50), Va(this, void 0, void 0, function() {
    var s, i;
    return qa(this, function(l) {
      switch (l.label) {
        case 0:
          s = document, l.label = 1;
        case 1:
          return s.body ? [3, 3] : [4, il(a)];
        case 2:
          return l.sent(), [3, 1];
        case 3:
          i = s.createElement("iframe"), l.label = 4;
        case 4:
          return l.trys.push([4, , 10, 11]), [4, new Promise(function(u, f) {
            var p = !1, c = function() {
              p = !0, u();
            }, h = function(b) {
              p = !0, f(b);
            };
            i.onload = c, i.onerror = h;
            var g = i.style;
            g.setProperty("display", "block", "important"), g.position = "absolute", g.top = "0", g.left = "0", g.visibility = "hidden", t && "srcdoc" in i ? i.srcdoc = t : i.src = "about:blank", s.body.appendChild(i);
            var _ = function() {
              var b, m;
              p || (((m = (b = i.contentWindow) === null || b === void 0 ? void 0 : b.document) === null || m === void 0 ? void 0 : m.readyState) === "complete" ? c() : setTimeout(_, 10));
            };
            _();
          })];
        case 5:
          l.sent(), l.label = 6;
        case 6:
          return !((n = (r = i.contentWindow) === null || r === void 0 ? void 0 : r.document) === null || n === void 0) && n.body ? [3, 8] : [4, il(a)];
        case 7:
          return l.sent(), [3, 6];
        case 8:
          return [4, e(i, i.contentWindow)];
        case 9:
          return [2, l.sent()];
        case 10:
          return (o = i.parentNode) === null || o === void 0 || o.removeChild(i), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function L$(e) {
  for (var t = d$(e), a = t[0], r = t[1], n = document.createElement(a ?? "div"), o = 0, s = Object.keys(r); o < s.length; o++) {
    var i = s[o], l = r[i].join(" ");
    i === "style" ? D$(n.style, l) : n.setAttribute(i, l);
  }
  return n;
}
function D$(e, t) {
  for (var a = 0, r = t.split(";"); a < r.length; a++) {
    var n = r[a], o = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(n);
    if (o) {
      var s = o[1], i = o[2], l = o[4];
      e.setProperty(s, i, l || "");
    }
  }
}
function N$() {
  for (var e = window; ; ) {
    var t = e.parent;
    if (!t || t === e)
      return !1;
    try {
      if (t.location.origin !== e.location.origin)
        return !0;
    } catch (a) {
      if (a instanceof Error && a.name === "SecurityError")
        return !0;
      throw a;
    }
    e = t;
  }
}
var V$ = "mmMwWLliI0O&1", q$ = "48px", wn = ["monospace", "sans-serif", "serif"], Jp = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function B$() {
  var e = this;
  return zm(function(t, a) {
    var r = a.document;
    return Va(e, void 0, void 0, function() {
      var n, o, s, i, l, u, f, p, c, h, g, _;
      return qa(this, function(b) {
        for (n = r.body, n.style.fontSize = q$, o = r.createElement("div"), o.style.setProperty("visibility", "hidden", "important"), s = {}, i = {}, l = function(m) {
          var w = r.createElement("span"), S = w.style;
          return S.position = "absolute", S.top = "0", S.left = "0", S.fontFamily = m, w.textContent = V$, o.appendChild(w), w;
        }, u = function(m, w) {
          return l("'".concat(m, "',").concat(w));
        }, f = function() {
          return wn.map(l);
        }, p = function() {
          for (var m = {}, w = function(y) {
            m[y] = wn.map(function(k) {
              return u(y, k);
            });
          }, S = 0, C = Jp; S < C.length; S++) {
            var v = C[S];
            w(v);
          }
          return m;
        }, c = function(m) {
          return wn.some(function(w, S) {
            return m[S].offsetWidth !== s[w] || m[S].offsetHeight !== i[w];
          });
        }, h = f(), g = p(), n.appendChild(o), _ = 0; _ < wn.length; _++)
          s[wn[_]] = h[_].offsetWidth, i[wn[_]] = h[_].offsetHeight;
        return [2, Jp.filter(function(m) {
          return c(g[m]);
        })];
      });
    });
  });
}
function W$() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], a = 0; a < e.length; ++a) {
      var r = e[a];
      if (r) {
        for (var n = [], o = 0; o < r.length; ++o) {
          var s = r[o];
          n.push({
            type: s.type,
            suffixes: s.suffixes
          });
        }
        t.push({
          name: r.name,
          description: r.description,
          mimeTypes: n
        });
      }
    }
    return t;
  }
}
function H$() {
  return U$(Q$());
}
function U$(e) {
  var t, a = !1, r, n, o = G$(), s = o[0], i = o[1];
  return K$(s, i) ? (a = Z$(i), e ? r = n = "skipped" : (t = Y$(s, i), r = t[0], n = t[1])) : r = n = "unsupported", { winding: a, geometry: r, text: n };
}
function G$() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function K$(e, t) {
  return !!(t && e.toDataURL);
}
function Z$(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function Y$(e, t) {
  X$(e, t);
  var a = qc(e), r = qc(e);
  if (a !== r)
    return [
      "unstable",
      "unstable"
      /* ImageStatus.Unstable */
    ];
  J$(e, t);
  var n = qc(e);
  return [n, a];
}
function X$(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var a = "Cwm fjordbank gly ".concat(
    "😃"
    /* 😃 */
  );
  t.fillText(a, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(a, 4, 45);
}
function J$(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var a = 0, r = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; a < r.length; a++) {
    var n = r[a], o = n[0], s = n[1], i = n[2];
    t.fillStyle = o, t.beginPath(), t.arc(s, i, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function qc(e) {
  return e.toDataURL();
}
function Q$() {
  return ka() && li() && ii();
}
function $$() {
  var e = navigator, t = 0, a;
  e.maxTouchPoints !== void 0 ? t = Nd(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), a = !0;
  } catch {
    a = !1;
  }
  var r = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: a,
    touchStart: r
  };
}
function eee() {
  return navigator.oscpu;
}
function tee() {
  var e = navigator, t = [], a = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (a !== void 0 && t.push([a]), Array.isArray(e.languages))
    si() && z$() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var r = e.languages;
    r && t.push(r.split(","));
  }
  return t;
}
function aee() {
  return window.screen.colorDepth;
}
function ree() {
  return Za(pa(navigator.deviceMemory), void 0);
}
function nee() {
  if (!(ka() && li() && ii()))
    return oee();
}
function oee() {
  var e = screen, t = function(r) {
    return Za(Nd(r), null);
  }, a = [t(e.width), t(e.height)];
  return a.sort().reverse(), a;
}
var see = 2500, iee = 10, Ri, Bc;
function lee() {
  if (Bc === void 0) {
    var e = function() {
      var t = Mu();
      Iu(t) ? Bc = setTimeout(e, see) : (Ri = t, Bc = void 0);
    };
    e();
  }
}
function cee() {
  var e = this;
  return lee(), function() {
    return Va(e, void 0, void 0, function() {
      var t;
      return qa(this, function(a) {
        switch (a.label) {
          case 0:
            return t = Mu(), Iu(t) ? Ri ? [2, _m([], Ri, !0)] : A$() ? [4, T$()] : [3, 2] : [3, 2];
          case 1:
            a.sent(), t = Mu(), a.label = 2;
          case 2:
            return Iu(t) || (Ri = t), [2, t];
        }
      });
    });
  };
}
function uee() {
  var e = this;
  if (ka() && li() && ii())
    return function() {
      return Promise.resolve(void 0);
    };
  var t = cee();
  return function() {
    return Va(e, void 0, void 0, function() {
      var a, r;
      return qa(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, t()];
          case 1:
            return a = n.sent(), r = function(o) {
              return o === null ? null : bm(o, iee);
            }, [2, [r(a[0]), r(a[1]), r(a[2]), r(a[3])]];
        }
      });
    });
  };
}
function Mu() {
  var e = screen;
  return [
    Za(pa(e.availTop), null),
    Za(pa(e.width) - pa(e.availWidth) - Za(pa(e.availLeft), 0), null),
    Za(pa(e.height) - pa(e.availHeight) - Za(pa(e.availTop), 0), null),
    Za(pa(e.availLeft), null)
  ];
}
function Iu(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function dee() {
  return Za(Nd(navigator.hardwareConcurrency), void 0);
}
function fee() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var a = new t().resolvedOptions().timeZone;
    if (a)
      return a;
  }
  var r = -pee();
  return "UTC".concat(r >= 0 ? "+" : "").concat(r);
}
function pee() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    pa(new Date(e, 0, 1).getTimezoneOffset()),
    pa(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function yee() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function hee() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function gee() {
  if (!(km() || x$()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function mee() {
  return !!window.openDatabase;
}
function _ee() {
  return navigator.cpuClass;
}
function wee() {
  var e = navigator.platform;
  return e === "MacIntel" && ka() && !Vd() ? E$() ? "iPad" : "iPhone" : e;
}
function vee() {
  return navigator.vendor || "";
}
function bee() {
  for (var e = [], t = 0, a = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < a.length; t++) {
    var r = a[t], n = window[r];
    n && typeof n == "object" && e.push(r);
  }
  return e.sort();
}
function kee() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function xee() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function zee(e) {
  var t = e === void 0 ? {} : e, a = t.debug;
  return Va(this, void 0, void 0, function() {
    var r, n, o, s, i, l;
    return qa(this, function(u) {
      switch (u.label) {
        case 0:
          return See() ? (r = xee(), n = Object.keys(r), o = (l = []).concat.apply(l, n.map(function(f) {
            return r[f];
          })), [4, Cee(o)]) : [2, void 0];
        case 1:
          return s = u.sent(), a && Eee(r, s), i = n.filter(function(f) {
            var p = r[f], c = Ht(p.map(function(h) {
              return s[h];
            }));
            return c > p.length * 0.6;
          }), i.sort(), [2, i];
      }
    });
  });
}
function See() {
  return ka() || qd();
}
function Cee(e) {
  var t;
  return Va(this, void 0, void 0, function() {
    var a, r, n, o, l, s, i, l;
    return qa(this, function(u) {
      switch (u.label) {
        case 0:
          for (a = document, r = a.createElement("div"), n = new Array(e.length), o = {}, Qp(r), l = 0; l < e.length; ++l)
            s = L$(e[l]), s.tagName === "DIALOG" && s.show(), i = a.createElement("div"), Qp(i), i.appendChild(s), r.appendChild(i), n[l] = s;
          u.label = 1;
        case 1:
          return a.body ? [3, 3] : [4, il(50)];
        case 2:
          return u.sent(), [3, 1];
        case 3:
          a.body.appendChild(r);
          try {
            for (l = 0; l < e.length; ++l)
              n[l].offsetParent || (o[e[l]] = !0);
          } finally {
            (t = r.parentNode) === null || t === void 0 || t.removeChild(r);
          }
          return [2, o];
      }
    });
  });
}
function Qp(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function Eee(e, t) {
  for (var a = "DOM blockers debug:\n```", r = 0, n = Object.keys(e); r < n.length; r++) {
    var o = n[r];
    a += `
`.concat(o, ":");
    for (var s = 0, i = e[o]; s < i.length; s++) {
      var l = i[s];
      a += `
  `.concat(t[l] ? "🚫" : "➡️", " ").concat(l);
    }
  }
  console.log("".concat(a, "\n```"));
}
function Aee() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var a = t[e];
    if (matchMedia("(color-gamut: ".concat(a, ")")).matches)
      return a;
  }
}
function Tee() {
  if ($p("inverted"))
    return !0;
  if ($p("none"))
    return !1;
}
function $p(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function Pee() {
  if (ey("active"))
    return !0;
  if (ey("none"))
    return !1;
}
function ey(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var Oee = 100;
function Mee() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= Oee; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function Iee() {
  if (vn("no-preference"))
    return 0;
  if (vn("high") || vn("more"))
    return 1;
  if (vn("low") || vn("less"))
    return -1;
  if (vn("forced"))
    return 10;
}
function vn(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function Fee() {
  if (ty("reduce"))
    return !0;
  if (ty("no-preference"))
    return !1;
}
function ty(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function jee() {
  if (ay("reduce"))
    return !0;
  if (ay("no-preference"))
    return !1;
}
function ay(e) {
  return matchMedia("(prefers-reduced-transparency: ".concat(e, ")")).matches;
}
function Ree() {
  if (ry("high"))
    return !0;
  if (ry("standard"))
    return !1;
}
function ry(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var rt = Math, Vt = function() {
  return 0;
};
function Lee() {
  var e = rt.acos || Vt, t = rt.acosh || Vt, a = rt.asin || Vt, r = rt.asinh || Vt, n = rt.atanh || Vt, o = rt.atan || Vt, s = rt.sin || Vt, i = rt.sinh || Vt, l = rt.cos || Vt, u = rt.cosh || Vt, f = rt.tan || Vt, p = rt.tanh || Vt, c = rt.exp || Vt, h = rt.expm1 || Vt, g = rt.log1p || Vt, _ = function(x) {
    return rt.pow(rt.PI, x);
  }, b = function(x) {
    return rt.log(x + rt.sqrt(x * x - 1));
  }, m = function(x) {
    return rt.log(x + rt.sqrt(x * x + 1));
  }, w = function(x) {
    return rt.log((1 + x) / (1 - x)) / 2;
  }, S = function(x) {
    return rt.exp(x) - 1 / rt.exp(x) / 2;
  }, C = function(x) {
    return (rt.exp(x) + 1 / rt.exp(x)) / 2;
  }, v = function(x) {
    return rt.exp(x) - 1;
  }, y = function(x) {
    return (rt.exp(2 * x) - 1) / (rt.exp(2 * x) + 1);
  }, k = function(x) {
    return rt.log(1 + x);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: b(1e154),
    asin: a(0.12312423423423424),
    asinh: r(1),
    asinhPf: m(1),
    atanh: n(0.5),
    atanhPf: w(0.5),
    atan: o(0.5),
    sin: s(-1e300),
    sinh: i(1),
    sinhPf: S(1),
    cos: l(10.000000000123),
    cosh: u(1),
    coshPf: C(1),
    tan: f(-1e300),
    tanh: p(1),
    tanhPf: y(1),
    exp: c(1),
    expm1: h(1),
    expm1Pf: v(1),
    log1p: g(10),
    log1pPf: k(10),
    powPI: _(-100)
  };
}
var Dee = "mmMwWLliI0fiflO&1", Wc = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function Nee() {
  return Vee(function(e, t) {
    for (var a = {}, r = {}, n = 0, o = Object.keys(Wc); n < o.length; n++) {
      var s = o[n], i = Wc[s], l = i[0], u = l === void 0 ? {} : l, f = i[1], p = f === void 0 ? Dee : f, c = e.createElement("span");
      c.textContent = p, c.style.whiteSpace = "nowrap";
      for (var h = 0, g = Object.keys(u); h < g.length; h++) {
        var _ = g[h], b = u[_];
        b !== void 0 && (c.style[_] = b);
      }
      a[s] = c, t.append(e.createElement("br"), c);
    }
    for (var m = 0, w = Object.keys(Wc); m < w.length; m++) {
      var s = w[m];
      r[s] = a[s].getBoundingClientRect().width;
    }
    return r;
  });
}
function Vee(e, t) {
  return t === void 0 && (t = 4e3), zm(function(a, r) {
    var n = r.document, o = n.body, s = o.style;
    s.width = "".concat(t, "px"), s.webkitTextSizeAdjust = s.textSizeAdjust = "none", si() ? o.style.zoom = "".concat(1 / r.devicePixelRatio) : ka() && (o.style.zoom = "reset");
    var i = n.createElement("div");
    return i.textContent = _m([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), o.appendChild(i), e(n, o);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function qee() {
  return navigator.pdfViewerEnabled;
}
function Bee() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
function Wee() {
  var e = window.ApplePaySession;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return -1;
  if (Hee())
    return -3;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (t) {
    return Uee(t);
  }
}
var Hee = N$;
function Uee(e) {
  if (e instanceof Error && e.name === "InvalidAccessError" && /\bfrom\b.*\binsecure\b/i.test(e.message))
    return -2;
  throw e;
}
function Gee() {
  var e, t = document.createElement("a"), a = (e = t.attributionSourceId) !== null && e !== void 0 ? e : t.attributionsourceid;
  return a === void 0 ? void 0 : String(a);
}
var Sm = -1, Cm = -2, Kee = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
  // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
  // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]), Zee = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
  // MAX_VIEWS_OVR
]), Yee = ["FRAGMENT_SHADER", "VERTEX_SHADER"], Xee = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], Em = "WEBGL_debug_renderer_info", Jee = "WEBGL_polygon_mode";
function Qee(e) {
  var t, a, r, n, o, s, i = e.cache, l = Am(i);
  if (!l)
    return Sm;
  if (!Pm(l))
    return Cm;
  var u = Tm() ? null : l.getExtension(Em);
  return {
    version: ((t = l.getParameter(l.VERSION)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendor: ((a = l.getParameter(l.VENDOR)) === null || a === void 0 ? void 0 : a.toString()) || "",
    vendorUnmasked: u ? (r = l.getParameter(u.UNMASKED_VENDOR_WEBGL)) === null || r === void 0 ? void 0 : r.toString() : "",
    renderer: ((n = l.getParameter(l.RENDERER)) === null || n === void 0 ? void 0 : n.toString()) || "",
    rendererUnmasked: u ? (o = l.getParameter(u.UNMASKED_RENDERER_WEBGL)) === null || o === void 0 ? void 0 : o.toString() : "",
    shadingLanguageVersion: ((s = l.getParameter(l.SHADING_LANGUAGE_VERSION)) === null || s === void 0 ? void 0 : s.toString()) || ""
  };
}
function $ee(e) {
  var t = e.cache, a = Am(t);
  if (!a)
    return Sm;
  if (!Pm(a))
    return Cm;
  var r = a.getSupportedExtensions(), n = a.getContextAttributes(), o = [], s = [], i = [], l = [], u = [];
  if (n)
    for (var f = 0, p = Object.keys(n); f < p.length; f++) {
      var c = p[f];
      s.push("".concat(c, "=").concat(n[c]));
    }
  for (var h = ny(a), g = 0, _ = h; g < _.length; g++) {
    var b = _[g], m = a[b];
    i.push("".concat(b, "=").concat(m).concat(Kee.has(m) ? "=".concat(a.getParameter(m)) : ""));
  }
  if (r)
    for (var w = 0, S = r; w < S.length; w++) {
      var C = S[w];
      if (!(C === Em && Tm() || C === Jee && ate())) {
        var v = a.getExtension(C);
        if (!v) {
          o.push(C);
          continue;
        }
        for (var y = 0, k = ny(v); y < k.length; y++) {
          var b = k[y], m = v[b];
          l.push("".concat(b, "=").concat(m).concat(Zee.has(m) ? "=".concat(a.getParameter(m)) : ""));
        }
      }
    }
  for (var x = 0, T = Yee; x < T.length; x++)
    for (var F = T[x], P = 0, O = Xee; P < O.length; P++) {
      var I = O[P], E = ete(a, F, I);
      u.push("".concat(F, ".").concat(I, "=").concat(E.join(",")));
    }
  return l.sort(), i.sort(), {
    contextAttributes: s,
    parameters: i,
    shaderPrecisions: u,
    extensions: r,
    extensionParameters: l,
    unsupportedExtensions: o
  };
}
function Am(e) {
  if (e.webgl)
    return e.webgl.context;
  var t = document.createElement("canvas"), a;
  t.addEventListener("webglCreateContextError", function() {
    return a = void 0;
  });
  for (var r = 0, n = ["webgl", "experimental-webgl"]; r < n.length; r++) {
    var o = n[r];
    try {
      a = t.getContext(o);
    } catch {
    }
    if (a)
      break;
  }
  return e.webgl = { context: a }, a;
}
function ete(e, t, a) {
  var r = e.getShaderPrecisionFormat(e[t], e[a]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
function ny(e) {
  var t = Object.keys(e.__proto__);
  return t.filter(tte);
}
function tte(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function Tm() {
  return xm();
}
function ate() {
  return si() || ka();
}
function Pm(e) {
  return typeof e.getParameter == "function";
}
function rte() {
  var e, t = qd() || ka();
  return t ? window.AudioContext && (e = new AudioContext().baseLatency) !== null && e !== void 0 ? e : -1 : -2;
}
var nte = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: B$,
  domBlockers: zee,
  fontPreferences: Nee,
  audio: O$,
  screenFrame: uee,
  canvas: H$,
  osCpu: eee,
  languages: tee,
  colorDepth: aee,
  deviceMemory: ree,
  screenResolution: nee,
  hardwareConcurrency: dee,
  timezone: fee,
  sessionStorage: yee,
  localStorage: hee,
  indexedDB: gee,
  openDatabase: mee,
  cpuClass: _ee,
  platform: wee,
  plugins: W$,
  touchSupport: $$,
  vendor: vee,
  vendorFlavors: bee,
  cookiesEnabled: kee,
  colorGamut: Aee,
  invertedColors: Tee,
  forcedColors: Pee,
  monochrome: Mee,
  contrast: Iee,
  reducedMotion: Fee,
  reducedTransparency: jee,
  hdr: Ree,
  math: Lee,
  pdfViewerEnabled: qee,
  architecture: Bee,
  applePay: Wee,
  privateClickMeasurement: Gee,
  audioBaseLatency: rte,
  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: Qee,
  webGlExtensions: $ee
};
function ote(e) {
  return k$(nte, e, []);
}
var ste = "$ if upgrade to Pro: https://fpjs.dev/pro";
function ite(e) {
  var t = lte(e), a = cte(t);
  return { score: t, comment: ste.replace(/\$/g, "".concat(a)) };
}
function lte(e) {
  if (qd())
    return 0.4;
  if (ka())
    return Vd() && !(li() && ii()) ? 0.5 : 0.3;
  var t = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function cte(e) {
  return bm(0.99 + 0.01 * e, 1e-4);
}
function ute(e) {
  for (var t = "", a = 0, r = Object.keys(e).sort(); a < r.length; a++) {
    var n = r[a], o = e[n], s = "error" in o ? "error" : JSON.stringify(o.value);
    t += "".concat(t ? "|" : "").concat(n.replace(/([:|\\])/g, "\\$1"), ":").concat(s);
  }
  return t;
}
function Om(e) {
  return JSON.stringify(e, function(t, a) {
    return a instanceof Error ? _$(a) : a;
  }, 2);
}
function Mm(e) {
  return m$(ute(e));
}
function dte(e) {
  var t, a = ite(e);
  return {
    get visitorId() {
      return t === void 0 && (t = Mm(this.components)), t;
    },
    set visitorId(r) {
      t = r;
    },
    confidence: a,
    components: e,
    version: wm
  };
}
function fte(e) {
  return e === void 0 && (e = 50), l$(e, e * 2);
}
function pte(e, t) {
  var a = Date.now();
  return {
    get: function(r) {
      return Va(this, void 0, void 0, function() {
        var n, o, s;
        return qa(this, function(i) {
          switch (i.label) {
            case 0:
              return n = Date.now(), [4, e()];
            case 1:
              return o = i.sent(), s = dte(o), (t || r != null && r.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(s.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(n - a, `
visitorId: `).concat(s.visitorId, `
components: `).concat(Om(o), "\n```")), [2, s];
          }
        });
      });
    }
  };
}
function yte() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(wm, "/npm-monitoring"), !0), e.send();
    } catch (t) {
      console.error(t);
    }
}
function hte(e) {
  var t;
  return e === void 0 && (e = {}), Va(this, void 0, void 0, function() {
    var a, r, n;
    return qa(this, function(o) {
      switch (o.label) {
        case 0:
          return (!((t = e.monitoring) !== null && t !== void 0) || t) && yte(), a = e.delayFallback, r = e.debug, [4, fte(a)];
        case 1:
          return o.sent(), n = ote({ cache: {}, debug: r }), [2, pte(n, r)];
      }
    });
  });
}
var gte = { load: hte, hashComponents: Mm, componentsToDebugString: Om };
const mte = () => {
  let e = !1;
  const t = /* @__PURE__ */ new Map(), a = (l, u) => {
    var f;
    return t.has(l) || t.set(l, /* @__PURE__ */ new Set()), (f = t.get(l)) == null || f.add(u), () => r(l, u);
  }, r = (l, u) => {
    var f;
    (f = t.get(l)) == null || f.delete(u);
  }, n = (l) => {
    var u;
    (u = t.get(l)) == null || u.forEach((f) => f());
  };
  async function o(l, u, f, p, c, h) {
    var g, _;
    try {
      if (document.getElementById("layup-app") || e)
        return;
      e = !0;
      const b = (g = u.user_data) == null ? void 0 : g.user_id;
      if (!b || typeof b != "string" || b.trim() === "") {
        const C = await gte.load(), { visitorId: v } = await C.get();
        u.user_data = { user_id: v, ...u.user_data };
      } else
        u.user_data = { user_id: b, ...u.user_data };
      Z.config.isSSR = u.isSSR, Z.config.anchor = u.anchor, Z.config.api_host = u.guidance_endpoint, Z.internal_config.api_key = l, Z.config.group_id = u.group_id, Z.config.user_data = u.user_data, Z.config.variant = u.variant || "sidebarcompact", p && (Z.config.onClose = p), c && (Z.config.onOpen = c), f && (Z.config.onInit = f), h && (Z.config.onMetadata = h);
      const m = document.createElement("layup-widget");
      m.id = "layup-app", u.mountElement ? u.mountElement.appendChild(m) : document.body.appendChild(m);
      const w = (C) => {
        C === "system" ? (localStorage.setItem("layup-widget-theme", C), Z.config.theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", document.documentElement.setAttribute("data-layup-mode", Z.config.theme)) : (document.documentElement.setAttribute("data-layup-mode", C), localStorage.setItem("layup-widget-theme", C), Z.config.theme = C);
      }, S = ((_ = u == null ? void 0 : u.theme) == null ? void 0 : _.mode) || "light";
      return w(S || "light"), Z.config = {
        ...Z.config,
        ...u,
        theme: {
          ...Z.config.theme,
          ...u.theme,
          mode: S
        }
      }, qu(s$, { target: m }), n("init"), !0;
    } catch (b) {
      return console.warn("[Layup] Error during initialization:", b), !1;
    }
  }
  return {
    getConfig() {
      return Z.config;
    },
    init: o,
    setConfig: (l) => {
      var p, c, h, g, _, b, m, w, S, C, v, y, k, x, T;
      l.URLpath && (Z.config.URLpath = l.URLpath), l.group_id && (Z.config.group_id = l.group_id), l.guidance_endpoint && (Z.config.api_host = l.guidance_endpoint), l.user_data && (Z.config.user_data = {
        ...Z.config.user_data,
        ...l.user_data
      }), l.variant && (Z.config.variant = l.variant);
      let u = !1;
      ((p = Z.config.theme) == null ? void 0 : p.mode) !== ((c = l.theme) == null ? void 0 : c.mode) && (u = !0, Z.config.theme = {
        ...Z.config.theme,
        mode: (h = l.theme) == null ? void 0 : h.mode
      });
      const f = {
        ...Z.config.theme,
        colors: {
          ...(g = l == null ? void 0 : l.theme) == null ? void 0 : g.colors,
          dark_mode: {
            ...(b = (_ = l == null ? void 0 : l.theme) == null ? void 0 : _.colors) == null ? void 0 : b.dark_mode,
            ...(S = (w = (m = Z.config) == null ? void 0 : m.theme) == null ? void 0 : w.colors) == null ? void 0 : S.dark_mode
          },
          light_mode: {
            ...(v = (C = l == null ? void 0 : l.theme) == null ? void 0 : C.colors) == null ? void 0 : v.light_mode,
            ...(x = (k = (y = Z.config) == null ? void 0 : y.theme) == null ? void 0 : k.colors) == null ? void 0 : x.light_mode
          }
        }
      };
      if (Z.config.theme = f, u) {
        const F = (P) => {
          var I, E, N;
          if (!P || P === "system")
            return;
          document.documentElement.setAttribute("data-layup-mode", P), localStorage.setItem("layup-widget-theme", P);
          const O = (N = (E = (I = Z == null ? void 0 : Z.config) == null ? void 0 : I.theme) == null ? void 0 : E.colors) == null ? void 0 : N[`${P}_mode`];
          Z.config.styles = Ii(Z.config.theme, O), Ti(Z.config.theme, O);
        };
        if ((T = l.theme) != null && T.mode) {
          const P = l.theme.mode;
          P === "light" || P === "dark" ? F(P) : window.matchMedia("(prefers-color-scheme: dark)").matches ? F("dark") : F("light");
        }
      }
    },
    on: a,
    off: r,
    destroy: () => {
      var l;
      document.getElementById("layup-app") && ((l = document.getElementById("layup-app")) == null || l.remove()), Z.internal_config.api_key = void 0, Z.config = {
        api_host: "https://api.layuplabs.ai",
        user_data: void 0
      }, n("destroy");
    }
  };
}, bte = mte();
export {
  bte as default
};
